// @ts-nocheck
/* eslint-disable */

export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Any: { input: any; output: any; }
  BigInteger: { input: number; output: number; }
  Date: { input: any; output: any; }
  ISO8601Date: { input: any; output: any; }
  ISO8601DateTime: { input: date; output: date; }
  JSON: { input: any; output: any; }
};

/** Autogenerated input type of AcceptFormInviteLink */
export type AcceptFormInviteLinkInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 邀请链接TOKEN */
  token: Scalars['ID']['input'];
  /** 共享为外部联系人，且当前用户有多个企业身份时，选择以哪个身份加入 */
  userId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of AcceptFormInviteLink */
export type AcceptFormInviteLinkPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  form?: Maybe<Form>;
  user?: Maybe<User>;
};

/** Autogenerated input type of AcceptUserInviteLink */
export type AcceptUserInviteLinkInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 被邀请人姓名 */
  name: Scalars['String']['input'];
  /** 邀请链接签名 */
  t: Scalars['String']['input'];
  /** 邀请链接TOKEN */
  token: Scalars['ID']['input'];
};

/** Autogenerated return type of AcceptUserInviteLink */
export type AcceptUserInviteLinkPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  user?: Maybe<User>;
};

export enum AccessControlType {
  /** 黑名单 */
  Black = 'black',
  /** 白名单 */
  White = 'white'
}

export type AccessControlableField = {
  accessControlType: AccessControlType;
  accessControlValues?: Maybe<Array<Scalars['String']['output']>>;
};

export type AccessPolicySetting = {
  /** 查看/查询的密码 */
  accessPassword?: Maybe<Scalars['String']['output']>;
  /** 谁能看 */
  allowedAudience: AllowedAudience;
  /** 达到限填后是否允许取消预约 */
  cancelReservationFillFrequencyLimited: Scalars['Boolean']['output'];
  /** 到达限填后展示数据的设置 */
  entriesActionFillFrequencyLimited?: Maybe<OpenEntriesAction>;
  /** 填写限制规则 */
  fillFrequency?: Maybe<FillFrequency>;
  /** 当allowed_audience为sms_verification需要设置。表示：验证身份时，是否使用特定的手机号。true：使用，false：不使用 */
  isSpecifiedVerifier: Scalars['Boolean']['output'];
  /** 是否凭密码查看/查询，true：凭密码打开，false：不需要密码 */
  passwordRequired: Scalars['Boolean']['output'];
  /** 当达到限填后，是否展示表单 */
  showFormFillFrequencyLimited?: Maybe<Scalars['Boolean']['output']>;
  /** 表单提交时，是否限制地区 */
  submissionRegionLimited: Scalars['Boolean']['output'];
  /** 表单提交时，限制地区 */
  submissionRegions?: Maybe<Array<Scalars['String']['output']>>;
  /** 表单人群设置。限制群组及部分人群条件. */
  submitterSetting?: Maybe<FormSubmitterSetting>;
  /** 当allowed_audience为sms_verification需要设置。表示：特定手机号-身份验证的手机号 */
  viewVerifiers?: Maybe<Array<Scalars['String']['output']>>;
  /** 当allowed_audience为sms_verification需要设置。表示：验证身份时，表单中选择的手机认证字段api_code */
  viewVerifyFieldApiCode?: Maybe<Scalars['String']['output']>;
  /** 是否仅限在微信/企业微信中 */
  weixinLimited: Scalars['Boolean']['output'];
};

export type AccountAccessToken = {
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  /** Only returned at creation time; never persisted. */
  plainToken?: Maybe<Scalars['String']['output']>;
  revokedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  tokenHint?: Maybe<Scalars['String']['output']>;
};

export type AccountManager = BaseAccountSupporter & {
  /** 头像图片URL */
  avatarUrl?: Maybe<Scalars['String']['output']>;
  /** 展示名字 */
  displayName?: Maybe<Scalars['String']['output']>;
  /** 联系电话 */
  mobileNo?: Maybe<Scalars['String']['output']>;
  /** 二维码图片URL */
  qrcodeUrl?: Maybe<Scalars['String']['output']>;
};

export type AccountSupporter = AccountManager | CsMan;

export type ActAsBusinessForm = {
  /** 业务表单所属门户 */
  businessBoundPortal?: Maybe<GdPortalBusinessBoundPortalType>;
};

export type ActAsSignupForm = {
  /** 注册表单所属门户 */
  signupBoundPortal?: Maybe<GdPortalSignupBoundPortalType>;
};

/** Autogenerated input type of ActivateCoupon */
export type ActivateCouponInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  code: Scalars['String']['input'];
};

/** Autogenerated return type of ActivateCoupon */
export type ActivateCouponPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  coupon?: Maybe<Coupon>;
  errors?: Maybe<Array<Error>>;
};

/** Autogenerated input type of ActivateTemplateCoupon */
export type ActivateTemplateCouponInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  templateCouponCode: Scalars['ID']['input'];
};

/** Autogenerated return type of ActivateTemplateCoupon */
export type ActivateTemplateCouponPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  templateCoupon?: Maybe<TemplateCoupon>;
};

export type Activity = AdvancedNotificationsEmailFailActivity | AdvancedNotificationsSmsFailActivity | AnnouncementActivity | AnnouncementPopupActivity | BaseActivityType | EntryEmailTaskFailActivity | EntrySmsTaskEntrySmsTemplateApprovedWithAutosendActivity | EntrySmsTaskEntrySmsTemplateApprovedWithoutAutosendActivity | EntrySmsTaskAuditFailureActivity | EntrySmsTaskFailActivity | FieldVerificationFieldVerificationSendSmsFailureActivity | FormBannedActivity | FormEntriesExportActivity | FormEntryAttachmentBulkTaskActivity | FormEntryPostFailureActivity | FormFolderShareRoleActivity | FormMergedNewEntryActivity | FormNewEntryActivity | FormSmsSignatureFailActivity | FormShareRoleActivity | PortalSmsSignatureFailActivity | RuleAdvancedNotificationsSmsAuditFailureActivity | RuleSmsTemplateApprovedWithAutosendActivity | RuleSmsTemplateApprovedWithoutAutosendActivity | SmsContentAuditRejectedActivity | SimpleUserSystemNotificationActivity | SystemWarningType | TradeFreezedActivity | WebhookHistoryWebhookFailureActivity;

export type AddressChangeable = {
  city: Scalars['Boolean']['output'];
  district: Scalars['Boolean']['output'];
  province: Scalars['Boolean']['output'];
  street: Scalars['Boolean']['output'];
};

export type AddressChangeableAttributes = {
  city: Scalars['Boolean']['input'];
  district: Scalars['Boolean']['input'];
  province: Scalars['Boolean']['input'];
  street: Scalars['Boolean']['input'];
};

export type AddressCity = {
  city: Scalars['String']['output'];
  districts: Array<Scalars['String']['output']>;
};

export type AddressData = {
  cities: Array<AddressCity>;
  province: Scalars['String']['output'];
};

export type AddressField = AssociatedField & BaseField & FieldAbility & PlanAvailableField & PredefineableField & {
  apiCode: Scalars['ID']['output'];
  apiCodeAlias?: Maybe<Scalars['String']['output']>;
  /** 对应的表单关联字段 */
  associationField?: Maybe<Field>;
  /** 自动填写上次提交内容 */
  cacheData: Scalars['Boolean']['output'];
  changeable: AddressChangeable;
  /** 客户端ID */
  cid?: Maybe<Scalars['String']['output']>;
  /** 封装的字段类型 */
  customizedType?: Maybe<Scalars['String']['output']>;
  /** 封装的字段类型文本 */
  customizedTypeName?: Maybe<Scalars['String']['output']>;
  /** 自定义出错文案 */
  customizedValidationMessage?: Maybe<Scalars['String']['output']>;
  /** 已提交的数据是否可被编辑 */
  editable: Scalars['Boolean']['output'];
  /** 是否开启自动定位 */
  enableAutoPosition?: Maybe<Scalars['Boolean']['output']>;
  /** 该字段能否使用字段规则: true - 能， false - 不能 */
  fieldRuleAvailable: Scalars['Boolean']['output'];
  /** 是否是关联主键字段 */
  forAssociated?: Maybe<Scalars['Boolean']['output']>;
  /** 是否是关联展示字段 */
  forAssociatedDisplay?: Maybe<Scalars['Boolean']['output']>;
  /** 表单Token */
  formToken: Scalars['String']['output'];
  /** 宽度占用整行的四分之几 */
  gridsToOccupy?: Maybe<Scalars['Int']['output']>;
  hasAbility: Scalars['Boolean']['output'];
  /** 字段标题（去富文本化） */
  label?: Maybe<Scalars['String']['output']>;
  /** 字段描述，富文本 */
  notes?: Maybe<Scalars['String']['output']>;
  paidFeature?: Maybe<PaidFeature>;
  planAvailable: Scalars['Boolean']['output'];
  /** 字段排序 */
  position: Scalars['Int']['output'];
  /** 预填写表单 */
  predefined: Scalars['Boolean']['output'];
  /** 默认值 */
  predefinedValue?: Maybe<AddressFieldValue>;
  /** 该字段是否是隐私字段 true - 是, false - 不是 */
  privacy: Scalars['Boolean']['output'];
  /** 字段隐藏 */
  private: Scalars['Boolean']['output'];
  /** 字段是否通过预填写表单预设了值 true - 是, false - 否 */
  pseudoFormPredefined?: Maybe<Scalars['Boolean']['output']>;
  /** 字段标题（富文本化） */
  rawLabel?: Maybe<Scalars['String']['output']>;
  /** 字段是否只读，无法编辑 */
  readonly?: Maybe<Scalars['Boolean']['output']>;
  /** 该字段是否属于评分字段（e.g. 考试、测评中的题目） */
  scorable: Scalars['Boolean']['output'];
  /** 字段提示较长时折叠展示 */
  showPartDescription: Scalars['Boolean']['output'];
  /** 新起一行 */
  startNewRow: Scalars['Boolean']['output'];
  /** 该字段是否可以作为文本插入 true - 能, false - 不能 */
  textPlaceholderable: Scalars['Boolean']['output'];
  /** 字段类型 */
  type: FieldClass;
  /** 字段类型文本 */
  typeName: Scalars['String']['output'];
  /** 字段验证规则 */
  validations?: Maybe<Array<FieldValidation>>;
};


export type AddressFieldHasAbilityArgs = {
  key: FieldAbilityEnum;
};


export type AddressFieldNotesArgs = {
  sanitize?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AddressFieldReport = {
  field?: Maybe<Field>;
  widgets?: Maybe<Array<Widget>>;
};

export type AddressFieldValue = {
  city?: Maybe<Scalars['String']['output']>;
  district?: Maybe<Scalars['String']['output']>;
  province?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
};

export type AdvancedNotificationsEmailFailActivity = {
  formInfo: FormActivityBaseInfo;
};

export type AdvancedNotificationsNotification = DingTalk | Email | NotImplementedNotification | Sms | Webhook | WeixinOnetime | Wxwork;

/** The connection type for AdvancedNotificationsNotification. */
export type AdvancedNotificationsNotificationConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<AdvancedNotificationsNotificationEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<AdvancedNotificationsNotification>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AdvancedNotificationsNotificationEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<AdvancedNotificationsNotification>;
};

export enum AdvancedNotificationsRuleClassType {
  DingTalkRule = 'DingTalkRule',
  EmailRule = 'EmailRule',
  SmsRule = 'SMSRule',
  WebhookRule = 'WebhookRule',
  WeixinOnetimeRule = 'WeixinOnetimeRule',
  WxworkRule = 'WxworkRule'
}

export type AdvancedNotificationsSmsFailActivity = {
  formInfo: FormActivityBaseInfo;
};

export type AfterSubmission = {
  /** 填表后可修改已填数据 */
  editEntryOnSuccess?: Maybe<Scalars['Boolean']['output']>;
  /** 成功页展示功能 */
  endingActionsDisplayOrder?: Maybe<EndingActionsDisplayOrder>;
  /** 提交后动作类型 */
  entrySubmitMode?: Maybe<EntrySubmitMode>;
  /** 裂变海报 */
  formDistribution?: Maybe<FormDistribution>;
  /** 提交后隐藏登录注册 */
  hideLoginAndSignup?: Maybe<Scalars['Boolean']['output']>;
  /** 提交后显示返回门户按钮 */
  showBackToPortal?: Maybe<Scalars['Boolean']['output']>;
  /** 填表后展示已填数据 */
  showEntryOnSuccess?: Maybe<Scalars['Boolean']['output']>;
  /** 填表后展示已填数据按钮文案 */
  showEntryOnSuccessButtonText?: Maybe<Scalars['String']['output']>;
  /** 提交后显示结果链接 */
  showResultLinkAfterSubmit?: Maybe<Scalars['Boolean']['output']>;
  /** 提交后显示结果链接token */
  showResultLinkAfterSubmitToken?: Maybe<Scalars['String']['output']>;
  /** 提交后显示序号 */
  showSerialNumberOnSuccess?: Maybe<Scalars['Boolean']['output']>;
  /** 提交后显示社交分享 */
  showSocialSharing?: Maybe<Scalars['Boolean']['output']>;
  /** 提交后显示再次提交按钮 */
  showSubmitAgain?: Maybe<Scalars['Boolean']['output']>;
  /** 提交后展示描述 */
  successDescription?: Maybe<Scalars['String']['output']>;
  /** 提交后展示文案 */
  successMessage?: Maybe<Scalars['String']['output']>;
  /** 提交后展示图文 */
  successMessageRichText?: Maybe<Scalars['String']['output']>;
  /** 提交后展示提示类型 */
  successMessageStyle?: Maybe<SuccessMessageStyle>;
  /** 提交后跳转网页参数列表 */
  successRedirectFields?: Maybe<Array<Scalars['String']['output']>>;
  /** 提交后跳转网页链接 */
  successRedirectUrl?: Maybe<Scalars['String']['output']>;
};

export type AiFileElementType = {
  contentType: Scalars['String']['output'];
  /** 从文件中提取的内容 */
  extractContent?: Maybe<Scalars['String']['output']>;
  /** 附件为图片,此字段非null */
  fileHeight?: Maybe<Scalars['Int']['output']>;
  fileName: Scalars['String']['output'];
  fileSize: Scalars['Int']['output'];
  /** 附件为图片,此字段非null */
  fileWidth?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  /** 文件类型，如image、document等 */
  type?: Maybe<Scalars['String']['output']>;
  visitUrl: Scalars['String']['output'];
};


export type AiFileElementTypeVisitUrlArgs = {
  size?: InputMaybe<Scalars['String']['input']>;
};

export type AlipayAccount = {
  /** 支付宝账号 */
  account?: Maybe<Scalars['String']['output']>;
  /** 支付宝接口类型 */
  accountType: AlipayAccountType;
  /** 支付宝公钥 */
  alipayPublicKey?: Maybe<Scalars['String']['output']>;
  /** 支付宝应用AppID */
  appId?: Maybe<Scalars['String']['output']>;
  /** 支付宝应用私钥 */
  appPrivateKey?: Maybe<Scalars['String']['output']>;
  /** 支付宝邮箱 */
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** 支付宝密钥 */
  key?: Maybe<Scalars['String']['output']>;
  /** 是否开启手机支付 */
  mobileEnabled: Scalars['Boolean']['output'];
};

export enum AlipayAccountType {
  /** 即时到帐 */
  CreateDirectPayByUser = 'create_direct_pay_by_user',
  /** 担保交易 */
  CreatePartnerTradeByBuyer = 'create_partner_trade_by_buyer',
  /** 电脑网站支付 */
  FastInstantTradePay = 'fast_instant_trade_pay',
  /** 双功能收款 */
  TradeCreateByBuyer = 'trade_create_by_buyer'
}

export enum AllowedAudience {
  /** GD user only */
  GdUserOnly = 'gd_user_only',
  /** Internal */
  Internal = 'internal',
  /** Private */
  Private = 'private',
  /** Public */
  Public = 'public',
  /** Submitter only */
  SubmitterOnly = 'submitter_only',
  /** Weixin followers only */
  WeixinFollowersOnly = 'weixin_followers_only',
  /** Weixin qiye followers only */
  WeixinQiyeFollowersOnly = 'weixin_qiye_followers_only'
}

export enum AllowedAudienceForViewer {
  /** Private */
  Private = 'private',
  /** Public */
  Public = 'public',
  /** SMS verification */
  SmsVerification = 'sms_verification',
  /** Submitter only */
  SubmitterOnly = 'submitter_only'
}

export enum Amap {
  /** 基于ip的大体自动定位 */
  Ip = 'ip',
  /** 地图中选择位置 */
  Regeo = 'regeo',
  /** 输入位置定位 */
  Text = 'text'
}

/** Autogenerated input type of AmendFormImportJob */
export type AmendFormImportJobInput = {
  attributes: FormImportJobAmendmentAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of AmendFormImportJob */
export type AmendFormImportJobPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  result?: Maybe<FormImportJobExecutionResult>;
};

export type Announcement = {
  buttonLabel?: Maybe<Scalars['String']['output']>;
  buttonUrl?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  /** popup 投放的客户端列表 */
  targetClients?: Maybe<Array<TargetClientEnum>>;
  title?: Maybe<Scalars['String']['output']>;
};

export type AnnouncementActivity = {
  /** 运营消息 */
  announcement?: Maybe<Announcement>;
};

export type AnnouncementPopupActivity = {
  /** 运营弹窗 */
  announcement?: Maybe<Announcement>;
  /** 是否当前用户最新一条运营弹窗 */
  latest: Scalars['Boolean']['output'];
};

export type Answer = {
  apiCode: Scalars['ID']['output'];
  correctAnswer?: Maybe<Scalars['Any']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
};

export type AnswerAttributes = {
  /** 答案区分api_code */
  apiCode: Scalars['ID']['input'];
  /** 答案 */
  correctAnswer?: InputMaybe<Scalars['Any']['input']>;
  /** 答案分值 */
  score?: InputMaybe<Scalars['Float']['input']>;
  /** 答案类型 */
  type?: InputMaybe<AnswerType>;
};

export type AnswerBank = AnswerExplanationSetting & {
  /** 答案解析 */
  answerExplanation?: Maybe<Scalars['String']['output']>;
  /** 唯一正确，部分正确或者赋值 */
  answerSettingMode: AnswerSettingMode;
  /** 题目区的样式大小（例如横向填空的长度） */
  answerSize: Scalars['Int']['output'];
  /** 答案 */
  answers: Array<Answer>;
  /** 开启答案解析 */
  enableAnswerExplanation: Scalars['Boolean']['output'];
};

export type AnswerExplanationSetting = {
  /** 答案解析 */
  answerExplanation?: Maybe<Scalars['String']['output']>;
  /** 开启答案解析 */
  enableAnswerExplanation: Scalars['Boolean']['output'];
};

export enum AnswerSettingMode {
  /** 有且仅有答案完全匹配时正确 */
  Absolute = 'absolute',
  /** 有且仅有答案在正确答案范围内正确，正确答案分数可配置 */
  PartialAbsolute = 'partial_absolute',
  /** 无正确答案，每个答案可配置分数 */
  Relative = 'relative'
}

export enum AnswerType {
  ArrayAnswer = 'ArrayAnswer',
  NumberAnswer = 'NumberAnswer',
  TextAnswer = 'TextAnswer',
  TokenAnswer = 'TokenAnswer'
}

export type AntiCheatingSetting = {
  /** 是否禁止题目被复制， true - 禁止， false - 允许 */
  copyingDisabled: Scalars['Boolean']['output'];
  /** 防作弊是否可用，true - 可用，false - 不可用 */
  enabled: Scalars['Boolean']['output'];
  /** 是否禁止粘贴答题， true - 禁止， false - 允许 */
  pasteDisabled: Scalars['Boolean']['output'];
  /** 是否禁止切屏， true - 禁止， false - 允许 */
  switchingScreenDisabled: Scalars['Boolean']['output'];
  /** 切屏次数上限，null - 无上限 */
  switchingScreenLimit?: Maybe<Scalars['Int']['output']>;
  /** 每次切屏时长限制，null - 无上限 */
  switchingScreenLimitTime?: Maybe<Scalars['Int']['output']>;
};

export type AntiCheatingSettingAttributes = {
  /** 是否禁止题目被复制， true - 禁止， false - 允许 */
  copyingDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** 防作弊是否可用，true - 可用，false - 不可用 */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** 是否禁止粘贴答题， true - 禁止， false - 允许 */
  pasteDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** 是否禁止切屏， true - 禁止， false - 允许 */
  switchingScreenDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** 切屏次数上限， null - 无上限 */
  switchingScreenLimit?: InputMaybe<Scalars['Int']['input']>;
  /** 每次切屏时长限制，null - 无上限 */
  switchingScreenLimitTime?: InputMaybe<Scalars['Int']['input']>;
};

export type ApiLicence = {
  apiKey: Scalars['String']['output'];
  apiSecret: Scalars['String']['output'];
};

export type ApiNotification = {
  app?: Maybe<DoorkeeperApplication>;
  approach?: Maybe<ApiNotificationApproach>;
  content: Scalars['String']['output'];
  fee: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  performedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  recipient: Scalars['String']['output'];
  status?: Maybe<ApiNotificationStatus>;
};

export enum ApiNotificationApproach {
  Sms = 'sms'
}

/** The connection type for ApiNotification. */
export type ApiNotificationConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ApiNotificationEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ApiNotification>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ApiNotificationEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ApiNotification>;
};

export enum ApiNotificationStatus {
  Fail = 'fail',
  Sending = 'sending',
  Success = 'success'
}

export type AppBinding = {
  application?: Maybe<DoorkeeperApplication>;
  bindingFields?: Maybe<Array<Scalars['String']['output']>>;
  bindingSettings?: Maybe<Array<Scalars['String']['output']>>;
};

export type AppConflictCheck = {
  /** 是否已启用证书 */
  certificateEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** 是否已启用幸运大转盘 */
  wheelFortuneEnabled?: Maybe<Scalars['Boolean']['output']>;
};

export enum AppIdentity {
  /** 金数据 微信小程序 */
  Miniapp = 'miniapp',
  /** 金数据 NextApp */
  Nextapp = 'nextapp'
}

export type AppPackage = {
  appIds: Array<Scalars['String']['output']>;
  apps: Array<DoorkeeperApplication>;
  cardBgColor?: Maybe<Scalars['String']['output']>;
  cardIcon?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  logo?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** @deprecated nextfe 中的 new_banner 替换为 card_icon 和 card_bg_color */
  newBanner?: Maybe<Scalars['String']['output']>;
  originalPrice?: Maybe<Scalars['Float']['output']>;
  price: Scalars['Float']['output'];
  purchased: Scalars['Boolean']['output'];
};

export type AppSetting = {
  formNotificationEnabled: Scalars['Boolean']['output'];
  /** 开启APP通知的表单数 */
  formNotificationEnabledCount: Scalars['Int']['output'];
};

/** Autogenerated input type of AppendFromImportJob */
export type AppendFromImportJobInput = {
  attributes: FormImportJobAppendAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of AppendFromImportJob */
export type AppendFromImportJobPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  result?: Maybe<FormImportJobExecutionResult>;
};

export type Application = {
  /** 插件编码 */
  appCode: Scalars['String']['output'];
  /** 插件名称 */
  name: Scalars['String']['output'];
  /** 是否开启 */
  opened: Scalars['Boolean']['output'];
};

export enum Approach {
  /** Ding talk */
  DingTalk = 'DING_TALK',
  /** Email */
  Email = 'EMAIL',
  /** SMS */
  Sms = 'SMS',
  /** Webhook */
  Webhook = 'WEBHOOK',
  /** Weixin onetime */
  WeixinOnetime = 'WEIXIN_ONETIME',
  /** Wxwork */
  Wxwork = 'WXWORK'
}

export type ArtifactMessagePart = {
  /** 构件 */
  artifact?: Maybe<Scalars['JSON']['output']>;
  /** 构件ID */
  artifactId?: Maybe<Scalars['String']['output']>;
  /** 构件字符 */
  artifactJsonString?: Maybe<Scalars['String']['output']>;
  /** 构件类型, eg: Form */
  artifactType?: Maybe<ArtifactTypeEnum>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
};

export enum ArtifactTypeEnum {
  /** 表单 */
  Form = 'Form'
}

export type AssociableFormData = {
  /** 表单是否被冻结 */
  disabled?: Maybe<Scalars['Boolean']['output']>;
  /** 可被关联的字段 */
  fields: Array<AssociableFormField>;
  name: Scalars['String']['output'];
  /** 主表单中关联了此表单的所有表单关联字段的apiCode。仅当当前用户不是此表单的管理员时，返回此值，用于在添加表单关联字段时进行过滤。 */
  targetFieldApiCodes?: Maybe<Array<Scalars['ID']['output']>>;
  token: Scalars['ID']['output'];
};

/** The connection type for AssociableFormData. */
export type AssociableFormDataConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<AssociableFormDataEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<AssociableFormData>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AssociableFormDataEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<AssociableFormData>;
};

export type AssociableFormField = {
  apiCode: Scalars['ID']['output'];
  associable: Scalars['Boolean']['output'];
  /** 字段类型是否可以参与计算 */
  calculable: Scalars['Boolean']['output'];
  /** @deprecated 使用 ScopeConditionType 完成 */
  choices?: Maybe<Array<AssociableFormFieldChoice>>;
  /** 封装的字段类型 */
  customizedType?: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
  /** @deprecated 使用 ScopeConditionType 完成 */
  scopeConditionTriggerable: Scalars['Boolean']['output'];
  type: FieldClass;
};

export type AssociableFormFieldChoice = {
  name: Scalars['String']['output'];
  subChoices?: Maybe<Array<AssociableFormFieldChoice>>;
  value: Scalars['ID']['output'];
};

export type AssociatedDisplayFieldSetting = {
  /** 被关联字段开启选项赋值 */
  calculable?: Maybe<Scalars['Boolean']['output']>;
  /** 被关联字段的apiCode */
  fieldApiCode: Scalars['ID']['output'];
  /** 被关联字段的选项赋值 */
  operandValues?: Maybe<Array<AssociatedFieldOperandValue>>;
  /** 是否启用隐私保护 */
  privacySafe: Scalars['Boolean']['output'];
  /** 隐藏被关联展示字段 */
  private: Scalars['Boolean']['output'];
};

export type AssociatedDisplayFieldSettingAttributes = {
  /** 被关联字段开启选项赋值 */
  calculable?: InputMaybe<Scalars['Boolean']['input']>;
  /** 被关联字段的apiCode */
  fieldApiCode: Scalars['ID']['input'];
  /** 被关联字段的选项赋值 */
  operandValues?: InputMaybe<Array<AssociatedFieldOperandValueAttributes>>;
  /** 是否启用隐私保护 */
  privacySafe?: InputMaybe<Scalars['Boolean']['input']>;
  /** 隐藏被关联展示字段 */
  private: Scalars['Boolean']['input'];
};

export type AssociatedEntry = {
  /** 被关联的 entry */
  associatedEntry?: Maybe<Entry>;
  /** 格式化后的关联展示数据 */
  displayData?: Maybe<Scalars['JSON']['output']>;
};

export type AssociatedEntryOption = {
  /** 被关联的 entry */
  associatedEntry?: Maybe<EntryOption>;
  /** 其他被关联字段的内容 */
  associatedFieldData?: Maybe<Array<AssociatedFieldData>>;
  /** 显示字段的内容 */
  displayData?: Maybe<Scalars['JSON']['output']>;
  /** 选项文字 */
  text?: Maybe<Scalars['String']['output']>;
  /** 选项值 */
  value: Scalars['String']['output'];
};

/** The connection type for AssociatedEntryOption. */
export type AssociatedEntryOptionConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<AssociatedEntryOptionEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<AssociatedEntryOption>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AssociatedEntryOptionEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<AssociatedEntryOption>;
};

/** 获取关联字段数据时的来源页面 */
export enum AssociatedEntrySource {
  /** 公开页面 */
  Entry = 'entry',
  /** 对外查询页面 */
  OpenSearch = 'open_search'
}

export type AssociatedField = {
  /** 对应的表单关联字段 */
  associationField?: Maybe<Field>;
  /** 是否是关联主键字段 */
  forAssociated?: Maybe<Scalars['Boolean']['output']>;
  /** 是否是关联展示字段 */
  forAssociatedDisplay?: Maybe<Scalars['Boolean']['output']>;
};

export type AssociatedFieldData = {
  /** 被关联字段的apiCode */
  apiCode: Scalars['ID']['output'];
  /** 选项文字 */
  text: Scalars['String']['output'];
  /** 选项值 */
  value: Scalars['String']['output'];
};

export type AssociatedFieldOperandValue = {
  /** 选项值 */
  choiceValue: Scalars['ID']['output'];
  /** 选项赋值 */
  operandValue: Scalars['Float']['output'];
};

export type AssociatedFieldOperandValueAttributes = {
  /** 选项值 */
  choiceValue: Scalars['ID']['input'];
  /** 选项赋值 */
  operandValue: Scalars['Float']['input'];
};

export type AssociatedFieldSetting = {
  /** 被关联字段开启选项赋值 */
  calculable?: Maybe<Scalars['Boolean']['output']>;
  /** 被关联字段的apiCode */
  fieldApiCode: Scalars['ID']['output'];
  /** 被关联字段的选项赋值 */
  operandValues?: Maybe<Array<AssociatedFieldOperandValue>>;
};

export type AssociatedFieldSettingAttributes = {
  /** 被关联字段开启选项赋值 */
  calculable?: InputMaybe<Scalars['Boolean']['input']>;
  /** 被关联字段的apiCode */
  fieldApiCode: Scalars['ID']['input'];
  /** 被关联字段的选项赋值 */
  operandValues?: InputMaybe<Array<AssociatedFieldOperandValueAttributes>>;
};

export type AssociatedForm = Cooperator & {
  /** 关联的字段 */
  associatedFields: Array<Field>;
  /** 表单角色列表 */
  availableRoles: Array<FormRole>;
  /**
   * currentUser在此表单下的权限集
   * @deprecated 应当使用userFormRole#abilities
   */
  cooperativeAbilities: Array<FormRoleAbility>;
  /** 协作者邀请链接 */
  cooperatorLinks?: Maybe<Array<CooperatorLink>>;
  /** 表单协作者们[不包含表单creator] */
  cooperators?: Maybe<FormCooperatorsConnection>;
  /** 当前表单可添加协作者的席位数，若无上限则为-1 */
  cooperatorsLimit: Scalars['Int']['output'];
  /** 表单协作者们中的当前用户 */
  currentCooperator: FormCooperators;
  /** 表单是否被冻结 */
  disabled?: Maybe<Scalars['Boolean']['output']>;
  /** 展示的字段 */
  displayFields: Array<Field>;
  id: Scalars['ID']['output'];
  /** 协作者邀请待回应 */
  inviters?: Maybe<InviterConnection>;
  name: Scalars['String']['output'];
  /** 表单拥有者 */
  owner: FormOwner;
  /** 过往联系人推荐列表 */
  recommendCooperators?: Maybe<FormRecommendedCooperatorsConnection>;
  /** 站内表单名 */
  subname: Scalars['String']['output'];
  token: Scalars['String']['output'];
  /** currentUser在此表单下的角色 */
  userFormRole?: Maybe<FormRole>;
};


export type AssociatedFormCooperatorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type AssociatedFormInvitersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type AssociatedFormRecommendCooperatorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AssociatedTextualChoice = {
  value?: Maybe<Scalars['String']['output']>;
};

/** The connection type for AssociatedTextualChoice. */
export type AssociatedTextualChoiceConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<AssociatedTextualChoiceEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<AssociatedTextualChoice>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AssociatedTextualChoiceEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<AssociatedTextualChoice>;
};

export type Attachment = {
  contentType: Scalars['String']['output'];
  /** 附件为图片,此字段非null */
  fileHeight?: Maybe<Scalars['Int']['output']>;
  fileName: Scalars['String']['output'];
  fileSize: Scalars['Int']['output'];
  /** 附件为图片,此字段非null */
  fileWidth?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  visitUrl: Scalars['String']['output'];
};


export type AttachmentVisitUrlArgs = {
  size?: InputMaybe<Scalars['String']['input']>;
};

export type AttachmentField = AssociatedField & BaseField & FieldAbility & PlanAvailableField & {
  apiCode: Scalars['ID']['output'];
  apiCodeAlias?: Maybe<Scalars['String']['output']>;
  /** 对应的表单关联字段 */
  associationField?: Maybe<Field>;
  /** 自动填写上次提交内容 */
  cacheData: Scalars['Boolean']['output'];
  /** 客户端ID */
  cid?: Maybe<Scalars['String']['output']>;
  /** 封装的字段类型 */
  customizedType?: Maybe<Scalars['String']['output']>;
  /** 封装的字段类型文本 */
  customizedTypeName?: Maybe<Scalars['String']['output']>;
  /** 自定义出错文案 */
  customizedValidationMessage?: Maybe<Scalars['String']['output']>;
  /** 已提交的数据是否可被编辑 */
  editable: Scalars['Boolean']['output'];
  /** 该字段能否使用字段规则: true - 能， false - 不能 */
  fieldRuleAvailable: Scalars['Boolean']['output'];
  /** 是否是关联主键字段 */
  forAssociated?: Maybe<Scalars['Boolean']['output']>;
  /** 是否是关联展示字段 */
  forAssociatedDisplay?: Maybe<Scalars['Boolean']['output']>;
  /** 表单Token */
  formToken: Scalars['String']['output'];
  /** 宽度占用整行的四分之几 */
  gridsToOccupy?: Maybe<Scalars['Int']['output']>;
  hasAbility: Scalars['Boolean']['output'];
  /** 字段标题（去富文本化） */
  label?: Maybe<Scalars['String']['output']>;
  /** 最大文件数量 */
  maxFileQuantity: Scalars['Int']['output'];
  /** 单个文件最大体积, MB */
  maxSize: Scalars['Float']['output'];
  /** 文件上传类型 */
  mediaType: AttachmentFieldMedia;
  /** 仅限手机拍照或现场录制上传 */
  mobileCameraOnly?: Maybe<Scalars['Boolean']['output']>;
  /** 字段描述，富文本 */
  notes?: Maybe<Scalars['String']['output']>;
  paidFeature?: Maybe<PaidFeature>;
  planAvailable: Scalars['Boolean']['output'];
  /** 字段排序 */
  position: Scalars['Int']['output'];
  /** 该字段是否是隐私字段 true - 是, false - 不是 */
  privacy: Scalars['Boolean']['output'];
  /** 字段隐藏 */
  private: Scalars['Boolean']['output'];
  /** 字段是否通过预填写表单预设了值 true - 是, false - 否 */
  pseudoFormPredefined?: Maybe<Scalars['Boolean']['output']>;
  /** 字段标题（富文本化） */
  rawLabel?: Maybe<Scalars['String']['output']>;
  /** 字段是否只读，无法编辑 */
  readonly?: Maybe<Scalars['Boolean']['output']>;
  /** 该字段是否属于评分字段（e.g. 考试、测评中的题目） */
  scorable: Scalars['Boolean']['output'];
  /** 字段提示较长时折叠展示 */
  showPartDescription: Scalars['Boolean']['output'];
  /** 新起一行 */
  startNewRow: Scalars['Boolean']['output'];
  /** 文件存储平台 */
  storage: AttachmentStorage;
  /** 该字段是否可以作为文本插入 true - 能, false - 不能 */
  textPlaceholderable: Scalars['Boolean']['output'];
  /** 字段类型 */
  type: FieldClass;
  /** 字段类型文本 */
  typeName: Scalars['String']['output'];
  /** 字段验证规则 */
  validations?: Maybe<Array<FieldValidation>>;
};


export type AttachmentFieldHasAbilityArgs = {
  key: FieldAbilityEnum;
};


export type AttachmentFieldNotesArgs = {
  sanitize?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AttachmentFieldMedia = {
  extensions?: Maybe<Array<Scalars['String']['output']>>;
  type: AttachmentMedia;
};

export type AttachmentFieldMediaTypeAttributes = {
  extensions?: InputMaybe<Array<Scalars['String']['input']>>;
  type: AttachmentMedia;
};

export enum AttachmentMedia {
  /** 音频类 */
  Audio = 'audio',
  /** 压缩包 */
  Compress = 'compress',
  /** 自定义 */
  Custom = 'custom',
  /** 文档类 */
  Doc = 'doc',
  /** 图片类 */
  Image = 'image',
  /** 不限制 */
  Unlimited = 'unlimited',
  /** 视频类 */
  Video = 'video'
}

export enum AttachmentStorage {
  Qiniu = 'qiniu'
}

export type AudioField = AssociatedField & BaseField & FieldAbility & PlanAvailableField & {
  apiCode: Scalars['ID']['output'];
  apiCodeAlias?: Maybe<Scalars['String']['output']>;
  /** 对应的表单关联字段 */
  associationField?: Maybe<Field>;
  /** 自动填写上次提交内容 */
  cacheData: Scalars['Boolean']['output'];
  /** 客户端ID */
  cid?: Maybe<Scalars['String']['output']>;
  /** 封装的字段类型 */
  customizedType?: Maybe<Scalars['String']['output']>;
  /** 封装的字段类型文本 */
  customizedTypeName?: Maybe<Scalars['String']['output']>;
  /** 自定义出错文案 */
  customizedValidationMessage?: Maybe<Scalars['String']['output']>;
  /** 已提交的数据是否可被编辑 */
  editable: Scalars['Boolean']['output'];
  /** 该字段能否使用字段规则: true - 能， false - 不能 */
  fieldRuleAvailable: Scalars['Boolean']['output'];
  /** 是否是关联主键字段 */
  forAssociated?: Maybe<Scalars['Boolean']['output']>;
  /** 是否是关联展示字段 */
  forAssociatedDisplay?: Maybe<Scalars['Boolean']['output']>;
  /** 表单Token */
  formToken: Scalars['String']['output'];
  /** 宽度占用整行的四分之几 */
  gridsToOccupy?: Maybe<Scalars['Int']['output']>;
  hasAbility: Scalars['Boolean']['output'];
  /** 字段标题（去富文本化） */
  label?: Maybe<Scalars['String']['output']>;
  /** 最大时长, 分钟 */
  maxDuration?: Maybe<Scalars['Int']['output']>;
  /** 字段描述，富文本 */
  notes?: Maybe<Scalars['String']['output']>;
  paidFeature?: Maybe<PaidFeature>;
  planAvailable: Scalars['Boolean']['output'];
  /** 字段排序 */
  position: Scalars['Int']['output'];
  /** 该字段是否是隐私字段 true - 是, false - 不是 */
  privacy: Scalars['Boolean']['output'];
  /** 字段隐藏 */
  private: Scalars['Boolean']['output'];
  /** 字段是否通过预填写表单预设了值 true - 是, false - 否 */
  pseudoFormPredefined?: Maybe<Scalars['Boolean']['output']>;
  /** 字段标题（富文本化） */
  rawLabel?: Maybe<Scalars['String']['output']>;
  /** 字段是否只读，无法编辑 */
  readonly?: Maybe<Scalars['Boolean']['output']>;
  /** 该字段是否属于评分字段（e.g. 考试、测评中的题目） */
  scorable: Scalars['Boolean']['output'];
  /** 字段提示较长时折叠展示 */
  showPartDescription: Scalars['Boolean']['output'];
  /** 新起一行 */
  startNewRow: Scalars['Boolean']['output'];
  /** 该字段是否可以作为文本插入 true - 能, false - 不能 */
  textPlaceholderable: Scalars['Boolean']['output'];
  /** 字段类型 */
  type: FieldClass;
  /** 字段类型文本 */
  typeName: Scalars['String']['output'];
  /** 字段验证规则 */
  validations?: Maybe<Array<FieldValidation>>;
};


export type AudioFieldHasAbilityArgs = {
  key: FieldAbilityEnum;
};


export type AudioFieldNotesArgs = {
  sanitize?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AuditTrailEntry = {
  entry: Entry;
  /** 该条数据是否已恢复 */
  restored: Scalars['Boolean']['output'];
};

/** The connection type for AuditTrailEntry. */
export type AuditTrailEntryConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<AuditTrailEntryEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<AuditTrailEntry>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AuditTrailEntryEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<AuditTrailEntry>;
};

export enum AuditTrailOperationTypeEnum {
  /** 删除记录 */
  Destroy = 'destroy',
  /** 修改记录 */
  Update = 'update'
}

export enum AuditTrialUserTypeEnum {
  /** 金数据用户 */
  Jsj = 'jsj',
  /** 企业微信用户 */
  Wecom = 'wecom'
}

export type AuthFields = {
  /** 用于登录的字段 */
  apiCode: Scalars['String']['output'];
  needVerification: Scalars['Boolean']['output'];
};

export type AuthFieldsAttributes = {
  /** 用于登录的字段 */
  apiCode?: InputMaybe<Scalars['String']['input']>;
  needVerification?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Authentication = {
  name?: Maybe<Scalars['String']['output']>;
  provider: AuthenticationProvider;
  uid: Scalars['String']['output'];
};

export enum AuthenticationProvider {
  /** Baidu app */
  BaiduApp = 'baidu_app',
  /** Ding talk */
  DingTalk = 'ding_talk',
  /** Google oauth2 */
  GoogleOauth2 = 'google_oauth2',
  /** Identity */
  Identity = 'identity',
  /** Mingdao */
  Mingdao = 'mingdao',
  /** QQ connect */
  QqConnect = 'qq_connect',
  /** Teambition */
  Teambition = 'teambition',
  /** Tencent meeting */
  TencentMeeting = 'tencent_meeting',
  /** Trade weixin app */
  TradeWeixinApp = 'trade_weixin_app',
  /** Wechat */
  Wechat = 'wechat',
  /** Weibo */
  Weibo = 'weibo',
  Weixin = 'weixin',
  /** Weixin app */
  WeixinApp = 'weixin_app',
  /** Weixin cyborg */
  WeixinCyborg = 'weixin_cyborg',
  /** Weixin h5 */
  WeixinH5 = 'weixin_h5',
  /** Weixin PC */
  WeixinPc = 'weixin_pc',
  /** Weixin qiye */
  WeixinQiye = 'weixin_qiye'
}

export type AutoCountRule = {
  /** 确认码位数 */
  countDigit: Scalars['Int']['output'];
  /** 计数器 */
  counter: Scalars['Int']['output'];
  /** 是否固定位数 */
  fixedDigits: Scalars['Boolean']['output'];
  /** 规则 ID */
  id: Scalars['ID']['output'];
  /** 规则位置 */
  position: Scalars['Int']['output'];
  /** 重置规则值 */
  resetRuleApiCode?: Maybe<Scalars['String']['output']>;
  /** 重置规则类型 */
  resetRuleType: ResetRule;
};

export enum AutomationActionType {
  /** Email */
  Email = 'email',
  /** SMS */
  Sms = 'sms'
}

export type AutomationDefaultTransaction = AutomationTransactionBase & {
  actionType: AutomationActionType;
  cachedFormName: Scalars['String']['output'];
  content: Scalars['String']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  form?: Maybe<Form>;
  id: Scalars['ID']['output'];
  messageCount: Scalars['Int']['output'];
  performedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** @deprecated 不支持多个接收者，使用recipients */
  recipient: Scalars['String']['output'];
  recipients: Array<Scalars['String']['output']>;
  status: AutomationStatus;
};

export type AutomationEmailTransaction = AutomationTransactionBase & {
  actionType: AutomationActionType;
  cachedFormName: Scalars['String']['output'];
  content: Scalars['String']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  form?: Maybe<Form>;
  id: Scalars['ID']['output'];
  messageCount: Scalars['Int']['output'];
  performedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** @deprecated 不支持多个接收者，使用recipients */
  recipient: Scalars['String']['output'];
  recipients: Array<Scalars['String']['output']>;
  status: AutomationStatus;
  subject: Scalars['String']['output'];
};

export enum AutomationStatus {
  /** Failed */
  Failed = 'failed',
  /** Success */
  Success = 'success'
}

export type AutomationTransaction = AutomationDefaultTransaction | AutomationEmailTransaction;

export type AutomationTransactionBase = {
  actionType: AutomationActionType;
  cachedFormName: Scalars['String']['output'];
  content: Scalars['String']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  form?: Maybe<Form>;
  id: Scalars['ID']['output'];
  messageCount: Scalars['Int']['output'];
  performedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** @deprecated 不支持多个接收者，使用recipients */
  recipient: Scalars['String']['output'];
  recipients: Array<Scalars['String']['output']>;
  status: AutomationStatus;
};

/** The connection type for AutomationTransaction. */
export type AutomationTransactionConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<AutomationTransactionEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<AutomationTransaction>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AutomationTransactionEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<AutomationTransaction>;
};

export enum BackgroundImageType {
  /** 用户上传的图片 */
  Custom = 'custom',
  /** 系统图片 */
  Image = 'image',
  /** 系统纹理 */
  Texture = 'texture'
}

export type Ban = {
  publishedReason: Scalars['String']['output'];
};

export type Base = {
  /** 推送类型 */
  approach: Approach;
  cachedFormName: Scalars['String']['output'];
  /** 推送/短信/邮件内容 */
  content?: Maybe<Scalars['String']['output']>;
  entry?: Maybe<Entry>;
  /** 错误信息 */
  errorMessage?: Maybe<Scalars['String']['output']>;
  form?: Maybe<Form>;
  id: Scalars['ID']['output'];
  /** 发送时间（不等于任务触发时间） */
  performedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** 收件人，常用于短信和邮件 */
  recipient?: Maybe<Scalars['String']['output']>;
  /** 状态 */
  status: Status;
};

export type BaseAccountSupporter = {
  /** 头像图片URL */
  avatarUrl?: Maybe<Scalars['String']['output']>;
  /** 展示名字 */
  displayName?: Maybe<Scalars['String']['output']>;
  /** 联系电话 */
  mobileNo?: Maybe<Scalars['String']['output']>;
  /** 二维码图片URL */
  qrcodeUrl?: Maybe<Scalars['String']['output']>;
};

export type BaseActivityType = {
  content?: Maybe<Scalars['String']['output']>;
  extraParams?: Maybe<Scalars['JSON']['output']>;
  targetId?: Maybe<Scalars['String']['output']>;
  targetType?: Maybe<Scalars['String']['output']>;
  verb: Scalars['String']['output'];
};

export type BaseCaptcha = {
  geetestId?: Maybe<Scalars['String']['output']>;
  geetestRegister?: Maybe<GeetestRegister>;
  useGeetest: Scalars['Boolean']['output'];
};

export type BaseChoice = {
  hidden: Scalars['Boolean']['output'];
  operandValue?: Maybe<Scalars['Float']['output']>;
  position: Scalars['Int']['output'];
  selected: Scalars['Boolean']['output'];
  type?: Maybe<Scalars['String']['output']>;
  value: Scalars['ID']['output'];
};

export type BaseEntriesBatchJob = {
  /** 预估的剩余时长 */
  estimateLeft?: Maybe<Scalars['BigInteger']['output']>;
  /** 数据筛选条件 */
  filter?: Maybe<Scalars['JSON']['output']>;
  /** ID */
  id: Scalars['ID']['output'];
  /** 数据范围 */
  rowScope: RowScopeType;
  /** 导出任务状态 */
  status: EntriesBatchJobStatus;
};

export type BaseField = {
  apiCode: Scalars['ID']['output'];
  apiCodeAlias?: Maybe<Scalars['String']['output']>;
  /** 自动填写上次提交内容 */
  cacheData: Scalars['Boolean']['output'];
  /** 客户端ID */
  cid?: Maybe<Scalars['String']['output']>;
  /** 封装的字段类型 */
  customizedType?: Maybe<Scalars['String']['output']>;
  /** 封装的字段类型文本 */
  customizedTypeName?: Maybe<Scalars['String']['output']>;
  /** 自定义出错文案 */
  customizedValidationMessage?: Maybe<Scalars['String']['output']>;
  /** 已提交的数据是否可被编辑 */
  editable: Scalars['Boolean']['output'];
  /** 该字段能否使用字段规则: true - 能， false - 不能 */
  fieldRuleAvailable: Scalars['Boolean']['output'];
  /** 表单Token */
  formToken: Scalars['String']['output'];
  /** 宽度占用整行的四分之几 */
  gridsToOccupy?: Maybe<Scalars['Int']['output']>;
  /** 字段标题（去富文本化） */
  label?: Maybe<Scalars['String']['output']>;
  /** 字段描述，富文本 */
  notes?: Maybe<Scalars['String']['output']>;
  /** 字段排序 */
  position: Scalars['Int']['output'];
  /** 该字段是否是隐私字段 true - 是, false - 不是 */
  privacy: Scalars['Boolean']['output'];
  /** 字段隐藏 */
  private: Scalars['Boolean']['output'];
  /** 字段是否通过预填写表单预设了值 true - 是, false - 否 */
  pseudoFormPredefined?: Maybe<Scalars['Boolean']['output']>;
  /** 字段标题（富文本化） */
  rawLabel?: Maybe<Scalars['String']['output']>;
  /** 字段是否只读，无法编辑 */
  readonly?: Maybe<Scalars['Boolean']['output']>;
  /** 该字段是否属于评分字段（e.g. 考试、测评中的题目） */
  scorable: Scalars['Boolean']['output'];
  /** 字段提示较长时折叠展示 */
  showPartDescription: Scalars['Boolean']['output'];
  /** 新起一行 */
  startNewRow: Scalars['Boolean']['output'];
  /** 该字段是否可以作为文本插入 true - 能, false - 不能 */
  textPlaceholderable: Scalars['Boolean']['output'];
  /** 字段类型 */
  type: FieldClass;
  /** 字段类型文本 */
  typeName: Scalars['String']['output'];
  /** 字段验证规则 */
  validations?: Maybe<Array<FieldValidation>>;
};


export type BaseFieldNotesArgs = {
  sanitize?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BaseFile = {
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** 表单、文件夹的图标、颜色等 */
  ensuredSymbol?: Maybe<FormSymbol>;
  userFormSetting?: Maybe<UserFormSetting>;
};

export enum BaseFileEnum {
  /** 表单 */
  Form = 'Form',
  /** 文件夹 */
  FormFolder = 'FormFolder'
}

export enum BaseFileKindEnum {
  /** 普通表单 */
  Form = 'form',
  /** 数据表格 */
  Table = 'table'
}

export type BaseFileTagAttributes = {
  /** 标签ID */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** 标签名称 */
  name: Scalars['String']['input'];
  /** 标签排序 */
  order?: InputMaybe<Scalars['Int']['input']>;
};

export type BaseGoodsItem = {
  /** 规格 */
  dimensions: Array<GoodsDimension>;
  /** 不允许修改数量 */
  fixedNumber: Scalars['Boolean']['output'];
  goodsItemImages: Array<Attachment>;
  /** 隐藏商品 */
  hidden: Scalars['Boolean']['output'];
  /** 商品展示形式 */
  layout?: Maybe<ItemLayout>;
  /** 商品名 */
  name: Scalars['String']['output'];
  /** 原价 */
  originalPrice?: Maybe<Scalars['Float']['output']>;
  /** 商品排序 */
  position: Scalars['Int']['output'];
  /** 默认数量 */
  predefinedNumber?: Maybe<Scalars['BigInteger']['output']>;
  /** 默认规格 */
  predefinedSpecification?: Maybe<Array<GoodsSpecificationItem>>;
  /** 现价 */
  price?: Maybe<Scalars['Float']['output']>;
  skus: Array<GoodsSku>;
  value: Scalars['ID']['output'];
};

export type BaseNotification = {
  /** 推送类型 */
  approach: Approach;
  cachedFormName: Scalars['String']['output'];
  /** 推送/短信/邮件内容 */
  content?: Maybe<Scalars['String']['output']>;
  entry?: Maybe<Entry>;
  form?: Maybe<Form>;
  id: Scalars['ID']['output'];
  /** 发送时间（不等于任务触发时间） */
  performedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** 收件人，常用于短信和邮件 */
  recipient?: Maybe<Scalars['String']['output']>;
};

export type BaseProperties = {
  customerAlias?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  token: Scalars['String']['output'];
};

export type BaseRule = {
  /** 推送类型 */
  approach: Approach;
  /** 发送条件字段 api_code */
  conditionKey?: Maybe<Scalars['String']['output']>;
  /** 发送条件的值 */
  conditionValue?: Maybe<Scalars['String']['output']>;
  /** true: 开启ScopeCondition */
  conditionalScope?: Maybe<Scalars['Boolean']['output']>;
  /** 任务禁用原因，仅 enabled: false 时有效 */
  disabledBy?: Maybe<DisabledBy>;
  /** 任务是否开启 */
  enabled: Scalars['Boolean']['output'];
  /** 是否为支付条件 */
  entryPaid?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  /** 发送量 */
  notificationsCount?: Maybe<Scalars['Int']['output']>;
  /** 按周期重复发送 */
  repeatRule?: Maybe<RepeatRule>;
  /** 基于数据定制规则发送 */
  scheduleRule?: Maybe<ScheduleRule>;
  /** 基于日期发送的规则 */
  scheduleTimeRule?: Maybe<ScheduleTimeRule>;
  /** ScopeCondition条件组 */
  scopeConditions?: Maybe<Array<ScopeCondition>>;
  /** 指定发送时间 */
  sendAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** 何时发送 */
  sendTiming?: Maybe<SendTiming>;
  /** 推送范围 */
  triggerScope: TriggerScope;
  /** 更新时间 */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type BaseTransaction = {
  /** 创建时间 */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  currency: Currency;
  id: Scalars['ID']['output'];
  order?: Maybe<Order>;
  /** 付费时间 */
  paidAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** 支付渠道 */
  paymentMethod?: Maybe<Scalars['String']['output']>;
  /** 付费金额 */
  totalFee: Scalars['Float']['output'];
  /** 交易号 */
  tradeNo?: Maybe<Scalars['String']['output']>;
  /** 交易类型 */
  type: TransactionClass;
  user?: Maybe<User>;
};

export type BaseUser = {
  /** 用户在系统中展示的名字，优先级为：企业身份下的名字 -> 微信昵称 -> 昵称 -> 邮箱 -> 手机号 */
  displayName: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  mobile?: Maybe<Scalars['String']['output']>;
};


export type BaseUserDisplayNameArgs = {
  privacyProtect?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BaseWidget = {
  displayType?: Maybe<GdPortalWidgetDisplayTypeEnum>;
  icon?: Maybe<GdPortalIconType>;
  id: Scalars['ID']['output'];
  image?: Maybe<Attachment>;
  name?: Maybe<Scalars['String']['output']>;
  type: GdPortalWidgetTypeEnum;
  visibleGroups?: Maybe<Array<GdPortalCustomerGroupType>>;
  visibleType: GdPortalWidgetVisibleTypeEnum;
};

export enum BasedOnOrder {
  /** 最新表单创建时间 */
  CreatedAt = 'created_at',
  /** 最新数据提交时间 */
  LastEntryCreatedAt = 'last_entry_created_at',
  /** 手工拖拽排序 */
  Manual = 'manual'
}

/** Autogenerated input type of BatchCreateUserInvitation */
export type BatchCreateUserInvitationInput = {
  attributes?: InputMaybe<Array<UserInvitationAttributes>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  emailOrMobileList?: InputMaybe<Array<Scalars['String']['input']>>;
  role?: InputMaybe<UserInvitationRole>;
};

/** Autogenerated return type of BatchCreateUserInvitation */
export type BatchCreateUserInvitationPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  userInvitations?: Maybe<Array<UserInvitation>>;
};

export type BatchFormSettingAttributes = {
  /** 允许搜索引擎收录 */
  allowSearchEngineIndex: Scalars['Boolean']['input'];
  /** 表单ID或者Token */
  formId: Scalars['ID']['input'];
};

/** Autogenerated input type of BatchUpdateFormEntries */
export type BatchUpdateFormEntriesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  entryAttributes: Scalars['JSON']['input'];
  /** 过滤条件 */
  filter?: InputMaybe<EntriesFilterAttributes>;
  /** 表单的使用场景 */
  formUsage?: InputMaybe<FormUsage>;
  /** 表单ID或token */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of BatchUpdateFormEntries */
export type BatchUpdateFormEntriesPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  /** true - 包含异步更新，需要重新抓取数据 */
  stale?: Maybe<Scalars['Boolean']['output']>;
  /** 更新的数据量 */
  updatedCount?: Maybe<Scalars['Int']['output']>;
  /** 更新后的数据字段值 */
  updatedFieldValues?: Maybe<Scalars['JSON']['output']>;
};

/** Autogenerated input type of BatchUpdateFormSetting */
export type BatchUpdateFormSettingInput = {
  /** 批量更新 */
  attributes: Array<BatchFormSettingAttributes>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of BatchUpdateFormSetting */
export type BatchUpdateFormSettingPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  formSettings?: Maybe<Array<FormSetting>>;
};

export type Bill = {
  billDate: Scalars['Date']['output'];
  endDate?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  items?: Maybe<Array<BillItem>>;
  startDate?: Maybe<Scalars['Date']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  totalCost: Scalars['Float']['output'];
  user?: Maybe<User>;
};

/** The connection type for Bill. */
export type BillConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<BillEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Bill>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type BillEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Bill>;
};

export type BillItem = {
  usageType: Scalars['String']['output'];
  usages: Array<BillItemDetail>;
};

export type BillItemDetail = {
  plan?: Maybe<UserPlan>;
  usageHash: Scalars['JSON']['output'];
};

export enum BillUsageType {
  Daily = 'daily',
  Monthly = 'monthly'
}

export type BillingAccount = HasBillCenter & HasMerchant & HasSmsSignature & HasUserFormApplications & HasUsers & HasYamchaAccount & PortalQuota & ThirdPartyIntegration & {
  /** 企业级 Access Token 列表（仅活跃） */
  accountAccessTokens?: Maybe<Array<AccountAccessToken>>;
  /** 企业分配的1v1客服 */
  accountSupporter?: Maybe<AccountSupporter>;
  /** 实际使用的二级域名。当套餐不可用后，返回系统随机二级域名 */
  activeSubdomain?: Maybe<Scalars['String']['output']>;
  /** 支付宝账户 */
  alipayAccounts: Array<AlipayAccount>;
  apiLicence?: Maybe<ApiLicence>;
  /** 未使用优惠券 */
  availableCoupons: Array<Coupon>;
  branding: Branding;
  cnameSetting: Cname;
  /** 公司信用编码 */
  companyId?: Maybe<Scalars['String']['output']>;
  /** 公司名称 */
  companyName?: Maybe<Scalars['String']['output']>;
  companySize?: Maybe<Scalars['String']['output']>;
  /** 已使用的填表人数量 */
  consumedSubmitterQuota: Scalars['Int']['output'];
  contactJobTitle?: Maybe<Scalars['String']['output']>;
  contactMobile?: Maybe<Scalars['String']['output']>;
  contactName?: Maybe<Scalars['String']['output']>;
  /** 创建来源 */
  createdFrom: UserCreatedFrom;
  /** 企业分配的客户成功经理 */
  csMan?: Maybe<CsMan>;
  currentFeatureTrialInfo?: Maybe<FeatureTrialInfo>;
  currentMonthlyUsage: MonthlyUsage;
  debitBalance: DebitBalance;
  /** 已过期优惠券 */
  expiredCoupons: Array<Coupon>;
  featureQuota?: Maybe<Scalars['BigInteger']['output']>;
  /** @deprecated 逻辑错误。正确逻辑是返回当前试用。否则会出现e10用户,后台添加e30试用，无法使用。请使用 currentFeatureTrialInfo */
  featureTrialInfo?: Maybe<FeatureTrialInfo>;
  /** 小金商户 */
  gdMerchant?: Maybe<GdMerchant>;
  /** 是否购买过企业版套餐 */
  hadBoughtOrgPlan?: Maybe<Scalars['Boolean']['output']>;
  hasAbility?: Maybe<Scalars['Boolean']['output']>;
  hasOrgPlan?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  /** 企业认证 - 经办人/法人电话，个人认证 - 电话 */
  identityMobile?: Maybe<Scalars['String']['output']>;
  /** 企业认证 - 法人姓名，个人认证 - 姓名 */
  identityName?: Maybe<Scalars['String']['output']>;
  industry?: Maybe<Industry>;
  /** 用户意图 */
  intention?: Maybe<Intention>;
  /** 发票抬头 */
  invoiceTitles: Array<InvoiceTitle>;
  /** 发票 */
  invoices: Array<EInvoice>;
  /** 最后一个套餐，包含已经过期的 */
  lastUserPlan?: Maybe<UserPlan>;
  latestUserPlan?: Maybe<UserPlan>;
  /** 是否需要认证状态，no_need: 无需认证，recommended: 推荐认证，required: 强制认证 */
  licenseStatus?: Maybe<LicenseStatus>;
  licenseType?: Maybe<LicenseType>;
  /** 金数据商户账户 */
  merchantAccounts: Array<MerchantAccount>;
  /** 支持月付的套餐列表 */
  monthlyPayablePlans: Array<PlanCode>;
  name?: Maybe<Scalars['String']['output']>;
  /** 未开票金额 */
  notInvoicedAmount: Scalars['Float']['output'];
  /** 未开票的付费记录 */
  notInvoicedTransactions: Array<Transaction>;
  /** 已占用的企业成员数量 */
  occupiedUsersCount: Scalars['Int']['output'];
  /** 对公转账 */
  offlineRecharges: OfflineRechargeConnection;
  /** 是否企业版套餐用户（包括试用版），true - 是，false - 不是 */
  orgAccount: Scalars['Boolean']['output'];
  /** 企业管理员 */
  owner?: Maybe<User>;
  /** 邀请中的子账号 */
  pendingUserInvitations: UserInvitationConnection;
  /** Ping++账户 */
  pingppAccounts: Array<PingppAccount>;
  /** 当前套餐的信息（active 的套餐） */
  planPackage?: Maybe<PlanPackage>;
  /** 门户配额 */
  portalQuota?: Maybe<GdPortalPortalQuotaType>;
  /** 对外表单使用的域名 */
  publishedFormHost?: Maybe<Scalars['String']['output']>;
  /** 套餐剩余价值 */
  realtimeTotalBalance: Scalars['Float']['output'];
  /** 推荐升级套餐版本 */
  recommendedPlanCode?: Maybe<Scalars['String']['output']>;
  redEnvelopeDebitBalance: RedEnvelopeDebitBalance;
  /** 客服指定的认证类型，当有值时前端不允许用户切换认证类型 */
  requiredLicenseType?: Maybe<LicenseType>;
  /** 已用数据量（已废弃） */
  reservedEntriesCount?: Maybe<Scalars['Int']['output']>;
  /** 是否超出数据上限 */
  reservedEntryOver?: Maybe<Scalars['Boolean']['output']>;
  /** 螺丝帽已审核签名列表 */
  reviewedSmsSignatures?: Maybe<Array<Signature>>;
  shortName?: Maybe<Scalars['String']['output']>;
  /** SMTP邮件服务器 */
  smtpAccounts: Array<SmtpAccount>;
  /** 企业自定义的二级域名 */
  subdomain?: Maybe<Scalars['String']['output']>;
  /** 套餐内+单独购买的填表人数量 */
  submitterQuota: Scalars['BigInteger']['output'];
  superAccount: Scalars['Boolean']['output'];
  /** 总消费金额 */
  totalSpent: Scalars['Float']['output'];
  /** true: 可以通过门户source来试用 */
  trialExist?: Maybe<Scalars['Boolean']['output']>;
  /** 套餐不可用功能列表 */
  unusableFeatureKeys?: Maybe<Array<Scalars['String']['output']>>;
  /** Url 传参的 sign secret */
  urlParamsSignSecret?: Maybe<Scalars['String']['output']>;
  /** currentUser绑定过的场景 */
  usageScenarios?: Maybe<Array<UsageScenarioKey>>;
  /** 当currentUser绑定过的场景有[其它]时，该字段为[其它]的值 */
  usageScenariosOther?: Maybe<Scalars['String']['output']>;
  /** 已使用优惠券 */
  usedCoupons: Array<Coupon>;
  /**
   * 已使用的填表人数量
   * @deprecated 不包含队列中的名额, 请使用 consumedSubmitterQuota
   */
  usedSubmitterCount: Scalars['Int']['output'];
  /** 用户表单插件 Usages */
  userFormApplications: Array<UserFormApplicationUsage>;
  /** 邀请链接 */
  userInviteLinks: Array<UserInviteLink>;
  /** 云片资质证明 */
  userLicenseAttachments?: Maybe<Array<Attachment>>;
  /** 购买套餐数量 */
  userPlansCount: Scalars['Int']['output'];
  /** 企业成员列表（子账号） */
  users: UserConnection;
  /** 套餐内+单独购买的企业成员总量 */
  usersQuota: Scalars['Int']['output'];
  /** 微信服务号账户 */
  weixinAccounts: Array<WeixinAccount>;
  /** 微信支付账户。如果是从FormType过来的，返回该表单可以使用的微信支付账户 */
  wxpayAccounts: Array<WxpayAccount>;
  /** 绑定的YamchaAccount */
  yamchaAccount?: Maybe<YamchaAccount>;
};


export type BillingAccountFeatureQuotaArgs = {
  key: Scalars['String']['input'];
};


export type BillingAccountHasAbilityArgs = {
  paidFeature: Scalars['String']['input'];
};


export type BillingAccountInvoicesArgs = {
  dedicated?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BillingAccountOfflineRechargesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type BillingAccountPendingUserInvitationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type BillingAccountSmtpAccountsArgs = {
  available?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type BillingAccountTrialExistArgs = {
  source?: InputMaybe<Scalars['String']['input']>;
};


export type BillingAccountUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type BillingAccountAttributes = {
  branding?: InputMaybe<BillingAccountBrandingAttributes>;
  cname?: InputMaybe<Scalars['String']['input']>;
  companySize?: InputMaybe<Scalars['String']['input']>;
  contactJobTitle?: InputMaybe<Scalars['String']['input']>;
  contactMobile?: InputMaybe<Scalars['String']['input']>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  customDomainEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  icp?: InputMaybe<Scalars['String']['input']>;
  industryId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  usageScenarios?: InputMaybe<Array<UsageScenarioKey>>;
  usageScenariosOther?: InputMaybe<Scalars['String']['input']>;
};

export type BillingAccountBrandingAttributes = {
  customFooter?: InputMaybe<Scalars['String']['input']>;
  customFooterEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  customFooterLink?: InputMaybe<Scalars['String']['input']>;
  customFooterLogoEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  navBgColor?: InputMaybe<Scalars['String']['input']>;
  navColor?: InputMaybe<Scalars['String']['input']>;
  navDisplay?: InputMaybe<NavDisplay>;
  navLogoAttachmentId?: InputMaybe<Scalars['ID']['input']>;
  qrcodeLogoAttachmentId?: InputMaybe<Scalars['ID']['input']>;
  shortName?: InputMaybe<Scalars['String']['input']>;
  showQrcodeLogo?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BillingAccountLandingInfoAttributes = {
  industryId?: InputMaybe<Scalars['ID']['input']>;
  intention?: InputMaybe<Intention>;
};

/** Autogenerated input type of BindSocialUserMobile */
export type BindSocialUserMobileInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 需要绑定的手机号 */
  mobileNo: Scalars['String']['input'];
  /** 手机验证码 */
  newMobileVerificationCode: Scalars['String']['input'];
  /** 第三方平台 */
  provider: ProviderEnum;
};

/** Autogenerated return type of BindSocialUserMobile */
export type BindSocialUserMobilePayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  /** 绑定手机的用户 */
  user?: Maybe<User>;
  /** 绑定后登录系统的用户Token */
  ut?: Maybe<Scalars['String']['output']>;
};

export type BindingWeixinData = {
  /** 当前群组是否允许submitter绑定微信 */
  allowBindingWeixin: Scalars['Boolean']['output'];
  /** 绑定微信时的跳转地址，当表单不能收集微信信息时返回空 */
  oauthUrl?: Maybe<Scalars['String']['output']>;
};

export type Branding = {
  customFooter?: Maybe<Scalars['String']['output']>;
  customFooterEnabled: Scalars['Boolean']['output'];
  customFooterLink?: Maybe<Scalars['String']['output']>;
  customFooterLogoEnabled: Scalars['Boolean']['output'];
  navBgColor: Scalars['String']['output'];
  navColor: Scalars['String']['output'];
  navDisplay: NavDisplay;
  navLogo?: Maybe<Attachment>;
  qrcodeLogo?: Maybe<Attachment>;
  shortName?: Maybe<Scalars['String']['output']>;
  showCustomFooter: Scalars['Boolean']['output'];
  showQrcodeLogo: Scalars['Boolean']['output'];
};

export type Bulletin = {
  conditionalScope: Scalars['Boolean']['output'];
  /** 公告内容 */
  content?: Maybe<Scalars['String']['output']>;
  /** 公告封面图 */
  cover?: Maybe<SubmitterBulletinCoverType>;
  /**
   * true: 展示, false: 隐藏
   * @deprecated 已废弃, 不展示需要按照current_submitter判断，已改为：不能看的公告不被渲染
   */
  display: Scalars['Boolean']['output'];
  /** 公告过期时间 */
  expireAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** 公告ID */
  id: Scalars['ID']['output'];
  /** 公告顺序 */
  position: Scalars['Int']['output'];
  /** 公告发布时间 */
  publishAt: Scalars['ISO8601DateTime']['output'];
  /** 发布模式 */
  publishMode: BulletinPublishModeEnum;
  scopeConditions?: Maybe<Array<ScopeCondition>>;
  /** 公告标题 */
  title: Scalars['String']['output'];
};

export type BulletinAttributes = {
  /** 设置数据范围 */
  conditionalScope?: InputMaybe<Scalars['Boolean']['input']>;
  /** 公告内容 */
  content?: InputMaybe<Scalars['String']['input']>;
  /** 缩略图 */
  coverAttributes?: InputMaybe<SubmitterBulletinCoverAttributes>;
  /** true: 删除 */
  destroy?: InputMaybe<Scalars['Boolean']['input']>;
  /** 公告失效时间 */
  expireAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** 公告ID */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** 公告顺序 */
  position: Scalars['Int']['input'];
  /** 发布时间,默认为立即发布 */
  publishAt: Scalars['ISO8601DateTime']['input'];
  /** 发布模式 */
  publishMode: BulletinPublishModeEnum;
  /** 数据条件 */
  scopeConditions?: InputMaybe<Array<ScopeConditionAttributes>>;
  /** 公告状态 */
  status: BulletinStatusEnum;
  /** 公告标题 */
  title: Scalars['String']['input'];
};

/** The connection type for Bulletin. */
export type BulletinConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<BulletinEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Bulletin>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type BulletinEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Bulletin>;
};

export enum BulletinPublishModeEnum {
  /** 定时发布 */
  FixedTime = 'fixed_time',
  /** 立即发布 */
  Immediate = 'immediate'
}

export enum BulletinStatusEnum {
  /** 展示公告 */
  Display = 'display',
  /** 隐藏公告 */
  Hidden = 'hidden'
}

export type ByDayRepeatWeeklyQuota = ReservationQuotaSettingBase & {
  /** 可预约的星期 */
  availableDaysOfWeek: Array<DayNameOfWeek>;
  dailyTimeRangeQuotas?: Maybe<Array<DailyTimeRangeQuota>>;
  /** 最大可预约时间限制 */
  endTimeOffset?: Maybe<ReservationTimeOffset>;
  /** 不可预约的时间段 */
  nonReservableRules?: Maybe<Array<NonReservableRule>>;
  /** 名额仅统计未删除数据 */
  quotaExcludeDeletedEntry: Scalars['Boolean']['output'];
  /** true: 向填表者展示剩余名额, false: 不展示, 默认: true */
  showLeftQuota?: Maybe<Scalars['Boolean']['output']>;
  specialTimeRangeQuotas?: Maybe<Array<SpecialTimeRangeQuota>>;
  /** 提前预约时间限制 */
  startTimeOffset?: Maybe<ReservationTimeOffset>;
  /** 预约类型 */
  type?: Maybe<ReservationQuotaSettingType>;
};

export type ByEntriesCloseRule = {
  /** 收集数据条数 */
  limit?: Maybe<Scalars['Int']['output']>;
};

export type ByEntriesCloseRuleAttributes = {
  /** 是否启用 */
  enabled: Scalars['Boolean']['input'];
  /** 收集数据条数限制 */
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type ByTimeRangeCloseRule = {
  /** 停止时间 */
  endTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** 开始时间 */
  startTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type ByTimeRangeCloseRuleAttributes = {
  /** 是否启用 */
  enabled: Scalars['Boolean']['input'];
  /** 停止时间，目前「分」的设置只支持0，5，10...50，55 */
  endTime?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** 开始时间，目前「分」的设置只支持0，5，10...50，55 */
  startTime?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
};

export type ByTimeRangeRepeatDailyQuota = ReservationQuotaSettingBase & {
  /** 可预约的星期 */
  availableDaysOfWeek: Array<DayNameOfWeek>;
  dailyTimeRangeQuotas?: Maybe<Array<DailyTimeRangeQuota>>;
  dailyTimeRanges?: Maybe<Array<DailyTimeRange>>;
  /** 最大可预约时间限制 */
  endTimeOffset?: Maybe<ReservationTimeOffset>;
  /** 不可预约的时间段 */
  nonReservableRules?: Maybe<Array<NonReservableRule>>;
  /** 名额仅统计未删除数据 */
  quotaExcludeDeletedEntry: Scalars['Boolean']['output'];
  /** true: 向填表者展示剩余名额, false: 不展示, 默认: true */
  showLeftQuota?: Maybe<Scalars['Boolean']['output']>;
  /** 提前预约时间限制 */
  startTimeOffset?: Maybe<ReservationTimeOffset>;
  timeRangeMode: TimeRangeMode;
  /** 预约类型 */
  type?: Maybe<ReservationQuotaSettingType>;
};

export type CsMan = BaseAccountSupporter & {
  /** 头像图片URL */
  avatarUrl?: Maybe<Scalars['String']['output']>;
  /** 展示名字 */
  displayName?: Maybe<Scalars['String']['output']>;
  /** CSMan 记录 ID */
  id: Scalars['ID']['output'];
  /** 联系电话 */
  mobileNo?: Maybe<Scalars['String']['output']>;
  /** 二维码图片URL */
  qrcodeUrl?: Maybe<Scalars['String']['output']>;
  /** CS 角色，cs 或 cs_manager */
  role?: Maybe<Scalars['String']['output']>;
};

export type CsManageCsManAdmin = BaseAccountSupporter & {
  /** 头像图片URL */
  avatarUrl?: Maybe<Scalars['String']['output']>;
  /** 展示名字 */
  displayName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** 联系电话 */
  mobileNo?: Maybe<Scalars['String']['output']>;
  /** 二维码图片URL */
  qrcodeUrl?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type CsManageCsWorkload = {
  activeHandoffs: Scalars['Int']['output'];
  csMan: CsMan;
};

export type CsManageConversationRow = {
  activeHandoff: Scalars['Boolean']['output'];
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  customer?: Maybe<BaseUser>;
  handoffCount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  lastHandlerName?: Maybe<Scalars['String']['output']>;
};

export type CsManageConversationsPage = {
  rows: Array<CsManageConversationRow>;
  total: Scalars['Int']['output'];
};

export type CsManageDashboardMetrics = {
  /** 当前仍在进行中的 handoff 数 */
  activeHandoffs: Scalars['Int']['output'];
  /** 各 CS 当前 active handoff 工作量 */
  csWorkload: Array<CsManageCsWorkload>;
  /** 今日结束的 handoff 数 */
  todayEndedHandoffs: Scalars['Int']['output'];
  /** 今日新创建的 AgentInquiry 会话数 */
  todayNewConversations: Scalars['Int']['output'];
  /** 今日开始的 handoff 数 */
  todayTakeovers: Scalars['Int']['output'];
};

/** Autogenerated input type of CSManageUpdateCSMan */
export type CsManageUpdateCsManInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  nickName?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CSManageUpdateCSMan */
export type CsManageUpdateCsManPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  csMan?: Maybe<CsManageCsManAdmin>;
  errors?: Maybe<Array<Error>>;
};

export type CalculableField = {
  /** 开启选项赋值或本身可参与计算 */
  calculable: Scalars['Boolean']['output'];
};

/** Autogenerated input type of CancelAdvancedNotification */
export type CancelAdvancedNotificationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of CancelAdvancedNotification */
export type CancelAdvancedNotificationPayload = {
  advancedNotification?: Maybe<AdvancedNotificationsNotification>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
};

/** Autogenerated input type of CancelPendingHandoff */
export type CancelPendingHandoffInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 要取消等待人工的 AgentInquiryConversation Id */
  conversationId: Scalars['String']['input'];
};

/** Autogenerated return type of CancelPendingHandoff */
export type CancelPendingHandoffPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  conversation?: Maybe<Conversation>;
  errors?: Maybe<Array<Error>>;
};

export type CandidateUser = {
  avatarUrl?: Maybe<Scalars['String']['output']>;
  /** 用户在系统中展示的名字，优先级为：企业身份下的名字 -> 微信昵称 -> 昵称 -> 邮箱 -> 手机号 */
  displayName: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Is member of current billing_account */
  joined?: Maybe<Scalars['Boolean']['output']>;
  mobile?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};


export type CandidateUserDisplayNameArgs = {
  privacyProtect?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Carousel = AssociatedField & BaseField & FieldAbility & FieldItemImageCount & PlanAvailableField & {
  apiCode: Scalars['ID']['output'];
  apiCodeAlias?: Maybe<Scalars['String']['output']>;
  /** 对应的表单关联字段 */
  associationField?: Maybe<Field>;
  /** 自动填写上次提交内容 */
  cacheData: Scalars['Boolean']['output'];
  /** 客户端ID */
  cid?: Maybe<Scalars['String']['output']>;
  /** 封装的字段类型 */
  customizedType?: Maybe<Scalars['String']['output']>;
  /** 封装的字段类型文本 */
  customizedTypeName?: Maybe<Scalars['String']['output']>;
  /** 自定义出错文案 */
  customizedValidationMessage?: Maybe<Scalars['String']['output']>;
  /** 已提交的数据是否可被编辑 */
  editable: Scalars['Boolean']['output'];
  /** 该字段能否使用字段规则: true - 能， false - 不能 */
  fieldRuleAvailable: Scalars['Boolean']['output'];
  /** 展示字段中，图文介绍、图片展示、轮播图、倒计时的样式 */
  fieldStyle?: Maybe<DisplayFieldsFieldStyleType>;
  /** 是否是关联主键字段 */
  forAssociated?: Maybe<Scalars['Boolean']['output']>;
  /** 是否是关联展示字段 */
  forAssociatedDisplay?: Maybe<Scalars['Boolean']['output']>;
  /** 表单Token */
  formToken: Scalars['String']['output'];
  /** 宽度占用整行的四分之几 */
  gridsToOccupy?: Maybe<Scalars['Int']['output']>;
  hasAbility: Scalars['Boolean']['output'];
  /** 轮播图-图片设置 */
  images: Array<DisplayFieldsFieldItemImageType>;
  /** 图片展示、轮播图的图片数量 */
  imagesCount?: Maybe<Scalars['Int']['output']>;
  /** 字段标题（去富文本化） */
  label?: Maybe<Scalars['String']['output']>;
  /** 展示字段中，图文介绍、图片展示、轮播图、倒计时的布局 */
  layout?: Maybe<DisplayFieldLayout>;
  /** 字段描述，富文本 */
  notes?: Maybe<Scalars['String']['output']>;
  paidFeature?: Maybe<PaidFeature>;
  planAvailable: Scalars['Boolean']['output'];
  /** 字段排序 */
  position: Scalars['Int']['output'];
  /** 该字段是否是隐私字段 true - 是, false - 不是 */
  privacy: Scalars['Boolean']['output'];
  /** 字段隐藏 */
  private: Scalars['Boolean']['output'];
  /** 字段是否通过预填写表单预设了值 true - 是, false - 否 */
  pseudoFormPredefined?: Maybe<Scalars['Boolean']['output']>;
  /** 字段标题（富文本化） */
  rawLabel?: Maybe<Scalars['String']['output']>;
  /** 字段是否只读，无法编辑 */
  readonly?: Maybe<Scalars['Boolean']['output']>;
  /** 该字段是否属于评分字段（e.g. 考试、测评中的题目） */
  scorable: Scalars['Boolean']['output'];
  /** 字段提示较长时折叠展示 */
  showPartDescription: Scalars['Boolean']['output'];
  /** 新起一行 */
  startNewRow: Scalars['Boolean']['output'];
  /** 该字段是否可以作为文本插入 true - 能, false - 不能 */
  textPlaceholderable: Scalars['Boolean']['output'];
  /** 字段类型 */
  type: FieldClass;
  /** 字段类型文本 */
  typeName: Scalars['String']['output'];
  /** 字段验证规则 */
  validations?: Maybe<Array<FieldValidation>>;
};


export type CarouselHasAbilityArgs = {
  key: FieldAbilityEnum;
};


export type CarouselNotesArgs = {
  sanitize?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CascadeChoiceFieldReport = {
  field?: Maybe<Field>;
  widgets?: Maybe<Array<Widget>>;
};

export type CascadeDropDown = AssociatedField & BaseField & CalculableField & FieldAbility & PlanAvailableField & PredefineableField & PromptableField & QuotableField & {
  apiCode: Scalars['ID']['output'];
  apiCodeAlias?: Maybe<Scalars['String']['output']>;
  /** 对应的表单关联字段 */
  associationField?: Maybe<Field>;
  /** 自动填写上次提交内容 */
  cacheData: Scalars['Boolean']['output'];
  /** 开启选项赋值或本身可参与计算 */
  calculable: Scalars['Boolean']['output'];
  choiceFilterable: Scalars['Boolean']['output'];
  choices: Array<TextChoice>;
  /** 客户端ID */
  cid?: Maybe<Scalars['String']['output']>;
  /** 封装的字段类型 */
  customizedType?: Maybe<Scalars['String']['output']>;
  /** 封装的字段类型文本 */
  customizedTypeName?: Maybe<Scalars['String']['output']>;
  /** 自定义出错文案 */
  customizedValidationMessage?: Maybe<Scalars['String']['output']>;
  /** 已提交的数据是否可被编辑 */
  editable: Scalars['Boolean']['output'];
  /** 该字段能否使用字段规则: true - 能， false - 不能 */
  fieldRuleAvailable: Scalars['Boolean']['output'];
  /** 是否是关联主键字段 */
  forAssociated?: Maybe<Scalars['Boolean']['output']>;
  /** 是否是关联展示字段 */
  forAssociatedDisplay?: Maybe<Scalars['Boolean']['output']>;
  /** 表单Token */
  formToken: Scalars['String']['output'];
  /** 宽度占用整行的四分之几 */
  gridsToOccupy?: Maybe<Scalars['Int']['output']>;
  hasAbility: Scalars['Boolean']['output'];
  /** 选项名额为空时隐藏选项 */
  hideChoiceWhenQuotaEmpty: Scalars['Boolean']['output'];
  /** 不向填表者展示选项名额剩余数字 */
  hideQuota: Scalars['Boolean']['output'];
  /** 字段标题（去富文本化） */
  label?: Maybe<Scalars['String']['output']>;
  levels: Scalars['Int']['output'];
  /** 字段描述，富文本 */
  notes?: Maybe<Scalars['String']['output']>;
  paidFeature?: Maybe<PaidFeature>;
  planAvailable: Scalars['Boolean']['output'];
  /** 字段排序 */
  position: Scalars['Int']['output'];
  /** 预填写表单 */
  predefined: Scalars['Boolean']['output'];
  /** 该字段是否是隐私字段 true - 是, false - 不是 */
  privacy: Scalars['Boolean']['output'];
  /** 字段隐藏 */
  private: Scalars['Boolean']['output'];
  prompt?: Maybe<Scalars['String']['output']>;
  /** @deprecated Next中多级下拉只有一个下拉框，因此改为prompt 字段。此字段目前只在 4.0中使用 */
  prompts: Scalars['JSON']['output'];
  /** 字段是否通过预填写表单预设了值 true - 是, false - 否 */
  pseudoFormPredefined?: Maybe<Scalars['Boolean']['output']>;
  /** 剩余名额为0时，显示文案 */
  quotaBlankWarning?: Maybe<Scalars['String']['output']>;
  /** 选项名额重置 */
  quotaCycleRule?: Maybe<QuotaCycleRule>;
  /** 删除数据后，选项名额自动恢复 */
  quotaRecoverable: Scalars['Boolean']['output'];
  randomChoices: Scalars['Boolean']['output'];
  /** 字段标题（富文本化） */
  rawLabel?: Maybe<Scalars['String']['output']>;
  /** 字段是否只读，无法编辑 */
  readonly?: Maybe<Scalars['Boolean']['output']>;
  /** 该字段是否属于评分字段（e.g. 考试、测评中的题目） */
  scorable: Scalars['Boolean']['output'];
  /** 字段提示较长时折叠展示 */
  showPartDescription: Scalars['Boolean']['output'];
  /** 新起一行 */
  startNewRow: Scalars['Boolean']['output'];
  /** 该字段是否可以作为文本插入 true - 能, false - 不能 */
  textPlaceholderable: Scalars['Boolean']['output'];
  /** 字段类型 */
  type: FieldClass;
  /** 字段类型文本 */
  typeName: Scalars['String']['output'];
  /** 字段验证规则 */
  validations?: Maybe<Array<FieldValidation>>;
};


export type CascadeDropDownHasAbilityArgs = {
  key: FieldAbilityEnum;
};


export type CascadeDropDownNotesArgs = {
  sanitize?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Cash = {
  /** 兑奖方式：phone - 手机号码，code - 兑奖码 */
  cashStyle: CashStyle;
  /** 当兑奖方式为手机号码时，该字段为手机字段的api_code */
  mobileFieldApiCode?: Maybe<Scalars['ID']['output']>;
};

export enum CashStyle {
  Code = 'code',
  Phone = 'phone'
}

export type Certificate = {
  /** 背景图片 */
  background?: Maybe<CertificateBackground>;
  /** 证书类型 */
  bgType?: Maybe<Scalars['String']['output']>;
  /** 系统证书url */
  builtinUrl?: Maybe<Scalars['String']['output']>;
  conditionalScope?: Maybe<Scalars['Boolean']['output']>;
  /** 图片方向 */
  direction?: Maybe<Scalars['String']['output']>;
  /** 描述 */
  elements: Array<Scalars['JSON']['output']>;
  /** 显示规则 */
  scopeConditionType?: Maybe<Scalars['String']['output']>;
  scopeConditions?: Maybe<Array<ScopeCondition>>;
};

export type CertificateAttributes = {
  /** 背景图片 */
  background?: InputMaybe<CertificateBackgroundAttributes>;
  /** 证书类型 */
  bgType: Scalars['String']['input'];
  /** 系统证书url */
  builtinUrl?: InputMaybe<Scalars['String']['input']>;
  /** 设置数据范围 */
  conditionalScope?: InputMaybe<Scalars['Boolean']['input']>;
  /** 图片方向 */
  direction: Scalars['String']['input'];
  /** 描述 */
  elements?: InputMaybe<Array<Scalars['JSON']['input']>>;
  /** 显示规则 */
  scopeConditionType: Scalars['String']['input'];
  /** 数据条件 */
  scopeConditions?: InputMaybe<Array<ScopeConditionAttributes>>;
};

export type CertificateBackground = {
  attachment?: Maybe<Attachment>;
  /** 裁剪高度 */
  croppedH?: Maybe<Scalars['Int']['output']>;
  /** 裁剪宽度 */
  croppedW?: Maybe<Scalars['Int']['output']>;
  /** 裁剪起点-X轴 */
  croppedX?: Maybe<Scalars['Int']['output']>;
  /** 裁剪起点-Y轴 */
  croppedY?: Maybe<Scalars['Int']['output']>;
};

export type CertificateBackgroundAttributes = {
  /** 背景图片id */
  attachmentId?: InputMaybe<Scalars['ID']['input']>;
  croppedH?: InputMaybe<Scalars['Int']['input']>;
  croppedW?: InputMaybe<Scalars['Int']['input']>;
  croppedX?: InputMaybe<Scalars['Int']['input']>;
  croppedY?: InputMaybe<Scalars['Int']['input']>;
};

export enum CertificateGenerateWay {
  /** After submission */
  AfterSubmission = 'after_submission',
  /** Manual only */
  ManualOnly = 'manual_only',
  /** Via button after submission */
  ViaButtonAfterSubmission = 'via_button_after_submission'
}

export type CertificateJob = BaseEntriesBatchJob & {
  /** 总的数据量 */
  entriesCount?: Maybe<Scalars['BigInteger']['output']>;
  /** 预估的剩余时长 */
  estimateLeft?: Maybe<Scalars['BigInteger']['output']>;
  /** 生成失败的数据量 */
  failedEntriesCount?: Maybe<Scalars['BigInteger']['output']>;
  /** 数据筛选条件 */
  filter?: Maybe<Scalars['JSON']['output']>;
  /** ID */
  id: Scalars['ID']['output'];
  /** 数据范围 */
  rowScope: RowScopeType;
  /** 导出任务状态 */
  status: EntriesBatchJobStatus;
};

export type CertificateSetting = {
  /** 提交后按钮文案 */
  btnContent?: Maybe<Scalars['String']['output']>;
  /** 多证书列表 */
  certificates?: Maybe<Array<Certificate>>;
  /** 证书名称 */
  displayLabel?: Maybe<Scalars['String']['output']>;
  /** 证书开关 */
  enabled: Scalars['Boolean']['output'];
  /** 生成方式 */
  generateWay?: Maybe<CertificateGenerateWay>;
  /**
   * 展示方式
   * @deprecated 添加了手动生成，请使用generate_way
   */
  successMessageStyle?: Maybe<Scalars['String']['output']>;
};

export type CertificatesConfig = {
  /** 系统证书模板列表 */
  certificatesTemplates?: Maybe<Array<CertificatesTemplate>>;
};

export type CertificatesTemplate = {
  id: Scalars['ID']['output'];
  /** 模板名 */
  name: Scalars['String']['output'];
  /** 图片地址 */
  templateUrl: Scalars['String']['output'];
};

export type ChargeRedEnvelopeTransaction = BaseTransaction & {
  /** 创建时间 */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  currency: Currency;
  id: Scalars['ID']['output'];
  order?: Maybe<Order>;
  /** 付费时间 */
  paidAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** 支付渠道 */
  paymentMethod?: Maybe<Scalars['String']['output']>;
  redEnvelopeOrder?: Maybe<RedEnvelopeOrder>;
  /** 付费金额 */
  totalFee: Scalars['Float']['output'];
  /** 交易号 */
  tradeNo?: Maybe<Scalars['String']['output']>;
  /** 交易类型 */
  type: TransactionClass;
  user?: Maybe<User>;
};

/** The connection type for ChargeRedEnvelopeTransaction. */
export type ChargeRedEnvelopeTransactionConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ChargeRedEnvelopeTransactionEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ChargeRedEnvelopeTransaction>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ChargeRedEnvelopeTransactionEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ChargeRedEnvelopeTransaction>;
};

export type ChargeTransaction = BaseTransaction & {
  /** 创建时间 */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  currency: Currency;
  id: Scalars['ID']['output'];
  order?: Maybe<Order>;
  /** 付费时间 */
  paidAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** 支付渠道 */
  paymentMethod?: Maybe<Scalars['String']['output']>;
  /** 付费金额 */
  totalFee: Scalars['Float']['output'];
  /** 交易号 */
  tradeNo?: Maybe<Scalars['String']['output']>;
  /** 交易类型 */
  type: TransactionClass;
  user?: Maybe<User>;
};

export type CheckBox = AssociatedField & BaseField & CalculableField & ChoiceExclusivableField & ExtraConfigurableSetting & FieldAbility & LengthValidatableField & PlanAvailableField & PredefineableField & PromptableField & QuotableField & SelectableField & {
  apiCode: Scalars['ID']['output'];
  apiCodeAlias?: Maybe<Scalars['String']['output']>;
  /** 对应的表单关联字段 */
  associationField?: Maybe<Field>;
  /** 自动填写上次提交内容 */
  cacheData: Scalars['Boolean']['output'];
  /** 开启选项赋值或本身可参与计算 */
  calculable: Scalars['Boolean']['output'];
  choices: Array<Choice>;
  choicesLayout?: Maybe<ChoicesLayout>;
  /** 客户端ID */
  cid?: Maybe<Scalars['String']['output']>;
  /** 封装的字段类型 */
  customizedType?: Maybe<Scalars['String']['output']>;
  /** 封装的字段类型文本 */
  customizedTypeName?: Maybe<Scalars['String']['output']>;
  /** 自定义出错文案 */
  customizedValidationMessage?: Maybe<Scalars['String']['output']>;
  displayEntryCountsPerChoice: Scalars['Boolean']['output'];
  /** 已提交的数据是否可被编辑 */
  editable: Scalars['Boolean']['output'];
  exclusiveChoiceApiCodes?: Maybe<Array<Scalars['ID']['output']>>;
  /** 场景化可配置字段设置 */
  extraConfigurableSettings?: Maybe<FieldExtraConfigurableSettings>;
  /** 该字段能否使用字段规则: true - 能， false - 不能 */
  fieldRuleAvailable: Scalars['Boolean']['output'];
  /** 是否是关联主键字段 */
  forAssociated?: Maybe<Scalars['Boolean']['output']>;
  /** 是否是关联展示字段 */
  forAssociatedDisplay?: Maybe<Scalars['Boolean']['output']>;
  /** 表单Token */
  formToken: Scalars['String']['output'];
  /** 宽度占用整行的四分之几 */
  gridsToOccupy?: Maybe<Scalars['Int']['output']>;
  hasAbility: Scalars['Boolean']['output'];
  /** 选项名额为空时隐藏选项 */
  hideChoiceWhenQuotaEmpty: Scalars['Boolean']['output'];
  /** 不向填表者展示选项名额剩余数字 */
  hideQuota: Scalars['Boolean']['output'];
  /** 字段标题（去富文本化） */
  label?: Maybe<Scalars['String']['output']>;
  maximumLength?: Maybe<Scalars['BigInteger']['output']>;
  migratedFromDropDown?: Maybe<Scalars['Boolean']['output']>;
  minimumLength?: Maybe<Scalars['BigInteger']['output']>;
  /** 字段描述，富文本 */
  notes?: Maybe<Scalars['String']['output']>;
  paidFeature?: Maybe<PaidFeature>;
  planAvailable: Scalars['Boolean']['output'];
  /** 字段排序 */
  position: Scalars['Int']['output'];
  /** 预填写表单 */
  predefined: Scalars['Boolean']['output'];
  presentationStyle: CheckBoxPresentationStyle;
  /** 该字段是否是隐私字段 true - 是, false - 不是 */
  privacy: Scalars['Boolean']['output'];
  /** 字段隐藏 */
  private: Scalars['Boolean']['output'];
  prompt?: Maybe<Scalars['String']['output']>;
  /** 字段是否通过预填写表单预设了值 true - 是, false - 否 */
  pseudoFormPredefined?: Maybe<Scalars['Boolean']['output']>;
  /** 剩余名额为0时，显示文案 */
  quotaBlankWarning?: Maybe<Scalars['String']['output']>;
  /** 选项名额重置 */
  quotaCycleRule?: Maybe<QuotaCycleRule>;
  /** 删除数据后，选项名额自动恢复 */
  quotaRecoverable: Scalars['Boolean']['output'];
  randomChoices: Scalars['Boolean']['output'];
  /** 字段标题（富文本化） */
  rawLabel?: Maybe<Scalars['String']['output']>;
  /** 字段是否只读，无法编辑 */
  readonly?: Maybe<Scalars['Boolean']['output']>;
  /** 该字段是否属于评分字段（e.g. 考试、测评中的题目） */
  scorable: Scalars['Boolean']['output'];
  /** 字段提示较长时折叠展示 */
  showPartDescription: Scalars['Boolean']['output'];
  /** 新起一行 */
  startNewRow: Scalars['Boolean']['output'];
  /** 该字段是否可以作为文本插入 true - 能, false - 不能 */
  textPlaceholderable: Scalars['Boolean']['output'];
  /** 字段类型 */
  type: FieldClass;
  /** 字段类型文本 */
  typeName: Scalars['String']['output'];
  /** 字段验证规则 */
  validations?: Maybe<Array<FieldValidation>>;
  withExclusiveChoice: Scalars['Boolean']['output'];
};


export type CheckBoxHasAbilityArgs = {
  key: FieldAbilityEnum;
};


export type CheckBoxNotesArgs = {
  sanitize?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum CheckBoxPresentationStyle {
  /** Dropdown */
  Dropdown = 'dropdown',
  /** List */
  List = 'list'
}

/** Autogenerated input type of CheckWebhookAvailable */
export type CheckWebhookAvailableInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  formId: Scalars['ID']['input'];
  /** Webhook URL to check */
  url: Scalars['String']['input'];
};

/** Autogenerated return type of CheckWebhookAvailable */
export type CheckWebhookAvailablePayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  /** Whether the webhook rule is in success */
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ChineseFontAttributes = {
  /** 字体名字 */
  name: Scalars['String']['input'];
  /** 待裁剪的内容 */
  text: Scalars['String']['input'];
};

export type Choice = ColorMarkChoice | ImageChoice | OtherChoice | TextChoice;

export type ChoiceExclusivableField = {
  exclusiveChoiceApiCodes?: Maybe<Array<Scalars['ID']['output']>>;
  withExclusiveChoice: Scalars['Boolean']['output'];
};

export type ChoiceFieldReport = {
  field?: Maybe<Field>;
  widgets?: Maybe<Array<Widget>>;
};

export enum ChoiceType {
  Choice = 'Choice',
  ImageChoice = 'ImageChoice',
  OtherChoice = 'OtherChoice'
}

export enum ChoicesLayout {
  Column = 'column',
  SideBySide = 'side_by_side'
}

export type CloseRule = {
  /** 数据条数关闭表单规则 */
  byEntriesCloseRule?: Maybe<ByEntriesCloseRule>;
  /** 数据收集时间之开启/停止时间 */
  byTimeRangeCloseRule?: Maybe<ByTimeRangeCloseRule>;
  /** 每日开放填写时间 */
  dailyRepeatCloseRule?: Maybe<DailyRepeatCloseRule>;
  /** 手动开启关闭表单数据收集开关设置 */
  manuallyCloseRule: ManuallyCloseRule;
  /** 在表单中显示停止倒计时 */
  showCloseCountDown: Scalars['Boolean']['output'];
  /** 表单开放前是否展示表单内容 */
  showFormBeforeOpen: Scalars['Boolean']['output'];
};

export type Cname = {
  cname?: Maybe<Scalars['String']['output']>;
  cnameEnabled: Scalars['Boolean']['output'];
  customDomainEnabled: Scalars['Boolean']['output'];
  icp?: Maybe<Scalars['String']['output']>;
  protocol: Scalars['String']['output'];
};

export type ColorMarkChoice = BaseChoice & {
  /** 色号 */
  color: Scalars['String']['output'];
  /** 强调色号，例如数据详情中的回显色号 */
  emphasisColor: Scalars['String']['output'];
  /** 颜色分组 */
  group: ColorMarkChoiceGroupEnum;
  hidden: Scalars['Boolean']['output'];
  /** 颜色名称 */
  name: Scalars['String']['output'];
  operandValue?: Maybe<Scalars['Float']['output']>;
  position: Scalars['Int']['output'];
  selected: Scalars['Boolean']['output'];
  type?: Maybe<Scalars['String']['output']>;
  value: Scalars['ID']['output'];
};

export enum ColorMarkChoiceGroupEnum {
  /** 深色 */
  Dark = 'dark',
  /** 浅色 */
  Light = 'light'
}

export enum ColumnScopeType {
  All = 'all',
  Limited = 'limited'
}

export type Complaint = {
  reason: Scalars['String']['output'];
};

/** Autogenerated input type of CompletelyDestroyForm */
export type CompletelyDestroyFormInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 表单ID或token */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of CompletelyDestroyForm */
export type CompletelyDestroyFormPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
};

export enum Condition {
  /** By device */
  ByDevice = 'by_device',
  /** By fields */
  ByFields = 'by_fields',
  /** By IP */
  ByIp = 'by_ip',
  /** By weixin */
  ByWeixin = 'by_weixin'
}

export type ConditionalChoice = {
  name: Scalars['String']['output'];
  subChoices?: Maybe<Array<ConditionalChoice>>;
  value: Scalars['ID']['output'];
};

/** The connection type for ConditionalChoice. */
export type ConditionalChoiceConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ConditionalChoiceEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ConditionalChoice>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ConditionalChoiceEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ConditionalChoice>;
};

export type ConditionalTriggerableField = HasDynamicConditionValues & {
  apiCode: Scalars['ID']['output'];
  /** @deprecated 当选项过多时会存在性能问题,请使用relay_choices替代 */
  choices?: Maybe<Array<ConditionalChoice>>;
  /** 只有在 FormulaField 为日期格式时返回 true */
  displayAsDate?: Maybe<Scalars['Boolean']['output']>;
  label: Scalars['String']['output'];
  paginationChoices?: Maybe<ConditionalChoiceConnection>;
  /** 系统预定义的动态条件选项 */
  predefinedDynamicConditionOptions?: Maybe<Array<PredefinedDynamicCondition>>;
  rawValueKey: Scalars['ID']['output'];
  /** 只有在 FormulaField 返回结果的数据类型 */
  resultDisplayType?: Maybe<ValueTypeEnum>;
  supportedOperators: Array<ScopeConditionOperator>;
  type: FieldClass;
};


export type ConditionalTriggerableFieldPaginationChoicesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export enum ConditionalTriggerableFieldsContext {
  /** 展示或修改表单角色 */
  FormRole = 'form_role'
}

export type Contact = {
  /** 联系人邮箱 */
  emails?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['ID']['output'];
  /** 联系人名称 */
  name?: Maybe<Scalars['String']['output']>;
  /** 联系人电话 */
  phones?: Maybe<Array<Scalars['String']['output']>>;
};

export type ContactEmail = Base & {
  /** 推送类型 */
  approach: Approach;
  cachedFormName: Scalars['String']['output'];
  /** 推送/短信/邮件内容 */
  content?: Maybe<Scalars['String']['output']>;
  entry?: Maybe<Entry>;
  /** 错误信息 */
  errorMessage?: Maybe<Scalars['String']['output']>;
  form?: Maybe<Form>;
  id: Scalars['ID']['output'];
  messageCount: Scalars['Int']['output'];
  /** 发送时间（不等于任务触发时间） */
  performedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** 收件人，常用于短信和邮件 */
  recipient?: Maybe<Scalars['String']['output']>;
  /** 状态 */
  status: Status;
};

/** The connection type for ContactEmail. */
export type ContactEmailConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ContactEmailEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ContactEmail>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ContactEmailEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ContactEmail>;
};

export type ContactSms = Base & {
  /** 推送类型 */
  approach: Approach;
  cachedFormName: Scalars['String']['output'];
  /** 推送/短信/邮件内容 */
  content?: Maybe<Scalars['String']['output']>;
  entry?: Maybe<Entry>;
  /** 错误信息 */
  errorMessage?: Maybe<Scalars['String']['output']>;
  form?: Maybe<Form>;
  id: Scalars['ID']['output'];
  messageCount: Scalars['Int']['output'];
  /** 发送时间（不等于任务触发时间） */
  performedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** 收件人，常用于短信和邮件 */
  recipient?: Maybe<Scalars['String']['output']>;
  /** 状态 */
  status: Status;
};

/** The connection type for ContactSMS. */
export type ContactSmsConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ContactSmsEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ContactSms>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ContactSmsEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ContactSms>;
};

export type ContactTag = {
  contactsCount?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/** The connection type for ContactTag. */
export type ContactTagConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ContactTagEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ContactTag>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ContactTagEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ContactTag>;
};

export type ContactTagRule = {
  contactTags: Array<ContactTag>;
  id: Scalars['ID']['output'];
  scopeConditions?: Maybe<Array<ScopeCondition>>;
};

export type ContactTagRuleAttributes = {
  /** 设置数据范围 */
  conditionalScope: Scalars['Boolean']['input'];
  /** 数据条件 */
  scopeConditions: Array<ScopeConditionAttributes>;
  tags: Array<TagAttributes>;
};

/** The connection type for ContactTagRule. */
export type ContactTagRuleConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ContactTagRuleEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ContactTagRule>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ContactTagRuleEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ContactTagRule>;
};

export type Conversation = {
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** 会话的用户（发起人） */
  customer?: Maybe<User>;
  /** 会话的人工接管历史，按接管时间升序 */
  handoffHistory: Array<Handoff>;
  id: Scalars['ID']['output'];
  /** 会话中的消息列表 */
  messages: Array<Message>;
  /** 用户发起转人工的时间；nil 表示仍在 Jiri 处理 */
  requestedHumanAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** 对话主题 */
  subject?: Maybe<Scalars['String']['output']>;
  /** 人工填写的会话总结 */
  summary?: Maybe<ConversationSummary>;
  /** 被接管的时间；nil 表示尚未被接管 */
  takenOverAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** 当前接管该会话的 CS */
  takenOverBy?: Maybe<CsMan>;
  /**
   * 对话类型
   * @deprecated 已废弃
   */
  type?: Maybe<ConversationTypeEnum>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** The connection type for Conversation. */
export type ConversationConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ConversationEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Conversation>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ConversationEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Conversation>;
};

export type ConversationSummary = {
  /** AI 解答备注 */
  aiResolution?: Maybe<Scalars['String']['output']>;
  /** 所属业务 */
  business?: Maybe<Scalars['String']['output']>;
  /** 是否有效会话 */
  isValid?: Maybe<Scalars['String']['output']>;
  /** 问题类型 */
  problemType?: Maybe<Scalars['String']['output']>;
  /** 总结备注（自由文本） */
  remarks?: Maybe<Scalars['String']['output']>;
  /** 最近一次更新时间 */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export enum ConversationTypeEnum {
  /** Agent代理生成表单 */
  AgentGenerateForm = 'agent_generate_form',
  /** AI客服 */
  AgentInquiry = 'agent_inquiry',
  /** 一句话生成表单 */
  GenerateForm = 'generate_form',
  /** 生成表单描述 */
  GenerateFormDescription = 'generate_form_description'
}

/** Autogenerated input type of ConvertExperiencePaymentForm */
export type ConvertExperiencePaymentFormInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['ID']['input'];
};

/** Autogenerated return type of ConvertExperiencePaymentForm */
export type ConvertExperiencePaymentFormPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  form?: Maybe<Form>;
};

/** Autogenerated input type of ConvertMockPaymentForms */
export type ConvertMockPaymentFormsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of ConvertMockPaymentForms */
export type ConvertMockPaymentFormsPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
};

export type Cooperator = {
  /** 表单角色列表 */
  availableRoles: Array<FormRole>;
  /**
   * currentUser在此表单下的权限集
   * @deprecated 应当使用userFormRole#abilities
   */
  cooperativeAbilities: Array<FormRoleAbility>;
  /** 协作者邀请链接 */
  cooperatorLinks?: Maybe<Array<CooperatorLink>>;
  /** 表单协作者们[不包含表单creator] */
  cooperators?: Maybe<FormCooperatorsConnection>;
  /** 当前表单可添加协作者的席位数，若无上限则为-1 */
  cooperatorsLimit: Scalars['Int']['output'];
  /** 表单协作者们中的当前用户 */
  currentCooperator: FormCooperators;
  /** 协作者邀请待回应 */
  inviters?: Maybe<InviterConnection>;
  /** 表单拥有者 */
  owner: FormOwner;
  /** 过往联系人推荐列表 */
  recommendCooperators?: Maybe<FormRecommendedCooperatorsConnection>;
  /** currentUser在此表单下的角色 */
  userFormRole?: Maybe<FormRole>;
};


export type CooperatorCooperatorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type CooperatorInvitersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type CooperatorRecommendCooperatorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CooperatorLink = {
  /** 协作者角色 */
  formRole?: Maybe<FormRole>;
  /** 邀请人 */
  inviter?: Maybe<PublishedUser>;
  /** 协作邀请链接Token */
  token: Scalars['String']['output'];
  /** 协作者邀请链接 */
  url: Scalars['String']['output'];
  /** 企业成员角色 */
  userRole?: Maybe<Scalars['String']['output']>;
};

export enum CooperatorRole {
  DataMaintainer = 'data_maintainer',
  DataViewer = 'data_viewer',
  Manager = 'manager'
}

export enum CooperatorUserRole {
  Admin = 'admin',
  External = 'external',
  Outworker = 'outworker',
  Worker = 'worker'
}

/** Autogenerated input type of CopyForm */
export type CopyFormInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 表单ID或token */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of CopyForm */
export type CopyFormPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  form?: Maybe<Form>;
};

export type Coupon = {
  code: Scalars['String']['output'];
  /** 名称 */
  couponName: Scalars['String']['output'];
  /** 额度 */
  discountValue: Scalars['Float']['output'];
  /** 过期时间 */
  expireAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** 使用时间 */
  usedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** Autogenerated input type of CreateAdvancedNotificationsRule */
export type CreateAdvancedNotificationsRuleInput = {
  attributes: RuleAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  formId: Scalars['ID']['input'];
  /** 是否为NEXT创建 */
  fromNext?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of CreateAdvancedNotificationsRule */
export type CreateAdvancedNotificationsRulePayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  rule?: Maybe<Rule>;
};

/** Autogenerated input type of CreateApiLicence */
export type CreateApiLicenceInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateApiLicence */
export type CreateApiLicencePayload = {
  apiLicence: ApiLicence;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
};

/** Autogenerated input type of CreateAppTrial */
export type CreateAppTrialInput = {
  applicationId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateAppTrial */
export type CreateAppTrialPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of CreateBatchJob */
export type CreateBatchJobInput = {
  attributes: EntriesBatchJobAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 表单的使用场景 */
  formUsage?: InputMaybe<FormUsage>;
  /** 表单ID或token */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateBatchJob */
export type CreateBatchJobPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  job?: Maybe<Job>;
};

/** Autogenerated input type of CreateCalculation */
export type CreateCalculationInput = {
  attributes: FormCalculationAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  formId: Scalars['ID']['input'];
  routeType?: InputMaybe<PublishedFormRoute>;
};

/** Autogenerated return type of CreateCalculation */
export type CreateCalculationPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  result?: Maybe<Scalars['JSON']['output']>;
};

/** Autogenerated input type of CreateCooperatorLink */
export type CreateCooperatorLinkInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 表单角色ID */
  formRoleId?: InputMaybe<Scalars['ID']['input']>;
  /** 表单ID或token */
  id: Scalars['ID']['input'];
  /** 仅支持manager、data_maintainer、data_viewer, deprecated */
  role?: InputMaybe<CooperatorRole>;
  /** 仅支持external、admin、worker、outworker */
  userRole?: InputMaybe<CooperatorUserRole>;
};

/** Autogenerated return type of CreateCooperatorLink */
export type CreateCooperatorLinkPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  cooperatorLink?: Maybe<CooperatorLink>;
  errors?: Maybe<Array<Error>>;
};

/** Autogenerated input type of CreateEmail */
export type CreateEmailInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
};

/** Autogenerated return type of CreateEmail */
export type CreateEmailPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  emailHomepage?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  user?: Maybe<User>;
};

/** Autogenerated input type of CreateEmailVerification */
export type CreateEmailVerificationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateEmailVerification */
export type CreateEmailVerificationPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of CreateEntryAttachment */
export type CreateEntryAttachmentInput = {
  /** 当prefix=en时必填 */
  attributes?: InputMaybe<EntryAttachmentAttributes>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 小文件的Data URI，当prefix=ens时必填 */
  dataUri?: InputMaybe<Scalars['String']['input']>;
  /** 矩阵填空或表格字段中上传文件项目的apiCode */
  dimensionApiCode?: InputMaybe<Scalars['ID']['input']>;
  fieldApiCode: Scalars['ID']['input'];
  formId: Scalars['ID']['input'];
  prefix: EntryAttachmentPrefix;
  routeType?: InputMaybe<PublishedFormRoute>;
};

/** Autogenerated return type of CreateEntryAttachment */
export type CreateEntryAttachmentPayload = {
  attachment?: Maybe<Attachment>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
};

/** Autogenerated input type of CreateEntryAttachmentPresignedToken */
export type CreateEntryAttachmentPresignedTokenInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  dimensionApiCode?: InputMaybe<Scalars['ID']['input']>;
  fieldApiCode: Scalars['ID']['input'];
  formId: Scalars['ID']['input'];
  prefix: EntryAttachmentPrefix;
  routeType?: InputMaybe<PublishedFormRoute>;
};

/** Autogenerated return type of CreateEntryAttachmentPresignedToken */
export type CreateEntryAttachmentPresignedTokenPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  presignedUrl?: Maybe<Scalars['String']['output']>;
  saveKey?: Maybe<Scalars['String']['output']>;
  storage: Scalars['String']['output'];
  token?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of CreateEntryAttachmentUploadToken */
export type CreateEntryAttachmentUploadTokenInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  dimensionApiCode?: InputMaybe<Scalars['ID']['input']>;
  fieldApiCode: Scalars['ID']['input'];
  formId: Scalars['ID']['input'];
  prefix: EntryAttachmentPrefix;
  routeType?: InputMaybe<PublishedFormRoute>;
};

/** Autogenerated return type of CreateEntryAttachmentUploadToken */
export type CreateEntryAttachmentUploadTokenPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  token?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of CreateEntryAttachmentsTask */
export type CreateEntryAttachmentsTaskInput = {
  attributes: EntriesAttachmentsTaskAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 表单的使用场景 */
  formUsage?: InputMaybe<FormUsage>;
  /** 表单ID或token */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateEntryAttachmentsTask */
export type CreateEntryAttachmentsTaskPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  task?: Maybe<EntryAttachmentsTaskType>;
};

/** Autogenerated input type of CreateEntryEmailTask */
export type CreateEntryEmailTaskInput = {
  attributes: EntryEmailTaskAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 表单的使用场景 */
  formUsage?: InputMaybe<FormUsage>;
  /** 表单ID或token */
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of CreateEntryEmailTask */
export type CreateEntryEmailTaskPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  task?: Maybe<EntryEmailTaskType>;
};

/** Autogenerated input type of CreateEntrySmsTask */
export type CreateEntrySmsTaskInput = {
  attributes: EntrySmsTaskAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 表单的使用场景 */
  formUsage?: InputMaybe<FormUsage>;
  /** 表单ID或token */
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of CreateEntrySmsTask */
export type CreateEntrySmsTaskPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  smsTask?: Maybe<EntrySmsTaskType>;
};

/** Autogenerated input type of CreateExportJob */
export type CreateExportJobInput = {
  attributes: EntriesExportJobAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 表单的使用场景 */
  formUsage?: InputMaybe<FormUsage>;
  /** 表单ID或token */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateExportJob */
export type CreateExportJobPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  job?: Maybe<ExportJobType>;
};

/** Autogenerated input type of CreateExtendedAttributeFilter */
export type CreateExtendedAttributeFilterInput = {
  attributes: ExtendedAttributeFilterAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 表单ID或token */
  formId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateExtendedAttributeFilter */
export type CreateExtendedAttributeFilterPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  extendedAttributeFilter?: Maybe<ExtendedAttributeFilter>;
};

/** Autogenerated input type of CreateFeatureTrial */
export type CreateFeatureTrialInput = {
  attributes: FeatureTrialAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateFeatureTrial */
export type CreateFeatureTrialPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of CreateFieldVerification */
export type CreateFieldVerificationInput = {
  /** 图形验证码 */
  captchaData?: InputMaybe<VisualAttributes>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 当前编辑的数据ID或token，仅当编辑数据时传递 */
  entryId?: InputMaybe<Scalars['ID']['input']>;
  fieldApiCode: Scalars['ID']['input'];
  formId: Scalars['ID']['input'];
  /** geetest4验证码 */
  geetest4Data?: InputMaybe<Geetest4Attributes>;
  /** geetest验证码 */
  geetestData?: InputMaybe<GeetestAttributes>;
  mobile: Scalars['String']['input'];
  routeType?: InputMaybe<PublishedFormRoute>;
};

/** Autogenerated return type of CreateFieldVerification */
export type CreateFieldVerificationPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Autogenerated input type of CreateFormApplicationTrial */
export type CreateFormApplicationTrialInput = {
  applicationCode: FormApplicationAppCode;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateFormApplicationTrial */
export type CreateFormApplicationTrialPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of CreateFormCooperators */
export type CreateFormCooperatorsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 被选中协作者的手机或者邮箱 */
  emailOrPhones?: InputMaybe<Array<Scalars['String']['input']>>;
  /** 表单ID或token */
  id: Scalars['ID']['input'];
  /** 表单角色id，默认为表单管理员 */
  roleId?: InputMaybe<Scalars['ID']['input']>;
  /** 被选中协作者的user_ids */
  userIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** 被邀请来的企业成员权限 */
  userRole?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateFormCooperators */
export type CreateFormCooperatorsPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  cooperators?: Maybe<FormCooperatorsConnection>;
  errors?: Maybe<Array<Error>>;
  formInviters?: Maybe<FormInvitersConnection>;
};


/** Autogenerated return type of CreateFormCooperators */
export type CreateFormCooperatorsPayloadCooperatorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Autogenerated return type of CreateFormCooperators */
export type CreateFormCooperatorsPayloadFormInvitersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated input type of CreateFormEntry */
export type CreateFormEntryInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  entryAttributes: Scalars['JSON']['input'];
  /** 表单的使用场景 */
  formUsage?: InputMaybe<FormUsage>;
  /** 表单ID或token */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateFormEntry */
export type CreateFormEntryPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  entry?: Maybe<Entry>;
  errors?: Maybe<Array<Error>>;
};

/** Autogenerated input type of CreateFormFolder */
export type CreateFormFolderInput = {
  attributes?: InputMaybe<FormFolderAttributes>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 父级文件夹ID */
  folderId?: InputMaybe<Scalars['ID']['input']>;
  /** 文件夹归属：表单或数据表格 */
  kind?: InputMaybe<BaseFileKindEnum>;
  /** 标签ID */
  tagId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of CreateFormFolder */
export type CreateFormFolderPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  formFolder?: Maybe<FormFolder>;
};

/** Autogenerated input type of CreateFormFromImportJob */
export type CreateFormFromImportJobInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  folderId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  /** 表单布局 */
  layout?: InputMaybe<Layout>;
  tagId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of CreateFormFromImportJob */
export type CreateFormFromImportJobPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  form?: Maybe<Form>;
};

/** Autogenerated input type of CreateFormHeaderImageAttachment */
export type CreateFormHeaderImageAttachmentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 页面图片url */
  imageUrl: Scalars['String']['input'];
  /** 图片下载地址 */
  trackDownloadUrl?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateFormHeaderImageAttachment */
export type CreateFormHeaderImageAttachmentPayload = {
  attachment?: Maybe<Attachment>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of CreateFormImportJob */
export type CreateFormImportJobInput = {
  attachmentId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 表单场景 */
  scene?: InputMaybe<Scene>;
};

/** Autogenerated return type of CreateFormImportJob */
export type CreateFormImportJobPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  job?: Maybe<FormImportJob>;
};

/** Autogenerated input type of CreateForm */
export type CreateFormInput = {
  /** AI生成表单的对话 ID */
  aiMessageId?: InputMaybe<Scalars['ID']['input']>;
  attributes: FormAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  createSource?: InputMaybe<Scalars['String']['input']>;
  createdFrom?: InputMaybe<Scalars['String']['input']>;
  folderId?: InputMaybe<Scalars['ID']['input']>;
  /** 表单布局 */
  layout?: InputMaybe<Layout>;
  /** 表单场景 */
  scene?: InputMaybe<Scene>;
  /** 子场景，用于后端按预设填充默认字段 */
  subScene?: InputMaybe<Scalars['String']['input']>;
  tagId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of CreateForm */
export type CreateFormPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  form?: Maybe<Form>;
};

/** Autogenerated input type of CreateFormView */
export type CreateFormViewInput = {
  attributes: FormViewCreateAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 表单 token */
  formToken: Scalars['String']['input'];
};

/** Autogenerated return type of CreateFormView */
export type CreateFormViewPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  formView?: Maybe<FormViewType>;
};

/** Autogenerated input type of CreateIndustry */
export type CreateIndustryInput = {
  attributes: IndustryAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateIndustry */
export type CreateIndustryPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  industry?: Maybe<Industry>;
};

/** Autogenerated input type of CreateInvoice */
export type CreateInvoiceInput = {
  attributes: InvoiceAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateInvoice */
export type CreateInvoicePayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  invoice?: Maybe<EInvoice>;
};

/** Autogenerated input type of CreateInvoiceTitle */
export type CreateInvoiceTitleInput = {
  /** 抬头属性 */
  attributes: InvoiceTitleAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateInvoiceTitle */
export type CreateInvoiceTitlePayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  invoiceTitle?: Maybe<InvoiceTitle>;
};

/** Autogenerated input type of CreateMobile */
export type CreateMobileInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  mobileNo: Scalars['String']['input'];
  newMobileVerificationCode: Scalars['String']['input'];
};

/** Autogenerated return type of CreateMobile */
export type CreateMobilePayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  user?: Maybe<User>;
};

/** Autogenerated input type of CreateMobileVerification */
export type CreateMobileVerificationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** geetest4 验证码 */
  geetest4Data?: InputMaybe<Geetest4Attributes>;
  /** 是否用作账号合并 */
  migratable?: InputMaybe<Scalars['Boolean']['input']>;
  /** 接收验证码的手机号 */
  mobileNo?: InputMaybe<Scalars['String']['input']>;
  /** 是否重置手机号 */
  resetMobileNo?: InputMaybe<Scalars['Boolean']['input']>;
  /** 错误提示文案是否需要包含帮助链接，true - 需要，false - 不需要 */
  showGuideLink?: InputMaybe<Scalars['Boolean']['input']>;
  /** 验证码使用场景 */
  verificationType?: InputMaybe<MobileVerificationTypeEnum>;
};

/** Autogenerated return type of CreateMobileVerification */
export type CreateMobileVerificationPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  coolingTime?: Maybe<Scalars['Int']['output']>;
  errors?: Maybe<Array<Error>>;
};

/** Autogenerated input type of CreateNotificationVerificationSignatures */
export type CreateNotificationVerificationSignaturesInput = {
  attributes: SmsSignatureAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateNotificationVerificationSignatures */
export type CreateNotificationVerificationSignaturesPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  smsSignatures?: Maybe<Array<Signature>>;
};

/** Autogenerated input type of CreateOfflineRecharge */
export type CreateOfflineRechargeInput = {
  attributes: OfflineRechargeAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateOfflineRecharge */
export type CreateOfflineRechargePayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  offlineRecharge?: Maybe<OfflineRecharge>;
};

/** Autogenerated input type of CreateOpenEntrySession */
export type CreateOpenEntrySessionInput = {
  authFieldValues: Scalars['JSON']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  openEntryToken?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of CreateOpenEntrySession */
export type CreateOpenEntrySessionPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  /** 认证成功后的跳转链接 */
  redirectUrl?: Maybe<Scalars['String']['output']>;
  sessionId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of CreateOpenResult */
export type CreateOpenResultInput = {
  /** 结果分享属性 */
  attributes: OpenResultAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 表单ID或token */
  id: Scalars['ID']['input'];
  /** 是否使用默认设置快速创建 */
  quickCreation?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of CreateOpenResult */
export type CreateOpenResultPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  openResult?: Maybe<OpenResult>;
};

/** Autogenerated input type of CreateOpenSearch */
export type CreateOpenSearchInput = {
  /** 对外查询属性 */
  attributes: OpenSearchAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 表单ID或token */
  id: Scalars['ID']['input'];
  /** 是否使用默认设置快速创建 */
  quickCreation?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of CreateOpenSearch */
export type CreateOpenSearchPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  openSearch?: Maybe<OpenSearch>;
};

/** Autogenerated input type of CreatePaymentAccount */
export type CreatePaymentAccountInput = {
  /** 更新参数 */
  attributes: PaymentAccountAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreatePaymentAccount */
export type CreatePaymentAccountPayload = {
  account?: Maybe<PaymentAccount>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
};

/** Autogenerated input type of CreatePersonalAccessToken */
export type CreatePersonalAccessTokenInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

/** Autogenerated return type of CreatePersonalAccessToken */
export type CreatePersonalAccessTokenPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  personalAccessToken?: Maybe<PersonalAccessToken>;
};

/** Autogenerated input type of CreatePresignedToken */
export type CreatePresignedTokenInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  prefix: Scalars['String']['input'];
};

/** Autogenerated return type of CreatePresignedToken */
export type CreatePresignedTokenPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  presignedUrl?: Maybe<Scalars['String']['output']>;
  saveKey?: Maybe<Scalars['String']['output']>;
  storage?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of CreatePrizeVoucher */
export type CreatePrizeVoucherInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  contentType?: InputMaybe<Scalars['String']['input']>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  fileSize?: InputMaybe<Scalars['Int']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  prefix: Scalars['String']['input'];
};

/** Autogenerated return type of CreatePrizeVoucher */
export type CreatePrizeVoucherPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  prizeVoucher?: Maybe<PrizeVoucherAttachment>;
};

/** Autogenerated input type of CreatePseudoForm */
export type CreatePseudoFormInput = {
  attributes: PseudoFormAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 表单ID或token */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of CreatePseudoForm */
export type CreatePseudoFormPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  pseudoForm?: Maybe<PseudoForm>;
};

/** Autogenerated input type of CreatePublishedFormEntry */
export type CreatePublishedFormEntryInput = {
  /** 是否系统匿名填写，为 true 时不记录数据的 creator */
  anonymousFilling?: InputMaybe<Scalars['Boolean']['input']>;
  /** 是否展示页面背景，仅当embedded=true时有用，默认不展示 */
  backgroundImage?: InputMaybe<Scalars['Boolean']['input']>;
  /** 是否展示页眉，仅当embedded=true时有用。当banner=hide时不展示，默认展示。 */
  banner?: InputMaybe<Scalars['String']['input']>;
  /** 图形验证码 */
  captchaData?: InputMaybe<VisualAttributes>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** window.location中的code参数，用于通过企业微信获取用户信息 */
  code?: InputMaybe<Scalars['ID']['input']>;
  /** 自定义参数签名 */
  cusd?: InputMaybe<Scalars['String']['input']>;
  embedded?: InputMaybe<Scalars['Boolean']['input']>;
  entryAttributes: Scalars['JSON']['input'];
  /** 填写时长 in seconds */
  fillingDuration?: InputMaybe<Scalars['Float']['input']>;
  /** 是否强制走非分离收银台，目前用于带一次性消息的收款表单 */
  forcePaymentGateway?: InputMaybe<Scalars['Boolean']['input']>;
  /** 是否强制提交，目前用于考试测评 */
  forceSubmit?: InputMaybe<Scalars['Boolean']['input']>;
  formId: Scalars['ID']['input'];
  /** 仅当embedded=true时有用 */
  formMargin?: InputMaybe<Scalars['Boolean']['input']>;
  /** geetest4验证码 */
  geetest4Data?: InputMaybe<Geetest4Attributes>;
  /** geetest验证码 */
  geetestData?: InputMaybe<GeetestAttributes>;
  /** 是否计算了优惠金额 */
  hasPreferential?: InputMaybe<Scalars['Boolean']['input']>;
  incognitoToken?: InputMaybe<Scalars['String']['input']>;
  /** 是否系统内部数据提交, 用来判断是否skip手机字段短信校验 */
  internal?: InputMaybe<Scalars['Boolean']['input']>;
  /** 提交表单的小程序 */
  miniapp?: InputMaybe<MiniappName>;
  /** 凭密码填写时用户输入的密码 */
  password?: InputMaybe<Scalars['String']['input']>;
  /** URL传参 */
  prefilledParams?: InputMaybe<Scalars['String']['input']>;
  /** 是否为预览模式 */
  previewMode?: InputMaybe<Scalars['Boolean']['input']>;
  /** tsa参数，从url中获得 */
  qzGdt?: InputMaybe<Scalars['ID']['input']>;
  /** tsa参数，从url中获得 */
  qzVid?: InputMaybe<Scalars['ID']['input']>;
  /** 考试/测评随机出题题目 api_codes jwt token */
  randomFieldsToken?: InputMaybe<Scalars['String']['input']>;
  /** 考试/测评随机出题题目的唯一 id，用于校验提交唯一性 */
  randomQuestionsToken?: InputMaybe<Scalars['String']['input']>;
  /** 用户的邀请人如果有的话 */
  referredFrom?: InputMaybe<Scalars['ID']['input']>;
  routeType?: InputMaybe<PublishedFormRoute>;
  /** URL传参签名 */
  sign?: InputMaybe<Scalars['String']['input']>;
  /** 判断是否从poster填写数据 */
  submitLinkGeneratedFrom?: InputMaybe<Scalars['String']['input']>;
  weixinAccessToken?: InputMaybe<Scalars['ID']['input']>;
  weixinInfo?: InputMaybe<Scalars['JSON']['input']>;
  /** 扩展属性 */
  xField1?: InputMaybe<Scalars['String']['input']>;
  /** 通过 code 换取的微信 openid */
  xFieldWeixinOpenid?: InputMaybe<Scalars['ID']['input']>;
  /** 微信 openid 的签名。legacy react app 使用的是 cookies 校验。next webapp 因为跨域，使用本参数进行校验。 */
  xFieldWeixinOpenidSign?: InputMaybe<Scalars['String']['input']>;
  xFieldWeixinUnionid?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of CreatePublishedFormEntry */
export type CreatePublishedFormEntryPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** 为了解决IE浏览器无法获取Cookie的问题兼容 */
  cookies?: Maybe<Scalars['JSON']['output']>;
  /** Customer 已存在不需要重复注册 */
  customerExists?: Maybe<Scalars['Boolean']['output']>;
  /** 发布页修改数据使用，过期时间为3分钟 */
  editToken?: Maybe<Scalars['String']['output']>;
  /** 提交成功后的entry token */
  entryToken?: Maybe<Scalars['ID']['output']>;
  errors?: Maybe<Array<Error>>;
  /** 客户信息表唯一标识字段Label */
  identityFieldLabel?: Maybe<Scalars['String']['output']>;
  /** 支付链接，如果为null，则使用弹窗式收银台 */
  paymentUrl?: Maybe<Scalars['String']['output']>;
  /** portal的业务表是否需要登录 */
  portalLogin?: Maybe<Scalars['Boolean']['output']>;
  /** 免费用户的表单在小程序中提交后跳转至小程序的原生success页 */
  redirectToMiniprogramSuccess?: Maybe<Scalars['Boolean']['output']>;
  /** 提交成功后跳转URL */
  redirectUrl?: Maybe<Scalars['String']['output']>;
  serialNumber?: Maybe<Scalars['Int']['output']>;
  /** Submitter 已存在不需要重复注册 */
  submitterExists?: Maybe<Scalars['Boolean']['output']>;
  /** 表单总价 */
  totalPrice?: Maybe<Scalars['Float']['output']>;
  /** 提交成功后跳转微信一次性消息URL */
  wxOnetimeMessageRedirectUrl?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of CreateQiniuCallback */
export type CreateQiniuCallbackInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  contentType?: InputMaybe<Scalars['String']['input']>;
  fileHeight?: InputMaybe<Scalars['Int']['input']>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  fileSize?: InputMaybe<Scalars['Int']['input']>;
  fileWidth?: InputMaybe<Scalars['Int']['input']>;
  /** 创客贴图片地址，仅当 prefix=hi (表单头图)时可用 */
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  prefix: Scalars['String']['input'];
  /** 生成附件的关联对象 */
  targetId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateQiniuCallback */
export type CreateQiniuCallbackPayload = {
  attachmentId?: Maybe<Scalars['ID']['output']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  fileName?: Maybe<Scalars['String']['output']>;
  previewUrl?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of CreateQiniuToken */
export type CreateQiniuTokenInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  prefix: Scalars['String']['input'];
};

/** Autogenerated return type of CreateQiniuToken */
export type CreateQiniuTokenPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  token?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of CreateRemainingPrizeVoucherAttachment */
export type CreateRemainingPrizeVoucherAttachmentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 奖品-奖券ID，导出剩余奖券时必传 */
  prizeId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateRemainingPrizeVoucherAttachment */
export type CreateRemainingPrizeVoucherAttachmentPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  remainingPrizeVoucherAttachment?: Maybe<RemainingPrizeVoucherAttachment>;
};

/** Autogenerated input type of CreateSystemIncidentAction */
export type CreateSystemIncidentActionInput = {
  attributes: SystemIncidentActionAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  incidentId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateSystemIncidentAction */
export type CreateSystemIncidentActionPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  incident?: Maybe<SystemIncident>;
};

/** Autogenerated input type of CreateTable */
export type CreateTableInput = {
  attributes: FormAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  createSource?: InputMaybe<Scalars['String']['input']>;
  folderId?: InputMaybe<Scalars['ID']['input']>;
  tagId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of CreateTable */
export type CreateTablePayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  form?: Maybe<Form>;
};

/** Autogenerated input type of CreateUserInviteLink */
export type CreateUserInviteLinkInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  role: UserRole;
};

/** Autogenerated input type of CreateWithdrawAccount */
export type CreateWithdrawAccountInput = {
  attributes: WithdrawAccountAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateWithdrawAccount */
export type CreateWithdrawAccountPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  templateWithdrawAccount?: Maybe<WithdrawAccount>;
};

export enum CreationSource {
  Ai = 'ai',
  Blank = 'blank',
  Excel = 'excel',
  FormCopy = 'form_copy',
  GokuMigration = 'goku_migration',
  SceneModalTemplateSpread = 'scene_modal_template_spread',
  SubmitterGroup = 'submitter_group',
  Template = 'template',
  TemplateBulk = 'template_bulk',
  TemplateCenter = 'template_center',
  TemplateNewUserGreeting = 'template_new_user_greeting',
  TemplateSpread = 'template_spread',
  Text = 'text'
}

export type Creator = {
  /** 表单创建者头像 */
  avatar?: Maybe<Scalars['String']['output']>;
  /** 创建者昵称 */
  nickName?: Maybe<Scalars['String']['output']>;
};

export type Currency = {
  htmlEntity: Scalars['String']['output'];
  isoCode: Scalars['String']['output'];
  symbol: Scalars['String']['output'];
};

export enum CurrencyIso {
  /** Translation missing: en.common.currency.AUD.full_label */
  Aud = 'AUD',
  /** Translation missing: en.common.currency.BRL.full_label */
  Brl = 'BRL',
  /** Translation missing: en.common.currency.CAD.full_label */
  Cad = 'CAD',
  /** Translation missing: en.common.currency.CNY.full_label */
  Cny = 'CNY',
  /** Translation missing: en.common.currency.EUR.full_label */
  Eur = 'EUR',
  /** Translation missing: en.common.currency.GBP.full_label */
  Gbp = 'GBP',
  /** Translation missing: en.common.currency.HKD.full_label */
  Hkd = 'HKD',
  /** Translation missing: en.common.currency.INR.full_label */
  Inr = 'INR',
  /** Translation missing: en.common.currency.JPY.full_label */
  Jpy = 'JPY',
  /** Translation missing: en.common.currency.KRW.full_label */
  Krw = 'KRW',
  /** Translation missing: en.common.currency.MXN.full_label */
  Mxn = 'MXN',
  /** Translation missing: en.common.currency.NOK.full_label */
  Nok = 'NOK',
  /** Translation missing: en.common.currency.NZD.full_label */
  Nzd = 'NZD',
  /** Translation missing: en.common.currency.SGD.full_label */
  Sgd = 'SGD',
  /** Translation missing: en.common.currency.THB.full_label */
  Thb = 'THB',
  /** Translation missing: en.common.currency.TWD.full_label */
  Twd = 'TWD',
  /** Translation missing: en.common.currency.USD.full_label */
  Usd = 'USD',
  /** Translation missing: en.common.currency.ZAR.full_label */
  Zar = 'ZAR'
}

export type CurrentUserAttributes = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type Customer = CustomerProperties & EntriesBaseProperties & MetaProperties & ReservationStatusProperties & ShareAndMarkProperties & WeixinProperties & {
  _type?: Maybe<Scalars['String']['output']>;
  /** 头像 */
  avatarUrl?: Maybe<Scalars['String']['output']>;
  browser?: Maybe<Scalars['String']['output']>;
  colorMark?: Maybe<Scalars['String']['output']>;
  /** 表单联系人 */
  contactId?: Maybe<Scalars['ID']['output']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  creator?: Maybe<PublishedUser>;
  customer?: Maybe<GdCustomer>;
  /** 审核记录 */
  customerAuditLog?: Maybe<GdPortalCustomerAuditLogType>;
  /** 当前版本号 */
  editedVersion?: Maybe<Scalars['Int']['output']>;
  fieldValues: Scalars['JSON']['output'];
  fillingDuration?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  ip?: Maybe<Scalars['String']['output']>;
  /** 用户类型 */
  kind: GdPortalCustomerKindEnum;
  /** 姓名 */
  name?: Maybe<Scalars['String']['output']>;
  os?: Maybe<Scalars['String']['output']>;
  /**
   * true: 存在初始密码
   * @deprecated 请使用 password_free
   */
  passwordExist: Scalars['Boolean']['output'];
  /** true: 用户未设置过密码 */
  passwordFree: Scalars['Boolean']['output'];
  platform?: Maybe<Scalars['String']['output']>;
  region?: Maybe<RegionInfo>;
  remark?: Maybe<Scalars['String']['output']>;
  /** 预约状态 */
  reservationStatus?: Maybe<ReservationStatusEnum>;
  serialNumber: Scalars['Int']['output'];
  sessionCreatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  shareLink?: Maybe<Scalars['String']['output']>;
  shareToken?: Maybe<Scalars['String']['output']>;
  signInTodos: Array<GdPortalSignInTodoEnum>;
  /** 来源记录 */
  sourceRecord?: Maybe<Entry>;
  startFillingTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  useragent?: Maybe<Scalars['String']['output']>;
  weixinAccessToken?: Maybe<Scalars['ID']['output']>;
  xFieldWeixinHeadimgurl?: Maybe<Scalars['String']['output']>;
  xFieldWeixinNickname?: Maybe<Scalars['String']['output']>;
  xFieldWeixinOpenid?: Maybe<Scalars['ID']['output']>;
  xFieldWeixinUnionid?: Maybe<Scalars['ID']['output']>;
};


export type CustomerFieldValuesArgs = {
  fieldsContext?: InputMaybe<FieldsContext>;
};

/** The connection type for Customer. */
export type CustomerConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<CustomerEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Customer>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CustomerEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Customer>;
};

export enum CustomerImportJobStatusEnum {
  Failed = 'failed',
  PartialSuccess = 'partial_success',
  Pending = 'pending',
  Running = 'running',
  Success = 'success',
  Timeout = 'timeout'
}

export type CustomerProperties = {
  customer?: Maybe<GdCustomer>;
};

export type CuttingFontAttributes = {
  /** 待裁剪中文字体 */
  chineseFonts?: InputMaybe<Array<ChineseFontAttributes>>;
  /** 无需裁剪的英文字体 */
  englishFonts?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum CyclePeriod {
  /** Every day */
  EveryDay = 'every_day',
  /** Every hour */
  EveryHour = 'every_hour',
  /** Every month */
  EveryMonth = 'every_month',
  /** Every week */
  EveryWeek = 'every_week'
}

export type DailyRepeatCloseRule = {
  /** 每日开启时间段 */
  timePeriods?: Maybe<Array<TimePeriod>>;
};

export type DailyRepeatCloseRuleAttributes = {
  /** 是否启用 */
  enabled: Scalars['Boolean']['input'];
  /** 每日开放时间区间 */
  timePeriods?: InputMaybe<Array<TimePeriodAttributes>>;
};

export type DailyTimeRange = {
  /** 可预约的星期 */
  availableDaysOfWeek: Array<DayNameOfWeek>;
  dailyTimeRangeQuotas?: Maybe<Array<DailyTimeRangeQuota>>;
  /** 时段表名称 */
  name?: Maybe<Scalars['String']['output']>;
  payable: Scalars['Boolean']['output'];
  /** 时段表token */
  token: Scalars['ID']['output'];
};

export type DailyTimeRangeAttributes = {
  /** 可预约时间类型 */
  availableDaysOfWeek?: InputMaybe<Array<DayNameOfWeek>>;
  /** 分时段配额设置 */
  dailyTimeRangeQuotas?: InputMaybe<Array<TimeRangeQuotaAttributes>>;
  /** 时段表名称 */
  name: Scalars['String']['input'];
  /** 是否需要付费 */
  payable?: InputMaybe<Scalars['Boolean']['input']>;
  /** 时段表token，前端生成 */
  token: Scalars['ID']['input'];
};

export type DailyTimeRangeQuota = {
  /** 时段表token */
  dailyTimeRangeToken?: Maybe<Scalars['ID']['output']>;
  endTime?: Maybe<Scalars['JSON']['output']>;
  forWday?: Maybe<DayNameOfWeek>;
  position: Scalars['Int']['output'];
  price?: Maybe<Scalars['Float']['output']>;
  quota?: Maybe<Scalars['Int']['output']>;
  startTime?: Maybe<Scalars['JSON']['output']>;
};

export type DailyUsageStats = SmsAndEmailStats | VasStats;

export enum DateOffsetAction {
  /** After */
  After = 'after',
  /** Before */
  Before = 'before',
  /** That day */
  ThatDay = 'that_day'
}

export enum DateOffsetUnit {
  /** Day */
  Day = 'day',
  /** Hour */
  Hour = 'hour',
  /** Minute */
  Minute = 'minute',
  /** Month */
  Month = 'month',
  /** Week */
  Week = 'week'
}

export type DateRange = {
  endDate?: Maybe<Scalars['Date']['output']>;
  startDate?: Maybe<Scalars['Date']['output']>;
};

export type DateRangeAttributes = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};

export type DateTimeField = AssociatedField & BaseField & CalculableField & FieldAbility & PlanAvailableField & PredefineableField & {
  apiCode: Scalars['ID']['output'];
  apiCodeAlias?: Maybe<Scalars['String']['output']>;
  /** 显示年龄 */
  asAge: Scalars['Boolean']['output'];
  /** 对应的表单关联字段 */
  associationField?: Maybe<Field>;
  /** 自动填写上次提交内容 */
  cacheData: Scalars['Boolean']['output'];
  /** 开启选项赋值或本身可参与计算 */
  calculable: Scalars['Boolean']['output'];
  /** 客户端ID */
  cid?: Maybe<Scalars['String']['output']>;
  /** 封装的字段类型 */
  customizedType?: Maybe<Scalars['String']['output']>;
  /** 封装的字段类型文本 */
  customizedTypeName?: Maybe<Scalars['String']['output']>;
  /** 自定义出错文案 */
  customizedValidationMessage?: Maybe<Scalars['String']['output']>;
  /** 已提交的数据是否可被编辑 */
  editable: Scalars['Boolean']['output'];
  /** 结束日期 */
  endDate?: Maybe<DateTimeOrString>;
  /** 该字段能否使用字段规则: true - 能， false - 不能 */
  fieldRuleAvailable: Scalars['Boolean']['output'];
  /** 是否是关联主键字段 */
  forAssociated?: Maybe<Scalars['Boolean']['output']>;
  /** 是否是关联展示字段 */
  forAssociatedDisplay?: Maybe<Scalars['Boolean']['output']>;
  /** 表单Token */
  formToken: Scalars['String']['output'];
  /** 宽度占用整行的四分之几 */
  gridsToOccupy?: Maybe<Scalars['Int']['output']>;
  hasAbility: Scalars['Boolean']['output'];
  /** 字段标题（去富文本化） */
  label?: Maybe<Scalars['String']['output']>;
  /** 字段描述，富文本 */
  notes?: Maybe<Scalars['String']['output']>;
  paidFeature?: Maybe<PaidFeature>;
  planAvailable: Scalars['Boolean']['output'];
  /** 字段排序 */
  position: Scalars['Int']['output'];
  /** 日期精度 */
  precision: DateTimePrecision;
  /** 预填写表单 */
  predefined: Scalars['Boolean']['output'];
  /** 默认值 */
  predefinedValue?: Maybe<DateTimeOrString>;
  /** 该字段是否是隐私字段 true - 是, false - 不是 */
  privacy: Scalars['Boolean']['output'];
  /** 字段隐藏 */
  private: Scalars['Boolean']['output'];
  /** 字段是否通过预填写表单预设了值 true - 是, false - 否 */
  pseudoFormPredefined?: Maybe<Scalars['Boolean']['output']>;
  /** 字段标题（富文本化） */
  rawLabel?: Maybe<Scalars['String']['output']>;
  /** 字段是否只读，无法编辑 */
  readonly?: Maybe<Scalars['Boolean']['output']>;
  /** 该字段是否属于评分字段（e.g. 考试、测评中的题目） */
  scorable: Scalars['Boolean']['output'];
  /** 字段提示较长时折叠展示 */
  showPartDescription: Scalars['Boolean']['output'];
  /** 起始日期 */
  startDate?: Maybe<DateTimeOrString>;
  /** 新起一行 */
  startNewRow: Scalars['Boolean']['output'];
  /** 该字段是否可以作为文本插入 true - 能, false - 不能 */
  textPlaceholderable: Scalars['Boolean']['output'];
  /** 字段类型 */
  type: FieldClass;
  /** 字段类型文本 */
  typeName: Scalars['String']['output'];
  /** 字段验证规则 */
  validations?: Maybe<Array<FieldValidation>>;
};


export type DateTimeFieldHasAbilityArgs = {
  key: FieldAbilityEnum;
};


export type DateTimeFieldNotesArgs = {
  sanitize?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DateTimeOrString = {
  /** 相对当前日期的偏移量，比如前1天(-1)，或后3天(3）；如果不是相对日期，则返回null */
  offset?: Maybe<Scalars['Int']['output']>;
  /** 指定日期或根据相对日期计算出并根据精度格式化后的日期 */
  value?: Maybe<Scalars['String']['output']>;
};

export enum DateTimePrecision {
  /** Day */
  Day = 'day',
  /** Hour */
  Hour = 'hour',
  /** Minute */
  Minute = 'minute',
  /** Month */
  Month = 'month',
  /** Second */
  Second = 'second',
  /** Year */
  Year = 'year'
}

export type DateUsageStats = PerAppUsageStats | PerFormDateUsageStats | PerOwnerDateUsageStats;

export type DateUsageStatsGroup = {
  /** @deprecated 使用 usages */
  formUsages?: Maybe<Array<PerFormDateUsageStats>>;
  groupKey: Scalars['String']['output'];
  usages?: Maybe<Array<DateUsageStats>>;
};

export enum DayNameOfWeek {
  Friday = 'friday',
  Monday = 'monday',
  Saturday = 'saturday',
  Sunday = 'sunday',
  Thursday = 'thursday',
  Tuesday = 'tuesday',
  Wednesday = 'wednesday'
}

export type DayQuotaSummary = {
  /** 按天预约凌晨 */
  datetime: Scalars['ISO8601DateTime']['output'];
  /** 价格 */
  price?: Maybe<Scalars['Float']['output']>;
  /** 剩余配额 */
  remainingQuota?: Maybe<Scalars['BigInteger']['output']>;
  /** 按时段：当日所有时段的quota使用情况 */
  timeRanges?: Maybe<Array<TimeRangeSummary>>;
  /** 已用配额 */
  usedQuota: Scalars['BigInteger']['output'];
};

export type DebitBalance = {
  aiPointsBalance: Scalars['Int']['output'];
  audioBalance: Scalars['Int']['output'];
  balance: Scalars['Float']['output'];
  emailBalance: Scalars['Int']['output'];
  smsBalance: Scalars['Int']['output'];
};

export type DebitBalanceHistory = {
  /** 金额 */
  amount: Scalars['Float']['output'];
  /** 余额 */
  balance: Scalars['Float']['output'];
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** 金额 */
  description: Scalars['String']['output'];
  order?: Maybe<Order>;
  verb: DebitBalanceVerb;
};

/** The connection type for DebitBalanceHistory. */
export type DebitBalanceHistoryConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<DebitBalanceHistoryEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<DebitBalanceHistory>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type DebitBalanceHistoryEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<DebitBalanceHistory>;
};

export enum DebitBalanceVerb {
  /** Active mail charge */
  ActiveMailCharge = 'active_mail_charge',
  /** Ai points charge */
  AiPointsCharge = 'ai_points_charge',
  /** App charge */
  AppCharge = 'app_charge',
  /** App package charge */
  AppPackageCharge = 'app_package_charge',
  /** App upgrade charge */
  AppUpgradeCharge = 'app_upgrade_charge',
  /** Audio quota charge */
  AudioQuotaCharge = 'audio_quota_charge',
  /** Charge */
  Charge = 'charge',
  /** Cname protocol charge */
  CnameProtocolCharge = 'cname_protocol_charge',
  /** Convert to pro2 */
  ConvertToPro2 = 'convert_to_pro2',
  /** Coupons */
  Coupons = 'coupons',
  /** Email notification */
  EmailNotification = 'email_notification',
  /** Expand entries charge */
  ExpandEntriesCharge = 'expand_entries_charge',
  /** Form application charge */
  FormApplicationCharge = 'form_application_charge',
  /** Form application upgrade charge */
  FormApplicationUpgradeCharge = 'form_application_upgrade_charge',
  /** GD portal charge */
  GdPortalCharge = 'gd_portal_charge',
  /** GD portal customer charge */
  GdPortalCustomerCharge = 'gd_portal_customer_charge',
  /** GD portal customer for free */
  GdPortalCustomerForFree = 'gd_portal_customer_for_free',
  /** GD portal for free */
  GdPortalForFree = 'gd_portal_for_free',
  /** Hide report form charge */
  HideReportFormCharge = 'hide_report_form_charge',
  /** Other charge */
  OtherCharge = 'other_charge',
  /** Plan charge */
  PlanCharge = 'plan_charge',
  /** Plan convert */
  PlanConvert = 'plan_convert',
  /** Plan for free */
  PlanForFree = 'plan_for_free',
  /** Plan refund */
  PlanRefund = 'plan_refund',
  /** Red envelope charge */
  RedEnvelopeCharge = 'red_envelope_charge',
  /** Show alipay charge */
  ShowAlipayCharge = 'show_alipay_charge',
  /** SMS charge */
  SmsCharge = 'sms_charge',
  /** SMS notification */
  SmsNotification = 'sms_notification',
  /** SMS verify */
  SmsVerify = 'sms_verify',
  /** Storage quota charge */
  StorageQuotaCharge = 'storage_quota_charge',
  /** Sub account charge */
  SubAccountCharge = 'sub_account_charge',
  /** Sub account for free */
  SubAccountForFree = 'sub_account_for_free',
  /** Submitter charge */
  SubmitterCharge = 'submitter_charge',
  /** Submitter for free */
  SubmitterForFree = 'submitter_for_free',
  /** Template charge */
  TemplateCharge = 'template_charge',
  /** Weixin account charge */
  WeixinAccountCharge = 'weixin_account_charge'
}

/** Autogenerated input type of DeletePaymentAccount */
export type DeletePaymentAccountInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 支付账号ID */
  id: Scalars['ID']['input'];
  /** 支付账号类型 */
  type: PaymentAccountEnum;
};

/** Autogenerated return type of DeletePaymentAccount */
export type DeletePaymentAccountPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Autogenerated input type of DeleteUserBaseFileTag */
export type DeleteUserBaseFileTagInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 标签ID */
  tagId: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteUserBaseFileTag */
export type DeleteUserBaseFileTagPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
};

/** Autogenerated input type of DeleteWeixinAccount */
export type DeleteWeixinAccountInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 微信服务号ID */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteWeixinAccount */
export type DeleteWeixinAccountPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** 选项说明 */
export type DescribableItem = {
  /** 选项说明 */
  description?: Maybe<Scalars['String']['output']>;
  /** 说明类型 */
  descriptionMode: DescribableItemMode;
  /** 选项说明文字 */
  descriptionText?: Maybe<Scalars['String']['output']>;
  /** 选项说明链接 */
  descriptionUrl?: Maybe<Scalars['String']['output']>;
  /** 用户自定义选项说明扩展按钮文案 */
  showMoreDescriptionTip?: Maybe<Scalars['String']['output']>;
};

export enum DescribableItemMode {
  Text = 'text',
  Url = 'url'
}

/** Autogenerated input type of DestroyAdvancedNotificationsRule */
export type DestroyAdvancedNotificationsRuleInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  formId: Scalars['ID']['input'];
  ruleId: Scalars['ID']['input'];
};

/** Autogenerated return type of DestroyAdvancedNotificationsRule */
export type DestroyAdvancedNotificationsRulePayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
};

/** Autogenerated input type of DestroyAuthorizedApplication */
export type DestroyAuthorizedApplicationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DestroyAuthorizedApplication */
export type DestroyAuthorizedApplicationPayload = {
  authorizedApplication?: Maybe<DoorkeeperApplication>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
};

/** Autogenerated input type of DestroyBillingAccountUser */
export type DestroyBillingAccountUserInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** UserID */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DestroyBillingAccountUser */
export type DestroyBillingAccountUserPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DestroyExtendedAttributeFilter */
export type DestroyExtendedAttributeFilterInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 扩展值记录的ID */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DestroyExtendedAttributeFilter */
export type DestroyExtendedAttributeFilterPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  status?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of DestroyFeatureTrial */
export type DestroyFeatureTrialInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of DestroyFeatureTrial */
export type DestroyFeatureTrialPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DestroyFormCooperator */
export type DestroyFormCooperatorInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 表单ID或token */
  id: Scalars['ID']['input'];
  /** 被选中协作者的user_id */
  userId: Scalars['ID']['input'];
};

/** Autogenerated input type of DestroyFormCooperatorLink */
export type DestroyFormCooperatorLinkInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 表单ID或token */
  id: Scalars['ID']['input'];
  /** 表单邀请链接的token */
  token: Scalars['String']['input'];
};

/** Autogenerated return type of DestroyFormCooperatorLink */
export type DestroyFormCooperatorLinkPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  status?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of DestroyFormCooperatorLinks */
export type DestroyFormCooperatorLinksInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 表单ID或token */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DestroyFormCooperatorLinks */
export type DestroyFormCooperatorLinksPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  status?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated return type of DestroyFormCooperator */
export type DestroyFormCooperatorPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  status?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of DestroyFormFolder */
export type DestroyFormFolderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 文件夹ID或token */
  folderId: Scalars['ID']['input'];
};

/** Autogenerated return type of DestroyFormFolder */
export type DestroyFormFolderPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
};

/** Autogenerated input type of DestroyForm */
export type DestroyFormInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 表单ID或token */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DestroyForm */
export type DestroyFormPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
};

/** Autogenerated input type of DestroyFormView */
export type DestroyFormViewInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DestroyFormView */
export type DestroyFormViewPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Autogenerated input type of DestroyInvoiceTitle */
export type DestroyInvoiceTitleInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DestroyInvoiceTitle */
export type DestroyInvoiceTitlePayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DestroyOpenEntry */
export type DestroyOpenEntryInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 表单ID或token */
  id: Scalars['ID']['input'];
  openEntryId: Scalars['ID']['input'];
};

/** Autogenerated return type of DestroyOpenEntry */
export type DestroyOpenEntryPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
};

/** Autogenerated input type of DestroyOpenResult */
export type DestroyOpenResultInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 表单ID或token */
  id: Scalars['ID']['input'];
  /** 对外查询id */
  openResultId: Scalars['ID']['input'];
};

/** Autogenerated return type of DestroyOpenResult */
export type DestroyOpenResultPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  status?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of DestroyOpenSearch */
export type DestroyOpenSearchInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 表单ID或token */
  id: Scalars['ID']['input'];
  /** 对外查询id */
  openSearchId: Scalars['ID']['input'];
};

/** Autogenerated return type of DestroyOpenSearch */
export type DestroyOpenSearchPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  status?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of DestroyPseudoForm */
export type DestroyPseudoFormInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 表单ID或token */
  id: Scalars['ID']['input'];
  pseudoFormId: Scalars['ID']['input'];
};

/** Autogenerated return type of DestroyPseudoForm */
export type DestroyPseudoFormPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  status?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of DestroySessionExceptCurrent */
export type DestroySessionExceptCurrentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of DestroySessionExceptCurrent */
export type DestroySessionExceptCurrentPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
};

/** Autogenerated input type of DestroySession */
export type DestroySessionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  forceLogoutAll?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of DestroySession */
export type DestroySessionPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  url?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of DestroySocialAuthentication */
export type DestroySocialAuthenticationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  provider: AuthenticationProvider;
};

/** Autogenerated return type of DestroySocialAuthentication */
export type DestroySocialAuthenticationPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  destroyedAuthentications?: Maybe<Array<Authentication>>;
  errors?: Maybe<Array<Error>>;
};

/** Autogenerated input type of DestroySystemIncidentAction */
export type DestroySystemIncidentActionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DestroySystemIncidentAction */
export type DestroySystemIncidentActionPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  incident?: Maybe<SystemIncident>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Autogenerated input type of DestroyTable */
export type DestroyTableInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 表格ID或token */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DestroyTable */
export type DestroyTablePayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
};

/** Autogenerated input type of DestroyTemplateCoupon */
export type DestroyTemplateCouponInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  code: Scalars['ID']['input'];
};

/** Autogenerated return type of DestroyTemplateCoupon */
export type DestroyTemplateCouponPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  templateCoupon?: Maybe<TemplateCoupon>;
};

/** Autogenerated input type of DestroyUser */
export type DestroyUserInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  confirmKeyword: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of DestroyUserInviteLinks */
export type DestroyUserInviteLinksInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of DestroyUserInviteLinks */
export type DestroyUserInviteLinksPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  succeed: Scalars['Boolean']['output'];
};

/** Autogenerated return type of DestroyUser */
export type DestroyUserPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
};

export type Dimension = {
  extra?: Maybe<Scalars['JSON']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export enum DimensionOperator {
  Avg = 'avg',
  Max = 'max',
  Min = 'min',
  Sum = 'sum'
}

export type DimensionedField = {
  dimensions: Array<Field>;
};

export type DimensionsAnswerBank = AnswerExplanationSetting & {
  /** 答案解析 */
  answerExplanation?: Maybe<Scalars['String']['output']>;
  /** dimensions的分数设置模式 */
  dimensionsScoringMode: DimensionsScoringMode;
  /** 开启答案解析 */
  enableAnswerExplanation: Scalars['Boolean']['output'];
  /** 总分 */
  score?: Maybe<Scalars['Float']['output']>;
};

export enum DimensionsScoringMode {
  /** All */
  All = 'all',
  /** Individual */
  Individual = 'individual'
}

export type DingTalk = Base & {
  /** 推送类型 */
  approach: Approach;
  cachedFormName: Scalars['String']['output'];
  /** 推送/短信/邮件内容 */
  content?: Maybe<Scalars['String']['output']>;
  entry?: Maybe<Entry>;
  /** 错误信息 */
  errorMessage?: Maybe<Scalars['String']['output']>;
  form?: Maybe<Form>;
  id: Scalars['ID']['output'];
  /** 提醒对象 */
  mentionedMobileList?: Maybe<Array<Scalars['String']['output']>>;
  /** 发送时间（不等于任务触发时间） */
  performedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** 收件人，常用于短信和邮件 */
  recipient?: Maybe<Scalars['String']['output']>;
  /** 返回内容 */
  responseBody?: Maybe<Scalars['String']['output']>;
  /** 状态码 */
  responseCode?: Maybe<Scalars['String']['output']>;
  /** 状态 */
  status: Status;
  /** 推送地址 */
  url?: Maybe<Scalars['String']['output']>;
};

export type DingTalkRule = BaseRule & {
  /** 推送类型 */
  approach: Approach;
  /** 发送条件字段 api_code */
  conditionKey?: Maybe<Scalars['String']['output']>;
  /** 发送条件的值 */
  conditionValue?: Maybe<Scalars['String']['output']>;
  /** true: 开启ScopeCondition */
  conditionalScope?: Maybe<Scalars['Boolean']['output']>;
  /** 消息内容 */
  content?: Maybe<Scalars['String']['output']>;
  /** 任务禁用原因，仅 enabled: false 时有效 */
  disabledBy?: Maybe<DisabledBy>;
  /** 任务是否开启 */
  enabled: Scalars['Boolean']['output'];
  /** 是否为支付条件 */
  entryPaid?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  /** 最后一次失败的错误信息 */
  lastErrorMessage?: Maybe<Scalars['String']['output']>;
  /** 提醒成员，@全体请传: @all */
  mentionedMobileList?: Maybe<Array<Scalars['String']['output']>>;
  /** 发送量 */
  notificationsCount?: Maybe<Scalars['Int']['output']>;
  /** 按周期重复发送 */
  repeatRule?: Maybe<RepeatRule>;
  /** 基于数据定制规则发送 */
  scheduleRule?: Maybe<ScheduleRule>;
  /** 基于日期发送的规则 */
  scheduleTimeRule?: Maybe<ScheduleTimeRule>;
  /** ScopeCondition条件组 */
  scopeConditions?: Maybe<Array<ScopeCondition>>;
  /** 指定发送时间 */
  sendAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** 何时发送 */
  sendTiming?: Maybe<SendTiming>;
  /** 推送范围 */
  triggerScope: TriggerScope;
  /** 更新时间 */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Webhook推送地址 */
  url?: Maybe<Scalars['String']['output']>;
};

export enum DisabledBy {
  /** Custom SMTP authentication error */
  CustomSmtpAuthenticationError = 'custom_smtp_authentication_error',
  /** Custom SMTP deleted */
  CustomSmtpDeleted = 'custom_smtp_deleted',
  /** Manually */
  Manually = 'manually',
  /** Share link disabled */
  ShareLinkDisabled = 'share_link_disabled',
  /** Webhook connection error */
  WebhookConnectionError = 'webhook_connection_error'
}

export enum DisplayFieldLayout {
  /** Bottom */
  Bottom = 'bottom',
  /** Center */
  Center = 'center',
  /** Circular */
  Circular = 'circular',
  /** Cover */
  Cover = 'cover',
  /** Layout 1 of quantity 1 */
  Layout_1OfQuantity_1 = 'layout_1_of_quantity_1',
  /** Layout 1 of quantity 2 */
  Layout_1OfQuantity_2 = 'layout_1_of_quantity_2',
  /** Layout 1 of quantity 3 */
  Layout_1OfQuantity_3 = 'layout_1_of_quantity_3',
  /** Layout 1 of quantity 4 */
  Layout_1OfQuantity_4 = 'layout_1_of_quantity_4',
  /** Layout 1 of quantity 5 */
  Layout_1OfQuantity_5 = 'layout_1_of_quantity_5',
  /** Layout 2 of quantity 1 */
  Layout_2OfQuantity_1 = 'layout_2_of_quantity_1',
  /** Layout 2 of quantity 2 */
  Layout_2OfQuantity_2 = 'layout_2_of_quantity_2',
  /** Layout 2 of quantity 3 */
  Layout_2OfQuantity_3 = 'layout_2_of_quantity_3',
  /** Layout 2 of quantity 4 */
  Layout_2OfQuantity_4 = 'layout_2_of_quantity_4',
  /** Layout 2 of quantity 5 */
  Layout_2OfQuantity_5 = 'layout_2_of_quantity_5',
  /** Layout 3 of quantity 2 */
  Layout_3OfQuantity_2 = 'layout_3_of_quantity_2',
  /** Layout 3 of quantity 3 */
  Layout_3OfQuantity_3 = 'layout_3_of_quantity_3',
  /** Layout 3 of quantity 4 */
  Layout_3OfQuantity_4 = 'layout_3_of_quantity_4',
  /** Layout 3 of quantity 5 */
  Layout_3OfQuantity_5 = 'layout_3_of_quantity_5',
  /** Layout 4 of quantity 4 */
  Layout_4OfQuantity_4 = 'layout_4_of_quantity_4',
  /** Layout 4 of quantity 5 */
  Layout_4OfQuantity_5 = 'layout_4_of_quantity_5',
  /** Left */
  Left = 'left',
  /** Right */
  Right = 'right',
  /** Top */
  Top = 'top',
  /** Tube */
  Tube = 'tube',
  /** Zoom in out */
  ZoomInOut = 'zoom_in_out'
}

export type DisplayFieldsFieldItemImageAttributes = {
  /** 展示字段图片的attachment id */
  attachmentId?: InputMaybe<Scalars['ID']['input']>;
  /** 裁剪高度 */
  croppedH?: InputMaybe<Scalars['Int']['input']>;
  /** 裁剪宽度 */
  croppedW?: InputMaybe<Scalars['Int']['input']>;
  /** 裁剪起点-X轴 */
  croppedX?: InputMaybe<Scalars['Int']['input']>;
  /** 裁剪起点-Y轴 */
  croppedY?: InputMaybe<Scalars['Int']['input']>;
};

export type DisplayFieldsFieldItemImageType = {
  /** 图片原件 */
  attachment?: Maybe<Attachment>;
  /** 裁剪高度 */
  croppedH?: Maybe<Scalars['Int']['output']>;
  /** 裁剪宽度 */
  croppedW?: Maybe<Scalars['Int']['output']>;
  /** 裁剪起点-X轴 */
  croppedX?: Maybe<Scalars['Int']['output']>;
  /** 裁剪起点-Y轴 */
  croppedY?: Maybe<Scalars['Int']['output']>;
};

export type DisplayFieldsFieldStyleType = {
  /** 背景色 */
  backgroundColor?: Maybe<Scalars['String']['output']>;
  /** 描边颜色 */
  borderColor?: Maybe<Scalars['String']['output']>;
  /** 圆角 */
  borderRadius?: Maybe<Scalars['Int']['output']>;
  /** 内边距 */
  padding?: Maybe<Scalars['String']['output']>;
};

export type DisplayFieldsImageTextItemAttributes = {
  /** 文字描述-描述 */
  description?: InputMaybe<DisplayFieldsStyledTextContentAttributes>;
  /** 图文介绍组件的图片 */
  image?: InputMaybe<DisplayFieldsFieldItemImageAttributes>;
  /** 文字描述-标题 */
  title?: InputMaybe<DisplayFieldsStyledTextContentAttributes>;
};

export type DisplayFieldsImageTextItemType = WithTextContent & {
  /** 文字描述-描述 */
  description: DisplayFieldsTextContentType;
  /** 图文介绍-图片设置 */
  image?: Maybe<DisplayFieldsFieldItemImageType>;
  /** 文字描述-标题 */
  title: DisplayFieldsTextContentType;
};

export type DisplayFieldsStyledFieldStyleAttributes = {
  /** 背景色 */
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  /** 描边颜色 */
  borderColor?: InputMaybe<Scalars['String']['input']>;
  /** 圆角 */
  borderRadius?: InputMaybe<Scalars['Int']['input']>;
  /** 内边距 */
  padding?: InputMaybe<Scalars['String']['input']>;
};

export type DisplayFieldsStyledTextContentAttributes = {
  /** 文本内容 */
  content?: InputMaybe<Scalars['String']['input']>;
  /** 文本样式 */
  style?: InputMaybe<DisplayFieldsStyledTextStyleAttributes>;
};

export type DisplayFieldsStyledTextItemAttributes = {
  /** 文字描述-描述 */
  description?: InputMaybe<DisplayFieldsStyledTextContentAttributes>;
  /** 文字描述-标题 */
  title?: InputMaybe<DisplayFieldsStyledTextContentAttributes>;
};

export type DisplayFieldsStyledTextItemType = WithTextContent & {
  /** 文字描述-描述 */
  description: DisplayFieldsTextContentType;
  /** 文字描述-标题 */
  title: DisplayFieldsTextContentType;
};

export enum DisplayFieldsStyledTextStyleAlignmentType {
  Center = 'center',
  Left = 'left',
  Right = 'right'
}

export type DisplayFieldsStyledTextStyleAttributes = {
  /** 字体位置 */
  alignment?: InputMaybe<DisplayFieldsStyledTextStyleAlignmentType>;
  /** 字体颜色 */
  fontColor?: InputMaybe<Scalars['String']['input']>;
  /** 字体 */
  fontFamily?: InputMaybe<Scalars['String']['input']>;
  /** 字体大小 */
  fontSize?: InputMaybe<Scalars['Int']['input']>;
  /** 字体宽度 */
  fontWeight?: InputMaybe<DisplayFieldsStyledTextStyleFontWeightType>;
};

export enum DisplayFieldsStyledTextStyleFontWeightType {
  Bold = 'bold',
  Normal = 'normal'
}

export type DisplayFieldsTextContentType = {
  /** 内容 */
  content?: Maybe<Scalars['String']['output']>;
  /** 内容样式 */
  style?: Maybe<DisplayFieldsTextStyleType>;
};

export type DisplayFieldsTextStyleType = {
  /** 字体位置 */
  alignment?: Maybe<DisplayFieldsStyledTextStyleAlignmentType>;
  /** 字体颜色 */
  fontColor?: Maybe<Scalars['String']['output']>;
  /** 字体 */
  fontFamily?: Maybe<Scalars['String']['output']>;
  /** 字体大小 */
  fontSize?: Maybe<Scalars['Int']['output']>;
  /** 字体宽度 */
  fontWeight?: Maybe<DisplayFieldsStyledTextStyleFontWeightType>;
};

/** Autogenerated input type of DisplayRank */
export type DisplayRankInput = {
  /** 用户当前的排序方式 */
  basedOnOrder: BasedOnOrder;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 所在文件夹TOKEN */
  folderId?: InputMaybe<Scalars['ID']['input']>;
  /** 被排序的表单/文件夹TOKEN */
  id: Scalars['ID']['input'];
  /** 移动后，在后面的表单/文件夹TOKEN */
  nextItemId?: InputMaybe<Scalars['ID']['input']>;
  /** 移动后，在前面的表单/文件夹TOKEN */
  prevItemId?: InputMaybe<Scalars['ID']['input']>;
  /** 所在标签ID */
  pseudoTag?: InputMaybe<Scalars['ID']['input']>;
  /** 所在标签ID */
  tagId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of DisplayRank */
export type DisplayRankPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  succeed?: Maybe<Scalars['Boolean']['output']>;
};

export type Divider = AssociatedField & BaseField & FieldAbility & PlanAvailableField & {
  apiCode: Scalars['ID']['output'];
  apiCodeAlias?: Maybe<Scalars['String']['output']>;
  /** 对应的表单关联字段 */
  associationField?: Maybe<Field>;
  /** 自动填写上次提交内容 */
  cacheData: Scalars['Boolean']['output'];
  /** 客户端ID */
  cid?: Maybe<Scalars['String']['output']>;
  /** 颜色 */
  color?: Maybe<Scalars['String']['output']>;
  /** 封装的字段类型 */
  customizedType?: Maybe<Scalars['String']['output']>;
  /** 封装的字段类型文本 */
  customizedTypeName?: Maybe<Scalars['String']['output']>;
  /** 自定义出错文案 */
  customizedValidationMessage?: Maybe<Scalars['String']['output']>;
  /** 已提交的数据是否可被编辑 */
  editable: Scalars['Boolean']['output'];
  /** 该字段能否使用字段规则: true - 能， false - 不能 */
  fieldRuleAvailable: Scalars['Boolean']['output'];
  /** 是否是关联主键字段 */
  forAssociated?: Maybe<Scalars['Boolean']['output']>;
  /** 是否是关联展示字段 */
  forAssociatedDisplay?: Maybe<Scalars['Boolean']['output']>;
  /** 表单Token */
  formToken: Scalars['String']['output'];
  /** 宽度占用整行的四分之几 */
  gridsToOccupy?: Maybe<Scalars['Int']['output']>;
  hasAbility: Scalars['Boolean']['output'];
  /** 字段标题（去富文本化） */
  label?: Maybe<Scalars['String']['output']>;
  /** 字段描述，富文本 */
  notes?: Maybe<Scalars['String']['output']>;
  /** 上下间距 */
  padding?: Maybe<Scalars['Int']['output']>;
  paidFeature?: Maybe<PaidFeature>;
  planAvailable: Scalars['Boolean']['output'];
  /** 字段排序 */
  position: Scalars['Int']['output'];
  /** 该字段是否是隐私字段 true - 是, false - 不是 */
  privacy: Scalars['Boolean']['output'];
  /** 字段隐藏 */
  private: Scalars['Boolean']['output'];
  /** 字段是否通过预填写表单预设了值 true - 是, false - 否 */
  pseudoFormPredefined?: Maybe<Scalars['Boolean']['output']>;
  /** 字段标题（富文本化） */
  rawLabel?: Maybe<Scalars['String']['output']>;
  /** 字段是否只读，无法编辑 */
  readonly?: Maybe<Scalars['Boolean']['output']>;
  /** 该字段是否属于评分字段（e.g. 考试、测评中的题目） */
  scorable: Scalars['Boolean']['output'];
  /** 字段提示较长时折叠展示 */
  showPartDescription: Scalars['Boolean']['output'];
  /** 新起一行 */
  startNewRow: Scalars['Boolean']['output'];
  /** 样式 */
  style?: Maybe<DividerStyle>;
  /** 该字段是否可以作为文本插入 true - 能, false - 不能 */
  textPlaceholderable: Scalars['Boolean']['output'];
  /** 字段类型 */
  type: FieldClass;
  /** 字段类型文本 */
  typeName: Scalars['String']['output'];
  /** 字段验证规则 */
  validations?: Maybe<Array<FieldValidation>>;
};


export type DividerHasAbilityArgs = {
  key: FieldAbilityEnum;
};


export type DividerNotesArgs = {
  sanitize?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum DividerStyle {
  Blank = 'blank',
  Dashed = 'dashed',
  Dotted = 'dotted',
  DoubleSolid = 'double_solid',
  Solid = 'solid',
  ThickSolid = 'thick_solid',
  ThinAndThickSolid = 'thin_and_thick_solid'
}

export type DocJob = BaseEntriesBatchJob & {
  /** 导出下载链接 */
  downloadUrl?: Maybe<Scalars['String']['output']>;
  /** 预估的剩余时长 */
  estimateLeft?: Maybe<Scalars['BigInteger']['output']>;
  /** 数据筛选条件 */
  filter?: Maybe<Scalars['JSON']['output']>;
  /** ID */
  id: Scalars['ID']['output'];
  /** 数据范围 */
  rowScope: RowScopeType;
  /** 导出任务状态 */
  status: EntriesBatchJobStatus;
};

export type DoorkeeperApplication = {
  /** 插件在 Next 中的唯一性标识 code */
  appCenterCode?: Maybe<Scalars['String']['output']>;
  /** 进入插件中心 URL。实际先跳转到 oauth 授权页面 */
  appCenterUrl?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  developer?: Maybe<Scalars['String']['output']>;
  /** 体验插件表单 token */
  experienceFormToken?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  inlineDesc?: Maybe<Scalars['String']['output']>;
  /** Only for current logged in user */
  lastAuthorizedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  lastReleasedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** 新版 logo, for next-fe */
  newLogo?: Maybe<Scalars['String']['output']>;
  orgPrice: Scalars['Float']['output'];
  price: Scalars['Float']['output'];
  screenshots: Array<Scalars['String']['output']>;
  userApplication?: Maybe<UserApplication>;
  version?: Maybe<Scalars['String']['output']>;
  websiteUrl?: Maybe<Scalars['String']['output']>;
};

/** The connection type for DoorkeeperApplication. */
export type DoorkeeperApplicationConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<DoorkeeperApplicationEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<DoorkeeperApplication>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type DoorkeeperApplicationEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<DoorkeeperApplication>;
};

export type DropDown = AssociatedField & BaseField & CalculableField & ExtraConfigurableSetting & FieldAbility & PlanAvailableField & PredefineableField & PromptableField & QuotableField & SelectableField & {
  apiCode: Scalars['ID']['output'];
  apiCodeAlias?: Maybe<Scalars['String']['output']>;
  /** 对应的表单关联字段 */
  associationField?: Maybe<Field>;
  /** 自动填写上次提交内容 */
  cacheData: Scalars['Boolean']['output'];
  /** 开启选项赋值或本身可参与计算 */
  calculable: Scalars['Boolean']['output'];
  choiceFilterable: Scalars['Boolean']['output'];
  choices: Array<Choice>;
  /** 客户端ID */
  cid?: Maybe<Scalars['String']['output']>;
  /** 封装的字段类型 */
  customizedType?: Maybe<Scalars['String']['output']>;
  /** 封装的字段类型文本 */
  customizedTypeName?: Maybe<Scalars['String']['output']>;
  /** 自定义出错文案 */
  customizedValidationMessage?: Maybe<Scalars['String']['output']>;
  /** 已提交的数据是否可被编辑 */
  editable: Scalars['Boolean']['output'];
  /** 场景化可配置字段设置 */
  extraConfigurableSettings?: Maybe<FieldExtraConfigurableSettings>;
  /** 该字段能否使用字段规则: true - 能， false - 不能 */
  fieldRuleAvailable: Scalars['Boolean']['output'];
  /** 是否是关联主键字段 */
  forAssociated?: Maybe<Scalars['Boolean']['output']>;
  /** 是否是关联展示字段 */
  forAssociatedDisplay?: Maybe<Scalars['Boolean']['output']>;
  /** 表单Token */
  formToken: Scalars['String']['output'];
  /** 宽度占用整行的四分之几 */
  gridsToOccupy?: Maybe<Scalars['Int']['output']>;
  hasAbility: Scalars['Boolean']['output'];
  /** 选项名额为空时隐藏选项 */
  hideChoiceWhenQuotaEmpty: Scalars['Boolean']['output'];
  /** 不向填表者展示选项名额剩余数字 */
  hideQuota: Scalars['Boolean']['output'];
  /** 字段标题（去富文本化） */
  label?: Maybe<Scalars['String']['output']>;
  /** 字段描述，富文本 */
  notes?: Maybe<Scalars['String']['output']>;
  paidFeature?: Maybe<PaidFeature>;
  planAvailable: Scalars['Boolean']['output'];
  /** 字段排序 */
  position: Scalars['Int']['output'];
  /** 预填写表单 */
  predefined: Scalars['Boolean']['output'];
  /** 该字段是否是隐私字段 true - 是, false - 不是 */
  privacy: Scalars['Boolean']['output'];
  /** 字段隐藏 */
  private: Scalars['Boolean']['output'];
  prompt?: Maybe<Scalars['String']['output']>;
  /** 字段是否通过预填写表单预设了值 true - 是, false - 否 */
  pseudoFormPredefined?: Maybe<Scalars['Boolean']['output']>;
  /** 剩余名额为0时，显示文案 */
  quotaBlankWarning?: Maybe<Scalars['String']['output']>;
  /** 选项名额重置 */
  quotaCycleRule?: Maybe<QuotaCycleRule>;
  /** 删除数据后，选项名额自动恢复 */
  quotaRecoverable: Scalars['Boolean']['output'];
  randomChoices: Scalars['Boolean']['output'];
  /** 字段标题（富文本化） */
  rawLabel?: Maybe<Scalars['String']['output']>;
  /** 字段是否只读，无法编辑 */
  readonly?: Maybe<Scalars['Boolean']['output']>;
  /** 该字段是否属于评分字段（e.g. 考试、测评中的题目） */
  scorable: Scalars['Boolean']['output'];
  /** 字段提示较长时折叠展示 */
  showPartDescription: Scalars['Boolean']['output'];
  /** 新起一行 */
  startNewRow: Scalars['Boolean']['output'];
  /** 该字段是否可以作为文本插入 true - 能, false - 不能 */
  textPlaceholderable: Scalars['Boolean']['output'];
  /** 字段类型 */
  type: FieldClass;
  /** 字段类型文本 */
  typeName: Scalars['String']['output'];
  /** 字段验证规则 */
  validations?: Maybe<Array<FieldValidation>>;
};


export type DropDownHasAbilityArgs = {
  key: FieldAbilityEnum;
};


export type DropDownNotesArgs = {
  sanitize?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DynamicAttrs = FormDefaultEntry & WithDynamicAttrs & {
  /** 带有默认值的预填写数据 */
  entry?: Maybe<Entry>;
  /** 选择类字段的投票结果统计数据 */
  entryCountsPerChoice?: Maybe<Scalars['JSON']['output']>;
  /** 包含库存信息的商品字段 */
  inventoryFields?: Maybe<Scalars['JSON']['output']>;
  /** 包含余额的选项类字段 */
  quotableFields?: Maybe<Scalars['JSON']['output']>;
};


export type DynamicAttrsEntryArgs = {
  code?: InputMaybe<Scalars['ID']['input']>;
};

export type EInvoice = {
  /** 开票金额 */
  amount: Scalars['Float']['output'];
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  /** 发票抬头 */
  invoiceTitle?: Maybe<InvoiceTitle>;
  /** 备注 */
  remarks?: Maybe<Scalars['String']['output']>;
  /** 审核备注 */
  reviewRemarks?: Maybe<Scalars['String']['output']>;
  /** 状态 */
  reviewStatus?: Maybe<ReviewStatusEnum>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** 下载链接 */
  visitUrl?: Maybe<Scalars['String']['output']>;
};

export type ESignatureField = AssociatedField & BaseField & FieldAbility & PlanAvailableField & {
  apiCode: Scalars['ID']['output'];
  apiCodeAlias?: Maybe<Scalars['String']['output']>;
  /** 对应的表单关联字段 */
  associationField?: Maybe<Field>;
  /** 自动填写上次提交内容 */
  cacheData: Scalars['Boolean']['output'];
  /** 客户端ID */
  cid?: Maybe<Scalars['String']['output']>;
  /** 封装的字段类型 */
  customizedType?: Maybe<Scalars['String']['output']>;
  /** 封装的字段类型文本 */
  customizedTypeName?: Maybe<Scalars['String']['output']>;
  /** 自定义出错文案 */
  customizedValidationMessage?: Maybe<Scalars['String']['output']>;
  /** 已提交的数据是否可被编辑 */
  editable: Scalars['Boolean']['output'];
  /** 该字段能否使用字段规则: true - 能， false - 不能 */
  fieldRuleAvailable: Scalars['Boolean']['output'];
  /** 是否是关联主键字段 */
  forAssociated?: Maybe<Scalars['Boolean']['output']>;
  /** 是否是关联展示字段 */
  forAssociatedDisplay?: Maybe<Scalars['Boolean']['output']>;
  /** 表单Token */
  formToken: Scalars['String']['output'];
  /** 宽度占用整行的四分之几 */
  gridsToOccupy?: Maybe<Scalars['Int']['output']>;
  hasAbility: Scalars['Boolean']['output'];
  /** 字段标题（去富文本化） */
  label?: Maybe<Scalars['String']['output']>;
  /** 字段描述，富文本 */
  notes?: Maybe<Scalars['String']['output']>;
  paidFeature?: Maybe<PaidFeature>;
  planAvailable: Scalars['Boolean']['output'];
  /** 字段排序 */
  position: Scalars['Int']['output'];
  /** 该字段是否是隐私字段 true - 是, false - 不是 */
  privacy: Scalars['Boolean']['output'];
  /** 字段隐藏 */
  private: Scalars['Boolean']['output'];
  /** 字段是否通过预填写表单预设了值 true - 是, false - 否 */
  pseudoFormPredefined?: Maybe<Scalars['Boolean']['output']>;
  /** 字段标题（富文本化） */
  rawLabel?: Maybe<Scalars['String']['output']>;
  /** 字段是否只读，无法编辑 */
  readonly?: Maybe<Scalars['Boolean']['output']>;
  /** 该字段是否属于评分字段（e.g. 考试、测评中的题目） */
  scorable: Scalars['Boolean']['output'];
  /** 字段提示较长时折叠展示 */
  showPartDescription: Scalars['Boolean']['output'];
  /** 新起一行 */
  startNewRow: Scalars['Boolean']['output'];
  /** 该字段是否可以作为文本插入 true - 能, false - 不能 */
  textPlaceholderable: Scalars['Boolean']['output'];
  /** 字段类型 */
  type: FieldClass;
  /** 字段类型文本 */
  typeName: Scalars['String']['output'];
  /** 字段验证规则 */
  validations?: Maybe<Array<FieldValidation>>;
};


export type ESignatureFieldHasAbilityArgs = {
  key: FieldAbilityEnum;
};


export type ESignatureFieldNotesArgs = {
  sanitize?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Email = Base & {
  /** 推送类型 */
  approach: Approach;
  cachedFormName: Scalars['String']['output'];
  /** 推送/短信/邮件内容 */
  content?: Maybe<Scalars['String']['output']>;
  entry?: Maybe<Entry>;
  /** 错误信息 */
  errorMessage?: Maybe<Scalars['String']['output']>;
  form?: Maybe<Form>;
  id: Scalars['ID']['output'];
  /** 发送时间（不等于任务触发时间） */
  performedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** 收件人，常用于短信和邮件 */
  recipient?: Maybe<Scalars['String']['output']>;
  /** 状态 */
  status: Status;
  /** 邮件正文 */
  subject?: Maybe<Scalars['String']['output']>;
};

/** The connection type for Email. */
export type EmailConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<EmailEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Email>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type EmailEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Email>;
};

export type EmailField = AssociatedField & BaseField & FieldAbility & PlanAvailableField & PredefineableField & {
  apiCode: Scalars['ID']['output'];
  apiCodeAlias?: Maybe<Scalars['String']['output']>;
  /** 对应的表单关联字段 */
  associationField?: Maybe<Field>;
  /** 自动填写上次提交内容 */
  cacheData: Scalars['Boolean']['output'];
  /** 客户端ID */
  cid?: Maybe<Scalars['String']['output']>;
  /** 封装的字段类型 */
  customizedType?: Maybe<Scalars['String']['output']>;
  /** 封装的字段类型文本 */
  customizedTypeName?: Maybe<Scalars['String']['output']>;
  /** 自定义出错文案 */
  customizedValidationMessage?: Maybe<Scalars['String']['output']>;
  /** 已提交的数据是否可被编辑 */
  editable: Scalars['Boolean']['output'];
  /** 该字段能否使用字段规则: true - 能， false - 不能 */
  fieldRuleAvailable: Scalars['Boolean']['output'];
  /** 是否是关联主键字段 */
  forAssociated?: Maybe<Scalars['Boolean']['output']>;
  /** 是否是关联展示字段 */
  forAssociatedDisplay?: Maybe<Scalars['Boolean']['output']>;
  /** 表单Token */
  formToken: Scalars['String']['output'];
  /** 宽度占用整行的四分之几 */
  gridsToOccupy?: Maybe<Scalars['Int']['output']>;
  hasAbility: Scalars['Boolean']['output'];
  /** 字段标题（去富文本化） */
  label?: Maybe<Scalars['String']['output']>;
  /** 字段描述，富文本 */
  notes?: Maybe<Scalars['String']['output']>;
  paidFeature?: Maybe<PaidFeature>;
  /** 占位符 */
  placeholder?: Maybe<Scalars['String']['output']>;
  planAvailable: Scalars['Boolean']['output'];
  /** 字段排序 */
  position: Scalars['Int']['output'];
  /** 预填写表单 */
  predefined: Scalars['Boolean']['output'];
  /** 该字段是否是隐私字段 true - 是, false - 不是 */
  privacy: Scalars['Boolean']['output'];
  /** 字段隐藏 */
  private: Scalars['Boolean']['output'];
  /** 字段是否通过预填写表单预设了值 true - 是, false - 否 */
  pseudoFormPredefined?: Maybe<Scalars['Boolean']['output']>;
  /** 字段标题（富文本化） */
  rawLabel?: Maybe<Scalars['String']['output']>;
  /** 字段是否只读，无法编辑 */
  readonly?: Maybe<Scalars['Boolean']['output']>;
  /** 该字段是否属于评分字段（e.g. 考试、测评中的题目） */
  scorable: Scalars['Boolean']['output'];
  /** 字段提示较长时折叠展示 */
  showPartDescription: Scalars['Boolean']['output'];
  /** 新起一行 */
  startNewRow: Scalars['Boolean']['output'];
  /** 该字段是否可以作为文本插入 true - 能, false - 不能 */
  textPlaceholderable: Scalars['Boolean']['output'];
  /** 字段类型 */
  type: FieldClass;
  /** 字段类型文本 */
  typeName: Scalars['String']['output'];
  /** 字段验证规则 */
  validations?: Maybe<Array<FieldValidation>>;
};


export type EmailFieldHasAbilityArgs = {
  key: FieldAbilityEnum;
};


export type EmailFieldNotesArgs = {
  sanitize?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EmailRule = BaseRule & {
  /** 推送类型 */
  approach: Approach;
  /** 发送条件字段 api_code */
  conditionKey?: Maybe<Scalars['String']['output']>;
  /** 发送条件的值 */
  conditionValue?: Maybe<Scalars['String']['output']>;
  /** true: 开启ScopeCondition */
  conditionalScope?: Maybe<Scalars['Boolean']['output']>;
  /** 邮件内容 */
  content?: Maybe<Scalars['String']['output']>;
  /** 任务禁用原因，仅 enabled: false 时有效 */
  disabledBy?: Maybe<DisabledBy>;
  /** 任务是否开启 */
  enabled: Scalars['Boolean']['output'];
  /** 是否为支付条件 */
  entryPaid?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  /** 发送量 */
  notificationsCount?: Maybe<Scalars['Int']['output']>;
  /** 收件人，可传邮箱或字段 */
  recipients?: Maybe<Array<Scalars['String']['output']>>;
  /** 按周期重复发送 */
  repeatRule?: Maybe<RepeatRule>;
  /** 基于数据定制规则发送 */
  scheduleRule?: Maybe<ScheduleRule>;
  /** 基于日期发送的规则 */
  scheduleTimeRule?: Maybe<ScheduleTimeRule>;
  /** ScopeCondition条件组 */
  scopeConditions?: Maybe<Array<ScopeCondition>>;
  /** 指定发送时间 */
  sendAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** 何时发送 */
  sendTiming?: Maybe<SendTiming>;
  /** smtp账号 */
  smtpAccount?: Maybe<SmtpAccount>;
  /** 邮件标题 */
  subject?: Maybe<Scalars['String']['output']>;
  /** 推送范围 */
  triggerScope: TriggerScope;
  /** 更新时间 */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export enum EmailTaskSendStatusEnum {
  AllSent = 'all_sent',
  NoneSent = 'none_sent',
  PartialSent = 'partial_sent',
  Sending = 'sending',
  WaitingForSend = 'waiting_for_send'
}

export enum EmailTaskStatusEnum {
  /** Translation missing: en.tasks.status.all_sent */
  AllSent = 'all_sent',
  /** Translation missing: en.tasks.status.none_sent */
  NoneSent = 'none_sent',
  /** Translation missing: en.tasks.status.partial_sent */
  PartialSent = 'partial_sent',
  /** Translation missing: en.tasks.status.sending */
  Sending = 'sending',
  /** Translation missing: en.tasks.status.waiting_for_send */
  WaitingForSend = 'waiting_for_send'
}

/** Autogenerated input type of EndHandoff */
export type EndHandoffInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 要结束人工接待的 AgentInquiryConversation Id */
  conversationId: Scalars['String']['input'];
};

/** Autogenerated return type of EndHandoff */
export type EndHandoffPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  conversation?: Maybe<Conversation>;
  errors?: Maybe<Array<Error>>;
};

export enum EndingActionFeature {
  /** Translation missing: en.form_settings.ending_actions_display_order.certificate */
  Certificate = 'certificate',
  /** Translation missing: en.form_settings.ending_actions_display_order.entry_red_envelope */
  EntryRedEnvelope = 'entry_red_envelope',
  /** Translation missing: en.form_settings.ending_actions_display_order.exam_filled_entry */
  ExamFilledEntry = 'exam_filled_entry',
  /** Translation missing: en.form_settings.ending_actions_display_order.exam_info */
  ExamInfo = 'exam_info',
  /** Translation missing: en.form_settings.ending_actions_display_order.fill_again */
  FillAgain = 'fill_again',
  /** Translation missing: en.form_settings.ending_actions_display_order.filled_entry */
  FilledEntry = 'filled_entry',
  /** Translation missing: en.form_settings.ending_actions_display_order.gen_code */
  GenCode = 'gen_code',
  /** Translation missing: en.form_settings.ending_actions_display_order.login_button */
  LoginButton = 'login_button',
  /** Translation missing: en.form_settings.ending_actions_display_order.radar_chart */
  RadarChart = 'radar_chart',
  /** Translation missing: en.form_settings.ending_actions_display_order.redirect */
  Redirect = 'redirect',
  /** Translation missing: en.form_settings.ending_actions_display_order.reports */
  Reports = 'reports',
  /** Translation missing: en.form_settings.ending_actions_display_order.serial_number */
  SerialNumber = 'serial_number',
  /** Translation missing: en.form_settings.ending_actions_display_order.success_message */
  SuccessMessage = 'success_message',
  /** Translation missing: en.form_settings.ending_actions_display_order.wheel_fortune */
  WheelFortune = 'wheel_fortune'
}

export type EndingActionsDisplayOrder = {
  /** 测评报告展示功能 */
  showEvaluationReports?: Maybe<Array<EndingActionFeature>>;
  /** 成绩单展示功能 */
  showExamScore?: Maybe<Array<EndingActionFeature>>;
  /** 结束页展示功能 */
  showMessagePage?: Maybe<Array<EndingActionFeature>>;
};

export type EntriesAttachmentsTaskAttributes = {
  /** 导出附件字段code */
  attachmentField: Scalars['String']['input'];
  /** 数据筛选条件 */
  filter?: InputMaybe<EntriesFilterAttributes>;
  /** 命名规则 */
  namingRule: Scalars['String']['input'];
};

export type EntriesBaseProperties = {
  _type?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  serialNumber: Scalars['Int']['output'];
  token?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type EntriesBatchJobAttributes = {
  /** 数据筛选条件 */
  filter?: InputMaybe<EntriesFilterAttributes>;
  /** ID */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** 数据范围 */
  rowScope: RowScopeType;
  /** 任务类型 */
  type: EntriesBatchJobTypeType;
};

export enum EntriesBatchJobStatus {
  /** failed */
  Failed = 'failed',
  /** partial_success */
  PartialSuccess = 'partial_success',
  /** pending */
  Pending = 'pending',
  /** running */
  Running = 'running',
  /** success */
  Success = 'success',
  /** timeout */
  Timeout = 'timeout'
}

export enum EntriesBatchJobTypeType {
  CertificateJob = 'CertificateJob',
  DocJob = 'DocJob'
}

export type EntriesExportJobAttributes = {
  /** 字段范围 */
  columnScope: ColumnScopeType;
  /** 排除的数据 */
  exceptEntryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** 地理信息字段是否同时导出经纬度 */
  exportLongAndLat?: InputMaybe<Scalars['Boolean']['input']>;
  /** 对题目仅导出分值 */
  exportWithAnswerScore?: InputMaybe<Scalars['Boolean']['input']>;
  /** 赋值的选项只导出数值 */
  exportWithOperandValue?: InputMaybe<Scalars['Boolean']['input']>;
  /** 数据筛选条件 */
  filter?: InputMaybe<EntriesFilterAttributes>;
  /** 当前视图 ID；传入后会校验视图归属当前用户和当前表单，column_scope=limited 时按该 FormView 的 prefer_columns 导出，column_scope=all 时仅做校验不影响导出列 */
  formViewId?: InputMaybe<Scalars['ID']['input']>;
  /** 同时导出数据中包含的附件 */
  includeAttachments?: InputMaybe<Scalars['Boolean']['input']>;
  /** 地址字段是否合并单元格 */
  mergeForAddressField?: InputMaybe<Scalars['Boolean']['input']>;
  /** 多级下拉框是否合并单元格 */
  mergeForCascadeDropDown?: InputMaybe<Scalars['Boolean']['input']>;
  /** 预约字段是否合并单元格 */
  mergeForReservationField?: InputMaybe<Scalars['Boolean']['input']>;
  /** 导出文件命名规则 */
  namingRule?: InputMaybe<Scalars['String']['input']>;
  /** 数据范围 */
  rowScope: RowScopeType;
  /** 选中的数据 */
  selectedEntryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** 导出格式（excel, csv, spss） */
  sheetFormat: ExportJobSheetFormatType;
  /** 根据字段排序 */
  sortColumns?: InputMaybe<Array<SortColumnAttributes>>;
  /** 是否将矩阵选择导出为独立矩阵格式工作表 */
  subsheetForLikertField?: InputMaybe<Scalars['Boolean']['input']>;
  /** 是否将矩阵填空导出为独立矩阵格式工作表 */
  subsheetForMatrixField?: InputMaybe<Scalars['Boolean']['input']>;
  /** 是否将表格导出为独立矩阵格式工作表 */
  subsheetForTableField?: InputMaybe<Scalars['Boolean']['input']>;
  /** 矩阵填空在表格中的显示格式：true - 拆分显示；false - 平铺显示 */
  subsheetLayoutSettingForMatrixField?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EntriesFilterAttributes = {
  /** 被排除的的数据序号 */
  exceptSerialNumbers?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** 全局搜索的Keyword */
  keyword?: InputMaybe<Scalars['String']['input']>;
  /** 全局搜索类型(默认按内容搜索) */
  keywordType?: InputMaybe<EntriesKeywordTypeEnum>;
  /** 数据被标记成什么，例如：客户 */
  markAs?: InputMaybe<EntryMarkAsEnum>;
  /** ScopeCondition筛选条件 */
  scopeConditions?: InputMaybe<Array<ScopeConditionAttributes>>;
  /** 是否全选 */
  selectAll?: InputMaybe<Scalars['Boolean']['input']>;
  /** 按数据序号筛选 */
  serialNumbers?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export enum EntriesKeywordTypeEnum {
  /** 按内容搜索 */
  Content = 'content',
  /** 按序号搜索 */
  SerialNumber = 'serial_number'
}

export type Entry = CustomerProperties & EntriesBaseProperties & MetaProperties & ReservationStatusProperties & ShareAndMarkProperties & WeixinProperties & {
  _type?: Maybe<Scalars['String']['output']>;
  browser?: Maybe<Scalars['String']['output']>;
  colorMark?: Maybe<Scalars['String']['output']>;
  /** 表单联系人 */
  contactId?: Maybe<Scalars['ID']['output']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  creator?: Maybe<PublishedUser>;
  customer?: Maybe<GdCustomer>;
  /** 当前版本号 */
  editedVersion?: Maybe<Scalars['Int']['output']>;
  fieldValues: Scalars['JSON']['output'];
  fillingDuration?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  ip?: Maybe<Scalars['String']['output']>;
  os?: Maybe<Scalars['String']['output']>;
  platform?: Maybe<Scalars['String']['output']>;
  region?: Maybe<RegionInfo>;
  remark?: Maybe<Scalars['String']['output']>;
  /** 预约状态 */
  reservationStatus?: Maybe<ReservationStatusEnum>;
  serialNumber: Scalars['Int']['output'];
  shareLink?: Maybe<Scalars['String']['output']>;
  shareToken?: Maybe<Scalars['String']['output']>;
  startFillingTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  useragent?: Maybe<Scalars['String']['output']>;
  weixinAccessToken?: Maybe<Scalars['ID']['output']>;
  xFieldWeixinHeadimgurl?: Maybe<Scalars['String']['output']>;
  xFieldWeixinNickname?: Maybe<Scalars['String']['output']>;
  xFieldWeixinOpenid?: Maybe<Scalars['ID']['output']>;
  xFieldWeixinUnionid?: Maybe<Scalars['ID']['output']>;
};


export type EntryFieldValuesArgs = {
  fieldsContext?: InputMaybe<FieldsContext>;
};

export type EntryAttachmentAttributes = {
  /** 文件类型, 七牛: 由七牛直传返回值中获得, s3: 前端解析获取 */
  contentType: Scalars['String']['input'];
  /** 语音时长, 单位: 秒 */
  duration?: InputMaybe<Scalars['Float']['input']>;
  /** 文件名, 七牛: 由七牛直传返回值中获得, s3: 前端解析获取 */
  fileName: Scalars['String']['input'];
  /** 文件大小, 七牛: 由七牛直传返回值中获得, s3: 前端解析获取 */
  fileSize: Scalars['Int']['input'];
  /** 存储路径, 七牛: 由七牛直传返回值中获得, s3: 从接口createEntryAttachmentPresignedUrl中获取 */
  key: Scalars['String']['input'];
  /** 安全码, 七牛: 由七牛直传返回值中获得(必填), s3: 不用填写 */
  securityCode?: InputMaybe<Scalars['String']['input']>;
};

export enum EntryAttachmentPrefix {
  /** EntryAttachment */
  En = 'en',
  /** EntryAudioAttachment */
  Ena = 'ena',
  /** EntryESignatureAttachment */
  Ens = 'ens'
}

export enum EntryAttachmentsTaskStatusType {
  Fail = 'fail',
  Running = 'running',
  Success = 'success'
}

export type EntryAttachmentsTaskType = {
  /** 导出任务附件下载链接 */
  downloadUrls?: Maybe<Array<Scalars['String']['output']>>;
  /** 失败原因 */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** 附件字段code */
  fieldApiCode?: Maybe<Scalars['String']['output']>;
  /** ID */
  id: Scalars['ID']['output'];
  /** 附件打包状态 */
  status: EntryAttachmentsTaskStatusType;
};

export type EntryColumn = {
  /** 字段的api_code */
  apiCode: Scalars['String']['output'];
  /** 顺序(升序排列) */
  position: Scalars['Int']['output'];
};

export type EntryColumnAttributes = {
  /** 字段api_code */
  apiCode: Scalars['String']['input'];
};

/** The connection type for Entry. */
export type EntryConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<EntryEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Entry>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type EntryEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Entry>;
};

export type EntryEditable = {
  /** 是否允许修改数据, true: 允许  */
  entryEditEnabled: Scalars['Boolean']['output'];
  /** 修改前是否需要手机验证，true: 需要,false: 不需要 */
  entryEditVerifyEnabled: Scalars['Boolean']['output'];
  /** 修改手机可验证字段 */
  entryEditVerifyField: Field;
  /** 修改前手机验证字段api_code */
  entryEditVerifyFieldApiCode?: Maybe<Scalars['String']['output']>;
};

export type EntryEmailTaskAttributes = {
  /** 邮件内容 */
  content?: InputMaybe<Scalars['String']['input']>;
  /** 收件人字段 */
  dimensionField?: InputMaybe<Scalars['String']['input']>;
  /** 数据筛选条件 */
  entriesFilter?: InputMaybe<EntriesFilterAttributes>;
  /** 收件人字段 */
  entryField?: InputMaybe<Scalars['String']['input']>;
  /** 表单id */
  formId?: InputMaybe<Scalars['ID']['input']>;
  /** smtp account */
  smtpAccountId?: InputMaybe<Scalars['ID']['input']>;
  /** 主题 */
  subject?: InputMaybe<Scalars['String']['input']>;
};

export type EntryEmailTaskFailActivity = {
  formInfo: FormActivityBaseInfo;
};

/** Entry Email Task status counts */
export type EntryEmailTaskStatusCounts = {
  /** Translation missing: en.tasks.status.all_sent */
  allSentCount: Scalars['Int']['output'];
  /** Translation missing: en.tasks.status.none_sent */
  noneSentCount: Scalars['Int']['output'];
  /** Translation missing: en.tasks.status.partial_sent */
  partialSentCount: Scalars['Int']['output'];
  /** Translation missing: en.tasks.status.sending */
  sendingCount: Scalars['Int']['output'];
  /** 总任务数量 */
  totalCount: Scalars['Int']['output'];
  /** Translation missing: en.tasks.status.waiting_for_send */
  waitingForSendCount: Scalars['Int']['output'];
};

export type EntryEmailTaskType = {
  /** 发送结果 */
  activities: EntryTaskActivityConnection;
  /** 发送结果统计 */
  allSendStatusWithCount: Scalars['JSON']['output'];
  /** 发送内容 */
  content?: Maybe<Scalars['String']['output']>;
  /** 创建时间 */
  createdAt: Scalars['ISO8601DateTime']['output'];
  dimensionField: Scalars['String']['output'];
  /** 目标数据量 */
  entriesCount: Scalars['Int']['output'];
  /** 发送的字段 */
  entryField: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** 已发送数量 */
  publicActivitiesCount: Scalars['Int']['output'];
  /** 预览显示待发送人（仅显示前 3 个） */
  sampleRecipients?: Maybe<Array<Scalars['String']['output']>>;
  /** SMTP邮件服务器 */
  smtpAccount?: Maybe<SmtpAccount>;
  /** 发送状态 */
  status: EmailTaskStatusEnum;
  /** 主题 */
  subject?: Maybe<Scalars['String']['output']>;
  /** 待发送数量 */
  totalActivities: Scalars['Int']['output'];
  /** 更新时间 */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};


export type EntryEmailTaskTypeActivitiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<TaskActivityStatusEnum>;
};

/** The connection type for EntryEmailTaskType. */
export type EntryEmailTaskTypeConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<EntryEmailTaskTypeEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<EntryEmailTaskType>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type EntryEmailTaskTypeEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<EntryEmailTaskType>;
};

export enum EntryExportStatus {
  Failed = 'failed',
  Pending = 'pending',
  Running = 'running',
  Success = 'success',
  Timeout = 'timeout'
}

export type EntryFilter = {
  filter?: Maybe<Scalars['JSON']['output']>;
};

export enum EntryFilterUseAsType {
  /** Data filter */
  DataFilter = 'data_filter',
  /** Report */
  Report = 'report'
}

export enum EntryMarkAsEnum {
  Customer = 'Customer',
  Submitter = 'Submitter'
}

export type EntryOption = CustomerProperties & EntriesBaseProperties & MetaProperties & ReservationStatusProperties & ShareAndMarkProperties & WeixinProperties & {
  _type?: Maybe<Scalars['String']['output']>;
  browser?: Maybe<Scalars['String']['output']>;
  colorMark?: Maybe<Scalars['String']['output']>;
  /** 表单联系人 */
  contactId?: Maybe<Scalars['ID']['output']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  creator?: Maybe<PublishedUser>;
  customer?: Maybe<GdCustomer>;
  /** 当前版本号 */
  editedVersion?: Maybe<Scalars['Int']['output']>;
  fieldValues: Scalars['JSON']['output'];
  fillingDuration?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  ip?: Maybe<Scalars['String']['output']>;
  os?: Maybe<Scalars['String']['output']>;
  platform?: Maybe<Scalars['String']['output']>;
  region?: Maybe<RegionInfo>;
  remark?: Maybe<Scalars['String']['output']>;
  /** 预约状态 */
  reservationStatus?: Maybe<ReservationStatusEnum>;
  serialNumber: Scalars['Int']['output'];
  shareLink?: Maybe<Scalars['String']['output']>;
  shareToken?: Maybe<Scalars['String']['output']>;
  startFillingTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  useragent?: Maybe<Scalars['String']['output']>;
  weixinAccessToken?: Maybe<Scalars['ID']['output']>;
  xFieldWeixinHeadimgurl?: Maybe<Scalars['String']['output']>;
  xFieldWeixinNickname?: Maybe<Scalars['String']['output']>;
  xFieldWeixinOpenid?: Maybe<Scalars['ID']['output']>;
  xFieldWeixinUnionid?: Maybe<Scalars['ID']['output']>;
};


export type EntryOptionFieldValuesArgs = {
  fieldsContext?: InputMaybe<FieldsContext>;
};

export type EntryRedEnvelopeSetting = RedEnvelopeCommonSetting & {
  /** 领取规则类型 */
  deliveryRule: RedEnvelopeDeliveryRule;
  /** 固定红包金额 */
  fixedAmount: Scalars['Float']['output'];
  /** 随机领取概率 */
  probability: Scalars['Int']['output'];
  /** 随机最小金额 */
  rangeLowerBound: Scalars['Float']['output'];
  /** 随机最大金额 */
  rangeUpperBound: Scalars['Float']['output'];
  /** 按分数段规则是否启用 */
  redEnvelopeRulesEnabled: Scalars['Boolean']['output'];
  /** 按分数段规则 */
  redEnvelopeScoreRule?: Maybe<RedEnvelopeScoreRule>;
  /** 限领频率类型 */
  redeemFrequency: RedEnvelopeRedeemFrequency;
  /** 填表时是否展示红包弹窗 */
  showRedEnvelopPopup: Scalars['Boolean']['output'];
  /** 是否随机金额 */
  useRandomAmount: Scalars['Boolean']['output'];
  /** 是否在自定义范围内随机 */
  useRandomAmountInRange: Scalars['Boolean']['output'];
};

export type EntryRedEnvelopeSettingAttributes = {
  /** 领取规则类型 */
  deliveryRule?: InputMaybe<RedEnvelopeDeliveryRule>;
  /** 固定红包金额 */
  fixedAmount?: InputMaybe<Scalars['Float']['input']>;
  /** 随机领取概率 */
  probability?: InputMaybe<Scalars['Int']['input']>;
  /** 随机最小金额 */
  rangeLowerBound?: InputMaybe<Scalars['Float']['input']>;
  /** 随机最大金额 */
  rangeUpperBound?: InputMaybe<Scalars['Float']['input']>;
  /** 按分数段规则是否启用 */
  redEnvelopeRulesEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** 按分数段规则 */
  redEnvelopeScoreRule?: InputMaybe<RedEnvelopeScoreRuleAttributes>;
  /** 限领频率类型 */
  redeemFrequency?: InputMaybe<RedEnvelopeRedeemFrequency>;
  /** 填表时是否展示红包弹窗 */
  showRedEnvelopPopup?: InputMaybe<Scalars['Boolean']['input']>;
  /** 是否随机金额 */
  useRandomAmount?: InputMaybe<Scalars['Boolean']['input']>;
  /** 是否在自定义范围内随机 */
  useRandomAmountInRange?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EntrySms = Base & {
  /** 推送类型 */
  approach: Approach;
  cachedFormName: Scalars['String']['output'];
  /** 推送/短信/邮件内容 */
  content?: Maybe<Scalars['String']['output']>;
  entry?: Maybe<Entry>;
  /** 错误信息 */
  errorMessage?: Maybe<Scalars['String']['output']>;
  form?: Maybe<Form>;
  id: Scalars['ID']['output'];
  messageCount: Scalars['Int']['output'];
  /** 发送时间（不等于任务触发时间） */
  performedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** 收件人，常用于短信和邮件 */
  recipient?: Maybe<Scalars['String']['output']>;
  /** 状态 */
  status: Status;
};

/** The connection type for EntrySMS. */
export type EntrySmsConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<EntrySmsEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<EntrySms>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type EntrySmsEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<EntrySms>;
};

export type EntrySmsTaskEntrySmsTemplateApprovedWithAutosendActivity = {
  formInfo: FormActivityBaseInfo;
  /** 短信任务ID */
  targetId: Scalars['ID']['output'];
};

export type EntrySmsTaskEntrySmsTemplateApprovedWithoutAutosendActivity = {
  formInfo: FormActivityBaseInfo;
  /** 短信任务ID */
  targetId: Scalars['ID']['output'];
};

export type EntrySmsTaskAttributes = {
  /** 是否自动发送 */
  autoSend?: InputMaybe<Scalars['Boolean']['input']>;
  /** 为 true 时表示已撤回 */
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** 数据筛选条件 */
  entriesFilter?: InputMaybe<EntriesFilterAttributes>;
  /** 发送的手机字段 */
  entryField?: InputMaybe<Scalars['String']['input']>;
  /** 表单id */
  formId?: InputMaybe<Scalars['ID']['input']>;
  /** 模板字段插入列表，按照插入顺序排列 */
  placeholderKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  /** 为 true 表示撤销正生审核内容的发送 */
  revoked?: InputMaybe<Scalars['Boolean']['input']>;
  /** 指定发送时间，当send_timing为on_specified_datetime生效 */
  sendAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** 何时发送 */
  sendTiming?: InputMaybe<SendTiming>;
  /** 短信模板id（非云片id，而是模型id） */
  smsTemplateId?: InputMaybe<Scalars['ID']['input']>;
};

export type EntrySmsTaskAuditFailureActivity = {
  formInfo: FormActivityBaseInfo;
  /** 短信任务ID */
  targetId: Scalars['ID']['output'];
};

export type EntrySmsTaskFailActivity = {
  formInfo: FormActivityBaseInfo;
  /** 短信任务ID */
  targetId: Scalars['ID']['output'];
};

export enum EntrySmsTaskSendStatus {
  AllSent = 'all_sent',
  NoneSent = 'none_sent',
  PartialSent = 'partial_sent',
  Sending = 'sending',
  TemplateChecking = 'template_checking',
  TemplateDeleted = 'template_deleted',
  TemplateFail = 'template_fail',
  WaitingForSend = 'waiting_for_send'
}

/** Entry SMS Task status counts */
export type EntrySmsTaskStatusCounts = {
  /** Translation missing: en.tasks.status.all_sent */
  allSentCount: Scalars['Int']['output'];
  /** Translation missing: en.tasks.status.none_sent */
  noneSentCount: Scalars['Int']['output'];
  /** Translation missing: en.tasks.status.partial_sent */
  partialSentCount: Scalars['Int']['output'];
  /** Translation missing: en.tasks.status.sending */
  sendingCount: Scalars['Int']['output'];
  /** Translation missing: en.tasks.status.template_checking */
  templateCheckingCount: Scalars['Int']['output'];
  /** Translation missing: en.tasks.status.template_deleted */
  templateDeletedCount: Scalars['Int']['output'];
  /** Translation missing: en.tasks.status.template_fail */
  templateFailCount: Scalars['Int']['output'];
  /** 总任务数量 */
  totalCount: Scalars['Int']['output'];
  /** Translation missing: en.tasks.status.waiting_for_send */
  waitingForSendCount: Scalars['Int']['output'];
};

export type EntrySmsTaskType = {
  /** 发送结果 */
  activities: EntryTaskActivityConnection;
  /** 发送结果统计 */
  allSendStatusWithCount: Scalars['JSON']['output'];
  /** 是否自动发送 */
  autoSend: Scalars['Boolean']['output'];
  /** 发送内容 */
  content?: Maybe<Scalars['String']['output']>;
  /** 创建时间 */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** 是否禁用 */
  disabled: Scalars['Boolean']['output'];
  /** 目标数据量 */
  entriesCount: Scalars['Int']['output'];
  /** 发送的字段 */
  entryField: Scalars['String']['output'];
  /** 失败原因 */
  failedReason?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** 模板字段插入列表，按照插入顺序排列 */
  placeholderKeys: Array<Scalars['String']['output']>;
  /** 已发送数量 */
  publicActivitiesCount: Scalars['Int']['output'];
  /** 预览显示待发送人（仅显示前 3 个） */
  sampleRecipients?: Maybe<Array<Scalars['String']['output']>>;
  /** 发送时间 */
  sendAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** 何时发送 */
  sendTiming: SendTiming;
  /** 实际发送时间 */
  sentAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** 短信签名 */
  signature?: Maybe<Scalars['String']['output']>;
  /** 短信模板 */
  smsTemplate?: Maybe<SmsTemplate>;
  /** 发送状态 */
  status: SmsTaskStatusEnum;
  /** 待发送数量 */
  totalActivities: Scalars['Int']['output'];
  /** 更新时间 */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};


export type EntrySmsTaskTypeActivitiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<TaskActivityStatusEnum>;
};

/** The connection type for EntrySmsTaskType. */
export type EntrySmsTaskTypeConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<EntrySmsTaskTypeEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<EntrySmsTaskType>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type EntrySmsTaskTypeEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<EntrySmsTaskType>;
};

export enum EntrySubmitMode {
  /** Exam score */
  ExamScore = 'exam_score',
  /** Redirect */
  Redirect = 'redirect',
  /** Reports */
  Reports = 'reports',
  /** Show message */
  ShowMessage = 'show_message'
}

export type EntrySubmitter = {
  entry: Entry;
  form: Form;
};

/** The connection type for EntrySubmitter. */
export type EntrySubmitterConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<EntrySubmitterEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<EntrySubmitter>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type EntrySubmitterEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<EntrySubmitter>;
};

export type EntryTaskActivity = {
  createdAt: Scalars['ISO8601DateTime']['output'];
  entry?: Maybe<Entry>;
  form?: Maybe<Form>;
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  owner?: Maybe<PublishedUser>;
  parameters?: Maybe<Scalars['JSON']['output']>;
  trackableId?: Maybe<Scalars['String']['output']>;
};

/** The connection type for EntryTaskActivity. */
export type EntryTaskActivityConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<EntryTaskActivityEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<EntryTaskActivity>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type EntryTaskActivityEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<EntryTaskActivity>;
};

export type Error = {
  code?: Maybe<Scalars['Int']['output']>;
  details?: Maybe<Scalars['JSON']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  path?: Maybe<Array<Scalars['String']['output']>>;
};

export enum EvaluationBackgroundMode {
  /** Customize */
  Customize = 'customize',
  /** Follow form */
  FollowForm = 'follow_form',
  /** Recommendation */
  Recommendation = 'recommendation'
}

export enum EvaluationNoticeAfterFillingMode {
  /** Customize */
  Customize = 'customize',
  /** None */
  None = 'none',
  /** Reports */
  Reports = 'reports'
}

export type EvaluationReportBackground = {
  /** 报告背景模式为customize时的自定义颜色 */
  backgroundColor?: Maybe<Scalars['String']['output']>;
  /** 报告背景模式: recommendation - 系统推荐背景, follow_form - 跟随表单背景, customize - 自定义背景 */
  backgroundMode: EvaluationBackgroundMode;
};

export type EvaluationSetting = EvaluationReportBackground & Examination & {
  /** 防作弊设置 */
  antiCheatingSetting?: Maybe<AntiCheatingSetting>;
  /** 报告背景模式为customize时的自定义颜色 */
  backgroundColor?: Maybe<Scalars['String']['output']>;
  /** 报告背景模式: recommendation - 系统推荐背景, follow_form - 跟随表单背景, customize - 自定义背景 */
  backgroundMode: EvaluationBackgroundMode;
  /** 根据测评分数显示不同文案是否开启。true - 开启；false - 关闭 */
  enableEvaluationComments: Scalars['Boolean']['output'];
  /** 根据测评分数显示的不同文案 */
  evaluationCommentSettings?: Maybe<Array<ExamCommentSetting>>;
  /** 维度设置 */
  indicatorSetting?: Maybe<IndicatorSetting>;
  /** 测评限时。单位：分钟 */
  limitedTime: Scalars['Int']['output'];
  /** 最大题目数量。 */
  maximumRandomNum?: Maybe<Scalars['Int']['output']>;
  /** 测评须知提示内容 */
  needAttention?: Maybe<Scalars['String']['output']>;
  /** 提交测评后的展示。reports - 显示测评报告；custom - 自定义样式； */
  noticeAfterFillingMode: EvaluationNoticeAfterFillingMode;
  /** 随机出题-按题型抽取。题型设置 */
  questionSettings?: Maybe<Array<QuestionSetting>>;
  /** 题型列表 */
  questionTypeList?: Maybe<Array<QuestionSetting>>;
  /** 随机出题是否开启。true - 开启；false - 关闭 */
  randomQuestions?: Maybe<Scalars['Boolean']['output']>;
  /** 随机出题-从所有题目中抽取。抽取题目数量 */
  randomQuestionsCount?: Maybe<Scalars['Int']['output']>;
  /** 随机出题是否打乱题目顺序。true - 打乱顺序；false - 不打乱顺序 */
  randomQuestionsOrder?: Maybe<Scalars['Boolean']['output']>;
  /** 随机出题-按题型抽取是否开启。true - 开启；false - 关闭 */
  randomQuestionsWithType?: Maybe<Scalars['Boolean']['output']>;
  /** 是否展示测评评语 */
  showComments: Scalars['Boolean']['output'];
  /** 是否展示测评须知。true - 展示；false - 不展示 */
  showDispatcherStructure: Scalars['Boolean']['output'];
  /** 是否展示测评结果分析（各维度结果与建议） */
  showIndicatorComments: Scalars['Boolean']['output'];
  /** 是否展示题目结构。true - 展示；false - 不展示 */
  showQuestionSettingsStructure: Scalars['Boolean']['output'];
  /** 是否展示测评结果雷达图 */
  showReportRadar: Scalars['Boolean']['output'];
  /** 是否展示测评结果得分 */
  showReportScore: Scalars['Boolean']['output'];
  /** 是否展示测评结果（包含得分和各维度得分雷达图） */
  showReports: Scalars['Boolean']['output'];
  /** 限时答题是否开启。true - 开启；false - 关闭 */
  showTimeout: Scalars['Boolean']['output'];
  /** 开始答题按钮文案 */
  startToAnswerButtonText?: Maybe<Scalars['String']['output']>;
  /** 提交后显示的感谢参与文案 */
  successMessageRichText?: Maybe<Scalars['String']['output']>;
};

export type ExamCommentSetting = Recommendation & {
  /** 文案内容 */
  comment?: Maybe<Scalars['String']['output']>;
  /** 分数区间右端点 */
  endPoint?: Maybe<Scalars['Float']['output']>;
  /** 是否开启再填一次。true - 开启；false - 关闭 */
  retry?: Maybe<Scalars['Boolean']['output']>;
  /** 分数区间左端点 */
  startPoint?: Maybe<Scalars['Float']['output']>;
};

export enum ExamNoticeAfterFillingMode {
  /** Answer */
  Answer = 'answer',
  /** Appreciation */
  Appreciation = 'appreciation',
  /** Explaination */
  Explaination = 'explaination',
  /** Grade */
  Grade = 'grade',
  /** None */
  None = 'none'
}

export type ExamSetting = Examination & {
  /** 防作弊设置 */
  antiCheatingSetting?: Maybe<AntiCheatingSetting>;
  /** 根据考试分数显示不同文案是否开启。true - 开启；false - 关闭 */
  enableExamComments: Scalars['Boolean']['output'];
  /** 根据考试分数显示不同文案是否开启。true - 开启；false - 关闭 */
  enableIntervalComments: Scalars['Boolean']['output'];
  /** 根据考试分数显示的不同文案 */
  examCommentSettings?: Maybe<Array<ExamCommentSetting>>;
  /** 根据考试分数显示的不同文案 */
  intervalCommentSettings?: Maybe<Array<IntervalCommentSetting>>;
  /** 考试限时。单位：分钟 */
  limitedTime: Scalars['Int']['output'];
  /** 最大题目数量。 */
  maximumRandomNum?: Maybe<Scalars['Int']['output']>;
  /** 考前须知提示内容 */
  needAttention?: Maybe<Scalars['String']['output']>;
  /** 提交试卷后的展示。appreciation - 显示感谢参与文案（已弃用）；grade - 显示考试成绩；explaination - 显示考试成绩和答案解析；answer - 仅展示对错 */
  noticeAfterFillingMode: ExamNoticeAfterFillingMode;
  /** 随机出题-按题型抽取。题型设置 */
  questionSettings?: Maybe<Array<QuestionSetting>>;
  /** 题型列表 */
  questionTypeList?: Maybe<Array<QuestionSetting>>;
  /** 随机出题是否开启。true - 开启；false - 关闭 */
  randomQuestions?: Maybe<Scalars['Boolean']['output']>;
  /** 随机出题-从所有题目中抽取。抽取题目数量 */
  randomQuestionsCount?: Maybe<Scalars['Int']['output']>;
  /** 随机出题是否打乱题目顺序。true - 打乱顺序；false - 不打乱顺序 */
  randomQuestionsOrder?: Maybe<Scalars['Boolean']['output']>;
  /** 随机出题-按题型抽取是否开启。true - 开启；false - 关闭 */
  randomQuestionsWithType?: Maybe<Scalars['Boolean']['output']>;
  /** 是否展示考前须知。true - 展示；false - 不展示 */
  showDispatcherStructure: Scalars['Boolean']['output'];
  /** 是否展示题目结构。true - 展示；false - 不展示 */
  showQuestionSettingsStructure: Scalars['Boolean']['output'];
  /** 限时答题是否开启。true - 开启；false - 关闭 */
  showTimeout: Scalars['Boolean']['output'];
  /** 开始答题按钮文案 */
  startToAnswerButtonText?: Maybe<Scalars['String']['output']>;
  /** 提交后显示的感谢参与文案 */
  successMessageRichText?: Maybe<Scalars['String']['output']>;
};

export type Examination = {
  /** 防作弊设置 */
  antiCheatingSetting?: Maybe<AntiCheatingSetting>;
  /** 题型列表 */
  questionTypeList?: Maybe<Array<QuestionSetting>>;
  /** 随机出题是否开启。true - 开启；false - 关闭, 可能为NULL */
  randomQuestions?: Maybe<Scalars['Boolean']['output']>;
  /** 随机出题是否打乱题目顺序。true - 打乱顺序；false - 不打乱顺序 */
  randomQuestionsOrder?: Maybe<Scalars['Boolean']['output']>;
  /** 限时答题是否开启。true - 开启；false - 关闭 */
  showTimeout: Scalars['Boolean']['output'];
};

/** Autogenerated input type of ExecuteFormImportJob */
export type ExecuteFormImportJobInput = {
  attributes: FormImportJobUpdateAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of ExecuteFormImportJob */
export type ExecuteFormImportJobPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  result?: Maybe<FormImportJobExecutionResult>;
};

export type ExpiredNoticed = {
  /** true - 已通知，false - 未通知 */
  expiredNoticed?: Maybe<Scalars['Boolean']['output']>;
};

export enum ExportJobSheetFormatType {
  Csv = 'csv',
  Excel = 'excel',
  Spss = 'spss'
}

export enum ExportJobStatusType {
  Failed = 'failed',
  Running = 'running',
  Success = 'success'
}

export type ExportJobType = {
  /** 导出任务附件下载链接 */
  downloadUrl?: Maybe<Scalars['String']['output']>;
  /**
   * 导出任务状态（不包含附件打包）
   * @deprecated 请使用 status
   */
  entryExportStatus: EntryExportStatus;
  /** 预估的剩余时长 */
  estimateLeft?: Maybe<Scalars['Int']['output']>;
  /** 导出任务进度（0-100） */
  estimatedProgress?: Maybe<Scalars['Int']['output']>;
  /** ID */
  id: Scalars['ID']['output'];
  /** 失败原因 */
  reason?: Maybe<Scalars['String']['output']>;
  /** 导出任务状态（包含附件打包），数据页面导出请使用这个状态 */
  status: ExportJobStatusType;
};

export type ExtendedAttributeFilter = {
  /** 是否使用自定义域名 */
  cname: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** 扩展值 */
  value: Scalars['String']['output'];
};

export type ExtendedAttributeFilterAttributes = {
  /** 是否使用自定义域名 */
  cname?: InputMaybe<Scalars['Boolean']['input']>;
  /** 扩展值 */
  value: Scalars['String']['input'];
};

/** The connection type for ExtendedAttributeFilter. */
export type ExtendedAttributeFilterConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ExtendedAttributeFilterEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ExtendedAttributeFilter>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ExtendedAttributeFilterEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ExtendedAttributeFilter>;
};

export type ExtraConfigurableFormSetting = CertificateSetting | EvaluationSetting | ExamSetting | RegistrySetting;

/** 场景化可配置字段设置 */
export type ExtraConfigurableSetting = {
  /** 场景化可配置字段设置 */
  extraConfigurableSettings?: Maybe<FieldExtraConfigurableSettings>;
};

export type ExtraConfigurableSettingAttributes = {
  /** 答案解析 */
  answerExplanation?: InputMaybe<Scalars['String']['input']>;
  /** 唯一正确，部分正确或者赋值 */
  answerSettingMode?: InputMaybe<AnswerSettingMode>;
  /** 题目区的样式大小（例如横向填空的长度） */
  answerSize?: InputMaybe<Scalars['Int']['input']>;
  /** 答案 */
  answers?: InputMaybe<Array<AnswerAttributes>>;
  /** 全部答对得分或答对几个得几分 */
  dimensionsScoringMode?: InputMaybe<DimensionsScoringMode>;
  /** 开启答案解析 */
  enableAnswerExplanation?: InputMaybe<Scalars['Boolean']['input']>;
  /** 题目总分 */
  score?: InputMaybe<Scalars['Float']['input']>;
  /** 场景化可配置字段设置类型 */
  type: ExtraConfigurableSettingClass;
};

export enum ExtraConfigurableSettingClass {
  AnswerBank = 'AnswerBank',
  DimensionsAnswerBank = 'DimensionsAnswerBank'
}

export type Extrainfo = {
  /** 是否已查看NEXT欢迎页 */
  nextWelcomeViewed: Scalars['Boolean']['output'];
  /** 是否体验过小金商户助手的收款页 */
  tradeWeixinAppPaymentFormExperienced: Scalars['Boolean']['output'];
  /** 用户对新版表格的显式选择：nil=未选，true=opt in，false=opt out */
  useDataTables?: Maybe<Scalars['Boolean']['output']>;
  /** 是否切换到NEXT */
  useNextUi: Scalars['Boolean']['output'];
};

export type FeatureTrialAttributes = {
  /** 联系人手机 */
  contactMobile?: InputMaybe<Scalars['String']['input']>;
  /** 联系人姓名 */
  contactName?: InputMaybe<Scalars['String']['input']>;
  /** 创建来源地址或其他信息 */
  createFrom?: InputMaybe<Scalars['String']['input']>;
  /** 创建来源 */
  createdFrom?: InputMaybe<FeatureTrialsCreatedFrom>;
  /** true - 已通知，false - 未通知 */
  expiredNoticed?: InputMaybe<Scalars['Boolean']['input']>;
  /** 企业名称 */
  name?: InputMaybe<Scalars['String']['input']>;
  /** 想要体验的功能 */
  trialFeatureReasons?: InputMaybe<Array<Scalars['String']['input']>>;
  /** 试用类型 */
  trialType?: InputMaybe<FeatureTrialType>;
  /** 验证码 */
  verificationCode?: InputMaybe<Scalars['String']['input']>;
};

export type FeatureTrialInfo = ExpiredNoticed & {
  endDate?: Maybe<Scalars['Date']['output']>;
  /** true - 已通知，false - 未通知 */
  expiredNoticed?: Maybe<Scalars['Boolean']['output']>;
  /** 微信一次性消息发送量 */
  onetimeCount?: Maybe<Scalars['Int']['output']>;
  /** 试用结束后的推荐套餐 */
  recommendUpgradePlan?: Maybe<Plan>;
  /** 用于判断用户是否可以发起一次试用，true - 弹出start_feature_trial modal */
  showE30FeatureTrial: Scalars['Boolean']['output'];
  /** 用于判断用户是否可以发起二次试用，true - 弹出contact_sales_modal modal */
  showMoreE30FeatureTrial: Scalars['Boolean']['output'];
  /** 试用来源 */
  source?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['Date']['output']>;
  status?: Maybe<FeatureTrialStatus>;
  trialType?: Maybe<FeatureTrialType>;
};

export enum FeatureTrialStatus {
  Ended = 'ended',
  InUse = 'in_use',
  Interrupted = 'interrupted',
  NotStarted = 'not_started'
}

export enum FeatureTrialType {
  DproTrial = 'dpro_trial',
  E30Trial = 'e30_trial',
  Ent2Trial = 'ent2_trial'
}

export enum FeatureTrialsCreatedFrom {
  /** 系统设置-套餐概览 */
  SystemProfile = 'system_profile',
  /** 模板中心 */
  TemplateCenter = 'template_center'
}

export type Field = AddressField | AttachmentField | AudioField | Carousel | CascadeDropDown | CheckBox | DateTimeField | Divider | DropDown | ESignatureField | EmailField | FormAssociation | FormulaField | GeoField | GoodsField | IdCardField | ImageCheckBox | ImageGroup | ImageRadioButton | ImageText | LikertField | LinkField | MatrixField | MatrixScaleField | MobileField | MultipleBlanksField | NameField | NotImplementedField | NpsField | NumberField | PageBreak | RadioButton | RatingField | ReservationField | ReversedAssociation | SectionBreak | SortField | StyledText | TableField | TelephoneField | TextArea | TextField | TimeField | Timer | WidgetButton | WidgetContact | WidgetMap | WidgetMarquee | WidgetVideo;

export type FieldAbility = {
  hasAbility: Scalars['Boolean']['output'];
};


export type FieldAbilityHasAbilityArgs = {
  key: FieldAbilityEnum;
};

export enum FieldAbilityEnum {
  AdvancedNotifiableForUpdate = 'advanced_notifiable_for_update',
  Aggregatable = 'aggregatable',
  Associable = 'associable',
  AttachmentExportNameable = 'attachment_export_nameable',
  AttachmentExportable = 'attachment_exportable',
  BulkEditable = 'bulk_editable',
  Calculable = 'calculable',
  CaseInsensitive = 'case_insensitive',
  ConditionalScopeTriggerable = 'conditional_scope_triggerable',
  FieldQuotable = 'field_quotable',
  FieldRuleAvailable = 'field_rule_available',
  GenCodeElementable = 'gen_code_elementable',
  GenCodeFieldable = 'gen_code_fieldable',
  InBulkEditFieldList = 'in_bulk_edit_field_list',
  KanbanGroupable = 'kanban_groupable',
  LabelBlankable = 'label_blankable',
  NewReportable = 'new_reportable',
  Payable = 'payable',
  PivotReportable = 'pivot_reportable',
  Printable = 'printable',
  PrivacyProtectable = 'privacy_protectable',
  PublishSearchable = 'publish_searchable',
  Quotable = 'quotable',
  ReportLevelSwitchable = 'report_level_switchable',
  Reportable = 'reportable',
  ShownOnly = 'shown_only',
  Sortable = 'sortable',
  SuccessRedirectAvailable = 'success_redirect_available',
  TextPlaceholderable = 'text_placeholderable',
  TextSearchable = 'text_searchable'
}

export type FieldAttributes = {
  /** 黑白名单类型，默认为白名单 */
  accessControlType?: InputMaybe<AccessControlType>;
  /** 黑白名单列表 */
  accessControlValues?: InputMaybe<Array<Scalars['String']['input']>>;
  /** 允许预约多个项目 */
  allowMultipleItems?: InputMaybe<Scalars['Boolean']['input']>;
  /** 单次预约可选择多个名额 */
  allowMultipleNumber?: InputMaybe<Scalars['Boolean']['input']>;
  /** 是否允许反向关联 */
  allowReverseAssociation?: InputMaybe<Scalars['Boolean']['input']>;
  /** 字段apiCode，新字段不传或传null */
  apiCode?: InputMaybe<Scalars['ID']['input']>;
  /** 显示年龄 */
  asAge?: InputMaybe<Scalars['Boolean']['input']>;
  /** 被关联字段的apiCodes */
  associatedFieldApiCodes?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** 被关联字段的设置属性 */
  associatedFieldSettings?: InputMaybe<Array<AssociatedFieldSettingAttributes>>;
  /** 被关联表单的token */
  associatedFormToken?: InputMaybe<Scalars['ID']['input']>;
  /** 背景样式 */
  backgroundStyle?: InputMaybe<WidgetsdBackgroundStyleAttributes>;
  /** 描述字段按钮文字 */
  buttonText?: InputMaybe<Scalars['String']['input']>;
  /** 按钮集 */
  buttons?: InputMaybe<Array<WidgetsButtonItemAttributes>>;
  /** 按钮数量 */
  buttonsNumber?: InputMaybe<Scalars['Int']['input']>;
  /** 自动填写上次提交内容 */
  cacheData?: InputMaybe<Scalars['Boolean']['input']>;
  /** 开启选项赋值 */
  calculable?: InputMaybe<Scalars['Boolean']['input']>;
  /** 地址项是否可输入 */
  changeable?: InputMaybe<AddressChangeableAttributes>;
  /** 允许填表者搜索选项 */
  choiceFilterable?: InputMaybe<Scalars['Boolean']['input']>;
  /** 选项列表 */
  choices?: InputMaybe<Array<FieldChoiceAttributes>>;
  /** 选项排列方式 */
  choicesLayout?: InputMaybe<ChoicesLayout>;
  /** 客户端cid */
  cid?: InputMaybe<Scalars['String']['input']>;
  /** 在手机上默认折叠显示 */
  collapseOnMobile?: InputMaybe<Scalars['Boolean']['input']>;
  /** 分节颜色 */
  color?: InputMaybe<Scalars['String']['input']>;
  /** 手机端展示列数（1列或2列） */
  columnsOnMobile?: InputMaybe<Scalars['Int']['input']>;
  /** 设置数据范围 */
  conditionalScope?: InputMaybe<Scalars['Boolean']['input']>;
  /** 下一页等待时间，单位秒 */
  countDown?: InputMaybe<Scalars['Int']['input']>;
  /** 字段格式验证自定义正则表达式 */
  customValidationRegex?: InputMaybe<Scalars['String']['input']>;
  /** 封装的字段类型 */
  customizedType?: InputMaybe<Scalars['String']['input']>;
  /** 自定义出错文案 */
  customizedValidationMessage?: InputMaybe<Scalars['String']['input']>;
  /** 项目 */
  dimensions?: InputMaybe<Array<TabularDimensionAttributes>>;
  /** 禁止返回上一页 */
  disablePreviousPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** 显示百分比 */
  displayAsPercentage?: InputMaybe<Scalars['Boolean']['input']>;
  /** 显示实时投票数量 */
  displayEntryCountsPerChoice?: InputMaybe<Scalars['Boolean']['input']>;
  /** 被关联展示字段的设置属性 */
  displayFieldSettings?: InputMaybe<Array<AssociatedDisplayFieldSettingAttributes>>;
  /** 开启年龄限制 */
  enableAgeScope?: InputMaybe<Scalars['Boolean']['input']>;
  /** 是否开启自动定位 */
  enableAutoPosition?: InputMaybe<Scalars['Boolean']['input']>;
  /** 结束日期 */
  endDate?: InputMaybe<Scalars['Any']['input']>;
  /** 倒计时的结束时间 */
  endTime?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** 填写人数初始值 */
  entriesInitNumber?: InputMaybe<Scalars['Int']['input']>;
  /** 显示填写人数 */
  entriesNumberVisible?: InputMaybe<Scalars['Boolean']['input']>;
  /** 排他选项的ApiCodes */
  exclusiveChoiceApiCodes?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** 场景化可配置其他设置 */
  extraConfigurableSettings?: InputMaybe<ExtraConfigurableSettingAttributes>;
  /** 展示字段样式 */
  fieldStyle?: InputMaybe<DisplayFieldsStyledFieldStyleAttributes>;
  /** 固定在底部 */
  fixedToBottom?: InputMaybe<Scalars['Boolean']['input']>;
  /** 字段格式验证类型 */
  formatValidationType?: InputMaybe<FieldValidation>;
  /** 以字段标题为变量的公式 */
  formulaDisplay?: InputMaybe<Scalars['String']['input']>;
  /** 商品列表 */
  goodsItems?: InputMaybe<Array<GoodsItemAttributes>>;
  /** 商品优惠方式 */
  goodsPreferentialCase?: InputMaybe<GoodsPreferentialCaseAttributes>;
  /** 商品优惠类型 */
  goodsPreferentialType?: InputMaybe<GoodsPreferentialTypeAttributes>;
  /** 宽度占用整行的四分之几 */
  gridsToOccupy?: InputMaybe<Scalars['Int']['input']>;
  /** 描述字段是否显示按钮。true - 不显示，false - 显示，默认不显示 */
  hideButton?: InputMaybe<Scalars['Boolean']['input']>;
  /** 选项名额为空时隐藏选项 */
  hideChoiceWhenQuotaEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  /** 不向填表者展示选项名额剩余数字 */
  hideQuota?: InputMaybe<Scalars['Boolean']['input']>;
  /** 在手机上横向展示 */
  horizontalOnMobile?: InputMaybe<Scalars['Boolean']['input']>;
  /** 用户选择的字段图标 */
  iconType?: InputMaybe<Scalars['String']['input']>;
  /** 图文介绍组件 */
  imageTextItems?: InputMaybe<Array<DisplayFieldsImageTextItemAttributes>>;
  /** 图文介绍-组件数量 */
  imageTextItemsCount?: InputMaybe<Scalars['Int']['input']>;
  /** 图片展示、轮播图的图片 */
  images?: InputMaybe<Array<DisplayFieldsFieldItemImageAttributes>>;
  /** 图片展示-图片数量 */
  imagesCount?: InputMaybe<Scalars['Int']['input']>;
  /** 精确到秒 */
  includeSecond?: InputMaybe<Scalars['Boolean']['input']>;
  /** 表格默认行数 */
  initRowLength?: InputMaybe<Scalars['Int']['input']>;
  /** 库存文案 */
  inventoryLabel?: InputMaybe<Scalars['String']['input']>;
  /** 删除数据后，库存余量自动恢复 */
  inventoryRecoverable?: InputMaybe<Scalars['Boolean']['input']>;
  /** 单项目允许预约多个时段 */
  itemAllowMultipleReservations?: InputMaybe<Scalars['Boolean']['input']>;
  /** 字段标题 */
  label: Scalars['String']['input'];
  /** 纬度 */
  latitude?: InputMaybe<Scalars['String']['input']>;
  /** 展示字段样式 */
  layout?: InputMaybe<DisplayFieldLayout>;
  /** 下拉框级数 */
  levels?: InputMaybe<Scalars['Int']['input']>;
  /** 展示样式，单选或者多选 */
  likertChoiceStyle?: InputMaybe<LikertChoiceStyle>;
  /** 显示行数 */
  lines?: InputMaybe<Scalars['Int']['input']>;
  /** 允许填写者在手机上自行标注位置 */
  localizableOnMobile?: InputMaybe<Scalars['Boolean']['input']>;
  /** 经度 */
  longitude?: InputMaybe<Scalars['String']['input']>;
  /** 跑马灯数据类型 */
  marqueeDataType?: InputMaybe<Scalars['String']['input']>;
  /** 跑马灯文字样式 */
  marqueeStyle?: InputMaybe<WidgetsdBaseTextStyleAttributes>;
  /** 最大年龄限制 */
  maxAge?: InputMaybe<Scalars['Int']['input']>;
  /** 最大时长, 分钟 */
  maxDuration?: InputMaybe<Scalars['Int']['input']>;
  /** 最大文件数量 */
  maxFileQuantity?: InputMaybe<Scalars['Int']['input']>;
  /** 单个文件最大体积, MB */
  maxSize?: InputMaybe<Scalars['Float']['input']>;
  /** 最多填几个字 */
  maximumLength?: InputMaybe<Scalars['BigInteger']['input']>;
  /** 最高分文案 */
  maximumRatingsDisplayText?: InputMaybe<Scalars['String']['input']>;
  /** 文件上传类型 */
  mediaType?: InputMaybe<AttachmentFieldMediaTypeAttributes>;
  /** 由下拉框变化而来 */
  migratedFromDropDown?: InputMaybe<Scalars['Boolean']['input']>;
  /** 最小年龄限制 */
  minAge?: InputMaybe<Scalars['Int']['input']>;
  /** 最少填几个字 */
  minimumLength?: InputMaybe<Scalars['BigInteger']['input']>;
  /** 最低分文案 */
  minimumRatingsDisplayText?: InputMaybe<Scalars['String']['input']>;
  /** 仅限手机拍照或现场视频上传 */
  mobileCameraOnly?: InputMaybe<Scalars['Boolean']['input']>;
  /** 导航地址 */
  navAddress?: InputMaybe<Scalars['String']['input']>;
  /** 下一页按钮文字 */
  nextPageText?: InputMaybe<Scalars['String']['input']>;
  /** 字段描述 */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** 分节上下间距 */
  padding?: InputMaybe<Scalars['Int']['input']>;
  /** 电话集 */
  phones?: InputMaybe<Array<WidgetsPhoneFieldAttributes>>;
  /** 占位符 */
  placeholder?: InputMaybe<Scalars['String']['input']>;
  /** 字段排序标识 */
  position: Scalars['Int']['input'];
  /** 小数位数 或 日期精度 */
  precision?: InputMaybe<Scalars['Any']['input']>;
  /** 默认值 */
  predefinedValue?: InputMaybe<Scalars['Any']['input']>;
  /** 展示样式，列表排列或下拉框排列 */
  presentationStyle?: InputMaybe<CheckBoxPresentationStyle>;
  /** 上一页按钮文字 */
  previousPageText?: InputMaybe<Scalars['String']['input']>;
  /** 表单关联开启隐私保护 */
  privacySafe?: InputMaybe<Scalars['Boolean']['input']>;
  /** 字段隐藏 */
  private?: InputMaybe<Scalars['Boolean']['input']>;
  /** 自定义选择默认文案 */
  prompt?: InputMaybe<Scalars['String']['input']>;
  /** 自定义选择默认文案 */
  prompts?: InputMaybe<Scalars['JSON']['input']>;
  /** 剩余名额为0时，显示文案 */
  quotaBlankWarning?: InputMaybe<Scalars['String']['input']>;
  /** 选项名额重置频率 */
  quotaCycleRule?: InputMaybe<QuotaCycleRule>;
  /** 删除数据后，选项名额自动恢复 */
  quotaRecoverable?: InputMaybe<Scalars['Boolean']['input']>;
  /** 选项展示顺序随机 */
  randomChoices?: InputMaybe<Scalars['Boolean']['input']>;
  /** 最大值 */
  rangeMax?: InputMaybe<Scalars['Float']['input']>;
  /** 最小值 */
  rangeMin?: InputMaybe<Scalars['Float']['input']>;
  /** 评分量级 */
  ratingMax?: InputMaybe<Scalars['Int']['input']>;
  /** 评分外观 */
  ratingType?: InputMaybe<RatingTypeAttribute>;
  /** 预约项 */
  reservationItems?: InputMaybe<Array<ReservationItemAttributes>>;
  resultDisplayAsDate?: InputMaybe<Scalars['Boolean']['input']>;
  /** 反向关联的展示字段 */
  reverseDisplayFieldApiCodes?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** 扫码录入时截取部分字符的起始位置 */
  scanBegin?: InputMaybe<Scalars['BigInteger']['input']>;
  /** 扫码录入时截取部分字符的结束位置 */
  scanEnd?: InputMaybe<Scalars['BigInteger']['input']>;
  /** 微信扫码录入 */
  scannable?: InputMaybe<Scalars['Boolean']['input']>;
  /** 数据条件 */
  scopeConditions?: InputMaybe<Array<ScopeConditionAttributes>>;
  /** 字段提示较长时折叠展示 */
  showPartDescription?: InputMaybe<Scalars['Boolean']['input']>;
  /** 显示分割线 */
  showSplitLine?: InputMaybe<Scalars['Boolean']['input']>;
  /** 开启短信验证 */
  smsVerification?: InputMaybe<Scalars['Boolean']['input']>;
  /** 获取验证码前需填写图形验证码 */
  smsVerificationCaptcha?: InputMaybe<Scalars['Boolean']['input']>;
  /** 起始日期 */
  startDate?: InputMaybe<Scalars['Any']['input']>;
  /** 新起一行 */
  startNewRow?: InputMaybe<Scalars['Boolean']['input']>;
  /** 题目-选项对应的余额及设置 */
  statementChoiceQuotaAttributes?: InputMaybe<Array<StatementChoiceQuotaAttributes>>;
  /** 题目 */
  statements?: InputMaybe<Array<StatementAttributes>>;
  /** 分节样式 */
  style?: InputMaybe<DividerStyle>;
  /** 文字描述组件 */
  styledTextItems?: InputMaybe<Array<DisplayFieldsStyledTextItemAttributes>>;
  /** 文字描述-组件数量 */
  styledTextItemsCount?: InputMaybe<Scalars['Int']['input']>;
  /** 标题文字样式 */
  subjectStyle?: InputMaybe<WidgetsdBaseTextStyleAttributes>;
  /** 客户管理属性设置 */
  submitterFieldSetting?: InputMaybe<SubmitterFieldSettingAttributes>;
  /** 倒计时的自定义文案 */
  text?: InputMaybe<DisplayFieldsStyledTextContentAttributes>;
  /** 显示千位分隔符 */
  thousandsSeparator?: InputMaybe<Scalars['Boolean']['input']>;
  /** 扫码录入时截取部分字符 */
  trimmable?: InputMaybe<Scalars['Boolean']['input']>;
  /** 字段类型 */
  type: FieldClass;
  /** 库存单位文案 */
  unit?: InputMaybe<Scalars['String']['input']>;
  /** 是否使用时段表配置预约项目 */
  useDailyTimeRange?: InputMaybe<Scalars['Boolean']['input']>;
  /** 字段验证规则 */
  validations?: InputMaybe<Array<FieldValidation>>;
  /** 视频iframe代码 */
  videoEmbedCode?: InputMaybe<Scalars['String']['input']>;
  /** 边距 */
  videoPadding?: InputMaybe<Scalars['String']['input']>;
  /** 图片集 */
  widgetImages?: InputMaybe<Array<WidgetsFieldItemImageAttributes>>;
  /** 最大图片数量 */
  widgetMaxImagesNumber?: InputMaybe<Scalars['Int']['input']>;
  /** 开启排他选项 */
  withExclusiveChoice?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FieldChoiceAttributes = {
  /** 选择 - 是否需要输入框 */
  allowExtendedText?: InputMaybe<Scalars['Boolean']['input']>;
  /** 图片选项的attachment id */
  attachmentId?: InputMaybe<Scalars['ID']['input']>;
  /** 选项说明类型 */
  descriptionMode?: InputMaybe<DescribableItemMode>;
  /** 选项说明 - 文字说明 */
  descriptionText?: InputMaybe<Scalars['String']['input']>;
  /** 选项说明 - 链接说明 */
  descriptionUrl?: InputMaybe<Scalars['String']['input']>;
  /** 选择 - 输入框占位符文案 */
  extendedTextPlaceholder?: InputMaybe<Scalars['String']['input']>;
  /** 选择 - 输入框说明是否必填 */
  extendedTextRequired?: InputMaybe<Scalars['Boolean']['input']>;
  /** 选项隐藏 */
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  /** 选择 - 最多被选次数 */
  maximumFrequency?: InputMaybe<Scalars['Int']['input']>;
  /** 选项文字 */
  name: Scalars['String']['input'];
  /** 选项赋值，当可以使用计算字段时能设置 */
  operandValue?: InputMaybe<Scalars['Float']['input']>;
  /** 其他选项必填（实际是字段 validations 的 other_choice_presence） */
  otherChoicePresence?: InputMaybe<Scalars['Boolean']['input']>;
  /** 位置排序 */
  position?: InputMaybe<Scalars['Int']['input']>;
  /** 剩余名额 */
  quota?: InputMaybe<Scalars['BigInteger']['input']>;
  /** 名额设置 */
  quotaSetting?: InputMaybe<Scalars['BigInteger']['input']>;
  /** 默认选中 */
  selected?: InputMaybe<Scalars['Boolean']['input']>;
  /** 用户自定义选项说明扩展按钮文案 */
  showMoreDescriptionTip?: InputMaybe<Scalars['String']['input']>;
  /** 子选项 - CascadeDropDown */
  subChoices?: InputMaybe<Array<FieldChoiceAttributes>>;
  /** 选项类型 */
  type: ChoiceType;
  /** 选项值，新选项不传或传null */
  value?: InputMaybe<Scalars['ID']['input']>;
};

export enum FieldClass {
  AddressField = 'AddressField',
  AttachmentField = 'AttachmentField',
  AudioField = 'AudioField',
  Carousel = 'Carousel',
  CascadeDropDown = 'CascadeDropDown',
  CheckBox = 'CheckBox',
  DateTimeField = 'DateTimeField',
  Divider = 'Divider',
  DropDown = 'DropDown',
  ESignatureField = 'ESignatureField',
  EmailField = 'EmailField',
  FormAssociation = 'FormAssociation',
  FormulaField = 'FormulaField',
  GeoField = 'GeoField',
  GoodsField = 'GoodsField',
  IdCardField = 'IdCardField',
  ImageCheckBox = 'ImageCheckBox',
  ImageGroup = 'ImageGroup',
  ImageRadioButton = 'ImageRadioButton',
  ImageText = 'ImageText',
  LikertField = 'LikertField',
  LinkField = 'LinkField',
  MatrixField = 'MatrixField',
  MatrixScaleField = 'MatrixScaleField',
  MobileField = 'MobileField',
  MultipleBlanksField = 'MultipleBlanksField',
  NameField = 'NameField',
  NpsField = 'NpsField',
  NumberField = 'NumberField',
  PageBreak = 'PageBreak',
  RadioButton = 'RadioButton',
  RatingField = 'RatingField',
  ReservationField = 'ReservationField',
  ReversedAssociation = 'ReversedAssociation',
  SectionBreak = 'SectionBreak',
  SortField = 'SortField',
  StyledText = 'StyledText',
  TableField = 'TableField',
  TelephoneField = 'TelephoneField',
  TextArea = 'TextArea',
  TextField = 'TextField',
  TimeField = 'TimeField',
  Timer = 'Timer',
  WidgetButton = 'WidgetButton',
  WidgetContact = 'WidgetContact',
  WidgetMap = 'WidgetMap',
  WidgetMarquee = 'WidgetMarquee',
  WidgetVideo = 'WidgetVideo'
}

export type FieldCombination = {
  /** 查询条件-字段api_codes */
  fieldApiCodes: Array<Scalars['String']['output']>;
  /** 查询条件id */
  id?: Maybe<Scalars['ID']['output']>;
  /** 组内条件组合方式，支持and和or */
  operator: FieldCombinationOperator;
  /** 查询条件-需要验证手机号的字段api_codes */
  verificationFields: Array<Scalars['String']['output']>;
};

export type FieldCombinationAttributes = {
  /** 是否删除当前条件，true: 删除，false: 保留 */
  _destroy?: InputMaybe<Scalars['Boolean']['input']>;
  /** 查询条件-字段api_codes */
  fieldApiCodes: Array<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** 组内条件组合方式，支持and和or */
  operator?: InputMaybe<FieldCombinationOperator>;
  /** 查询条件-需要验证手机号的字段api_codes */
  verificationFields?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum FieldCombinationOperator {
  /** And */
  And = 'and',
  /** Or */
  Or = 'or'
}

/** The connection type for Field. */
export type FieldConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<FieldEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Field>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FieldDefinition = {
  /** 可以转换至的字段类型，null时请使用原字段类型的默认规则 */
  availableConversionTypes?: Maybe<Array<Scalars['String']['output']>>;
  /** 支持的字段功能 */
  availableFeatures?: Maybe<Array<FieldFeature>>;
  /** 支持的字段校验 */
  availableValidations?: Maybe<Array<FieldValidation>>;
  /** 不支持切换至的字段类型 */
  excludeConversionTypes?: Maybe<Array<FieldClass>>;
  /** 不支持的字段功能 */
  excludeFeatures?: Maybe<Array<FieldFeature>>;
  /** 不支持的字段校验 */
  excludeValidations?: Maybe<Array<FieldValidation>>;
  /** 字段实例，承载了字段的属性 */
  field: Field;
  /** 字段图标 */
  iconName: Scalars['String']['output'];
  /** 字段类型Key */
  type: Scalars['String']['output'];
  /** 字段类型名称 */
  typeName: Scalars['String']['output'];
};

/** An edge in a connection. */
export type FieldEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Field>;
};

export type FieldExtraConfigurableSettings = AnswerBank | DimensionsAnswerBank;

export enum FieldFeature {
  /** 上传文件-文件上传类型 */
  AttachmentMediaType = 'attachment_media_type',
  /** 描述字段-按钮自定义文案 */
  ButtonText = 'button_text',
  /** 自动填写上次提交内容 */
  CacheData = 'cache_data',
  /** 选项描述/说明 */
  ChoiceDescription = 'choice_description',
  /** 选项排他 */
  ChoiceExclusive = 'choice_exclusive',
  /** 允许填表者搜索选项 */
  ChoiceFilterable = 'choice_filterable',
  /** 选项名额 */
  ChoiceQuota = 'choice_quota',
  /** 选项模板 */
  ChoiceTemplates = 'choice_templates',
  /** 布局设置-排列方式 */
  ChoicesLayout = 'choices_layout',
  /** 字段类型切换 */
  Conversion = 'conversion',
  /** 默认选项 */
  DefaultChoice = 'default_choice',
  /** 分页字段-禁止返回上一页 */
  DisablePreviousPage = 'disable_previous_page',
  /** 显示百分比 */
  DisplayAsPercentage = 'display_as_percentage',
  /** 实时显示投票人数 */
  DisplayEntryCountsPerChoice = 'display_entry_counts_per_choice',
  /** 选项输入 */
  ExtendedText = 'extended_text',
  /** 「布局设置」的宽度占用整行的几分之几 */
  GridsToOccupy = 'grids_to_occupy',
  /** 描述字段-隐藏按钮 */
  HideButton = 'hide_button',
  /** 在手机上横向展示 */
  HorizontalOnMobile = 'horizontal_on_mobile',
  /** 矩阵选择-题型选择 */
  LikertChoiceStyle = 'likert_choice_style',
  /** 地理位置-允许填写者在手机上自行标注位置 */
  LocalizableOnMobile = 'localizable_on_mobile',
  /** 上传文件-最大文件数量 */
  MaxFileQuantity = 'max_file_quantity',
  /** 上传文件-单个文件最大体积 */
  MaxSize = 'max_size',
  /** 其他选项 */
  OtherChoice = 'other_choice',
  /** 选项模板 */
  PredefinedChoiceSets = 'predefined_choice_sets',
  /** 「布局设置」的展示样式 */
  PresentationStyle = 'presentation_style',
  /** 字段隐藏 */
  Private = 'private',
  /** 选项展示顺序随机 */
  RandomChoices = 'random_choices',
  /** 评分字段-量级 */
  RatingMax = 'rating_max',
  /** 评分字段-外观 */
  RatingType = 'rating_type',
  /** 微信扫码录入 */
  Scan = 'scan',
  /** 字段提示较长时折叠展示 */
  ShowPartDescription = 'show_part_description',
  /** 显示分割线 */
  ShowSplitLine = 'show_split_line',
  /** 短信签名 */
  SmsSignature = 'sms_signature',
  /** 开启短信验证 */
  SmsVerification = 'sms_verification',
  /** 获取验证码前需填写图形验证码 */
  SmsVerificationCaptcha = 'sms_verification_captcha',
  /** 显示千位分隔符 */
  ThousandsSeparator = 'thousands_separator'
}

export type FieldGroup = {
  collapsed: Scalars['Boolean']['output'];
  collapsible: Scalars['Boolean']['output'];
  fieldDefinitions: Array<FieldDefinition>;
  /** @deprecated 不能承载更加自由的字段配置，请使用 fieldDefinitions */
  fields: Array<Field>;
  helpDocument?: Maybe<HelpDocument>;
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

/** 展示字段的图片数量属性 */
export type FieldItemImageCount = {
  /** 图片展示、轮播图的图片数量 */
  imagesCount?: Maybe<Scalars['Int']['output']>;
};

export type FieldMeta = {
  /** 是否已被关联 */
  associated: Scalars['Boolean']['output'];
  /** 是否已有数据提交 */
  hasData: Scalars['Boolean']['output'];
  /** 该字段是否设置了字段规则: true - 是， false - 否 */
  hasFieldRuleTrigger: Scalars['Boolean']['output'];
  /** 该字段是否设置了跳转规则: true - 是， false - 否 */
  hasRedirectRuleTrigger: Scalars['Boolean']['output'];
  /** 字段被那些模块引用 */
  quotedBy: Array<FieldMetaTarget>;
  /** 是否已作为邀请人字段 */
  referred: Scalars['Boolean']['output'];
  /** 被表单设置使用 */
  settingOccupied: Scalars['Boolean']['output'];
  /** 被计算字段引用 */
  usedInFormula: Scalars['Boolean']['output'];
  /** 该字段是否被确认码引用 */
  usedInGenCode: Scalars['Boolean']['output'];
};


export type FieldMetaHasDataArgs = {
  checkExtendedText?: InputMaybe<Scalars['Boolean']['input']>;
  choiceType?: InputMaybe<FieldMetaChoiceType>;
  choiceValue?: InputMaybe<Scalars['ID']['input']>;
  goodsItemDimensionOptions?: InputMaybe<Scalars['JSON']['input']>;
  parentField?: InputMaybe<Scalars['ID']['input']>;
};

export enum FieldMetaChoiceType {
  /** 选项/商品 - DropDown, RadioButton, CheckBox, ImageRadioButton, ImageCheckBox, LikertField, SortField, GoodsField, ReservationField */
  Choice = 'choice',
  /** 项目 - MatrixField */
  Dimension = 'dimension',
  /** 一级选项 - CascadeDropDown */
  Level_1 = 'level_1',
  /** 二级选项 - CascadeDropDown */
  Level_2 = 'level_2',
  /** 三级选项 - CascadeDropDown */
  Level_3 = 'level_3',
  /** 四级选项 - CascadeDropDown */
  Level_4 = 'level_4',
  /** 题目 - LikertField, MatrixField */
  Statement = 'statement'
}

export type FieldMetaTarget = {
  /** 如表单名, 对外查询名称等 */
  targets?: Maybe<Array<Scalars['String']['output']>>;
  /** 被引用的模块, 如 OpenSearch, OpenResult */
  type?: Maybe<Scalars['String']['output']>;
  /** 是否被引用 */
  value: Scalars['Boolean']['output'];
};

export type FieldReport = AddressFieldReport | CascadeChoiceFieldReport | ChoiceFieldReport | GeoFieldReport | MatrixScaleFieldReport | NumberFieldReport;

export type FieldRuleAttributes = {
  /** 且/或 */
  operator: FieldRuleTriggerConditionGroupOperator;
  /** 规则集 */
  ruleSets: Array<RuleSetAttributes>;
  /** 目标字段的api_code */
  targets: Array<Scalars['ID']['input']>;
  /** 显示或隐藏 */
  targetsDisplayMode: FieldRuleMode;
};

export enum FieldRuleMode {
  /** Abort */
  Abort = 'abort',
  /** Show */
  Show = 'show'
}

export type FieldRuleOnTarget = {
  /** 显示或隐藏的条件 */
  conditionGroup: FieldRuleTriggerConditionGroup;
  /** 显示或隐藏 */
  mode: FieldRuleMode;
  /** 目标字段的api_code */
  target: Scalars['ID']['output'];
};

export type FieldRuleTriggerCondition = {
  /** 触发条件的值匹配方式 */
  comparator: FieldRuleValueComparator;
  /** 触发字段的api_code */
  trigger: Scalars['ID']['output'];
  /** 触发字段满足条件时的值 */
  value: Scalars['Any']['output'];
};

export type FieldRuleTriggerConditionGroup = RuleTriggerOperator & {
  conditionGroups?: Maybe<Array<FieldRuleTriggerConditionGroup>>;
  /** 叶子条件 */
  conditions?: Maybe<Array<FieldRuleTriggerCondition>>;
  /** 或/且 */
  operator: FieldRuleTriggerConditionGroupOperator;
};

export enum FieldRuleTriggerConditionGroupOperator {
  And = 'and',
  Or = 'or'
}

export enum FieldRuleValueComparator {
  /** Between */
  Between = 'between',
  /** Equal */
  Equal = 'equal',
  /** Like */
  Like = 'like',
  /** None in */
  NoneIn = 'none_in',
  /** Not like */
  NotLike = 'not_like'
}

export type FieldStateFlow = {
  availableFsfEvents?: Maybe<Array<Scalars['String']['output']>>;
  extraFsfData?: Maybe<Scalars['JSON']['output']>;
  fsfTarget: Scalars['String']['output'];
  fsfType: FsfType;
};

export type FieldStatementPredefinedValues = {
  enabled: Scalars['Boolean']['output'];
  values: Scalars['JSON']['output'];
};

export type FieldStatementPredefinedValuesAttributes = {
  enabled: Scalars['Boolean']['input'];
  values?: InputMaybe<Scalars['JSON']['input']>;
};

export enum FieldValidation {
  /** 白/黑名单 */
  AccessControlListLimit = 'access_control_list_limit',
  /** 仅中文 */
  ChineseOnly = 'chinese_only',
  /** 选项可选次数 */
  ChoiceFrequency = 'choice_frequency',
  /** 自定义正则表达式验证 */
  CustomRegexFormat = 'custom_regex_format',
  /** 起止日期 */
  DateRange = 'date_range',
  /** 仅英文 */
  EnglishOnly = 'english_only',
  /** 身份证号验证 */
  IdCardFormat = 'id_card_format',
  /** 同时收集国际/港澳台手机号 */
  IntlMobileNo = 'intl_mobile_no',
  /** 最多/最少字符或选项 */
  Length = 'length',
  /** 设置"其他"必填 */
  OtherChoicePresence = 'other_choice_presence',
  /** 车牌号验证 */
  PlateNumberFormat = 'plate_number_format',
  /** 必须填 */
  Presence = 'presence',
  /** QQ号验证 */
  QqNumberFormat = 'qq_number_format',
  /** 最大/最小值 */
  Range = 'range',
  /** 不能和已有数据重复 */
  Uniqueness = 'uniqueness',
  /** 白名单 */
  WhiteListLimit = 'white_list_limit'
}

export type FieldVerification = {
  cachedFormName?: Maybe<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  forTesting: Scalars['Boolean']['output'];
  form?: Maybe<Form>;
  id: Scalars['ID']['output'];
  mobile: Scalars['String']['output'];
  performedAt: Scalars['ISO8601DateTime']['output'];
  status: FieldVerificationStatus;
};

/** The connection type for FieldVerification. */
export type FieldVerificationConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<FieldVerificationEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<FieldVerification>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type FieldVerificationEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<FieldVerification>;
};

export type FieldVerificationFieldVerificationSendSmsFailureActivity = {
  formInfo: FormActivityBaseInfo;
};

export enum FieldVerificationStatus {
  Failed = 'failed',
  Successful = 'successful'
}

export enum FieldsContext {
  /** 可用作附件重命名的字段 */
  AttachmentExportNameable = 'attachment_export_nameable',
  /** 可用作反向关联展示字段的字段 */
  AvailableReverseAssociationDisplay = 'available_reverse_association_display',
  /** 所有可能的反向关联字段 */
  AvailableReversedAssociation = 'available_reversed_association',
  /** 对外查询、结果分享可操作的字段 */
  AvailableShared = 'available_shared',
  /** 表单数据列表 */
  Entries = 'entries',
  /** 数据批量编辑 */
  EntriesBatchEdit = 'entries_batch_edit',
  /** 可用字段规则的字段 */
  FieldRuleAvailable = 'field_rule_available',
  /** 可用作gen code重置规则的字段 */
  GenCodeElementable = 'gen_code_elementable',
  /** 可用作gen code的字段 */
  GenCodeFieldable = 'gen_code_fieldable',
  /** 协作表单数据列表 */
  MyEntries = 'my_entries',
  /** 对外查询Component：可作为查询条件的字段 */
  Opensearchable = 'opensearchable',
  /** 门户客户填写表单可见字段 */
  PortalCustomerFilled = 'portal_customer_filled',
  /** 对外查询：可作为查询条件的字段 */
  ResultSearchable = 'result_searchable',
  /** 可对外分享的字段 */
  SingleEntrySharableFields = 'single_entry_sharable_fields',
  /** 提交后展示文案可插值字段 */
  SuccessMessageInsertable = 'success_message_insertable',
  /** 提交后跳转链接可使用字段 */
  SuccessRedirect = 'success_redirect',
  /** 模板插值选项 */
  TextPlaceholders = 'text_placeholders'
}

export type FileMessagePart = {
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  /** 输入的文件元素 */
  inputFileElement?: Maybe<AiFileElementType>;
};

export type FillFrequency = {
  /** 填写次数的限填方式：每设备、每IP等 */
  condition?: Maybe<Condition>;
  /** 限填次数的类型是重复填写时，重复的周期：每小时、每天、每周、每月 */
  cyclePeriod?: Maybe<CyclePeriod>;
  /** 限填次数的类型是自定义时，自定义的周期长度：每2天、每3天 etc */
  cyclesPerPeriod?: Maybe<Scalars['Int']['output']>;
  /** 填写次数的限填类型：不限填、仅限一次、重复填写等 */
  fillType?: Maybe<FillType>;
  /** 当限填方式是每字段时，字段的 API Code。注意这里是数组格式。 */
  limitedFieldApiCodes?: Maybe<Array<Scalars['String']['output']>>;
  /** 限填次数的类型是重复填写时，每周期的最大次数 */
  limitedTime?: Maybe<Scalars['Int']['output']>;
};

export type FillFrequencyAttributes = {
  /** 填写次数的限填方式：每设备、每IP、每字段等 */
  condition?: InputMaybe<Condition>;
  /** 限填次数的类型是重复填写时，重复的周期：每小时、每天、每周 */
  cyclePeriod?: InputMaybe<CyclePeriod>;
  /** 限填次数的类型是自定义时，自定义的周期长度：每2天、每3天 etc */
  cyclesPerPeriod?: InputMaybe<Scalars['Int']['input']>;
  /** 填写次数的限填类型：不限填、仅限一次、重复填写等 */
  fillType?: InputMaybe<FillType>;
  /** 当限填方式是每字段时，字段的 API Code。注意这里接受的是数组格式。 */
  limitedFieldApiCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** 限填次数的类型是重复填写时，每周期的最大次数 */
  limitedTime?: InputMaybe<Scalars['Int']['input']>;
};

export type FillInRate = {
  /**
   * 限填的群组
   * @deprecated 请使用 boundGroupTokens
   */
  boundCustomerGroupToken?: Maybe<Scalars['String']['output']>;
  /** 限填的群组Token列表 */
  boundGroupTokens?: Maybe<Array<Scalars['String']['output']>>;
  /** 表单的填写率。当表单未绑定群组，或群组人数为空时，返回空 */
  customerFillInRate?: Maybe<Scalars['Float']['output']>;
  /** 可填写的客户 */
  customers?: Maybe<CustomerConnection>;
  /** 绑定群组的人数 */
  customersCount?: Maybe<Scalars['Int']['output']>;
  /** 已填写的客户 */
  filledCustomers?: Maybe<CustomerConnection>;
  /** 已填写的客户数 */
  filledCustomersCount?: Maybe<Scalars['Int']['output']>;
  /** 未填写的客户 */
  unfilledCustomers?: Maybe<CustomerConnection>;
};


export type FillInRateCustomerFillInRateArgs = {
  customerGroupToken?: InputMaybe<Scalars['ID']['input']>;
};


export type FillInRateCustomersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  customerGroupToken?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type FillInRateCustomersCountArgs = {
  customerGroupToken?: InputMaybe<Scalars['ID']['input']>;
};


export type FillInRateFilledCustomersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  customerGroupToken?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type FillInRateFilledCustomersCountArgs = {
  customerGroupToken?: InputMaybe<Scalars['ID']['input']>;
};


export type FillInRateUnfilledCustomersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  customerGroupToken?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type FillInRule = {
  /**
   * 查看/查询的密码
   * @deprecated 为了和 updateFormSetting mutation 兼容，请使用 accessPolicySetting 字段。
   */
  accessPassword?: Maybe<Scalars['String']['output']>;
  /** 限定填写设置 */
  accessPolicySetting?: Maybe<AccessPolicySetting>;
  /**
   * 谁能看
   * @deprecated 为了和 updateFormSetting mutation 兼容，请使用 accessPolicySetting 字段。
   */
  allowedAudience: AllowedAudience;
  availableAllowedAudiences: Array<AllowedAudience>;
  /**
   * 达到限填后是否允许取消预约
   * @deprecated 为了和 updateFormSetting mutation 兼容，请使用 accessPolicySetting 字段。
   */
  cancelReservationFillFrequencyLimited: Scalars['Boolean']['output'];
  /**
   * 到达限填后展示数据的设置
   * @deprecated 为了和 updateFormSetting mutation 兼容，请使用 accessPolicySetting 字段。
   */
  entriesActionFillFrequencyLimited?: Maybe<OpenEntriesAction>;
  /**
   * 填写限制规则
   * @deprecated 为了和 updateFormSetting mutation 兼容，请使用 accessPolicySetting 字段。
   */
  fillFrequency?: Maybe<FillFrequency>;
  /**
   * 当allowed_audience为sms_verification需要设置。表示：验证身份时，是否使用特定的手机号。true：使用，false：不使用
   * @deprecated 为了和 updateFormSetting mutation 兼容，请使用 accessPolicySetting 字段。
   */
  isSpecifiedVerifier: Scalars['Boolean']['output'];
  /**
   * 是否凭密码查看/查询，true：凭密码打开，false：不需要密码
   * @deprecated 为了和 updateFormSetting mutation 兼容，请使用 accessPolicySetting 字段。
   */
  passwordRequired: Scalars['Boolean']['output'];
  /**
   * 当达到限填后，是否展示表单
   * @deprecated 为了和 updateFormSetting mutation 兼容，请使用 accessPolicySetting 字段。
   */
  showFormFillFrequencyLimited?: Maybe<Scalars['Boolean']['output']>;
  /**
   * 表单提交时，是否限制地区
   * @deprecated 为了和 updateFormSetting mutation 兼容，请使用 accessPolicySetting 字段。
   */
  submissionRegionLimited: Scalars['Boolean']['output'];
  /**
   * 表单提交时，限制地区
   * @deprecated 为了和 updateFormSetting mutation 兼容，请使用 accessPolicySetting 字段。
   */
  submissionRegions?: Maybe<Array<Scalars['String']['output']>>;
  submitterGroup?: Maybe<SubmitterGroup>;
  /**
   * 表单人群设置。限制群组及部分人群条件.
   * @deprecated 为了和 updateFormSetting mutation 兼容，请使用 accessPolicySetting 字段。
   */
  submitterSetting?: Maybe<FormSubmitterSetting>;
  /**
   * 当allowed_audience为sms_verification需要设置。表示：特定手机号-身份验证的手机号
   * @deprecated 为了和 updateFormSetting mutation 兼容，请使用 accessPolicySetting 字段。
   */
  viewVerifiers?: Maybe<Array<Scalars['String']['output']>>;
  /**
   * 当allowed_audience为sms_verification需要设置。表示：验证身份时，表单中选择的手机认证字段api_code
   * @deprecated 为了和 updateFormSetting mutation 兼容，请使用 accessPolicySetting 字段。
   */
  viewVerifyFieldApiCode?: Maybe<Scalars['String']['output']>;
  /**
   * 是否仅限在微信/企业微信中
   * @deprecated 为了和 updateFormSetting mutation 兼容，请使用 accessPolicySetting 字段。
   */
  weixinLimited: Scalars['Boolean']['output'];
};

export enum FillLayout {
  /** Form */
  Form = 'form',
  /** Landing page */
  LandingPage = 'landing_page'
}

export enum FillType {
  /** Custom repeatable */
  CustomRepeatable = 'custom_repeatable',
  /** Once */
  Once = 'once',
  /** Repeatable */
  Repeatable = 'repeatable',
  /** Repeatable by day */
  RepeatableByDay = 'repeatable_by_day',
  /** Unlimited */
  Unlimited = 'unlimited'
}

export type FilledForm = LastEntryCreatedAt & {
  /** currentUser为别人所填写表单的数据量 */
  entriesCount: Scalars['Int']['output'];
  /** currentUser为别人所填写表单的表单信息 */
  form: Form;
  /** 表单的最新数据提交时间 */
  lastEntryCreatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type FillerIdentity = {
  mobileNo?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type Filter = {
  dateRange?: Maybe<DateRange>;
  subjects?: Maybe<Array<Subject>>;
};

export type FixedCharactersRule = {
  /** 规则 ID */
  id: Scalars['ID']['output'];
  /** 规则位置 */
  position: Scalars['Int']['output'];
  /** 固定字符 */
  value: Scalars['String']['output'];
};

export type FloatShareBtn = {
  bgColor?: Maybe<Scalars['String']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type FloatShareBtnAttributes = {
  bgColor?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type Footer = {
  /** 广告按钮文案 */
  adButtonText?: Maybe<Scalars['String']['output']>;
  /** 表单底部「品牌」的超链接 */
  hyperlink?: Maybe<Scalars['String']['output']>;
  /** 表单底部「品牌Logo」 */
  logo?: Maybe<Scalars['String']['output']>;
  /** 是否显示「提交即同意该表单收集你的信息用于后续服务」 */
  showPrivacyCollectingWarning: Scalars['Boolean']['output'];
  /** 是否展示隐私协议弹窗按钮 */
  showPrivacyContent: Scalars['Boolean']['output'];
  /** 表单底部「品牌文字」 */
  text?: Maybe<Scalars['String']['output']>;
  /** footer 底部点击唤起小程序的 weapp id */
  weappId?: Maybe<Scalars['String']['output']>;
};

export type Form = ActAsBusinessForm & ActAsSignupForm & BaseFile & Cooperator & FillInRate & FormDefaultEntry & HasManyEntries & HasManyFields & LastEntryCreatedAt & PublishedFormBaseProperties & RiskControl & SceneProperties & Subname & Templates & TradePaymentForm & {
  ability: FormAbility;
  /** 当前用户对于当前文件的所有父文件夹列表 */
  allAncestorFolders?: Maybe<Array<FormFolder>>;
  allFields: FieldConnection;
  /** 被关联的表单列表 */
  associationForms?: Maybe<Array<Form>>;
  /** 表单变更记录 */
  auditTrails: FormAuditTrailsConnection;
  /** 表单角色列表 */
  availableRoles: Array<FormRole>;
  /** 平均填写时长 */
  averageFillingDuration?: Maybe<Scalars['Float']['output']>;
  /** 封停原因 */
  ban?: Maybe<Ban>;
  billingAccount: BillingAccount;
  /**
   * 限填的群组
   * @deprecated 请使用 boundGroupTokens
   */
  boundCustomerGroupToken?: Maybe<Scalars['String']['output']>;
  /** 限填的群组Token列表 */
  boundGroupTokens?: Maybe<Array<Scalars['String']['output']>>;
  /** 业务表单所属门户 */
  businessBoundPortal?: Maybe<GdPortalBusinessBoundPortalType>;
  /** 举报原因 */
  complaints?: Maybe<Array<Complaint>>;
  /** 【用于 next】返回表单的所有字段，包括编辑器可编辑字段、只读字段、隐藏字段、系统字段、关联字段和计算字段，用于编辑器、数据页面等所有场景。 */
  completeFields: FieldConnection;
  /**
   * currentUser在此表单下的权限集
   * @deprecated 应当使用userFormRole#abilities
   */
  cooperativeAbilities: Array<FormRoleAbility>;
  /** 协作者邀请链接 */
  cooperatorLinks?: Maybe<Array<CooperatorLink>>;
  /** 表单协作者们[不包含表单creator] */
  cooperators?: Maybe<FormCooperatorsConnection>;
  /** 当前表单可添加协作者的席位数，若无上限则为-1 */
  cooperatorsLimit: Scalars['Int']['output'];
  /** 表单创建来源 */
  createSource?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** 表单创建来源 */
  createdFrom?: Maybe<CreationSource>;
  /** 表单创建的群组 */
  createdGroup?: Maybe<SubmitterGroup>;
  creatorId: Scalars['ID']['output'];
  currency: Currency;
  /** 当前批量任务 */
  currentBatchJob?: Maybe<Job>;
  /** 表单协作者们中的当前用户 */
  currentCooperator: FormCooperators;
  /** 当前附件导出任务 */
  currentEntryAttachmentsTask?: Maybe<EntryAttachmentsTaskType>;
  /** 当前数据导出任务 */
  currentExportJob?: Maybe<ExportJobType>;
  /** 表单的填写率。当表单未绑定群组，或群组人数为空时，返回空 */
  customerFillInRate?: Maybe<Scalars['Float']['output']>;
  /** 可填写的客户 */
  customers?: Maybe<CustomerConnection>;
  /** 绑定群组的人数 */
  customersCount?: Maybe<Scalars['Int']['output']>;
  /**
   * 表单开启/关闭状态描述文本
   * @deprecated 使用 FormSettingType.data_collection_status_text
   */
  dataCollectionStatusText: Scalars['String']['output'];
  /** 在有表单规则时，显示一些隐藏但是在规则中的默认值 */
  defaultRulableHiddenValues?: Maybe<Scalars['JSON']['output']>;
  deleted: Scalars['Boolean']['output'];
  /** 表单描述，富文本 */
  description?: Maybe<Scalars['String']['output']>;
  /** 表单是否被冻结 */
  disabled?: Maybe<Scalars['Boolean']['output']>;
  /** 表单被编辑后的版本 */
  editedVersion?: Maybe<Scalars['Int']['output']>;
  /** 表单、文件夹的图标、颜色等 */
  ensuredSymbol?: Maybe<FormSymbol>;
  entriesCount: Scalars['Int']['output'];
  /** 带有默认值的预填写数据 */
  entry?: Maybe<Entry>;
  /** 微信红包设置 */
  entryRedEnvelopeSetting?: Maybe<EntryRedEnvelopeSetting>;
  /** 自定义扩展属性 */
  extendedAttributeFilters: ExtendedAttributeFilterConnection;
  /** 字段规则 */
  fieldRules?: Maybe<Array<FormFieldRule>>;
  fieldRulesGroupByTarget: Array<FieldRuleOnTarget>;
  /** 统一给分离、非分离、M站各处通用的字段规则对外结构，待稳定后，会废除field_rules_group_by_target字段 */
  fieldRulesGroupByTargetAndOperator?: Maybe<Scalars['JSON']['output']>;
  fields: FieldConnection;
  /** 表单字段最后更新时间 */
  fieldsUpdatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** 已填写的客户 */
  filledCustomers?: Maybe<CustomerConnection>;
  /** 已填写的客户数 */
  filledCustomersCount?: Maybe<Scalars['Int']['output']>;
  /** 表单绑定的插件 */
  formApplications?: Maybe<Array<UserFormApplication>>;
  /** 表单变更记录 */
  formAuditTrails: FormAuditTrailsConnection;
  /** 表单角色可以操作字段 */
  formRoleAvailableFields?: Maybe<FieldConnection>;
  /** 表单角色 */
  formRoles?: Maybe<FormRoleConnection>;
  /**
   * 是否采用新的字段规则OUTPUT
   * @deprecated toggle 已移除，始终为 true
   */
  gdFieldRulesGroupByTargetAndOperatorEnabled: Scalars['Boolean']['output'];
  /** 是否含有必填字段 */
  hasRequiredFields: Scalars['Boolean']['output'];
  /** 是否有「题型字段」已配置字段规则 */
  hasScorableFieldsInRules: Scalars['Boolean']['output'];
  /** 是否含有不可用的附件字段 */
  hasUnusableAttachmentFields: Scalars['Boolean']['output'];
  /** 是否含有不可用的语音字段 */
  hasUnusableAudioFields: Scalars['Boolean']['output'];
  /** 是否含有套餐不可用功能 */
  hasUnusableFeatures: Scalars['Boolean']['output'];
  /** 是否含有套餐不可用字段 */
  hasUnusableFields: Scalars['Boolean']['output'];
  /** 分页式表单隐藏欢迎页 */
  hideWelcomeScreen: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** 协作者邀请待回应 */
  inviters?: Maybe<InviterConnection>;
  /** 文件类型：表单 form 或 数据表格 table */
  kind: BaseFileKindEnum;
  /** 表单的最新数据提交时间 */
  lastEntryCreatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** 表单布局 */
  layout: Layout;
  /** 小金商户额度用完了 */
  merchantQuotaUsedUp: Scalars['Boolean']['output'];
  /** 商品最低价格 */
  minGoodsPrice?: Maybe<Scalars['Float']['output']>;
  mobileCover?: Maybe<MobileCover>;
  /** 是否有个多个商品 */
  mutilGoodsPrice?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  /** 订单数量 */
  ordersCount?: Maybe<Scalars['Int']['output']>;
  /** 表单的原始名称 */
  originalName: Scalars['String']['output'];
  /** 表单拥有者 */
  owner: FormOwner;
  /** 考试通过率 */
  passRate?: Maybe<Scalars['Float']['output']>;
  /** 是否含有支付相关的字段 */
  payable?: Maybe<Scalars['Boolean']['output']>;
  /** 跳过支付规则 */
  paymentRedirectExceptionRules?: Maybe<Array<PaymentRedirectExceptionRule>>;
  /** 隐藏字段，供对外页面使用 */
  privateFields: FieldConnection;
  /** 预填写表单 */
  pseudoForms: PseudoFormConnection;
  /** 表单对外填写地址 */
  publicFillUrl: Scalars['String']['output'];
  /** 过往联系人推荐列表 */
  recommendCooperators?: Maybe<FormRecommendedCooperatorsConnection>;
  /** 表单不可用的推荐套餐 */
  recommendedPlanCode?: Maybe<Scalars['String']['output']>;
  /** 表单的红包余额 */
  redEnvelopeDebitBalance?: Maybe<RedEnvelopeDebitBalance>;
  /** 跳转规则 */
  redirectRules?: Maybe<Array<FormRedirectRule>>;
  /** 表单场景 */
  scene: Scene;
  setting: FormSetting;
  /** 是否展示超级赞。true - 展示; false - 不展示 */
  showAwesome: Scalars['Boolean']['output'];
  /** 是否展示金数据底部注册引导广告 */
  showJsjFooterSignupAd: Scalars['Boolean']['output'];
  /** 注册表单所属门户 */
  signupBoundPortal?: Maybe<GdPortalSignupBoundPortalType>;
  stats: FormStats;
  storageConfig: StorageConfig;
  /** 填表人提交的数据量 */
  submitterEntriesCount: Scalars['Int']['output'];
  /** 站内表单名 */
  subname?: Maybe<Scalars['String']['output']>;
  /** 使用复制模板需要的表单插件 */
  templateRequiredFormApplications?: Maybe<Array<Application>>;
  /** 使用复制模板需要的套餐 */
  templateRequiredLowestPlan?: Maybe<Plan>;
  theme: Theme;
  token: Scalars['String']['output'];
  /** 交易数量 */
  transactionCount?: Maybe<Scalars['Int']['output']>;
  /** 交易金额 */
  transactionsAmount?: Maybe<Scalars['Float']['output']>;
  type: BaseFileEnum;
  /** 未填写的客户 */
  unfilledCustomers?: Maybe<CustomerConnection>;
  /** 套餐不可用功能列表 */
  unusableFeatureKeys?: Maybe<Array<Scalars['String']['output']>>;
  /**
   * 是否可以使用 CKEditor 5
   * @deprecated toggle 已移除，始终为 true
   */
  useCk5?: Maybe<Scalars['Boolean']['output']>;
  userFormAppSetting: UserFormAppSetting;
  /** currentUser在此表单下的角色 */
  userFormRole?: Maybe<FormRole>;
  userFormSetting?: Maybe<UserFormSetting>;
  /** 可见填表人数量 */
  visibleSubmittersCount: Scalars['Int']['output'];
  /** 是否开启裂变红包 */
  withDistributionRedEnvelope?: Maybe<Scalars['Boolean']['output']>;
  /** 是否开启红包 */
  withRedEnvelope?: Maybe<Scalars['Boolean']['output']>;
  /** 微信小程序分享信息 */
  wxMiniappShareInfo: WxMiniappShareInfo;
};


export type FormAllFieldsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  entryAction?: InputMaybe<FormRoleEntryOperator>;
  fieldsContext?: InputMaybe<FieldsContext>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type FormAuditTrailsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  scopeConditions?: InputMaybe<Array<ScopeConditionAttributes>>;
};


export type FormCompleteFieldsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type FormCooperatorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type FormCurrentBatchJobArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  type: EntriesBatchJobTypeType;
};


export type FormCustomerFillInRateArgs = {
  customerGroupToken?: InputMaybe<Scalars['ID']['input']>;
};


export type FormCustomersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  customerGroupToken?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type FormCustomersCountArgs = {
  customerGroupToken?: InputMaybe<Scalars['ID']['input']>;
};


export type FormDescriptionArgs = {
  sanitize?: InputMaybe<Scalars['Boolean']['input']>;
};


export type FormEntryArgs = {
  code?: InputMaybe<Scalars['ID']['input']>;
};


export type FormExtendedAttributeFiltersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  cname?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type FormFieldsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  allFormUsageFields?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forEntryOperator?: InputMaybe<FormRoleEntryOperator>;
  forcePublished?: InputMaybe<Scalars['Boolean']['input']>;
  formUsage?: InputMaybe<FormUsage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  scorable?: InputMaybe<Scalars['Boolean']['input']>;
  successEntryToken?: InputMaybe<Scalars['String']['input']>;
  systemExtendField?: InputMaybe<Scalars['Boolean']['input']>;
};


export type FormFilledCustomersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  customerGroupToken?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type FormFilledCustomersCountArgs = {
  customerGroupToken?: InputMaybe<Scalars['ID']['input']>;
};


export type FormFormAuditTrailsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type FormFormRoleAvailableFieldsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type FormFormRolesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type FormInvitersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type FormPassRateArgs = {
  thresholdScore: Scalars['Float']['input'];
};


export type FormPrivateFieldsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type FormPseudoFormsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type FormRecommendCooperatorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type FormShowAwesomeArgs = {
  ignoreAwesome?: InputMaybe<Scalars['Boolean']['input']>;
};


export type FormUnfilledCustomersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  customerGroupToken?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type FormAbility = {
  canSkipExternalLinkInterceptor: Scalars['Boolean']['output'];
  canUsePaidFeature: Scalars['Boolean']['output'];
  canUseVas: Scalars['Boolean']['output'];
};


export type FormAbilityCanUsePaidFeatureArgs = {
  key: Scalars['String']['input'];
};


export type FormAbilityCanUseVasArgs = {
  vas: Vas;
};

export type FormActivityBaseInfo = {
  /** 表单名称 */
  formName?: Maybe<Scalars['String']['output']>;
  /** 表单Token */
  formToken?: Maybe<Scalars['String']['output']>;
};

export type FormAppSettingAttributes = {
  /** 表单数据通知开关[true-打开，false-关闭] */
  formNotificationEnabled: Scalars['Boolean']['input'];
};

export enum FormApplicationAppCode {
  /** Code verify */
  CodeVerify = 'code_verify',
  /** Wheel fortune */
  WheelFortune = 'wheel_fortune'
}

export type FormApplicationWheelFortuneAttributes = {
  /** 幸运大转盘 - 兑奖设置 */
  cash?: InputMaybe<FormApplicationWheelFortuneCashAttributes>;
  /** 幸运大转盘 - 中奖设置 */
  lottery?: InputMaybe<FormApplicationWheelFortuneLotteryAttributes>;
  /** 插件开关：true - 开启，false - 关闭 */
  opened?: InputMaybe<Scalars['Boolean']['input']>;
  /** 幸运大转盘 - 奖品设置 */
  prizes?: InputMaybe<Array<FormApplicationWheelFortunePrizeAttributes>>;
  /** 插件开关：true - 开启，false - 关闭 */
  settingStep?: InputMaybe<SettingStep>;
  /** 幸运大转盘 - 文案设置 */
  text?: InputMaybe<FormApplicationWheelFortuneTextAttributes>;
};

export type FormApplicationWheelFortuneCashAttributes = {
  /** 兑奖方式：phone - 手机号码，code - 兑奖码 */
  cashStyle: CashStyle;
  /** 当兑奖方式为手机号码时，该字段为手机字段的api_code，必传 */
  mobileFieldApiCode?: InputMaybe<Scalars['ID']['input']>;
};

export type FormApplicationWheelFortuneLotteryAttributes = {
  /** 发奖人姓名 */
  casherName?: InputMaybe<Scalars['String']['input']>;
  /** 发奖人电话号码 */
  casherPhone?: InputMaybe<Scalars['String']['input']>;
  /** 每填写一次表单可抽奖次数 */
  limitTimes: Scalars['Int']['input'];
  /** 幸运大转盘 - 分数规则设置 */
  lotteryScopeRule?: InputMaybe<FormApplicationWheelFortunePrizeLotteryScopeRulesAttribute>;
  /** 是否启动分数相关的rules */
  lotteryScopeRuleEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** 当兑奖方式为手机号码时，该字段为手机字段的api_code，必传 */
  mobileFieldApiCode?: InputMaybe<Scalars['ID']['input']>;
  /** 中奖短信推送开关：true - 开启，false - 默认关闭 */
  sendSms?: InputMaybe<Scalars['Boolean']['input']>;
  /** 是否展示发奖人信息, true - 默认是, false - 否 */
  showCasher?: Scalars['Boolean']['input'];
  /** 展示中奖名单条数：不展示中奖名单 - 0 */
  showWinnerNumber?: InputMaybe<Scalars['Int']['input']>;
};

export type FormApplicationWheelFortunePrizeAttributes = {
  /** 奖品ID，如果是更新奖品，须带上ID */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** 奖品(奖券)数量 */
  prizeAmount?: InputMaybe<Scalars['Int']['input']>;
  /** 奖品图片 */
  prizeImage?: InputMaybe<FormApplicationWheelFortunePrizeImageAttributes>;
  /** 奖品名字 */
  prizeName: Scalars['String']['input'];
  /** 奖品类型：gift - 奖品，voucher - 奖券 */
  prizeType: PrizeKind;
  /** 奖券附件，如果奖项是奖券，必传 */
  prizeVoucher?: InputMaybe<FormApplicationWheelFortunePrizeVoucherAttributes>;
  /** 奖品类型：gift - 奖品，voucher - 奖券 */
  probability: Scalars['Float']['input'];
  /** 奖项名称 */
  title: Scalars['String']['input'];
};

export type FormApplicationWheelFortunePrizeImageAttributes = {
  /** 奖品图片ID - QiniuCallback中的attachmentId */
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type FormApplicationWheelFortunePrizeLotteryScopeRulesAttribute = {
  /** 最小数字边界 */
  leftBoundary?: InputMaybe<Scalars['Float']['input']>;
  predicateType: LotteryScopeRuleKind;
  /** 最大数字边界 */
  rightBoundary?: InputMaybe<Scalars['Float']['input']>;
};

export type FormApplicationWheelFortunePrizeVoucherAttributes = {
  /** 奖券附件ID - QiniuCallback中的attachmentId */
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type FormApplicationWheelFortuneTextAttributes = {
  /** 兑奖说明 */
  cashText: Scalars['String']['input'];
  /** 未中奖文案 */
  loseText: Scalars['String']['input'];
  /** 中奖文案 */
  winText: Scalars['String']['input'];
};

export type FormAssociation = AssociatedField & BaseField & CalculableField & FieldAbility & HasDynamicConditionValues & PlanAvailableField & WithConditionalScope & WithSmsVerification & {
  /** 是否允许反向关联 */
  allowReverseAssociation?: Maybe<Scalars['Boolean']['output']>;
  apiCode: Scalars['ID']['output'];
  apiCodeAlias?: Maybe<Scalars['String']['output']>;
  /** 被关联字段的设置属性 */
  associatedFieldSettings: Array<AssociatedFieldSetting>;
  associatedForm?: Maybe<AssociatedForm>;
  /** 对应的表单关联字段 */
  associationField?: Maybe<Field>;
  /** 自动填写上次提交内容 */
  cacheData: Scalars['Boolean']['output'];
  /** 开启选项赋值或本身可参与计算 */
  calculable: Scalars['Boolean']['output'];
  /** 客户端ID */
  cid?: Maybe<Scalars['String']['output']>;
  conditionalScope: Scalars['Boolean']['output'];
  /** 封装的字段类型 */
  customizedType?: Maybe<Scalars['String']['output']>;
  /** 封装的字段类型文本 */
  customizedTypeName?: Maybe<Scalars['String']['output']>;
  /** 自定义出错文案 */
  customizedValidationMessage?: Maybe<Scalars['String']['output']>;
  /** 被关联展示字段的设置属性 */
  displayFieldSettings: Array<AssociatedDisplayFieldSetting>;
  /** 已提交的数据是否可被编辑 */
  editable: Scalars['Boolean']['output'];
  /** 该字段能否使用字段规则: true - 能， false - 不能 */
  fieldRuleAvailable: Scalars['Boolean']['output'];
  /** 是否是关联主键字段 */
  forAssociated?: Maybe<Scalars['Boolean']['output']>;
  /** 是否是关联展示字段 */
  forAssociatedDisplay?: Maybe<Scalars['Boolean']['output']>;
  /** 表单Token */
  formToken: Scalars['String']['output'];
  /** 宽度占用整行的四分之几 */
  gridsToOccupy?: Maybe<Scalars['Int']['output']>;
  hasAbility: Scalars['Boolean']['output'];
  /** 字段标题（去富文本化） */
  label?: Maybe<Scalars['String']['output']>;
  /** 字段描述，富文本 */
  notes?: Maybe<Scalars['String']['output']>;
  paidFeature?: Maybe<PaidFeature>;
  planAvailable: Scalars['Boolean']['output'];
  /** 字段排序 */
  position: Scalars['Int']['output'];
  /** 系统预定义的动态条件选项 */
  predefinedDynamicConditionOptions?: Maybe<Array<PredefinedDynamicCondition>>;
  /** 该字段是否是隐私字段 true - 是, false - 不是 */
  privacy: Scalars['Boolean']['output'];
  /** 开启隐私保护 */
  privacySafe: Scalars['Boolean']['output'];
  /** 字段隐藏 */
  private: Scalars['Boolean']['output'];
  prompts: Scalars['JSON']['output'];
  /** 字段是否通过预填写表单预设了值 true - 是, false - 否 */
  pseudoFormPredefined?: Maybe<Scalars['Boolean']['output']>;
  /** 字段标题（富文本化） */
  rawLabel?: Maybe<Scalars['String']['output']>;
  /** 字段是否只读，无法编辑 */
  readonly?: Maybe<Scalars['Boolean']['output']>;
  /** 反向关联的展示字段 */
  reverseDisplayFieldApiCodes?: Maybe<Array<Scalars['ID']['output']>>;
  scopeConditions?: Maybe<Array<ScopeCondition>>;
  /** 该字段是否属于评分字段（e.g. 考试、测评中的题目） */
  scorable: Scalars['Boolean']['output'];
  /** 字段提示较长时折叠展示 */
  showPartDescription: Scalars['Boolean']['output'];
  /** 开启短信验证 */
  smsVerification: Scalars['Boolean']['output'];
  /** 获取验证码前需填写图形验证码 */
  smsVerificationCaptcha: Scalars['Boolean']['output'];
  /** 新起一行 */
  startNewRow: Scalars['Boolean']['output'];
  /** 该字段是否可以作为文本插入 true - 能, false - 不能 */
  textPlaceholderable: Scalars['Boolean']['output'];
  /** 字段类型 */
  type: FieldClass;
  /** 字段类型文本 */
  typeName: Scalars['String']['output'];
  /** 当前版本允许的被关联展示字段个数 */
  validAssociatedDisplayFieldsCount: Scalars['Int']['output'];
  /** 当前版本允许的被关联字段个数 */
  validAssociatedFieldsCount: Scalars['Int']['output'];
  /** 字段验证规则 */
  validations?: Maybe<Array<FieldValidation>>;
};


export type FormAssociationHasAbilityArgs = {
  key: FieldAbilityEnum;
};


export type FormAssociationNotesArgs = {
  sanitize?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FormAttributes = {
  /** 待裁剪字体 */
  cuttingFonts?: InputMaybe<CuttingFontAttributes>;
  /** 表单描述 */
  description?: InputMaybe<Scalars['String']['input']>;
  /** 字段规则 */
  fieldRules?: InputMaybe<Array<FieldRuleAttributes>>;
  /** 字段 */
  fields?: InputMaybe<Array<FieldAttributes>>;
  /** 分页式表单是否隐藏欢迎页。true为隐藏，false为显示，默认为false */
  hideWelcomeScreen?: InputMaybe<Scalars['Boolean']['input']>;
  /** 表单封面 */
  mobileCover?: InputMaybe<MobileCoverAttributes>;
  /** 表单标题 */
  name: Scalars['String']['input'];
  /** 跳转规则 */
  redirectRules?: InputMaybe<Array<RedirectRuleAttributes>>;
  /** 表单设置 */
  setting?: InputMaybe<FormSettingAttributes>;
  /** 系统内的表单标题 */
  subname?: InputMaybe<Scalars['String']['input']>;
};

export type FormAuditTrailOwner = {
  avatar?: Maybe<Scalars['String']['output']>;
  isExternal: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  ownerType: AuditTrialUserTypeEnum;
  weixinQiyeUserid?: Maybe<Scalars['String']['output']>;
};

export type FormAuditTrails = {
  changedCount?: Maybe<Scalars['Int']['output']>;
  details: Scalars['JSON']['output'];
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  owner?: Maybe<FormAuditTrailOwner>;
  /** 是否可以恢复数据 */
  restorable: Scalars['Boolean']['output'];
  time: Scalars['ISO8601DateTime']['output'];
  /** 触发来源日志 */
  triggerBy?: Maybe<FormAuditTrails>;
  /** @deprecated 使用owner以支持更多的属性 */
  userAvatar?: Maybe<Scalars['String']['output']>;
  /** @deprecated 使用owner以支持更多的属性 */
  userName?: Maybe<Scalars['String']['output']>;
};

/** The connection type for FormAuditTrails. */
export type FormAuditTrailsConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<FormAuditTrailsEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<FormAuditTrails>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type FormAuditTrailsEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<FormAuditTrails>;
};

export type FormBannedActivity = {
  content?: Maybe<Scalars['String']['output']>;
  formInfo: FormActivityBaseInfo;
};

export type FormCalculationAttributes = {
  /** 当计算字段是矩阵填空的项目时，矩阵填空题目的apiCode */
  statementApiCode?: InputMaybe<Scalars['ID']['input']>;
  /** 当计算字段是矩阵填空或表格字段的项目时，矩阵填空或表格字段的apiCode */
  tabularApiCode?: InputMaybe<Scalars['ID']['input']>;
  /** 需要计算的字段的apiCode */
  targets: Array<Scalars['ID']['input']>;
  /** 变量对应的值 */
  variables: Scalars['JSON']['input'];
};

/** The connection type for Form. */
export type FormConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<FormEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Form>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FormCooperators = {
  avatarUrl?: Maybe<Scalars['String']['output']>;
  billingAccount?: Maybe<BillingAccount>;
  /** 协作者在当前文件夹中的直接角色 */
  directRole?: Maybe<FormRole>;
  /** 用户在系统中展示的名字，优先级为：企业身份下的名字 -> 微信昵称 -> 昵称 -> 邮箱 -> 手机号 */
  displayName: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  /** 外部联系人权限 */
  externalAttachAbilities?: Maybe<Array<FormRoleUserExternalAbilitiesType>>;
  /** 协作者在当前表单中的角色 */
  formRole: FormRole;
  id: Scalars['ID']['output'];
  /** 协作者在当前文件夹中的继承角色 */
  inheritedRole?: Maybe<FormRole>;
  mobile?: Maybe<Scalars['String']['output']>;
  status: UserStatus;
  weixinQiyeUser?: Maybe<WeixinQiyeUser>;
};


export type FormCooperatorsDisplayNameArgs = {
  privacyProtect?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The connection type for FormCooperators. */
export type FormCooperatorsConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<FormCooperatorsEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<FormCooperators>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type FormCooperatorsEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<FormCooperators>;
};

export type FormCover = FilledForm | Form | FormFolder;

/** The connection type for FormCover. */
export type FormCoverConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<FormCoverEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<FormCover>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type FormCoverEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<FormCover>;
};

export type FormDefaultEntry = {
  /** 带有默认值的预填写数据 */
  entry?: Maybe<Entry>;
};


export type FormDefaultEntryEntryArgs = {
  code?: InputMaybe<Scalars['ID']['input']>;
};

export type FormDistribution = {
  /** 裂变海报邀请文案 */
  description?: Maybe<Scalars['String']['output']>;
  /** 是否开启裂变海报 */
  enabled: Scalars['Boolean']['output'];
  /** 裂变海报样式 */
  posterStyleName?: Maybe<Scalars['String']['output']>;
  /** 邀请人标识字段 apiCode */
  referrerFieldApiCode?: Maybe<Scalars['String']['output']>;
  /** 裂变海报邀请按钮文案 */
  successDistributionBtnContent?: Maybe<Scalars['String']['output']>;
};

/** An edge in a connection. */
export type FormEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Form>;
};

export type FormEntriesExportActivity = {
  formInfo: FormActivityBaseInfo;
};

export type FormEntryAttachmentBulkTaskActivity = {
  downloadUrls?: Maybe<Array<Scalars['String']['output']>>;
  fieldApiCode: Scalars['String']['output'];
  formInfo: FormActivityBaseInfo;
  status: Scalars['String']['output'];
};

export type FormEntryPostFailureActivity = {
  formInfo: FormActivityBaseInfo;
};

export type FormFieldRule = RuleTriggerOperator & {
  /** 或/且 */
  operator: FieldRuleTriggerConditionGroupOperator;
  /** 规则集 */
  ruleSets: Array<RuleSet>;
  /** 目标字段的api_code */
  targets: Array<Scalars['ID']['output']>;
  /** 显示或隐藏 */
  targetsDisplayMode: FieldRuleMode;
};

export type FormFolder = BaseFile & PublishedFormBaseProperties & SceneProperties & {
  /** 当前用户对于当前文件夹的所有父文件夹列表 */
  allAncestorFolders?: Maybe<Array<FormFolder>>;
  /** 文件夹协作者们 */
  cooperators?: Maybe<FormFolderCooperatorTypeConnection>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  deleted: Scalars['Boolean']['output'];
  /** 表单、文件夹的图标、颜色等 */
  ensuredSymbol?: Maybe<FormSymbol>;
  /** 子文件夹数 */
  folderCount: Scalars['Int']['output'];
  /** 子表单数 */
  formCount: Scalars['Int']['output'];
  /** 当前文件夹的协作者中是否有继承角色存在，true - 有，false -没有 */
  hasInheritedRoleUser: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** 文件夹归属：表单或数据表格 */
  kind: BaseFileKindEnum;
  lastFormCreatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  name: Scalars['String']['output'];
  /** 创建者 */
  owner?: Maybe<User>;
  /** 文件夹的上一级文件夹 */
  previousLevelFolder?: Maybe<FormFolder>;
  /** 表单场景 */
  scene: Scene;
  /** 文件夹的共享级别，详见GQL注解 */
  shareType?: Maybe<FormFolderShareType>;
  token: Scalars['String']['output'];
  type: BaseFileEnum;
  /** currentUser在此文件夹下的角色 */
  userFolderRole: FormFolderRoleType;
  userFormSetting?: Maybe<UserFormSetting>;
};


export type FormFolderCooperatorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  shared?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FormFolderActivityBaseInfo = {
  /** 文件夹的名称 */
  folderName?: Maybe<Scalars['String']['output']>;
  /** 文件夹的Token */
  folderToken?: Maybe<Scalars['String']['output']>;
};

export type FormFolderAttributes = {
  /** 文件夹名字 */
  name?: InputMaybe<Scalars['String']['input']>;
  /** 文件夹图标和颜色 */
  symbol?: InputMaybe<FormSymbolAttributes>;
};

export type FormFolderCooperatorType = {
  avatarUrl?: Maybe<Scalars['String']['output']>;
  billingAccount?: Maybe<BillingAccount>;
  /** 协作者在当前文件夹中的直接角色 */
  directRole?: Maybe<FormFolderRoleType>;
  /** 用户在系统中展示的名字，优先级为：企业身份下的名字 -> 微信昵称 -> 昵称 -> 邮箱 -> 手机号 */
  displayName: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** 协作者在当前文件夹中的继承角色 */
  inheritedRole?: Maybe<FormFolderRoleType>;
  mobile?: Maybe<Scalars['String']['output']>;
  status: UserStatus;
  weixinQiyeUser?: Maybe<WeixinQiyeUser>;
};


export type FormFolderCooperatorTypeDisplayNameArgs = {
  privacyProtect?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The connection type for FormFolderCooperatorType. */
export type FormFolderCooperatorTypeConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<FormFolderCooperatorTypeEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<FormFolderCooperatorType>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type FormFolderCooperatorTypeEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<FormFolderCooperatorType>;
};

export type FormFolderRoleType = {
  /** 文件夹角色ID */
  id?: Maybe<Scalars['ID']['output']>;
  /** 文件夹角色名 */
  role: FormFolderRoleUserType;
};

export enum FormFolderRoleUserType {
  /** Data viewer */
  DataViewer = 'data_viewer',
  /** Manager */
  Manager = 'manager',
  /** 无权限 */
  None = 'none'
}

export type FormFolderRoleUsersAttributes = {
  /** 协作者ID */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** 权限 */
  role: FormFolderRoleUserType;
  /** 协作者UserID */
  user: Scalars['ID']['input'];
};

export type FormFolderShareRoleActivity = {
  folderInfo: FormFolderActivityBaseInfo;
  targetType: Scalars['String']['output'];
  userName: Scalars['String']['output'];
};

export enum FormFolderShareType {
  /** All */
  All = 'all',
  /** None */
  None = 'none',
  /** User */
  User = 'user'
}

export type FormHeaderImage = {
  /** 图片主题色 */
  color: Scalars['String']['output'];
  /** 创建人链接 */
  creatorLink?: Maybe<Scalars['String']['output']>;
  /** 创建人 */
  creatorName?: Maybe<Scalars['String']['output']>;
  /** 下载地址 */
  trackDownloadUrl?: Maybe<Scalars['String']['output']>;
  /** 图片地址 */
  url: Scalars['String']['output'];
};

export type FormImportJob = {
  /** 上传文件的列 */
  columns: Array<FormImportJobExcelColumn>;
  /** 上传文件的文件名 */
  filename: Scalars['String']['output'];
  /** 上传文件的表头行号。null表示文件没有数据 */
  headerRowIndex?: Maybe<Scalars['Int']['output']>;
  /** 任务ID，即创建的表单TOKEN */
  id: Scalars['ID']['output'];
  /** 上传文件的最后一行行号。null表示文件没有数据 */
  lastRowIndex?: Maybe<Scalars['Int']['output']>;
  /** 上传文件的预览数据。返回null时，代表Excel文件内容有误 */
  previewData?: Maybe<Array<Scalars['Any']['output']>>;
};


export type FormImportJobPreviewDataArgs = {
  previewRows?: InputMaybe<Scalars['Int']['input']>;
};

export type FormImportJobAmendmentAttributes = {
  /** 导入的字段列表 */
  columns?: InputMaybe<Array<FormImportJobExcelColumnAttributes>>;
  rows: Array<FormImportJobAmendmentRowAttributes>;
};

export type FormImportJobAmendmentRowAttributes = {
  cells: Array<Scalars['Any']['input']>;
  index: Scalars['Int']['input'];
};

export type FormImportJobAppendAttributes = {
  /** 导入的字段列表 */
  columns: Array<FormImportJobExcelColumnAttributes>;
  /** 手动设置导入数据的表头是第几行 */
  headerRowIndex?: InputMaybe<Scalars['Int']['input']>;
  /** 导入数据需要去重的字段apiCode */
  uniqueFieldCode?: InputMaybe<Scalars['String']['input']>;
};

export type FormImportJobExcelCell = {
  error?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Any']['output']>;
};

export type FormImportJobExcelColumn = {
  /** 该列映射到的字段api_code。不通过 form 映射 Excel 中的字段关系时该值可能为空 */
  fieldApiCode?: Maybe<Scalars['ID']['output']>;
  /** 该列的字段类型。未保存时为推导出的类型。通过 form 映射 Excel 中的字段关系时该值可能为空 */
  fieldType?: Maybe<FieldClass>;
  /** Excel中的列索引, 从1开始 */
  index: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  selected?: Maybe<Scalars['Boolean']['output']>;
};

export type FormImportJobExcelColumnAttributes = {
  /** 字段api_code，数据页面导入数据时使用 */
  fieldApiCode?: InputMaybe<Scalars['ID']['input']>;
  /** 该列的字段类型 */
  fieldType: FieldClass;
  /** Excel中的列索引, 从1开始 */
  index: Scalars['Int']['input'];
  /** 列标题 */
  label: Scalars['String']['input'];
  /** 是否导入该列 */
  selected: Scalars['Boolean']['input'];
};

export type FormImportJobExcelRow = {
  cells: Array<FormImportJobExcelCell>;
  /** Excel中的行索引, 从1开始 */
  index: Scalars['Int']['output'];
};

export type FormImportJobExecutionResult = {
  /** 追加成功的数据量 = 总行数 - 不合法的行数 */
  appendedCount?: Maybe<Scalars['Int']['output']>;
  fields: Array<Field>;
  /** 追加的数据的起始序号 */
  firstEntrySerialNumber?: Maybe<Scalars['Int']['output']>;
  importedCount: Scalars['Int']['output'];
  invalidRows?: Maybe<Array<FormImportJobExcelRow>>;
  previewEntries: Array<Entry>;
  /** 去除的重复数据量 */
  skipCount?: Maybe<Scalars['Int']['output']>;
  status: FormImportJobExecutionResultStatus;
};


export type FormImportJobExecutionResultPreviewEntriesArgs = {
  previewCount?: InputMaybe<Scalars['Int']['input']>;
};

export enum FormImportJobExecutionResultStatus {
  /** Completed */
  Completed = 'completed',
  /** Invalid */
  Invalid = 'invalid',
  /** Need amend */
  NeedAmend = 'need_amend'
}

export type FormImportJobUpdateAttributes = {
  columns?: InputMaybe<Array<FormImportJobExcelColumnAttributes>>;
  createSource?: InputMaybe<Scalars['String']['input']>;
  formName?: InputMaybe<Scalars['String']['input']>;
  headerRowIndex?: InputMaybe<Scalars['Int']['input']>;
};

export type FormInterceptionSetting = {
  /** 访问密码的提示文案 */
  accessPasswordWording?: Maybe<Scalars['String']['output']>;
  /** 数据收集时间之开启/停止时间 */
  byTimeRangeCloseRule?: Maybe<ByTimeRangeCloseRule>;
  /** 达到限填后，是否可取消预约 */
  cancelReservationFillFrequencyLimited: Scalars['Boolean']['output'];
  /** 每日开放填写时间 */
  dailyRepeatCloseRule?: Maybe<DailyRepeatCloseRule>;
  /** 到达限填后展示数据的设置 */
  entriesActionFillFrequencyLimited: OpenEntriesAction;
  /** 达到限填后（不可查看表单内容）的提示文案 */
  fillFrequencyLimitedHideFormWording?: Maybe<Scalars['String']['output']>;
  /** Available values: ["en"] */
  locale: Scalars['String']['output'];
  /** 是否允许填表人查看修改历史数据，hide: 不允许查看, view: 允许查看, edit: 允许查看修改 */
  openEntryAction: OpenEntriesAction;
  /** 是否允许取消预约 */
  openEntryCancelReservation: Scalars['Boolean']['output'];
  /** open entry的提示文案 */
  openEntryMessage?: Maybe<Scalars['String']['output']>;
  /** 表单开启前，是否展示表单 */
  showFormBeforeOpen: Scalars['Boolean']['output'];
  /** 当达到限填后，是否展示表单 */
  showFormFillFrequencyLimited: Scalars['Boolean']['output'];
};

export type FormInviters = {
  email?: Maybe<Scalars['String']['output']>;
  mobile?: Maybe<Scalars['String']['output']>;
};

/** The connection type for FormInviters. */
export type FormInvitersConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<FormInvitersEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<FormInviters>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type FormInvitersEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<FormInviters>;
};

export type FormMergedNewEntryActivity = {
  formInfo: FormActivityBaseInfo;
};

export type FormNewEntryActivity = {
  formInfo: FormActivityBaseInfo;
};

export type FormOperation = {
  action: Scalars['String']['output'];
  form: Form;
  id: Scalars['ID']['output'];
  ownerName?: Maybe<Scalars['String']['output']>;
  performedAt: Scalars['ISO8601DateTime']['output'];
};

/** The connection type for FormOperation. */
export type FormOperationConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<FormOperationEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<FormOperation>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type FormOperationEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<FormOperation>;
};

export enum FormOperationQuery {
  DeletedForms = 'deleted_forms',
  TransferForms = 'transfer_forms'
}

export type FormOwner = {
  avatarUrl?: Maybe<Scalars['String']['output']>;
  billingAccount?: Maybe<BillingAccount>;
  /** 用户在系统中展示的名字，优先级为：企业身份下的名字 -> 微信昵称 -> 昵称 -> 邮箱 -> 手机号 */
  displayName: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  mobile?: Maybe<Scalars['String']['output']>;
  status: UserStatus;
  weixinQiyeUser?: Maybe<WeixinQiyeUser>;
};


export type FormOwnerDisplayNameArgs = {
  privacyProtect?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FormRecommendedCooperators = {
  avatarUrl?: Maybe<Scalars['String']['output']>;
  billingAccount?: Maybe<BillingAccount>;
  /** 协作者在当前文件夹中的直接角色 */
  directRole?: Maybe<FormRole>;
  /** 用户在系统中展示的名字，优先级为：企业身份下的名字 -> 微信昵称 -> 昵称 -> 邮箱 -> 手机号 */
  displayName: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  /** 外部联系人权限 */
  externalAttachAbilities?: Maybe<Array<FormRoleUserExternalAbilitiesType>>;
  /** 协作者在当前表单中的角色 */
  formRole: FormRole;
  id: Scalars['ID']['output'];
  /** 协作者在当前文件夹中的继承角色 */
  inheritedRole?: Maybe<FormRole>;
  mobile?: Maybe<Scalars['String']['output']>;
  status: UserStatus;
  weixinQiyeUser?: Maybe<WeixinQiyeUser>;
};


export type FormRecommendedCooperatorsDisplayNameArgs = {
  privacyProtect?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The connection type for FormRecommendedCooperators. */
export type FormRecommendedCooperatorsConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<FormRecommendedCooperatorsEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<FormRecommendedCooperators>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type FormRecommendedCooperatorsEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<FormRecommendedCooperators>;
};

export type FormRedirectRule = RuleTriggerOperator & {
  /** 或/且 */
  operator: FieldRuleTriggerConditionGroupOperator;
  /** 跳转链接 */
  redirectUrl: Scalars['String']['output'];
  /** 规则集 */
  ruleSets: Array<RuleSet>;
};

export type FormRole = WithConditionalScope & {
  /** currentUser在此表单下的权限集 */
  abilities: Array<FormRoleAbility>;
  conditionalScope: Scalars['Boolean']['output'];
  /** 表单角色权限介绍 */
  description: Scalars['String']['output'];
  /** 字段操作权限 */
  fieldAbilities: Array<FormRoleFieldAbility>;
  formInviters?: Maybe<FormInvitersConnection>;
  formRoleUsers?: Maybe<FormRoleUsersConnection>;
  /** 可读的ScopeCondition */
  humanReadableText?: Maybe<Scalars['String']['output']>;
  /** 表单角色ID */
  id: Scalars['ID']['output'];
  /** 表单角色名 */
  name: Scalars['String']['output'];
  /** 无【编辑权限】的字段 api codes */
  notAllowedFieldApiCodesForEdit: Array<Scalars['String']['output']>;
  /** 无【新增权限】的字段 api codes */
  notAllowedFieldApiCodesForNew: Array<Scalars['String']['output']>;
  /** 无【查看权限】的字段 api codes */
  notAllowedFieldApiCodesForRead: Array<Scalars['String']['output']>;
  /** 原生的表单角色名 */
  originalName: Scalars['String']['output'];
  /** 是否为系统默认角色，true - 是，false - 不是 */
  predefined: Scalars['Boolean']['output'];
  scopeConditions?: Maybe<Array<ScopeCondition>>;
};


export type FormRoleFormInvitersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type FormRoleFormRoleUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export enum FormRoleAbility {
  DataDelete = 'data_delete',
  DataEdit = 'data_edit',
  DataExport = 'data_export',
  DataNew = 'data_new',
  DataRead = 'data_read',
  FormManage = 'form_manage'
}

export type FormRoleAttributes = {
  /** 字段操作权限 */
  abilities?: InputMaybe<Array<FormRoleAbility>>;
  /** 设置数据范围 */
  conditionalScope?: InputMaybe<Scalars['Boolean']['input']>;
  /** 字段操作权限 */
  fieldAbilitiesAttributes?: InputMaybe<Array<FormRoleFieldAbilityAttributes>>;
  /** 名称 */
  name: Scalars['String']['input'];
  /** 数据条件 */
  scopeConditions?: InputMaybe<Array<ScopeConditionAttributes>>;
};

/** The connection type for FormRole. */
export type FormRoleConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<FormRoleEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<FormRole>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type FormRoleEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<FormRole>;
};

export enum FormRoleEntryOperator {
  Edit = 'edit',
  Export = 'export',
  New = 'new',
  Read = 'read'
}

export type FormRoleFieldAbility = {
  /** 字段api_code */
  abilities?: Maybe<Array<FormRoleFieldAbilityType>>;
  /** 字段api_code */
  fieldApiCode: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type FormRoleFieldAbilityAttributes = {
  abilities?: InputMaybe<Array<FormRoleFieldAbilityType>>;
  fieldApiCode: Scalars['String']['input'];
  /** 字段操作权限单条id，更新时需要带上 */
  id?: InputMaybe<Scalars['ID']['input']>;
};

export enum FormRoleFieldAbilityType {
  /** Data edit */
  DataEdit = 'data_edit',
  /** Data export */
  DataExport = 'data_export',
  /** Data new */
  DataNew = 'data_new',
  /** Data read */
  DataRead = 'data_read'
}

export enum FormRoleUserExternalAbilitiesType {
  /** Data export */
  DataExport = 'data_export',
  /** Send SMS and email */
  SendSmsAndEmail = 'send_sms_and_email'
}

export type FormRoleUsers = {
  user: FormCooperators;
};

/** The connection type for FormRoleUsers. */
export type FormRoleUsersConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<FormRoleUsersEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<FormRoleUsers>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type FormRoleUsersEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<FormRoleUsers>;
};

export type FormSmsSignatureFailActivity = {
  formInfo: FormActivityBaseInfo;
};

export type FormSetting = AfterSubmission & AppConflictCheck & CloseRule & FillInRule & PaymentSetting & {
  /**
   * 查看/查询的密码
   * @deprecated 为了和 updateFormSetting mutation 兼容，请使用 accessPolicySetting 字段。
   */
  accessPassword?: Maybe<Scalars['String']['output']>;
  /** 限定填写设置 */
  accessPolicySetting?: Maybe<AccessPolicySetting>;
  alipayAccount?: Maybe<AlipayAccount>;
  /** 允许搜索引擎收录 */
  allowSearchEngineIndex: Scalars['Boolean']['output'];
  /**
   * 谁能看
   * @deprecated 为了和 updateFormSetting mutation 兼容，请使用 accessPolicySetting 字段。
   */
  allowedAudience: AllowedAudience;
  /** 绑定到此表单的插件中心插件信息 */
  appBindings: Array<AppBinding>;
  availableAllowedAudiences: Array<AllowedAudience>;
  /** 是否绑定旧核销码插件 */
  bindingLegacyCodeVerify: Scalars['Boolean']['output'];
  /** 数据条数关闭表单规则 */
  byEntriesCloseRule?: Maybe<ByEntriesCloseRule>;
  /** 数据收集时间之开启/停止时间 */
  byTimeRangeCloseRule?: Maybe<ByTimeRangeCloseRule>;
  canChangeCurrency?: Maybe<Scalars['Boolean']['output']>;
  /** 允许填写者在登录后修改结果 */
  canChangeEntry: Scalars['Boolean']['output'];
  /**
   * 达到限填后是否允许取消预约
   * @deprecated 为了和 updateFormSetting mutation 兼容，请使用 accessPolicySetting 字段。
   */
  cancelReservationFillFrequencyLimited: Scalars['Boolean']['output'];
  /** 是否已启用证书 */
  certificateEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** 友盟 U-WEB 网站统计 */
  cnzzId?: Maybe<Scalars['String']['output']>;
  /** 联系人标签规则 */
  contactTagRules?: Maybe<ContactTagRuleConnection>;
  currency?: Maybe<Currency>;
  /** 自定义打印URL */
  customPrintUrl?: Maybe<Scalars['String']['output']>;
  /** 自定义统计 JS */
  customTrackjs?: Maybe<Scalars['String']['output']>;
  /** 每日开放填写时间 */
  dailyRepeatCloseRule?: Maybe<DailyRepeatCloseRule>;
  /** 表单开启/关闭状态描述文本 */
  dataCollectionStatusText: Scalars['String']['output'];
  /** 禁止返回上一页 */
  disablePreviousPage: Scalars['Boolean']['output'];
  /** 填表后可修改已填数据 */
  editEntryOnSuccess?: Maybe<Scalars['Boolean']['output']>;
  /** 提交前需填写验证码 */
  enableCaptcha: Scalars['Boolean']['output'];
  /** 显示分享二维码 */
  enableQrcode: Scalars['Boolean']['output'];
  /** 为填写者填写时自动保存 */
  enableRecovery: Scalars['Boolean']['output'];
  /** 为填表者开启智能填写 */
  enableSmartFill: Scalars['Boolean']['output'];
  /** 成功页展示功能 */
  endingActionsDisplayOrder?: Maybe<EndingActionsDisplayOrder>;
  /** 历史数据入口的信息 */
  entranceOpenEntry?: Maybe<OpenEntry>;
  /**
   * 到达限填后展示数据的设置
   * @deprecated 为了和 updateFormSetting mutation 兼容，请使用 accessPolicySetting 字段。
   */
  entriesActionFillFrequencyLimited?: Maybe<OpenEntriesAction>;
  /** 微信提交人可以修改48小时内填写的最近一条数据 */
  entryChangeableByWeixinSubmitter: Scalars['Boolean']['output'];
  /** Webhook POST 推送 URL */
  entryPostUrl?: Maybe<Scalars['String']['output']>;
  /** 提交后动作类型 */
  entrySubmitMode?: Maybe<EntrySubmitMode>;
  /** 提交数据前需要获取weixin openid */
  entryWeixinOpenidRequired: Scalars['Boolean']['output'];
  /** 场景化可配置表单设置 */
  extraConfigurableSettings?: Maybe<Array<ExtraConfigurableFormSetting>>;
  /**
   * 填写限制规则
   * @deprecated 为了和 updateFormSetting mutation 兼容，请使用 accessPolicySetting 字段。
   */
  fillFrequency?: Maybe<FillFrequency>;
  /** 填写限制描述 */
  fillRuleSummary?: Maybe<Scalars['String']['output']>;
  /** 在网页中嵌入悬浮按钮 */
  floatShareBtn?: Maybe<FloatShareBtn>;
  /** 裂变海报 */
  formDistribution?: Maybe<FormDistribution>;
  /** 表单ID */
  formId: Scalars['ID']['output'];
  /** Google Analytics 跟踪 ID */
  gaId?: Maybe<Scalars['String']['output']>;
  /** 是否启用确认码 */
  genCodeEnabled: Scalars['Boolean']['output'];
  /** 确认码格式 */
  genCodeFormat: GenCodeFormat;
  /** 确认码标签 */
  genCodeLabel: Scalars['String']['output'];
  /** 确认码规则 */
  genCodeRules?: Maybe<Array<GenCodeRule>>;
  /** 提交后隐藏登录注册 */
  hideLoginAndSignup?: Maybe<Scalars['Boolean']['output']>;
  /**
   * 当allowed_audience为sms_verification需要设置。表示：验证身份时，是否使用特定的手机号。true：使用，false：不使用
   * @deprecated 为了和 updateFormSetting mutation 兼容，请使用 accessPolicySetting 字段。
   */
  isSpecifiedVerifier: Scalars['Boolean']['output'];
  /** Available values: ["en"] */
  locale: Scalars['String']['output'];
  /** 是否投放了腾讯社交广告 */
  lockedByEQq: Scalars['Boolean']['output'];
  /** 表单手机字段短信验证的签名 */
  luosimaoSmsSignature?: Maybe<Signature>;
  /** 手动开启关闭表单数据收集开关设置 */
  manuallyCloseRule: ManuallyCloseRule;
  /** 美洽企业 ID 号 */
  meiqiaId?: Maybe<Scalars['String']['output']>;
  merchantAccount?: Maybe<MerchantAccount>;
  /** 历史数据入口的信息 */
  openEntries?: Maybe<Array<OpenEntry>>;
  /** 是否允许填表人查看修改历史数据，hide: 不允许查看, view: 允许查看, edit: 允许查看修改 */
  openEntryAction: Scalars['String']['output'];
  /** 是否允许取消预约 */
  openEntryCancelReservation: Scalars['Boolean']['output'];
  /** open entry的提示文案 */
  openEntryMessage?: Maybe<Scalars['String']['output']>;
  /** 结果分享 */
  openResults?: Maybe<OpenResultConnection>;
  /** 对外查询 */
  openSearches?: Maybe<OpenSearchConnection>;
  /**
   * 是否凭密码查看/查询，true：凭密码打开，false：不需要密码
   * @deprecated 为了和 updateFormSetting mutation 兼容，请使用 accessPolicySetting 字段。
   */
  passwordRequired: Scalars['Boolean']['output'];
  /** 【DEPRECATED】请使用 payment_source_type */
  paymentAccountType?: Maybe<PaymentAccountEnum>;
  /** 支付渠道，目前仅支持 wxpay 和 alipay。不论是模拟支付、第三方支付，还是金数据商户平台，最终只有 wxpay 和 alipay 两种支付渠道。 */
  paymentChannels: Array<PaymentChannel>;
  /** 是否开启交易超时 */
  paymentExpirable?: Maybe<Scalars['Boolean']['output']>;
  /** 超时时间 */
  paymentExpirationTime?: Maybe<Scalars['BigInteger']['output']>;
  /** 【next webapp】当前的支付渠道来自哪里，目前仅支持 third_party、merchant 和 mock。 */
  paymentSourceType?: Maybe<PaymentSource>;
  paymentWay?: Maybe<PaymentWay>;
  pingppAccount?: Maybe<PingppAccount>;
  /** 只用于前端类型定义，不会在后端使用 */
  pingppChannel?: Maybe<PingppChannel>;
  /** Webhook 是否推送填写设备、操作系统和浏览器等信息 */
  postMetainfo: Scalars['Boolean']['output'];
  /** Webhook 是否推送新增数据 */
  postNewEntry: Scalars['Boolean']['output'];
  /** Webhook 是否推送变更数据 */
  postUpdatedEntry: Scalars['Boolean']['output'];
  /** 当前选中的海报 */
  poster: Poster;
  /** 二维码海报自定义图片/AI生成图片 */
  posterBackground?: Maybe<PosterBackground>;
  /** 举报链接地址 */
  reportLinkUrl: Scalars['String']['output'];
  /** 提交后显示返回门户按钮 */
  showBackToPortal?: Maybe<Scalars['Boolean']['output']>;
  /** 在表单中显示停止倒计时 */
  showCloseCountDown: Scalars['Boolean']['output'];
  /** 填表后展示已填数据 */
  showEntryOnSuccess?: Maybe<Scalars['Boolean']['output']>;
  /** 填表后展示已填数据按钮文案 */
  showEntryOnSuccessButtonText?: Maybe<Scalars['String']['output']>;
  /** 显示字段序号 */
  showFieldNumber: Scalars['Boolean']['output'];
  /** 表单开放前是否展示表单内容 */
  showFormBeforeOpen: Scalars['Boolean']['output'];
  /**
   * 当达到限填后，是否展示表单
   * @deprecated 为了和 updateFormSetting mutation 兼容，请使用 accessPolicySetting 字段。
   */
  showFormFillFrequencyLimited?: Maybe<Scalars['Boolean']['output']>;
  /** 显示填写进度条，true - 显示；false - 不显示 */
  showProgress: Scalars['Boolean']['output'];
  /** 显示举报链接 */
  showReportLink: Scalars['Boolean']['output'];
  /** 提交后显示结果链接 */
  showResultLinkAfterSubmit?: Maybe<Scalars['Boolean']['output']>;
  /** 提交后显示结果链接token */
  showResultLinkAfterSubmitToken?: Maybe<Scalars['String']['output']>;
  /** 提交后显示序号 */
  showSerialNumberOnSuccess?: Maybe<Scalars['Boolean']['output']>;
  /** 提交后显示社交分享 */
  showSocialSharing?: Maybe<Scalars['Boolean']['output']>;
  /** 提交后显示再次提交按钮 */
  showSubmitAgain?: Maybe<Scalars['Boolean']['output']>;
  /** 单条数据分享设置 */
  singleEntryShare?: Maybe<SingleEntryShare>;
  /** @deprecated 表单手机字段短信验证的签名(已废弃，请使用luosimao_sms_signature) */
  smsSignature?: Maybe<Scalars['String']['output']>;
  /**
   * 表单提交时，是否限制地区
   * @deprecated 为了和 updateFormSetting mutation 兼容，请使用 accessPolicySetting 字段。
   */
  submissionRegionLimited: Scalars['Boolean']['output'];
  /**
   * 表单提交时，限制地区
   * @deprecated 为了和 updateFormSetting mutation 兼容，请使用 accessPolicySetting 字段。
   */
  submissionRegions?: Maybe<Array<Scalars['String']['output']>>;
  submitterGroup?: Maybe<SubmitterGroup>;
  /**
   * 表单人群设置。限制群组及部分人群条件.
   * @deprecated 为了和 updateFormSetting mutation 兼容，请使用 accessPolicySetting 字段。
   */
  submitterSetting?: Maybe<FormSubmitterSetting>;
  /** 提交后展示描述 */
  successDescription?: Maybe<Scalars['String']['output']>;
  /** 提交后展示文案 */
  successMessage?: Maybe<Scalars['String']['output']>;
  /** 提交后展示图文 */
  successMessageRichText?: Maybe<Scalars['String']['output']>;
  /** 提交后展示提示类型 */
  successMessageStyle?: Maybe<SuccessMessageStyle>;
  /** 提交后跳转网页参数列表 */
  successRedirectFields?: Maybe<Array<Scalars['String']['output']>>;
  /** 提交后跳转网页链接 */
  successRedirectUrl?: Maybe<Scalars['String']['output']>;
  /** 53 客服网页代码 */
  thirdParty53kfEmbedJs?: Maybe<Scalars['String']['output']>;
  /** 是否使用金数据默认签名 */
  useGdSignature?: Maybe<Scalars['Boolean']['output']>;
  /**
   * 当allowed_audience为sms_verification需要设置。表示：特定手机号-身份验证的手机号
   * @deprecated 为了和 updateFormSetting mutation 兼容，请使用 accessPolicySetting 字段。
   */
  viewVerifiers?: Maybe<Array<Scalars['String']['output']>>;
  /**
   * 当allowed_audience为sms_verification需要设置。表示：验证身份时，表单中选择的手机认证字段api_code
   * @deprecated 为了和 updateFormSetting mutation 兼容，请使用 accessPolicySetting 字段。
   */
  viewVerifyFieldApiCode?: Maybe<Scalars['String']['output']>;
  /** 绑定的微信服务号 */
  weixinAccount?: Maybe<WeixinAccount>;
  /** 收集更多微信信息 */
  weixinCollectMoreInfoEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** 收集微信信息 */
  weixinCollectWay: FormSettingWeixinCollectWay;
  /** 禁止在微信中分享（微信中隐藏右上角菜单） */
  weixinHideOptionMenu: Scalars['Boolean']['output'];
  /**
   * 是否仅限在微信/企业微信中
   * @deprecated 为了和 updateFormSetting mutation 兼容，请使用 accessPolicySetting 字段。
   */
  weixinLimited: Scalars['Boolean']['output'];
  /** 分享到微信标题描述设置 */
  weixinShareInfo: WeixinShareInfo;
  /** 分享到微信的链接图标 */
  weixinThumbnail: WeixinThumbnail;
  /** 是否已启用幸运大转盘 */
  wheelFortuneEnabled?: Maybe<Scalars['Boolean']['output']>;
  /**
   * 用户自定义的提示文案
   * @deprecated 请使用 wordingSetting
   */
  wording: Scalars['String']['output'];
  /** 用户自定义的提示文案设置（for luigi） */
  wordingSetting?: Maybe<WordingSetting>;
  /** 微信公众号发布偏好设置 */
  wxOfficialAccountPublicationSetting?: Maybe<WxOfficialAccountPublicationSetting>;
  wxpayAccount?: Maybe<WxpayAccount>;
};


export type FormSettingContactTagRulesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type FormSettingExtraConfigurableSettingsArgs = {
  configurableType?: InputMaybe<Scalars['String']['input']>;
};


export type FormSettingOpenResultsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type FormSettingOpenSearchesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type FormSettingWordingArgs = {
  key: FormSettingWordingKey;
};

export type FormSettingAccessPolicyAttributes = {
  /** 查看/查询的密码 */
  accessPassword?: InputMaybe<Scalars['String']['input']>;
  /** 谁能看 */
  allowedAudience: AllowedAudience;
  /** 达到限填后是否允许取消预约 */
  cancelReservationFillFrequencyLimited?: InputMaybe<Scalars['Boolean']['input']>;
  /** 到达限填后展示数据的设置 */
  entriesActionFillFrequencyLimited?: InputMaybe<OpenEntriesAction>;
  /** 填写限制规则 */
  fillFrequency?: InputMaybe<FillFrequencyAttributes>;
  /** 当allowed_audience为sms_verification需要设置。表示：是否使用特定的手机号验证身份。true：使用，false：不使用 */
  isSpecifiedVerifier?: InputMaybe<Scalars['Boolean']['input']>;
  /** 是否凭密码查看/查询，true：凭密码打开，false：不需要密码 */
  passwordRequired?: InputMaybe<Scalars['Boolean']['input']>;
  /** 当达到限填后，是否展示表单 */
  showFormFillFrequencyLimited?: InputMaybe<Scalars['Boolean']['input']>;
  /** 表单提交时，是否限制地区 */
  submissionRegionLimited?: InputMaybe<Scalars['Boolean']['input']>;
  /** 表单提交时，限制地区 */
  submissionRegions?: InputMaybe<Array<Scalars['String']['input']>>;
  /** submitter部分限填条件 */
  submitterSettingAttributes?: InputMaybe<SubmitterConditionalScopeAttributes>;
  /** 当allowed_audience为sms_verification需要设置。表示：特定手机号-身份验证的手机号 */
  viewVerifiers?: InputMaybe<Array<Scalars['String']['input']>>;
  /** 当allowed_audience为sms_verification需要设置。表示：验证身份时，表单中选择的手机认证字段api_code */
  viewVerifyFieldApiCode?: InputMaybe<Scalars['String']['input']>;
  /** 是否仅在微信可填 */
  weixinLimited?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FormSettingAttributes = {
  /** 限定填表人群 */
  accessPolicySetting?: InputMaybe<FormSettingAccessPolicyAttributes>;
  /** 支付宝账户id */
  alipayAccountId?: InputMaybe<Scalars['ID']['input']>;
  /** 允许搜索引擎收录 */
  allowSearchEngineIndex?: InputMaybe<Scalars['Boolean']['input']>;
  /** 数据收集条数限制 */
  byEntriesCloseRule?: InputMaybe<ByEntriesCloseRuleAttributes>;
  /** 数据收集时间之开启/停止时间 */
  byTimeRangeCloseRule?: InputMaybe<ByTimeRangeCloseRuleAttributes>;
  /** 允许填写者在登录金数据后修改结果 */
  canChangeEntry?: InputMaybe<Scalars['Boolean']['input']>;
  /** 表单证书设置 */
  certificateSetting?: InputMaybe<SettingFormCertificateSettingAttributes>;
  /** 友盟 U-WEB 网站统计 */
  cnzzId?: InputMaybe<Scalars['String']['input']>;
  /** 货币 */
  currency?: InputMaybe<CurrencyIso>;
  /** 自定义统计 JS */
  customTrackjs?: InputMaybe<Scalars['String']['input']>;
  /** 数据收集每日重复开启/停止时间 */
  dailyRepeatCloseRule?: InputMaybe<DailyRepeatCloseRuleAttributes>;
  /** 卡片式表单是否禁止返回上一页, true - 禁止， false - 允许，默认为false */
  disablePreviousPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** 填表后可修改已填数据 */
  editEntryOnSuccess?: InputMaybe<Scalars['Boolean']['input']>;
  /** 提交前需填写验证码 */
  enableCaptcha?: InputMaybe<Scalars['Boolean']['input']>;
  /** 显示分享二维码 */
  enableQrcode?: InputMaybe<Scalars['Boolean']['input']>;
  /** 为填写者填写时自动保存 */
  enableRecovery?: InputMaybe<Scalars['Boolean']['input']>;
  /** 为填表者开启智能填写 */
  enableSmartFill?: InputMaybe<Scalars['Boolean']['input']>;
  /** 成功页展示功能 */
  endingActionsDisplayOrder?: InputMaybe<FormSettingEndingActionsDisplayOrderAttributes>;
  /** 微信中填表后允许填表人修改 */
  entryChangeableByWeixinSubmitter?: InputMaybe<Scalars['Boolean']['input']>;
  /** Webhook POST 推送 URL */
  entryPostUrl?: InputMaybe<Scalars['String']['input']>;
  /** 提交后动作类型 */
  entrySubmitMode?: InputMaybe<EntrySubmitMode>;
  /** 表单依据场景化的个性化设置 */
  extraConfigurableSettings?: InputMaybe<Array<FormSettingExtraConfigurableSettingAttributes>>;
  /** 在网页中嵌入悬浮按钮 */
  floatShareBtn?: InputMaybe<FloatShareBtnAttributes>;
  /** Google Analytics 跟踪 ID */
  gaId?: InputMaybe<Scalars['String']['input']>;
  /** 开关确认码 */
  genCodeEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** 确认码格式 */
  genCodeFormat?: InputMaybe<GenCodeFormat>;
  /** 确认码标签 */
  genCodeLabel?: InputMaybe<Scalars['String']['input']>;
  /** 确认码规则 */
  genCodeRulesAttributes?: InputMaybe<Array<GenCodeRulesAttributes>>;
  /** 提交后隐藏登录注册 */
  hideLoginAndSignup?: InputMaybe<Scalars['Boolean']['input']>;
  /** Available values: ["en"] */
  locale?: InputMaybe<Scalars['String']['input']>;
  /** 表单手机字段短信验证的签名 */
  luosimaoSmsSignatureId?: InputMaybe<Scalars['ID']['input']>;
  /** 手动开启关闭表单数据收集开关设置 */
  manuallyCloseRule?: InputMaybe<ManuallyCloseRuleAttributes>;
  /** 美洽企业 ID 号 */
  meiqiaId?: InputMaybe<Scalars['String']['input']>;
  /** 商户平台id */
  merchantAccountId?: InputMaybe<Scalars['ID']['input']>;
  /** 是否允许填表人查看修改历史数据，hide: 不允许查看, view: 允许查看, edit: 允许查看修改 */
  openEntryAction?: InputMaybe<Scalars['String']['input']>;
  /** 是否允许取消预约 */
  openEntryCancelReservation?: InputMaybe<Scalars['Boolean']['input']>;
  /** open entry的提示文案 */
  openEntryMessage?: InputMaybe<Scalars['String']['input']>;
  /** 是否开启交易超时 */
  paymentExpirable?: InputMaybe<Scalars['Boolean']['input']>;
  /** 超时时间 */
  paymentExpirationTime?: InputMaybe<Scalars['BigInteger']['input']>;
  /** 支付方式设置 */
  paymentWay?: InputMaybe<PaymentWay>;
  /** Ping++账户id */
  pingppAccountId?: InputMaybe<Scalars['ID']['input']>;
  /** Webhook 是否推送填写设备、操作系统和浏览器等信息 */
  postMetainfo?: InputMaybe<Scalars['Boolean']['input']>;
  /** Webhook 是否推送新增数据 */
  postNewEntry?: InputMaybe<Scalars['Boolean']['input']>;
  /** Webhook 是否推送变更数据 */
  postUpdatedEntry?: InputMaybe<Scalars['Boolean']['input']>;
  /** 提交后显示返回门户按钮 */
  showBackToPortal?: InputMaybe<Scalars['Boolean']['input']>;
  /** 在表单中显示停止倒计时 */
  showCloseCountDown?: InputMaybe<Scalars['Boolean']['input']>;
  /** 填表后展示已填数据 */
  showEntryOnSuccess?: InputMaybe<Scalars['Boolean']['input']>;
  /** 填表后展示已填数据按钮文案 */
  showEntryOnSuccessButtonText?: InputMaybe<Scalars['String']['input']>;
  /** 显示字段序号 */
  showFieldNumber?: InputMaybe<Scalars['Boolean']['input']>;
  /** 表单开启前是否展示表单 */
  showFormBeforeOpen?: InputMaybe<Scalars['Boolean']['input']>;
  /** 显示填写进度条 */
  showProgress?: InputMaybe<Scalars['Boolean']['input']>;
  /** 提交后显示结果链接 */
  showResultLinkAfterSubmit?: InputMaybe<Scalars['Boolean']['input']>;
  /** 提交后显示结果链接token */
  showResultLinkAfterSubmitToken?: InputMaybe<Scalars['String']['input']>;
  /** 提交后显示序号 */
  showSerialNumberOnSuccess?: InputMaybe<Scalars['Boolean']['input']>;
  /** 提交后显示社交分享 */
  showSocialSharing?: InputMaybe<Scalars['Boolean']['input']>;
  /** 提交后显示再次提交按钮 */
  showSubmitAgain?: InputMaybe<Scalars['Boolean']['input']>;
  /** 提交后展示描述 */
  successDescription?: InputMaybe<Scalars['String']['input']>;
  /** 提交后展示文案 */
  successMessage?: InputMaybe<Scalars['String']['input']>;
  /** 提交后展示图文 */
  successMessageRichText?: InputMaybe<Scalars['String']['input']>;
  /** 提交后展示提示类型 */
  successMessageStyle?: InputMaybe<SuccessMessageStyle>;
  /** 提交后跳转网页参数列表 */
  successRedirectFields?: InputMaybe<Array<Scalars['String']['input']>>;
  /** 提交后跳转网页链接 */
  successRedirectUrl?: InputMaybe<Scalars['String']['input']>;
  /** 53 客服网页代码 */
  thirdParty53kfEmbedJs?: InputMaybe<Scalars['String']['input']>;
  /** 是否使用金数据默认签名 */
  useGdSignature?: InputMaybe<Scalars['Boolean']['input']>;
  /** 绑定的微信公众号 */
  weixinAccountId?: InputMaybe<Scalars['ID']['input']>;
  /** 收集填写者微信信息-是否收集更多信息 */
  weixinCollectMoreInfoEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** 收集填写者微信信息-通过哪种方式收集 */
  weixinCollectWay?: InputMaybe<FormSettingWeixinCollectWay>;
  /** 禁止在微信中分享（微信中隐藏右上角菜单） */
  weixinHideOptionMenu?: InputMaybe<Scalars['Boolean']['input']>;
  /** 是否仅在微信可填, deprecated */
  weixinLimited?: InputMaybe<Scalars['Boolean']['input']>;
  /** 分享到微信-标题，描述 */
  weixinShareInfo?: InputMaybe<WeixinShareInfoAttributes>;
  /** 分享到微信-图标 */
  weixinThumbnail?: InputMaybe<WeixinShareThumbnailAttributes>;
  /** 提示文案, deprecated，请用 wordingSetting */
  wording?: InputMaybe<WordingAttributes>;
  /** 提示文案 */
  wordingSetting?: InputMaybe<WordingAttributes>;
  /** 微信公众号发布设置 */
  wxOfficialAccountPublicationSetting?: InputMaybe<WxOfficialAccountPublicationSettingAttributes>;
  /** 微信支付账户id */
  wxpayAccountId?: InputMaybe<Scalars['ID']['input']>;
};

export type FormSettingEndingActionsDisplayOrderAttributes = {
  /** 测评报告展示功能 */
  showEvaluationReports?: InputMaybe<Array<EndingActionFeature>>;
  /** 成绩单展示功能 */
  showExamScore?: InputMaybe<Array<EndingActionFeature>>;
  /** 结束页展示功能 */
  showMessagePage?: InputMaybe<Array<EndingActionFeature>>;
};

export enum FormSettingExtraConfigurableFormSettingClassType {
  /** 测评 */
  Evaluation = 'Evaluation',
  /** 考试 */
  Exam = 'Exam',
  /** 报名 */
  Registry = 'Registry'
}

export type FormSettingExtraConfigurableSettingAttributes = {
  /** 防作弊设置 */
  antiCheatingSetting?: InputMaybe<AntiCheatingSettingAttributes>;
  /** 报告背景模式为customize时的自定义颜色 */
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  /** 报告背景模式: recommendation - 系统推荐背景, follow_form - 跟随表单背景, customize - 自定义背景 */
  backgroundMode?: InputMaybe<EvaluationBackgroundMode>;
  /** 根据测评分数显示不同文案是否开启。true - 开启；false - 关闭 */
  enableEvaluationComments?: InputMaybe<Scalars['Boolean']['input']>;
  /** 根据考试分数显示不同文案是否开启。true - 开启；false - 关闭 */
  enableExamComments?: InputMaybe<Scalars['Boolean']['input']>;
  /** 根据分数显示的不同文案 */
  evaluationCommentSettings?: InputMaybe<Array<RecommendationCommentSettingAttributes>>;
  /** 根据分数显示的不同文案 */
  examCommentSettings?: InputMaybe<Array<RecommendationCommentSettingAttributes>>;
  /** 填写布局 */
  fillLayout?: InputMaybe<FillLayout>;
  /** 维度设置 */
  indicatorSetting?: InputMaybe<IndicatorSettingAttributes>;
  /** 考试/测评限时。单位：分钟 */
  limitedTime?: InputMaybe<Scalars['Int']['input']>;
  /** 考前须知提示内容/测评须知提示内容 */
  needAttention?: InputMaybe<Scalars['String']['input']>;
  /** 提交后展示类型 */
  noticeAfterFillingMode?: InputMaybe<Scalars['String']['input']>;
  /** 随机出题-按题型抽取。题型设置 */
  questionSettings?: InputMaybe<Array<QuestionSettingAttributes>>;
  /** 随机出题是否开启。true - 开启；false - 关闭 */
  randomQuestions?: InputMaybe<Scalars['Boolean']['input']>;
  /** 随机出题-从所有题目中抽取。抽取题目数量 */
  randomQuestionsCount?: InputMaybe<Scalars['Int']['input']>;
  /** 随机出题是否打乱题目顺序。true - 打乱顺序；false - 不打乱顺序 */
  randomQuestionsOrder?: InputMaybe<Scalars['Boolean']['input']>;
  /** 随机出题-按题型抽取是否开启。true - 开启；false - 关闭 */
  randomQuestionsWithType?: InputMaybe<Scalars['Boolean']['input']>;
  /** 开启测评评语 */
  showComments?: InputMaybe<Scalars['Boolean']['input']>;
  /** 是否展示考前/测评须知。true - 展示；false - 不展示 */
  showDispatcherStructure?: InputMaybe<Scalars['Boolean']['input']>;
  /** 是否显示测评结果分析（各维度结果与建议） */
  showIndicatorComments?: InputMaybe<Scalars['Boolean']['input']>;
  /** 是否展示题目结构。true - 展示；false - 不展示 */
  showQuestionSettingsStructure?: InputMaybe<Scalars['Boolean']['input']>;
  /** 是否显示测评雷达图 */
  showReportRadar?: InputMaybe<Scalars['Boolean']['input']>;
  /** 是否显示测评得分 */
  showReportScore?: InputMaybe<Scalars['Boolean']['input']>;
  /** 是否显示测评结果（得分与雷达图） */
  showReports?: InputMaybe<Scalars['Boolean']['input']>;
  /** 限时答题是否开启。true - 开启；false - 关闭 */
  showTimeout?: InputMaybe<Scalars['Boolean']['input']>;
  /** 开始答题按钮文案 */
  startToAnswerButtonText?: InputMaybe<Scalars['String']['input']>;
  /** 提交后显示的感谢参与文案 */
  successMessageRichText?: InputMaybe<Scalars['String']['input']>;
  /** 场景化可配置字段设置类型 */
  type: FormSettingExtraConfigurableFormSettingClassType;
};

export enum FormSettingWeixinCollectWay {
  /** Goldendata */
  Goldendata = 'goldendata',
  /** Not collect */
  NotCollect = 'not_collect',
  /** Own */
  Own = 'own',
  /** Own weixin qiye */
  OwnWeixinQiye = 'own_weixin_qiye',
  /** Yamcha */
  Yamcha = 'yamcha'
}

export enum FormSettingWordingKey {
  AlreadyClosed = 'already_closed',
  AlreadyClosedRichText = 'already_closed_rich_text',
  FillFrequencyLimited = 'fill_frequency_limited',
  FillFrequencyLimitedHideForm = 'fill_frequency_limited_hide_form',
  FillFrequencyLimitedShowForm = 'fill_frequency_limited_show_form',
  NotOpen = 'not_open',
  NotOpenHideForm = 'not_open_hide_form',
  NotOpenShowForm = 'not_open_show_form',
  RegionLimited = 'region_limited',
  SearchResultByPassword = 'search_result_by_password',
  Start = 'start',
  Submit = 'submit',
  SubmitByPassword = 'submit_by_password',
  ViewResultByPassword = 'view_result_by_password'
}

export type FormShareRoleActivity = {
  formInfo: FormActivityBaseInfo;
  targetType: Scalars['String']['output'];
  userName: Scalars['String']['output'];
};

export type FormStats = {
  /** @deprecated 已填写的填表人数量 */
  entrySubmitterCount?: Maybe<Scalars['Int']['output']>;
  /** 表单是否含有日级别的统计数据(最大范围是一年前) */
  hasYearlyStats?: Maybe<Scalars['Boolean']['output']>;
  /** 回填率百分比 */
  submitterResponsePercent?: Maybe<Scalars['Float']['output']>;
  /** 今日提交量 */
  todayFillCount: Scalars['Int']['output'];
  /** 今日浏览量 */
  todayViewCount: Scalars['Int']['output'];
  /** 总提交量 */
  totalFillCount: Scalars['Int']['output'];
  /** 总浏览量 */
  totalViewCount: Scalars['Int']['output'];
};

export type FormSubmitter = {
  entry?: Maybe<Entry>;
  submitter: Submitter;
};

/** The connection type for FormSubmitter. */
export type FormSubmitterConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<FormSubmitterEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<FormSubmitter>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type FormSubmitterEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<FormSubmitter>;
};

export type FormSubmitterSetting = WithConditionalScope & {
  conditionalScope: Scalars['Boolean']['output'];
  scopeConditions?: Maybe<Array<ScopeCondition>>;
  submitterGroup: SubmitterGroup;
  submitterVisible?: Maybe<Form>;
};


export type FormSubmitterSettingSubmitterVisibleArgs = {
  q?: InputMaybe<Scalars['String']['input']>;
};

/** The connection type for FormSubmitterSetting. */
export type FormSubmitterSettingConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<FormSubmitterSettingEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<FormSubmitterSetting>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type FormSubmitterSettingEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<FormSubmitterSetting>;
};

export type FormSymbol = {
  /** 表单、文件夹颜色 */
  backgroundColor: Scalars['String']['output'];
  /** 表单、文件夹图标 */
  icon: Scalars['String']['output'];
};

export type FormSymbolAttributes = {
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
};

export type FormTag = {
  /** 标签ID */
  id: Scalars['ID']['output'];
  /** 标签名称 */
  name: Scalars['String']['output'];
  /** 标签排序 */
  order: Scalars['Int']['output'];
  /** 该标签文件夹+标签数量 */
  taggedCount: Scalars['Int']['output'];
};

export enum FormUsage {
  /** 作为表单场景使用 */
  Normal = 'normal',
  /** 作为客户信息表使用 */
  Submitter = 'submitter'
}

export type FormViewCreateAttributes = {
  filter?: InputMaybe<EntriesFilterAttributes>;
  /** 看板卡片标题字段 apiCode */
  kanbanCardTitleApiCode?: InputMaybe<Scalars['String']['input']>;
  /** 看板分组字段 apiCode */
  kanbanGroupByApiCode?: InputMaybe<Scalars['String']['input']>;
  /** 视图名称，用户/表单范围唯一 */
  name: Scalars['String']['input'];
  /** 显示列的 apiCode 顺序 */
  preferColumns?: InputMaybe<Array<Scalars['String']['input']>>;
  /** 排序列表 */
  sort?: InputMaybe<Array<SortColumnAttributes>>;
  /** 列顺序 */
  sortedColumns?: InputMaybe<Array<EntryColumnAttributes>>;
  /** 视图类型，默认 grid */
  viewType?: InputMaybe<FormViewTypeEnum>;
};

export type FormViewReorderAttributes = {
  /** FormView ID */
  id: Scalars['ID']['input'];
  /** 新的位置（从 0 开始） */
  position: Scalars['Int']['input'];
};

/** 表单数据页视图（用户私有） */
export type FormViewType = {
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** 筛选条件（持久化部分） */
  filter?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  /** 看板卡片标题字段 apiCode（未设置时回退为 prefer_columns 中第一个非分组、非系统字段；都没有时回退为分组字段本身） */
  kanbanCardTitleApiCode?: Maybe<Scalars['String']['output']>;
  /** 看板分组字段 apiCode */
  kanbanGroupByApiCode?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  position: Scalars['Int']['output'];
  /** 是否为系统预置视图（不可删除/不可改类型） */
  predefined: Scalars['Boolean']['output'];
  /** 显示列的 apiCode 顺序 */
  preferColumns: Array<Scalars['String']['output']>;
  /** 排序列表 */
  sort: Array<SortColumnType>;
  /** 列顺序（apiCode + position） */
  sortedColumns: Array<EntryColumn>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  viewType: FormViewTypeEnum;
};

/** 视图类型 */
export enum FormViewTypeEnum {
  /** Grid */
  Grid = 'grid',
  /** Kanban */
  Kanban = 'kanban',
  /** Stats */
  Stats = 'stats'
}

export type FormViewUpdateAttributes = {
  filter?: InputMaybe<EntriesFilterAttributes>;
  kanbanCardTitleApiCode?: InputMaybe<Scalars['String']['input']>;
  kanbanGroupByApiCode?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  preferColumns?: InputMaybe<Array<Scalars['String']['input']>>;
  sort?: InputMaybe<Array<SortColumnAttributes>>;
  sortedColumns?: InputMaybe<Array<EntryColumnAttributes>>;
  /** 视图类型 */
  viewType?: InputMaybe<FormViewTypeEnum>;
};

export type FormatValidatableField = {
  customValidationRegex?: Maybe<Scalars['String']['output']>;
  formatValidationEnabled: Scalars['Boolean']['output'];
  formatValidationJsRegex?: Maybe<JsRegex>;
  formatValidationType?: Maybe<FieldValidation>;
};

export type FormulaField = AssociatedField & BaseField & CalculableField & FieldAbility & NumericalField & PlanAvailableField & {
  apiCode: Scalars['ID']['output'];
  apiCodeAlias?: Maybe<Scalars['String']['output']>;
  /** 对应的表单关联字段 */
  associationField?: Maybe<Field>;
  /** 自动填写上次提交内容 */
  cacheData: Scalars['Boolean']['output'];
  /** 开启选项赋值或本身可参与计算 */
  calculable: Scalars['Boolean']['output'];
  /** 客户端ID */
  cid?: Maybe<Scalars['String']['output']>;
  /** 封装的字段类型 */
  customizedType?: Maybe<Scalars['String']['output']>;
  /** 封装的字段类型文本 */
  customizedTypeName?: Maybe<Scalars['String']['output']>;
  /** 自定义出错文案 */
  customizedValidationMessage?: Maybe<Scalars['String']['output']>;
  /** 项目列计算的操作符，当字段为矩阵填空和表格的项目时有用 */
  dimensionOperator?: Maybe<DimensionOperator>;
  /** 显示百分比 */
  displayAsPercentage: Scalars['Boolean']['output'];
  /** 已提交的数据是否可被编辑 */
  editable: Scalars['Boolean']['output'];
  /** 开启项目列计算，当字段为矩阵填空和表格的项目时有用 */
  enableDimensionCalculation: Scalars['Boolean']['output'];
  /** 该字段能否使用字段规则: true - 能， false - 不能 */
  fieldRuleAvailable: Scalars['Boolean']['output'];
  /** 是否是关联主键字段 */
  forAssociated?: Maybe<Scalars['Boolean']['output']>;
  /** 是否是关联展示字段 */
  forAssociatedDisplay?: Maybe<Scalars['Boolean']['output']>;
  /** 表单Token */
  formToken: Scalars['String']['output'];
  /** 公式 */
  formula: Scalars['String']['output'];
  /** 以字段标题为变量的公式 */
  formulaDisplay?: Maybe<Scalars['String']['output']>;
  /** 宽度占用整行的四分之几 */
  gridsToOccupy?: Maybe<Scalars['Int']['output']>;
  hasAbility: Scalars['Boolean']['output'];
  /** 用户选择的字段图标 */
  iconType: Scalars['String']['output'];
  /** 字段标题（去富文本化） */
  label?: Maybe<Scalars['String']['output']>;
  /** 字段描述，富文本 */
  notes?: Maybe<Scalars['String']['output']>;
  paidFeature?: Maybe<PaidFeature>;
  planAvailable: Scalars['Boolean']['output'];
  /** 字段排序 */
  position: Scalars['Int']['output'];
  /** 小数位数 */
  precision?: Maybe<Scalars['Int']['output']>;
  /** 该字段是否是隐私字段 true - 是, false - 不是 */
  privacy: Scalars['Boolean']['output'];
  /** 字段隐藏 */
  private: Scalars['Boolean']['output'];
  /** 字段是否通过预填写表单预设了值 true - 是, false - 否 */
  pseudoFormPredefined?: Maybe<Scalars['Boolean']['output']>;
  /** 字段标题（富文本化） */
  rawLabel?: Maybe<Scalars['String']['output']>;
  /** 字段是否只读，无法编辑 */
  readonly?: Maybe<Scalars['Boolean']['output']>;
  /** 参与计算的字段的apiCode */
  requiredFields: Array<Scalars['ID']['output']>;
  resultDisplayAsDate: Scalars['Boolean']['output'];
  /** 公式结果返回类型 */
  resultDisplayType?: Maybe<ValueTypeEnum>;
  /** 该字段是否属于评分字段（e.g. 考试、测评中的题目） */
  scorable: Scalars['Boolean']['output'];
  /** 字段提示较长时折叠展示 */
  showPartDescription: Scalars['Boolean']['output'];
  /** 新起一行 */
  startNewRow: Scalars['Boolean']['output'];
  /** 该字段是否可以作为文本插入 true - 能, false - 不能 */
  textPlaceholderable: Scalars['Boolean']['output'];
  /** 显示千位分隔符 */
  thousandsSeparator: Scalars['Boolean']['output'];
  /** 字段类型 */
  type: FieldClass;
  /** 字段类型文本 */
  typeName: Scalars['String']['output'];
  /** 字段验证规则 */
  validations?: Maybe<Array<FieldValidation>>;
  /** 公式中用到的字段变量 */
  variableFieldApiCodes: Array<Scalars['ID']['output']>;
};


export type FormulaFieldHasAbilityArgs = {
  key: FieldAbilityEnum;
};


export type FormulaFieldNotesArgs = {
  sanitize?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum FsfType {
  /** red_envelope_audit_state */
  RedEnvelopeAuditState = 'red_envelope_audit_state',
  /** reservation_status */
  ReservationStatus = 'reservation_status',
  /** wheel_fortune_prize_audit_state */
  WheelFortunePrizeAuditState = 'wheel_fortune_prize_audit_state'
}

export type GdCustomer = {
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export enum GdFormReportJob {
  /** Docx */
  Docx = 'docx',
  /** Png */
  Png = 'png'
}

export enum GdFormReportJobStatus {
  /** Completed */
  Completed = 'completed',
  /** Failed */
  Failed = 'failed',
  /** Running */
  Running = 'running'
}

export type GdMerchant = {
  /** 小金商户头像 */
  merchantAvatar?: Maybe<Attachment>;
  /** 小金商户名称 */
  merchantName?: Maybe<Scalars['String']['output']>;
  /** 小金商户编号 */
  merchantNo?: Maybe<Scalars['String']['output']>;
  /** 小金商户入网申请状态 */
  merchantRegisterApplicationStatus?: Maybe<MerchantRegisterApplicationStatus>;
  /** 小金商户入网申请的商户类型 */
  merchantRegisterApplicationType?: Maybe<MerchantRegisterApplication>;
  /** 小金商户渠道商 */
  merchantRegisterProvider?: Maybe<MerchantRegisterProvider>;
};

export type Geetest4Attributes = {
  captchaOutput: Scalars['String']['input'];
  genTime: Scalars['String']['input'];
  lotNumber: Scalars['String']['input'];
  passToken: Scalars['String']['input'];
  type: GeetestKeyEnum;
};

export type GeetestAttributes = {
  challenge: Scalars['String']['input'];
  digestMod?: InputMaybe<Scalars['String']['input']>;
  seccode: Scalars['String']['input'];
  type: GeetestKeyEnum;
  validate: Scalars['String']['input'];
};

export enum GeetestKeyEnum {
  Other = 'other',
  PublishedForm = 'published_form',
  SendSms = 'send_sms',
  SendSmsV4 = 'send_sms_v4',
  SmsAndroid = 'sms_android',
  SmsIos = 'sms_ios',
  SmsMiniapp = 'sms_miniapp',
  UserOauth = 'user_oauth'
}

export type GeetestRegister = {
  challenge?: Maybe<Scalars['String']['output']>;
  gt?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Int']['output']>;
};

export type GenCodeFormFieldRule = {
  /** 字段的 Api Code */
  apiCode: Scalars['String']['output'];
  /** 规则 ID */
  id: Scalars['ID']['output'];
  /** 规则位置 */
  position: Scalars['Int']['output'];
};

export enum GenCodeFormat {
  /** 自定义 */
  Custom = 'custom',
  /** 系统默认 */
  D8 = 'd8',
  /** 系统默认 */
  D12 = 'd12'
}

export type GenCodeRule = AutoCountRule | FixedCharactersRule | GenCodeFormFieldRule;

export enum GenCodeRuleType {
  AutoCountRule = 'AutoCountRule',
  FixedCharactersRule = 'FixedCharactersRule',
  GenCodeFormFieldRule = 'GenCodeFormFieldRule'
}

export type GenCodeRulesAttributes = {
  /** 是否删除当前规则, true: 删除, false: 保留 */
  _destroy?: InputMaybe<Scalars['Boolean']['input']>;
  /** 字段 ApiCode */
  apiCode?: InputMaybe<Scalars['String']['input']>;
  /** 确认码位数 */
  countDigit?: InputMaybe<Scalars['Int']['input']>;
  /** 计数器 */
  counter?: InputMaybe<Scalars['Int']['input']>;
  /** 是否固定位数 */
  fixedDigits?: InputMaybe<Scalars['Boolean']['input']>;
  /** ID */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** 计数器 */
  position: Scalars['Int']['input'];
  /** 重置规则值 */
  resetRuleApiCode?: InputMaybe<Scalars['String']['input']>;
  /** 重置规则类型 */
  resetRuleType?: InputMaybe<ResetRule>;
  /** 规则类型 */
  type: GenCodeRuleType;
  /** 规则值 */
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of GenerateEntryCertificate */
export type GenerateEntryCertificateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 表单的使用场景 */
  formUsage?: InputMaybe<FormUsage>;
  /** 表单ID或token */
  id: Scalars['ID']['input'];
  serialNumber: Scalars['Int']['input'];
};

/** Autogenerated return type of GenerateEntryCertificate */
export type GenerateEntryCertificatePayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  entry?: Maybe<Entry>;
  errors?: Maybe<Array<Error>>;
};

export type GeneratedFormHeaderImage = {
  /** 文件名 */
  fileFilename?: Maybe<Scalars['String']['output']>;
  /** 图片高度 */
  fileHeight?: Maybe<Scalars['Int']['output']>;
  /** 图片宽度 */
  fileWidth?: Maybe<Scalars['Int']['output']>;
  /** 图片ID */
  id: Scalars['ID']['output'];
  /** 图片访问地址 */
  visitUrl?: Maybe<Scalars['String']['output']>;
};


export type GeneratedFormHeaderImageVisitUrlArgs = {
  size?: InputMaybe<Scalars['String']['input']>;
};

export type GeoField = AssociatedField & BaseField & FieldAbility & PlanAvailableField & {
  apiCode: Scalars['ID']['output'];
  apiCodeAlias?: Maybe<Scalars['String']['output']>;
  /** 对应的表单关联字段 */
  associationField?: Maybe<Field>;
  /** 自动填写上次提交内容 */
  cacheData: Scalars['Boolean']['output'];
  /** 客户端ID */
  cid?: Maybe<Scalars['String']['output']>;
  /** 封装的字段类型 */
  customizedType?: Maybe<Scalars['String']['output']>;
  /** 封装的字段类型文本 */
  customizedTypeName?: Maybe<Scalars['String']['output']>;
  /** 自定义出错文案 */
  customizedValidationMessage?: Maybe<Scalars['String']['output']>;
  /** 已提交的数据是否可被编辑 */
  editable: Scalars['Boolean']['output'];
  /** 该字段能否使用字段规则: true - 能， false - 不能 */
  fieldRuleAvailable: Scalars['Boolean']['output'];
  /** 是否是关联主键字段 */
  forAssociated?: Maybe<Scalars['Boolean']['output']>;
  /** 是否是关联展示字段 */
  forAssociatedDisplay?: Maybe<Scalars['Boolean']['output']>;
  /** 表单Token */
  formToken: Scalars['String']['output'];
  /** 宽度占用整行的四分之几 */
  gridsToOccupy?: Maybe<Scalars['Int']['output']>;
  hasAbility: Scalars['Boolean']['output'];
  /** 字段标题（去富文本化） */
  label?: Maybe<Scalars['String']['output']>;
  /** 允许填写者在手机上自行标注位置 */
  localizableOnMobile: Scalars['Boolean']['output'];
  /** 字段描述，富文本 */
  notes?: Maybe<Scalars['String']['output']>;
  paidFeature?: Maybe<PaidFeature>;
  planAvailable: Scalars['Boolean']['output'];
  /** 字段排序 */
  position: Scalars['Int']['output'];
  /** 该字段是否是隐私字段 true - 是, false - 不是 */
  privacy: Scalars['Boolean']['output'];
  /** 字段隐藏 */
  private: Scalars['Boolean']['output'];
  /** 字段是否通过预填写表单预设了值 true - 是, false - 否 */
  pseudoFormPredefined?: Maybe<Scalars['Boolean']['output']>;
  /** 字段标题（富文本化） */
  rawLabel?: Maybe<Scalars['String']['output']>;
  /** 字段是否只读，无法编辑 */
  readonly?: Maybe<Scalars['Boolean']['output']>;
  /** 该字段是否属于评分字段（e.g. 考试、测评中的题目） */
  scorable: Scalars['Boolean']['output'];
  /** 字段提示较长时折叠展示 */
  showPartDescription: Scalars['Boolean']['output'];
  /** 新起一行 */
  startNewRow: Scalars['Boolean']['output'];
  /** 该字段是否可以作为文本插入 true - 能, false - 不能 */
  textPlaceholderable: Scalars['Boolean']['output'];
  /** 字段类型 */
  type: FieldClass;
  /** 字段类型文本 */
  typeName: Scalars['String']['output'];
  /** 字段验证规则 */
  validations?: Maybe<Array<FieldValidation>>;
};


export type GeoFieldHasAbilityArgs = {
  key: FieldAbilityEnum;
};


export type GeoFieldNotesArgs = {
  sanitize?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GeoFieldReport = {
  field?: Maybe<Field>;
  widgets?: Maybe<Array<Widget>>;
};

export type GlobalSearch = {
  /** 联系人搜索结果 */
  contacts?: Maybe<Array<Contact>>;
  /** 表单搜索结果 */
  forms: Array<Form>;
  /** 模板搜索结果 */
  templates?: Maybe<Array<Template>>;
};

export type GoodsDimension = {
  label: Scalars['String']['output'];
  options: Array<GoodsDimensionOption>;
  value: Scalars['ID']['output'];
};

export type GoodsDimensionAttributes = {
  /** 商品规格标题 */
  label: Scalars['String']['input'];
  /** 具体规格 */
  options: Array<GoodsDimensionOptionAttributes>;
  /** 规格值，新规格不传或传null */
  value?: InputMaybe<Scalars['ID']['input']>;
};

export type GoodsDimensionOption = {
  label: Scalars['String']['output'];
  value: Scalars['ID']['output'];
};

export type GoodsDimensionOptionAttributes = {
  /** 具体规格文字 */
  label: Scalars['String']['input'];
  /** 具体规格值，新规格不传或传null */
  value?: InputMaybe<Scalars['ID']['input']>;
};

export type GoodsField = AssociatedField & BaseField & FieldAbility & PayableField & PlanAvailableField & {
  apiCode: Scalars['ID']['output'];
  apiCodeAlias?: Maybe<Scalars['String']['output']>;
  /** 对应的表单关联字段 */
  associationField?: Maybe<Field>;
  /** 自动填写上次提交内容 */
  cacheData: Scalars['Boolean']['output'];
  /** 客户端ID */
  cid?: Maybe<Scalars['String']['output']>;
  /** 在手机上默认折叠显示 */
  collapseOnMobile: Scalars['Boolean']['output'];
  /** 手机端展示列数（1列或2列） */
  columnsOnMobile: Scalars['Int']['output'];
  /** 封装的字段类型 */
  customizedType?: Maybe<Scalars['String']['output']>;
  /** 封装的字段类型文本 */
  customizedTypeName?: Maybe<Scalars['String']['output']>;
  /** 自定义出错文案 */
  customizedValidationMessage?: Maybe<Scalars['String']['output']>;
  /** 已提交的数据是否可被编辑 */
  editable: Scalars['Boolean']['output'];
  /** 该字段能否使用字段规则: true - 能， false - 不能 */
  fieldRuleAvailable: Scalars['Boolean']['output'];
  /** 是否是关联主键字段 */
  forAssociated?: Maybe<Scalars['Boolean']['output']>;
  /** 是否是关联展示字段 */
  forAssociatedDisplay?: Maybe<Scalars['Boolean']['output']>;
  /** 表单Token */
  formToken: Scalars['String']['output'];
  goodsItems: Array<GoodsItem>;
  goodsPreferentialCase?: Maybe<GoodsPreferentialCase>;
  goodsPreferentialType?: Maybe<GoodsPreferentialType>;
  /** 宽度占用整行的四分之几 */
  gridsToOccupy?: Maybe<Scalars['Int']['output']>;
  hasAbility: Scalars['Boolean']['output'];
  /** 库存文案 */
  inventoryLabel?: Maybe<Scalars['String']['output']>;
  /** 删除数据后，库存余量自动恢复 */
  inventoryRecoverable: Scalars['Boolean']['output'];
  /** 字段标题（去富文本化） */
  label?: Maybe<Scalars['String']['output']>;
  /** 字段描述，富文本 */
  notes?: Maybe<Scalars['String']['output']>;
  paidFeature?: Maybe<PaidFeature>;
  /** 该字段是否可支付（e.g. 商品、预约） */
  payable: Scalars['Boolean']['output'];
  planAvailable: Scalars['Boolean']['output'];
  /** 字段排序 */
  position: Scalars['Int']['output'];
  /** 该字段是否是隐私字段 true - 是, false - 不是 */
  privacy: Scalars['Boolean']['output'];
  /** 字段隐藏 */
  private: Scalars['Boolean']['output'];
  /** 字段是否通过预填写表单预设了值 true - 是, false - 否 */
  pseudoFormPredefined?: Maybe<Scalars['Boolean']['output']>;
  /** 字段标题（富文本化） */
  rawLabel?: Maybe<Scalars['String']['output']>;
  /** 字段是否只读，无法编辑 */
  readonly?: Maybe<Scalars['Boolean']['output']>;
  /** 该字段是否属于评分字段（e.g. 考试、测评中的题目） */
  scorable: Scalars['Boolean']['output'];
  /** 字段提示较长时折叠展示 */
  showPartDescription: Scalars['Boolean']['output'];
  /** 新起一行 */
  startNewRow: Scalars['Boolean']['output'];
  /** 该字段是否可以作为文本插入 true - 能, false - 不能 */
  textPlaceholderable: Scalars['Boolean']['output'];
  /** 字段类型 */
  type: FieldClass;
  /** 字段类型文本 */
  typeName: Scalars['String']['output'];
  /** 库存单位文案 */
  unit?: Maybe<Scalars['String']['output']>;
  /** 字段验证规则 */
  validations?: Maybe<Array<FieldValidation>>;
};


export type GoodsFieldHasAbilityArgs = {
  key: FieldAbilityEnum;
};


export type GoodsFieldNotesArgs = {
  sanitize?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GoodsItem = BaseGoodsItem & DescribableItem & InventoriableItem & PurchaseLimitedItem & {
  /** 选项说明 */
  description?: Maybe<Scalars['String']['output']>;
  /** 说明类型 */
  descriptionMode: DescribableItemMode;
  /** 选项说明文字 */
  descriptionText?: Maybe<Scalars['String']['output']>;
  /** 选项说明链接 */
  descriptionUrl?: Maybe<Scalars['String']['output']>;
  /** 规格 */
  dimensions: Array<GoodsDimension>;
  /** 不允许修改数量 */
  fixedNumber: Scalars['Boolean']['output'];
  goodsItemImages: Array<Attachment>;
  /** 隐藏商品 */
  hidden: Scalars['Boolean']['output'];
  /** 当前库存 */
  inventory?: Maybe<Scalars['BigInteger']['output']>;
  /** 商品展示形式 */
  layout?: Maybe<ItemLayout>;
  /** 最多购买 */
  maxPurchaseQuantity?: Maybe<Scalars['BigInteger']['output']>;
  /** 最少购买 */
  minPurchaseQuantity?: Maybe<Scalars['BigInteger']['output']>;
  /** 商品名 */
  name: Scalars['String']['output'];
  /** 原价 */
  originalPrice?: Maybe<Scalars['Float']['output']>;
  /** 商品排序 */
  position: Scalars['Int']['output'];
  /** 默认数量 */
  predefinedNumber?: Maybe<Scalars['BigInteger']['output']>;
  /** 默认规格 */
  predefinedSpecification?: Maybe<Array<GoodsSpecificationItem>>;
  /** 现价 */
  price?: Maybe<Scalars['Float']['output']>;
  /** 用户自定义选项说明扩展按钮文案 */
  showMoreDescriptionTip?: Maybe<Scalars['String']['output']>;
  skus: Array<GoodsSku>;
  /** 已售数量 */
  soldQuantity: Scalars['BigInteger']['output'];
  value: Scalars['ID']['output'];
};

export type GoodsItemAttributes = {
  /** 商品说明内容 */
  description?: InputMaybe<Scalars['String']['input']>;
  /** 商品说明类型 */
  descriptionMode?: InputMaybe<DescribableItemMode>;
  /** 商品规格 */
  dimensions?: InputMaybe<Array<GoodsDimensionAttributes>>;
  /** 不允许修改数量 */
  fixedNumber?: InputMaybe<Scalars['Boolean']['input']>;
  /** 隐藏商品 */
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  /** 商品配图 */
  images?: InputMaybe<Array<GoodsItemImageAttributes>>;
  /** 当前库存 */
  inventory?: InputMaybe<Scalars['BigInteger']['input']>;
  /** 库存重置 */
  inventoryReset?: InputMaybe<Scalars['Boolean']['input']>;
  /** 商品展示形式 */
  layout?: InputMaybe<ItemLayout>;
  /** 最多购买数量 */
  maxPurchaseQuantity?: InputMaybe<Scalars['BigInteger']['input']>;
  /** 最少购买数量 */
  minPurchaseQuantity?: InputMaybe<Scalars['BigInteger']['input']>;
  /** 商品名 */
  name: Scalars['String']['input'];
  /** 原价 */
  originalPrice?: InputMaybe<Scalars['Float']['input']>;
  /** 位置排序 */
  position?: InputMaybe<Scalars['Int']['input']>;
  /** 默认数量 */
  predefinedNumber?: InputMaybe<Scalars['BigInteger']['input']>;
  /** 默认规格组合 */
  predefinedSpecification?: InputMaybe<Scalars['JSON']['input']>;
  /** 现价 */
  price?: InputMaybe<Scalars['Float']['input']>;
  /** 用户自定义选项说明扩展按钮文案 */
  showMoreDescriptionTip?: InputMaybe<Scalars['String']['input']>;
  /** 商品规格定价和库存 */
  skus?: InputMaybe<Array<GoodsSkuAttributes>>;
  /** 商品类型 */
  type: GoodsItemType;
  /** 商品值，新商品不传或传null */
  value?: InputMaybe<Scalars['ID']['input']>;
};

export type GoodsItemImageAttributes = {
  /** 商品配图的attachment id */
  attachmentId: Scalars['ID']['input'];
};

export enum GoodsItemType {
  GoodsItem = 'GoodsItem'
}

export type GoodsPreferentialCase = {
  discount: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  unit?: Maybe<Scalars['Int']['output']>;
};

export type GoodsPreferentialCaseAttributes = {
  discount: Scalars['Float']['input'];
  name: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['Int']['input']>;
};

export type GoodsPreferentialType = {
  endTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  minCount?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
};

export type GoodsPreferentialTypeAttributes = {
  endTime?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  minCount?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
};

export type GoodsSku = InventoriableItem & PurchaseLimitedItem & {
  apiCode: Scalars['ID']['output'];
  /** 当前库存 */
  inventory?: Maybe<Scalars['BigInteger']['output']>;
  /** 最多购买 */
  maxPurchaseQuantity?: Maybe<Scalars['BigInteger']['output']>;
  /** 最少购买 */
  minPurchaseQuantity?: Maybe<Scalars['BigInteger']['output']>;
  originalPrice?: Maybe<Scalars['Float']['output']>;
  price: Scalars['Float']['output'];
  /** 已售数量 */
  soldQuantity: Scalars['BigInteger']['output'];
  specification: Array<GoodsSpecificationItem>;
};

export type GoodsSkuAttributes = {
  /** 库存 */
  inventory?: InputMaybe<Scalars['BigInteger']['input']>;
  /** 库存重置 */
  inventoryReset?: InputMaybe<Scalars['Boolean']['input']>;
  /** 最多购买数量 */
  maxPurchaseQuantity?: InputMaybe<Scalars['BigInteger']['input']>;
  /** 最少购买数量 */
  minPurchaseQuantity?: InputMaybe<Scalars['BigInteger']['input']>;
  /** 原价 */
  originalPrice?: InputMaybe<Scalars['Float']['input']>;
  /** 现价 */
  price: Scalars['Float']['input'];
  /** 规格组合 */
  specification: Scalars['JSON']['input'];
};

export type GoodsSpecificationItem = {
  dimensionOptionValue: Scalars['ID']['output'];
  dimensionValue: Scalars['ID']['output'];
};

export enum GroupAuthTypesEnum {
  /** Dual auth */
  DualAuth = 'dual_auth',
  /** Oauth */
  Oauth = 'oauth',
  /** SMS */
  Sms = 'sms',
  /** Weixin */
  Weixin = 'weixin',
  /** Weixin qiye */
  WeixinQiye = 'weixin_qiye'
}

export enum GroupCreatedFrom {
  /** Ding talk */
  DingTalk = 'ding_talk',
  /** Form */
  Form = 'form',
  /** Weixin qiye app */
  WeixinQiyeApp = 'weixin_qiye_app'
}

export enum GroupDemoCase {
  /** Employee reporting system */
  EmployeeReportingSystem = 'employee_reporting_system',
  /** Student management system */
  StudentManagementSystem = 'student_management_system'
}

/** 看板单组请求：choice apiCode + 本组续拉游标 */
export type GroupedEntriesGroupRequestAttributes = {
  /** 本组续拉游标；未传则从第一页开始 */
  after?: InputMaybe<Scalars['String']['input']>;
  /** choice apiCode；未传或 null 代表未设置分组（含 orphan 与空值） */
  groupValue?: InputMaybe<Scalars['String']['input']>;
};

/** 分组数据（看板一列） */
export type GroupedEntriesGroupType = {
  /** 分组字段的 choice apiCode；null 表示未设置分组（含 orphan 与空值） */
  groupValue?: Maybe<Scalars['String']['output']>;
  /** 本次返回的数据节点 */
  nodes: Array<Entry>;
  /** 分页信息，用于单列续拉 */
  pageInfo: PageInfo;
  /** 当前筛选下该分组的数据总数 */
  totalCount: Scalars['Int']['output'];
};

/** 看板视图按字段分组后的数据集合 */
export type GroupedEntriesType = {
  /** 分组列表；首屏请求时按 field.choices 顺序 + null 放最后 */
  groups: Array<GroupedEntriesGroupType>;
};

export type Handoff = {
  /** 接管该 handoff 的 CS */
  csMan?: Maybe<CsMan>;
  /** CS 结束接管时间；nil 表示仍在接管中 */
  endedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  /** CS 接管时间 */
  takenOverAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type HasBillCenter = {
  /** 未使用优惠券 */
  availableCoupons: Array<Coupon>;
  /** 已过期优惠券 */
  expiredCoupons: Array<Coupon>;
  /** 发票抬头 */
  invoiceTitles: Array<InvoiceTitle>;
  /** 发票 */
  invoices: Array<EInvoice>;
  /** 未开票金额 */
  notInvoicedAmount: Scalars['Float']['output'];
  /** 未开票的付费记录 */
  notInvoicedTransactions: Array<Transaction>;
  /** 对公转账 */
  offlineRecharges: OfflineRechargeConnection;
  /** 总消费金额 */
  totalSpent: Scalars['Float']['output'];
  /** 已使用优惠券 */
  usedCoupons: Array<Coupon>;
};


export type HasBillCenterInvoicesArgs = {
  dedicated?: InputMaybe<Scalars['Boolean']['input']>;
};


export type HasBillCenterOfflineRechargesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type HasDynamicConditionValues = {
  /** 系统预定义的动态条件选项 */
  predefinedDynamicConditionOptions?: Maybe<Array<PredefinedDynamicCondition>>;
};

export type HasManyEntries = {
  /** 表单变更记录 */
  auditTrails: FormAuditTrailsConnection;
  /** 当前批量任务 */
  currentBatchJob?: Maybe<Job>;
  /** 当前附件导出任务 */
  currentEntryAttachmentsTask?: Maybe<EntryAttachmentsTaskType>;
  /** 当前数据导出任务 */
  currentExportJob?: Maybe<ExportJobType>;
  entriesCount: Scalars['Int']['output'];
};


export type HasManyEntriesAuditTrailsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  scopeConditions?: InputMaybe<Array<ScopeConditionAttributes>>;
};


export type HasManyEntriesCurrentBatchJobArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  type: EntriesBatchJobTypeType;
};

export type HasManyFields = {
  allFields: FieldConnection;
  /** 【用于 next】返回表单的所有字段，包括编辑器可编辑字段、只读字段、隐藏字段、系统字段、关联字段和计算字段，用于编辑器、数据页面等所有场景。 */
  completeFields: FieldConnection;
  fields: FieldConnection;
  /** 隐藏字段，供对外页面使用 */
  privateFields: FieldConnection;
};


export type HasManyFieldsAllFieldsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  entryAction?: InputMaybe<FormRoleEntryOperator>;
  fieldsContext?: InputMaybe<FieldsContext>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type HasManyFieldsCompleteFieldsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type HasManyFieldsFieldsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  allFormUsageFields?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forEntryOperator?: InputMaybe<FormRoleEntryOperator>;
  forcePublished?: InputMaybe<Scalars['Boolean']['input']>;
  formUsage?: InputMaybe<FormUsage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  scorable?: InputMaybe<Scalars['Boolean']['input']>;
  successEntryToken?: InputMaybe<Scalars['String']['input']>;
  systemExtendField?: InputMaybe<Scalars['Boolean']['input']>;
};


export type HasManyFieldsPrivateFieldsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type HasMerchant = {
  /** 小金商户 */
  gdMerchant?: Maybe<GdMerchant>;
};

export type HasPrivacyProtectedFields = {
  /** 开启隐私保护字段的api codes */
  privacyProtectedFieldApiCodes?: Maybe<Array<Scalars['String']['output']>>;
};

export type HasSmsSignature = {
  /** 螺丝帽已审核签名列表 */
  reviewedSmsSignatures?: Maybe<Array<Signature>>;
};

export type HasUserFormApplications = {
  /** 用户表单插件 Usages */
  userFormApplications: Array<UserFormApplicationUsage>;
};

export type HasUsers = {
  /** 邀请中的子账号 */
  pendingUserInvitations: UserInvitationConnection;
  /** 邀请链接 */
  userInviteLinks: Array<UserInviteLink>;
  /** 企业成员列表（子账号） */
  users: UserConnection;
};


export type HasUsersPendingUserInvitationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type HasUsersUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type HasYamchaAccount = {
  /** 绑定的YamchaAccount */
  yamchaAccount?: Maybe<YamchaAccount>;
};

export type HelpDocument = {
  content?: Maybe<Scalars['String']['output']>;
  hyperlinkText?: Maybe<Scalars['String']['output']>;
  hyperlinkTextUrl?: Maybe<Scalars['String']['output']>;
  idSelector: Scalars['String']['output'];
  locale: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type IdCardField = AccessControlableField & AssociatedField & BaseField & CalculableField & ExtraConfigurableSetting & FieldAbility & FormatValidatableField & LengthValidatableField & PlanAvailableField & PredefineableField & WithStatementPredefinedValues & {
  accessControlType: AccessControlType;
  accessControlValues?: Maybe<Array<Scalars['String']['output']>>;
  apiCode: Scalars['ID']['output'];
  apiCodeAlias?: Maybe<Scalars['String']['output']>;
  /** 对应的表单关联字段 */
  associationField?: Maybe<Field>;
  /** 自动填写上次提交内容 */
  cacheData: Scalars['Boolean']['output'];
  /** 开启选项赋值或本身可参与计算 */
  calculable: Scalars['Boolean']['output'];
  /** 客户端ID */
  cid?: Maybe<Scalars['String']['output']>;
  customValidationRegex?: Maybe<Scalars['String']['output']>;
  /** 封装的字段类型 */
  customizedType?: Maybe<Scalars['String']['output']>;
  /** 封装的字段类型文本 */
  customizedTypeName?: Maybe<Scalars['String']['output']>;
  /** 自定义出错文案 */
  customizedValidationMessage?: Maybe<Scalars['String']['output']>;
  /** 已提交的数据是否可被编辑 */
  editable: Scalars['Boolean']['output'];
  /** 开启年龄范围 */
  enableAgeScope?: Maybe<Scalars['Boolean']['output']>;
  /** 场景化可配置字段设置 */
  extraConfigurableSettings?: Maybe<FieldExtraConfigurableSettings>;
  /** 该字段能否使用字段规则: true - 能， false - 不能 */
  fieldRuleAvailable: Scalars['Boolean']['output'];
  /** 是否是关联主键字段 */
  forAssociated?: Maybe<Scalars['Boolean']['output']>;
  /** 是否是关联展示字段 */
  forAssociatedDisplay?: Maybe<Scalars['Boolean']['output']>;
  /** 表单Token */
  formToken: Scalars['String']['output'];
  formatValidationEnabled: Scalars['Boolean']['output'];
  formatValidationJsRegex?: Maybe<JsRegex>;
  formatValidationType?: Maybe<FieldValidation>;
  /** 宽度占用整行的四分之几 */
  gridsToOccupy?: Maybe<Scalars['Int']['output']>;
  hasAbility: Scalars['Boolean']['output'];
  /** 字段标题（去富文本化） */
  label?: Maybe<Scalars['String']['output']>;
  /** 最大年龄 */
  maxAge?: Maybe<Scalars['Int']['output']>;
  maximumLength?: Maybe<Scalars['BigInteger']['output']>;
  /** 最小年龄 */
  minAge?: Maybe<Scalars['Int']['output']>;
  minimumLength?: Maybe<Scalars['BigInteger']['output']>;
  /** 字段描述，富文本 */
  notes?: Maybe<Scalars['String']['output']>;
  paidFeature?: Maybe<PaidFeature>;
  /** 占位符 */
  placeholder?: Maybe<Scalars['String']['output']>;
  planAvailable: Scalars['Boolean']['output'];
  /** 字段排序 */
  position: Scalars['Int']['output'];
  /** 预填写表单 */
  predefined: Scalars['Boolean']['output'];
  /** 默认值 */
  predefinedValue?: Maybe<Scalars['String']['output']>;
  /** 该字段是否是隐私字段 true - 是, false - 不是 */
  privacy: Scalars['Boolean']['output'];
  /** 字段隐藏 */
  private: Scalars['Boolean']['output'];
  /** 字段是否通过预填写表单预设了值 true - 是, false - 否 */
  pseudoFormPredefined?: Maybe<Scalars['Boolean']['output']>;
  /** 字段标题（富文本化） */
  rawLabel?: Maybe<Scalars['String']['output']>;
  /** 字段是否只读，无法编辑 */
  readonly?: Maybe<Scalars['Boolean']['output']>;
  /** 扫码录入时截取部分字符的起始位置 */
  scanBegin?: Maybe<Scalars['BigInteger']['output']>;
  /** 扫码录入时截取部分字符的结束位置 */
  scanEnd?: Maybe<Scalars['BigInteger']['output']>;
  /** 微信扫码录入 */
  scannable: Scalars['Boolean']['output'];
  /** 该字段是否属于评分字段（e.g. 考试、测评中的题目） */
  scorable: Scalars['Boolean']['output'];
  /** 字段提示较长时折叠展示 */
  showPartDescription: Scalars['Boolean']['output'];
  /** 新起一行 */
  startNewRow: Scalars['Boolean']['output'];
  statementPredefinedValues?: Maybe<FieldStatementPredefinedValues>;
  /** 该字段是否可以作为文本插入 true - 能, false - 不能 */
  textPlaceholderable: Scalars['Boolean']['output'];
  /** 扫码录入时截取部分字符 */
  trimmable: Scalars['Boolean']['output'];
  /** 字段类型 */
  type: FieldClass;
  /** 字段类型文本 */
  typeName: Scalars['String']['output'];
  /** 字段验证规则 */
  validations?: Maybe<Array<FieldValidation>>;
};


export type IdCardFieldHasAbilityArgs = {
  key: FieldAbilityEnum;
};


export type IdCardFieldNotesArgs = {
  sanitize?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IdCardInfo = {
  idCardBackAttachment?: Maybe<Attachment>;
  idCardFrontAttachment?: Maybe<Attachment>;
  idCardName?: Maybe<Scalars['String']['output']>;
  idCardNumber?: Maybe<Scalars['String']['output']>;
  /** 身份证对应的实名手机号 */
  identityMobile?: Maybe<Scalars['String']['output']>;
};

export type IdentityField = {
  apiCode: Scalars['ID']['output'];
};

export enum IdentityProvider {
  Weixin = 'weixin'
}

export type ImageCheckBox = AssociatedField & BaseField & CalculableField & ChoiceExclusivableField & ExtraConfigurableSetting & FieldAbility & LengthValidatableField & PlanAvailableField & PredefineableField & PromptableField & QuotableField & SelectableField & {
  apiCode: Scalars['ID']['output'];
  apiCodeAlias?: Maybe<Scalars['String']['output']>;
  /** 对应的表单关联字段 */
  associationField?: Maybe<Field>;
  /** 自动填写上次提交内容 */
  cacheData: Scalars['Boolean']['output'];
  /** 开启选项赋值或本身可参与计算 */
  calculable: Scalars['Boolean']['output'];
  choices: Array<Choice>;
  choicesLayout?: Maybe<ChoicesLayout>;
  /** 客户端ID */
  cid?: Maybe<Scalars['String']['output']>;
  /** 封装的字段类型 */
  customizedType?: Maybe<Scalars['String']['output']>;
  /** 封装的字段类型文本 */
  customizedTypeName?: Maybe<Scalars['String']['output']>;
  /** 自定义出错文案 */
  customizedValidationMessage?: Maybe<Scalars['String']['output']>;
  displayEntryCountsPerChoice: Scalars['Boolean']['output'];
  /** 已提交的数据是否可被编辑 */
  editable: Scalars['Boolean']['output'];
  exclusiveChoiceApiCodes?: Maybe<Array<Scalars['ID']['output']>>;
  /** 场景化可配置字段设置 */
  extraConfigurableSettings?: Maybe<FieldExtraConfigurableSettings>;
  /** 该字段能否使用字段规则: true - 能， false - 不能 */
  fieldRuleAvailable: Scalars['Boolean']['output'];
  /** 是否是关联主键字段 */
  forAssociated?: Maybe<Scalars['Boolean']['output']>;
  /** 是否是关联展示字段 */
  forAssociatedDisplay?: Maybe<Scalars['Boolean']['output']>;
  /** 表单Token */
  formToken: Scalars['String']['output'];
  /** 宽度占用整行的四分之几 */
  gridsToOccupy?: Maybe<Scalars['Int']['output']>;
  hasAbility: Scalars['Boolean']['output'];
  /** 选项名额为空时隐藏选项 */
  hideChoiceWhenQuotaEmpty: Scalars['Boolean']['output'];
  /** 不向填表者展示选项名额剩余数字 */
  hideQuota: Scalars['Boolean']['output'];
  /** 字段标题（去富文本化） */
  label?: Maybe<Scalars['String']['output']>;
  maximumLength?: Maybe<Scalars['BigInteger']['output']>;
  migratedFromDropDown?: Maybe<Scalars['Boolean']['output']>;
  minimumLength?: Maybe<Scalars['BigInteger']['output']>;
  /** 字段描述，富文本 */
  notes?: Maybe<Scalars['String']['output']>;
  paidFeature?: Maybe<PaidFeature>;
  planAvailable: Scalars['Boolean']['output'];
  /** 字段排序 */
  position: Scalars['Int']['output'];
  /** 预填写表单 */
  predefined: Scalars['Boolean']['output'];
  presentationStyle: CheckBoxPresentationStyle;
  /** 该字段是否是隐私字段 true - 是, false - 不是 */
  privacy: Scalars['Boolean']['output'];
  /** 字段隐藏 */
  private: Scalars['Boolean']['output'];
  prompt?: Maybe<Scalars['String']['output']>;
  /** 字段是否通过预填写表单预设了值 true - 是, false - 否 */
  pseudoFormPredefined?: Maybe<Scalars['Boolean']['output']>;
  /** 剩余名额为0时，显示文案 */
  quotaBlankWarning?: Maybe<Scalars['String']['output']>;
  /** 选项名额重置 */
  quotaCycleRule?: Maybe<QuotaCycleRule>;
  /** 删除数据后，选项名额自动恢复 */
  quotaRecoverable: Scalars['Boolean']['output'];
  randomChoices: Scalars['Boolean']['output'];
  /** 字段标题（富文本化） */
  rawLabel?: Maybe<Scalars['String']['output']>;
  /** 字段是否只读，无法编辑 */
  readonly?: Maybe<Scalars['Boolean']['output']>;
  /** 该字段是否属于评分字段（e.g. 考试、测评中的题目） */
  scorable: Scalars['Boolean']['output'];
  /** 字段提示较长时折叠展示 */
  showPartDescription: Scalars['Boolean']['output'];
  /** 新起一行 */
  startNewRow: Scalars['Boolean']['output'];
  /** 该字段是否可以作为文本插入 true - 能, false - 不能 */
  textPlaceholderable: Scalars['Boolean']['output'];
  /** 字段类型 */
  type: FieldClass;
  /** 字段类型文本 */
  typeName: Scalars['String']['output'];
  /** 字段验证规则 */
  validations?: Maybe<Array<FieldValidation>>;
  withExclusiveChoice: Scalars['Boolean']['output'];
};


export type ImageCheckBoxHasAbilityArgs = {
  key: FieldAbilityEnum;
};


export type ImageCheckBoxNotesArgs = {
  sanitize?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ImageChoice = BaseChoice & DescribableItem & QuotableChoice & {
  attachmentId?: Maybe<Scalars['ID']['output']>;
  /** 选项说明 */
  description?: Maybe<Scalars['String']['output']>;
  /** 说明类型 */
  descriptionMode: DescribableItemMode;
  /** 选项说明文字 */
  descriptionText?: Maybe<Scalars['String']['output']>;
  /** 选项说明链接 */
  descriptionUrl?: Maybe<Scalars['String']['output']>;
  hidden: Scalars['Boolean']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  operandValue?: Maybe<Scalars['Float']['output']>;
  position: Scalars['Int']['output'];
  /** 剩余名额 */
  quota?: Maybe<Scalars['BigInteger']['output']>;
  /** 名额设置 */
  quotaSetting?: Maybe<Scalars['BigInteger']['output']>;
  selected: Scalars['Boolean']['output'];
  /** 用户自定义选项说明扩展按钮文案 */
  showMoreDescriptionTip?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  value: Scalars['ID']['output'];
};

export type ImageCroppedAttributes = {
  /** 裁剪高度 */
  croppedH?: InputMaybe<Scalars['Int']['input']>;
  /** 裁剪宽度 */
  croppedW?: InputMaybe<Scalars['Int']['input']>;
  /** 裁剪起点-X轴 */
  croppedX?: InputMaybe<Scalars['Int']['input']>;
  /** 裁剪起点-Y轴 */
  croppedY?: InputMaybe<Scalars['Int']['input']>;
};

export type ImageCroppedAttributesType = {
  /** 裁剪高度 */
  croppedH?: Maybe<Scalars['Int']['output']>;
  /** 裁剪宽度 */
  croppedW?: Maybe<Scalars['Int']['output']>;
  /** 裁剪起点-X轴 */
  croppedX?: Maybe<Scalars['Int']['output']>;
  /** 裁剪起点-Y轴 */
  croppedY?: Maybe<Scalars['Int']['output']>;
};

export type ImageGroup = AssociatedField & BaseField & FieldAbility & FieldItemImageCount & PlanAvailableField & {
  apiCode: Scalars['ID']['output'];
  apiCodeAlias?: Maybe<Scalars['String']['output']>;
  /** 对应的表单关联字段 */
  associationField?: Maybe<Field>;
  /** 自动填写上次提交内容 */
  cacheData: Scalars['Boolean']['output'];
  /** 客户端ID */
  cid?: Maybe<Scalars['String']['output']>;
  /** 封装的字段类型 */
  customizedType?: Maybe<Scalars['String']['output']>;
  /** 封装的字段类型文本 */
  customizedTypeName?: Maybe<Scalars['String']['output']>;
  /** 自定义出错文案 */
  customizedValidationMessage?: Maybe<Scalars['String']['output']>;
  /** 已提交的数据是否可被编辑 */
  editable: Scalars['Boolean']['output'];
  /** 该字段能否使用字段规则: true - 能， false - 不能 */
  fieldRuleAvailable: Scalars['Boolean']['output'];
  /** 展示字段中，图文介绍、图片展示、轮播图、倒计时的样式 */
  fieldStyle?: Maybe<DisplayFieldsFieldStyleType>;
  /** 是否是关联主键字段 */
  forAssociated?: Maybe<Scalars['Boolean']['output']>;
  /** 是否是关联展示字段 */
  forAssociatedDisplay?: Maybe<Scalars['Boolean']['output']>;
  /** 表单Token */
  formToken: Scalars['String']['output'];
  /** 宽度占用整行的四分之几 */
  gridsToOccupy?: Maybe<Scalars['Int']['output']>;
  hasAbility: Scalars['Boolean']['output'];
  /** 图片展示-图片设置 */
  images?: Maybe<Array<DisplayFieldsFieldItemImageType>>;
  /** 图片展示、轮播图的图片数量 */
  imagesCount?: Maybe<Scalars['Int']['output']>;
  /** 字段标题（去富文本化） */
  label?: Maybe<Scalars['String']['output']>;
  /** 展示字段中，图文介绍、图片展示、轮播图、倒计时的布局 */
  layout?: Maybe<DisplayFieldLayout>;
  /** 字段描述，富文本 */
  notes?: Maybe<Scalars['String']['output']>;
  paidFeature?: Maybe<PaidFeature>;
  planAvailable: Scalars['Boolean']['output'];
  /** 字段排序 */
  position: Scalars['Int']['output'];
  /** 该字段是否是隐私字段 true - 是, false - 不是 */
  privacy: Scalars['Boolean']['output'];
  /** 字段隐藏 */
  private: Scalars['Boolean']['output'];
  /** 字段是否通过预填写表单预设了值 true - 是, false - 否 */
  pseudoFormPredefined?: Maybe<Scalars['Boolean']['output']>;
  /** 字段标题（富文本化） */
  rawLabel?: Maybe<Scalars['String']['output']>;
  /** 字段是否只读，无法编辑 */
  readonly?: Maybe<Scalars['Boolean']['output']>;
  /** 该字段是否属于评分字段（e.g. 考试、测评中的题目） */
  scorable: Scalars['Boolean']['output'];
  /** 字段提示较长时折叠展示 */
  showPartDescription: Scalars['Boolean']['output'];
  /** 新起一行 */
  startNewRow: Scalars['Boolean']['output'];
  /** 该字段是否可以作为文本插入 true - 能, false - 不能 */
  textPlaceholderable: Scalars['Boolean']['output'];
  /** 字段类型 */
  type: FieldClass;
  /** 字段类型文本 */
  typeName: Scalars['String']['output'];
  /** 字段验证规则 */
  validations?: Maybe<Array<FieldValidation>>;
};


export type ImageGroupHasAbilityArgs = {
  key: FieldAbilityEnum;
};


export type ImageGroupNotesArgs = {
  sanitize?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ImageItemAttributes = {
  /** 展示字段图片的attachment id */
  attachmentId?: InputMaybe<Scalars['ID']['input']>;
  /** 裁剪高度 */
  croppedH?: InputMaybe<Scalars['Int']['input']>;
  /** 裁剪宽度 */
  croppedW?: InputMaybe<Scalars['Int']['input']>;
  /** 裁剪起点-X轴 */
  croppedX?: InputMaybe<Scalars['Int']['input']>;
  /** 裁剪起点-Y轴 */
  croppedY?: InputMaybe<Scalars['Int']['input']>;
  /** true: 删除 */
  destroy?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** 移动端图片裁剪属性 */
  mobile?: InputMaybe<ImageCroppedAttributes>;
  /** 桌面端图片裁剪属性 */
  pc?: InputMaybe<ImageCroppedAttributes>;
};

export type ImageItemType = {
  /** 图片原件 */
  attachment?: Maybe<Attachment>;
  /** 裁剪高度 */
  croppedH?: Maybe<Scalars['Int']['output']>;
  /** 裁剪宽度 */
  croppedW?: Maybe<Scalars['Int']['output']>;
  /** 裁剪起点-X轴 */
  croppedX?: Maybe<Scalars['Int']['output']>;
  /** 裁剪起点-Y轴 */
  croppedY?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  /** 手机端图片裁剪属性 */
  mobile?: Maybe<ImageCroppedAttributesType>;
  /** 桌面端图片裁剪属性 */
  pc?: Maybe<ImageCroppedAttributesType>;
};

export type ImageRadioButton = AssociatedField & BaseField & CalculableField & ExtraConfigurableSetting & FieldAbility & PlanAvailableField & PredefineableField & QuotableField & SelectableField & {
  apiCode: Scalars['ID']['output'];
  apiCodeAlias?: Maybe<Scalars['String']['output']>;
  /** 对应的表单关联字段 */
  associationField?: Maybe<Field>;
  /** 自动填写上次提交内容 */
  cacheData: Scalars['Boolean']['output'];
  /** 开启选项赋值或本身可参与计算 */
  calculable: Scalars['Boolean']['output'];
  choices: Array<Choice>;
  choicesLayout?: Maybe<ChoicesLayout>;
  /** 客户端ID */
  cid?: Maybe<Scalars['String']['output']>;
  /** 封装的字段类型 */
  customizedType?: Maybe<Scalars['String']['output']>;
  /** 封装的字段类型文本 */
  customizedTypeName?: Maybe<Scalars['String']['output']>;
  /** 自定义出错文案 */
  customizedValidationMessage?: Maybe<Scalars['String']['output']>;
  displayEntryCountsPerChoice: Scalars['Boolean']['output'];
  /** 已提交的数据是否可被编辑 */
  editable: Scalars['Boolean']['output'];
  /** 场景化可配置字段设置 */
  extraConfigurableSettings?: Maybe<FieldExtraConfigurableSettings>;
  /** 该字段能否使用字段规则: true - 能， false - 不能 */
  fieldRuleAvailable: Scalars['Boolean']['output'];
  /** 是否是关联主键字段 */
  forAssociated?: Maybe<Scalars['Boolean']['output']>;
  /** 是否是关联展示字段 */
  forAssociatedDisplay?: Maybe<Scalars['Boolean']['output']>;
  /** 表单Token */
  formToken: Scalars['String']['output'];
  /** 宽度占用整行的四分之几 */
  gridsToOccupy?: Maybe<Scalars['Int']['output']>;
  hasAbility: Scalars['Boolean']['output'];
  /** 选项名额为空时隐藏选项 */
  hideChoiceWhenQuotaEmpty: Scalars['Boolean']['output'];
  /** 不向填表者展示选项名额剩余数字 */
  hideQuota: Scalars['Boolean']['output'];
  /** 字段标题（去富文本化） */
  label?: Maybe<Scalars['String']['output']>;
  /** 字段描述，富文本 */
  notes?: Maybe<Scalars['String']['output']>;
  paidFeature?: Maybe<PaidFeature>;
  planAvailable: Scalars['Boolean']['output'];
  /** 字段排序 */
  position: Scalars['Int']['output'];
  /** 预填写表单 */
  predefined: Scalars['Boolean']['output'];
  /** 该字段是否是隐私字段 true - 是, false - 不是 */
  privacy: Scalars['Boolean']['output'];
  /** 字段隐藏 */
  private: Scalars['Boolean']['output'];
  /** 字段是否通过预填写表单预设了值 true - 是, false - 否 */
  pseudoFormPredefined?: Maybe<Scalars['Boolean']['output']>;
  /** 剩余名额为0时，显示文案 */
  quotaBlankWarning?: Maybe<Scalars['String']['output']>;
  /** 选项名额重置 */
  quotaCycleRule?: Maybe<QuotaCycleRule>;
  /** 删除数据后，选项名额自动恢复 */
  quotaRecoverable: Scalars['Boolean']['output'];
  randomChoices: Scalars['Boolean']['output'];
  /** 字段标题（富文本化） */
  rawLabel?: Maybe<Scalars['String']['output']>;
  /** 字段是否只读，无法编辑 */
  readonly?: Maybe<Scalars['Boolean']['output']>;
  /** 该字段是否属于评分字段（e.g. 考试、测评中的题目） */
  scorable: Scalars['Boolean']['output'];
  /** 字段提示较长时折叠展示 */
  showPartDescription: Scalars['Boolean']['output'];
  /** 新起一行 */
  startNewRow: Scalars['Boolean']['output'];
  /** 该字段是否可以作为文本插入 true - 能, false - 不能 */
  textPlaceholderable: Scalars['Boolean']['output'];
  /** 字段类型 */
  type: FieldClass;
  /** 字段类型文本 */
  typeName: Scalars['String']['output'];
  /** 字段验证规则 */
  validations?: Maybe<Array<FieldValidation>>;
};


export type ImageRadioButtonHasAbilityArgs = {
  key: FieldAbilityEnum;
};


export type ImageRadioButtonNotesArgs = {
  sanitize?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ImageText = AssociatedField & BaseField & FieldAbility & PlanAvailableField & {
  apiCode: Scalars['ID']['output'];
  apiCodeAlias?: Maybe<Scalars['String']['output']>;
  /** 对应的表单关联字段 */
  associationField?: Maybe<Field>;
  /** 自动填写上次提交内容 */
  cacheData: Scalars['Boolean']['output'];
  /** 客户端ID */
  cid?: Maybe<Scalars['String']['output']>;
  /** 封装的字段类型 */
  customizedType?: Maybe<Scalars['String']['output']>;
  /** 封装的字段类型文本 */
  customizedTypeName?: Maybe<Scalars['String']['output']>;
  /** 自定义出错文案 */
  customizedValidationMessage?: Maybe<Scalars['String']['output']>;
  /** 已提交的数据是否可被编辑 */
  editable: Scalars['Boolean']['output'];
  /** 该字段能否使用字段规则: true - 能， false - 不能 */
  fieldRuleAvailable: Scalars['Boolean']['output'];
  /** 展示字段中，图文介绍、图片展示、轮播图、倒计时的样式 */
  fieldStyle?: Maybe<DisplayFieldsFieldStyleType>;
  /** 是否是关联主键字段 */
  forAssociated?: Maybe<Scalars['Boolean']['output']>;
  /** 是否是关联展示字段 */
  forAssociatedDisplay?: Maybe<Scalars['Boolean']['output']>;
  /** 表单Token */
  formToken: Scalars['String']['output'];
  /** 宽度占用整行的四分之几 */
  gridsToOccupy?: Maybe<Scalars['Int']['output']>;
  hasAbility: Scalars['Boolean']['output'];
  /** 图文介绍-图文组件 */
  imageTextItems: Array<DisplayFieldsImageTextItemType>;
  /** 图文介绍-组件数量 */
  imageTextItemsCount: Scalars['Int']['output'];
  /** 字段标题（去富文本化） */
  label?: Maybe<Scalars['String']['output']>;
  /** 展示字段中，图文介绍、图片展示、轮播图、倒计时的布局 */
  layout?: Maybe<DisplayFieldLayout>;
  /** 字段描述，富文本 */
  notes?: Maybe<Scalars['String']['output']>;
  paidFeature?: Maybe<PaidFeature>;
  planAvailable: Scalars['Boolean']['output'];
  /** 字段排序 */
  position: Scalars['Int']['output'];
  /** 该字段是否是隐私字段 true - 是, false - 不是 */
  privacy: Scalars['Boolean']['output'];
  /** 字段隐藏 */
  private: Scalars['Boolean']['output'];
  /** 字段是否通过预填写表单预设了值 true - 是, false - 否 */
  pseudoFormPredefined?: Maybe<Scalars['Boolean']['output']>;
  /** 字段标题（富文本化） */
  rawLabel?: Maybe<Scalars['String']['output']>;
  /** 字段是否只读，无法编辑 */
  readonly?: Maybe<Scalars['Boolean']['output']>;
  /** 该字段是否属于评分字段（e.g. 考试、测评中的题目） */
  scorable: Scalars['Boolean']['output'];
  /** 字段提示较长时折叠展示 */
  showPartDescription: Scalars['Boolean']['output'];
  /** 新起一行 */
  startNewRow: Scalars['Boolean']['output'];
  /** 该字段是否可以作为文本插入 true - 能, false - 不能 */
  textPlaceholderable: Scalars['Boolean']['output'];
  /** 字段类型 */
  type: FieldClass;
  /** 字段类型文本 */
  typeName: Scalars['String']['output'];
  /** 字段验证规则 */
  validations?: Maybe<Array<FieldValidation>>;
};


export type ImageTextHasAbilityArgs = {
  key: FieldAbilityEnum;
};


export type ImageTextNotesArgs = {
  sanitize?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum IncidentLevel {
  /** Critical */
  Critical = 'critical',
  /** Warning */
  Warning = 'warning'
}

export type Indicator = {
  /** 维度token */
  apiCode: Scalars['ID']['output'];
  /** 维度下绑定的字段api_codes */
  fieldApiCodes: Array<Scalars['ID']['output']>;
  /** 自定义公式 */
  formulaDisplay?: Maybe<Scalars['String']['output']>;
  /** 维度结果与建议 */
  indicatorCommentSettings: Array<IndicatorCommentSetting>;
  /** 维度名字 */
  name: Scalars['String']['output'];
  /** 维度标准分 */
  standardScore?: Maybe<Scalars['Float']['output']>;
  /** 维度总分 */
  totalScore?: Maybe<Scalars['Float']['output']>;
};

export type IndicatorAttributes = {
  /** 维度token */
  apiCode?: InputMaybe<Scalars['ID']['input']>;
  /** 维度下的绑定的字段api_codes */
  fieldApiCodes?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** 维度自定义公式 */
  formulaDisplay?: InputMaybe<Scalars['String']['input']>;
  /** 维度结果与建议 */
  indicatorCommentSettings?: InputMaybe<Array<IndicatorCommentSettingAttributes>>;
  /** 维度名称 */
  name?: InputMaybe<Scalars['String']['input']>;
  /** 维度标准分 */
  standardScore?: InputMaybe<Scalars['Float']['input']>;
};

export type IndicatorCommentSetting = Recommendation & {
  /** 文案内容 */
  comment?: Maybe<Scalars['String']['output']>;
  /** 分数区间右端点 */
  endPoint?: Maybe<Scalars['Float']['output']>;
  /** 是否开启再填一次。true - 开启；false - 关闭 */
  retry?: Maybe<Scalars['Boolean']['output']>;
  /** 分数区间左端点 */
  startPoint?: Maybe<Scalars['Float']['output']>;
};

export type IndicatorCommentSettingAttributes = {
  /** 评论 */
  comment: Scalars['String']['input'];
  /** 分数左区间 */
  endPoint: Scalars['Float']['input'];
  /** 分数左区间 */
  startPoint: Scalars['Float']['input'];
};

export enum IndicatorScoringMode {
  /** Average */
  Average = 'average',
  /** Customization */
  Customization = 'customization',
  /** Summation */
  Summation = 'summation'
}

export type IndicatorSetting = {
  enabled: Scalars['Boolean']['output'];
  /** 维度 */
  indicators?: Maybe<Array<Indicator>>;
  /** 维度分数计算模式 */
  indicatorsScoringMode: IndicatorScoringMode;
};

export type IndicatorSettingAttributes = {
  /** 维度设置是否开启：true - 开启；false - 关闭 */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** 维度设置 */
  indicators?: InputMaybe<Array<IndicatorAttributes>>;
  /** 维度分数计算模式 */
  indicatorsScoringMode?: InputMaybe<IndicatorScoringMode>;
};

export type IndicatorsScoreMap = {
  /** 填表人提交的数据对应的维度设置的结果与建议 */
  comment?: Maybe<Scalars['String']['output']>;
  /** 填表人提交的数据的维度得分 */
  grade: Scalars['Float']['output'];
  /** 维度名称 */
  name: Scalars['String']['output'];
  /** 维度设置的标准分 */
  standardScore?: Maybe<Scalars['Float']['output']>;
  /** 维度设置的总分 */
  totalScore: Scalars['Float']['output'];
};

export type Industry = {
  englishName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type IndustryAttributes = {
  /** 行业名字（如果用户在行业选择时选了「其他」，此参数为必填） */
  name: Scalars['String']['input'];
};

export enum IndustryCategory {
  Landing = 'landing'
}

export enum Intention {
  /** Data view */
  DataView = 'data_view',
  /** Form creation */
  FormCreation = 'form_creation',
  /** Just curious */
  JustCurious = 'just_curious'
}

export type IntervalCommentSetting = Recommendation & {
  /** 文案内容 */
  comment?: Maybe<Scalars['String']['output']>;
  /** 分数区间右端点 */
  endPoint?: Maybe<Scalars['Float']['output']>;
  /** 是否开启再填一次。true - 开启；false - 关闭 */
  retry?: Maybe<Scalars['Boolean']['output']>;
  /** 分数区间左端点 */
  startPoint?: Maybe<Scalars['Float']['output']>;
};

export type IntlMobileMetaData = {
  /** 国家区号 */
  code: Scalars['String']['output'];
  /** 国家码 */
  countryIsoCode: Scalars['String']['output'];
  /** 国家名 + 区号 */
  text: Scalars['String']['output'];
};

/** 可以设置库存的 */
export type InventoriableItem = {
  /** 当前库存 */
  inventory?: Maybe<Scalars['BigInteger']['output']>;
  /** 已售数量 */
  soldQuantity: Scalars['BigInteger']['output'];
};

export type Inviter = {
  email?: Maybe<Scalars['String']['output']>;
  mobile?: Maybe<Scalars['String']['output']>;
};

/** The connection type for Inviter. */
export type InviterConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<InviterEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Inviter>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type InviterEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Inviter>;
};

export type InvoiceAttributes = {
  /** 邮箱 */
  email?: InputMaybe<Scalars['String']['input']>;
  /** 发票类型 */
  invoiceCategory: InvoiceCategory;
  /** 发票抬头类型 */
  invoiceTitleCategory: InvoiceTitleCategory;
  /** 企业增值税发票 id */
  invoiceTitleId?: InputMaybe<Scalars['ID']['input']>;
  /** 个人发票抬头 */
  invoiceTitleOrganization?: InputMaybe<Scalars['ID']['input']>;
  /** 备注 */
  remarks?: InputMaybe<Scalars['String']['input']>;
  /** 付费记录 ID */
  transactionIds: Array<Scalars['ID']['input']>;
};

export enum InvoiceCategory {
  /** 增值税专用发票 */
  EntVat = 'ent_vat',
  /** 增值税普通发票 */
  EntVatGeneral = 'ent_vat_general'
}

export enum InvoiceCategoryEnum {
  /** 增值税专用发票 */
  EntVat = 'ent_vat',
  /** 增值税普通发票 */
  EntVatGeneral = 'ent_vat_general',
  None = 'none',
  /** 个人增值税普通发票 */
  PersonalVatGeneral = 'personal_vat_general'
}

export type InvoiceTitle = {
  /** 开户许可证 */
  accountOpeningLicenses?: Maybe<Array<Attachment>>;
  /** 营业执照副本 */
  businessLicenseCopies?: Maybe<Array<Attachment>>;
  /** 发票类型 */
  category?: Maybe<InvoiceCategoryEnum>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  /** 发票抬头 */
  organization?: Maybe<Scalars['String']['output']>;
  /** 纳税人识别号 */
  taxpayerNo?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type InvoiceTitleAttributes = {
  /** 开户许可证 */
  accountOpeningLicenses?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** 营业执照副本 */
  businessLicenseCopies?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** 发票类型 */
  category: InvoiceCategoryEnum;
  /** 发票抬头 */
  organization: Scalars['String']['input'];
  /** 纳税人识别号 */
  taxpayerNo: Scalars['String']['input'];
};

export enum InvoiceTitleCategory {
  /** 企业 */
  Enterprise = 'enterprise',
  /** 个人 */
  Personal = 'personal'
}

export enum ItemLayout {
  /** Images */
  Images = 'images',
  /** Price only */
  PriceOnly = 'price_only',
  /** Text options */
  TextOptions = 'text_options',
  /** Without images */
  WithoutImages = 'without_images'
}

export type Job = CertificateJob | DocJob;

export enum JobStatus {
  /** All imported */
  AllImported = 'all_imported',
  /** Done */
  Done = 'done',
  /** Failed */
  Failed = 'failed',
  /** Partial imported */
  PartialImported = 'partial_imported',
  /** Running */
  Running = 'running',
  /** Waiting */
  Waiting = 'waiting'
}

export type JsApiConfig = {
  appid: Scalars['String']['output'];
  noncestr: Scalars['String']['output'];
  signature: Scalars['String']['output'];
  timestamp: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type JsRegex = {
  options: Scalars['String']['output'];
  source: Scalars['String']['output'];
};

export type LastEntryCreatedAt = {
  /** 表单的最新数据提交时间 */
  lastEntryCreatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export enum Layout {
  /** Card */
  Card = 'card',
  /** Classic */
  Classic = 'classic'
}

export type LengthValidatableField = {
  maximumLength?: Maybe<Scalars['BigInteger']['output']>;
  minimumLength?: Maybe<Scalars['BigInteger']['output']>;
};

export type LicenseInfo = {
  /** 表单创建者信息 */
  creator: Creator;
  /** 联系电话 */
  customerServicePhone?: Maybe<Scalars['String']['output']>;
  licenseType?: Maybe<LicenseType>;
  /** 表单创建者IP地址 */
  location: Location;
  /** 企业认证 - 企业名称，个人认证 - 姓名 */
  name?: Maybe<Scalars['String']['output']>;
};

export type LicenseInfoAttributes = {
  /** 企业认证必传，公司信用编码 */
  companyId?: InputMaybe<Scalars['String']['input']>;
  /** 企业认证必传，公司名称 */
  companyName?: InputMaybe<Scalars['String']['input']>;
  /** 企业认证 - 无需填写，个人认证 - 身份证号码 */
  identityIdCardNumber?: InputMaybe<Scalars['String']['input']>;
  /** 企业认证 - 经办人/法人电话，个人认证 - 电话 */
  identityMobile?: InputMaybe<Scalars['String']['input']>;
  /** 企业认证 - 法人姓名，个人认证 - 姓名 */
  identityName: Scalars['String']['input'];
  /** 企业认证必传，资质证明列表 */
  licenseAttachmentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  licenseType: LicenseType;
};

/** Autogenerated input type of LicenseRecognize */
export type LicenseRecognizeInput = {
  attachmentId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  ocrType: Ocr;
};

/** Autogenerated return type of LicenseRecognize */
export type LicenseRecognizePayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  response?: Maybe<Scalars['JSON']['output']>;
};

export enum LicenseStatus {
  /** No need */
  NoNeed = 'no_need',
  /** Recommended */
  Recommended = 'recommended',
  /** Required */
  Required = 'required'
}

export enum LicenseType {
  /** Enterprise */
  Enterprise = 'enterprise',
  /** Personal */
  Personal = 'personal'
}

export enum LikertChoiceStyle {
  /** Multiple */
  Multiple = 'multiple',
  /** Single */
  Single = 'single'
}

export type LikertField = AssociatedField & BaseField & CalculableField & ExtraConfigurableSetting & FieldAbility & LengthValidatableField & PlanAvailableField & QuotableField & SelectableField & {
  apiCode: Scalars['ID']['output'];
  apiCodeAlias?: Maybe<Scalars['String']['output']>;
  /** 对应的表单关联字段 */
  associationField?: Maybe<Field>;
  /** 自动填写上次提交内容 */
  cacheData: Scalars['Boolean']['output'];
  /** 开启选项赋值或本身可参与计算 */
  calculable: Scalars['Boolean']['output'];
  choices: Array<Choice>;
  /** 客户端ID */
  cid?: Maybe<Scalars['String']['output']>;
  /** 封装的字段类型 */
  customizedType?: Maybe<Scalars['String']['output']>;
  /** 封装的字段类型文本 */
  customizedTypeName?: Maybe<Scalars['String']['output']>;
  /** 自定义出错文案 */
  customizedValidationMessage?: Maybe<Scalars['String']['output']>;
  /** 已提交的数据是否可被编辑 */
  editable: Scalars['Boolean']['output'];
  /** 场景化可配置字段设置 */
  extraConfigurableSettings?: Maybe<FieldExtraConfigurableSettings>;
  /** 该字段能否使用字段规则: true - 能， false - 不能 */
  fieldRuleAvailable: Scalars['Boolean']['output'];
  /** 是否是关联主键字段 */
  forAssociated?: Maybe<Scalars['Boolean']['output']>;
  /** 是否是关联展示字段 */
  forAssociatedDisplay?: Maybe<Scalars['Boolean']['output']>;
  /** 表单Token */
  formToken: Scalars['String']['output'];
  /** 宽度占用整行的四分之几 */
  gridsToOccupy?: Maybe<Scalars['Int']['output']>;
  hasAbility: Scalars['Boolean']['output'];
  /** 选项名额为空时隐藏选项 */
  hideChoiceWhenQuotaEmpty: Scalars['Boolean']['output'];
  /** 不向填表者展示选项名额剩余数字 */
  hideQuota: Scalars['Boolean']['output'];
  /** 在手机上横向展示 */
  horizontalOnMobile?: Maybe<Scalars['Boolean']['output']>;
  /** 字段标题（去富文本化） */
  label?: Maybe<Scalars['String']['output']>;
  /** 字段展示类型 */
  likertChoiceStyle?: Maybe<LikertChoiceStyle>;
  maximumLength?: Maybe<Scalars['BigInteger']['output']>;
  minimumLength?: Maybe<Scalars['BigInteger']['output']>;
  /** 字段描述，富文本 */
  notes?: Maybe<Scalars['String']['output']>;
  paidFeature?: Maybe<PaidFeature>;
  planAvailable: Scalars['Boolean']['output'];
  /** 字段排序 */
  position: Scalars['Int']['output'];
  /** 该字段是否是隐私字段 true - 是, false - 不是 */
  privacy: Scalars['Boolean']['output'];
  /** 字段隐藏 */
  private: Scalars['Boolean']['output'];
  /** 字段是否通过预填写表单预设了值 true - 是, false - 否 */
  pseudoFormPredefined?: Maybe<Scalars['Boolean']['output']>;
  /** 剩余名额为0时，显示文案 */
  quotaBlankWarning?: Maybe<Scalars['String']['output']>;
  /** 选项名额重置 */
  quotaCycleRule?: Maybe<QuotaCycleRule>;
  /** 删除数据后，选项名额自动恢复 */
  quotaRecoverable: Scalars['Boolean']['output'];
  /** 【Deprecated 请使用 statement_choice_quota_attributes】题目-选项对应的余额 */
  quotas?: Maybe<Scalars['JSON']['output']>;
  /** 字段标题（富文本化） */
  rawLabel?: Maybe<Scalars['String']['output']>;
  /** 字段是否只读，无法编辑 */
  readonly?: Maybe<Scalars['Boolean']['output']>;
  /** 该字段是否属于评分字段（e.g. 考试、测评中的题目） */
  scorable: Scalars['Boolean']['output'];
  /** 字段提示较长时折叠展示 */
  showPartDescription: Scalars['Boolean']['output'];
  /** 新起一行 */
  startNewRow: Scalars['Boolean']['output'];
  /** 题目-选项对应的余额及设置 */
  statementChoiceQuotaAttributes?: Maybe<Array<StatementChoiceQuota>>;
  /** 【Deprecated 请使用 statement_choice_quota_attributes】题目-选项对应的余额及设置 */
  statementChoiceQuotas?: Maybe<Array<StatementChoiceQuota>>;
  /** 题目 */
  statements: Array<Statement>;
  /** 该字段是否可以作为文本插入 true - 能, false - 不能 */
  textPlaceholderable: Scalars['Boolean']['output'];
  /** 字段类型 */
  type: FieldClass;
  /** 字段类型文本 */
  typeName: Scalars['String']['output'];
  /** 字段验证规则 */
  validations?: Maybe<Array<FieldValidation>>;
};


export type LikertFieldHasAbilityArgs = {
  key: FieldAbilityEnum;
};


export type LikertFieldNotesArgs = {
  sanitize?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LinkAttrsItemType = {
  /** 小程序appid */
  appid?: Maybe<Scalars['String']['output']>;
  /** 拨打电话 */
  phone?: Maybe<Scalars['String']['output']>;
  /** 链接URL */
  url?: Maybe<Scalars['String']['output']>;
};

export type LinkField = AssociatedField & BaseField & FieldAbility & PlanAvailableField & PredefineableField & {
  apiCode: Scalars['ID']['output'];
  apiCodeAlias?: Maybe<Scalars['String']['output']>;
  /** 对应的表单关联字段 */
  associationField?: Maybe<Field>;
  /** 自动填写上次提交内容 */
  cacheData: Scalars['Boolean']['output'];
  /** 客户端ID */
  cid?: Maybe<Scalars['String']['output']>;
  /** 封装的字段类型 */
  customizedType?: Maybe<Scalars['String']['output']>;
  /** 封装的字段类型文本 */
  customizedTypeName?: Maybe<Scalars['String']['output']>;
  /** 自定义出错文案 */
  customizedValidationMessage?: Maybe<Scalars['String']['output']>;
  /** 已提交的数据是否可被编辑 */
  editable: Scalars['Boolean']['output'];
  /** 该字段能否使用字段规则: true - 能， false - 不能 */
  fieldRuleAvailable: Scalars['Boolean']['output'];
  /** 是否是关联主键字段 */
  forAssociated?: Maybe<Scalars['Boolean']['output']>;
  /** 是否是关联展示字段 */
  forAssociatedDisplay?: Maybe<Scalars['Boolean']['output']>;
  /** 表单Token */
  formToken: Scalars['String']['output'];
  /** 宽度占用整行的四分之几 */
  gridsToOccupy?: Maybe<Scalars['Int']['output']>;
  hasAbility: Scalars['Boolean']['output'];
  /** 字段标题（去富文本化） */
  label?: Maybe<Scalars['String']['output']>;
  /** 字段描述，富文本 */
  notes?: Maybe<Scalars['String']['output']>;
  paidFeature?: Maybe<PaidFeature>;
  /** 占位符 */
  placeholder?: Maybe<Scalars['String']['output']>;
  planAvailable: Scalars['Boolean']['output'];
  /** 字段排序 */
  position: Scalars['Int']['output'];
  /** 预填写表单 */
  predefined: Scalars['Boolean']['output'];
  /** 默认值 */
  predefinedValue?: Maybe<Scalars['String']['output']>;
  /** 该字段是否是隐私字段 true - 是, false - 不是 */
  privacy: Scalars['Boolean']['output'];
  /** 字段隐藏 */
  private: Scalars['Boolean']['output'];
  /** 字段是否通过预填写表单预设了值 true - 是, false - 否 */
  pseudoFormPredefined?: Maybe<Scalars['Boolean']['output']>;
  /** 字段标题（富文本化） */
  rawLabel?: Maybe<Scalars['String']['output']>;
  /** 字段是否只读，无法编辑 */
  readonly?: Maybe<Scalars['Boolean']['output']>;
  /** 该字段是否属于评分字段（e.g. 考试、测评中的题目） */
  scorable: Scalars['Boolean']['output'];
  /** 字段提示较长时折叠展示 */
  showPartDescription: Scalars['Boolean']['output'];
  /** 新起一行 */
  startNewRow: Scalars['Boolean']['output'];
  /** 该字段是否可以作为文本插入 true - 能, false - 不能 */
  textPlaceholderable: Scalars['Boolean']['output'];
  /** 字段类型 */
  type: FieldClass;
  /** 字段类型文本 */
  typeName: Scalars['String']['output'];
  /** 字段验证规则 */
  validations?: Maybe<Array<FieldValidation>>;
};


export type LinkFieldHasAbilityArgs = {
  key: FieldAbilityEnum;
};


export type LinkFieldNotesArgs = {
  sanitize?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LinkMessagePart = {
  /** 提取的内容 */
  content?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  /** 链接地址 */
  url?: Maybe<Scalars['String']['output']>;
};

export type Location = {
  /** 国家 */
  country?: Maybe<Scalars['String']['output']>;
  /** 省份 */
  province?: Maybe<Scalars['String']['output']>;
};

export type LoginLog = {
  date: Scalars['Date']['output'];
  ip: Scalars['String']['output'];
  platform: Scalars['String']['output'];
  time?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type Lottery = {
  /** 发奖人姓名 */
  casherName?: Maybe<Scalars['String']['output']>;
  /** 发奖人联系方式 */
  casherPhone?: Maybe<Scalars['String']['output']>;
  /** 抽奖次数 */
  limitTimes: Scalars['Int']['output'];
  /** 幸运大转盘 - 分数规则设置 */
  lotteryScopeRule?: Maybe<LotteryScopeRule>;
  /** 是否 */
  lotteryScopeRuleEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** 当中奖短信推送开关开启时，该字段为手机字段的api_code，必传 */
  mobileFieldApiCode?: Maybe<Scalars['ID']['output']>;
  /** 中奖短信推送开关：true - 开启，false - 关闭 */
  sendSms: Scalars['Boolean']['output'];
  /** 是否显示发件人信息 */
  showCasher: Scalars['Boolean']['output'];
  /** 展示中奖名单条数， 0 - 不展示 */
  showWinnerNumber: Scalars['Int']['output'];
};

export type LotteryScopeRule = {
  /** 最小数字边界 */
  leftBoundary: Scalars['Float']['output'];
  predicateType: LotteryScopeRuleKind;
  /** 最大数字边界 */
  rightBoundary: Scalars['Float']['output'];
};

export enum LotteryScopeRuleKind {
  EqualTo = 'equal_to',
  GreaterThanOrEqualTo = 'greater_than_or_equal_to',
  LessThanOrEqualTo = 'less_than_or_equal_to',
  Range = 'range'
}

export type ManuallyCloseRule = {
  closed: Scalars['Boolean']['output'];
};

export type ManuallyCloseRuleAttributes = {
  closed?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated input type of MarkAllNotificationsRead */
export type MarkAllNotificationsReadInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of MarkAllNotificationsRead */
export type MarkAllNotificationsReadPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  status?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of MarkNotificationRead */
export type MarkNotificationReadInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 标记已读的消息ID */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of MarkNotificationRead */
export type MarkNotificationReadPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  status?: Maybe<Scalars['String']['output']>;
};

export enum MarketingAdOrderKeyEnum {
  /** 更新时间 */
  UpdatedAt = 'updated_at'
}

export enum MarketingAdOrderSeqEnum {
  /** 正序(默认) */
  Asc = 'asc',
  /** 倒序 */
  Desc = 'desc'
}

export enum MarketingAdShownTypeEnum {
  /** dashboard */
  Dashboard = 'dashboard',
  /** dashboard_text_ad */
  DashboardTextAd = 'dashboard_text_ad',
  /** home_page */
  HomePage = 'home_page',
  /** new_feature_notification */
  NewFeatureNotification = 'new_feature_notification'
}

export type MarketingAdvertisement = {
  /** 主按钮文案 */
  confirmButtonText?: Maybe<Scalars['String']['output']>;
  /** PC描述内容（markdown） */
  description?: Maybe<Scalars['String']['output']>;
  /** 如果用户点击了关闭，需要将cookies["ad_closed_$id"]标记为true */
  id: Scalars['ID']['output'];
  /** 图片链接 */
  imageLink?: Maybe<Scalars['String']['output']>;
  /** 广告展示图片 */
  imgSrc?: Maybe<Scalars['String']['output']>;
  /** Mobile描述内容（markdown） */
  mobileDescription?: Maybe<Scalars['String']['output']>;
  /** 展示位置 */
  position: Scalars['Int']['output'];
  /** 广告展示类型 */
  shownType: MarketingAdShownTypeEnum;
  /** 副标题 */
  subtitle?: Maybe<Scalars['String']['output']>;
  /** 标题 */
  title?: Maybe<Scalars['String']['output']>;
  /** 点击跳转链接 */
  url?: Maybe<Scalars['String']['output']>;
};


export type MarketingAdvertisementImgSrcArgs = {
  mobileDevice: Scalars['Boolean']['input'];
};

export type MarqueeDisplayDataType = {
  /** 手机 */
  mobile?: Maybe<Scalars['String']['output']>;
  /** 姓名 */
  name?: Maybe<Scalars['String']['output']>;
};

export type MatrixField = AssociatedField & BaseField & DimensionedField & FieldAbility & PlanAvailableField & {
  apiCode: Scalars['ID']['output'];
  apiCodeAlias?: Maybe<Scalars['String']['output']>;
  /** 对应的表单关联字段 */
  associationField?: Maybe<Field>;
  /** 自动填写上次提交内容 */
  cacheData: Scalars['Boolean']['output'];
  /** 客户端ID */
  cid?: Maybe<Scalars['String']['output']>;
  /** 封装的字段类型 */
  customizedType?: Maybe<Scalars['String']['output']>;
  /** 封装的字段类型文本 */
  customizedTypeName?: Maybe<Scalars['String']['output']>;
  /** 自定义出错文案 */
  customizedValidationMessage?: Maybe<Scalars['String']['output']>;
  dimensions: Array<Field>;
  /** 已提交的数据是否可被编辑 */
  editable: Scalars['Boolean']['output'];
  /** 该字段能否使用字段规则: true - 能， false - 不能 */
  fieldRuleAvailable: Scalars['Boolean']['output'];
  /** 是否是关联主键字段 */
  forAssociated?: Maybe<Scalars['Boolean']['output']>;
  /** 是否是关联展示字段 */
  forAssociatedDisplay?: Maybe<Scalars['Boolean']['output']>;
  /** 表单Token */
  formToken: Scalars['String']['output'];
  /** 宽度占用整行的四分之几 */
  gridsToOccupy?: Maybe<Scalars['Int']['output']>;
  hasAbility: Scalars['Boolean']['output'];
  /** 在手机上横向展示 */
  horizontalOnMobile?: Maybe<Scalars['Boolean']['output']>;
  /** 字段标题（去富文本化） */
  label?: Maybe<Scalars['String']['output']>;
  /** 字段描述，富文本 */
  notes?: Maybe<Scalars['String']['output']>;
  paidFeature?: Maybe<PaidFeature>;
  planAvailable: Scalars['Boolean']['output'];
  /** 字段排序 */
  position: Scalars['Int']['output'];
  /** 该字段是否是隐私字段 true - 是, false - 不是 */
  privacy: Scalars['Boolean']['output'];
  /** 字段隐藏 */
  private: Scalars['Boolean']['output'];
  /** 字段是否通过预填写表单预设了值 true - 是, false - 否 */
  pseudoFormPredefined?: Maybe<Scalars['Boolean']['output']>;
  /** 字段标题（富文本化） */
  rawLabel?: Maybe<Scalars['String']['output']>;
  /** 字段是否只读，无法编辑 */
  readonly?: Maybe<Scalars['Boolean']['output']>;
  /** 该字段是否属于评分字段（e.g. 考试、测评中的题目） */
  scorable: Scalars['Boolean']['output'];
  /** 字段提示较长时折叠展示 */
  showPartDescription: Scalars['Boolean']['output'];
  /** 新起一行 */
  startNewRow: Scalars['Boolean']['output'];
  /** 题目 */
  statements: Array<Statement>;
  /** 该字段是否可以作为文本插入 true - 能, false - 不能 */
  textPlaceholderable: Scalars['Boolean']['output'];
  /** 字段类型 */
  type: FieldClass;
  /** 字段类型文本 */
  typeName: Scalars['String']['output'];
  /** 字段验证规则 */
  validations?: Maybe<Array<FieldValidation>>;
};


export type MatrixFieldHasAbilityArgs = {
  key: FieldAbilityEnum;
};


export type MatrixFieldNotesArgs = {
  sanitize?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MatrixScaleField = AssociatedField & BaseField & CalculableField & DimensionedField & FieldAbility & PlanAvailableField & {
  apiCode: Scalars['ID']['output'];
  apiCodeAlias?: Maybe<Scalars['String']['output']>;
  /** 对应的表单关联字段 */
  associationField?: Maybe<Field>;
  /** 自动填写上次提交内容 */
  cacheData: Scalars['Boolean']['output'];
  /** 开启选项赋值或本身可参与计算 */
  calculable: Scalars['Boolean']['output'];
  /** 客户端ID */
  cid?: Maybe<Scalars['String']['output']>;
  /** 封装的字段类型 */
  customizedType?: Maybe<Scalars['String']['output']>;
  /** 封装的字段类型文本 */
  customizedTypeName?: Maybe<Scalars['String']['output']>;
  /** 自定义出错文案 */
  customizedValidationMessage?: Maybe<Scalars['String']['output']>;
  dimensions: Array<Field>;
  /** 已提交的数据是否可被编辑 */
  editable: Scalars['Boolean']['output'];
  /** 该字段能否使用字段规则: true - 能， false - 不能 */
  fieldRuleAvailable: Scalars['Boolean']['output'];
  /** 是否是关联主键字段 */
  forAssociated?: Maybe<Scalars['Boolean']['output']>;
  /** 是否是关联展示字段 */
  forAssociatedDisplay?: Maybe<Scalars['Boolean']['output']>;
  /** 表单Token */
  formToken: Scalars['String']['output'];
  /** 宽度占用整行的四分之几 */
  gridsToOccupy?: Maybe<Scalars['Int']['output']>;
  hasAbility: Scalars['Boolean']['output'];
  /** 在手机上横向展示 */
  horizontalOnMobile?: Maybe<Scalars['Boolean']['output']>;
  /** 字段标题（去富文本化） */
  label?: Maybe<Scalars['String']['output']>;
  /** 字段描述，富文本 */
  notes?: Maybe<Scalars['String']['output']>;
  paidFeature?: Maybe<PaidFeature>;
  planAvailable: Scalars['Boolean']['output'];
  /** 字段排序 */
  position: Scalars['Int']['output'];
  /** 该字段是否是隐私字段 true - 是, false - 不是 */
  privacy: Scalars['Boolean']['output'];
  /** 字段隐藏 */
  private: Scalars['Boolean']['output'];
  /** 字段是否通过预填写表单预设了值 true - 是, false - 否 */
  pseudoFormPredefined?: Maybe<Scalars['Boolean']['output']>;
  /** 字段标题（富文本化） */
  rawLabel?: Maybe<Scalars['String']['output']>;
  /** 字段是否只读，无法编辑 */
  readonly?: Maybe<Scalars['Boolean']['output']>;
  /** 该字段是否属于评分字段（e.g. 考试、测评中的题目） */
  scorable: Scalars['Boolean']['output'];
  /** 字段提示较长时折叠展示 */
  showPartDescription: Scalars['Boolean']['output'];
  /** 新起一行 */
  startNewRow: Scalars['Boolean']['output'];
  /** 题目 */
  statements: Array<Statement>;
  /** 该字段是否可以作为文本插入 true - 能, false - 不能 */
  textPlaceholderable: Scalars['Boolean']['output'];
  /** 字段类型 */
  type: FieldClass;
  /** 字段类型文本 */
  typeName: Scalars['String']['output'];
  /** 字段验证规则 */
  validations?: Maybe<Array<FieldValidation>>;
};


export type MatrixScaleFieldHasAbilityArgs = {
  key: FieldAbilityEnum;
};


export type MatrixScaleFieldNotesArgs = {
  sanitize?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MatrixScaleFieldReport = {
  field?: Maybe<Field>;
  fieldEntriesCount?: Maybe<Scalars['Int']['output']>;
  widgets?: Maybe<Array<Widget>>;
};

export type MerchantAccount = {
  channels: Array<PaymentChannel>;
  id: Scalars['ID']['output'];
  merchantNo: Scalars['String']['output'];
  name: Scalars['String']['output'];
  registerProviderV2: Scalars['Boolean']['output'];
  weixinAccount?: Maybe<WeixinAccount>;
};

export enum MerchantRegisterApplication {
  Business = 'business',
  Micro = 'micro'
}

export enum MerchantRegisterApplicationStatus {
  Approved = 'approved',
  ChannelIdentified = 'channel_identified',
  ChannelRegistered = 'channel_registered',
  DocumentSubmitted = 'document_submitted',
  ESigned = 'e_signed',
  GdApproved = 'gd_approved',
  Rejected = 'rejected'
}

export enum MerchantRegisterProvider {
  /** 成都惜数如金微信渠道商 */
  V1 = 'v1',
  /** 西安数据如金微信渠道商 */
  V2 = 'v2'
}

export enum MerchantTypeEnum {
  /** 直连商户 */
  Direct = 'direct',
  /** 小金商户 */
  GdMerchant = 'gd_merchant'
}

export type Message = {
  /** AG-UI Activity Message 的结构化内容 */
  activityContent?: Maybe<Scalars['JSON']['output']>;
  /** AG-UI Activity Message 的类型 */
  activityType?: Maybe<Scalars['String']['output']>;
  /** 消息作者；客户消息为 nil，CS 回复为 CSMan */
  author?: Maybe<MessageAuthor>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  finishedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  interruptedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** 消息内容部分 */
  parts: Array<MessagePart>;
  risky: Scalars['Boolean']['output'];
  /** 消息角色：system, user, assistant, activity (AG-UI) */
  role: Scalars['String']['output'];
};

/** 消息作者；type 区分 cs_man / user，其他字段统一为 id/displayName/avatarUrl */
export type MessageAuthor = {
  avatarUrl?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** cs_man 或 user */
  type: MessageAuthorKind;
};

/** 消息作者类型：客服或客户 */
export enum MessageAuthorKind {
  /** 客服 */
  CsMan = 'cs_man',
  /** 客户 */
  User = 'user'
}

export type MessagePart = ArtifactMessagePart | FileMessagePart | LinkMessagePart | SummaryMessagePart | TextMessagePart | ThinkingMessagePart;

export type MetaProperties = {
  browser?: Maybe<Scalars['String']['output']>;
  /** 当前版本号 */
  editedVersion?: Maybe<Scalars['Int']['output']>;
  fillingDuration?: Maybe<Scalars['Float']['output']>;
  ip?: Maybe<Scalars['String']['output']>;
  os?: Maybe<Scalars['String']['output']>;
  platform?: Maybe<Scalars['String']['output']>;
  region?: Maybe<RegionInfo>;
  startFillingTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  useragent?: Maybe<Scalars['String']['output']>;
};

export type Metric = {
  extra?: Maybe<Scalars['JSON']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  value?: Maybe<Scalars['Any']['output']>;
};

export enum MiniappName {
  TradeWeixinApp = 'trade_weixin_app',
  WeixinApp = 'weixin_app'
}

export type MixpanelUser = {
  /** 用户的Mixpanel属性 */
  mixpanelSuperProperties?: Maybe<Scalars['JSON']['output']>;
  /** 是否使用Mixpanel追踪用户行为。true - 追踪 */
  shouldTrackByMixpanel: Scalars['Boolean']['output'];
};

export type MobileCover = {
  /** 表单封面背景 */
  bgImageUrl?: Maybe<Scalars['String']['output']>;
  /** 按键背景颜色 */
  btnBgColor?: Maybe<Scalars['String']['output']>;
  /** 按键标题 */
  btnContent?: Maybe<Scalars['String']['output']>;
  /** 按键字体颜色 */
  btnTextColor?: Maybe<Scalars['String']['output']>;
  /** 设置是否开启表单封面 */
  enabled: Scalars['Boolean']['output'];
  /** 开启填表方式 */
  startFrom?: Maybe<MobileCoverStartFrom>;
  /** 表单封面标题 */
  title?: Maybe<Scalars['String']['output']>;
};

export type MobileCoverAttributes = {
  /** 表单封面背景 */
  bgImageUrl?: InputMaybe<Scalars['String']['input']>;
  /** 按键背景颜色 */
  btnBgColor?: InputMaybe<Scalars['String']['input']>;
  /** 按键标题 */
  btnContent?: InputMaybe<Scalars['String']['input']>;
  /** 按键字体颜色 */
  btnTextColor?: InputMaybe<Scalars['String']['input']>;
  /** 设置是否开启表单封面 */
  enabled: Scalars['Boolean']['input'];
  /** 开启填表方式 */
  startFrom?: InputMaybe<MobileCoverStartFrom>;
  /** 表单封面标题 */
  title?: InputMaybe<Scalars['String']['input']>;
};

export enum MobileCoverStartFrom {
  Btn = 'btn',
  Swipe = 'swipe'
}

export type MobileField = AccessControlableField & AssociatedField & BaseField & FieldAbility & PlanAvailableField & PredefineableField & WithSmsVerification & {
  accessControlType: AccessControlType;
  accessControlValues?: Maybe<Array<Scalars['String']['output']>>;
  apiCode: Scalars['ID']['output'];
  apiCodeAlias?: Maybe<Scalars['String']['output']>;
  /** 对应的表单关联字段 */
  associationField?: Maybe<Field>;
  /** 自动填写上次提交内容 */
  cacheData: Scalars['Boolean']['output'];
  /** 客户端ID */
  cid?: Maybe<Scalars['String']['output']>;
  /** 封装的字段类型 */
  customizedType?: Maybe<Scalars['String']['output']>;
  /** 封装的字段类型文本 */
  customizedTypeName?: Maybe<Scalars['String']['output']>;
  /** 自定义出错文案 */
  customizedValidationMessage?: Maybe<Scalars['String']['output']>;
  /** 已提交的数据是否可被编辑 */
  editable: Scalars['Boolean']['output'];
  /** 该字段能否使用字段规则: true - 能， false - 不能 */
  fieldRuleAvailable: Scalars['Boolean']['output'];
  /** 是否是关联主键字段 */
  forAssociated?: Maybe<Scalars['Boolean']['output']>;
  /** 是否是关联展示字段 */
  forAssociatedDisplay?: Maybe<Scalars['Boolean']['output']>;
  /** 表单Token */
  formToken: Scalars['String']['output'];
  /** 宽度占用整行的四分之几 */
  gridsToOccupy?: Maybe<Scalars['Int']['output']>;
  hasAbility: Scalars['Boolean']['output'];
  /** 不合规的短信验证码签名关键字 */
  illegalSmsSignatureKeywords: Array<Scalars['String']['output']>;
  /** 字段标题（去富文本化） */
  label?: Maybe<Scalars['String']['output']>;
  /** 字段描述，富文本 */
  notes?: Maybe<Scalars['String']['output']>;
  paidFeature?: Maybe<PaidFeature>;
  /** 占位符 */
  placeholder?: Maybe<Scalars['String']['output']>;
  planAvailable: Scalars['Boolean']['output'];
  /** 字段排序 */
  position: Scalars['Int']['output'];
  /** 预填写表单 */
  predefined: Scalars['Boolean']['output'];
  /** 默认值 */
  predefinedValue?: Maybe<Scalars['String']['output']>;
  /** 该字段是否是隐私字段 true - 是, false - 不是 */
  privacy: Scalars['Boolean']['output'];
  /** 字段隐藏 */
  private: Scalars['Boolean']['output'];
  /** 字段是否通过预填写表单预设了值 true - 是, false - 否 */
  pseudoFormPredefined?: Maybe<Scalars['Boolean']['output']>;
  /** 字段标题（富文本化） */
  rawLabel?: Maybe<Scalars['String']['output']>;
  /** 字段是否只读，无法编辑 */
  readonly?: Maybe<Scalars['Boolean']['output']>;
  /** 该字段是否属于评分字段（e.g. 考试、测评中的题目） */
  scorable: Scalars['Boolean']['output'];
  /** 字段提示较长时折叠展示 */
  showPartDescription: Scalars['Boolean']['output'];
  /** 开启短信验证 */
  smsVerification: Scalars['Boolean']['output'];
  /** 获取验证码前需填写图形验证码 */
  smsVerificationCaptcha: Scalars['Boolean']['output'];
  /** 新起一行 */
  startNewRow: Scalars['Boolean']['output'];
  /** 该字段是否可以作为文本插入 true - 能, false - 不能 */
  textPlaceholderable: Scalars['Boolean']['output'];
  /** 字段类型 */
  type: FieldClass;
  /** 字段类型文本 */
  typeName: Scalars['String']['output'];
  /** 字段验证规则 */
  validations?: Maybe<Array<FieldValidation>>;
};


export type MobileFieldHasAbilityArgs = {
  key: FieldAbilityEnum;
};


export type MobileFieldNotesArgs = {
  sanitize?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum MobileVerificationTypeEnum {
  /** 试用企业高级版。（不会校验手机号是否注册过） */
  FeatureTrial = 'feature_trial',
  /** 交易退款 */
  TradeRefund = 'trade_refund',
  /** 金数据商户小程序（不会校验手机号是否注册过） */
  TradeWeixinApp = 'trade_weixin_app',
  /** 实名认证（不会校验手机号是否注册过） */
  UserLicense = 'user_license'
}

export enum ModalReminder {
  /** 账户充值 */
  AccountChargeWarningModal = 'account_charge_warning_modal',
  /** 企业成员使用超出上限 */
  BeyondSubAccountQuotaModal = 'beyond_sub_account_quota_modal',
  /** 企业试用已到期 */
  FeatureTrialExpired = 'feature_trial_expired',
  /** 你的套餐已到期 */
  PlanExpiredWarningModal = 'plan_expired_warning_modal',
  /** 数据已超出免费用量 */
  ReservedEntryWarningModal = 'reserved_entry_warning_modal'
}

export type MonthlyUsage = {
  resetDate: Scalars['Date']['output'];
  vasBalance: VasBalance;
};


export type MonthlyUsageVasBalanceArgs = {
  vas: Vas;
};

/** Autogenerated input type of MoveToFolder */
export type MoveToFolderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 移入文件夹TOKEN/如果是移动到桌面则是为空 */
  folderId?: InputMaybe<Scalars['ID']['input']>;
  /** 表单ID或token */
  id: Scalars['ID']['input'];
  /** 移出文件夹TOKEN */
  originalFolderId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of MoveToFolder */
export type MoveToFolderPayload = {
  /** 移动后，当前用户对于当前表单的所有父文件夹列表 */
  allAncestorFolders?: Maybe<Array<FormFolder>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  succeed?: Maybe<Scalars['Boolean']['output']>;
};

export type MultipleBlanksField = AssociatedField & BaseField & DimensionedField & ExtraConfigurableSetting & FieldAbility & PlanAvailableField & {
  apiCode: Scalars['ID']['output'];
  apiCodeAlias?: Maybe<Scalars['String']['output']>;
  /** 对应的表单关联字段 */
  associationField?: Maybe<Field>;
  /** 自动填写上次提交内容 */
  cacheData: Scalars['Boolean']['output'];
  /** 客户端ID */
  cid?: Maybe<Scalars['String']['output']>;
  /** 封装的字段类型 */
  customizedType?: Maybe<Scalars['String']['output']>;
  /** 封装的字段类型文本 */
  customizedTypeName?: Maybe<Scalars['String']['output']>;
  /** 自定义出错文案 */
  customizedValidationMessage?: Maybe<Scalars['String']['output']>;
  dimensions: Array<Field>;
  /** 已提交的数据是否可被编辑 */
  editable: Scalars['Boolean']['output'];
  /** 场景化可配置字段设置 */
  extraConfigurableSettings?: Maybe<FieldExtraConfigurableSettings>;
  /** 该字段能否使用字段规则: true - 能， false - 不能 */
  fieldRuleAvailable: Scalars['Boolean']['output'];
  /** 是否是关联主键字段 */
  forAssociated?: Maybe<Scalars['Boolean']['output']>;
  /** 是否是关联展示字段 */
  forAssociatedDisplay?: Maybe<Scalars['Boolean']['output']>;
  /** 表单Token */
  formToken: Scalars['String']['output'];
  /** 宽度占用整行的四分之几 */
  gridsToOccupy?: Maybe<Scalars['Int']['output']>;
  hasAbility: Scalars['Boolean']['output'];
  /** 字段标题（去富文本化） */
  label?: Maybe<Scalars['String']['output']>;
  /** 字段描述，富文本 */
  notes?: Maybe<Scalars['String']['output']>;
  paidFeature?: Maybe<PaidFeature>;
  /** 占位符，格式为: placeholder_1${ANSWER_TARGET_API_CODE}$placeholder_2 */
  placeholder: Scalars['String']['output'];
  planAvailable: Scalars['Boolean']['output'];
  /** 字段排序 */
  position: Scalars['Int']['output'];
  /** 该字段是否是隐私字段 true - 是, false - 不是 */
  privacy: Scalars['Boolean']['output'];
  /** 字段隐藏 */
  private: Scalars['Boolean']['output'];
  /** 字段是否通过预填写表单预设了值 true - 是, false - 否 */
  pseudoFormPredefined?: Maybe<Scalars['Boolean']['output']>;
  /** 字段标题（富文本化） */
  rawLabel?: Maybe<Scalars['String']['output']>;
  /** 字段是否只读，无法编辑 */
  readonly?: Maybe<Scalars['Boolean']['output']>;
  /** 该字段是否属于评分字段（e.g. 考试、测评中的题目） */
  scorable: Scalars['Boolean']['output'];
  /** 字段提示较长时折叠展示 */
  showPartDescription: Scalars['Boolean']['output'];
  /** 新起一行 */
  startNewRow: Scalars['Boolean']['output'];
  /** 该字段是否可以作为文本插入 true - 能, false - 不能 */
  textPlaceholderable: Scalars['Boolean']['output'];
  /** 字段类型 */
  type: FieldClass;
  /** 字段类型文本 */
  typeName: Scalars['String']['output'];
  /** 字段验证规则 */
  validations?: Maybe<Array<FieldValidation>>;
};


export type MultipleBlanksFieldHasAbilityArgs = {
  key: FieldAbilityEnum;
};


export type MultipleBlanksFieldNotesArgs = {
  sanitize?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Mutation = {
  acceptFormInviteLink?: Maybe<AcceptFormInviteLinkPayload>;
  acceptUserInviteLink?: Maybe<AcceptUserInviteLinkPayload>;
  activateCoupon?: Maybe<ActivateCouponPayload>;
  activateTemplateCoupon?: Maybe<ActivateTemplateCouponPayload>;
  amendFormImportJob?: Maybe<AmendFormImportJobPayload>;
  appendFromImportJob?: Maybe<AppendFromImportJobPayload>;
  auditPendingCustomer?: Maybe<GdPortalAuditPendingCustomerPayload>;
  batchCreateUserInvitation?: Maybe<BatchCreateUserInvitationPayload>;
  /** 数据批量编辑 */
  batchUpdateFormEntries?: Maybe<BatchUpdateFormEntriesPayload>;
  batchUpdateFormSetting?: Maybe<BatchUpdateFormSettingPayload>;
  bindSocialUserMobile?: Maybe<BindSocialUserMobilePayload>;
  cancelAdvancedNotification?: Maybe<CancelAdvancedNotificationPayload>;
  cancelCustomerReservation?: Maybe<GdPortalCancelCustomerReservationPayload>;
  cancelOpenEntryReservation?: Maybe<CancelOpenEntryReservationPayload>;
  cancelPendingHandoff?: Maybe<CancelPendingHandoffPayload>;
  cancelSubmitterReservation?: Maybe<CancelSubmitterReservationPayload>;
  checkSmsSignatures?: Maybe<CheckSmsSignaturesPayload>;
  checkSmsTemplate?: Maybe<CheckSmsTemplatePayload>;
  checkWebhookAvailable?: Maybe<CheckWebhookAvailablePayload>;
  clearFormData?: Maybe<ClearFormDataPayload>;
  completelyDestroyForm?: Maybe<CompletelyDestroyFormPayload>;
  convertExperiencePaymentForm?: Maybe<ConvertExperiencePaymentFormPayload>;
  convertMockPaymentForms?: Maybe<ConvertMockPaymentFormsPayload>;
  copyForm?: Maybe<CopyFormPayload>;
  copyFormRole?: Maybe<CopyFormRolePayload>;
  createAdvancedNotificationsRule?: Maybe<CreateAdvancedNotificationsRulePayload>;
  createApiLicence?: Maybe<CreateApiLicencePayload>;
  createAppTrial?: Maybe<CreateAppTrialPayload>;
  createBillingAccountAPILicence?: Maybe<CreateBillingAccountApiLicencePayload>;
  createBillingAccountAccessToken?: Maybe<CreateBillingAccountAccessTokenPayload>;
  createCalculation?: Maybe<CreateCalculationPayload>;
  createContactTagRule?: Maybe<CreateContactTagRulePayload>;
  createCustomTheme?: Maybe<GdPortalCreateCustomThemePayload>;
  createCustomerField?: Maybe<GdPortalCreateCustomerFieldPayload>;
  createCustomerGroup?: Maybe<GdPortalCreateCustomerGroupPayload>;
  createCustomerImportJob?: Maybe<GdPortalCreateImportJobPayload>;
  createCustomerPortal?: Maybe<GdPortalCreatePortalPayload>;
  createCustomerPortalAuthorization?: Maybe<GdPortalCreatePortalAuthorizationPayload>;
  createCustomerPortalPv?: Maybe<GdPortalCreatePortalPvPayload>;
  createCustomerPortalSession?: Maybe<GdPortalCreatePortalSessionPayload>;
  createCustomerWeixinPortalSession?: Maybe<GdPortalCreateWeixinPortalSessionPayload>;
  createEmail?: Maybe<CreateEmailPayload>;
  createEntriesBatchJob?: Maybe<CreateBatchJobPayload>;
  createEntriesExportJob?: Maybe<CreateExportJobPayload>;
  createEntryAttachment?: Maybe<CreateEntryAttachmentPayload>;
  createEntryAttachmentPresignedToken?: Maybe<CreateEntryAttachmentPresignedTokenPayload>;
  createEntryAttachmentUploadToken?: Maybe<CreateEntryAttachmentUploadTokenPayload>;
  createEntryAttachmentsTask?: Maybe<CreateEntryAttachmentsTaskPayload>;
  createEntryEmailTask?: Maybe<CreateEntryEmailTaskPayload>;
  createEntrySmsTask?: Maybe<CreateEntrySmsTaskPayload>;
  createExtendedAttributeFilter?: Maybe<CreateExtendedAttributeFilterPayload>;
  createFeatureTrial?: Maybe<CreateFeatureTrialPayload>;
  createFieldVerification?: Maybe<CreateFieldVerificationPayload>;
  createForm?: Maybe<CreateFormPayload>;
  createFormAmapStats?: Maybe<CreateFormAmapStatsPayload>;
  createFormApplicationTrial?: Maybe<CreateFormApplicationTrialPayload>;
  createFormCooperatorLink?: Maybe<CreateCooperatorLinkPayload>;
  createFormCooperators?: Maybe<CreateFormCooperatorsPayload>;
  createFormEntry?: Maybe<CreateFormEntryPayload>;
  createFormFolder?: Maybe<CreateFormFolderPayload>;
  createFormFromImportJob?: Maybe<CreateFormFromImportJobPayload>;
  createFormHeaderImageAttachment?: Maybe<CreateFormHeaderImageAttachmentPayload>;
  createFormImportJob?: Maybe<CreateFormImportJobPayload>;
  createFormPoster?: Maybe<CreateFormPosterPayload>;
  createFormRole?: Maybe<CreateFormRolePayload>;
  /** 为当前用户在指定表单上创建一个新视图 */
  createFormView?: Maybe<CreateFormViewPayload>;
  createIndustry?: Maybe<CreateIndustryPayload>;
  createInvoice?: Maybe<CreateInvoicePayload>;
  createInvoiceTitle?: Maybe<CreateInvoiceTitlePayload>;
  createMobile?: Maybe<CreateMobilePayload>;
  createMobileVerification?: Maybe<CreateMobileVerificationPayload>;
  createNotificationVerificationSignatures?: Maybe<CreateNotificationVerificationSignaturesPayload>;
  createOfflineRecharge?: Maybe<CreateOfflineRechargePayload>;
  createOpenEntry?: Maybe<CreateOpenEntriesPayload>;
  createOpenEntryOauthSession?: Maybe<CreateOpenEntryOauthSessionPayload>;
  createOpenEntrySession?: Maybe<CreateOpenEntrySessionPayload>;
  createOpenEntrySmsVerifyCode?: Maybe<CreateOpenEntrySmsVerifyCodePayload>;
  createOpenResult?: Maybe<CreateOpenResultPayload>;
  createOpenSearch?: Maybe<CreateOpenSearchPayload>;
  createPaymentAccount?: Maybe<CreatePaymentAccountPayload>;
  createPersonalAccessToken?: Maybe<CreatePersonalAccessTokenPayload>;
  createPortalAssets?: Maybe<GdPortalCreateAssetsPayload>;
  createPortalCustomerOrder?: Maybe<GdPortalCreatePortalCustomerOrderPayload>;
  createPresignedToken?: Maybe<CreatePresignedTokenPayload>;
  createPrizeVoucher?: Maybe<CreatePrizeVoucherPayload>;
  createPseudoForm?: Maybe<CreatePseudoFormPayload>;
  createPublishedFormEntry?: Maybe<CreatePublishedFormEntryPayload>;
  createQiniuCallback?: Maybe<CreateQiniuCallbackPayload>;
  createQiniuToken?: Maybe<CreateQiniuTokenPayload>;
  createRemainingPrizeVoucherAttachment?: Maybe<CreateRemainingPrizeVoucherAttachmentPayload>;
  createReportsExportJob?: Maybe<CreateFormReportsExportJobPayload>;
  createSMSSignature?: Maybe<CreateSmsSignaturePayload>;
  createSmsVerification?: Maybe<GdPortalCreateSmsVerificationPayload>;
  createSmtpAccount?: Maybe<CreateSmtpAccountPayload>;
  createSubmitterGroup?: Maybe<CreateSubmitterGroupPayload>;
  createSubmitterOauthLoginSession?: Maybe<CreateSubmitterOauthLoginSessionPayload>;
  createSubmitterPortalSession?: Maybe<CreateSubmitterPortalSessionPayload>;
  createSubmitterResponseRateExportJob?: Maybe<CreateSubmitterResponseRateExportJobPayload>;
  createSubmitterSendingTask?: Maybe<CreateSubmitterSendingTaskPayload>;
  createSubmitterSmsVerifyCode?: Maybe<CreateSubmitterSmsVerifyCodePayload>;
  createSubmitterWeixinQiyeLoginSession?: Maybe<CreateSubmitterWeixinQiyeLoginSessionPayload>;
  createSystemIncidentAction?: Maybe<CreateSystemIncidentActionPayload>;
  createTable?: Maybe<CreateTablePayload>;
  createTemplateWithdrawAccount?: Maybe<CreateWithdrawAccountPayload>;
  createUserInviteLink?: Maybe<UserInviteLink>;
  csManageUpdateCsMan?: Maybe<CsManageUpdateCsManPayload>;
  customerRegister?: Maybe<GdPortalCreateCustomerPayload>;
  deleteCustomer?: Maybe<GdPortalDeleteCustomerPayload>;
  deleteExportJob?: Maybe<DeleteExportJobPayload>;
  /** 批量删除有权限删除的数据 */
  deleteFormEntries?: Maybe<DeleteFormEntriesPayload>;
  deletePaymentAccount?: Maybe<DeletePaymentAccountPayload>;
  deleteSmtpAccount?: Maybe<DeleteSmtpAccountPayload>;
  deleteSubmitterPortalSession?: Maybe<DeleteSubmitterPortalSessionPayload>;
  deleteUserBaseFileTag?: Maybe<DeleteUserBaseFileTagPayload>;
  deleteWeixinAccount?: Maybe<DeleteWeixinAccountPayload>;
  destroyAdvancedNotificationsRule?: Maybe<DestroyAdvancedNotificationsRulePayload>;
  destroyAuthorizedApplication?: Maybe<DestroyAuthorizedApplicationPayload>;
  destroyBillingAccountUser?: Maybe<DestroyBillingAccountUserPayload>;
  destroyContactTagRule?: Maybe<DestroyContactTagRulePayload>;
  destroyCustomTheme?: Maybe<GdPortalDestroyCustomThemePayload>;
  destroyCustomerField?: Maybe<GdPortalDestroyCustomerFieldPayload>;
  destroyCustomerGroup?: Maybe<GdPortalDestroyCustomerGroupPayload>;
  destroyCustomerPortal?: Maybe<GdPortalDestroyPortalPayload>;
  destroyCustomerPortalSession?: Maybe<GdPortalDestroyPortalSessionPayload>;
  destroyEntriesBatchJob?: Maybe<DestroyEntriesBatchJobPayload>;
  destroyEntriesExportJob?: Maybe<DestroyEntriesExportJobPayload>;
  destroyEntryAttachmentsTask?: Maybe<DestroyEntryAttachmentsTaskPayload>;
  destroyExtendedAttributeFilter?: Maybe<DestroyExtendedAttributeFilterPayload>;
  destroyFeatureTrial?: Maybe<DestroyFeatureTrialPayload>;
  destroyForm?: Maybe<DestroyFormPayload>;
  destroyFormCooperator?: Maybe<DestroyFormCooperatorPayload>;
  destroyFormCooperatorLink?: Maybe<DestroyFormCooperatorLinkPayload>;
  destroyFormCooperatorLinks?: Maybe<DestroyFormCooperatorLinksPayload>;
  destroyFormFolder?: Maybe<DestroyFormFolderPayload>;
  destroyFormRole?: Maybe<DestroyFormRolePayload>;
  /** 删除视图。最后一个视图不可删。 */
  destroyFormView?: Maybe<DestroyFormViewPayload>;
  destroyInvoiceTitle?: Maybe<DestroyInvoiceTitlePayload>;
  destroyOpenEntry?: Maybe<DestroyOpenEntryPayload>;
  destroyOpenResult?: Maybe<DestroyOpenResultPayload>;
  destroyOpenSearch?: Maybe<DestroyOpenSearchPayload>;
  destroyPendingCustomer?: Maybe<GdPortalDestroyPendingCustomerPayload>;
  destroyPortalAssets?: Maybe<GdPortalDestroyAssetsPayload>;
  destroyPseudoForm?: Maybe<DestroyPseudoFormPayload>;
  destroySMSSignature?: Maybe<DestroySmsSignaturePayload>;
  destroySMSTemplate?: Maybe<DestroySmsTemplatePayload>;
  destroySession?: Maybe<DestroySessionPayload>;
  destroySessionExceptCurrent?: Maybe<DestroySessionExceptCurrentPayload>;
  destroySocialAuthentication?: Maybe<DestroySocialAuthenticationPayload>;
  destroySubmitterGroup?: Maybe<DestroySubmitterGroupPayload>;
  destroySubmitterSocialIdentity?: Maybe<DestroySubmitterSocialIdentityPayload>;
  destroySystemIncidentAction?: Maybe<DestroySystemIncidentActionPayload>;
  destroyTable?: Maybe<DestroyTablePayload>;
  destroyTemplateCoupon?: Maybe<DestroyTemplateCouponPayload>;
  destroyUser?: Maybe<DestroyUserPayload>;
  destroyUserInviteLinks?: Maybe<DestroyUserInviteLinksPayload>;
  destroyWheelFortuneWinner?: Maybe<DestroyWheelFortuneWinnerPayload>;
  displayRank?: Maybe<DisplayRankPayload>;
  endHandoff?: Maybe<EndHandoffPayload>;
  executeFormImportJob?: Maybe<ExecuteFormImportJobPayload>;
  generateEntryCertificate?: Maybe<GenerateEntryCertificatePayload>;
  hideAiGeneratedFormHeaderImage?: Maybe<HideAiGeneratedImagePayload>;
  hideAiGeneratedFormPoster?: Maybe<HideAiGeneratedPosterPayload>;
  licenseRecognize?: Maybe<LicenseRecognizePayload>;
  markAllNotificationsRead?: Maybe<MarkAllNotificationsReadPayload>;
  markNotificationRead?: Maybe<MarkNotificationReadPayload>;
  miniappBindEntryOpenid?: Maybe<MiniappBindEntryOpenidPayload>;
  moveToFolder?: Maybe<MoveToFolderPayload>;
  patchFormEntry?: Maybe<PatchFormEntryPayload>;
  previewCustomerGroup?: Maybe<GdPortalPreviewCustomerGroupPayload>;
  previewForm?: Maybe<PreviewPayload>;
  publishedFormsMobileVerifications?: Maybe<PublishedFormsMobileVerificationsPayload>;
  publishedOpenSearchEntryEditVerifications?: Maybe<PublishedOpenSearchEntryEditVerificationsPayload>;
  publishedOpenSearchMobileVerifications?: Maybe<PublishedOpenSearchMobileVerificationsPayload>;
  publishedOpenSearchUpdateEntry?: Maybe<PublishedOpenSearchUpdateEntryPayload>;
  /** 批量调整视图顺序（覆盖式：传入所有视图的新 position） */
  reorderFormViews?: Maybe<ReorderFormViewsPayload>;
  resendEntryEmailTask?: Maybe<ResendEntryEmailTaskPayload>;
  resendEntrySMSTask?: Maybe<ResendEntrySmsTaskPayload>;
  reserveAccountManager?: Maybe<ReserveAccountManagerPayload>;
  resetCustomerPassword?: Maybe<GdPortalResetCustomerPasswordPayload>;
  resetPortalCustomerPassword?: Maybe<GdPortalResetPortalCustomerPasswordPayload>;
  restoreForm?: Maybe<RestoreFormPayload>;
  /** 恢复被删除的数据 */
  restoreFormEntries?: Maybe<RestoreFormEntriesPayload>;
  revokeBillingAccountAccessToken?: Maybe<RevokeBillingAccountAccessTokenPayload>;
  revokePersonalAccessToken?: Maybe<RevokePersonalAccessTokenPayload>;
  saveConversationSummary?: Maybe<SaveConversationSummaryPayload>;
  saveFormWheelFortune?: Maybe<SaveWheelFortunePayload>;
  saveSmsTemplate?: Maybe<SaveSmsTemplatePayload>;
  saveTemplateCoupon?: Maybe<SaveTemplateCouponPayload>;
  saveTheme?: Maybe<SaveThemePayload>;
  saveUserLicenseInfo?: Maybe<SaveUserLicenseInfoPayload>;
  sendMessage?: Maybe<SendMessagePayload>;
  sendYamchaCardMessage?: Maybe<SendYamchaCardMessagePayload>;
  smsValidationContent?: Maybe<SmsValidationContentPayload>;
  sortUserBaseFileTag?: Maybe<SortUserBaseFileTagPayload>;
  /** 老用户切换新版 Tables 表格 / 返回旧版；返回旧版时必须带 reason */
  switchDataTables?: Maybe<SwitchDataTablesPayload>;
  switchUser?: Maybe<SwitchUserPayload>;
  takeoverConversation?: Maybe<TakeoverConversationPayload>;
  transferForm?: Maybe<TransferFormPayload>;
  transferHandoff?: Maybe<TransferHandoffPayload>;
  updateAdvancedNotificationsRule?: Maybe<UpdateAdvancedNotificationsRulePayload>;
  /** @deprecated Use updateProfile instead */
  updateAvatar?: Maybe<UpdateAvatarPayload>;
  updateBaseFileTag?: Maybe<UpdateBaseFileTagPayload>;
  updateBillingAccount?: Maybe<UpdateBillingAccountPayload>;
  updateBillingAccountLandingInfo?: Maybe<UpdateBillingAccountLandingInfoPayload>;
  updateBillingAccountUrlParamsSignSecret?: Maybe<UpdateBillingAccountUrlParamsSignSecretPayload>;
  updateBillingAccountUser?: Maybe<UpdateBillingAccountUserPayload>;
  updateContactTagRule?: Maybe<UpdateContactTagRulePayload>;
  updateCurrentUser?: Maybe<UpdateCurrentUserPayload>;
  updateCustomTheme?: Maybe<GdPortalUpdateCustomThemePayload>;
  updateCustomer?: Maybe<GdPortalUpdateCustomerPayload>;
  updateCustomerEmail?: Maybe<GdPortalUpdateEmailPayload>;
  updateCustomerField?: Maybe<GdPortalUpdateCustomerFieldPayload>;
  updateCustomerFilledData?: Maybe<GdPortalUpdateCustomerFilledEntryPayload>;
  updateCustomerGroup?: Maybe<GdPortalUpdateCustomerGroupPayload>;
  updateCustomerMobile?: Maybe<GdPortalUpdateMobilePayload>;
  updateCustomerPassword?: Maybe<GdPortalUpdatePasswordPayload>;
  updateCustomerPortal?: Maybe<GdPortalUpdatePortalPayload>;
  updateCustomerProfile?: Maybe<GdPortalUpdateCustomerProfilePayload>;
  updateEmail?: Maybe<UpdateEmailPayload>;
  updateEntry?: Maybe<UpdateEntryPayload>;
  updateEntrySingleSharing?: Maybe<UpdateEntrySingleSharingPayload>;
  updateEntrySmsTask?: Maybe<UpdateEntrySmsTaskPayload>;
  updateFeatureTrial?: Maybe<FeatureTrialInfo>;
  updateFieldStateFlow?: Maybe<UpdateFieldStateFlowPayload>;
  updateForm?: Maybe<UpdateFormPayload>;
  updateFormCooperator?: Maybe<UpdateFormCooperatorPayload>;
  updateFormEntry?: Maybe<UpdateFormEntryPayload>;
  updateFormEntryRedEnvelopeSetting?: Maybe<UpdateEntryRedEnvelopeSettingPayload>;
  updateFormEntryRemark?: Maybe<UpdateFormEntryRemarkPayload>;
  updateFormFieldApiCodeAlias?: Maybe<UpdateFormFieldApiCodeAliasPayload>;
  updateFormFolder?: Maybe<UpdateFormFolderPayload>;
  updateFormFolderShareSetting?: Maybe<UpdateShareSettingPayload>;
  updateFormLayout?: Maybe<UpdateFormLayoutPayload>;
  updateFormRole?: Maybe<UpdateFormRolePayload>;
  updateFormSetting?: Maybe<UpdateFormSettingPayload>;
  updateFormSymbol?: Maybe<UpdateFormSymbolPayload>;
  /** 更新视图（支持 autosave diff，所有字段可选） */
  updateFormView?: Maybe<UpdateFormViewPayload>;
  updateInvoiceTitle?: Maybe<UpdateInvoiceTitlePayload>;
  /** @deprecated use updateUserSetting instead */
  updateLocale?: Maybe<UpdateLocalePayload>;
  updateMobile?: Maybe<UpdateMobilePayload>;
  updateOpenEntry?: Maybe<UpdateOpenEntryPayload>;
  updateOpenResult?: Maybe<UpdateOpenResultPayload>;
  updateOpenSearch?: Maybe<UpdateOpenSearchPayload>;
  updatePassword?: Maybe<UpdatePasswordPayload>;
  updatePaymentAccount?: Maybe<UpdatePaymentAccountPayload>;
  updatePaymentRedirectExceptionRules?: Maybe<UpdatePaymentRedirectExceptionRulesPayload>;
  updatePhantomForm?: Maybe<UpdatePhantomFormPayload>;
  updatePortalPublishedUrlDomain?: Maybe<GdPortalUpdatePortalPublishedUrlDomainPayload>;
  updateProfile?: Maybe<UpdateProfilePayload>;
  updatePseudoForm?: Maybe<UpdatePseudoFormPayload>;
  updatePublishedFormEntry?: Maybe<UpdatePublishedFormEntryPayload>;
  updatePublishedWeixinEntry?: Maybe<UpdatePublishedWeixinEntryPayload>;
  updateReversedAssociationSetting?: Maybe<UpdateReversedAssociationSettingPayload>;
  updateSMSSignature?: Maybe<UpdateSmsSignaturePayload>;
  updateSMSYunpianSignature?: Maybe<UpdateSmsYunpianSignaturePayload>;
  updateSession?: Maybe<UpdateSessionPayload>;
  updateSingleEntryShareSetting?: Maybe<UpdateSingleEntryShareSettingPayload>;
  updateSmtpAccount?: Maybe<UpdateSmtpAccountPayload>;
  updateSubmitterGroup?: Maybe<UpdateSubmitterGroupPayload>;
  updateSubmitterPortal?: Maybe<UpdateSubmitterPortalPayload>;
  updateSystemIncidentAction?: Maybe<UpdateSystemIncidentActionPayload>;
  updateTable?: Maybe<UpdateTablePayload>;
  updateUsageScenarios?: Maybe<UpdateUsageScenariosPayload>;
  updateUserAppSetting?: Maybe<UpdateUserAppSettingPayload>;
  updateUserBaseFileTag?: Maybe<UpdateUserBaseFileTagPayload>;
  updateUserExtrainfo?: Maybe<UpdateUserExtrainfoPayload>;
  updateUserFormAppSetting?: Maybe<UpdateUserFormAppSettingPayload>;
  updateUserFormSetting?: Maybe<UpdateUserFormSettingPayload>;
  updateUserPlan?: Maybe<Plan>;
  updateUserSetting?: Maybe<UpdateUserSettingPayload>;
  updateUserSubmitterGroupSetting?: Maybe<UpdateUserSubmitterGroupSettingPayload>;
  updateWheelFortuneWinner?: Maybe<UpdateWheelFortuneWinnerPayload>;
  validatePublishedFormFields?: Maybe<ValidatePublishedFormFieldsPayload>;
  verifyEmail?: Maybe<CreateEmailVerificationPayload>;
  weixinBind?: Maybe<WeixinBindPayload>;
};


export type MutationAcceptFormInviteLinkArgs = {
  input: AcceptFormInviteLinkInput;
};


export type MutationAcceptUserInviteLinkArgs = {
  input: AcceptUserInviteLinkInput;
};


export type MutationActivateCouponArgs = {
  input: ActivateCouponInput;
};


export type MutationActivateTemplateCouponArgs = {
  input: ActivateTemplateCouponInput;
};


export type MutationAmendFormImportJobArgs = {
  input: AmendFormImportJobInput;
};


export type MutationAppendFromImportJobArgs = {
  input: AppendFromImportJobInput;
};


export type MutationAuditPendingCustomerArgs = {
  input: GdPortalAuditPendingCustomerInput;
};


export type MutationBatchCreateUserInvitationArgs = {
  input: BatchCreateUserInvitationInput;
};


export type MutationBatchUpdateFormEntriesArgs = {
  input: BatchUpdateFormEntriesInput;
};


export type MutationBatchUpdateFormSettingArgs = {
  input: BatchUpdateFormSettingInput;
};


export type MutationBindSocialUserMobileArgs = {
  input: BindSocialUserMobileInput;
};


export type MutationCancelAdvancedNotificationArgs = {
  input: CancelAdvancedNotificationInput;
};


export type MutationCancelCustomerReservationArgs = {
  input: GdPortalCancelCustomerReservationInput;
};


export type MutationCancelOpenEntryReservationArgs = {
  input: CancelOpenEntryReservationInput;
};


export type MutationCancelPendingHandoffArgs = {
  input: CancelPendingHandoffInput;
};


export type MutationCancelSubmitterReservationArgs = {
  input: CancelSubmitterReservationInput;
};


export type MutationCheckSmsSignaturesArgs = {
  input: CheckSmsSignaturesInput;
};


export type MutationCheckSmsTemplateArgs = {
  input: CheckSmsTemplateInput;
};


export type MutationCheckWebhookAvailableArgs = {
  input: CheckWebhookAvailableInput;
};


export type MutationClearFormDataArgs = {
  input: ClearFormDataInput;
};


export type MutationCompletelyDestroyFormArgs = {
  input: CompletelyDestroyFormInput;
};


export type MutationConvertExperiencePaymentFormArgs = {
  input: ConvertExperiencePaymentFormInput;
};


export type MutationConvertMockPaymentFormsArgs = {
  input: ConvertMockPaymentFormsInput;
};


export type MutationCopyFormArgs = {
  input: CopyFormInput;
};


export type MutationCopyFormRoleArgs = {
  input: CopyFormRoleInput;
};


export type MutationCreateAdvancedNotificationsRuleArgs = {
  input: CreateAdvancedNotificationsRuleInput;
};


export type MutationCreateApiLicenceArgs = {
  input: CreateApiLicenceInput;
};


export type MutationCreateAppTrialArgs = {
  input: CreateAppTrialInput;
};


export type MutationCreateBillingAccountApiLicenceArgs = {
  input: CreateBillingAccountApiLicenceInput;
};


export type MutationCreateBillingAccountAccessTokenArgs = {
  input: CreateBillingAccountAccessTokenInput;
};


export type MutationCreateCalculationArgs = {
  input: CreateCalculationInput;
};


export type MutationCreateContactTagRuleArgs = {
  input: CreateContactTagRuleInput;
};


export type MutationCreateCustomThemeArgs = {
  input: GdPortalCreateCustomThemeInput;
};


export type MutationCreateCustomerFieldArgs = {
  input: GdPortalCreateCustomerFieldInput;
};


export type MutationCreateCustomerGroupArgs = {
  input: GdPortalCreateCustomerGroupInput;
};


export type MutationCreateCustomerImportJobArgs = {
  input: GdPortalCreateImportJobInput;
};


export type MutationCreateCustomerPortalArgs = {
  input: GdPortalCreatePortalInput;
};


export type MutationCreateCustomerPortalAuthorizationArgs = {
  input: GdPortalCreatePortalAuthorizationInput;
};


export type MutationCreateCustomerPortalPvArgs = {
  input: GdPortalCreatePortalPvInput;
};


export type MutationCreateCustomerPortalSessionArgs = {
  input: GdPortalCreatePortalSessionInput;
};


export type MutationCreateCustomerWeixinPortalSessionArgs = {
  input: GdPortalCreateWeixinPortalSessionInput;
};


export type MutationCreateEmailArgs = {
  input: CreateEmailInput;
};


export type MutationCreateEntriesBatchJobArgs = {
  input: CreateBatchJobInput;
};


export type MutationCreateEntriesExportJobArgs = {
  input: CreateExportJobInput;
};


export type MutationCreateEntryAttachmentArgs = {
  input: CreateEntryAttachmentInput;
};


export type MutationCreateEntryAttachmentPresignedTokenArgs = {
  input: CreateEntryAttachmentPresignedTokenInput;
};


export type MutationCreateEntryAttachmentUploadTokenArgs = {
  input: CreateEntryAttachmentUploadTokenInput;
};


export type MutationCreateEntryAttachmentsTaskArgs = {
  input: CreateEntryAttachmentsTaskInput;
};


export type MutationCreateEntryEmailTaskArgs = {
  input: CreateEntryEmailTaskInput;
};


export type MutationCreateEntrySmsTaskArgs = {
  input: CreateEntrySmsTaskInput;
};


export type MutationCreateExtendedAttributeFilterArgs = {
  input: CreateExtendedAttributeFilterInput;
};


export type MutationCreateFeatureTrialArgs = {
  input: CreateFeatureTrialInput;
};


export type MutationCreateFieldVerificationArgs = {
  input: CreateFieldVerificationInput;
};


export type MutationCreateFormArgs = {
  input: CreateFormInput;
};


export type MutationCreateFormAmapStatsArgs = {
  input: CreateFormAmapStatsInput;
};


export type MutationCreateFormApplicationTrialArgs = {
  input: CreateFormApplicationTrialInput;
};


export type MutationCreateFormCooperatorLinkArgs = {
  input: CreateCooperatorLinkInput;
};


export type MutationCreateFormCooperatorsArgs = {
  input: CreateFormCooperatorsInput;
};


export type MutationCreateFormEntryArgs = {
  input: CreateFormEntryInput;
};


export type MutationCreateFormFolderArgs = {
  input: CreateFormFolderInput;
};


export type MutationCreateFormFromImportJobArgs = {
  input: CreateFormFromImportJobInput;
};


export type MutationCreateFormHeaderImageAttachmentArgs = {
  input: CreateFormHeaderImageAttachmentInput;
};


export type MutationCreateFormImportJobArgs = {
  input: CreateFormImportJobInput;
};


export type MutationCreateFormPosterArgs = {
  input: CreateFormPosterInput;
};


export type MutationCreateFormRoleArgs = {
  input: CreateFormRoleInput;
};


export type MutationCreateFormViewArgs = {
  input: CreateFormViewInput;
};


export type MutationCreateIndustryArgs = {
  input: CreateIndustryInput;
};


export type MutationCreateInvoiceArgs = {
  input: CreateInvoiceInput;
};


export type MutationCreateInvoiceTitleArgs = {
  input: CreateInvoiceTitleInput;
};


export type MutationCreateMobileArgs = {
  input: CreateMobileInput;
};


export type MutationCreateMobileVerificationArgs = {
  input: CreateMobileVerificationInput;
};


export type MutationCreateNotificationVerificationSignaturesArgs = {
  input: CreateNotificationVerificationSignaturesInput;
};


export type MutationCreateOfflineRechargeArgs = {
  input: CreateOfflineRechargeInput;
};


export type MutationCreateOpenEntryArgs = {
  input: CreateOpenEntriesInput;
};


export type MutationCreateOpenEntryOauthSessionArgs = {
  input: CreateOpenEntryOauthSessionInput;
};


export type MutationCreateOpenEntrySessionArgs = {
  input: CreateOpenEntrySessionInput;
};


export type MutationCreateOpenEntrySmsVerifyCodeArgs = {
  input: CreateOpenEntrySmsVerifyCodeInput;
};


export type MutationCreateOpenResultArgs = {
  input: CreateOpenResultInput;
};


export type MutationCreateOpenSearchArgs = {
  input: CreateOpenSearchInput;
};


export type MutationCreatePaymentAccountArgs = {
  input: CreatePaymentAccountInput;
};


export type MutationCreatePersonalAccessTokenArgs = {
  input: CreatePersonalAccessTokenInput;
};


export type MutationCreatePortalAssetsArgs = {
  input: GdPortalCreateAssetsInput;
};


export type MutationCreatePortalCustomerOrderArgs = {
  input: GdPortalCreatePortalCustomerOrderInput;
};


export type MutationCreatePresignedTokenArgs = {
  input: CreatePresignedTokenInput;
};


export type MutationCreatePrizeVoucherArgs = {
  input: CreatePrizeVoucherInput;
};


export type MutationCreatePseudoFormArgs = {
  input: CreatePseudoFormInput;
};


export type MutationCreatePublishedFormEntryArgs = {
  input: CreatePublishedFormEntryInput;
};


export type MutationCreateQiniuCallbackArgs = {
  input: CreateQiniuCallbackInput;
};


export type MutationCreateQiniuTokenArgs = {
  input: CreateQiniuTokenInput;
};


export type MutationCreateRemainingPrizeVoucherAttachmentArgs = {
  input: CreateRemainingPrizeVoucherAttachmentInput;
};


export type MutationCreateReportsExportJobArgs = {
  input: CreateFormReportsExportJobInput;
};


export type MutationCreateSmsSignatureArgs = {
  input: CreateSmsSignatureInput;
};


export type MutationCreateSmsVerificationArgs = {
  input: GdPortalCreateSmsVerificationInput;
};


export type MutationCreateSmtpAccountArgs = {
  input: CreateSmtpAccountInput;
};


export type MutationCreateSubmitterGroupArgs = {
  input: CreateSubmitterGroupInput;
};


export type MutationCreateSubmitterOauthLoginSessionArgs = {
  input: CreateSubmitterOauthLoginSessionInput;
};


export type MutationCreateSubmitterPortalSessionArgs = {
  input: CreateSubmitterPortalSessionInput;
};


export type MutationCreateSubmitterResponseRateExportJobArgs = {
  input: CreateSubmitterResponseRateExportJobInput;
};


export type MutationCreateSubmitterSendingTaskArgs = {
  input: CreateSubmitterSendingTaskInput;
};


export type MutationCreateSubmitterSmsVerifyCodeArgs = {
  input: CreateSubmitterSmsVerifyCodeInput;
};


export type MutationCreateSubmitterWeixinQiyeLoginSessionArgs = {
  input: CreateSubmitterWeixinQiyeLoginSessionInput;
};


export type MutationCreateSystemIncidentActionArgs = {
  input: CreateSystemIncidentActionInput;
};


export type MutationCreateTableArgs = {
  input: CreateTableInput;
};


export type MutationCreateTemplateWithdrawAccountArgs = {
  input: CreateWithdrawAccountInput;
};


export type MutationCreateUserInviteLinkArgs = {
  input: CreateUserInviteLinkInput;
};


export type MutationCsManageUpdateCsManArgs = {
  input: CsManageUpdateCsManInput;
};


export type MutationCustomerRegisterArgs = {
  input: GdPortalCreateCustomerInput;
};


export type MutationDeleteCustomerArgs = {
  input: GdPortalDeleteCustomerInput;
};


export type MutationDeleteExportJobArgs = {
  input: DeleteExportJobInput;
};


export type MutationDeleteFormEntriesArgs = {
  input: DeleteFormEntriesInput;
};


export type MutationDeletePaymentAccountArgs = {
  input: DeletePaymentAccountInput;
};


export type MutationDeleteSmtpAccountArgs = {
  input: DeleteSmtpAccountInput;
};


export type MutationDeleteSubmitterPortalSessionArgs = {
  input: DeleteSubmitterPortalSessionInput;
};


export type MutationDeleteUserBaseFileTagArgs = {
  input: DeleteUserBaseFileTagInput;
};


export type MutationDeleteWeixinAccountArgs = {
  input: DeleteWeixinAccountInput;
};


export type MutationDestroyAdvancedNotificationsRuleArgs = {
  input: DestroyAdvancedNotificationsRuleInput;
};


export type MutationDestroyAuthorizedApplicationArgs = {
  input: DestroyAuthorizedApplicationInput;
};


export type MutationDestroyBillingAccountUserArgs = {
  input: DestroyBillingAccountUserInput;
};


export type MutationDestroyContactTagRuleArgs = {
  input: DestroyContactTagRuleInput;
};


export type MutationDestroyCustomThemeArgs = {
  input: GdPortalDestroyCustomThemeInput;
};


export type MutationDestroyCustomerFieldArgs = {
  input: GdPortalDestroyCustomerFieldInput;
};


export type MutationDestroyCustomerGroupArgs = {
  input: GdPortalDestroyCustomerGroupInput;
};


export type MutationDestroyCustomerPortalArgs = {
  input: GdPortalDestroyPortalInput;
};


export type MutationDestroyCustomerPortalSessionArgs = {
  input: GdPortalDestroyPortalSessionInput;
};


export type MutationDestroyEntriesBatchJobArgs = {
  input: DestroyEntriesBatchJobInput;
};


export type MutationDestroyEntriesExportJobArgs = {
  input: DestroyEntriesExportJobInput;
};


export type MutationDestroyEntryAttachmentsTaskArgs = {
  input: DestroyEntryAttachmentsTaskInput;
};


export type MutationDestroyExtendedAttributeFilterArgs = {
  input: DestroyExtendedAttributeFilterInput;
};


export type MutationDestroyFeatureTrialArgs = {
  input: DestroyFeatureTrialInput;
};


export type MutationDestroyFormArgs = {
  input: DestroyFormInput;
};


export type MutationDestroyFormCooperatorArgs = {
  input: DestroyFormCooperatorInput;
};


export type MutationDestroyFormCooperatorLinkArgs = {
  input: DestroyFormCooperatorLinkInput;
};


export type MutationDestroyFormCooperatorLinksArgs = {
  input: DestroyFormCooperatorLinksInput;
};


export type MutationDestroyFormFolderArgs = {
  input: DestroyFormFolderInput;
};


export type MutationDestroyFormRoleArgs = {
  input: DestroyFormRoleInput;
};


export type MutationDestroyFormViewArgs = {
  input: DestroyFormViewInput;
};


export type MutationDestroyInvoiceTitleArgs = {
  input: DestroyInvoiceTitleInput;
};


export type MutationDestroyOpenEntryArgs = {
  input: DestroyOpenEntryInput;
};


export type MutationDestroyOpenResultArgs = {
  input: DestroyOpenResultInput;
};


export type MutationDestroyOpenSearchArgs = {
  input: DestroyOpenSearchInput;
};


export type MutationDestroyPendingCustomerArgs = {
  input: GdPortalDestroyPendingCustomerInput;
};


export type MutationDestroyPortalAssetsArgs = {
  input: GdPortalDestroyAssetsInput;
};


export type MutationDestroyPseudoFormArgs = {
  input: DestroyPseudoFormInput;
};


export type MutationDestroySmsSignatureArgs = {
  input: DestroySmsSignatureInput;
};


export type MutationDestroySmsTemplateArgs = {
  input: DestroySmsTemplateInput;
};


export type MutationDestroySessionArgs = {
  input: DestroySessionInput;
};


export type MutationDestroySessionExceptCurrentArgs = {
  input: DestroySessionExceptCurrentInput;
};


export type MutationDestroySocialAuthenticationArgs = {
  input: DestroySocialAuthenticationInput;
};


export type MutationDestroySubmitterGroupArgs = {
  input: DestroySubmitterGroupInput;
};


export type MutationDestroySubmitterSocialIdentityArgs = {
  input: DestroySubmitterSocialIdentityInput;
};


export type MutationDestroySystemIncidentActionArgs = {
  input: DestroySystemIncidentActionInput;
};


export type MutationDestroyTableArgs = {
  input: DestroyTableInput;
};


export type MutationDestroyTemplateCouponArgs = {
  input: DestroyTemplateCouponInput;
};


export type MutationDestroyUserArgs = {
  input: DestroyUserInput;
};


export type MutationDestroyUserInviteLinksArgs = {
  input: DestroyUserInviteLinksInput;
};


export type MutationDestroyWheelFortuneWinnerArgs = {
  input: DestroyWheelFortuneWinnerInput;
};


export type MutationDisplayRankArgs = {
  input: DisplayRankInput;
};


export type MutationEndHandoffArgs = {
  input: EndHandoffInput;
};


export type MutationExecuteFormImportJobArgs = {
  input: ExecuteFormImportJobInput;
};


export type MutationGenerateEntryCertificateArgs = {
  input: GenerateEntryCertificateInput;
};


export type MutationHideAiGeneratedFormHeaderImageArgs = {
  input: HideAiGeneratedImageInput;
};


export type MutationHideAiGeneratedFormPosterArgs = {
  input: HideAiGeneratedPosterInput;
};


export type MutationLicenseRecognizeArgs = {
  input: LicenseRecognizeInput;
};


export type MutationMarkAllNotificationsReadArgs = {
  input: MarkAllNotificationsReadInput;
};


export type MutationMarkNotificationReadArgs = {
  input: MarkNotificationReadInput;
};


export type MutationMiniappBindEntryOpenidArgs = {
  input: MiniappBindEntryOpenidInput;
};


export type MutationMoveToFolderArgs = {
  input: MoveToFolderInput;
};


export type MutationPatchFormEntryArgs = {
  input: PatchFormEntryInput;
};


export type MutationPreviewCustomerGroupArgs = {
  input: GdPortalPreviewCustomerGroupInput;
};


export type MutationPreviewFormArgs = {
  input: PreviewInput;
};


export type MutationPublishedFormsMobileVerificationsArgs = {
  input: PublishedFormsMobileVerificationsInput;
};


export type MutationPublishedOpenSearchEntryEditVerificationsArgs = {
  input: PublishedOpenSearchEntryEditVerificationsInput;
};


export type MutationPublishedOpenSearchMobileVerificationsArgs = {
  input: PublishedOpenSearchMobileVerificationsInput;
};


export type MutationPublishedOpenSearchUpdateEntryArgs = {
  input: PublishedOpenSearchUpdateEntryInput;
};


export type MutationReorderFormViewsArgs = {
  input: ReorderFormViewsInput;
};


export type MutationResendEntryEmailTaskArgs = {
  input: ResendEntryEmailTaskInput;
};


export type MutationResendEntrySmsTaskArgs = {
  input: ResendEntrySmsTaskInput;
};


export type MutationReserveAccountManagerArgs = {
  input: ReserveAccountManagerInput;
};


export type MutationResetCustomerPasswordArgs = {
  input: GdPortalResetCustomerPasswordInput;
};


export type MutationResetPortalCustomerPasswordArgs = {
  input: GdPortalResetPortalCustomerPasswordInput;
};


export type MutationRestoreFormArgs = {
  input: RestoreFormInput;
};


export type MutationRestoreFormEntriesArgs = {
  input: RestoreFormEntriesInput;
};


export type MutationRevokeBillingAccountAccessTokenArgs = {
  input: RevokeBillingAccountAccessTokenInput;
};


export type MutationRevokePersonalAccessTokenArgs = {
  input: RevokePersonalAccessTokenInput;
};


export type MutationSaveConversationSummaryArgs = {
  input: SaveConversationSummaryInput;
};


export type MutationSaveFormWheelFortuneArgs = {
  input: SaveWheelFortuneInput;
};


export type MutationSaveSmsTemplateArgs = {
  input: SaveSmsTemplateInput;
};


export type MutationSaveTemplateCouponArgs = {
  input: SaveTemplateCouponInput;
};


export type MutationSaveThemeArgs = {
  input: SaveThemeInput;
};


export type MutationSaveUserLicenseInfoArgs = {
  input: SaveUserLicenseInfoInput;
};


export type MutationSendMessageArgs = {
  input: SendMessageInput;
};


export type MutationSendYamchaCardMessageArgs = {
  input: SendYamchaCardMessageInput;
};


export type MutationSmsValidationContentArgs = {
  input: SmsValidationContentInput;
};


export type MutationSortUserBaseFileTagArgs = {
  input: SortUserBaseFileTagInput;
};


export type MutationSwitchDataTablesArgs = {
  input: SwitchDataTablesInput;
};


export type MutationSwitchUserArgs = {
  input: SwitchUserInput;
};


export type MutationTakeoverConversationArgs = {
  input: TakeoverConversationInput;
};


export type MutationTransferFormArgs = {
  input: TransferFormInput;
};


export type MutationTransferHandoffArgs = {
  input: TransferHandoffInput;
};


export type MutationUpdateAdvancedNotificationsRuleArgs = {
  input: UpdateAdvancedNotificationsRuleInput;
};


export type MutationUpdateAvatarArgs = {
  input: UpdateAvatarInput;
};


export type MutationUpdateBaseFileTagArgs = {
  input: UpdateBaseFileTagInput;
};


export type MutationUpdateBillingAccountArgs = {
  input: UpdateBillingAccountInput;
};


export type MutationUpdateBillingAccountLandingInfoArgs = {
  input: UpdateBillingAccountLandingInfoInput;
};


export type MutationUpdateBillingAccountUrlParamsSignSecretArgs = {
  input: UpdateBillingAccountUrlParamsSignSecretInput;
};


export type MutationUpdateBillingAccountUserArgs = {
  input: UpdateBillingAccountUserInput;
};


export type MutationUpdateContactTagRuleArgs = {
  input: UpdateContactTagRuleInput;
};


export type MutationUpdateCurrentUserArgs = {
  input: UpdateCurrentUserInput;
};


export type MutationUpdateCustomThemeArgs = {
  input: GdPortalUpdateCustomThemeInput;
};


export type MutationUpdateCustomerArgs = {
  input: GdPortalUpdateCustomerInput;
};


export type MutationUpdateCustomerEmailArgs = {
  input: GdPortalUpdateEmailInput;
};


export type MutationUpdateCustomerFieldArgs = {
  input: GdPortalUpdateCustomerFieldInput;
};


export type MutationUpdateCustomerFilledDataArgs = {
  input: GdPortalUpdateCustomerFilledEntryInput;
};


export type MutationUpdateCustomerGroupArgs = {
  input: GdPortalUpdateCustomerGroupInput;
};


export type MutationUpdateCustomerMobileArgs = {
  input: GdPortalUpdateMobileInput;
};


export type MutationUpdateCustomerPasswordArgs = {
  input: GdPortalUpdatePasswordInput;
};


export type MutationUpdateCustomerPortalArgs = {
  input: GdPortalUpdatePortalInput;
};


export type MutationUpdateCustomerProfileArgs = {
  input: GdPortalUpdateCustomerProfileInput;
};


export type MutationUpdateEmailArgs = {
  input: UpdateEmailInput;
};


export type MutationUpdateEntryArgs = {
  input: UpdateEntryInput;
};


export type MutationUpdateEntrySingleSharingArgs = {
  input: UpdateEntrySingleSharingInput;
};


export type MutationUpdateEntrySmsTaskArgs = {
  input: UpdateEntrySmsTaskInput;
};


export type MutationUpdateFeatureTrialArgs = {
  input: UpdateFeatureTrialInput;
};


export type MutationUpdateFieldStateFlowArgs = {
  input: UpdateFieldStateFlowInput;
};


export type MutationUpdateFormArgs = {
  input: UpdateFormInput;
};


export type MutationUpdateFormCooperatorArgs = {
  input: UpdateFormCooperatorInput;
};


export type MutationUpdateFormEntryArgs = {
  input: UpdateFormEntryInput;
};


export type MutationUpdateFormEntryRedEnvelopeSettingArgs = {
  input: UpdateEntryRedEnvelopeSettingInput;
};


export type MutationUpdateFormEntryRemarkArgs = {
  input: UpdateFormEntryRemarkInput;
};


export type MutationUpdateFormFieldApiCodeAliasArgs = {
  input: UpdateFormFieldApiCodeAliasInput;
};


export type MutationUpdateFormFolderArgs = {
  input: UpdateFormFolderInput;
};


export type MutationUpdateFormFolderShareSettingArgs = {
  input: UpdateShareSettingInput;
};


export type MutationUpdateFormLayoutArgs = {
  input: UpdateFormLayoutInput;
};


export type MutationUpdateFormRoleArgs = {
  input: UpdateFormRoleInput;
};


export type MutationUpdateFormSettingArgs = {
  input: UpdateFormSettingInput;
};


export type MutationUpdateFormSymbolArgs = {
  input: UpdateFormSymbolInput;
};


export type MutationUpdateFormViewArgs = {
  input: UpdateFormViewInput;
};


export type MutationUpdateInvoiceTitleArgs = {
  input: UpdateInvoiceTitleInput;
};


export type MutationUpdateLocaleArgs = {
  input: UpdateLocaleInput;
};


export type MutationUpdateMobileArgs = {
  input: UpdateMobileInput;
};


export type MutationUpdateOpenEntryArgs = {
  input: UpdateOpenEntryInput;
};


export type MutationUpdateOpenResultArgs = {
  input: UpdateOpenResultInput;
};


export type MutationUpdateOpenSearchArgs = {
  input: UpdateOpenSearchInput;
};


export type MutationUpdatePasswordArgs = {
  input: UpdatePasswordInput;
};


export type MutationUpdatePaymentAccountArgs = {
  input: UpdatePaymentAccountInput;
};


export type MutationUpdatePaymentRedirectExceptionRulesArgs = {
  input: UpdatePaymentRedirectExceptionRulesInput;
};


export type MutationUpdatePhantomFormArgs = {
  input: UpdatePhantomFormInput;
};


export type MutationUpdatePortalPublishedUrlDomainArgs = {
  input: GdPortalUpdatePortalPublishedUrlDomainInput;
};


export type MutationUpdateProfileArgs = {
  input: UpdateProfileInput;
};


export type MutationUpdatePseudoFormArgs = {
  input: UpdatePseudoFormInput;
};


export type MutationUpdatePublishedFormEntryArgs = {
  input: UpdatePublishedFormEntryInput;
};


export type MutationUpdatePublishedWeixinEntryArgs = {
  input: UpdatePublishedWeixinEntryInput;
};


export type MutationUpdateReversedAssociationSettingArgs = {
  input: UpdateReversedAssociationSettingInput;
};


export type MutationUpdateSmsSignatureArgs = {
  input: UpdateSmsSignatureInput;
};


export type MutationUpdateSmsYunpianSignatureArgs = {
  input: UpdateSmsYunpianSignatureInput;
};


export type MutationUpdateSessionArgs = {
  input: UpdateSessionInput;
};


export type MutationUpdateSingleEntryShareSettingArgs = {
  input: UpdateSingleEntryShareSettingInput;
};


export type MutationUpdateSmtpAccountArgs = {
  input: UpdateSmtpAccountInput;
};


export type MutationUpdateSubmitterGroupArgs = {
  input: UpdateSubmitterGroupInput;
};


export type MutationUpdateSubmitterPortalArgs = {
  input: UpdateSubmitterPortalInput;
};


export type MutationUpdateSystemIncidentActionArgs = {
  input: UpdateSystemIncidentActionInput;
};


export type MutationUpdateTableArgs = {
  input: UpdateTableInput;
};


export type MutationUpdateUsageScenariosArgs = {
  input: UpdateUsageScenariosInput;
};


export type MutationUpdateUserAppSettingArgs = {
  input: UpdateUserAppSettingInput;
};


export type MutationUpdateUserBaseFileTagArgs = {
  input: UpdateUserBaseFileTagInput;
};


export type MutationUpdateUserExtrainfoArgs = {
  input: UpdateUserExtrainfoInput;
};


export type MutationUpdateUserFormAppSettingArgs = {
  input: UpdateUserFormAppSettingInput;
};


export type MutationUpdateUserFormSettingArgs = {
  input: UpdateUserFormSettingInput;
};


export type MutationUpdateUserPlanArgs = {
  input: UpdateUserPlanInput;
};


export type MutationUpdateUserSettingArgs = {
  input: UpdateUserSettingInput;
};


export type MutationUpdateUserSubmitterGroupSettingArgs = {
  input: UpdateUserSubmitterGroupSettingInput;
};


export type MutationUpdateWheelFortuneWinnerArgs = {
  input: UpdateWheelFortuneWinnerInput;
};


export type MutationValidatePublishedFormFieldsArgs = {
  input: ValidatePublishedFormFieldsInput;
};


export type MutationVerifyEmailArgs = {
  input: CreateEmailVerificationInput;
};


export type MutationWeixinBindArgs = {
  input: WeixinBindInput;
};

export type NameField = AccessControlableField & AssociatedField & BaseField & CalculableField & ExtraConfigurableSetting & FieldAbility & FormatValidatableField & LengthValidatableField & PlanAvailableField & PredefineableField & WithStatementPredefinedValues & {
  accessControlType: AccessControlType;
  accessControlValues?: Maybe<Array<Scalars['String']['output']>>;
  apiCode: Scalars['ID']['output'];
  apiCodeAlias?: Maybe<Scalars['String']['output']>;
  /** 对应的表单关联字段 */
  associationField?: Maybe<Field>;
  /** 自动填写上次提交内容 */
  cacheData: Scalars['Boolean']['output'];
  /** 开启选项赋值或本身可参与计算 */
  calculable: Scalars['Boolean']['output'];
  /** 客户端ID */
  cid?: Maybe<Scalars['String']['output']>;
  customValidationRegex?: Maybe<Scalars['String']['output']>;
  /** 封装的字段类型 */
  customizedType?: Maybe<Scalars['String']['output']>;
  /** 封装的字段类型文本 */
  customizedTypeName?: Maybe<Scalars['String']['output']>;
  /** 自定义出错文案 */
  customizedValidationMessage?: Maybe<Scalars['String']['output']>;
  /** 已提交的数据是否可被编辑 */
  editable: Scalars['Boolean']['output'];
  /** 场景化可配置字段设置 */
  extraConfigurableSettings?: Maybe<FieldExtraConfigurableSettings>;
  /** 该字段能否使用字段规则: true - 能， false - 不能 */
  fieldRuleAvailable: Scalars['Boolean']['output'];
  /** 是否是关联主键字段 */
  forAssociated?: Maybe<Scalars['Boolean']['output']>;
  /** 是否是关联展示字段 */
  forAssociatedDisplay?: Maybe<Scalars['Boolean']['output']>;
  /** 表单Token */
  formToken: Scalars['String']['output'];
  formatValidationEnabled: Scalars['Boolean']['output'];
  formatValidationJsRegex?: Maybe<JsRegex>;
  formatValidationType?: Maybe<FieldValidation>;
  /** 宽度占用整行的四分之几 */
  gridsToOccupy?: Maybe<Scalars['Int']['output']>;
  hasAbility: Scalars['Boolean']['output'];
  /** 字段标题（去富文本化） */
  label?: Maybe<Scalars['String']['output']>;
  maximumLength?: Maybe<Scalars['BigInteger']['output']>;
  minimumLength?: Maybe<Scalars['BigInteger']['output']>;
  /** 字段描述，富文本 */
  notes?: Maybe<Scalars['String']['output']>;
  paidFeature?: Maybe<PaidFeature>;
  /** 占位符 */
  placeholder?: Maybe<Scalars['String']['output']>;
  planAvailable: Scalars['Boolean']['output'];
  /** 字段排序 */
  position: Scalars['Int']['output'];
  /** 预填写表单 */
  predefined: Scalars['Boolean']['output'];
  /** 默认值 */
  predefinedValue?: Maybe<Scalars['String']['output']>;
  /** 该字段是否是隐私字段 true - 是, false - 不是 */
  privacy: Scalars['Boolean']['output'];
  /** 字段隐藏 */
  private: Scalars['Boolean']['output'];
  /** 字段是否通过预填写表单预设了值 true - 是, false - 否 */
  pseudoFormPredefined?: Maybe<Scalars['Boolean']['output']>;
  /** 字段标题（富文本化） */
  rawLabel?: Maybe<Scalars['String']['output']>;
  /** 字段是否只读，无法编辑 */
  readonly?: Maybe<Scalars['Boolean']['output']>;
  /** 扫码录入时截取部分字符的起始位置 */
  scanBegin?: Maybe<Scalars['BigInteger']['output']>;
  /** 扫码录入时截取部分字符的结束位置 */
  scanEnd?: Maybe<Scalars['BigInteger']['output']>;
  /** 微信扫码录入 */
  scannable: Scalars['Boolean']['output'];
  /** 该字段是否属于评分字段（e.g. 考试、测评中的题目） */
  scorable: Scalars['Boolean']['output'];
  /** 字段提示较长时折叠展示 */
  showPartDescription: Scalars['Boolean']['output'];
  /** 新起一行 */
  startNewRow: Scalars['Boolean']['output'];
  statementPredefinedValues?: Maybe<FieldStatementPredefinedValues>;
  /** 该字段是否可以作为文本插入 true - 能, false - 不能 */
  textPlaceholderable: Scalars['Boolean']['output'];
  /** 扫码录入时截取部分字符 */
  trimmable: Scalars['Boolean']['output'];
  /** 字段类型 */
  type: FieldClass;
  /** 字段类型文本 */
  typeName: Scalars['String']['output'];
  /** 字段验证规则 */
  validations?: Maybe<Array<FieldValidation>>;
};


export type NameFieldHasAbilityArgs = {
  key: FieldAbilityEnum;
};


export type NameFieldNotesArgs = {
  sanitize?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum NavDisplay {
  /** Logo */
  Logo = 'logo',
  /** Logo text */
  LogoText = 'logo_text',
  /** Text */
  Text = 'text'
}

export enum Navigation {
  /** 外部共享 */
  ExternalSharedForms = 'external_shared_forms',
  /** 我收藏的 */
  FavoritesForms = 'favorites_forms',
  /** 回收站 */
  FormTrash = 'form_trash',
  /** 我的表单 */
  MyForms = 'my_forms',
  /** 我为别人填的表单 */
  ParticipatedForm = 'participated_form',
  /** 与我共享 */
  SharedForms = 'shared_forms',
  /** 标签 */
  Tag = 'tag',
  /** 试用企业高级版 */
  TryEnterprise = 'try_enterprise',
  /** 套餐到期受影响表单 */
  WithFieldsUnusableForms = 'with_fields_unusable_forms'
}

export enum NavigationItemTypeEnum {
  /** 我 */
  ProfileNavigationItem = 'ProfileNavigationItem',
  /** 工作台 */
  WorkspaceNavigationItem = 'WorkspaceNavigationItem'
}

export type NewUiAbility = {
  on?: Maybe<Scalars['Boolean']['output']>;
};

export type NonReservableRule = {
  endTime: Scalars['ISO8601DateTime']['output'];
  startTime: Scalars['ISO8601DateTime']['output'];
};

export type NonReservableRuleAttributes = {
  /** 不可约时段截止日期 */
  endTime: Scalars['ISO8601DateTime']['input'];
  /** 不可约时段开始日期 */
  startTime: Scalars['ISO8601DateTime']['input'];
};

export type NotImplementedApplication = {
  /** 表单插件关联表单 */
  form: Form;
  /** 是否已有其他表单插件 */
  hasSiblingFormApplication: Scalars['Boolean']['output'];
  /** 插件ID */
  id: Scalars['ID']['output'];
  /** 插件开关：true - 已开启，false - 未开启 */
  opened: Scalars['Boolean']['output'];
};

export type NotImplementedField = AssociatedField & BaseField & FieldAbility & PlanAvailableField & {
  apiCode: Scalars['ID']['output'];
  apiCodeAlias?: Maybe<Scalars['String']['output']>;
  /** 对应的表单关联字段 */
  associationField?: Maybe<Field>;
  /** 自动填写上次提交内容 */
  cacheData: Scalars['Boolean']['output'];
  /** 客户端ID */
  cid?: Maybe<Scalars['String']['output']>;
  /** 封装的字段类型 */
  customizedType?: Maybe<Scalars['String']['output']>;
  /** 封装的字段类型文本 */
  customizedTypeName?: Maybe<Scalars['String']['output']>;
  /** 自定义出错文案 */
  customizedValidationMessage?: Maybe<Scalars['String']['output']>;
  /** 已提交的数据是否可被编辑 */
  editable: Scalars['Boolean']['output'];
  /** 该字段能否使用字段规则: true - 能， false - 不能 */
  fieldRuleAvailable: Scalars['Boolean']['output'];
  /** 是否是关联主键字段 */
  forAssociated?: Maybe<Scalars['Boolean']['output']>;
  /** 是否是关联展示字段 */
  forAssociatedDisplay?: Maybe<Scalars['Boolean']['output']>;
  /** 表单Token */
  formToken: Scalars['String']['output'];
  /** 宽度占用整行的四分之几 */
  gridsToOccupy?: Maybe<Scalars['Int']['output']>;
  hasAbility: Scalars['Boolean']['output'];
  /** 字段标题（去富文本化） */
  label?: Maybe<Scalars['String']['output']>;
  /** 字段描述，富文本 */
  notes?: Maybe<Scalars['String']['output']>;
  paidFeature?: Maybe<PaidFeature>;
  planAvailable: Scalars['Boolean']['output'];
  /** 字段排序 */
  position: Scalars['Int']['output'];
  /** 该字段是否是隐私字段 true - 是, false - 不是 */
  privacy: Scalars['Boolean']['output'];
  /** 字段隐藏 */
  private: Scalars['Boolean']['output'];
  /** 字段是否通过预填写表单预设了值 true - 是, false - 否 */
  pseudoFormPredefined?: Maybe<Scalars['Boolean']['output']>;
  /** 字段标题（富文本化） */
  rawLabel?: Maybe<Scalars['String']['output']>;
  /** 字段是否只读，无法编辑 */
  readonly?: Maybe<Scalars['Boolean']['output']>;
  /** 该字段是否属于评分字段（e.g. 考试、测评中的题目） */
  scorable: Scalars['Boolean']['output'];
  /** 字段提示较长时折叠展示 */
  showPartDescription: Scalars['Boolean']['output'];
  /** 新起一行 */
  startNewRow: Scalars['Boolean']['output'];
  /** 该字段是否可以作为文本插入 true - 能, false - 不能 */
  textPlaceholderable: Scalars['Boolean']['output'];
  /** 字段类型 */
  type: FieldClass;
  /** 字段类型文本 */
  typeName: Scalars['String']['output'];
  /** 字段验证规则 */
  validations?: Maybe<Array<FieldValidation>>;
};


export type NotImplementedFieldHasAbilityArgs = {
  key: FieldAbilityEnum;
};


export type NotImplementedFieldNotesArgs = {
  sanitize?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NotImplementedNotification = Base & {
  /** 推送类型 */
  approach: Approach;
  cachedFormName: Scalars['String']['output'];
  /** 推送/短信/邮件内容 */
  content?: Maybe<Scalars['String']['output']>;
  entry?: Maybe<Entry>;
  /** 错误信息 */
  errorMessage?: Maybe<Scalars['String']['output']>;
  form?: Maybe<Form>;
  id: Scalars['ID']['output'];
  /** 发送时间（不等于任务触发时间） */
  performedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** 收件人，常用于短信和邮件 */
  recipient?: Maybe<Scalars['String']['output']>;
  /** 状态 */
  status: Status;
};

export type NotImplementedRule = BaseRule & {
  /** 推送类型 */
  approach: Approach;
  /** 发送条件字段 api_code */
  conditionKey?: Maybe<Scalars['String']['output']>;
  /** 发送条件的值 */
  conditionValue?: Maybe<Scalars['String']['output']>;
  /** true: 开启ScopeCondition */
  conditionalScope?: Maybe<Scalars['Boolean']['output']>;
  /** 任务禁用原因，仅 enabled: false 时有效 */
  disabledBy?: Maybe<DisabledBy>;
  /** 任务是否开启 */
  enabled: Scalars['Boolean']['output'];
  /** 是否为支付条件 */
  entryPaid?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  /** 发送量 */
  notificationsCount?: Maybe<Scalars['Int']['output']>;
  /** 按周期重复发送 */
  repeatRule?: Maybe<RepeatRule>;
  /** 基于数据定制规则发送 */
  scheduleRule?: Maybe<ScheduleRule>;
  /** 基于日期发送的规则 */
  scheduleTimeRule?: Maybe<ScheduleTimeRule>;
  /** ScopeCondition条件组 */
  scopeConditions?: Maybe<Array<ScopeCondition>>;
  /** 指定发送时间 */
  sendAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** 何时发送 */
  sendTiming?: Maybe<SendTiming>;
  /** 推送范围 */
  triggerScope: TriggerScope;
  /** 更新时间 */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export enum NotificationActionTypeEnum {
  /** 按钮 */
  Button = 'button',
  /** 无 */
  None = 'none',
  /** 文字链接 */
  TextLink = 'text_link'
}

/** The connection type for Notifications. */
export type NotificationConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<NotificationEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Notifications>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** 总的数量 */
  totalCount: Scalars['Int']['output'];
  /** 总的未读数 */
  totalUnreadCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type NotificationEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Notifications>;
};

export enum NotificationStatus {
  /** Approved */
  Approved = 'APPROVED',
  /** Auditing */
  Auditing = 'AUDITING',
  /** Cancelled */
  Cancelled = 'CANCELLED',
  /** Failed */
  Failed = 'FAILED',
  /** Rejected */
  Rejected = 'REJECTED',
  /** Revoked */
  Revoked = 'REVOKED',
  /** Scheduled */
  Scheduled = 'SCHEDULED',
  /** Success */
  Success = 'SUCCESS',
  /** Waiting */
  Waiting = 'WAITING'
}

export type Notifications = {
  /** @deprecated Removed. Kept for backward compatibility with older App versions. */
  actionLabel?: Maybe<Scalars['String']['output']>;
  /** @deprecated Removed. Kept for backward compatibility with older App versions. */
  actionType: NotificationActionTypeEnum;
  /** @deprecated Removed. Kept for backward compatibility with older App versions. */
  actionUrl?: Maybe<Scalars['String']['output']>;
  activity?: Maybe<Activity>;
  /** 影响数据量，例如[表单新增数据条数] */
  count: Scalars['Int']['output'];
  endTime: Scalars['ISO8601DateTime']['output'];
  /** ID */
  id: Scalars['ID']['output'];
  /** 是否已读 */
  read: Scalars['Boolean']['output'];
  startTime: Scalars['ISO8601DateTime']['output'];
  /** 操作类型 */
  verb: Scalars['String']['output'];
};

export type NpsField = AssociatedField & BaseField & ExtraConfigurableSetting & FieldAbility & PlanAvailableField & WithRatingsDisplayText & {
  apiCode: Scalars['ID']['output'];
  apiCodeAlias?: Maybe<Scalars['String']['output']>;
  /** 对应的表单关联字段 */
  associationField?: Maybe<Field>;
  /** 自动填写上次提交内容 */
  cacheData: Scalars['Boolean']['output'];
  /** 客户端ID */
  cid?: Maybe<Scalars['String']['output']>;
  /** 封装的字段类型 */
  customizedType?: Maybe<Scalars['String']['output']>;
  /** 封装的字段类型文本 */
  customizedTypeName?: Maybe<Scalars['String']['output']>;
  /** 自定义出错文案 */
  customizedValidationMessage?: Maybe<Scalars['String']['output']>;
  /** 已提交的数据是否可被编辑 */
  editable: Scalars['Boolean']['output'];
  /** 场景化可配置字段设置 */
  extraConfigurableSettings?: Maybe<FieldExtraConfigurableSettings>;
  /** 该字段能否使用字段规则: true - 能， false - 不能 */
  fieldRuleAvailable: Scalars['Boolean']['output'];
  /** 是否是关联主键字段 */
  forAssociated?: Maybe<Scalars['Boolean']['output']>;
  /** 是否是关联展示字段 */
  forAssociatedDisplay?: Maybe<Scalars['Boolean']['output']>;
  /** 表单Token */
  formToken: Scalars['String']['output'];
  /** 宽度占用整行的四分之几 */
  gridsToOccupy?: Maybe<Scalars['Int']['output']>;
  hasAbility: Scalars['Boolean']['output'];
  highlightColor: Scalars['String']['output'];
  /** 字段标题（去富文本化） */
  label?: Maybe<Scalars['String']['output']>;
  /** 最高分文案 */
  maximumRatingsDisplayText?: Maybe<Scalars['String']['output']>;
  /** 最低分文案 */
  minimumRatingsDisplayText?: Maybe<Scalars['String']['output']>;
  /** 字段描述，富文本 */
  notes?: Maybe<Scalars['String']['output']>;
  paidFeature?: Maybe<PaidFeature>;
  planAvailable: Scalars['Boolean']['output'];
  /** 字段排序 */
  position: Scalars['Int']['output'];
  /** 该字段是否是隐私字段 true - 是, false - 不是 */
  privacy: Scalars['Boolean']['output'];
  /** 字段隐藏 */
  private: Scalars['Boolean']['output'];
  /** 字段是否通过预填写表单预设了值 true - 是, false - 否 */
  pseudoFormPredefined?: Maybe<Scalars['Boolean']['output']>;
  /** 满分 */
  ratingMax: Scalars['Int']['output'];
  /** 字段标题（富文本化） */
  rawLabel?: Maybe<Scalars['String']['output']>;
  /** 字段是否只读，无法编辑 */
  readonly?: Maybe<Scalars['Boolean']['output']>;
  /** 该字段是否属于评分字段（e.g. 考试、测评中的题目） */
  scorable: Scalars['Boolean']['output'];
  /** 字段提示较长时折叠展示 */
  showPartDescription: Scalars['Boolean']['output'];
  /** 新起一行 */
  startNewRow: Scalars['Boolean']['output'];
  /** 该字段是否可以作为文本插入 true - 能, false - 不能 */
  textPlaceholderable: Scalars['Boolean']['output'];
  /** 字段类型 */
  type: FieldClass;
  /** 字段类型文本 */
  typeName: Scalars['String']['output'];
  /** 字段验证规则 */
  validations?: Maybe<Array<FieldValidation>>;
};


export type NpsFieldHasAbilityArgs = {
  key: FieldAbilityEnum;
};


export type NpsFieldNotesArgs = {
  sanitize?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NumberField = AssociatedField & BaseField & CalculableField & ExtraConfigurableSetting & FieldAbility & NumericalField & PlanAvailableField & PredefineableField & RangeValidatableField & WithStatementPredefinedValues & {
  apiCode: Scalars['ID']['output'];
  apiCodeAlias?: Maybe<Scalars['String']['output']>;
  /** 对应的表单关联字段 */
  associationField?: Maybe<Field>;
  /** 自动填写上次提交内容 */
  cacheData: Scalars['Boolean']['output'];
  /** 开启选项赋值或本身可参与计算 */
  calculable: Scalars['Boolean']['output'];
  /** 客户端ID */
  cid?: Maybe<Scalars['String']['output']>;
  /** 封装的字段类型 */
  customizedType?: Maybe<Scalars['String']['output']>;
  /** 封装的字段类型文本 */
  customizedTypeName?: Maybe<Scalars['String']['output']>;
  /** 自定义出错文案 */
  customizedValidationMessage?: Maybe<Scalars['String']['output']>;
  /** 项目列计算的操作符，当字段为矩阵填空和表格的项目时有用 */
  dimensionOperator?: Maybe<DimensionOperator>;
  /** 显示百分比 */
  displayAsPercentage: Scalars['Boolean']['output'];
  /** 已提交的数据是否可被编辑 */
  editable: Scalars['Boolean']['output'];
  /** 开启项目列计算，当字段为矩阵填空和表格的项目时有用 */
  enableDimensionCalculation: Scalars['Boolean']['output'];
  /** 场景化可配置字段设置 */
  extraConfigurableSettings?: Maybe<FieldExtraConfigurableSettings>;
  /** 该字段能否使用字段规则: true - 能， false - 不能 */
  fieldRuleAvailable: Scalars['Boolean']['output'];
  /** 是否是关联主键字段 */
  forAssociated?: Maybe<Scalars['Boolean']['output']>;
  /** 是否是关联展示字段 */
  forAssociatedDisplay?: Maybe<Scalars['Boolean']['output']>;
  /** 表单Token */
  formToken: Scalars['String']['output'];
  /** 宽度占用整行的四分之几 */
  gridsToOccupy?: Maybe<Scalars['Int']['output']>;
  hasAbility: Scalars['Boolean']['output'];
  /** 用户选择的字段图标 */
  iconType: Scalars['String']['output'];
  /** 字段标题（去富文本化） */
  label?: Maybe<Scalars['String']['output']>;
  /** 字段描述，富文本 */
  notes?: Maybe<Scalars['String']['output']>;
  paidFeature?: Maybe<PaidFeature>;
  /** 占位符 */
  placeholder?: Maybe<Scalars['String']['output']>;
  planAvailable: Scalars['Boolean']['output'];
  /** 字段排序 */
  position: Scalars['Int']['output'];
  /** 小数位数 */
  precision?: Maybe<Scalars['Int']['output']>;
  /** 预填写表单 */
  predefined: Scalars['Boolean']['output'];
  /** 默认值 */
  predefinedValue?: Maybe<Scalars['String']['output']>;
  /** 该字段是否是隐私字段 true - 是, false - 不是 */
  privacy: Scalars['Boolean']['output'];
  /** 字段隐藏 */
  private: Scalars['Boolean']['output'];
  /** 字段是否通过预填写表单预设了值 true - 是, false - 否 */
  pseudoFormPredefined?: Maybe<Scalars['Boolean']['output']>;
  rangeMax?: Maybe<Scalars['Float']['output']>;
  rangeMin?: Maybe<Scalars['Float']['output']>;
  /** 字段标题（富文本化） */
  rawLabel?: Maybe<Scalars['String']['output']>;
  /** 字段是否只读，无法编辑 */
  readonly?: Maybe<Scalars['Boolean']['output']>;
  /** 该字段是否属于评分字段（e.g. 考试、测评中的题目） */
  scorable: Scalars['Boolean']['output'];
  /** 字段提示较长时折叠展示 */
  showPartDescription: Scalars['Boolean']['output'];
  /** 新起一行 */
  startNewRow: Scalars['Boolean']['output'];
  statementPredefinedValues?: Maybe<FieldStatementPredefinedValues>;
  /** 该字段是否可以作为文本插入 true - 能, false - 不能 */
  textPlaceholderable: Scalars['Boolean']['output'];
  /** 显示千位分隔符 */
  thousandsSeparator: Scalars['Boolean']['output'];
  /** 字段类型 */
  type: FieldClass;
  /** 字段类型文本 */
  typeName: Scalars['String']['output'];
  /** 字段验证规则 */
  validations?: Maybe<Array<FieldValidation>>;
};


export type NumberFieldHasAbilityArgs = {
  key: FieldAbilityEnum;
};


export type NumberFieldNotesArgs = {
  sanitize?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NumberFieldReport = {
  field?: Maybe<Field>;
  widgets?: Maybe<Array<Widget>>;
};

export type NumericalField = {
  /** 项目列计算的操作符，当字段为矩阵填空和表格的项目时有用 */
  dimensionOperator?: Maybe<DimensionOperator>;
  /** 显示百分比 */
  displayAsPercentage: Scalars['Boolean']['output'];
  /** 开启项目列计算，当字段为矩阵填空和表格的项目时有用 */
  enableDimensionCalculation: Scalars['Boolean']['output'];
  /** 小数位数 */
  precision?: Maybe<Scalars['Int']['output']>;
  /** 显示千位分隔符 */
  thousandsSeparator: Scalars['Boolean']['output'];
};

export enum OauthLoginProvider {
  Weixin = 'weixin',
  WeixinQiye = 'weixin_qiye'
}

export type OauthLoginSession = {
  /** session 状态: 成功需转到 portal, 过期需要重新创建 */
  fieldValues?: Maybe<OauthLoginSessionValues>;
  /** 认证成功后的跳转链接 */
  redirectUrl?: Maybe<Scalars['String']['output']>;
  /** session 状态: 成功需转到 portal, 过期需要重新创建 */
  status: OauthLoginSessionStatus;
};

export enum OauthLoginSessionStatus {
  NotExistsOrExpired = 'not_exists_or_expired',
  SignedIn = 'signed_in',
  Started = 'started',
  Unregistered = 'unregistered'
}

export type OauthLoginSessionValues = {
  /** PC微信注册支持，当前session的手机扫码后是否获取到微信信息 */
  hasWeixinInfo?: Maybe<Scalars['Boolean']['output']>;
  /** PC微信注册支持，当前session的手机扫码 weixin code */
  wxCode?: Maybe<Scalars['String']['output']>;
};

/** OCR 类别，身份证/营业执照 */
export enum Ocr {
  /** 银行印鉴 或 开户证明 */
  BankAccount = 'bank_account',
  /** 银行卡 */
  BankCard = 'bank_card',
  /** 营业执照 */
  BusinessLicense = 'business_license',
  /** 营业执照（AI识别） */
  BusinessLicenseAi = 'business_license_ai',
  /** 身份证 */
  IdCard = 'id_card',
  /** 身份证国徽面 */
  IdCardBack = 'id_card_back'
}

export type OfflineRecharge = {
  id: Scalars['ID']['output'];
  /** 金额 */
  payAmount: Scalars['Float']['output'];
  payDate?: Maybe<Scalars['Date']['output']>;
  /** 交易状态 */
  payType?: Maybe<OfflineRechargePayType>;
  /** 交易套餐 */
  plan?: Maybe<Plan>;
  /** 购买信息 */
  planInfo?: Maybe<Scalars['String']['output']>;
  /** 交易状态 */
  status: OfflineRechargeStatus;
};

export type OfflineRechargeAttributes = {
  /** 备注信息（可选） */
  comment?: InputMaybe<Scalars['String']['input']>;
  /** 转账凭证截图，对应上传后的附件 ID */
  offlineRechargeVoucherAttachmentId: Scalars['ID']['input'];
  /** 付款人账号 */
  payAccount: Scalars['String']['input'];
  /** 付款金额 */
  payAmount?: InputMaybe<Scalars['Float']['input']>;
  /** 付款日期 */
  payDate: Scalars['ISO8601Date']['input'];
  /** 付款户名 */
  payName: Scalars['String']['input'];
  /** 付款套餐信息，eg: e10;per_year 或 e10;per_month 或者 other_amount */
  planInfo: Scalars['String']['input'];
};

/** The connection type for OfflineRecharge. */
export type OfflineRechargeConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<OfflineRechargeEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<OfflineRecharge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type OfflineRechargeEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<OfflineRecharge>;
};

export enum OfflineRechargePayType {
  /** Per month */
  PerMonth = 'per_month',
  /** Per year */
  PerYear = 'per_year'
}

export enum OfflineRechargeStatus {
  /** Done */
  Done = 'done',
  /** Failed */
  Failed = 'failed',
  /** Pending */
  Pending = 'pending',
  /** Process */
  Process = 'process'
}

export enum OpenEntriesAction {
  /** Edit */
  Edit = 'edit',
  /** Hide */
  Hide = 'hide',
  /** View */
  View = 'view'
}

export type OpenEntry = {
  abilities: Array<OpenEntryAbilitiesTypesEnum>;
  actAsEntrance: Scalars['Boolean']['output'];
  /** 登录的字段 */
  authFields: Array<AuthFields>;
  authTypes: Array<OpenEntryAuthTypesEnum>;
  disabled: Scalars['Boolean']['output'];
  entranceText: Scalars['String']['output'];
  token: Scalars['String']['output'];
  useCname: Scalars['Boolean']['output'];
};

export enum OpenEntryAbilitiesTypesEnum {
  /** Data edit */
  DataEdit = 'data_edit',
  /** Data read */
  DataRead = 'data_read',
  /** Reservation cancel */
  ReservationCancel = 'reservation_cancel'
}

export type OpenEntryAttributes = {
  abilities?: InputMaybe<Array<OpenEntryAbilitiesTypesEnum>>;
  actAsEntrance: Scalars['Boolean']['input'];
  authFields?: InputMaybe<Array<AuthFieldsAttributes>>;
  authTypes: Array<OpenEntryAuthTypesEnum>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  entranceText?: InputMaybe<Scalars['String']['input']>;
  useCname?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum OpenEntryAuthTypesEnum {
  /** SMS */
  Sms = 'sms',
  /** Submitter */
  Submitter = 'submitter',
  /** Weixin */
  Weixin = 'weixin'
}

/** The connection type for OpenEntry. */
export type OpenEntryConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<OpenEntryEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<OpenEntry>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type OpenEntryEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<OpenEntry>;
};

export enum OpenEntryOauthLoginSessionStatusType {
  NotExistsOrExpired = 'not_exists_or_expired',
  SignedIn = 'signed_in',
  Started = 'started'
}

export type OpenEntryOauthLoginSessionType = {
  /** session 状态: 成功需转到 success url, 过期需要重新创建 */
  status: OpenEntryOauthLoginSessionStatusType;
  /** 登录成功后的展示链接 */
  successUrl?: Maybe<Scalars['String']['output']>;
};

export type OpenResult = EntryEditable & HasPrivacyProtectedFields & PublishedResultsHasFields & PublishedResultsScenableSettings & WithConditionalScope & WithPublishedDomainInfo & {
  /** 查看/查询的密码 */
  accessPassword?: Maybe<Scalars['String']['output']>;
  /** 实际使用的二级域名。当套餐不可用后，返回系统随机二级域名 */
  activeSubdomain?: Maybe<Scalars['String']['output']>;
  /** 谁能看 */
  allowedAudience: AllowedAudienceForViewer;
  /** 达到限填后是否允许取消预约 */
  cancelReservationFillFrequencyLimited: Scalars['Boolean']['output'];
  /** 所属 BillingAccount 的cname 信息 */
  cnameSetting: Cname;
  /** scope condition筛选字段 */
  conditionTriggerableFields?: Maybe<Array<ConditionalTriggerableField>>;
  conditionalScope: Scalars['Boolean']['output'];
  /** 关闭状态,true:已关闭,false:已开启 */
  disabled?: Maybe<Scalars['Boolean']['output']>;
  /** 编辑数据按钮文案 */
  editDataBtnText?: Maybe<Scalars['String']['output']>;
  /** 操作权限-可编辑字段api_codes */
  editableFieldApiCodes: Array<Scalars['String']['output']>;
  /** 可修改字段 */
  editableFields?: Maybe<FieldConnection>;
  /** 到达限填后展示数据的设置 */
  entriesActionFillFrequencyLimited?: Maybe<OpenEntriesAction>;
  /** 是否允许修改数据, true: 允许  */
  entryEditEnabled: Scalars['Boolean']['output'];
  /** 修改前是否需要手机验证，true: 需要,false: 不需要 */
  entryEditVerifyEnabled: Scalars['Boolean']['output'];
  /** 修改手机可验证字段 */
  entryEditVerifyField: Field;
  /** 修改前手机验证字段api_code */
  entryEditVerifyFieldApiCode?: Maybe<Scalars['String']['output']>;
  /** 填写限制规则 */
  fillFrequency?: Maybe<FillFrequency>;
  /** 表单 */
  form?: Maybe<Form>;
  /** 表单设置 */
  formSetting: FormSetting;
  /** 当allowed_audience为sms_verification需要设置。表示：验证身份时，是否使用特定的手机号。true：使用，false：不使用 */
  isSpecifiedVerifier: Scalars['Boolean']['output'];
  /** 是否凭密码查看/查询，true：凭密码打开，false：不需要密码 */
  passwordRequired: Scalars['Boolean']['output'];
  /** 开启隐私保护字段的api codes */
  privacyProtectedFieldApiCodes?: Maybe<Array<Scalars['String']['output']>>;
  /** 操作权限-可查看字段api_code */
  readableFieldApiCodes: Array<Scalars['String']['output']>;
  /** 查询结果可查看的字段 */
  readableFields: FieldConnection;
  /** 操作权限-可看报表字段api_codes */
  reportFieldApiCodes: Array<Scalars['String']['output']>;
  /** 不同表单场景的额外设置，eg: 考试场景运行查看答案解析， */
  scenableSettings?: Maybe<Scalars['JSON']['output']>;
  scopeConditions?: Maybe<Array<ScopeCondition>>;
  /** 当达到限填后，是否展示表单 */
  showFormFillFrequencyLimited?: Maybe<Scalars['Boolean']['output']>;
  /** 表单提交时，是否限制地区 */
  submissionRegionLimited: Scalars['Boolean']['output'];
  /** 表单提交时，限制地区 */
  submissionRegions?: Maybe<Array<Scalars['String']['output']>>;
  /** 限制群组及部分人群条件. */
  submitterSetting?: Maybe<SubmitterSetting>;
  /** 名称 */
  title: Scalars['String']['output'];
  /** token */
  token: Scalars['String']['output'];
  /** 当allowed_audience为sms_verification需要设置。表示：特定手机号-身份验证的手机号 */
  viewVerifiers?: Maybe<Array<Scalars['String']['output']>>;
  /** 当allowed_audience为sms_verification需要设置。表示：验证身份时，表单中选择的手机认证字段api_code */
  viewVerifyFieldApiCode?: Maybe<Scalars['String']['output']>;
};


export type OpenResultEditableFieldsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type OpenResultReadableFieldsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type OpenResultAttributes = {
  /** 查看/查询的密码 */
  accessPassword?: InputMaybe<Scalars['String']['input']>;
  /** 谁能看 */
  allowedAudience?: InputMaybe<AllowedAudienceForViewer>;
  /** 达到限填后是否允许取消预约 */
  cancelReservationFillFrequencyLimited?: InputMaybe<Scalars['Boolean']['input']>;
  /** 设置数据范围 */
  conditionalScope?: InputMaybe<Scalars['Boolean']['input']>;
  /** 关闭状态,true:已关闭,false:已开启 */
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** 编辑数据按钮文案 */
  editDataBtnText?: InputMaybe<Scalars['String']['input']>;
  /** 查询结果操作权限-可编辑字段api_codes */
  editableFieldApiCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** 到达限填后展示数据的设置 */
  entriesActionFillFrequencyLimited?: InputMaybe<OpenEntriesAction>;
  /** 是否允许修改数据, true: 允许  */
  entryEditEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** 修改前是否需要手机验证，true: 需要,false: 不需要 */
  entryEditVerifyEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** 修改前手机验证字段api_code */
  entryEditVerifyFieldApiCode?: InputMaybe<Scalars['String']['input']>;
  /** 填写限制规则 */
  fillFrequency?: InputMaybe<FillFrequencyAttributes>;
  /** 当allowed_audience为sms_verification需要设置。表示：是否使用特定的手机号验证身份。true：使用，false：不使用 */
  isSpecifiedVerifier?: InputMaybe<Scalars['Boolean']['input']>;
  /** 是否凭密码查看/查询，true：凭密码打开，false：不需要密码 */
  passwordRequired?: InputMaybe<Scalars['Boolean']['input']>;
  /** 开启隐私保护字段的api codes */
  privacyProtectedFieldApiCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** 查询结果操作权限-可查看字段api_code */
  readableFieldApiCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** 操作权限-可看报表字段api_codes */
  reportFieldApiCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** 不同表单场景的额外设置，eg: 考试场景运行查看答案解析 */
  scenableSettings?: InputMaybe<Scalars['JSON']['input']>;
  /** 数据条件 */
  scopeConditions?: InputMaybe<Array<ScopeConditionAttributes>>;
  /** 当达到限填后，是否展示表单 */
  showFormFillFrequencyLimited?: InputMaybe<Scalars['Boolean']['input']>;
  /** 表单提交时，是否限制地区 */
  submissionRegionLimited?: InputMaybe<Scalars['Boolean']['input']>;
  /** 表单提交时，限制地区 */
  submissionRegions?: InputMaybe<Array<Scalars['String']['input']>>;
  /** submitter部分限填条件 */
  submitterSettingAttributes?: InputMaybe<SubmitterConditionalScopeAttributes>;
  /** 名称 */
  title?: InputMaybe<Scalars['String']['input']>;
  /** 当allowed_audience为sms_verification需要设置。表示：特定手机号-身份验证的手机号 */
  viewVerifiers?: InputMaybe<Array<Scalars['String']['input']>>;
  /** 当allowed_audience为sms_verification需要设置。表示：验证身份时，表单中选择的手机认证字段api_code */
  viewVerifyFieldApiCode?: InputMaybe<Scalars['String']['input']>;
};

/** The connection type for OpenResult. */
export type OpenResultConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<OpenResultEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<OpenResult>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type OpenResultEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<OpenResult>;
};

export type OpenSearch = EntryEditable & HasPrivacyProtectedFields & PublishedResultsHasFields & PublishedResultsScenableSettings & WithConditionalScope & {
  /** 查看/查询的密码 */
  accessPassword?: Maybe<Scalars['String']['output']>;
  /** 谁能看 */
  allowedAudience: AllowedAudienceForViewer;
  /** 达到限填后是否允许取消预约 */
  cancelReservationFillFrequencyLimited: Scalars['Boolean']['output'];
  /** 查询条件字段 */
  combinationsFields?: Maybe<FieldConnection>;
  /** scope condition筛选字段 */
  conditionTriggerableFields?: Maybe<Array<ConditionalTriggerableField>>;
  conditionalScope: Scalars['Boolean']['output'];
  /** 关闭状态,true:已关闭,false:已开启 */
  disabled?: Maybe<Scalars['Boolean']['output']>;
  /** 编辑数据按钮文案 */
  editDataBtnText?: Maybe<Scalars['String']['output']>;
  /** 查询结果操作权限-可编辑字段api_codes */
  editableFieldApiCodes: Array<Scalars['String']['output']>;
  /** 可修改字段 */
  editableFields?: Maybe<FieldConnection>;
  /** 查询失败提示文字 */
  emptyMessage?: Maybe<Scalars['String']['output']>;
  /** 到达限填后展示数据的设置 */
  entriesActionFillFrequencyLimited?: Maybe<OpenEntriesAction>;
  /** 是否允许修改数据, true: 允许  */
  entryEditEnabled: Scalars['Boolean']['output'];
  /** 修改前是否需要手机验证，true: 需要,false: 不需要 */
  entryEditVerifyEnabled: Scalars['Boolean']['output'];
  /** 修改手机可验证字段 */
  entryEditVerifyField: Field;
  /** 修改前手机验证字段api_code */
  entryEditVerifyFieldApiCode?: Maybe<Scalars['String']['output']>;
  /** 查询条件组合 */
  fieldCombinations: Array<FieldCombination>;
  /** 填写限制规则 */
  fillFrequency?: Maybe<FillFrequency>;
  /** 表单 */
  form?: Maybe<Form>;
  /** 允许模糊查询,true:允许模糊搜索,false:精确搜索 */
  fuzzyMode: Scalars['Boolean']['output'];
  /** 当allowed_audience为sms_verification需要设置。表示：验证身份时，是否使用特定的手机号。true：使用，false：不使用 */
  isSpecifiedVerifier: Scalars['Boolean']['output'];
  /** 查询页面的公告 */
  notice?: Maybe<Scalars['String']['output']>;
  /** 是否凭密码查看/查询，true：凭密码打开，false：不需要密码 */
  passwordRequired: Scalars['Boolean']['output'];
  /** 开启隐私保护字段的api codes */
  privacyProtectedFieldApiCodes?: Maybe<Array<Scalars['String']['output']>>;
  /** 查询结果操作权限-可查看字段api_code */
  readableFieldApiCodes: Array<Scalars['String']['output']>;
  /** 查询结果可查看的字段 */
  readableFields: FieldConnection;
  /** 查询页面的图片 */
  resultSearchEmbedImageAttachment?: Maybe<Attachment>;
  resultVerifyFieldApiCodes?: Maybe<Array<Scalars['String']['output']>>;
  /** 不同表单场景的额外设置，eg: 考试场景运行查看答案解析， */
  scenableSettings?: Maybe<Scalars['JSON']['output']>;
  scopeConditions?: Maybe<Array<ScopeCondition>>;
  /** 查询按钮文案 */
  searchBtnText?: Maybe<Scalars['String']['output']>;
  /** 当达到限填后，是否展示表单 */
  showFormFillFrequencyLimited?: Maybe<Scalars['Boolean']['output']>;
  /** 表单提交时，是否限制地区 */
  submissionRegionLimited: Scalars['Boolean']['output'];
  /** 表单提交时，限制地区 */
  submissionRegions?: Maybe<Array<Scalars['String']['output']>>;
  /** 限制群组及部分人群条件. */
  submitterSetting?: Maybe<SubmitterSetting>;
  /** 查询成功提示文字 */
  successMessage?: Maybe<Scalars['String']['output']>;
  /** 名称 */
  title: Scalars['String']['output'];
  /** token */
  token: Scalars['String']['output'];
  /** 当allowed_audience为sms_verification需要设置。表示：特定手机号-身份验证的手机号 */
  viewVerifiers?: Maybe<Array<Scalars['String']['output']>>;
  /** 当allowed_audience为sms_verification需要设置。表示：验证身份时，表单中选择的手机认证字段api_code */
  viewVerifyFieldApiCode?: Maybe<Scalars['String']['output']>;
};


export type OpenSearchCombinationsFieldsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type OpenSearchEditableFieldsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type OpenSearchReadableFieldsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type OpenSearchAttributes = {
  /** 查看/查询的密码 */
  accessPassword?: InputMaybe<Scalars['String']['input']>;
  /** 谁能看 */
  allowedAudience?: InputMaybe<AllowedAudienceForViewer>;
  /** 达到限填后是否允许取消预约 */
  cancelReservationFillFrequencyLimited?: InputMaybe<Scalars['Boolean']['input']>;
  /** 设置数据范围 */
  conditionalScope?: InputMaybe<Scalars['Boolean']['input']>;
  /** 关闭状态,true:已关闭,false:已开启 */
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** 编辑数据按钮文案 */
  editDataBtnText?: InputMaybe<Scalars['String']['input']>;
  /** 查询结果操作权限-可编辑字段api_codes */
  editableFieldApiCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** 查询失败提示文字 */
  emptyMessage?: InputMaybe<Scalars['String']['input']>;
  /** 到达限填后展示数据的设置 */
  entriesActionFillFrequencyLimited?: InputMaybe<OpenEntriesAction>;
  /** 是否允许修改数据, true: 允许  */
  entryEditEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** 修改前是否需要手机验证，true: 需要,false: 不需要 */
  entryEditVerifyEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** 修改前手机验证字段api_code */
  entryEditVerifyFieldApiCode?: InputMaybe<Scalars['String']['input']>;
  /** 查询条件组合 */
  fieldCombinationsAttributes?: InputMaybe<Array<FieldCombinationAttributes>>;
  /** 填写限制规则 */
  fillFrequency?: InputMaybe<FillFrequencyAttributes>;
  /** 允许模糊查询,true:允许模糊搜索,false:精确搜索 */
  fuzzyMode?: InputMaybe<Scalars['Boolean']['input']>;
  /** 当allowed_audience为sms_verification需要设置。表示：是否使用特定的手机号验证身份。true：使用，false：不使用 */
  isSpecifiedVerifier?: InputMaybe<Scalars['Boolean']['input']>;
  /** 查询页面的公告 */
  notice?: InputMaybe<Scalars['String']['input']>;
  /** 是否凭密码查看/查询，true：凭密码打开，false：不需要密码 */
  passwordRequired?: InputMaybe<Scalars['Boolean']['input']>;
  /** 开启隐私保护字段的api codes */
  privacyProtectedFieldApiCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** 查询结果操作权限-可查看字段api_code */
  readableFieldApiCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** 查询页面的图片 */
  resultSearchEmbedImageAttachmentId?: InputMaybe<Scalars['ID']['input']>;
  resultVerifyFieldApiCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** 不同表单场景的额外设置，eg: 考试场景运行查看答案解析 */
  scenableSettings?: InputMaybe<Scalars['JSON']['input']>;
  /** 数据条件 */
  scopeConditions?: InputMaybe<Array<ScopeConditionAttributes>>;
  /** 查询按钮文案 */
  searchBtnText?: InputMaybe<Scalars['String']['input']>;
  /** 当达到限填后，是否展示表单 */
  showFormFillFrequencyLimited?: InputMaybe<Scalars['Boolean']['input']>;
  /** 表单提交时，是否限制地区 */
  submissionRegionLimited?: InputMaybe<Scalars['Boolean']['input']>;
  /** 表单提交时，限制地区 */
  submissionRegions?: InputMaybe<Array<Scalars['String']['input']>>;
  /** submitter部分限填条件 */
  submitterSettingAttributes?: InputMaybe<SubmitterConditionalScopeAttributes>;
  /** 查询成功提示文字 */
  successMessage?: InputMaybe<Scalars['String']['input']>;
  /** 名称 */
  title?: InputMaybe<Scalars['String']['input']>;
  /** 当allowed_audience为sms_verification需要设置。表示：特定手机号-身份验证的手机号 */
  viewVerifiers?: InputMaybe<Array<Scalars['String']['input']>>;
  /** 当allowed_audience为sms_verification需要设置。表示：验证身份时，表单中选择的手机认证字段api_code */
  viewVerifyFieldApiCode?: InputMaybe<Scalars['String']['input']>;
};

/** The connection type for OpenSearch. */
export type OpenSearchConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<OpenSearchEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<OpenSearch>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type OpenSearchEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<OpenSearch>;
};

export type OpenSearchEntry = CustomerProperties & EntriesBaseProperties & MetaProperties & ReservationStatusProperties & ShareAndMarkProperties & WeixinProperties & {
  _type?: Maybe<Scalars['String']['output']>;
  browser?: Maybe<Scalars['String']['output']>;
  colorMark?: Maybe<Scalars['String']['output']>;
  /** 表单联系人 */
  contactId?: Maybe<Scalars['ID']['output']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  creator?: Maybe<PublishedUser>;
  customer?: Maybe<GdCustomer>;
  /** 当前版本号 */
  editedVersion?: Maybe<Scalars['Int']['output']>;
  fieldValues: Scalars['JSON']['output'];
  fillingDuration?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  ip?: Maybe<Scalars['String']['output']>;
  os?: Maybe<Scalars['String']['output']>;
  platform?: Maybe<Scalars['String']['output']>;
  region?: Maybe<RegionInfo>;
  remark?: Maybe<Scalars['String']['output']>;
  /** 预约状态 */
  reservationStatus?: Maybe<ReservationStatusEnum>;
  serialNumber: Scalars['Int']['output'];
  shareLink?: Maybe<Scalars['String']['output']>;
  shareToken?: Maybe<Scalars['String']['output']>;
  startFillingTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  useragent?: Maybe<Scalars['String']['output']>;
  weixinAccessToken?: Maybe<Scalars['ID']['output']>;
  xFieldWeixinHeadimgurl?: Maybe<Scalars['String']['output']>;
  xFieldWeixinNickname?: Maybe<Scalars['String']['output']>;
  xFieldWeixinOpenid?: Maybe<Scalars['ID']['output']>;
  xFieldWeixinUnionid?: Maybe<Scalars['ID']['output']>;
};


export type OpenSearchEntryFieldValuesArgs = {
  forceProtected?: InputMaybe<Scalars['Boolean']['input']>;
  openResultId?: InputMaybe<Scalars['ID']['input']>;
  openSearchId?: InputMaybe<Scalars['ID']['input']>;
};

/** The connection type for OpenSearchEntry. */
export type OpenSearchEntryConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<OpenSearchEntryEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<OpenSearchEntry>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type OpenSearchEntryEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<OpenSearchEntry>;
};

export type Order = {
  /** 购买邮件条数 */
  activeMailCount?: Maybe<Scalars['Int']['output']>;
  /** 购买服务的结束日期 */
  addonServiceEndDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** 购买服务的开始日期 */
  addonServiceStartDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** 购买 AI 点数 */
  aiCreditsCount?: Maybe<Scalars['Int']['output']>;
  /** 购买 AI 点数 */
  aiPointsCount?: Maybe<Scalars['Int']['output']>;
  /** 购买的插件 */
  app?: Maybe<DoorkeeperApplication>;
  /** 购买的插件礼包 */
  appPackage?: Maybe<AppPackage>;
  /** 购买 语音时长的秒数 */
  audioQuotaCount?: Maybe<Scalars['Int']['output']>;
  /** 购买 https */
  cnameProtocolDayQuantity?: Maybe<Scalars['Int']['output']>;
  couponIds: Array<Scalars['ID']['output']>;
  currency: Currency;
  /** 购买天数 */
  dayQuantity?: Maybe<Scalars['Int']['output']>;
  /** 扩充数据容量条数 */
  entriesCount?: Maybe<Scalars['Int']['output']>;
  /** 表单 */
  form?: Maybe<Form>;
  /** 购买表单高级功能 */
  formApplication?: Maybe<Application>;
  /** 购买门户数 */
  gdPortalCount?: Maybe<Scalars['Int']['output']>;
  /** 购买门户客户人数 */
  gdPortalCustomerCount?: Maybe<Scalars['Int']['output']>;
  gift: Scalars['Boolean']['output'];
  /** 购买 隐藏举报 */
  hideReportFormDayQuantity?: Maybe<Scalars['Int']['output']>;
  /** 购买月数 */
  monthQuantity?: Maybe<Scalars['Int']['output']>;
  /** 购买其他 */
  otherVas?: Maybe<Scalars['String']['output']>;
  /** 购买的套餐 */
  planCode?: Maybe<Scalars['String']['output']>;
  refund: Scalars['Boolean']['output'];
  /** 购买 支付宝配置 */
  showAlipayDayQuantity?: Maybe<Scalars['Int']['output']>;
  /** 购买短信条数 */
  smsCount?: Maybe<Scalars['Int']['output']>;
  /** 购买的附件量 MB，需要转成 GB 展示 */
  storageCount?: Maybe<Scalars['Int']['output']>;
  /** 购买的企业成员个数 */
  subAccountCount?: Maybe<Scalars['Int']['output']>;
  /** 购买的企业成员个数 */
  subAccountDayQuantity?: Maybe<Scalars['Int']['output']>;
  /** 购买客户账号 */
  submitterCount?: Maybe<Scalars['Int']['output']>;
  /** 购买的模板 */
  template?: Maybe<Template>;
  /** 购买的公众号个数 */
  weixinAccountCount?: Maybe<Scalars['Int']['output']>;
};

export enum OrderDirectionEnum {
  /** 升序排列 */
  Asc = 'asc',
  /** 降序排列 */
  Desc = 'desc'
}

export type OtherChoice = BaseChoice & DescribableItem & QuotableChoice & {
  /** 是否需要输入框 */
  allowExtendedText?: Maybe<Scalars['Boolean']['output']>;
  /** 选项说明 */
  description?: Maybe<Scalars['String']['output']>;
  /** 说明类型 */
  descriptionMode: DescribableItemMode;
  /** 选项说明文字 */
  descriptionText?: Maybe<Scalars['String']['output']>;
  /** 选项说明链接 */
  descriptionUrl?: Maybe<Scalars['String']['output']>;
  /** 输入框占位符文案 */
  extendedTextPlaceholder?: Maybe<Scalars['String']['output']>;
  /** 选项说明是否必填 */
  extendedTextRequired?: Maybe<Scalars['Boolean']['output']>;
  hidden: Scalars['Boolean']['output'];
  /** 选项最多被选次数 */
  maximumFrequency?: Maybe<Scalars['Int']['output']>;
  /** 选项名称 */
  name: Scalars['String']['output'];
  operandValue?: Maybe<Scalars['Float']['output']>;
  /** 其他选项必填（实际是字段 validations 的 other_choice_presence） */
  otherChoicePresence?: Maybe<Scalars['Boolean']['output']>;
  position: Scalars['Int']['output'];
  /** 剩余名额 */
  quota?: Maybe<Scalars['BigInteger']['output']>;
  /** 名额设置 */
  quotaSetting?: Maybe<Scalars['BigInteger']['output']>;
  selected: Scalars['Boolean']['output'];
  /** 用户自定义选项说明扩展按钮文案 */
  showMoreDescriptionTip?: Maybe<Scalars['String']['output']>;
  /** 子选项 */
  subChoices?: Maybe<Array<TextChoice>>;
  type?: Maybe<Scalars['String']['output']>;
  value: Scalars['ID']['output'];
};

export type Overview = {
  widgets?: Maybe<Array<Widget>>;
};

export type PageBreak = AssociatedField & BaseField & FieldAbility & PlanAvailableField & {
  apiCode: Scalars['ID']['output'];
  apiCodeAlias?: Maybe<Scalars['String']['output']>;
  /** 对应的表单关联字段 */
  associationField?: Maybe<Field>;
  /** 自动填写上次提交内容 */
  cacheData: Scalars['Boolean']['output'];
  /** 客户端ID */
  cid?: Maybe<Scalars['String']['output']>;
  /** 下一页等待时间，单位秒 */
  countDown: Scalars['Int']['output'];
  /** 封装的字段类型 */
  customizedType?: Maybe<Scalars['String']['output']>;
  /** 封装的字段类型文本 */
  customizedTypeName?: Maybe<Scalars['String']['output']>;
  /** 自定义出错文案 */
  customizedValidationMessage?: Maybe<Scalars['String']['output']>;
  /** 禁止返回上一页 */
  disablePreviousPage: Scalars['Boolean']['output'];
  /** 已提交的数据是否可被编辑 */
  editable: Scalars['Boolean']['output'];
  /** 该字段能否使用字段规则: true - 能， false - 不能 */
  fieldRuleAvailable: Scalars['Boolean']['output'];
  /** 是否是关联主键字段 */
  forAssociated?: Maybe<Scalars['Boolean']['output']>;
  /** 是否是关联展示字段 */
  forAssociatedDisplay?: Maybe<Scalars['Boolean']['output']>;
  /** 表单Token */
  formToken: Scalars['String']['output'];
  /** 宽度占用整行的四分之几 */
  gridsToOccupy?: Maybe<Scalars['Int']['output']>;
  hasAbility: Scalars['Boolean']['output'];
  /** 字段标题（去富文本化） */
  label?: Maybe<Scalars['String']['output']>;
  /** 下一页按钮文字 */
  nextPageText: Scalars['String']['output'];
  /** 字段描述，富文本 */
  notes?: Maybe<Scalars['String']['output']>;
  paidFeature?: Maybe<PaidFeature>;
  planAvailable: Scalars['Boolean']['output'];
  /** 字段排序 */
  position: Scalars['Int']['output'];
  /** 上一页按钮文字 */
  previousPageText: Scalars['String']['output'];
  /** 该字段是否是隐私字段 true - 是, false - 不是 */
  privacy: Scalars['Boolean']['output'];
  /** 字段隐藏 */
  private: Scalars['Boolean']['output'];
  /** 字段是否通过预填写表单预设了值 true - 是, false - 否 */
  pseudoFormPredefined?: Maybe<Scalars['Boolean']['output']>;
  /** 字段标题（富文本化） */
  rawLabel?: Maybe<Scalars['String']['output']>;
  /** 字段是否只读，无法编辑 */
  readonly?: Maybe<Scalars['Boolean']['output']>;
  /** 该字段是否属于评分字段（e.g. 考试、测评中的题目） */
  scorable: Scalars['Boolean']['output'];
  /** 字段提示较长时折叠展示 */
  showPartDescription: Scalars['Boolean']['output'];
  /** 新起一行 */
  startNewRow: Scalars['Boolean']['output'];
  /** 该字段是否可以作为文本插入 true - 能, false - 不能 */
  textPlaceholderable: Scalars['Boolean']['output'];
  /** 字段类型 */
  type: FieldClass;
  /** 字段类型文本 */
  typeName: Scalars['String']['output'];
  /** 字段验证规则 */
  validations?: Maybe<Array<FieldValidation>>;
};


export type PageBreakHasAbilityArgs = {
  key: FieldAbilityEnum;
};


export type PageBreakNotesArgs = {
  sanitize?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Information about pagination in a connection. */
export type PageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type PaidFeature = {
  availablePlans?: Maybe<Array<Plan>>;
  description?: Maybe<Scalars['String']['output']>;
  exampleTemplateLink?: Maybe<Scalars['String']['output']>;
  highestPlan?: Maybe<Plan>;
  key: Scalars['String']['output'];
  lowestPlan?: Maybe<Plan>;
  modalId?: Maybe<Scalars['String']['output']>;
};

export type ParticipatedForm = {
  conditionTriggerableFields: Array<ConditionalTriggerableField>;
  filledForm: FilledForm;
};

/** Autogenerated input type of PatchFormEntry */
export type PatchFormEntryInput = {
  /** 客户端ID */
  cid?: InputMaybe<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 要写入的字段值（支持 _other / _extended_text / _country_id 等子键，仅保留与 field_api_code 关联的键） */
  entryAttributes?: InputMaybe<Scalars['JSON']['input']>;
  /** 主字段 API Code，作为权限校验和更新依据 */
  fieldApiCode: Scalars['String']['input'];
  /** 表单的使用场景 */
  formUsage?: InputMaybe<FormUsage>;
  /** 表单ID或token */
  id: Scalars['ID']['input'];
  /** 本地版本号 */
  localEditedVersion?: InputMaybe<Scalars['Int']['input']>;
  serialNumber: Scalars['Int']['input'];
};

/** Autogenerated return type of PatchFormEntry */
export type PatchFormEntryPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  entry?: Maybe<Entry>;
  errors?: Maybe<Array<Error>>;
};

/** 字段可支付 */
export type PayableField = {
  /** 该字段是否可支付（e.g. 商品、预约） */
  payable: Scalars['Boolean']['output'];
};

export type PaymentAccount = AlipayAccount | MerchantAccount | PingppAccount | WxpayAccount;

export type PaymentAccountAttributes = {
  /** 支付宝账号 */
  account?: InputMaybe<Scalars['String']['input']>;
  /** 支付宝接口类型 */
  accountType?: InputMaybe<AlipayAccountType>;
  /** 支付宝公钥 */
  alipayPublicKey?: InputMaybe<Scalars['String']['input']>;
  /** 微信服务号ID */
  apiAccountId?: InputMaybe<Scalars['ID']['input']>;
  /** 支付宝应用AppID */
  appId?: InputMaybe<Scalars['String']['input']>;
  /** 支付宝应用私钥 */
  appPrivateKey?: InputMaybe<Scalars['String']['input']>;
  /** 支付宝邮箱 */
  email?: InputMaybe<Scalars['String']['input']>;
  /** 是否开启H5支付 */
  enableH5Pay?: InputMaybe<Scalars['Boolean']['input']>;
  /** 是否开启JSAPI支付 */
  enableJsapiPay?: InputMaybe<Scalars['Boolean']['input']>;
  /** 是否开启NATIVE支付 */
  enableNativePay?: InputMaybe<Scalars['Boolean']['input']>;
  /** 支付宝密钥 */
  key?: InputMaybe<Scalars['String']['input']>;
  /** 微信支付商户号 */
  mchId?: InputMaybe<Scalars['String']['input']>;
  /** 商户支付密钥 */
  mchKey?: InputMaybe<Scalars['String']['input']>;
  /** 商户名称 */
  mchName?: InputMaybe<Scalars['String']['input']>;
  /** 是否开启手机支付 */
  mobileEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** 支付账号类型 */
  type: PaymentAccountEnum;
};

export enum PaymentAccountEnum {
  /** 支付宝支付 */
  Alipay = 'alipay',
  /** 金数据商户平台支付 */
  Merchant = 'merchant',
  /** Ping++支付 */
  Pingpp = 'pingpp',
  /** 微信支付 */
  Wxpay = 'wxpay'
}

export enum PaymentChannel {
  Alipay = 'alipay',
  Wxpay = 'wxpay'
}

export type PaymentRedirectExceptionRule = RuleTriggerOperator & {
  /** 或/且 */
  operator: FieldRuleTriggerConditionGroupOperator;
  /** 规则集 */
  ruleSets: Array<RuleSet>;
};

export type PaymentRedirectExceptionRuleAttributes = {
  /** 且/或 */
  operator: FieldRuleTriggerConditionGroupOperator;
  /** 规则集 */
  ruleSets: Array<RuleSetAttributes>;
};

export type PaymentSetting = {
  alipayAccount?: Maybe<AlipayAccount>;
  canChangeCurrency?: Maybe<Scalars['Boolean']['output']>;
  currency?: Maybe<Currency>;
  merchantAccount?: Maybe<MerchantAccount>;
  /** 【DEPRECATED】请使用 payment_source_type */
  paymentAccountType?: Maybe<PaymentAccountEnum>;
  /** 支付渠道，目前仅支持 wxpay 和 alipay。不论是模拟支付、第三方支付，还是金数据商户平台，最终只有 wxpay 和 alipay 两种支付渠道。 */
  paymentChannels: Array<PaymentChannel>;
  /** 【next webapp】当前的支付渠道来自哪里，目前仅支持 third_party、merchant 和 mock。 */
  paymentSourceType?: Maybe<PaymentSource>;
  paymentWay?: Maybe<PaymentWay>;
  pingppAccount?: Maybe<PingppAccount>;
  /** 只用于前端类型定义，不会在后端使用 */
  pingppChannel?: Maybe<PingppChannel>;
  wxpayAccount?: Maybe<WxpayAccount>;
};

export enum PaymentSource {
  /** 金数据商户平台 */
  Merchant = 'merchant',
  /** 模拟支付 */
  Mock = 'mock',
  /** 第三方支付 */
  ThirdParty = 'third_party'
}

export enum PaymentWay {
  /** 仅展示商品价格 */
  DisplayOnly = 'display_only',
  /** 模拟支付 */
  Mock = 'mock',
  /** 未设置 */
  None = 'none',
  /** 第三方支付 */
  ThirdParty = 'third_party'
}

export type PerAppUsageStats = {
  appName?: Maybe<Scalars['String']['output']>;
  ownerName?: Maybe<Scalars['String']['output']>;
  usageCount: Scalars['Float']['output'];
};

export type PerFormDateUsageStats = {
  form?: Maybe<Form>;
  ownerName?: Maybe<Scalars['String']['output']>;
  usageCount: Scalars['Float']['output'];
};

export type PerOwnerDateUsageStats = {
  ownerName?: Maybe<Scalars['String']['output']>;
  usageCount: Scalars['Float']['output'];
};

export enum Period {
  All = 'all',
  ThisWeek = 'this_week',
  Today = 'today'
}

export type PersonalAccessToken = {
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  /** Only returned at creation time; never persisted. */
  plainToken?: Maybe<Scalars['String']['output']>;
  revokedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  tokenHint?: Maybe<Scalars['String']['output']>;
};

export type PhantomFormAttributes = {
  /** 幻象表单标题 */
  name: Scalars['String']['input'];
};

export type PingppAccount = {
  appid: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export enum PingppChannel {
  AlipayPcDirect = 'alipay_pc_direct',
  /** 支付宝PC扫码支付 */
  AlipayQr = 'alipay_qr',
  /** 支付宝手机网页支付 */
  AlipayWap = 'alipay_wap',
  WxPub = 'wx_pub',
  /** 微信PC扫码支付 */
  WxPubQr = 'wx_pub_qr',
  WxWap = 'wx_wap'
}

export type Plan = ExpiredNoticed & {
  code: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  /** true - 已通知，false - 未通知 */
  expiredNoticed?: Maybe<Scalars['Boolean']['output']>;
  featureQuota?: Maybe<Scalars['BigInteger']['output']>;
  isInternational: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  monthlyPay?: Maybe<Scalars['Boolean']['output']>;
  nextLevelPlan?: Maybe<Plan>;
  pricePerMonth: Scalars['Int']['output'];
  pricePerYear: Scalars['Int']['output'];
  restriction: PlanRestriction;
};


export type PlanFeatureQuotaArgs = {
  key: Scalars['String']['input'];
};


export type PlanRestrictionArgs = {
  vas: Vas;
};

export type PlanAvailableField = {
  paidFeature?: Maybe<PaidFeature>;
  planAvailable: Scalars['Boolean']['output'];
};

export enum PlanCode {
  /** Translation missing: en.plan.cor1 */
  Cor1 = 'cor1',
  /** Translation missing: en.plan.cor2 */
  Cor2 = 'cor2',
  /** Translation missing: en.plan.dpro */
  Dpro = 'dpro',
  /** Translation missing: en.plan.e10 */
  E10 = 'e10',
  /** Translation missing: en.plan.e20 */
  E20 = 'e20',
  /** Translation missing: en.plan.e30 */
  E30 = 'e30',
  /** Translation missing: en.plan.eb1 */
  Eb1 = 'eb1',
  /** Translation missing: en.plan.en_cor */
  EnCor = 'en_cor',
  /** Translation missing: en.plan.ent1 */
  Ent1 = 'ent1',
  /** Translation missing: en.plan.ent2 */
  Ent2 = 'ent2',
  /** Translation missing: en.plan.exp1 */
  Exp1 = 'exp1',
  /** Translation missing: en.plan.free */
  Free = 'free',
  /** Translation missing: en.plan.free_intl */
  FreeIntl = 'free_intl',
  /** Translation missing: en.plan.pro1 */
  Pro1 = 'pro1',
  /** Translation missing: en.plan.pro2 */
  Pro2 = 'pro2',
  /** Translation missing: en.plan.pro_intl_1 */
  ProIntl_1 = 'pro_intl_1',
  /** Translation missing: en.plan.proplus_intl_1 */
  ProplusIntl_1 = 'proplus_intl_1',
  /** Translation missing: en.plan.std1 */
  Std1 = 'std1'
}

export type PlanPackage = {
  /** 当前套餐的结束时间。（不包含后续已经续费的套餐） */
  currentPlanEndDate?: Maybe<Scalars['Date']['output']>;
  /** 当前套餐最大的结束时间。注意，这个方法实际是 current_plan_max_end_date，如果当前套餐之后还有续费的套餐，则计算的是最大的结束时间 */
  endDate?: Maybe<Scalars['Date']['output']>;
  /**
   * 当前套餐是否通过 Apple IAP 购买
   * @deprecated Use planUpgradeStatus { source } instead.
   */
  fromApple?: Maybe<Scalars['Boolean']['output']>;
  /** 是否按年付费 */
  paidByYear?: Maybe<Scalars['Boolean']['output']>;
  plan: Plan;
  /** 当前请求来源下的套餐升级状态；其 source 字段同时承载 subscription_source 信息 */
  planUpgradeStatus: PlanUpgradeStatus;
  /** 当前套餐开始时间 */
  startDate?: Maybe<Scalars['Date']['output']>;
};

export type PlanRestriction = {
  canUseAfterQuota: Scalars['Boolean']['output'];
  canUseThis: Scalars['Boolean']['output'];
  freeQuota: Scalars['Int']['output'];
  /** （已废弃） */
  reserveQuota: Scalars['Int']['output'];
};

export type PlanTransaction = BaseTransaction & {
  /** 创建时间 */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  currency: Currency;
  id: Scalars['ID']['output'];
  order?: Maybe<Order>;
  /** 付费时间 */
  paidAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** 支付渠道 */
  paymentMethod?: Maybe<Scalars['String']['output']>;
  planCode: PlanCode;
  /** 付费金额 */
  totalFee: Scalars['Float']['output'];
  /** 交易号 */
  tradeNo?: Maybe<Scalars['String']['output']>;
  /** 交易类型 */
  type: TransactionClass;
  user?: Maybe<User>;
};

export type PlanUpgradeStatus = {
  /** 当前请求来源是否可以升级套餐 */
  enabled: Scalars['Boolean']['output'];
  /** 不可升级时的提示文案；可升级时为 null */
  message?: Maybe<Scalars['String']['output']>;
  /** 当前套餐的外部订阅渠道；null 表示标准支付 */
  source?: Maybe<SubscriptionSource>;
};

export enum Platform {
  /** 小程序端 */
  Mobile = 'mobile',
  /** PC端 */
  Pc = 'pc'
}

export type Portal = {
  /** Portal 的登录方式 */
  authTypes: Array<GroupAuthTypesEnum>;
  /**
   * Portal 可用的登录方式
   * @deprecated 可用登录方式挪到前端统一处理，后端不需要再进行计算
   */
  availableAuthenticationTypes?: Maybe<Array<PortalIdentityTypeEnum>>;
  backgroundImage?: Maybe<ImageItemType>;
  /** @deprecated background_image_attachment 无法设置裁剪，请使用 background_image */
  backgroundImageAttachment?: Maybe<Attachment>;
  description?: Maybe<Scalars['String']['output']>;
  descriptionStyle?: Maybe<SubmitterStyle>;
  /** 用于双字段登录的字段 */
  dualAuthApiCodes?: Maybe<Array<Scalars['String']['output']>>;
  focusImage?: Maybe<ImageItemType>;
  /** @deprecated focus_image_attachment 无法设置裁剪，请使用 focus_image */
  focusImageAttachment?: Maybe<Attachment>;
  groupCreatedSource?: Maybe<Form>;
  /** 客户群组组成字段 */
  groupFields?: Maybe<Array<SubmitterField>>;
  /**
   * Portal 的登录方式
   * @deprecated 登录方式支持多种，使用 authTypes 代替 identityType
   */
  identityType?: Maybe<PortalIdentityTypeEnum>;
  logoAttachment?: Maybe<Attachment>;
  name: Scalars['String']['output'];
  nameStyle?: Maybe<SubmitterStyle>;
  navigationItems?: Maybe<SubmitterNavigationItemConnection>;
  registerUrl?: Maybe<Scalars['String']['output']>;
  /**
   * Portal 可用的登录校验字段
   * @deprecated 使用 group_fields 并选取 actAsIdentity = true 的 field 来代替
   */
  selectedIdentityFields?: Maybe<Array<SubmitterField>>;
  /** 是否自定义提示文案 */
  showSubmitterRuleTip: Scalars['Boolean']['output'];
  submitterRegistrable?: Maybe<Scalars['Boolean']['output']>;
  submitterRegistrationText?: Maybe<Scalars['String']['output']>;
  /** 不符合客户规则自定义提示文案 */
  submitterRuleTip: Scalars['String']['output'];
  /** 未注册客户自定义提示文案 */
  submitterUnregisteredText: Scalars['String']['output'];
  /** 是否自定义提示文案 */
  submitterUnregisteredTextCustomizable: Scalars['Boolean']['output'];
  token: Scalars['String']['output'];
  urlDomainType: PortalUrlDomainTypeEnum;
};


export type PortalNavigationItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PortalForm = {
  /** 表单绑定时间 */
  boundAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  form: Form;
};

/** The connection type for PortalForm. */
export type PortalFormConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PortalFormEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<PortalForm>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PortalFormEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<PortalForm>;
};

export enum PortalIdentityTypeEnum {
  /** 动态验证 */
  Auto = 'auto',
  /** 第三方授权登录 */
  Oauth = 'oauth',
  /** 手机号登录 */
  Phone = 'phone',
  /** 微信验证 */
  Weixin = 'weixin',
  /** 企业微信验证 */
  WeixinQiye = 'weixin_qiye'
}

export type PortalQuota = {
  /** 门户配额 */
  portalQuota?: Maybe<GdPortalPortalQuotaType>;
};

export type PortalSmsSignatureFailActivity = {
  formInfo: FormActivityBaseInfo;
  portalName: Scalars['String']['output'];
};

export enum PortalUrlDomainTypeEnum {
  /** Custom */
  Custom = 'custom',
  /** GD */
  Gd = 'gd'
}

export type Poster = {
  /** 海报描述 */
  description?: Maybe<Scalars['String']['output']>;
  /** 海报布局，默认居中 */
  layout: PosterLayout;
  /** 二维码提示文案 */
  qrcodeTip?: Maybe<Scalars['String']['output']>;
  /** 海报标题 */
  title?: Maybe<Scalars['String']['output']>;
  /** 海报背景token */
  token: Scalars['String']['output'];
};

export type PosterAttributes = {
  /** 海报描述 */
  description?: InputMaybe<Scalars['String']['input']>;
  /** 海报布局，默认居中 */
  layout: PosterLayout;
  /** 海报背景的ID，当token为user_poster_bg时使用 */
  posterBackgroundId?: InputMaybe<Scalars['ID']['input']>;
  /** 二维码提示文案 */
  qrcodeTip?: InputMaybe<Scalars['String']['input']>;
  /** 海报标题 */
  title?: InputMaybe<Scalars['String']['input']>;
  /** 海报背景token */
  token: Scalars['String']['input'];
};

export type PosterBackground = {
  /** 海报背景ID */
  id: Scalars['ID']['output'];
  /** 海报背景地址 */
  previewUrl: Scalars['String']['output'];
  /** 海报背景访问地址 */
  visitUrl: Scalars['String']['output'];
};


export type PosterBackgroundPreviewUrlArgs = {
  size?: InputMaybe<PreviewUrlSizeEnum>;
};

export enum PosterLayout {
  /** Center */
  Center = 'center',
  /** Left */
  Left = 'left',
  /** Right */
  Right = 'right',
  /** Top */
  Top = 'top'
}

export enum PosterStyle {
  /** General */
  General = 'general',
  /** Joyful */
  Joyful = 'joyful',
  /** Minimal */
  Minimal = 'minimal',
  /** Professional */
  Professional = 'professional',
  /** Tech */
  Tech = 'tech',
  /** Warm */
  Warm = 'warm'
}

export type PosterTemplate = {
  /** 海报背景地址 */
  backgroundImageUrl: Scalars['String']['output'];
  /** 海报背景预览地址 */
  previewImageUrl: Scalars['String']['output'];
  /** 海报风格 */
  style: PosterStyle;
  /**
   * 海报背景样式名称
   * @deprecated style_name 实际履行 token 的职责，这个名字很不规范，新的都应该查询 field :token
   */
  styleName: Scalars['String']['output'];
  /** 海报默认文字颜色 */
  textColor?: Maybe<Scalars['String']['output']>;
  /** 海报背景token */
  token: Scalars['String']['output'];
};

export type PredefineableField = {
  /** 预填写表单 */
  predefined: Scalars['Boolean']['output'];
};

export type PredefinedChoiceSet = {
  choices: Array<Scalars['String']['output']>;
  label: Scalars['String']['output'];
};

export type PredefinedDynamicCondition = {
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** Autogenerated input type of Preview */
export type PreviewInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  formAttributes?: InputMaybe<FormAttributes>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** 表单场景 */
  scene?: InputMaybe<Scene>;
  themeAttributes?: InputMaybe<ThemeAttributes>;
};

/** Autogenerated return type of Preview */
export type PreviewPayload = {
  cacheToken?: Maybe<Scalars['String']['output']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  previewForm?: Maybe<PublishedForm>;
};

export enum PreviewUrlSizeEnum {
  Large = 'large',
  Small = 'small',
  Xlarge = 'xlarge'
}

export type Prize = {
  /** 奖品ID */
  id: Scalars['ID']['output'];
  /** 奖品数量 */
  prizeAmount: Scalars['Int']['output'];
  /** 奖品图片 */
  prizeImage?: Maybe<PrizeImageAttachment>;
  /** 奖品名称 */
  prizeName: Scalars['String']['output'];
  /** 奖项类型：gift - 奖品，voucher - 奖券 */
  prizeType: PrizeKind;
  /** 关联奖券 */
  prizeVoucher?: Maybe<PrizeVoucherAttachment>;
  /** 中奖概率 */
  probability: Scalars['Float']['output'];
  /** 奖项名称 */
  title: Scalars['String']['output'];
  /** 已中奖品数量 */
  winnerAmount?: Maybe<Scalars['Int']['output']>;
};

export type PrizeImageAttachment = {
  /** 奖品图片ID */
  id: Scalars['ID']['output'];
  /** 奖品图片preview_url */
  previewUrl: Scalars['String']['output'];
};

export enum PrizeKind {
  Gift = 'gift',
  Voucher = 'voucher'
}

export type PrizeVoucherAttachment = {
  /** 奖券附件名 */
  filename: Scalars['String']['output'];
  /** 奖券附件ID */
  id: Scalars['ID']['output'];
  /** 奖券原始数量 */
  originalSize: Scalars['Int']['output'];
};

export type ProfileAttributes = {
  avatar?: InputMaybe<ProfileAvatarAttributes>;
  name?: InputMaybe<Scalars['String']['input']>;
  nickName?: InputMaybe<Scalars['String']['input']>;
};

export type ProfileAvatarAttributes = {
  attachmentId: Scalars['ID']['input'];
  cropH?: InputMaybe<Scalars['Float']['input']>;
  cropW?: InputMaybe<Scalars['Float']['input']>;
  cropX?: InputMaybe<Scalars['Float']['input']>;
  cropY?: InputMaybe<Scalars['Float']['input']>;
};

export enum ProfileHistory {
  ApiSms = 'api_sms',
  AutomationEmail = 'automation_email',
  AutomationSms = 'automation_sms',
  ContactEmail = 'contact_email',
  ContactSms = 'contact_sms',
  Emails = 'emails',
  EntrySms = 'entry_sms',
  FieldVerifications = 'field_verifications',
  FormOperations = 'form_operations',
  Sms = 'sms',
  SubmitterSms = 'submitter_sms'
}

export type PromptExample = {
  /** 描述 */
  description?: Maybe<Scalars['String']['output']>;
  /** 提示词 */
  prompt: Scalars['String']['output'];
  /** 标题 */
  title: Scalars['String']['output'];
};

export enum PromptExampleCategoryEnum {
  /** 客服聊天 */
  CsChat = 'cs_chat',
  /** 表单生成 */
  FormGeneration = 'form_generation'
}

export enum PromptExampleSceneEnum {
  /** 测评 */
  Evaluation = 'evaluation',
  /** 考试 */
  Exam = 'exam',
  /** 表单 */
  Form = 'form',
  /** 在线支付 */
  OnlinePayment = 'online_payment',
  /** 登记 */
  Registry = 'registry',
  /** 预约 */
  Reservation = 'reservation',
  /** 调研 */
  Survey = 'survey'
}

export type PromptableField = {
  prompt?: Maybe<Scalars['String']['output']>;
};

export enum ProviderEnum {
  /** 腾讯会议 */
  TencentMeeting = 'tencent_meeting'
}

export type PseudoForm = {
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  formPredefinedValue?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  predefinedFields?: Maybe<Array<Field>>;
  token: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type PseudoFormAttributes = {
  formPredefinedValue?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** The connection type for PseudoForm. */
export type PseudoFormConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PseudoFormEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<PseudoForm>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PseudoFormEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<PseudoForm>;
};

export type PublicActivity = {
  createdAt: Scalars['ISO8601DateTime']['output'];
  form?: Maybe<Form>;
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  owner?: Maybe<PublishedUser>;
  parameters?: Maybe<Scalars['JSON']['output']>;
  trackableId?: Maybe<Scalars['String']['output']>;
};

/** The connection type for PublicActivity. */
export type PublicActivityConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PublicActivityEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<PublicActivity>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PublicActivityEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<PublicActivity>;
};

export type PublishedBillingAccount = {
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type PublishedEntryRedEnvelopeSetting = {
  /** 是否展示红包弹窗 */
  showRedEnvelopPopup: Scalars['Boolean']['output'];
  /** 红包是否启用 */
  showRedEnvelope: Scalars['Boolean']['output'];
};

export type PublishedEntryType = CustomerProperties & EntriesBaseProperties & MetaProperties & ReservationStatusProperties & ShareAndMarkProperties & WeixinProperties & {
  _type?: Maybe<Scalars['String']['output']>;
  browser?: Maybe<Scalars['String']['output']>;
  colorMark?: Maybe<Scalars['String']['output']>;
  /** 表单联系人 */
  contactId?: Maybe<Scalars['ID']['output']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  creator?: Maybe<PublishedUser>;
  customer?: Maybe<GdCustomer>;
  /** 当前版本号 */
  editedVersion?: Maybe<Scalars['Int']['output']>;
  fieldValues: Scalars['JSON']['output'];
  fillingDuration?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  ip?: Maybe<Scalars['String']['output']>;
  os?: Maybe<Scalars['String']['output']>;
  platform?: Maybe<Scalars['String']['output']>;
  region?: Maybe<RegionInfo>;
  remark?: Maybe<Scalars['String']['output']>;
  /** 预约状态 */
  reservationStatus?: Maybe<ReservationStatusEnum>;
  serialNumber: Scalars['Int']['output'];
  shareLink?: Maybe<Scalars['String']['output']>;
  shareToken?: Maybe<Scalars['String']['output']>;
  startFillingTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  useragent?: Maybe<Scalars['String']['output']>;
  weixinAccessToken?: Maybe<Scalars['ID']['output']>;
  xFieldWeixinHeadimgurl?: Maybe<Scalars['String']['output']>;
  xFieldWeixinNickname?: Maybe<Scalars['String']['output']>;
  xFieldWeixinOpenid?: Maybe<Scalars['ID']['output']>;
  xFieldWeixinUnionid?: Maybe<Scalars['ID']['output']>;
};

export type PublishedForm = FormDefaultEntry & WithPublishedDomainInfo & PublishedFormDynamicFields & {
  /** 实际使用的二级域名。当套餐不可用后，返回系统随机二级域名 */
  activeSubdomain?: Maybe<Scalars['String']['output']>;
  /** 表单所属 BillingAccount 的品牌信息 */
  branding: Branding;
  /** 所属 BillingAccount 的cname 信息 */
  cnameSetting: Cname;
  /** 带有默认值的预填写数据 */
  entry?: Maybe<Entry>;
  /** 选择类字段的投票结果统计数据 */
  entryCountsPerChoice?: Maybe<Scalars['JSON']['output']>;
  /** 红包设置 */
  entryRedEnvelopeSetting?: Maybe<PublishedEntryRedEnvelopeSetting>;
  /** 表单底部品牌信息 */
  footer?: Maybe<Footer>;
  /** 如果表单处于无法访问的状态，返回null */
  form?: Maybe<Form>;
  /** 是否包含动态信息，包括选项余额、商品库存、投票人数、点赞数等 */
  hasDynamicAttrs: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** 表单拦截页面所需数据 */
  interceptionSetting: FormInterceptionSetting;
  /** 表单布局 */
  layout: Layout;
  /** 实名认证信息 */
  licenseInfo?: Maybe<LicenseInfo>;
  name: Scalars['String']['output'];
  /**
   * 对描述中的链接做安全监测跳转
   * @deprecated 公开表单中链接的 SafeJump 功能已经移除
   */
  safeJumpEnabled: Scalars['Boolean']['output'];
  /** 表单场景 */
  scene: Scene;
  /** 表单填写状态 */
  status: PublishedFormStatus;
  /** 提交后展示信息 */
  successMessage?: Maybe<Scalars['String']['output']>;
  theme: Theme;
  token: Scalars['String']['output'];
  /** 表单顶部警告 */
  topWarning?: Maybe<Scalars['String']['output']>;
};


export type PublishedFormEntryArgs = {
  code?: InputMaybe<Scalars['ID']['input']>;
};


export type PublishedFormStatusArgs = {
  code?: InputMaybe<Scalars['ID']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
};


export type PublishedFormSuccessMessageArgs = {
  entryToken: Scalars['String']['input'];
};

export type PublishedFormBaseProperties = {
  deleted: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  token: Scalars['String']['output'];
  type: BaseFileEnum;
};

export enum PublishedFormRoute {
  /** 预填写表单 */
  PseudoForm = 'pseudo_form'
}

/** Autogenerated input type of PublishedFormsMobileVerifications */
export type PublishedFormsMobileVerificationsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  entryAttributes: Scalars['JSON']['input'];
  formId: Scalars['ID']['input'];
  routeType?: InputMaybe<PublishedFormRoute>;
};

/** Autogenerated return type of PublishedFormsMobileVerifications */
export type PublishedFormsMobileVerificationsPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
};

export type PublishedOpenEntry = {
  /** 登录的字段 */
  authFormFields?: Maybe<Array<Field>>;
  /** 对外修改的标题 */
  name?: Maybe<Scalars['String']['output']>;
  openEntry: OpenEntry;
  publishedForm?: Maybe<Form>;
  theme: Theme;
};

export type PublishedOpenResult = EntryEditable & HasPrivacyProtectedFields & PublishedResultsHasFields & PublishedResultsScenableSettings & WithConditionalScope & WithPublishedDomainInfo & {
  /** 查看/查询的密码 */
  accessPassword?: Maybe<Scalars['String']['output']>;
  /** 实际使用的二级域名。当套餐不可用后，返回系统随机二级域名 */
  activeSubdomain?: Maybe<Scalars['String']['output']>;
  /** 谁能看 */
  allowedAudience: AllowedAudienceForViewer;
  /** 达到限填后是否允许取消预约 */
  cancelReservationFillFrequencyLimited: Scalars['Boolean']['output'];
  /** 所属 BillingAccount 的cname 信息 */
  cnameSetting: Cname;
  /** scope condition筛选字段 */
  conditionTriggerableFields?: Maybe<Array<ConditionalTriggerableField>>;
  conditionalScope: Scalars['Boolean']['output'];
  /** 关闭状态,true:已关闭,false:已开启 */
  disabled?: Maybe<Scalars['Boolean']['output']>;
  /** 编辑数据按钮文案 */
  editDataBtnText?: Maybe<Scalars['String']['output']>;
  /** 操作权限-可编辑字段api_codes */
  editableFieldApiCodes: Array<Scalars['String']['output']>;
  /** 可修改字段 */
  editableFields?: Maybe<FieldConnection>;
  /** 到达限填后展示数据的设置 */
  entriesActionFillFrequencyLimited?: Maybe<OpenEntriesAction>;
  /** 是否允许修改数据, true: 允许  */
  entryEditEnabled: Scalars['Boolean']['output'];
  /** 修改前是否需要手机验证，true: 需要,false: 不需要 */
  entryEditVerifyEnabled: Scalars['Boolean']['output'];
  /** 修改手机可验证字段 */
  entryEditVerifyField: Field;
  /** 修改前手机验证字段api_code */
  entryEditVerifyFieldApiCode?: Maybe<Scalars['String']['output']>;
  /** 填写限制规则 */
  fillFrequency?: Maybe<FillFrequency>;
  /** 表单 */
  form?: Maybe<Form>;
  /** 表单设置 */
  formSetting: FormSetting;
  /** 当allowed_audience为sms_verification需要设置。表示：验证身份时，是否使用特定的手机号。true：使用，false：不使用 */
  isSpecifiedVerifier: Scalars['Boolean']['output'];
  /** 是否凭密码查看/查询，true：凭密码打开，false：不需要密码 */
  passwordRequired: Scalars['Boolean']['output'];
  /** 开启隐私保护字段的api codes */
  privacyProtectedFieldApiCodes?: Maybe<Array<Scalars['String']['output']>>;
  /** 操作权限-可查看字段api_code */
  readableFieldApiCodes: Array<Scalars['String']['output']>;
  /** 查询结果可查看的字段 */
  readableFields: FieldConnection;
  /** 操作权限-可看报表字段api_codes */
  reportFieldApiCodes: Array<Scalars['String']['output']>;
  /** 不同表单场景的额外设置，eg: 考试场景运行查看答案解析， */
  scenableSettings?: Maybe<Scalars['JSON']['output']>;
  scopeConditions?: Maybe<Array<ScopeCondition>>;
  /** 当达到限填后，是否展示表单 */
  showFormFillFrequencyLimited?: Maybe<Scalars['Boolean']['output']>;
  /** 对外查询状态 */
  status: PublishedOpenResultStatus;
  /** 表单提交时，是否限制地区 */
  submissionRegionLimited: Scalars['Boolean']['output'];
  /** 表单提交时，限制地区 */
  submissionRegions?: Maybe<Array<Scalars['String']['output']>>;
  /** 限制群组及部分人群条件. */
  submitterSetting?: Maybe<SubmitterSetting>;
  /** 名称 */
  title: Scalars['String']['output'];
  /** token */
  token: Scalars['String']['output'];
  /** 当allowed_audience为sms_verification需要设置。表示：特定手机号-身份验证的手机号 */
  viewVerifiers?: Maybe<Array<Scalars['String']['output']>>;
  /** 当allowed_audience为sms_verification需要设置。表示：验证身份时，表单中选择的手机认证字段api_code */
  viewVerifyFieldApiCode?: Maybe<Scalars['String']['output']>;
};


export type PublishedOpenResultEditableFieldsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type PublishedOpenResultReadableFieldsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type PublishedOpenResultStatusArgs = {
  password?: InputMaybe<Scalars['String']['input']>;
};

export type PublishedOpenResultStatus = {
  key: PublishedOpenResultStatusKey;
};

export enum PublishedOpenResultStatusKey {
  /** 未开启分享 */
  NotShared = 'not_shared',
  /** 开放，能正常访问 */
  Open = 'open',
  /** 密码错误 */
  PasswordInvalid = 'password_invalid',
  /** 需要密码 */
  PasswordRequired = 'password_required',
  /** 暂不支持访问。包含：验证身份可浏览、仅限 submitter 浏览 */
  Unsupported = 'unsupported'
}

export type PublishedResultsHasFields = {
  /** 可修改字段 */
  editableFields?: Maybe<FieldConnection>;
  /** 查询结果可查看的字段 */
  readableFields: FieldConnection;
};


export type PublishedResultsHasFieldsEditableFieldsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type PublishedResultsHasFieldsReadableFieldsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PublishedResultsScenableSettings = {
  /** 不同表单场景的额外设置，eg: 考试场景运行查看答案解析， */
  scenableSettings?: Maybe<Scalars['JSON']['output']>;
};

export type PublishedSingleShareEntryType = {
  entry?: Maybe<PublishedEntryType>;
  form?: Maybe<PublishedForm>;
  /** 分享的字段 */
  sharedFields?: Maybe<FieldConnection>;
};


export type PublishedSingleShareEntryTypeSharedFieldsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export enum PublishedUrlDomainEnum {
  /** 自定义域名 */
  Custom = 'custom',
  /** 金数据域名 */
  Gd = 'gd'
}

export type PublishedUser = {
  avatarUrl?: Maybe<Scalars['String']['output']>;
  billingAccount?: Maybe<PublishedBillingAccount>;
  /** 用户在系统中展示的名字，优先级为：企业身份下的名字 -> 微信昵称 -> 昵称 -> 邮箱 -> 手机号 */
  displayName: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  /** 协作者在当前表单中的角色 */
  formRole?: Maybe<FormRole>;
  id: Scalars['ID']['output'];
  mobile?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  weixinQiyeUser?: Maybe<WeixinQiyeUser>;
};


export type PublishedUserDisplayNameArgs = {
  privacyProtect?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PublishedUserFormRoleArgs = {
  formToken?: InputMaybe<Scalars['ID']['input']>;
};

/** 购买限制 */
export type PurchaseLimitedItem = {
  /** 最多购买 */
  maxPurchaseQuantity?: Maybe<Scalars['BigInteger']['output']>;
  /** 最少购买 */
  minPurchaseQuantity?: Maybe<Scalars['BigInteger']['output']>;
};

export type Query = {
  abTest?: Maybe<Scalars['Boolean']['output']>;
  addressData: Array<AddressData>;
  advancedNotificationsNotifications?: Maybe<AdvancedNotificationsNotificationConnection>;
  advancedNotificationsRule?: Maybe<Rule>;
  advancedNotificationsRules?: Maybe<RuleConnection>;
  aiGeneratedFormHeaderImages: Array<GeneratedFormHeaderImage>;
  aiGeneratedFormPosters: Array<PosterBackground>;
  aiPromptExamples: Array<PromptExample>;
  announcementGenerator?: Maybe<Scalars['String']['output']>;
  apiSmsNotificationHistories?: Maybe<ApiNotificationConnection>;
  appCenterAppPackages: Array<AppPackage>;
  appCenterApplications: Array<DoorkeeperApplication>;
  associableFields: Array<AssociableFormField>;
  associableFormData: AssociableFormDataConnection;
  associatedFieldTextualChoices?: Maybe<AssociatedTextualChoiceConnection>;
  attachmentFieldMediaTypes: Array<AttachmentFieldMedia>;
  auditTrailEntries?: Maybe<AuditTrailEntryConnection>;
  automationHistories?: Maybe<AutomationTransactionConnection>;
  /** 当前 active 客服列表，可作为转交目标 */
  availableCsMen: Array<CsMan>;
  baseFileTags?: Maybe<Array<FormTag>>;
  bill?: Maybe<Bill>;
  billingAccountActivities?: Maybe<PublicActivityConnection>;
  bills: BillConnection;
  candidateUser?: Maybe<CandidateUser>;
  certificatesConfig?: Maybe<CertificatesConfig>;
  colorMarkField: Field;
  conditionTriggerableFields: Array<ConditionalTriggerableField>;
  conflictSetting: Scalars['JSON']['output'];
  contactEmailHistories?: Maybe<ContactEmailConnection>;
  contactSmsHistories?: Maybe<ContactSmsConnection>;
  contactTags?: Maybe<ContactTagConnection>;
  conversation: Conversation;
  cooperator?: Maybe<FormCooperators>;
  /** CS 控制台查看单个 Jiri 会话（含消息），仅限 active cs_man，仅限 AgentInquiryConversation */
  csConsoleConversation: Conversation;
  /** CS 控制台的近期 Jiri 会话列表，按最近活跃时间倒序 */
  csConsoleConversations: ConversationConnection;
  /** 管理后台所有客服账号（含 inactive） */
  csManageAllCsMen: Array<CsManageCsManAdmin>;
  /** 管理后台查看任意会话详情 */
  csManageConversation?: Maybe<Conversation>;
  /** 管理后台历史会话查询 */
  csManageConversations: CsManageConversationsPage;
  /** 管理后台 Dashboard 第一版指标 */
  csManageDashboard: CsManageDashboardMetrics;
  currentBillingAccount?: Maybe<BillingAccount>;
  /** 当前登录用户对应的 CSMan 记录（含 inactive），若当前用户不是 CS 或未登录则为 null */
  currentCsMan?: Maybe<CsMan>;
  currentCustomer?: Maybe<Customer>;
  currentSubmitter?: Maybe<Submitter>;
  currentUser?: Maybe<User>;
  customTheme?: Maybe<Array<GdPortalTheme>>;
  customerAuditLogs?: Maybe<GdPortalCustomerAuditLogTypeConnection>;
  customerFilledData?: Maybe<EntryConnection>;
  customerFilledForm?: Maybe<Form>;
  customerGroup?: Maybe<GdPortalCustomerGroupType>;
  customerImportJob?: Maybe<GdPortalCustomerImportJobType>;
  customerPortal?: Maybe<GdPortalPortalType>;
  customerPortals?: Maybe<GdPortalPortalTypeConnection>;
  customers?: Maybe<CustomerConnection>;
  dailyVasUsageStats?: Maybe<Array<DailyUsageStats>>;
  dateVasUsageStats?: Maybe<Array<DateUsageStatsGroup>>;
  detectSmsSignatureSensitive: Scalars['Boolean']['output'];
  emailNotificationHistories?: Maybe<EmailConnection>;
  entries?: Maybe<EntryConnection>;
  entry?: Maybe<Entry>;
  entryEmailTask: EntryEmailTaskType;
  entryEmailTasks: EntryEmailTaskTypeConnection;
  entryEmailTasksStatusCounts: EntryEmailTaskStatusCounts;
  entrySmsHistories?: Maybe<EntrySmsConnection>;
  entrySmsTask: EntrySmsTaskType;
  entrySmsTasks: EntrySmsTaskTypeConnection;
  entrySmsTasksStatusCounts: EntrySmsTaskStatusCounts;
  fieldStateFlow?: Maybe<FieldStateFlow>;
  fieldVerificationHistories?: Maybe<FieldVerificationConnection>;
  form?: Maybe<Form>;
  formApplications?: Maybe<Array<UserFormApplication>>;
  formCovers?: Maybe<FormCoverConnection>;
  formDynamicAttrs?: Maybe<DynamicAttrs>;
  formFieldGroups: Array<FieldGroup>;
  formFieldMeta?: Maybe<FieldMeta>;
  formFolder?: Maybe<FormFolder>;
  formHeaderImages: Array<FormHeaderImage>;
  formImportJob?: Maybe<FormImportJob>;
  formInviteLink?: Maybe<SessionFormInviteLink>;
  formOperationHistories?: Maybe<FormOperationConnection>;
  formPortalInfo?: Maybe<GdPortalFormPortalInfoType>;
  formRecent: Widget;
  formRole?: Maybe<FormRole>;
  formSubmitterSettings: FormSubmitterSettingConnection;
  /** 按 ID 返回当前用户名下的指定 FormView */
  formView?: Maybe<FormViewType>;
  /** 返回当前用户在指定表单上的全部 FormView（用户在此表单下尚无任何视图时，首次调用会一次性生成 Grid/Kanban/Stats 三条） */
  formViews: Array<FormViewType>;
  /** @deprecated This is a duplicate resolver, please use Query.FormCovers instead. */
  forms?: Maybe<FormConnection>;
  formulaValidationResult: ValidationResult;
  globalSearch: GlobalSearch;
  groupedEntries?: Maybe<GroupedEntriesType>;
  helpDocument?: Maybe<HelpDocument>;
  hiddenFeature?: Maybe<Scalars['Boolean']['output']>;
  initCaptcha?: Maybe<BaseCaptcha>;
  intlMobileMetaData: Array<IntlMobileMetaData>;
  marketingAdvertisement?: Maybe<Array<MarketingAdvertisement>>;
  modalReminder?: Maybe<ModalReminder>;
  myEntries?: Maybe<EntryConnection>;
  newUiAbility?: Maybe<NewUiAbility>;
  noneBindableFormIds?: Maybe<Array<Scalars['String']['output']>>;
  officialIndustries: Array<Industry>;
  openEntries?: Maybe<OpenEntryConnection>;
  openEntryOauthLoginSession: OpenEntryOauthLoginSessionType;
  openResult?: Maybe<OpenResult>;
  openSearch?: Maybe<OpenSearch>;
  paidFeature?: Maybe<PaidFeature>;
  participatedForm?: Maybe<ParticipatedForm>;
  paymentAccount?: Maybe<PaymentAccount>;
  paymentHistories: DebitBalanceHistoryConnection;
  plan: Plan;
  portal: Portal;
  portalAssets?: Maybe<Array<GdPortalAssetsType>>;
  portalTemplates?: Maybe<Array<GdPortalTemplateType>>;
  posterTemplates: Array<PosterTemplate>;
  predefinedChoiceSets: Array<PredefinedChoiceSet>;
  predefinedWeixinThumbnails: Array<WeixinThumbnail>;
  previewForm?: Maybe<PublishedForm>;
  profileHistoryFilter?: Maybe<Filter>;
  pseudoForm?: Maybe<PseudoForm>;
  /** 获取关联字段中被关联字段的选项 */
  publishedAssociatedEntriesOptions?: Maybe<AssociatedEntryOptionConnection>;
  /** 获取关联字段中关联的显示字段的内容 */
  publishedAssociatedEntryDisplayData?: Maybe<AssociatedEntry>;
  publishedCustomerFilledData?: Maybe<GdPortalCustomerFilledDataTypeConnection>;
  publishedCustomerFilledForm?: Maybe<GdPortalCustomerFilledFormType>;
  publishedCustomerMobileExists: GdPortalCustomerMobileExistsType;
  publishedCustomerPortal?: Maybe<GdPortalPublishedPortalType>;
  publishedCustomerRegistrationStatus?: Maybe<GdPortalCustomerRegistrationStatusType>;
  publishedCustomerWeixinPortalSession: GdPortalWeixinPortalSessionType;
  publishedEntries?: Maybe<EntryConnection>;
  publishedEntry?: Maybe<Entry>;
  publishedEvaluationReport?: Maybe<PublishedEvaluationReport>;
  publishedForm?: Maybe<PublishedForm>;
  /** 表单中的动态信息，包括选项余额、商品库存、动态日期、点赞数等 */
  publishedFormDynamicAttrs?: Maybe<PublishedDynamicAttrs>;
  publishedOpenEntry?: Maybe<PublishedOpenEntry>;
  publishedOpenResult?: Maybe<PublishedOpenResult>;
  publishedOpenSearch?: Maybe<OpenSearch>;
  publishedOpenSearchEntries?: Maybe<OpenSearchEntryConnection>;
  publishedOpenSearchEntry?: Maybe<OpenSearchEntry>;
  publishedOpenSearchShareReports: Report;
  publishedOpensearchQuery?: Maybe<PublishedOpensearchQueryType>;
  publishedSingleSharedEntry: PublishedSingleShareEntryType;
  /** 根据姓名、手机、邮箱搜索用户信息 */
  publishedUser?: Maybe<Array<PublishedUser>>;
  publishedWeixinEntry?: Maybe<PublishedWeixinEntry>;
  redEnvelopeRechargeHistories: ChargeRedEnvelopeTransactionConnection;
  reports: Report;
  reportsExportJob?: Maybe<ReportsExportJob>;
  requestLocation: RequestLocation;
  reservationItemMeta?: Maybe<ReservationItemMeta>;
  searchBaseFiles: SearchedBaseFileConnection;
  showFeature: Scalars['Boolean']['output'];
  siteMarketingAdvertisement?: Maybe<MarketingAdvertisement>;
  smsNotificationHistories?: Maybe<SmsConnection>;
  smsSignature?: Maybe<Signature>;
  smsSignatures: Array<Signature>;
  smsTemplate?: Maybe<SmsTemplate>;
  smsTemplates?: Maybe<SmsTemplateConnection>;
  submitterBindingWeixinData: BindingWeixinData;
  submitterBulletins?: Maybe<Array<Bulletin>>;
  submitterEntries: EntrySubmitterConnection;
  submitterFilledForms: SubmitterFillableFormConnection;
  submitterFormEntries: EntryConnection;
  submitterFormEntry: EntrySubmitter;
  submitterGroup?: Maybe<SubmitterGroup>;
  submitterGroups?: Maybe<SubmitterGroupConnection>;
  submitterOauthLoginSession: OauthLoginSession;
  submitterResponseRate: SubmitterResponseRate;
  submitterSendingTasks: SubmitterSendingTaskConnection;
  submitterSmsHistories?: Maybe<SubmitterNotificationConnection>;
  /** 获取待填写的表单 */
  submitterUnfilledForms: PortalFormConnection;
  submitterWeixinQiyeLoginSession: OauthLoginSession;
  submitters?: Maybe<SubmitterConnection>;
  systemIncidents?: Maybe<SystemIncidentConnection>;
  tableCovers?: Maybe<FormCoverConnection>;
  templateUsage?: Maybe<Usage>;
  templateWithdrawAccount?: Maybe<WithdrawAccount>;
  themeTemplates: Array<Theme>;
  unsupportedFeature: Scalars['Boolean']['output'];
  usageScenarios: Array<UsageScenarios>;
  userInviteLink?: Maybe<SessionUserInviteLink>;
  validateEvaluationIndicatorFormula: Indicator;
  vasPackages?: Maybe<Array<VasPackage>>;
  visitHistories?: Maybe<VisitInfoConnection>;
  weixinAccountAuthData: WeixinAccountAuthData;
  weixinAccountAuthUrl: Scalars['String']['output'];
  weixinJsApiConfig?: Maybe<JsApiConfig>;
  weixinLoginData: WeixinLoginData;
  weixinOauthData: WeixinOauthData;
  weixinOpenQrcode?: Maybe<Scalars['String']['output']>;
  weixinQiyeStructure: WeixinQiyeStructure;
};


export type QueryAbTestArgs = {
  key: Scalars['String']['input'];
  publishedFormToken?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAddressDataArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAdvancedNotificationsNotificationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  approach?: InputMaybe<Approach>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  formId: Scalars['ID']['input'];
  keyword?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  performedAt?: InputMaybe<DateRangeAttributes>;
  status?: InputMaybe<NotificationStatus>;
};


export type QueryAdvancedNotificationsRuleArgs = {
  formId: Scalars['ID']['input'];
  ruleId: Scalars['ID']['input'];
};


export type QueryAdvancedNotificationsRulesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  formId: Scalars['ID']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAiGeneratedFormHeaderImagesArgs = {
  contextConversationId?: InputMaybe<Scalars['String']['input']>;
  contextFormToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAiGeneratedFormPostersArgs = {
  contextConversationId?: InputMaybe<Scalars['String']['input']>;
  contextFormToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAiPromptExamplesArgs = {
  category: PromptExampleCategoryEnum;
  scene?: InputMaybe<PromptExampleSceneEnum>;
};


export type QueryAnnouncementGeneratorArgs = {
  formToken: Scalars['String']['input'];
};


export type QueryApiSmsNotificationHistoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  appId?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  billingAccountId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  performedAt?: InputMaybe<DateRangeAttributes>;
  recipient?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAssociableFieldsArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAssociableFormDataArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  targetFormId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAssociatedFieldTextualChoicesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  apiCode: Scalars['ID']['input'];
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
  keywords?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAuditTrailEntriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  auditTrailId: Scalars['ID']['input'];
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  formId: Scalars['ID']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAutomationHistoriesArgs = {
  actionType?: InputMaybe<AutomationActionType>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  billingAccountId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  formId?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  performedAt?: InputMaybe<DateRangeAttributes>;
  recipient?: InputMaybe<Scalars['String']['input']>;
};


export type QueryBaseFileTagsArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryBillArgs = {
  id: Scalars['ID']['input'];
  type: BillUsageType;
};


export type QueryBillingAccountActivitiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryBillsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  type: BillUsageType;
};


export type QueryCandidateUserArgs = {
  emailOrMobile: Scalars['String']['input'];
};


export type QueryConditionTriggerableFieldsArgs = {
  fieldsContext?: InputMaybe<ConditionalTriggerableFieldsContext>;
  id: Scalars['ID']['input'];
  returnAll?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryConflictSettingArgs = {
  formId: Scalars['ID']['input'];
  settingName: Scalars['String']['input'];
};


export type QueryContactEmailHistoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  billingAccountId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  performedAt?: InputMaybe<DateRangeAttributes>;
  recipient?: InputMaybe<Scalars['String']['input']>;
};


export type QueryContactSmsHistoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  billingAccountId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  performedAt?: InputMaybe<DateRangeAttributes>;
  recipient?: InputMaybe<Scalars['String']['input']>;
};


export type QueryContactTagsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryConversationArgs = {
  afft?: InputMaybe<Scalars['String']['input']>;
  conversationId: Scalars['String']['input'];
};


export type QueryCooperatorArgs = {
  formId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


export type QueryCsConsoleConversationArgs = {
  conversationId: Scalars['String']['input'];
};


export type QueryCsConsoleConversationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inHandoff?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCsManageConversationArgs = {
  conversationId: Scalars['String']['input'];
};


export type QueryCsManageConversationsArgs = {
  endAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  startAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCurrentUserArgs = {
  appIdentity?: InputMaybe<AppIdentity>;
};


export type QueryCustomerAuditLogsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  portalToken?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<GdPortalCustomerAuditStatus>;
};


export type QueryCustomerFilledDataArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  customerId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  formToken: Scalars['ID']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  portalToken?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryCustomerFilledFormArgs = {
  customerId: Scalars['ID']['input'];
  formToken: Scalars['ID']['input'];
  portalToken?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryCustomerGroupArgs = {
  portalToken?: InputMaybe<Scalars['ID']['input']>;
  token: Scalars['ID']['input'];
};


export type QueryCustomerImportJobArgs = {
  customerImportJobId?: InputMaybe<Scalars['ID']['input']>;
  portalToken?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryCustomerPortalArgs = {
  portalToken?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryCustomerPortalsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCustomersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  portalToken?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryDailyVasUsageStatsArgs = {
  type: VasUsageType;
};


export type QueryDateVasUsageStatsArgs = {
  date: Scalars['ISO8601DateTime']['input'];
  type: VasUsageType;
};


export type QueryDetectSmsSignatureSensitiveArgs = {
  signature: Scalars['String']['input'];
};


export type QueryEmailNotificationHistoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  billingAccountId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  formId?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  performedAt?: InputMaybe<DateRangeAttributes>;
  recipient?: InputMaybe<Scalars['String']['input']>;
};


export type QueryEntriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<EntriesFilterAttributes>;
  filterChanged?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  formId: Scalars['ID']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  sortColumns?: InputMaybe<Array<SortColumnAttributes>>;
};


export type QueryEntryArgs = {
  formId: Scalars['ID']['input'];
  serialNumber?: InputMaybe<Scalars['Int']['input']>;
  token?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryEntryEmailTaskArgs = {
  formId: Scalars['ID']['input'];
  taskId: Scalars['ID']['input'];
};


export type QueryEntryEmailTasksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  formId: Scalars['ID']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<EmailTaskSendStatusEnum>;
};


export type QueryEntryEmailTasksStatusCountsArgs = {
  formId: Scalars['ID']['input'];
};


export type QueryEntrySmsHistoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  billingAccountId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  formId?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  performedAt?: InputMaybe<DateRangeAttributes>;
  recipient?: InputMaybe<Scalars['String']['input']>;
};


export type QueryEntrySmsTaskArgs = {
  formId: Scalars['ID']['input'];
  taskId: Scalars['ID']['input'];
};


export type QueryEntrySmsTasksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  formId: Scalars['ID']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<EntrySmsTaskSendStatus>;
};


export type QueryEntrySmsTasksStatusCountsArgs = {
  formId: Scalars['ID']['input'];
};


export type QueryFieldStateFlowArgs = {
  formId: Scalars['ID']['input'];
  fsfTarget: Scalars['String']['input'];
  fsfType: FsfType;
  serialNumber: Scalars['Int']['input'];
};


export type QueryFieldVerificationHistoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  billingAccountId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  formId?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  performedAt?: InputMaybe<DateRangeAttributes>;
  recipient?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFormArgs = {
  formUsage?: InputMaybe<FormUsage>;
  id?: InputMaybe<Scalars['ID']['input']>;
  layout?: InputMaybe<Layout>;
  platform?: InputMaybe<Platform>;
  scene?: InputMaybe<Scene>;
};


export type QueryFormApplicationsArgs = {
  appCode?: InputMaybe<Scalars['String']['input']>;
  formId: Scalars['ID']['input'];
};


export type QueryFormCoversArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  billingAccountId?: InputMaybe<Scalars['ID']['input']>;
  currentUserOwned?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  flatten?: InputMaybe<Scalars['Boolean']['input']>;
  folderId?: InputMaybe<Scalars['ID']['input']>;
  ignorePinning?: InputMaybe<Scalars['Boolean']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  managed?: InputMaybe<Scalars['Boolean']['input']>;
  merchantType?: InputMaybe<MerchantTypeEnum>;
  participated?: InputMaybe<Scalars['Boolean']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  tagId?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<BaseFileEnum>;
};


export type QueryFormDynamicAttrsArgs = {
  formId: Scalars['ID']['input'];
};


export type QueryFormFieldGroupsArgs = {
  layout?: InputMaybe<Layout>;
  platform?: InputMaybe<Platform>;
  scene?: InputMaybe<Scene>;
  token?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFormFieldMetaArgs = {
  fieldApiCode: Scalars['ID']['input'];
  formId: Scalars['ID']['input'];
};


export type QueryFormFolderArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryFormHeaderImagesArgs = {
  scene?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};


export type QueryFormImportJobArgs = {
  assignCellsByForm?: InputMaybe<Scalars['Boolean']['input']>;
  headerRowIndex?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
};


export type QueryFormInviteLinkArgs = {
  token: Scalars['ID']['input'];
};


export type QueryFormOperationHistoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  billingAccountId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  formId?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  queryType?: InputMaybe<FormOperationQuery>;
};


export type QueryFormPortalInfoArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryFormRecentArgs = {
  endTime?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  formId: Scalars['ID']['input'];
  period: RecentRuleEnum;
  startTime?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
};


export type QueryFormRoleArgs = {
  formId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


export type QueryFormSubmitterSettingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFormViewArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFormViewsArgs = {
  formToken: Scalars['String']['input'];
};


export type QueryFormsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderDirection?: InputMaybe<OrderDirectionEnum>;
  q?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFormulaValidationResultArgs = {
  context: Scalars['JSON']['input'];
  formula: Scalars['String']['input'];
};


export type QueryGlobalSearchArgs = {
  currentUserOwned?: InputMaybe<Scalars['Boolean']['input']>;
  keyword: Scalars['String']['input'];
  managed?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGroupedEntriesArgs = {
  filter?: InputMaybe<EntriesFilterAttributes>;
  first?: InputMaybe<Scalars['Int']['input']>;
  formId: Scalars['ID']['input'];
  groupByApiCode: Scalars['String']['input'];
  groups?: InputMaybe<Array<GroupedEntriesGroupRequestAttributes>>;
  sortColumns?: InputMaybe<Array<SortColumnAttributes>>;
};


export type QueryHelpDocumentArgs = {
  formToken?: InputMaybe<Scalars['ID']['input']>;
  idSelector: Scalars['String']['input'];
  withMaxUpdate?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryHiddenFeatureArgs = {
  key: Scalars['String']['input'];
  layout?: InputMaybe<Layout>;
  scene: Scene;
  scope?: InputMaybe<Scalars['String']['input']>;
};


export type QueryInitCaptchaArgs = {
  digestMod?: InputMaybe<Scalars['String']['input']>;
  forceGeetest?: InputMaybe<Scalars['Boolean']['input']>;
  formToken?: InputMaybe<Scalars['ID']['input']>;
  options?: InputMaybe<Scalars['JSON']['input']>;
  type: GeetestKeyEnum;
};


export type QueryIntlMobileMetaDataArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMarketingAdvertisementArgs = {
  orderKey?: InputMaybe<MarketingAdOrderKeyEnum>;
  orderSeq?: InputMaybe<MarketingAdOrderSeqEnum>;
  shownType?: InputMaybe<MarketingAdShownTypeEnum>;
};


export type QueryMyEntriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<EntriesFilterAttributes>;
  first?: InputMaybe<Scalars['Int']['input']>;
  formId: Scalars['ID']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  sortColumns?: InputMaybe<Array<SortColumnAttributes>>;
};


export type QueryNewUiAbilityArgs = {
  key: Scalars['String']['input'];
};


export type QueryNoneBindableFormIdsArgs = {
  portalToken?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryOfficialIndustriesArgs = {
  category?: InputMaybe<IndustryCategory>;
};


export type QueryOpenEntriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  formId: Scalars['ID']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryOpenEntryOauthLoginSessionArgs = {
  id: Scalars['String']['input'];
  openEntryToken: Scalars['ID']['input'];
};


export type QueryOpenResultArgs = {
  formId: Scalars['ID']['input'];
  openResultId: Scalars['ID']['input'];
};


export type QueryOpenSearchArgs = {
  formId: Scalars['ID']['input'];
  openSearchId: Scalars['ID']['input'];
};


export type QueryPaidFeatureArgs = {
  key: Scalars['String']['input'];
};


export type QueryParticipatedFormArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryPaymentAccountArgs = {
  id: Scalars['ID']['input'];
  type: PaymentAccountEnum;
};


export type QueryPaymentHistoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPlanArgs = {
  code: PlanCode;
};


export type QueryPortalArgs = {
  token: Scalars['String']['input'];
};


export type QueryPreviewFormArgs = {
  cacheToken: Scalars['String']['input'];
};


export type QueryProfileHistoryFilterArgs = {
  billingAccountId?: InputMaybe<Scalars['ID']['input']>;
  queryType?: InputMaybe<FormOperationQuery>;
  type: ProfileHistory;
};


export type QueryPseudoFormArgs = {
  formId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


export type QueryPublishedAssociatedEntriesOptionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  associatedFieldApiCode: Scalars['ID']['input'];
  before?: InputMaybe<Scalars['String']['input']>;
  fieldApiCode: Scalars['ID']['input'];
  filters?: InputMaybe<Scalars['JSON']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  formId: Scalars['ID']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  routeType?: InputMaybe<PublishedFormRoute>;
  source?: InputMaybe<AssociatedEntrySource>;
};


export type QueryPublishedAssociatedEntryDisplayDataArgs = {
  associatedFieldApiCode: Scalars['ID']['input'];
  entryId?: InputMaybe<Scalars['ID']['input']>;
  fieldApiCode: Scalars['ID']['input'];
  formId: Scalars['ID']['input'];
  mobile?: InputMaybe<Scalars['String']['input']>;
  mobileVerification?: InputMaybe<Scalars['String']['input']>;
  routeType?: InputMaybe<PublishedFormRoute>;
  weixinOpenid?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryPublishedCustomerFilledDataArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  formToken: Scalars['ID']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  serialNumber?: InputMaybe<Scalars['Int']['input']>;
  widgetId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryPublishedCustomerFilledFormArgs = {
  formToken: Scalars['ID']['input'];
  widgetId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryPublishedCustomerMobileExistsArgs = {
  mobile: Scalars['String']['input'];
};


export type QueryPublishedCustomerPortalArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPublishedCustomerRegistrationStatusArgs = {
  authKey: Scalars['String']['input'];
  authProvider: GdPortalAuthenticationProviderEnum;
};


export type QueryPublishedCustomerWeixinPortalSessionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPublishedEntriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  formToken?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  openEntryId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryPublishedEntryArgs = {
  entryId: Scalars['ID']['input'];
  formToken?: InputMaybe<Scalars['ID']['input']>;
  openEntryId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryPublishedEvaluationReportArgs = {
  entryId: Scalars['ID']['input'];
  formId: Scalars['ID']['input'];
  routeType?: InputMaybe<PublishedFormRoute>;
};


export type QueryPublishedFormArgs = {
  afft?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  incognitoToken?: InputMaybe<Scalars['String']['input']>;
  internal?: InputMaybe<Scalars['Boolean']['input']>;
  routeType?: InputMaybe<PublishedFormRoute>;
};


export type QueryPublishedFormDynamicAttrsArgs = {
  afft?: InputMaybe<Scalars['String']['input']>;
  formId: Scalars['ID']['input'];
  incognitoToken?: InputMaybe<Scalars['String']['input']>;
  routeType?: InputMaybe<PublishedFormRoute>;
};


export type QueryPublishedOpenEntryArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPublishedOpenResultArgs = {
  formId: Scalars['ID']['input'];
  openResultId: Scalars['ID']['input'];
  routeType?: InputMaybe<PublishedFormRoute>;
};


export type QueryPublishedOpenSearchArgs = {
  formId: Scalars['ID']['input'];
  openSearchId: Scalars['ID']['input'];
  routeType?: InputMaybe<PublishedFormRoute>;
};


export type QueryPublishedOpenSearchEntriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  fieldFilter?: InputMaybe<Array<Scalars['JSON']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  formId: Scalars['ID']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  openResultId?: InputMaybe<Scalars['ID']['input']>;
  openSearchId?: InputMaybe<Scalars['ID']['input']>;
  routeType?: InputMaybe<PublishedFormRoute>;
  scopeConditions?: InputMaybe<Array<ScopeConditionAttributes>>;
  sortColumns?: InputMaybe<Array<SortColumnAttributes>>;
};


export type QueryPublishedOpenSearchEntryArgs = {
  entryId: Scalars['ID']['input'];
  formId: Scalars['ID']['input'];
  mobileVerificationToken?: InputMaybe<Scalars['String']['input']>;
  openResultId?: InputMaybe<Scalars['ID']['input']>;
  openSearchId?: InputMaybe<Scalars['ID']['input']>;
  routeType?: InputMaybe<PublishedFormRoute>;
};


export type QueryPublishedOpenSearchShareReportsArgs = {
  formId: Scalars['ID']['input'];
  openResultId: Scalars['ID']['input'];
  preferFields?: InputMaybe<Array<Scalars['String']['input']>>;
  routeType?: InputMaybe<PublishedFormRoute>;
};


export type QueryPublishedOpensearchQueryArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPublishedSingleSharedEntryArgs = {
  formId: Scalars['ID']['input'];
  routeType?: InputMaybe<PublishedFormRoute>;
  shareToken: Scalars['ID']['input'];
};


export type QueryPublishedUserArgs = {
  inOrg?: InputMaybe<Scalars['Boolean']['input']>;
  keyword: Scalars['String']['input'];
};


export type QueryPublishedWeixinEntryArgs = {
  code: Scalars['ID']['input'];
  formId: Scalars['ID']['input'];
  routeType?: InputMaybe<PublishedFormRoute>;
};


export type QueryRedEnvelopeRechargeHistoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryReportsArgs = {
  filter?: InputMaybe<EntriesFilterAttributes>;
  filterChanged?: InputMaybe<Scalars['Boolean']['input']>;
  formId: Scalars['ID']['input'];
  keyword?: InputMaybe<Scalars['String']['input']>;
  preferFields?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryReportsExportJobArgs = {
  formId: Scalars['ID']['input'];
};


export type QueryReservationItemMetaArgs = {
  fieldApiCode: Scalars['ID']['input'];
  formId: Scalars['ID']['input'];
  itemApiCode: Scalars['ID']['input'];
  routeType?: InputMaybe<PublishedFormRoute>;
};


export type QuerySearchBaseFilesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  keyword: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SearchBaseFilesSortMode>;
  type?: InputMaybe<BaseFileEnum>;
};


export type QueryShowFeatureArgs = {
  forBillingAccountOwner?: InputMaybe<Scalars['Boolean']['input']>;
  forFormBillingAccountOwner?: InputMaybe<Scalars['Boolean']['input']>;
  formToken?: InputMaybe<Scalars['ID']['input']>;
  key: Scalars['String']['input'];
};


export type QuerySmsNotificationHistoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  billingAccountId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  formId?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  performedAt?: InputMaybe<DateRangeAttributes>;
  recipient?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySmsSignatureArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySmsSignaturesArgs = {
  channel?: InputMaybe<SmsChannel>;
  scope?: InputMaybe<SmsTemplateScope>;
  signatureStatus?: InputMaybe<SignatureStatus>;
};


export type QuerySmsTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySmsTemplatesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  channel?: InputMaybe<SmsChannel>;
  filter?: InputMaybe<SmsFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  scene?: InputMaybe<Scene>;
  scope?: InputMaybe<SmsTemplateScope>;
  selectedId?: InputMaybe<Scalars['ID']['input']>;
  smsSignatureId?: InputMaybe<Scalars['ID']['input']>;
};


export type QuerySubmitterBulletinsArgs = {
  bulletinId?: InputMaybe<Scalars['ID']['input']>;
  navigationItemId: Scalars['ID']['input'];
};


export type QuerySubmitterEntriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySubmitterFilledFormsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySubmitterFormEntriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  formToken: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySubmitterFormEntryArgs = {
  formToken: Scalars['String']['input'];
  serialNumber: Scalars['Int']['input'];
};


export type QuerySubmitterGroupArgs = {
  groupToken: Scalars['String']['input'];
};


export type QuerySubmitterGroupsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  formId?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySubmitterOauthLoginSessionArgs = {
  id: Scalars['String']['input'];
  redirectionAttributes?: InputMaybe<SubmitterRedirectionAttributes>;
};


export type QuerySubmitterResponseRateArgs = {
  conditions?: InputMaybe<SubmitterFilterAttributes>;
  id: Scalars['ID']['input'];
};


export type QuerySubmitterSendingTasksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  payloadToken: Scalars['ID']['input'];
};


export type QuerySubmitterSmsHistoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  billingAccountId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  formId?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  performedAt?: InputMaybe<DateRangeAttributes>;
  recipient?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySubmitterUnfilledFormsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySubmitterWeixinQiyeLoginSessionArgs = {
  id: Scalars['String']['input'];
};


export type QuerySubmittersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  conditionalScope?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  groupId: Scalars['ID']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  scopeConditions?: InputMaybe<Array<ScopeConditionAttributes>>;
};


export type QuerySystemIncidentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  endTime?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  startTime: Scalars['ISO8601DateTime']['input'];
};


export type QueryTableCoversArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  billingAccountId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  folderId?: InputMaybe<Scalars['ID']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  tagId?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<BaseFileEnum>;
};


export type QueryTemplateUsageArgs = {
  templateId: Scalars['ID']['input'];
};


export type QueryThemeTemplatesArgs = {
  layout?: InputMaybe<Layout>;
  scene?: InputMaybe<Scene>;
};


export type QueryUnsupportedFeatureArgs = {
  key: Scalars['String']['input'];
};


export type QueryUserInviteLinkArgs = {
  t: Scalars['String']['input'];
  token: Scalars['ID']['input'];
};


export type QueryValidateEvaluationIndicatorFormulaArgs = {
  fieldApiCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  formId: Scalars['ID']['input'];
  formulaDisplay: Scalars['String']['input'];
  indicatorApiCode: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};


export type QueryVasPackagesArgs = {
  vas: Vas;
};


export type QueryVisitHistoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  billingAccountId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryWeixinAccountAuthDataArgs = {
  token: Scalars['ID']['input'];
};


export type QueryWeixinAccountAuthUrlArgs = {
  returnUrl: Scalars['String']['input'];
  state: Scalars['String']['input'];
  token: Scalars['String']['input'];
  weixinAccountId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryWeixinJsApiConfigArgs = {
  url: Scalars['String']['input'];
};


export type QueryWeixinLoginDataArgs = {
  omniauthParams?: InputMaybe<Scalars['String']['input']>;
};


export type QueryWeixinOauthDataArgs = {
  code: Scalars['ID']['input'];
};


export type QueryWeixinOpenQrcodeArgs = {
  scene?: InputMaybe<WeixinOpenScanScene>;
};


export type QueryWeixinQiyeStructureArgs = {
  departmentId?: InputMaybe<Scalars['Int']['input']>;
};

export type QuestionSetting = {
  /** 题型 */
  questionType?: Maybe<QuestionTypeKey>;
  /** 出题数目 */
  randomNum?: Maybe<Scalars['Int']['output']>;
  /** 分数 */
  score?: Maybe<Scalars['Float']['output']>;
};

export type QuestionSettingAttributes = {
  /** 题型 */
  questionType: QuestionTypeKey;
  /** 出题数目 */
  randomNum: Scalars['Int']['input'];
};

export enum QuestionTypeKey {
  AnalyticsFields = 'analytics_fields',
  MatrixFields = 'matrix_fields',
  MultiSelectFields = 'multi_select_fields',
  MultiTextFields = 'multi_text_fields',
  SimpleTextFields = 'simple_text_fields',
  SingleSelectOnlyFields = 'single_select_only_fields',
  TrueOrFalseFields = 'true_or_false_fields'
}

export enum QuotaCycleRule {
  /** 不重置 */
  Fixed = 'fixed',
  /** 按天重置 */
  PerDay = 'per_day',
  /** 按周重置 */
  PerWeek = 'per_week'
}

export type QuotaSummary = DayQuotaSummary | TimeRangeSummary;

/** 选项名额 */
export type QuotableChoice = {
  /** 剩余名额 */
  quota?: Maybe<Scalars['BigInteger']['output']>;
  /** 名额设置 */
  quotaSetting?: Maybe<Scalars['BigInteger']['output']>;
};

/** 字段选项名额设置 */
export type QuotableField = {
  /** 选项名额为空时隐藏选项 */
  hideChoiceWhenQuotaEmpty: Scalars['Boolean']['output'];
  /** 不向填表者展示选项名额剩余数字 */
  hideQuota: Scalars['Boolean']['output'];
  /** 剩余名额为0时，显示文案 */
  quotaBlankWarning?: Maybe<Scalars['String']['output']>;
  /** 选项名额重置 */
  quotaCycleRule?: Maybe<QuotaCycleRule>;
  /** 删除数据后，选项名额自动恢复 */
  quotaRecoverable: Scalars['Boolean']['output'];
};

export type RadioButton = AssociatedField & BaseField & CalculableField & ExtraConfigurableSetting & FieldAbility & PlanAvailableField & PredefineableField & QuotableField & SelectableField & {
  apiCode: Scalars['ID']['output'];
  apiCodeAlias?: Maybe<Scalars['String']['output']>;
  /** 对应的表单关联字段 */
  associationField?: Maybe<Field>;
  /** 自动填写上次提交内容 */
  cacheData: Scalars['Boolean']['output'];
  /** 开启选项赋值或本身可参与计算 */
  calculable: Scalars['Boolean']['output'];
  choices: Array<Choice>;
  choicesLayout?: Maybe<ChoicesLayout>;
  /** 客户端ID */
  cid?: Maybe<Scalars['String']['output']>;
  /** 封装的字段类型 */
  customizedType?: Maybe<Scalars['String']['output']>;
  /** 封装的字段类型文本 */
  customizedTypeName?: Maybe<Scalars['String']['output']>;
  /** 自定义出错文案 */
  customizedValidationMessage?: Maybe<Scalars['String']['output']>;
  displayEntryCountsPerChoice: Scalars['Boolean']['output'];
  /** 已提交的数据是否可被编辑 */
  editable: Scalars['Boolean']['output'];
  /** 场景化可配置字段设置 */
  extraConfigurableSettings?: Maybe<FieldExtraConfigurableSettings>;
  /** 该字段能否使用字段规则: true - 能， false - 不能 */
  fieldRuleAvailable: Scalars['Boolean']['output'];
  /** 是否是关联主键字段 */
  forAssociated?: Maybe<Scalars['Boolean']['output']>;
  /** 是否是关联展示字段 */
  forAssociatedDisplay?: Maybe<Scalars['Boolean']['output']>;
  /** 表单Token */
  formToken: Scalars['String']['output'];
  /** 宽度占用整行的四分之几 */
  gridsToOccupy?: Maybe<Scalars['Int']['output']>;
  hasAbility: Scalars['Boolean']['output'];
  /** 选项名额为空时隐藏选项 */
  hideChoiceWhenQuotaEmpty: Scalars['Boolean']['output'];
  /** 不向填表者展示选项名额剩余数字 */
  hideQuota: Scalars['Boolean']['output'];
  /** 字段标题（去富文本化） */
  label?: Maybe<Scalars['String']['output']>;
  /** 字段描述，富文本 */
  notes?: Maybe<Scalars['String']['output']>;
  paidFeature?: Maybe<PaidFeature>;
  planAvailable: Scalars['Boolean']['output'];
  /** 字段排序 */
  position: Scalars['Int']['output'];
  /** 预填写表单 */
  predefined: Scalars['Boolean']['output'];
  /** 该字段是否是隐私字段 true - 是, false - 不是 */
  privacy: Scalars['Boolean']['output'];
  /** 字段隐藏 */
  private: Scalars['Boolean']['output'];
  /** 字段是否通过预填写表单预设了值 true - 是, false - 否 */
  pseudoFormPredefined?: Maybe<Scalars['Boolean']['output']>;
  /** 剩余名额为0时，显示文案 */
  quotaBlankWarning?: Maybe<Scalars['String']['output']>;
  /** 选项名额重置 */
  quotaCycleRule?: Maybe<QuotaCycleRule>;
  /** 删除数据后，选项名额自动恢复 */
  quotaRecoverable: Scalars['Boolean']['output'];
  randomChoices: Scalars['Boolean']['output'];
  /** 字段标题（富文本化） */
  rawLabel?: Maybe<Scalars['String']['output']>;
  /** 字段是否只读，无法编辑 */
  readonly?: Maybe<Scalars['Boolean']['output']>;
  /** 该字段是否属于评分字段（e.g. 考试、测评中的题目） */
  scorable: Scalars['Boolean']['output'];
  /** 字段提示较长时折叠展示 */
  showPartDescription: Scalars['Boolean']['output'];
  /** 新起一行 */
  startNewRow: Scalars['Boolean']['output'];
  /** 该字段是否可以作为文本插入 true - 能, false - 不能 */
  textPlaceholderable: Scalars['Boolean']['output'];
  /** 字段类型 */
  type: FieldClass;
  /** 字段类型文本 */
  typeName: Scalars['String']['output'];
  /** 字段验证规则 */
  validations?: Maybe<Array<FieldValidation>>;
};


export type RadioButtonHasAbilityArgs = {
  key: FieldAbilityEnum;
};


export type RadioButtonNotesArgs = {
  sanitize?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RangeValidatableField = {
  rangeMax?: Maybe<Scalars['Float']['output']>;
  rangeMin?: Maybe<Scalars['Float']['output']>;
};

export type RatingField = AssociatedField & BaseField & CalculableField & ExtraConfigurableSetting & FieldAbility & PlanAvailableField & WithRatingsDisplayText & {
  apiCode: Scalars['ID']['output'];
  apiCodeAlias?: Maybe<Scalars['String']['output']>;
  /** 对应的表单关联字段 */
  associationField?: Maybe<Field>;
  /** 自动填写上次提交内容 */
  cacheData: Scalars['Boolean']['output'];
  /** 开启选项赋值或本身可参与计算 */
  calculable: Scalars['Boolean']['output'];
  /** 客户端ID */
  cid?: Maybe<Scalars['String']['output']>;
  /** 封装的字段类型 */
  customizedType?: Maybe<Scalars['String']['output']>;
  /** 封装的字段类型文本 */
  customizedTypeName?: Maybe<Scalars['String']['output']>;
  /** 自定义出错文案 */
  customizedValidationMessage?: Maybe<Scalars['String']['output']>;
  /** 已提交的数据是否可被编辑 */
  editable: Scalars['Boolean']['output'];
  /** 场景化可配置字段设置 */
  extraConfigurableSettings?: Maybe<FieldExtraConfigurableSettings>;
  /** 该字段能否使用字段规则: true - 能， false - 不能 */
  fieldRuleAvailable: Scalars['Boolean']['output'];
  /** 是否是关联主键字段 */
  forAssociated?: Maybe<Scalars['Boolean']['output']>;
  /** 是否是关联展示字段 */
  forAssociatedDisplay?: Maybe<Scalars['Boolean']['output']>;
  /** 表单Token */
  formToken: Scalars['String']['output'];
  /** 宽度占用整行的四分之几 */
  gridsToOccupy?: Maybe<Scalars['Int']['output']>;
  hasAbility: Scalars['Boolean']['output'];
  /** 字段标题（去富文本化） */
  label?: Maybe<Scalars['String']['output']>;
  /** 最高分文案 */
  maximumRatingsDisplayText?: Maybe<Scalars['String']['output']>;
  /** 最低分文案 */
  minimumRatingsDisplayText?: Maybe<Scalars['String']['output']>;
  /** 字段描述，富文本 */
  notes?: Maybe<Scalars['String']['output']>;
  paidFeature?: Maybe<PaidFeature>;
  planAvailable: Scalars['Boolean']['output'];
  /** 字段排序 */
  position: Scalars['Int']['output'];
  /** 该字段是否是隐私字段 true - 是, false - 不是 */
  privacy: Scalars['Boolean']['output'];
  /** 字段隐藏 */
  private: Scalars['Boolean']['output'];
  /** 字段是否通过预填写表单预设了值 true - 是, false - 否 */
  pseudoFormPredefined?: Maybe<Scalars['Boolean']['output']>;
  /** 评分起始值 */
  rangeMin?: Maybe<Scalars['Float']['output']>;
  /** 评分量级 */
  ratingMax: Scalars['Int']['output'];
  /** 外观 */
  ratingType: RatingType;
  /** 字段标题（富文本化） */
  rawLabel?: Maybe<Scalars['String']['output']>;
  /** 字段是否只读，无法编辑 */
  readonly?: Maybe<Scalars['Boolean']['output']>;
  /** 该字段是否属于评分字段（e.g. 考试、测评中的题目） */
  scorable: Scalars['Boolean']['output'];
  /** 字段提示较长时折叠展示 */
  showPartDescription: Scalars['Boolean']['output'];
  /** 新起一行 */
  startNewRow: Scalars['Boolean']['output'];
  /** 该字段是否可以作为文本插入 true - 能, false - 不能 */
  textPlaceholderable: Scalars['Boolean']['output'];
  /** 字段类型 */
  type: FieldClass;
  /** 字段类型文本 */
  typeName: Scalars['String']['output'];
  /** 字段验证规则 */
  validations?: Maybe<Array<FieldValidation>>;
};


export type RatingFieldHasAbilityArgs = {
  key: FieldAbilityEnum;
};


export type RatingFieldNotesArgs = {
  sanitize?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum RatingType {
  Applaud = 'applaud',
  Beer = 'beer',
  Cheers = 'cheers',
  Crown = 'crown',
  Diamond = 'diamond',
  Fire = 'fire',
  Flag = 'flag',
  Flower = 'flower',
  Happy = 'happy',
  Heart = 'heart',
  Money = 'money',
  Moon = 'moon',
  Plane = 'plane',
  Rose = 'rose',
  Shit = 'shit',
  Star = 'star',
  Strong = 'strong',
  Sun = 'sun',
  Thumb = 'thumb',
  Tomato = 'tomato',
  Tree = 'tree',
  Yeah = 'yeah'
}

export enum RatingTypeAttribute {
  Applaud = 'applaud',
  Cheers = 'cheers',
  Crown = 'crown',
  Flag = 'flag',
  Happy = 'happy',
  Heart = 'heart',
  Moon = 'moon',
  Plane = 'plane',
  Rose = 'rose',
  Shit = 'shit',
  Star = 'star',
  Sun = 'sun',
  Thumb = 'thumb',
  Tomato = 'tomato'
}

export enum RecentRuleEnum {
  ByDay = 'by_day',
  ByHour = 'by_hour'
}

export type Recommendation = {
  /** 文案内容 */
  comment?: Maybe<Scalars['String']['output']>;
  /** 分数区间右端点 */
  endPoint?: Maybe<Scalars['Float']['output']>;
  /** 是否开启再填一次。true - 开启；false - 关闭 */
  retry?: Maybe<Scalars['Boolean']['output']>;
  /** 分数区间左端点 */
  startPoint?: Maybe<Scalars['Float']['output']>;
};

export type RecommendationCommentSettingAttributes = {
  /** 评论 */
  comment: Scalars['String']['input'];
  /** 分数左区间 */
  endPoint: Scalars['Float']['input'];
  /** 是否再填一次 */
  retry: Scalars['Boolean']['input'];
  /** 分数左区间 */
  startPoint: Scalars['Float']['input'];
};

export type RedEnvelopeCommonSetting = {
  /** 固定红包金额 */
  fixedAmount: Scalars['Float']['output'];
  /** 随机最小金额 */
  rangeLowerBound: Scalars['Float']['output'];
  /** 随机最大金额 */
  rangeUpperBound: Scalars['Float']['output'];
  /** 是否随机金额 */
  useRandomAmount: Scalars['Boolean']['output'];
  /** 是否在自定义范围内随机 */
  useRandomAmountInRange: Scalars['Boolean']['output'];
};

export type RedEnvelopeDebitBalance = {
  balance: Scalars['Float']['output'];
  /** 充值时，用于身份验证的凭证 */
  purchaseToken: Scalars['String']['output'];
};

export enum RedEnvelopeDeliveryRule {
  /** After audit */
  AfterAudit = 'after_audit',
  /** Direct */
  Direct = 'direct',
  /** Use custom probability */
  UseCustomProbability = 'use_custom_probability'
}

export type RedEnvelopeOrder = {
  /** 表单 */
  form?: Maybe<Form>;
};

export enum RedEnvelopeRedeemFrequency {
  /** Daily */
  Daily = 'daily',
  /** Once */
  Once = 'once',
  /** Unlimitted */
  Unlimitted = 'unlimitted'
}

export type RedEnvelopeScoreRule = {
  /** 分数段左边界 */
  leftBoundary: Scalars['Float']['output'];
  /** 规则比较类型 */
  predicateType?: Maybe<RedEnvelopeScoreRulePredicateType>;
  /** 分数段右边界 */
  rightBoundary: Scalars['Float']['output'];
};

export type RedEnvelopeScoreRuleAttributes = {
  /** 分数段左边界 */
  leftBoundary?: InputMaybe<Scalars['Float']['input']>;
  /** 规则比较类型 */
  predicateType?: InputMaybe<RedEnvelopeScoreRulePredicateType>;
  /** 分数段右边界 */
  rightBoundary?: InputMaybe<Scalars['Float']['input']>;
};

export enum RedEnvelopeScoreRulePredicateType {
  /** Equal to */
  EqualTo = 'equal_to',
  /** Greater than or equal to */
  GreaterThanOrEqualTo = 'greater_than_or_equal_to',
  /** Less than or equal to */
  LessThanOrEqualTo = 'less_than_or_equal_to',
  /** Range */
  Range = 'range'
}

export type RedirectRuleAttributes = {
  /** 且/或 */
  operator: FieldRuleTriggerConditionGroupOperator;
  /** 跳转链接 */
  redirectUrl: Scalars['String']['input'];
  /** 规则集 */
  ruleSets: Array<RuleSetAttributes>;
};

export type RegionInfo = {
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  countryIsoCode?: Maybe<Scalars['String']['output']>;
  province?: Maybe<Scalars['String']['output']>;
};

export type RegistrySetting = {
  /** 填写布局 */
  fillLayout: FillLayout;
};

export type RemainingPrizeVoucherAttachment = {
  /** 剩余奖券EXCEL下载链接 */
  publicDownloadUrl: Scalars['String']['output'];
};

/** Autogenerated input type of ReorderFormViews */
export type ReorderFormViewsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  formToken: Scalars['String']['input'];
  views: Array<FormViewReorderAttributes>;
};

/** Autogenerated return type of ReorderFormViews */
export type ReorderFormViewsPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  formViews?: Maybe<Array<FormViewType>>;
};

export enum RepeatCycleUnit {
  /** Day */
  Day = 'day',
  /** Month */
  Month = 'month',
  /** Week */
  Week = 'week',
  /** Year */
  Year = 'year'
}

export type RepeatRule = {
  /** 日期字段的api_code */
  dateKey?: Maybe<Scalars['String']['output']>;
  /** 日期偏移动作 */
  dateOffsetAction?: Maybe<DateOffsetAction>;
  /** 日期偏移量 */
  dateOffsetNumber?: Maybe<Scalars['Int']['output']>;
  /** 日期偏移单位 */
  dateOffsetUnit?: Maybe<DateOffsetUnit>;
  /** 小时 */
  hour?: Maybe<Scalars['Int']['output']>;
  /** 分钟 */
  minute?: Maybe<Scalars['Int']['output']>;
  /** 重复日期量 */
  repeatCycleInterval?: Maybe<Scalars['Int']['output']>;
  /** 重复日期单位 */
  repeatCycleUnit?: Maybe<RepeatCycleUnit>;
};

export type RepeatRuleAttributes = {
  /** 日期字段的api_code */
  dateKey?: InputMaybe<Scalars['String']['input']>;
  /** 日期偏移动作 */
  dateOffsetAction?: InputMaybe<DateOffsetAction>;
  /** 日期偏移量 */
  dateOffsetNumber?: InputMaybe<Scalars['Int']['input']>;
  /** 日期偏移单位 */
  dateOffsetUnit?: InputMaybe<DateOffsetUnit>;
  /** 小时 */
  hour?: InputMaybe<Scalars['Int']['input']>;
  /** 分钟 */
  minute?: InputMaybe<Scalars['Int']['input']>;
  /** 重复日期量 */
  repeatCycleInterval?: InputMaybe<Scalars['Int']['input']>;
  /** 重复日期单位 */
  repeatCycleUnit?: InputMaybe<RepeatCycleUnit>;
};

export type Report = {
  fieldReports?: Maybe<Array<FieldReport>>;
  matchedEntriesCount?: Maybe<Scalars['Int']['output']>;
  overview?: Maybe<Overview>;
  scene: Scene;
};

export type ReportsExportJob = {
  attachmentUrl?: Maybe<Scalars['String']['output']>;
  failedMessage?: Maybe<Scalars['String']['output']>;
  reportType?: Maybe<GdFormReportJob>;
  status: GdFormReportJobStatus;
};

export type RequestLocation = {
  /** 国家码，比如，中国为 CN */
  countryIsoCode: Scalars['String']['output'];
  /** 来自中国的请求 */
  fromChina: Scalars['Boolean']['output'];
};

/** Autogenerated input type of ResendEntryEmailTask */
export type ResendEntryEmailTaskInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 数据筛选条件 */
  entriesFilter: EntriesFilterAttributes;
  /** 表单的使用场景 */
  formUsage?: InputMaybe<FormUsage>;
  /** 表单ID或token */
  id: Scalars['ID']['input'];
  taskId: Scalars['ID']['input'];
};

/** Autogenerated return type of ResendEntryEmailTask */
export type ResendEntryEmailTaskPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  task?: Maybe<EntryEmailTaskType>;
};

/** Autogenerated input type of ResendEntrySMSTask */
export type ResendEntrySmsTaskInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 数据筛选条件 */
  entriesFilter: EntriesFilterAttributes;
  /** 表单的使用场景 */
  formUsage?: InputMaybe<FormUsage>;
  /** 表单ID或token */
  id: Scalars['ID']['input'];
  taskId: Scalars['ID']['input'];
};

/** Autogenerated return type of ResendEntrySMSTask */
export type ResendEntrySmsTaskPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  smsTask?: Maybe<EntrySmsTaskType>;
};

export type ReservationField = AssociatedField & BaseField & FieldAbility & PayableField & PlanAvailableField & {
  /** 允许预约多个项目 */
  allowMultipleItems: Scalars['Boolean']['output'];
  /** 单次预约可选择多个名额 */
  allowMultipleNumber: Scalars['Boolean']['output'];
  apiCode: Scalars['ID']['output'];
  apiCodeAlias?: Maybe<Scalars['String']['output']>;
  /** 对应的表单关联字段 */
  associationField?: Maybe<Field>;
  /** 自动填写上次提交内容 */
  cacheData: Scalars['Boolean']['output'];
  /** 客户端ID */
  cid?: Maybe<Scalars['String']['output']>;
  /** 封装的字段类型 */
  customizedType?: Maybe<Scalars['String']['output']>;
  /** 封装的字段类型文本 */
  customizedTypeName?: Maybe<Scalars['String']['output']>;
  /** 自定义出错文案 */
  customizedValidationMessage?: Maybe<Scalars['String']['output']>;
  /** 已提交的数据是否可被编辑 */
  editable: Scalars['Boolean']['output'];
  /** 该字段能否使用字段规则: true - 能， false - 不能 */
  fieldRuleAvailable: Scalars['Boolean']['output'];
  /** 是否是关联主键字段 */
  forAssociated?: Maybe<Scalars['Boolean']['output']>;
  /** 是否是关联展示字段 */
  forAssociatedDisplay?: Maybe<Scalars['Boolean']['output']>;
  /** 表单Token */
  formToken: Scalars['String']['output'];
  /** 宽度占用整行的四分之几 */
  gridsToOccupy?: Maybe<Scalars['Int']['output']>;
  hasAbility: Scalars['Boolean']['output'];
  /** 单项目允许预约多个时段 */
  itemAllowMultipleReservations: Scalars['Boolean']['output'];
  /** 字段标题（去富文本化） */
  label?: Maybe<Scalars['String']['output']>;
  /** 字段描述，富文本 */
  notes?: Maybe<Scalars['String']['output']>;
  paidFeature?: Maybe<PaidFeature>;
  /** 该字段是否可支付（e.g. 商品、预约） */
  payable: Scalars['Boolean']['output'];
  planAvailable: Scalars['Boolean']['output'];
  /** 字段排序 */
  position: Scalars['Int']['output'];
  /** 该字段是否是隐私字段 true - 是, false - 不是 */
  privacy: Scalars['Boolean']['output'];
  /** 字段隐藏 */
  private: Scalars['Boolean']['output'];
  /** 字段是否通过预填写表单预设了值 true - 是, false - 否 */
  pseudoFormPredefined?: Maybe<Scalars['Boolean']['output']>;
  /** 字段标题（富文本化） */
  rawLabel?: Maybe<Scalars['String']['output']>;
  /** 字段是否只读，无法编辑 */
  readonly?: Maybe<Scalars['Boolean']['output']>;
  reservationItems: Array<ReservationItem>;
  /** 该字段是否属于评分字段（e.g. 考试、测评中的题目） */
  scorable: Scalars['Boolean']['output'];
  /** 字段提示较长时折叠展示 */
  showPartDescription: Scalars['Boolean']['output'];
  /** 新起一行 */
  startNewRow: Scalars['Boolean']['output'];
  /** 该字段是否可以作为文本插入 true - 能, false - 不能 */
  textPlaceholderable: Scalars['Boolean']['output'];
  /** 字段类型 */
  type: FieldClass;
  /** 字段类型文本 */
  typeName: Scalars['String']['output'];
  /** 字段验证规则 */
  validations?: Maybe<Array<FieldValidation>>;
};


export type ReservationFieldHasAbilityArgs = {
  key: FieldAbilityEnum;
};


export type ReservationFieldNotesArgs = {
  sanitize?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ReservationItem = {
  apiCode: Scalars['ID']['output'];
  /** 预约项描述 */
  description?: Maybe<Scalars['String']['output']>;
  /** 限时预约结束时间 */
  endDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** 隐藏商品 */
  hidden: Scalars['Boolean']['output'];
  /** 预约项名称 */
  name: Scalars['String']['output'];
  payable: Scalars['Boolean']['output'];
  /** 项目排序 */
  position: Scalars['Int']['output'];
  /** 预约方式及配额设置 */
  quotaSetting: ReservationQuotaSetting;
  /** 项目图片 */
  reservationItemImages: Array<Attachment>;
  selected: Scalars['Boolean']['output'];
  /** 限时预约开始时间 */
  startDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type ReservationItemAttributes = {
  apiCode?: InputMaybe<Scalars['ID']['input']>;
  /** 预约项目说明内容 */
  description?: InputMaybe<Scalars['String']['input']>;
  /** 限时预约结束时间 */
  endDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** 项目隐藏 */
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  /** 项目配图 */
  images?: InputMaybe<Array<ReservationItemImageAttributes>>;
  /** 预约项目名称 */
  name: Scalars['String']['input'];
  /** 可支付 */
  payable?: InputMaybe<Scalars['Boolean']['input']>;
  /** 位置排序 */
  position?: InputMaybe<Scalars['Int']['input']>;
  /** 预约方式及配额设置 */
  quotaSetting?: InputMaybe<ReservationQuotaSettingAttributes>;
  /** 默认选中 */
  selected?: InputMaybe<Scalars['Boolean']['input']>;
  /** 限时预约开始时间 */
  startDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
};

export type ReservationItemImageAttributes = {
  /** 预约项目配图的attachment id */
  attachmentId: Scalars['ID']['input'];
};

export type ReservationItemMeta = {
  /** 预约时段表 - 编辑器使用 */
  dailyTimeRanges?: Maybe<Array<DailyTimeRange>>;
  quotaSummary?: Maybe<Array<QuotaSummary>>;
};


export type ReservationItemMetaQuotaSummaryArgs = {
  endTime: Scalars['ISO8601DateTime']['input'];
  includeNonReservable?: InputMaybe<Scalars['Boolean']['input']>;
  putBackOccupiedQuotas?: InputMaybe<Array<Scalars['JSON']['input']>>;
  startTime: Scalars['ISO8601DateTime']['input'];
};

export type ReservationQuotaSetting = ByDayRepeatWeeklyQuota | ByTimeRangeRepeatDailyQuota;

export type ReservationQuotaSettingAttributes = {
  /** 可预约时间类型 */
  availableDaysOfWeek: Array<DayNameOfWeek>;
  /** 分时段配额设置 */
  dailyTimeRangeQuotas?: InputMaybe<Array<TimeRangeQuotaAttributes>>;
  /** 时段表 */
  dailyTimeRanges?: InputMaybe<Array<DailyTimeRangeAttributes>>;
  /** 最大可预约时间限制 */
  endTimeOffset?: InputMaybe<TimeOffsetAttributes>;
  /** 不可约时段配置 */
  nonReservableRules?: InputMaybe<Array<NonReservableRuleAttributes>>;
  /** 开启预约支付 */
  payable?: InputMaybe<Scalars['Boolean']['input']>;
  /** 名额仅统计未删除数据 */
  quotaExcludeDeletedEntry?: InputMaybe<Scalars['Boolean']['input']>;
  /** true: 向填表者展示剩余名额, false: 不展示, 默认: true */
  showLeftQuota?: InputMaybe<Scalars['Boolean']['input']>;
  /** 特殊时段配额设置 */
  specialTimeRangeQuotas?: InputMaybe<Array<SpecialTimeRangeQuotaAttributes>>;
  /** 提前预约时间限制 */
  startTimeOffset?: InputMaybe<TimeOffsetAttributes>;
  /** 时段的配置方式 */
  timeRangeMode?: InputMaybe<TimeRangeMode>;
  /** 预约方式 */
  type: ReservationQuotaSettingType;
};

export type ReservationQuotaSettingBase = {
  /** 可预约的星期 */
  availableDaysOfWeek: Array<DayNameOfWeek>;
  /** 最大可预约时间限制 */
  endTimeOffset?: Maybe<ReservationTimeOffset>;
  /** 不可预约的时间段 */
  nonReservableRules?: Maybe<Array<NonReservableRule>>;
  /** 名额仅统计未删除数据 */
  quotaExcludeDeletedEntry: Scalars['Boolean']['output'];
  /** true: 向填表者展示剩余名额, false: 不展示, 默认: true */
  showLeftQuota?: Maybe<Scalars['Boolean']['output']>;
  /** 提前预约时间限制 */
  startTimeOffset?: Maybe<ReservationTimeOffset>;
  /** 预约类型 */
  type?: Maybe<ReservationQuotaSettingType>;
};

export enum ReservationQuotaSettingType {
  ByDayRepeatWeekly = 'by_day_repeat_weekly',
  ByTimeRangeRepeatDaily = 'by_time_range_repeat_daily'
}

export enum ReservationStatusEnum {
  /** 已预约 */
  Booked = 'booked',
  /** 已取消 */
  Canceled = 'canceled',
  Fsfinit = 'fsfinit'
}

export type ReservationStatusProperties = {
  /** 预约状态 */
  reservationStatus?: Maybe<ReservationStatusEnum>;
};

export type ReservationTimeOffset = {
  offsetNumber: Scalars['Int']['output'];
  unit: TimeOffsetUnit;
};

/** Autogenerated input type of ReserveAccountManager */
export type ReserveAccountManagerInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of ReserveAccountManager */
export type ReserveAccountManagerPayload = {
  /** 服务顾问基础信息 */
  accountManager?: Maybe<AccountManager>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
};

export enum ResetRule {
  /** Daily */
  Daily = 'daily',
  /** Form field */
  FormField = 'form_field',
  /** Monthly */
  Monthly = 'monthly',
  /** None */
  None = 'none',
  /** Weekly */
  Weekly = 'weekly'
}

/** Autogenerated input type of RestoreForm */
export type RestoreFormInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 表单ID或token */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of RestoreForm */
export type RestoreFormPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  form?: Maybe<Form>;
};

export type ReversedAssociation = AssociatedField & BaseField & FieldAbility & PlanAvailableField & {
  apiCode: Scalars['ID']['output'];
  apiCodeAlias?: Maybe<Scalars['String']['output']>;
  /** 对应的表单关联字段 */
  associationField?: Maybe<Field>;
  associationForm?: Maybe<Form>;
  /** 自动填写上次提交内容 */
  cacheData: Scalars['Boolean']['output'];
  /** 客户端ID */
  cid?: Maybe<Scalars['String']['output']>;
  /** 封装的字段类型 */
  customizedType?: Maybe<Scalars['String']['output']>;
  /** 封装的字段类型文本 */
  customizedTypeName?: Maybe<Scalars['String']['output']>;
  /** 自定义出错文案 */
  customizedValidationMessage?: Maybe<Scalars['String']['output']>;
  /** 反向关联的展示字段 */
  displayFields: FieldConnection;
  /** 已提交的数据是否可被编辑 */
  editable: Scalars['Boolean']['output'];
  /** 该字段能否使用字段规则: true - 能， false - 不能 */
  fieldRuleAvailable: Scalars['Boolean']['output'];
  /** 是否是关联主键字段 */
  forAssociated?: Maybe<Scalars['Boolean']['output']>;
  /** 是否是关联展示字段 */
  forAssociatedDisplay?: Maybe<Scalars['Boolean']['output']>;
  formAssociationField?: Maybe<Field>;
  /** 表单Token */
  formToken: Scalars['String']['output'];
  /** 宽度占用整行的四分之几 */
  gridsToOccupy?: Maybe<Scalars['Int']['output']>;
  hasAbility: Scalars['Boolean']['output'];
  /** 字段标题（去富文本化） */
  label?: Maybe<Scalars['String']['output']>;
  /** 字段描述，富文本 */
  notes?: Maybe<Scalars['String']['output']>;
  paidFeature?: Maybe<PaidFeature>;
  planAvailable: Scalars['Boolean']['output'];
  /** 字段排序 */
  position: Scalars['Int']['output'];
  /** 该字段是否是隐私字段 true - 是, false - 不是 */
  privacy: Scalars['Boolean']['output'];
  /** 字段隐藏 */
  private: Scalars['Boolean']['output'];
  /** 字段是否通过预填写表单预设了值 true - 是, false - 否 */
  pseudoFormPredefined?: Maybe<Scalars['Boolean']['output']>;
  /** 字段标题（富文本化） */
  rawLabel?: Maybe<Scalars['String']['output']>;
  /** 字段是否只读，无法编辑 */
  readonly?: Maybe<Scalars['Boolean']['output']>;
  /** 该字段是否属于评分字段（e.g. 考试、测评中的题目） */
  scorable: Scalars['Boolean']['output'];
  /** 字段提示较长时折叠展示 */
  showPartDescription: Scalars['Boolean']['output'];
  /** 新起一行 */
  startNewRow: Scalars['Boolean']['output'];
  /** 该字段是否可以作为文本插入 true - 能, false - 不能 */
  textPlaceholderable: Scalars['Boolean']['output'];
  /** 字段类型 */
  type: FieldClass;
  /** 字段类型文本 */
  typeName: Scalars['String']['output'];
  /** 字段验证规则 */
  validations?: Maybe<Array<FieldValidation>>;
};


export type ReversedAssociationDisplayFieldsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type ReversedAssociationHasAbilityArgs = {
  key: FieldAbilityEnum;
};


export type ReversedAssociationNotesArgs = {
  sanitize?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ReviewStatusEnum {
  /** 开票成功 */
  Approved = 'approved',
  /** 开票中 */
  Invoicing = 'invoicing',
  /** 审核失败 */
  Rejected = 'rejected',
  /** 审核中 */
  UnderReview = 'under_review'
}

/** Autogenerated input type of RevokePersonalAccessToken */
export type RevokePersonalAccessTokenInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of RevokePersonalAccessToken */
export type RevokePersonalAccessTokenPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  personalAccessToken?: Maybe<PersonalAccessToken>;
};

export type RiskControl = {
  /** 封停原因 */
  ban?: Maybe<Ban>;
  /** 举报原因 */
  complaints?: Maybe<Array<Complaint>>;
  /** 表单是否被冻结 */
  disabled?: Maybe<Scalars['Boolean']['output']>;
};

export enum RowScopeType {
  All = 'all',
  Limited = 'limited'
}

export type Rule = DingTalkRule | EmailRule | NotImplementedRule | SmsRule | WebhookRule | WeixinOnetimeRule | WxworkRule;

export type RuleAdvancedNotificationsSmsAuditFailureActivity = {
  formInfo: FormActivityBaseInfo;
};

export type RuleAttributes = {
  /** 提醒推送类型 */
  approach: Approach;
  /** 发送条件字段 api_code */
  conditionKey?: InputMaybe<Scalars['String']['input']>;
  /** 发送条件的值 */
  conditionValue?: InputMaybe<Scalars['String']['input']>;
  /** true: 开启ScopeCondition */
  conditionalScope?: InputMaybe<Scalars['Boolean']['input']>;
  /** 消息/短信/邮件/微信消息内容 */
  content?: InputMaybe<Scalars['String']['input']>;
  /** 开启和关闭提醒推送 */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** 是否为支付条件 */
  entryPaid?: InputMaybe<Scalars['Boolean']['input']>;
  /** 提醒成员，@全体请传: @all */
  mentionedMobileList?: InputMaybe<Array<Scalars['String']['input']>>;
  /** 模板字段插入列表，按照插入顺序排列 */
  placeholderKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  /** 收件人，可直接传入手机号/邮箱，也可传入字段：$(api_code) */
  recipients?: InputMaybe<Array<Scalars['String']['input']>>;
  /** 按周期重复发送 */
  repeatRule?: InputMaybe<RepeatRuleAttributes>;
  /** 基于数据定制规则发送 */
  scheduleRule?: InputMaybe<ScheduleRuleAttributes>;
  /** 基于日期发送的规则 */
  scheduleTimeRule?: InputMaybe<ScheduleTimeRuleAttributes>;
  /** ScopeCondition条件组 */
  scopeConditions?: InputMaybe<Array<ScopeConditionAttributes>>;
  /** 指定发送时间 */
  sendAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** 何时发送 */
  sendTiming?: InputMaybe<SendTiming>;
  /** 短信签名 */
  signature?: InputMaybe<Scalars['String']['input']>;
  /** 短信模板ID */
  smsTemplateId?: InputMaybe<Scalars['ID']['input']>;
  /** smtp 账号id  */
  smtpAccountId?: InputMaybe<Scalars['ID']['input']>;
  /** 邮件标题/微信消息标题 */
  subject?: InputMaybe<Scalars['String']['input']>;
  /** 推送范围 */
  triggerScope: TriggerScope;
  /** 提醒推送类型 */
  type: AdvancedNotificationsRuleClassType;
  /** Webhook推送地址 */
  url?: InputMaybe<Scalars['String']['input']>;
  /** 微信一次性消息跳转链接 */
  weixinOnetimeUrl?: InputMaybe<Scalars['String']['input']>;
};

/** The connection type for Rule. */
export type RuleConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<RuleEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Rule>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type RuleEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Rule>;
};

export type RuleSmsTemplateApprovedWithAutosendActivity = {
  formInfo: FormActivityBaseInfo;
};

export type RuleSmsTemplateApprovedWithoutAutosendActivity = {
  formInfo: FormActivityBaseInfo;
};

export type RuleSet = {
  /** 选项级数 */
  cascadeLevel: Scalars['Int']['output'];
  /** 触发条件的值匹配方式 */
  comparator: FieldRuleValueComparator;
  /** 触发字段满足条件时的值: comparator为equal时应为api_code, comparator为between时应为api_code, */
  condition: Scalars['Any']['output'];
  /** 触发字段满足条件时的字段名 */
  conditionName?: Maybe<Scalars['String']['output']>;
  /** 父级选项 */
  parentChoices?: Maybe<Array<Scalars['ID']['output']>>;
  /** 触发字段的api_code */
  trigger: Scalars['ID']['output'];
};

export type RuleSetAttributes = {
  /** 选项级数 */
  cascadeLevel: Scalars['Int']['input'];
  /** 触发条件的值匹配方式 */
  comparator: FieldRuleValueComparator;
  /** 触发字段的选项api_code/触发字段的选择区间 */
  condition: Scalars['Any']['input'];
  /** 父级选项 */
  parentChoices?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** 触发字段的api_code */
  trigger: Scalars['ID']['input'];
};

export type RuleTriggerOperator = {
  /** 或/且 */
  operator: FieldRuleTriggerConditionGroupOperator;
};

export type Sms = Base & {
  /** 推送类型 */
  approach: Approach;
  cachedFormName: Scalars['String']['output'];
  /** 推送/短信/邮件内容 */
  content?: Maybe<Scalars['String']['output']>;
  entry?: Maybe<Entry>;
  /** 错误信息 */
  errorMessage?: Maybe<Scalars['String']['output']>;
  form?: Maybe<Form>;
  id: Scalars['ID']['output'];
  /** 消耗短信量 */
  messageCount: Scalars['Int']['output'];
  /** 发送时间（不等于任务触发时间） */
  performedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** 收件人，常用于短信和邮件 */
  recipient?: Maybe<Scalars['String']['output']>;
  /** 状态 */
  status: Status;
};

export type SmsAndEmailStats = {
  date: Scalars['ID']['output'];
  emailCount: Scalars['Float']['output'];
  smsCount: Scalars['Float']['output'];
};

/** 短信渠道，普通短信 或 营销短信 */
export enum SmsChannel {
  /** 营销短信 */
  Marketing = 'marketing',
  /** 普通短信 */
  Normal = 'normal'
}

/** The connection type for SMS. */
export type SmsConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SmsEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Sms>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SmsContentAuditRejectedActivity = {
  formInfo: FormActivityBaseInfo;
};

/** An edge in a connection. */
export type SmsEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Sms>;
};

/** 短信状态过滤，所有或可用于发短信的类型 */
export enum SmsFilter {
  /** 所有 */
  All = 'all',
  /** 可用与发送短信的 */
  Sendable = 'sendable'
}

export type SmsRule = BaseRule & {
  /** 推送类型 */
  approach: Approach;
  /** 发送条件字段 api_code */
  conditionKey?: Maybe<Scalars['String']['output']>;
  /** 发送条件的值 */
  conditionValue?: Maybe<Scalars['String']['output']>;
  /** true: 开启ScopeCondition */
  conditionalScope?: Maybe<Scalars['Boolean']['output']>;
  /** 短信内容 */
  content?: Maybe<Scalars['String']['output']>;
  /** 任务禁用原因，仅 enabled: false 时有效 */
  disabledBy?: Maybe<DisabledBy>;
  /** 任务是否开启 */
  enabled: Scalars['Boolean']['output'];
  /** 是否为支付条件 */
  entryPaid?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  /** 发送量 */
  notificationsCount?: Maybe<Scalars['Int']['output']>;
  /** 模板字段插入列表，按照插入顺序排列 */
  placeholderKeys?: Maybe<Array<Scalars['String']['output']>>;
  /** 收件人，可传手机号或字段 */
  recipients?: Maybe<Array<Scalars['String']['output']>>;
  /** 按周期重复发送 */
  repeatRule?: Maybe<RepeatRule>;
  /** 基于数据定制规则发送 */
  scheduleRule?: Maybe<ScheduleRule>;
  /** 基于日期发送的规则 */
  scheduleTimeRule?: Maybe<ScheduleTimeRule>;
  /** ScopeCondition条件组 */
  scopeConditions?: Maybe<Array<ScopeCondition>>;
  /** 指定发送时间 */
  sendAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** 何时发送 */
  sendTiming?: Maybe<SendTiming>;
  /** 短信签名 */
  signature?: Maybe<Scalars['String']['output']>;
  /** 云片短信模板 */
  smsTemplate?: Maybe<SmsTemplate>;
  /** 推送范围 */
  triggerScope: TriggerScope;
  /** 更新时间 */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type SmsSignatureAttributes = {
  /** 公司信用编码 */
  companyId: Scalars['String']['input'];
  /** 公司名称 */
  companyName: Scalars['String']['input'];
  /** 身份证反面照片(人像面)  */
  idCardBackAttachmentId: Scalars['ID']['input'];
  /** 身份证正面照片(国徽面)  */
  idCardFrontAttachmentId: Scalars['ID']['input'];
  /** 经办人身份证名 */
  idCardName: Scalars['String']['input'];
  /** 经办人身份证号 */
  idCardNumber: Scalars['String']['input'];
  /** 经办人手机号码 */
  identityMobile: Scalars['String']['input'];
  /** 公司法人姓名（实名认证用） */
  identityName?: InputMaybe<Scalars['String']['input']>;
  /** 资质证明列表 */
  licenseAttachmentIds: Array<Scalars['ID']['input']>;
  signature: Scalars['String']['input'];
  /** 签名类型 */
  type?: InputMaybe<Array<SignatureType>>;
};

export enum SmsTaskStatusEnum {
  /** Translation missing: en.tasks.status.all_sent */
  AllSent = 'all_sent',
  /** Translation missing: en.tasks.status.approved */
  Approved = 'approved',
  /** Translation missing: en.tasks.status.content_auditing */
  ContentAuditing = 'content_auditing',
  /** Translation missing: en.tasks.status.none_sent */
  NoneSent = 'none_sent',
  /** Translation missing: en.tasks.status.partial_sent */
  PartialSent = 'partial_sent',
  /** Translation missing: en.tasks.status.rejected */
  Rejected = 'rejected',
  /** Translation missing: en.tasks.status.revoked */
  Revoked = 'revoked',
  /** Translation missing: en.tasks.status.sending */
  Sending = 'sending',
  /** Translation missing: en.tasks.status.template_checking */
  TemplateChecking = 'template_checking',
  /** Translation missing: en.tasks.status.template_deleted */
  TemplateDeleted = 'template_deleted',
  /** Translation missing: en.tasks.status.template_fail */
  TemplateFail = 'template_fail',
  /** Translation missing: en.tasks.status.waiting_for_send */
  WaitingForSend = 'waiting_for_send'
}

export type SmsTemplate = {
  /** 提审备注 */
  applyDescription?: Maybe<Scalars['String']['output']>;
  channel: SmsChannel;
  checkStatus?: Maybe<Scalars['String']['output']>;
  /** 短信内容 */
  content: Scalars['String']['output'];
  /** 创建时间 */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** 审核失败原因 */
  failedReason?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** 是否为企业公开模板 */
  isPublic?: Maybe<Scalars['Boolean']['output']>;
  /** 短信平台模板 ID */
  outTemplateId?: Maybe<Scalars['String']['output']>;
  scope: SmsTemplateScope;
  /** 签名 */
  signature: Scalars['String']['output'];
  /** 短信签名模型 */
  smsSignature: Signature;
  /** 创建者 */
  user?: Maybe<User>;
};

export type SmsTemplateAttributes = {
  /** 提审备注  */
  applyDescription?: InputMaybe<Scalars['String']['input']>;
  channel?: InputMaybe<SmsChannel>;
  /** 公司信用编码 */
  companyId?: InputMaybe<Scalars['String']['input']>;
  /** 公司名称 */
  companyName?: InputMaybe<Scalars['String']['input']>;
  /** 短信内容 */
  content: Scalars['String']['input'];
  /** 表单id，提醒推送、自动化、数据页面使用请务必传 */
  formId?: InputMaybe<Scalars['ID']['input']>;
  /** 身份证反面照片(人像面)  */
  idCardBackAttachmentId?: InputMaybe<Scalars['ID']['input']>;
  /** 身份证正面照片(国徽面)  */
  idCardFrontAttachmentId?: InputMaybe<Scalars['ID']['input']>;
  /** 身份证姓名  */
  idCardName?: InputMaybe<Scalars['String']['input']>;
  /** 身份证号码  */
  idCardNumber?: InputMaybe<Scalars['String']['input']>;
  /** 身份证对应的实名手机号 */
  identityMobile?: InputMaybe<Scalars['String']['input']>;
  /** 公司法人姓名（实名认证用） */
  identityName?: InputMaybe<Scalars['String']['input']>;
  /** 资质证明列表 */
  licenseAttachmentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** 将该短信模板共享给企业内部 */
  public?: InputMaybe<Scalars['Boolean']['input']>;
  /** 短信签名 */
  signature?: InputMaybe<Scalars['String']['input']>;
  /** 云片短信签名id */
  smsSignatureId?: InputMaybe<Scalars['ID']['input']>;
  /** 短信模板id（非云片id，而是模型id） */
  templateId?: InputMaybe<Scalars['ID']['input']>;
};

/** The connection type for SMSTemplate. */
export type SmsTemplateConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SmsTemplateEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<SmsTemplate>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type SmsTemplateEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<SmsTemplate>;
};

export enum SmsTemplateScope {
  /** 我创建的 */
  Owned = 'owned',
  /** 企业共享 */
  Shared = 'shared',
  /** 系统提供 */
  System = 'system'
}

/** Autogenerated input type of SMSValidationContent */
export type SmsValidationContentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  content: Scalars['String']['input'];
};

/** Autogenerated return type of SMSValidationContent */
export type SmsValidationContentPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type SmsYunpianSignatureAttributes = {
  /** 是否为营销短信签名 */
  forMarketing: Scalars['Boolean']['input'];
  /** 身份证反面照片(人像面) */
  idCardBackAttachmentId: Scalars['ID']['input'];
  /** 身份证正面照片(国徽面) */
  idCardFrontAttachmentId: Scalars['ID']['input'];
  /** 身份证姓名 */
  idCardName: Scalars['String']['input'];
  /** 身份证号码 */
  idCardNumber: Scalars['String']['input'];
  /** 身份证对应的实名手机号 */
  identityMobile: Scalars['String']['input'];
  /** 资质证明列表 */
  licenseAttachmentIds: Array<Scalars['ID']['input']>;
  /** 短信签名 */
  signature: Scalars['String']['input'];
};

export type SmtpAccount = {
  /** SMTP服务器地址 */
  address: Scalars['String']['output'];
  /** 邮箱域名 */
  domain: Scalars['String']['output'];
  /** 发件人邮箱 */
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** [Deprecated: 请使用] 发件人名称 */
  name: Scalars['String']['output'];
  /** SMTP服务器端口 */
  port: Scalars['Int']['output'];
  /** [Deprecated: 请使用email] 发件人邮箱 */
  senderEmail: Scalars['String']['output'];
  /** [Deprecated: 请使用name] 发件人名称 */
  senderName: Scalars['String']['output'];
  /** 是否启用SSL */
  ssl?: Maybe<Scalars['Boolean']['output']>;
  /** 是否启用STARTTLS */
  starttls?: Maybe<Scalars['Boolean']['output']>;
  /** 状态 */
  status: SmtpAccountStatus;
  /** SMTP用户名 */
  userName: Scalars['String']['output'];
};

export type SmtpAccountAttributes = {
  /** SMTP服务器地址 */
  address: Scalars['String']['input'];
  /** 发件人邮箱 */
  email: Scalars['String']['input'];
  /** 发件人名称 */
  name: Scalars['String']['input'];
  /** SMTP密码 */
  password: Scalars['String']['input'];
  /** SMTP服务器端口 */
  port: Scalars['Int']['input'];
  /** 是否启用SSL */
  ssl?: InputMaybe<Scalars['Boolean']['input']>;
  /** 是否启用STARTTLS */
  starttls?: InputMaybe<Scalars['Boolean']['input']>;
  /** SMTP用户名 */
  userName: Scalars['String']['input'];
};

export enum SmtpAccountStatus {
  AuthFail = 'auth_fail',
  Success = 'success'
}

/** Autogenerated input type of SaveConversationSummary */
export type SaveConversationSummaryInput = {
  aiResolution?: InputMaybe<Scalars['String']['input']>;
  business?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  conversationId: Scalars['String']['input'];
  isValid?: InputMaybe<Scalars['String']['input']>;
  problemType?: InputMaybe<Scalars['String']['input']>;
  remarks?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of SaveConversationSummary */
export type SaveConversationSummaryPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  summary?: Maybe<ConversationSummary>;
};

/** Autogenerated input type of SaveSMSTemplate */
export type SaveSmsTemplateInput = {
  attributes: SmsTemplateAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of SaveSMSTemplate */
export type SaveSmsTemplatePayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  smsTemplate?: Maybe<SmsTemplate>;
};

/** Autogenerated input type of SaveTemplateCoupon */
export type SaveTemplateCouponInput = {
  attributes: TemplateCouponAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of SaveTemplateCoupon */
export type SaveTemplateCouponPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  templateCoupon?: Maybe<TemplateCoupon>;
};

/** Autogenerated input type of SaveTheme */
export type SaveThemeInput = {
  attributes: ThemeAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  formId?: InputMaybe<Scalars['ID']['input']>;
  /** 保存为样式模板 */
  template?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of SaveTheme */
export type SaveThemePayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  formId?: Maybe<Scalars['ID']['output']>;
  theme?: Maybe<Theme>;
};

/** Autogenerated input type of SaveUserLicenseInfo */
export type SaveUserLicenseInfoInput = {
  attributes: LicenseInfoAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 表单ID或token，在表单内做认证则必传 */
  formId?: InputMaybe<Scalars['ID']['input']>;
  /** 验证码 */
  verificationCode?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of SaveUserLicenseInfo */
export type SaveUserLicenseInfoPayload = {
  billingAccount?: Maybe<BillingAccount>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
};

/** Autogenerated input type of SaveWheelFortune */
export type SaveWheelFortuneInput = {
  attributes: FormApplicationWheelFortuneAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  formId: Scalars['ID']['input'];
};

/** Autogenerated return type of SaveWheelFortune */
export type SaveWheelFortunePayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  wheelFortune?: Maybe<WheelFortune>;
};

export enum Scene {
  /** Customer acquisition */
  CustomerAcquisition = 'customer_acquisition',
  /** Evaluation */
  Evaluation = 'evaluation',
  /** Exam */
  Exam = 'exam',
  /** Form */
  Form = 'form',
  /** Online payment */
  OnlinePayment = 'online_payment',
  /** Registry */
  Registry = 'registry',
  /** Reservation */
  Reservation = 'reservation',
  /** Survey */
  Survey = 'survey',
  /** Vote */
  Vote = 'vote'
}

export type SceneProperties = {
  /** 表单场景 */
  scene: Scene;
};

export type ScheduleRule = {
  /** 日期字段的api_code */
  dateKey?: Maybe<Scalars['String']['output']>;
  /** 日期偏移动作 */
  dateOffsetAction?: Maybe<DateOffsetAction>;
  /** 日期偏移量 */
  dateOffsetNumber?: Maybe<Scalars['Int']['output']>;
  /** 日期偏移单位 */
  dateOffsetUnit?: Maybe<DateOffsetUnit>;
  /** 小时 */
  hour?: Maybe<Scalars['Int']['output']>;
  /** 分钟 */
  minute?: Maybe<Scalars['Int']['output']>;
};

export type ScheduleRuleAttributes = {
  /** 日期字段的api_code */
  dateKey?: InputMaybe<Scalars['String']['input']>;
  /** 日期偏移动作 */
  dateOffsetAction?: InputMaybe<DateOffsetAction>;
  /** 日期偏移量 */
  dateOffsetNumber?: InputMaybe<Scalars['Int']['input']>;
  /** 日期偏移单位 */
  dateOffsetUnit?: InputMaybe<DateOffsetUnit>;
  /** 小时 */
  hour?: InputMaybe<Scalars['Int']['input']>;
  /** 分钟 */
  minute?: InputMaybe<Scalars['Int']['input']>;
};

export type ScheduleTimeRule = {
  /** 日期字段的api_code */
  dateKey?: Maybe<Scalars['String']['output']>;
  /** 日期偏移动作 */
  dateOffsetAction?: Maybe<DateOffsetAction>;
  /** 日期偏移量 */
  dateOffsetNumber?: Maybe<Scalars['Int']['output']>;
  /** 日期偏移单位 */
  dateOffsetUnit?: Maybe<DateOffsetUnit>;
  /** 小时 */
  hour?: Maybe<Scalars['Int']['output']>;
  /** 分钟 */
  minute?: Maybe<Scalars['Int']['output']>;
  /** 预约项目的code */
  reservationItemKey?: Maybe<Scalars['String']['output']>;
};

export type ScheduleTimeRuleAttributes = {
  /** 日期字段的api_code */
  dateKey?: InputMaybe<Scalars['String']['input']>;
  /** 日期偏移动作 */
  dateOffsetAction?: InputMaybe<DateOffsetAction>;
  /** 日期偏移量 */
  dateOffsetNumber?: InputMaybe<Scalars['Int']['input']>;
  /** 日期偏移单位 */
  dateOffsetUnit?: InputMaybe<DateOffsetUnit>;
  /** 小时 */
  hour?: InputMaybe<Scalars['Int']['input']>;
  /** 分钟 */
  minute?: InputMaybe<Scalars['Int']['input']>;
  /** 预约项目的code */
  reservationItemKey?: InputMaybe<Scalars['String']['input']>;
};

export type ScopeCondition = {
  groupIndex?: Maybe<Scalars['Int']['output']>;
  operator: ScopeConditionOperator;
  scopeAttr?: Maybe<ScopeConditionAttributeEnum>;
  trigger: Scalars['String']['output'];
  triggerField?: Maybe<Field>;
  value?: Maybe<Scalars['Any']['output']>;
  valueChoice?: Maybe<Choice>;
  valueForDisplay?: Maybe<Scalars['Any']['output']>;
};

export enum ScopeConditionAttributeEnum {
  /** 按预约项目筛选 */
  ApiCode = 'api_code',
  /** 按预约时间筛选 */
  DateTime = 'date_time'
}

export type ScopeConditionAttributes = {
  /** 「或」条件的分组 */
  groupIndex?: InputMaybe<Scalars['Int']['input']>;
  /** 操作符 */
  operator: ScopeConditionOperator;
  /** 子属性 */
  scopeAttr?: InputMaybe<ScopeConditionAttributeEnum>;
  /** 触发字段的apiCode */
  trigger: Scalars['String']['input'];
  /** 触发字段的值 */
  value?: InputMaybe<Scalars['Any']['input']>;
};

export enum ScopeConditionOperator {
  And = 'And',
  AnyIn = 'AnyIn',
  Between = 'Between',
  Eq = 'Eq',
  Equal = 'Equal',
  Gt = 'Gt',
  Gte = 'Gte',
  Like = 'Like',
  Lt = 'Lt',
  Lte = 'Lte',
  Match = 'Match',
  Ne = 'Ne',
  NoneIn = 'NoneIn',
  NotBetween = 'NotBetween',
  NotEqual = 'NotEqual',
  NotLike = 'NotLike',
  NotNull = 'NotNull',
  Null = 'Null',
  Or = 'Or'
}

export enum SearchBaseFilesSortMode {
  /** 按照创建时间倒序 */
  CreatedAt = 'created_at',
  /** 按照最后一次数据收集时间倒序 */
  LastEntryCreatedAt = 'last_entry_created_at'
}

export type SearchedBaseFile = Form | FormFolder;

/** The connection type for SearchedBaseFile. */
export type SearchedBaseFileConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SearchedBaseFileEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<SearchedBaseFile>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type SearchedBaseFileEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<SearchedBaseFile>;
};

export type SectionBreak = AssociatedField & BaseField & FieldAbility & PlanAvailableField & {
  apiCode: Scalars['ID']['output'];
  apiCodeAlias?: Maybe<Scalars['String']['output']>;
  /** 对应的表单关联字段 */
  associationField?: Maybe<Field>;
  /** 按钮文字 */
  buttonText?: Maybe<Scalars['String']['output']>;
  /** 自动填写上次提交内容 */
  cacheData: Scalars['Boolean']['output'];
  /** 客户端ID */
  cid?: Maybe<Scalars['String']['output']>;
  /** 封装的字段类型 */
  customizedType?: Maybe<Scalars['String']['output']>;
  /** 封装的字段类型文本 */
  customizedTypeName?: Maybe<Scalars['String']['output']>;
  /** 自定义出错文案 */
  customizedValidationMessage?: Maybe<Scalars['String']['output']>;
  /** 已提交的数据是否可被编辑 */
  editable: Scalars['Boolean']['output'];
  /** 该字段能否使用字段规则: true - 能， false - 不能 */
  fieldRuleAvailable: Scalars['Boolean']['output'];
  /** 是否是关联主键字段 */
  forAssociated?: Maybe<Scalars['Boolean']['output']>;
  /** 是否是关联展示字段 */
  forAssociatedDisplay?: Maybe<Scalars['Boolean']['output']>;
  /** 表单Token */
  formToken: Scalars['String']['output'];
  /** 宽度占用整行的四分之几 */
  gridsToOccupy?: Maybe<Scalars['Int']['output']>;
  hasAbility: Scalars['Boolean']['output'];
  /** 是否显示按钮。true - 不显示，false - 显示，默认不显示 */
  hideButton: Scalars['Boolean']['output'];
  /** 字段标题（去富文本化） */
  label?: Maybe<Scalars['String']['output']>;
  /** 字段描述，富文本 */
  notes?: Maybe<Scalars['String']['output']>;
  paidFeature?: Maybe<PaidFeature>;
  planAvailable: Scalars['Boolean']['output'];
  /** 字段排序 */
  position: Scalars['Int']['output'];
  /** 该字段是否是隐私字段 true - 是, false - 不是 */
  privacy: Scalars['Boolean']['output'];
  /** 字段隐藏 */
  private: Scalars['Boolean']['output'];
  /** 字段是否通过预填写表单预设了值 true - 是, false - 否 */
  pseudoFormPredefined?: Maybe<Scalars['Boolean']['output']>;
  /** 字段标题（富文本化） */
  rawLabel?: Maybe<Scalars['String']['output']>;
  /** 字段是否只读，无法编辑 */
  readonly?: Maybe<Scalars['Boolean']['output']>;
  /** 该字段是否属于评分字段（e.g. 考试、测评中的题目） */
  scorable: Scalars['Boolean']['output'];
  /** 字段提示较长时折叠展示 */
  showPartDescription: Scalars['Boolean']['output'];
  /** 显示分割线 */
  showSplitLine: Scalars['Boolean']['output'];
  /** 新起一行 */
  startNewRow: Scalars['Boolean']['output'];
  /** 该字段是否可以作为文本插入 true - 能, false - 不能 */
  textPlaceholderable: Scalars['Boolean']['output'];
  /** 字段类型 */
  type: FieldClass;
  /** 字段类型文本 */
  typeName: Scalars['String']['output'];
  /** 字段验证规则 */
  validations?: Maybe<Array<FieldValidation>>;
};


export type SectionBreakHasAbilityArgs = {
  key: FieldAbilityEnum;
};


export type SectionBreakNotesArgs = {
  sanitize?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SelectableField = {
  choices: Array<Choice>;
};

/** Autogenerated input type of SendMessage */
export type SendMessageInput = {
  attachmentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  conversationId: Scalars['String']['input'];
};

/** Autogenerated return type of SendMessage */
export type SendMessagePayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  message?: Maybe<Message>;
};

/** 何时发送 */
export enum SendTiming {
  /** 立即发送 */
  Immediately = 'immediately',
  /** 指定时间发送 */
  OnSpecifiedDatetime = 'on_specified_datetime',
  /** 按周期重复发送 */
  Repeated = 'repeated',
  /** 基于数据的定制规则发送 */
  ScheduledWithRule = 'scheduled_with_rule'
}

/** Autogenerated input type of SendYamchaCardMessage */
export type SendYamchaCardMessageInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 表单Token */
  formId: Scalars['ID']['input'];
  /** Yamcha群聊ID */
  yamchaGroupId: Scalars['ID']['input'];
};

/** Autogenerated return type of SendYamchaCardMessage */
export type SendYamchaCardMessagePayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  /** 消息ID */
  messageIds?: Maybe<Array<Scalars['String']['output']>>;
};

export enum SendingTaskNoticeChannel {
  /** 第三方通知（钉钉） */
  GdOpenIntegration = 'gd_open_integration',
  /** 短信通知 */
  Sms = 'sms',
  /** 微信企业通知 */
  WeixinQiye = 'weixin_qiye'
}

export enum SendingTaskNoticeTargetTypeEnum {
  /** 第三方企业部门 */
  GdOpenIntegrationDepartment = 'gd_open_integration_department',
  /** 第三方企业用户 */
  GdOpenIntegrationMember = 'gd_open_integration_member',
  /** 微信企业部门 */
  WeixinQiyeDepartment = 'weixin_qiye_department',
  /** 微信企业用户 */
  WeixinQiyeUser = 'weixin_qiye_user'
}

export enum SendingTaskStatus {
  /** All sent */
  AllSent = 'all_sent',
  /** Approved */
  Approved = 'approved',
  /** Content auditing */
  ContentAuditing = 'content_auditing',
  /** None sent */
  NoneSent = 'none_sent',
  /** Partial sent */
  PartialSent = 'partial_sent',
  /** Pending */
  Pending = 'pending',
  /** Process canceled */
  ProcessCanceled = 'process_canceled',
  /** Process failed */
  ProcessFailed = 'process_failed',
  /** Process success */
  ProcessSuccess = 'process_success',
  /** Processing */
  Processing = 'processing',
  /** Rejected */
  Rejected = 'rejected',
  /** Revoked */
  Revoked = 'revoked',
  /** Sending */
  Sending = 'sending',
  /** Template checking */
  TemplateChecking = 'template_checking',
  /** Template deleted */
  TemplateDeleted = 'template_deleted',
  /** Template fail */
  TemplateFail = 'template_fail',
  /** Waiting for send */
  WaitingForSend = 'waiting_for_send'
}

export type Series = {
  children?: Maybe<Array<Series>>;
  dimensions?: Maybe<Array<Dimension>>;
  metrics?: Maybe<Array<Metric>>;
};

export type SessionFormInviteLink = {
  billingAccount?: Maybe<PublishedBillingAccount>;
  form?: Maybe<PublishedForm>;
  /** 邀请人 */
  inviter?: Maybe<PublishedUser>;
  status: SessionFormInviteLinkStatus;
  /** 企业成员角色 */
  userRole?: Maybe<Scalars['String']['output']>;
};

export enum SessionFormInviteLinkStatus {
  /** 表单不存在 */
  FormNotFound = 'form_not_found',
  /** 当前用户不是表单的企业成员 */
  NotInternalUser = 'not_internal_user',
  /** 邀请名额已满 */
  QuotaFull = 'quota_full',
  /** 角色已被删除 */
  RoleNotFound = 'role_not_found',
  /** 链接有效 */
  Valid = 'valid'
}

export enum SessionKey {
  /** 数据量超出modal框是否关闭 */
  ReservedEntryExceedWarningClosed = 'reserved_entry_exceed_warning_closed',
  /** 数据量用光modal框是否关闭 */
  ReservedEntryOverWarningClosed = 'reserved_entry_over_warning_closed'
}

export type SessionUserInviteLink = {
  inviter?: Maybe<PublishedUser>;
  status: SessionUserInviteLinkStatus;
};

export enum SessionUserInviteLinkStatus {
  /** 链接无效 */
  Invalid = 'invalid',
  /** 邀请名额已满 */
  QuotaFull = 'quota_full',
  /** 链接有效 */
  Valid = 'valid'
}

export type SettingFormCertificateSettingAttributes = {
  /** 提交后按钮文案 */
  btnContent?: InputMaybe<Scalars['String']['input']>;
  /** 多证书列表 */
  certificates?: InputMaybe<Array<CertificateAttributes>>;
  /** 证书名称 */
  displayLabel?: InputMaybe<Scalars['String']['input']>;
  /** 证书开关 */
  enabled: Scalars['Boolean']['input'];
  /** 生成方式 */
  generateWay?: InputMaybe<CertificateGenerateWay>;
};

export enum SettingStep {
  CashSetting = 'cash_setting',
  LotterySetting = 'lottery_setting',
  PrizeSetting = 'prize_setting',
  TextSetting = 'text_setting'
}

export type ShareAndMarkProperties = {
  colorMark?: Maybe<Scalars['String']['output']>;
  remark?: Maybe<Scalars['String']['output']>;
  shareLink?: Maybe<Scalars['String']['output']>;
  shareToken?: Maybe<Scalars['String']['output']>;
};

export type Signature = {
  /** 创建时间 */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** 审核失败原因 */
  failedReason?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** 签名 */
  signature: Scalars['String']['output'];
  /** 签名审核状态 */
  signatureStatus?: Maybe<SignatureStatus>;
  /** 签名类型 */
  type?: Maybe<SignatureType>;
};

export enum SignatureStatus {
  /** Checking */
  Checking = 'CHECKING',
  /** Fail */
  Fail = 'FAIL',
  /** Success */
  Success = 'SUCCESS'
}

export enum SignatureType {
  /** 螺丝帽签名 */
  Luosimao = 'luosimao',
  /** 云片签名 */
  Yunpian = 'yunpian'
}

export type SimpleUserSystemNotificationActivity = {
  content: Scalars['String']['output'];
};

export type SingleEntryShare = {
  enabled: Scalars['Boolean']['output'];
  hiddenFieldApiCodes?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['ID']['output'];
  privacyProtectedFieldApiCodes?: Maybe<Array<Scalars['String']['output']>>;
};

export type SingleEntryShareAttributes = {
  /** 是否启用单条数据分享 */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** 在分享中隐藏的字段 API codes */
  hiddenFieldApiCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** 需要保护隐私的字段 API codes */
  privacyProtectedFieldApiCodes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SortColumnAttributes = {
  /** 用于排序的列 */
  apiCode: Scalars['String']['input'];
  /** asc: 升序, desc: 降序 */
  order: SortDirection;
};

export type SortColumnType = {
  /** 用于排序的列 apiCode */
  apiCode: Scalars['String']['output'];
  /** asc: 升序, desc: 降序 */
  order: SortDirection;
};

export enum SortDirection {
  Asc = 'asc',
  Desc = 'desc'
}

export type SortField = AssociatedField & BaseField & FieldAbility & LengthValidatableField & PlanAvailableField & SelectableField & {
  apiCode: Scalars['ID']['output'];
  apiCodeAlias?: Maybe<Scalars['String']['output']>;
  /** 对应的表单关联字段 */
  associationField?: Maybe<Field>;
  /** 自动填写上次提交内容 */
  cacheData: Scalars['Boolean']['output'];
  choices: Array<Choice>;
  /** 客户端ID */
  cid?: Maybe<Scalars['String']['output']>;
  /** 封装的字段类型 */
  customizedType?: Maybe<Scalars['String']['output']>;
  /** 封装的字段类型文本 */
  customizedTypeName?: Maybe<Scalars['String']['output']>;
  /** 自定义出错文案 */
  customizedValidationMessage?: Maybe<Scalars['String']['output']>;
  /** 已提交的数据是否可被编辑 */
  editable: Scalars['Boolean']['output'];
  /** 该字段能否使用字段规则: true - 能， false - 不能 */
  fieldRuleAvailable: Scalars['Boolean']['output'];
  /** 是否是关联主键字段 */
  forAssociated?: Maybe<Scalars['Boolean']['output']>;
  /** 是否是关联展示字段 */
  forAssociatedDisplay?: Maybe<Scalars['Boolean']['output']>;
  /** 表单Token */
  formToken: Scalars['String']['output'];
  /** 宽度占用整行的四分之几 */
  gridsToOccupy?: Maybe<Scalars['Int']['output']>;
  hasAbility: Scalars['Boolean']['output'];
  /** 字段标题（去富文本化） */
  label?: Maybe<Scalars['String']['output']>;
  maximumLength?: Maybe<Scalars['BigInteger']['output']>;
  minimumLength?: Maybe<Scalars['BigInteger']['output']>;
  /** 字段描述，富文本 */
  notes?: Maybe<Scalars['String']['output']>;
  paidFeature?: Maybe<PaidFeature>;
  planAvailable: Scalars['Boolean']['output'];
  /** 字段排序 */
  position: Scalars['Int']['output'];
  /** 该字段是否是隐私字段 true - 是, false - 不是 */
  privacy: Scalars['Boolean']['output'];
  /** 字段隐藏 */
  private: Scalars['Boolean']['output'];
  /** 字段是否通过预填写表单预设了值 true - 是, false - 否 */
  pseudoFormPredefined?: Maybe<Scalars['Boolean']['output']>;
  /** 选项展示顺序随机 */
  randomChoices: Scalars['Boolean']['output'];
  /** 字段标题（富文本化） */
  rawLabel?: Maybe<Scalars['String']['output']>;
  /** 字段是否只读，无法编辑 */
  readonly?: Maybe<Scalars['Boolean']['output']>;
  /** 该字段是否属于评分字段（e.g. 考试、测评中的题目） */
  scorable: Scalars['Boolean']['output'];
  /** 字段提示较长时折叠展示 */
  showPartDescription: Scalars['Boolean']['output'];
  /** 新起一行 */
  startNewRow: Scalars['Boolean']['output'];
  /** 该字段是否可以作为文本插入 true - 能, false - 不能 */
  textPlaceholderable: Scalars['Boolean']['output'];
  /** 字段类型 */
  type: FieldClass;
  /** 字段类型文本 */
  typeName: Scalars['String']['output'];
  /** 字段验证规则 */
  validations?: Maybe<Array<FieldValidation>>;
};


export type SortFieldHasAbilityArgs = {
  key: FieldAbilityEnum;
};


export type SortFieldNotesArgs = {
  sanitize?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated input type of SortUserBaseFileTag */
export type SortUserBaseFileTagInput = {
  /** 标签更新属性列表 */
  attributes: Array<BaseFileTagAttributes>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of SortUserBaseFileTag */
export type SortUserBaseFileTagPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
};

export type SpecialTimeRangeQuota = {
  price?: Maybe<Scalars['Float']['output']>;
  quota: Scalars['Int']['output'];
  specialDates: Array<Scalars['ISO8601DateTime']['output']>;
};

export type SpecialTimeRangeQuotaAttributes = {
  /** 单价 */
  price?: InputMaybe<Scalars['Float']['input']>;
  /** 时段配额 */
  quota: Scalars['BigInteger']['input'];
  /** 配置的日期 */
  specialDates: Array<Scalars['ISO8601Date']['input']>;
};

export type Statement = {
  apiCode: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  position: Scalars['Int']['output'];
};

export type StatementAttributes = {
  apiCode?: InputMaybe<Scalars['ID']['input']>;
  label: Scalars['String']['input'];
  position: Scalars['Int']['input'];
};

export type StatementChoiceQuota = QuotableChoice & {
  choiceApiCode: Scalars['ID']['output'];
  /** 剩余名额 */
  quota?: Maybe<Scalars['BigInteger']['output']>;
  /** 名额设置 */
  quotaSetting?: Maybe<Scalars['BigInteger']['output']>;
  statementApiCode: Scalars['ID']['output'];
};

export type StatementChoiceQuotaAttributes = {
  choiceApiCode: Scalars['ID']['input'];
  /** 剩余名额 */
  quota?: InputMaybe<Scalars['BigInteger']['input']>;
  /** 名额设置 */
  quotaSetting?: InputMaybe<Scalars['BigInteger']['input']>;
  statementApiCode: Scalars['ID']['input'];
};

export enum Status {
  /** 短信内容审核中 */
  Auditing = 'auditing',
  /** 任务取消 */
  Cancelled = 'cancelled',
  /** 失败 */
  Failed = 'failed',
  /** 审核未通过 */
  Rejected = 'rejected',
  /** 预定发送中 */
  Scheduled = 'scheduled',
  /** 成功 */
  Successful = 'successful',
  /** 等待发送 */
  Waiting = 'waiting'
}

export type StorageConfig = {
  provider?: Maybe<Scalars['String']['output']>;
  storage: Scalars['String']['output'];
};

export type StyledText = AssociatedField & BaseField & FieldAbility & PlanAvailableField & {
  apiCode: Scalars['ID']['output'];
  apiCodeAlias?: Maybe<Scalars['String']['output']>;
  /** 对应的表单关联字段 */
  associationField?: Maybe<Field>;
  /** 自动填写上次提交内容 */
  cacheData: Scalars['Boolean']['output'];
  /** 客户端ID */
  cid?: Maybe<Scalars['String']['output']>;
  /** 封装的字段类型 */
  customizedType?: Maybe<Scalars['String']['output']>;
  /** 封装的字段类型文本 */
  customizedTypeName?: Maybe<Scalars['String']['output']>;
  /** 自定义出错文案 */
  customizedValidationMessage?: Maybe<Scalars['String']['output']>;
  /** 已提交的数据是否可被编辑 */
  editable: Scalars['Boolean']['output'];
  /** 该字段能否使用字段规则: true - 能， false - 不能 */
  fieldRuleAvailable: Scalars['Boolean']['output'];
  /** 展示字段中，图文介绍、图片展示、轮播图、倒计时的样式 */
  fieldStyle?: Maybe<DisplayFieldsFieldStyleType>;
  /** 是否是关联主键字段 */
  forAssociated?: Maybe<Scalars['Boolean']['output']>;
  /** 是否是关联展示字段 */
  forAssociatedDisplay?: Maybe<Scalars['Boolean']['output']>;
  /** 表单Token */
  formToken: Scalars['String']['output'];
  /** 宽度占用整行的四分之几 */
  gridsToOccupy?: Maybe<Scalars['Int']['output']>;
  hasAbility: Scalars['Boolean']['output'];
  /** 字段标题（去富文本化） */
  label?: Maybe<Scalars['String']['output']>;
  /** 展示字段中，图文介绍、图片展示、轮播图、倒计时的布局 */
  layout?: Maybe<DisplayFieldLayout>;
  /** 字段描述，富文本 */
  notes?: Maybe<Scalars['String']['output']>;
  paidFeature?: Maybe<PaidFeature>;
  planAvailable: Scalars['Boolean']['output'];
  /** 字段排序 */
  position: Scalars['Int']['output'];
  /** 该字段是否是隐私字段 true - 是, false - 不是 */
  privacy: Scalars['Boolean']['output'];
  /** 字段隐藏 */
  private: Scalars['Boolean']['output'];
  /** 字段是否通过预填写表单预设了值 true - 是, false - 否 */
  pseudoFormPredefined?: Maybe<Scalars['Boolean']['output']>;
  /** 字段标题（富文本化） */
  rawLabel?: Maybe<Scalars['String']['output']>;
  /** 字段是否只读，无法编辑 */
  readonly?: Maybe<Scalars['Boolean']['output']>;
  /** 该字段是否属于评分字段（e.g. 考试、测评中的题目） */
  scorable: Scalars['Boolean']['output'];
  /** 字段提示较长时折叠展示 */
  showPartDescription: Scalars['Boolean']['output'];
  /** 新起一行 */
  startNewRow: Scalars['Boolean']['output'];
  /** 文字描述组件 */
  styledTextItems?: Maybe<Array<DisplayFieldsStyledTextItemType>>;
  /** 文字描述-组件数量 */
  styledTextItemsCount: Scalars['Int']['output'];
  /** 该字段是否可以作为文本插入 true - 能, false - 不能 */
  textPlaceholderable: Scalars['Boolean']['output'];
  /** 字段类型 */
  type: FieldClass;
  /** 字段类型文本 */
  typeName: Scalars['String']['output'];
  /** 字段验证规则 */
  validations?: Maybe<Array<FieldValidation>>;
};


export type StyledTextHasAbilityArgs = {
  key: FieldAbilityEnum;
};


export type StyledTextNotesArgs = {
  sanitize?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Subject = {
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export enum SubmitButtonAlignment {
  Center = 'center',
  Left = 'left',
  Right = 'right'
}

export type SubmitterBulletinCoverAttributes = {
  /** 自定义图片 */
  customizedCoverId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** true: 使用自定义图片，false: 使用系统图片 */
  isCustomizedCoverSelected?: InputMaybe<Scalars['Boolean']['input']>;
  /** 系统自定义图片名称 */
  predefinedCoverName?: InputMaybe<Scalars['String']['input']>;
};

export type SubmitterConditionalScopeAttributes = {
  /** 设置数据范围 */
  conditionalScope?: InputMaybe<Scalars['Boolean']['input']>;
  /** 数据条件 */
  scopeConditions?: InputMaybe<Array<ScopeConditionAttributes>>;
  /** 仅限指定人群可浏览-浏览人群id */
  submitterGroupId?: InputMaybe<Scalars['String']['input']>;
};

export enum SubmitterFieldAsSubmitterInfoEnum {
  /** Avatar */
  Avatar = 'avatar',
  /** Department */
  Department = 'department',
  /** Identity */
  Identity = 'identity',
  /** Nick name */
  NickName = 'nick_name'
}

export type SubmitterFieldAttributes = {
  actAsIdentity?: InputMaybe<Scalars['Boolean']['input']>;
  actAsSubmitterInfo?: InputMaybe<SubmitterFieldAsSubmitterInfoEnum>;
  apiCode: Scalars['String']['input'];
};

export type SubmitterFieldSettingAttributes = {
  actAsDualAuth?: InputMaybe<Scalars['Boolean']['input']>;
  actAsIdentity?: InputMaybe<Scalars['Boolean']['input']>;
  actAsSubmitterInfo?: InputMaybe<SubmitterFieldAsSubmitterInfoEnum>;
  dualAuthPosition?: InputMaybe<Scalars['Int']['input']>;
};

export type SubmitterFillableForm = {
  form: Form;
  /** 当前submitter对于该表单的最近一条记录填写时间 */
  lastEntryFilledAt: Scalars['ISO8601DateTime']['output'];
  /** 当前submitter对于该表单的最近一条记录 */
  lastFilledEntry?: Maybe<Entry>;
  /** 当前submitter对于该表单的填写总数 */
  totalEntriesCount: Scalars['Int']['output'];
};

/** The connection type for SubmitterFillableForm. */
export type SubmitterFillableFormConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SubmitterFillableFormEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<SubmitterFillableForm>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type SubmitterFillableFormEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<SubmitterFillableForm>;
};

export type SubmitterFilterAttributes = {
  /** 删除现有过滤条件 */
  _destroy?: InputMaybe<Scalars['Boolean']['input']>;
  /** 设置数据范围 */
  conditionalScope?: InputMaybe<Scalars['Boolean']['input']>;
  /** 周期 */
  period?: InputMaybe<Period>;
  /** 数据条件 */
  scopeConditions?: InputMaybe<Array<ScopeConditionAttributes>>;
  /** 企业微信部门ID */
  xFieldWeixinQiyeDepartmentIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** 微信企业userid */
  xFieldWeixinQiyeUserid?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SubmitterGroupAttributes = {
  /** Portal 的登录方式 */
  authTypes: Array<GroupAuthTypesEnum>;
  /** 用于双字段登录的字段 */
  dualAuthApiCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** 要创建的客户信息表单 */
  formAttributes?: InputMaybe<FormAttributes>;
  /** 分组设置 */
  groupSetting?: InputMaybe<SubmitterGroupSettingAttributes>;
  /** 填表人群组名称 */
  name: Scalars['String']['input'];
  /** Portal信息 */
  portal?: InputMaybe<SubmitterPortalAttributes>;
  /** 要导入的字段 */
  selectedFormFields?: InputMaybe<Array<SubmitterFieldAttributes>>;
  /** 要导入数据的表单 */
  selectedFormToken?: InputMaybe<Scalars['ID']['input']>;
};

export type SubmitterGroupSettingAttributes = {
  /** 标记样式 */
  markStyle?: InputMaybe<SubmitterStyleAttributes>;
};

export type SubmitterNavigationItemAttributes = {
  /** 公告列表 */
  bulletinsAttributes?: InputMaybe<Array<BulletinAttributes>>;
  /** 为 true 则删除 */
  destroy?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** 标题 */
  name: Scalars['String']['input'];
  /** 顺序 */
  position: Scalars['Int']['input'];
  /** 导航类型 */
  type: NavigationItemTypeEnum;
  /** 分组 */
  widgetGroupsAttributes?: InputMaybe<Array<SubmitterWidgetGroupAttributes>>;
};

export type SubmitterNotification = BaseNotification & {
  /** 推送类型 */
  approach: Approach;
  cachedFormName: Scalars['String']['output'];
  /** 推送/短信/邮件内容 */
  content?: Maybe<Scalars['String']['output']>;
  entry?: Maybe<Entry>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  form?: Maybe<Form>;
  id: Scalars['ID']['output'];
  messageCount: Scalars['Int']['output'];
  /** 发送时间（不等于任务触发时间） */
  performedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** 收件人，常用于短信和邮件 */
  recipient?: Maybe<Scalars['String']['output']>;
  status: SubmitterSendingStatus;
};

/** The connection type for SubmitterNotification. */
export type SubmitterNotificationConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SubmitterNotificationEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<SubmitterNotification>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type SubmitterNotificationEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<SubmitterNotification>;
};

export type SubmitterPortalAttributes = {
  /** 背景图 */
  backgroundImageAttributes?: InputMaybe<ImageItemAttributes>;
  /** 描述 */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionStyle?: InputMaybe<SubmitterStyleAttributes>;
  /** 焦点图 */
  focusImageAttributes?: InputMaybe<ImageItemAttributes>;
  identityType?: InputMaybe<PortalIdentityTypeEnum>;
  /** 品牌logo */
  logoAttachmentId?: InputMaybe<Scalars['String']['input']>;
  /** 标题 */
  name?: InputMaybe<Scalars['String']['input']>;
  nameStyle?: InputMaybe<SubmitterStyleAttributes>;
  navigationItemsAttributes?: InputMaybe<Array<SubmitterNavigationItemAttributes>>;
  selectedIdentityFields?: InputMaybe<Array<SubmitterFieldAttributes>>;
  /** 是否允许新客户注册 */
  submitterRegistrable?: InputMaybe<Scalars['Boolean']['input']>;
  /** 新客户注册文案 */
  submitterRegistrationText?: InputMaybe<Scalars['String']['input']>;
  /** 未注册客户自定义提示文案 */
  submitterUnregisteredText?: InputMaybe<Scalars['String']['input']>;
  /** 是否自定义提示文案 */
  submitterUnregisteredTextCustomizable?: InputMaybe<Scalars['Boolean']['input']>;
  urlDomainType?: InputMaybe<PortalUrlDomainTypeEnum>;
};

export type SubmitterPortalSessionAttributes = {
  /** 账号：手机号、邮箱、自定义文本字段 */
  authKey: Scalars['String']['input'];
  /** 双字段登录匹配到多个Submitter时，用于区分所选择的Submitter */
  pickedSubmitterToken?: InputMaybe<Scalars['String']['input']>;
  /** 1.portal手机认证：手机验证码（ps.国际/港澳台手机认证可不传）；2.portal双字段：自定义文本字段 */
  verificationToken?: InputMaybe<Scalars['String']['input']>;
};

export type SubmitterRedirectionAttributes = {
  /** 跳转链接 */
  redirectUrl: Scalars['String']['input'];
  /** 跳转链接的签名 */
  sign: Scalars['String']['input'];
  /** 跳转链接状态标识，例如published_form */
  state?: InputMaybe<Scalars['String']['input']>;
};

export type SubmitterResponseRate = {
  filledCount: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
  visibleSubmitters: FormSubmitterConnection;
};


export type SubmitterResponseRateVisibleSubmittersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SubmitterRuleAttributes = {
  /** 设置数据范围 */
  conditionalScope?: InputMaybe<Scalars['Boolean']['input']>;
  /** 自定义提示文案内容 */
  customerTip?: InputMaybe<Scalars['String']['input']>;
  /** 删除现有过滤条件 */
  destroy?: InputMaybe<Scalars['Boolean']['input']>;
  /** 数据条件 */
  scopeConditions?: InputMaybe<Array<ScopeConditionAttributes>>;
  /** 是否自定义提示文案 */
  showCustomerTip?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum SubmitterSendingStatus {
  /** Failed */
  Failed = 'failed',
  /** Success */
  Success = 'success'
}

export type SubmitterSetting = WithConditionalScope & {
  conditionalScope: Scalars['Boolean']['output'];
  scopeConditions?: Maybe<Array<ScopeCondition>>;
  submitterGroup?: Maybe<SubmitterGroup>;
};

export type SubmitterStyleAttributes = {
  /** 字体颜色 */
  color?: InputMaybe<Scalars['String']['input']>;
};

export type SubmitterWidgetAttributes = {
  /** 设置数据范围 */
  conditionalScope?: InputMaybe<Scalars['Boolean']['input']>;
  /** 为 true 则删除 */
  destroy?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** 标题 */
  name: Scalars['String']['input'];
  /** 顺序 */
  position: Scalars['Int']['input'];
  /** 数据条件 */
  scopeConditions?: InputMaybe<Array<ScopeConditionAttributes>>;
  /** 状态 */
  status?: InputMaybe<WidgetStatusEnum>;
  /** 目标类型ID */
  targetId: Scalars['ID']['input'];
  /** 目标类型 */
  targetType: WidgetTargetTypeEnum;
  /** 缩略图 */
  thumbnailAttributes?: InputMaybe<SubmitterWidgetThumbnailAttributes>;
};

export type SubmitterWidgetGroupAttributes = {
  /** 为 true 则删除 */
  destroy?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** 标题 */
  name: Scalars['String']['input'];
  /** 顺序 */
  position: Scalars['Int']['input'];
  /** Widget */
  widgetsAttributes: Array<SubmitterWidgetAttributes>;
};

export type SubmitterWidgetThumbnailAttributes = {
  /** 自定义图标 */
  customizedThumbnailId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** true: 使用自定义图标，false: 使用系统图标 */
  isCustomizedThumbnailSelected?: InputMaybe<Scalars['Boolean']['input']>;
  /** 系统自定义图标名称 */
  predefinedThumbnailName?: InputMaybe<Scalars['String']['input']>;
};

export type Subname = {
  /** 站内表单名 */
  subname?: Maybe<Scalars['String']['output']>;
};

/** 套餐的外部订阅渠道。null 表示标准支付渠道（Pingpp/余额）。 */
export enum SubscriptionSource {
  /** Apple 内购订阅 */
  Apple = 'apple',
  /** 微信虚拟支付（iOS 小程序） */
  WeixinVirtual = 'weixin_virtual'
}

export enum SuccessMessageStyle {
  /** Certificate */
  Certificate = 'certificate',
  /** Distribution poster */
  DistributionPoster = 'distribution_poster',
  /** Rich text */
  RichText = 'rich_text',
  /** Text */
  Text = 'text'
}

export type SummaryMessagePart = {
  /** 摘要内容 */
  content?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
};

/** Autogenerated input type of SwitchDataTables */
export type SwitchDataTablesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** opt out 时必填；自由文本，后端不做格式校验 */
  reason?: InputMaybe<Scalars['String']['input']>;
  /** true=opt in 新版，false=opt out 返回旧版 */
  toNew: Scalars['Boolean']['input'];
};

/** Autogenerated return type of SwitchDataTables */
export type SwitchDataTablesPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  extrainfo?: Maybe<Extrainfo>;
};

export type SystemIncident = {
  actions?: Maybe<SystemIncidentActionConnection>;
  endAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  incidentCities?: Maybe<Array<Scalars['String']['output']>>;
  incidentDomain?: Maybe<Scalars['String']['output']>;
  incidentLevel?: Maybe<IncidentLevel>;
  startAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};


export type SystemIncidentActionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SystemIncidentAction = {
  id: Scalars['ID']['output'];
  incidentId: Scalars['String']['output'];
  internalDescription?: Maybe<Scalars['String']['output']>;
  performedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type SystemIncidentActionAttributes = {
  /** 内部描述 */
  internalDescription: Scalars['String']['input'];
  /** 操作时间 */
  performedAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
};

/** The connection type for SystemIncidentAction. */
export type SystemIncidentActionConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SystemIncidentActionEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<SystemIncidentAction>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type SystemIncidentActionEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<SystemIncidentAction>;
};

/** The connection type for SystemIncident. */
export type SystemIncidentConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SystemIncidentEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<SystemIncident>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type SystemIncidentEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<SystemIncident>;
};

export enum SystemWarningLevel {
  Critical = 'critical',
  Info = 'info',
  Warning = 'warning'
}

export type SystemWarningType = {
  formInfo: FormActivityBaseInfo;
  /** 已欠费 */
  overdue?: Maybe<Scalars['Boolean']['output']>;
  /** 提示内容 */
  warningContent?: Maybe<Scalars['String']['output']>;
  /** 提示类型 */
  warningLevel?: Maybe<SystemWarningLevel>;
  /** 提示类型 */
  warningType?: Maybe<Scalars['String']['output']>;
};

export type TableField = AssociatedField & BaseField & DimensionedField & FieldAbility & LengthValidatableField & PlanAvailableField & {
  apiCode: Scalars['ID']['output'];
  apiCodeAlias?: Maybe<Scalars['String']['output']>;
  /** 对应的表单关联字段 */
  associationField?: Maybe<Field>;
  /** 自动填写上次提交内容 */
  cacheData: Scalars['Boolean']['output'];
  /** 客户端ID */
  cid?: Maybe<Scalars['String']['output']>;
  /** 封装的字段类型 */
  customizedType?: Maybe<Scalars['String']['output']>;
  /** 封装的字段类型文本 */
  customizedTypeName?: Maybe<Scalars['String']['output']>;
  /** 自定义出错文案 */
  customizedValidationMessage?: Maybe<Scalars['String']['output']>;
  dimensions: Array<Field>;
  /** 已提交的数据是否可被编辑 */
  editable: Scalars['Boolean']['output'];
  /** 该字段能否使用字段规则: true - 能， false - 不能 */
  fieldRuleAvailable: Scalars['Boolean']['output'];
  /** 是否是关联主键字段 */
  forAssociated?: Maybe<Scalars['Boolean']['output']>;
  /** 是否是关联展示字段 */
  forAssociatedDisplay?: Maybe<Scalars['Boolean']['output']>;
  /** 表单Token */
  formToken: Scalars['String']['output'];
  /** 宽度占用整行的四分之几 */
  gridsToOccupy?: Maybe<Scalars['Int']['output']>;
  hasAbility: Scalars['Boolean']['output'];
  /** 在手机上横向展示 */
  horizontalOnMobile?: Maybe<Scalars['Boolean']['output']>;
  /** 默认行数 */
  initRowLength: Scalars['Int']['output'];
  /** 字段标题（去富文本化） */
  label?: Maybe<Scalars['String']['output']>;
  maximumLength?: Maybe<Scalars['BigInteger']['output']>;
  minimumLength?: Maybe<Scalars['BigInteger']['output']>;
  /** 字段描述，富文本 */
  notes?: Maybe<Scalars['String']['output']>;
  paidFeature?: Maybe<PaidFeature>;
  planAvailable: Scalars['Boolean']['output'];
  /** 字段排序 */
  position: Scalars['Int']['output'];
  /** 该字段是否是隐私字段 true - 是, false - 不是 */
  privacy: Scalars['Boolean']['output'];
  /** 字段隐藏 */
  private: Scalars['Boolean']['output'];
  /** 字段是否通过预填写表单预设了值 true - 是, false - 否 */
  pseudoFormPredefined?: Maybe<Scalars['Boolean']['output']>;
  /** 字段标题（富文本化） */
  rawLabel?: Maybe<Scalars['String']['output']>;
  /** 字段是否只读，无法编辑 */
  readonly?: Maybe<Scalars['Boolean']['output']>;
  /** 该字段是否属于评分字段（e.g. 考试、测评中的题目） */
  scorable: Scalars['Boolean']['output'];
  /** 字段提示较长时折叠展示 */
  showPartDescription: Scalars['Boolean']['output'];
  /** 新起一行 */
  startNewRow: Scalars['Boolean']['output'];
  /** 该字段是否可以作为文本插入 true - 能, false - 不能 */
  textPlaceholderable: Scalars['Boolean']['output'];
  /** 字段类型 */
  type: FieldClass;
  /** 字段类型文本 */
  typeName: Scalars['String']['output'];
  /** 字段验证规则 */
  validations?: Maybe<Array<FieldValidation>>;
};


export type TableFieldHasAbilityArgs = {
  key: FieldAbilityEnum;
};


export type TableFieldNotesArgs = {
  sanitize?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TabularDimensionAttributes = {
  /** 字段apiCode，新字段不传或传null */
  apiCode?: InputMaybe<Scalars['ID']['input']>;
  /** 显示年龄 */
  asAge?: InputMaybe<Scalars['Boolean']['input']>;
  /** 自动填写上次提交内容 */
  cacheData?: InputMaybe<Scalars['Boolean']['input']>;
  /** 开启选项赋值 */
  calculable?: InputMaybe<Scalars['Boolean']['input']>;
  /** 选项列表 */
  choices?: InputMaybe<Array<FieldChoiceAttributes>>;
  /** 封装的字段类型 */
  customizedType?: InputMaybe<Scalars['String']['input']>;
  /** 项目列计算的操作符，当字段为矩阵填空和表格的项目时有用 */
  dimensionOperator?: InputMaybe<DimensionOperator>;
  /** 开启年龄限制 */
  enableAgeScope?: InputMaybe<Scalars['Boolean']['input']>;
  /** 开启项目列计算，当字段为矩阵填空和表格的项目时有用 */
  enableDimensionCalculation?: InputMaybe<Scalars['Boolean']['input']>;
  /** 结束日期 */
  endDate?: InputMaybe<Scalars['Any']['input']>;
  /** 场景化可配置其他设置 */
  extraConfigurableSettings?: InputMaybe<ExtraConfigurableSettingAttributes>;
  /** 以字段标题为变量的公式 */
  formulaDisplay?: InputMaybe<Scalars['String']['input']>;
  /** 精确到秒 */
  includeSecond?: InputMaybe<Scalars['Boolean']['input']>;
  /** 字段标题 */
  label: Scalars['String']['input'];
  /** 下拉框级数 */
  levels?: InputMaybe<Scalars['Int']['input']>;
  /** 展示样式，单选或者多选 */
  likertChoiceStyle?: InputMaybe<LikertChoiceStyle>;
  /** 最大年龄限制 */
  maxAge?: InputMaybe<Scalars['Int']['input']>;
  /** 最大时长, 分钟 */
  maxDuration?: InputMaybe<Scalars['Int']['input']>;
  /** 最大文件数量 */
  maxFileQuantity?: InputMaybe<Scalars['Int']['input']>;
  /** 单个文件最大体积, MB */
  maxSize?: InputMaybe<Scalars['Float']['input']>;
  /** 最多填几个字 */
  maximumLength?: InputMaybe<Scalars['BigInteger']['input']>;
  /** 最高分文案 */
  maximumRatingsDisplayText?: InputMaybe<Scalars['String']['input']>;
  /** 文件上传类型 */
  mediaType?: InputMaybe<AttachmentFieldMediaTypeAttributes>;
  /** 由下拉框变化而来 */
  migratedFromDropDown?: InputMaybe<Scalars['Boolean']['input']>;
  /** 最小年龄限制 */
  minAge?: InputMaybe<Scalars['Int']['input']>;
  /** 最少填几个字 */
  minimumLength?: InputMaybe<Scalars['BigInteger']['input']>;
  /** 最低分文案 */
  minimumRatingsDisplayText?: InputMaybe<Scalars['String']['input']>;
  /** 仅限手机拍照或现场视频上传 */
  mobileCameraOnly?: InputMaybe<Scalars['Boolean']['input']>;
  /** 占位符 */
  placeholder?: InputMaybe<Scalars['String']['input']>;
  /** 字段排序标识 */
  position: Scalars['Int']['input'];
  /** 日期精度 */
  precision?: InputMaybe<DateTimePrecision>;
  /** 默认值 */
  predefinedValue?: InputMaybe<Scalars['Any']['input']>;
  /** 展示样式，列表排列或下拉框排列 */
  presentationStyle?: InputMaybe<CheckBoxPresentationStyle>;
  /** 字段隐藏 */
  private?: InputMaybe<Scalars['Boolean']['input']>;
  /** 自定义选择默认文案 */
  prompt?: InputMaybe<Scalars['String']['input']>;
  /** 自定义选择默认文案 */
  prompts?: InputMaybe<Scalars['JSON']['input']>;
  /** 最大值 */
  rangeMax?: InputMaybe<Scalars['Float']['input']>;
  /** 最小值 */
  rangeMin?: InputMaybe<Scalars['Float']['input']>;
  /** 评分量级 */
  ratingMax?: InputMaybe<Scalars['Int']['input']>;
  /** 评分外观 */
  ratingType?: InputMaybe<RatingTypeAttribute>;
  resultDisplayAsDate?: InputMaybe<Scalars['Boolean']['input']>;
  /** 起始日期 */
  startDate?: InputMaybe<Scalars['Any']['input']>;
  /** 作为矩阵填空的项目，存储每个题目的默认值 */
  statementPredefinedValues?: InputMaybe<FieldStatementPredefinedValuesAttributes>;
  /** 项目类型 */
  type: TabularDimensionClass;
  /** 验证规则，非必须。服务端会根据 dimension 属性自动重新计算赋值。 */
  validations?: InputMaybe<Array<FieldValidation>>;
};

export enum TabularDimensionClass {
  AttachmentField = 'AttachmentField',
  CascadeDropDown = 'CascadeDropDown',
  CheckBox = 'CheckBox',
  DateTimeField = 'DateTimeField',
  DropDown = 'DropDown',
  EmailField = 'EmailField',
  FormulaField = 'FormulaField',
  IdCardField = 'IdCardField',
  MobileField = 'MobileField',
  NumberField = 'NumberField',
  RatingField = 'RatingField',
  TextArea = 'TextArea',
  TextField = 'TextField',
  TimeField = 'TimeField'
}

export type TagAttributes = {
  id?: InputMaybe<Scalars['ID']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of TakeoverConversation */
export type TakeoverConversationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 要接管的 AgentInquiryConversation Id */
  conversationId: Scalars['String']['input'];
};

/** Autogenerated return type of TakeoverConversation */
export type TakeoverConversationPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  conversation?: Maybe<Conversation>;
  errors?: Maybe<Array<Error>>;
};

export enum TargetClientEnum {
  /** 4.0 PC */
  LegacyPc = 'legacy_pc',
  /** Next PC */
  NextPc = 'next_pc'
}

export enum TaskActivityStatusEnum {
  All = 'ALL',
  Failed = 'FAILED',
  Success = 'SUCCESS'
}

export type TelephoneField = AssociatedField & BaseField & FieldAbility & PlanAvailableField & PredefineableField & {
  apiCode: Scalars['ID']['output'];
  apiCodeAlias?: Maybe<Scalars['String']['output']>;
  /** 对应的表单关联字段 */
  associationField?: Maybe<Field>;
  /** 自动填写上次提交内容 */
  cacheData: Scalars['Boolean']['output'];
  /** 客户端ID */
  cid?: Maybe<Scalars['String']['output']>;
  /** 封装的字段类型 */
  customizedType?: Maybe<Scalars['String']['output']>;
  /** 封装的字段类型文本 */
  customizedTypeName?: Maybe<Scalars['String']['output']>;
  /** 自定义出错文案 */
  customizedValidationMessage?: Maybe<Scalars['String']['output']>;
  /** 已提交的数据是否可被编辑 */
  editable: Scalars['Boolean']['output'];
  /** 该字段能否使用字段规则: true - 能， false - 不能 */
  fieldRuleAvailable: Scalars['Boolean']['output'];
  /** 是否是关联主键字段 */
  forAssociated?: Maybe<Scalars['Boolean']['output']>;
  /** 是否是关联展示字段 */
  forAssociatedDisplay?: Maybe<Scalars['Boolean']['output']>;
  /** 表单Token */
  formToken: Scalars['String']['output'];
  /** 宽度占用整行的四分之几 */
  gridsToOccupy?: Maybe<Scalars['Int']['output']>;
  hasAbility: Scalars['Boolean']['output'];
  /** 字段标题（去富文本化） */
  label?: Maybe<Scalars['String']['output']>;
  /** 字段描述，富文本 */
  notes?: Maybe<Scalars['String']['output']>;
  paidFeature?: Maybe<PaidFeature>;
  /** 占位符 */
  placeholder?: Maybe<Scalars['String']['output']>;
  planAvailable: Scalars['Boolean']['output'];
  /** 字段排序 */
  position: Scalars['Int']['output'];
  /** 预填写表单 */
  predefined: Scalars['Boolean']['output'];
  /** 默认值 */
  predefinedValue?: Maybe<Scalars['String']['output']>;
  /** 该字段是否是隐私字段 true - 是, false - 不是 */
  privacy: Scalars['Boolean']['output'];
  /** 字段隐藏 */
  private: Scalars['Boolean']['output'];
  /** 字段是否通过预填写表单预设了值 true - 是, false - 否 */
  pseudoFormPredefined?: Maybe<Scalars['Boolean']['output']>;
  /** 字段标题（富文本化） */
  rawLabel?: Maybe<Scalars['String']['output']>;
  /** 字段是否只读，无法编辑 */
  readonly?: Maybe<Scalars['Boolean']['output']>;
  /** 该字段是否属于评分字段（e.g. 考试、测评中的题目） */
  scorable: Scalars['Boolean']['output'];
  /** 字段提示较长时折叠展示 */
  showPartDescription: Scalars['Boolean']['output'];
  /** 新起一行 */
  startNewRow: Scalars['Boolean']['output'];
  /** 该字段是否可以作为文本插入 true - 能, false - 不能 */
  textPlaceholderable: Scalars['Boolean']['output'];
  /** 字段类型 */
  type: FieldClass;
  /** 字段类型文本 */
  typeName: Scalars['String']['output'];
  /** 字段验证规则 */
  validations?: Maybe<Array<FieldValidation>>;
};


export type TelephoneFieldHasAbilityArgs = {
  key: FieldAbilityEnum;
};


export type TelephoneFieldNotesArgs = {
  sanitize?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Template = {
  id: Scalars['ID']['output'];
  /** 模板名称 */
  name: Scalars['String']['output'];
  /** 模板 token */
  token: Scalars['String']['output'];
};

export type TemplateCoupon = {
  code: Scalars['ID']['output'];
  discountValue: Scalars['Float']['output'];
  name: Scalars['String']['output'];
};

export type TemplateCouponAttributes = {
  /** coupon代码 */
  code: Scalars['ID']['input'];
  /** coupon折扣 */
  discountValue: Scalars['Float']['input'];
  /** coupon使用截止日期 */
  expireAt: Scalars['Date']['input'];
  /** coupon名称 */
  name: Scalars['String']['input'];
  /** coupon使用门槛 */
  redeemBaseLimit: Scalars['Float']['input'];
  /** coupon使用开始日期 */
  startAt: Scalars['Date']['input'];
};

export type Templates = {
  /** 表单创建来源 */
  createdFrom?: Maybe<CreationSource>;
  /** 使用复制模板需要的表单插件 */
  templateRequiredFormApplications?: Maybe<Array<Application>>;
  /** 使用复制模板需要的套餐 */
  templateRequiredLowestPlan?: Maybe<Plan>;
};

export type Text = {
  /** 兑奖方式文案 */
  cashText: Scalars['String']['output'];
  /** 未中奖文案 */
  loseText: Scalars['String']['output'];
  /** 中奖文案 */
  winText: Scalars['String']['output'];
};

export type TextArea = AssociatedField & BaseField & ExtraConfigurableSetting & FieldAbility & LengthValidatableField & PlanAvailableField & PredefineableField & WithStatementPredefinedValues & {
  apiCode: Scalars['ID']['output'];
  apiCodeAlias?: Maybe<Scalars['String']['output']>;
  /** 对应的表单关联字段 */
  associationField?: Maybe<Field>;
  /** 自动填写上次提交内容 */
  cacheData: Scalars['Boolean']['output'];
  /** 客户端ID */
  cid?: Maybe<Scalars['String']['output']>;
  /** 封装的字段类型 */
  customizedType?: Maybe<Scalars['String']['output']>;
  /** 封装的字段类型文本 */
  customizedTypeName?: Maybe<Scalars['String']['output']>;
  /** 自定义出错文案 */
  customizedValidationMessage?: Maybe<Scalars['String']['output']>;
  /** 已提交的数据是否可被编辑 */
  editable: Scalars['Boolean']['output'];
  /** 场景化可配置字段设置 */
  extraConfigurableSettings?: Maybe<FieldExtraConfigurableSettings>;
  /** 该字段能否使用字段规则: true - 能， false - 不能 */
  fieldRuleAvailable: Scalars['Boolean']['output'];
  /** 是否是关联主键字段 */
  forAssociated?: Maybe<Scalars['Boolean']['output']>;
  /** 是否是关联展示字段 */
  forAssociatedDisplay?: Maybe<Scalars['Boolean']['output']>;
  /** 表单Token */
  formToken: Scalars['String']['output'];
  /** 宽度占用整行的四分之几 */
  gridsToOccupy?: Maybe<Scalars['Int']['output']>;
  hasAbility: Scalars['Boolean']['output'];
  /** 字段标题（去富文本化） */
  label?: Maybe<Scalars['String']['output']>;
  maximumLength?: Maybe<Scalars['BigInteger']['output']>;
  minimumLength?: Maybe<Scalars['BigInteger']['output']>;
  /** 字段描述，富文本 */
  notes?: Maybe<Scalars['String']['output']>;
  paidFeature?: Maybe<PaidFeature>;
  /** 占位符 */
  placeholder?: Maybe<Scalars['String']['output']>;
  planAvailable: Scalars['Boolean']['output'];
  /** 字段排序 */
  position: Scalars['Int']['output'];
  /** 预填写表单 */
  predefined: Scalars['Boolean']['output'];
  /** 默认值 */
  predefinedValue?: Maybe<Scalars['String']['output']>;
  /** 该字段是否是隐私字段 true - 是, false - 不是 */
  privacy: Scalars['Boolean']['output'];
  /** 字段隐藏 */
  private: Scalars['Boolean']['output'];
  /** 字段是否通过预填写表单预设了值 true - 是, false - 否 */
  pseudoFormPredefined?: Maybe<Scalars['Boolean']['output']>;
  /** 字段标题（富文本化） */
  rawLabel?: Maybe<Scalars['String']['output']>;
  /** 字段是否只读，无法编辑 */
  readonly?: Maybe<Scalars['Boolean']['output']>;
  /** 该字段是否属于评分字段（e.g. 考试、测评中的题目） */
  scorable: Scalars['Boolean']['output'];
  /** 字段提示较长时折叠展示 */
  showPartDescription: Scalars['Boolean']['output'];
  /** 新起一行 */
  startNewRow: Scalars['Boolean']['output'];
  statementPredefinedValues?: Maybe<FieldStatementPredefinedValues>;
  /** 该字段是否可以作为文本插入 true - 能, false - 不能 */
  textPlaceholderable: Scalars['Boolean']['output'];
  /** 字段类型 */
  type: FieldClass;
  /** 字段类型文本 */
  typeName: Scalars['String']['output'];
  /** 字段验证规则 */
  validations?: Maybe<Array<FieldValidation>>;
};


export type TextAreaHasAbilityArgs = {
  key: FieldAbilityEnum;
};


export type TextAreaNotesArgs = {
  sanitize?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TextChoice = BaseChoice & DescribableItem & QuotableChoice & {
  /** 是否需要输入框 */
  allowExtendedText?: Maybe<Scalars['Boolean']['output']>;
  /** 选项说明 */
  description?: Maybe<Scalars['String']['output']>;
  /** 说明类型 */
  descriptionMode: DescribableItemMode;
  /** 选项说明文字 */
  descriptionText?: Maybe<Scalars['String']['output']>;
  /** 选项说明链接 */
  descriptionUrl?: Maybe<Scalars['String']['output']>;
  /** 输入框占位符文案 */
  extendedTextPlaceholder?: Maybe<Scalars['String']['output']>;
  /** 选项说明是否必填 */
  extendedTextRequired?: Maybe<Scalars['Boolean']['output']>;
  hidden: Scalars['Boolean']['output'];
  /** 选项最多被选次数 */
  maximumFrequency?: Maybe<Scalars['Int']['output']>;
  /** 选项名称 */
  name: Scalars['String']['output'];
  operandValue?: Maybe<Scalars['Float']['output']>;
  position: Scalars['Int']['output'];
  /** 剩余名额 */
  quota?: Maybe<Scalars['BigInteger']['output']>;
  /** 名额设置 */
  quotaSetting?: Maybe<Scalars['BigInteger']['output']>;
  selected: Scalars['Boolean']['output'];
  /** 用户自定义选项说明扩展按钮文案 */
  showMoreDescriptionTip?: Maybe<Scalars['String']['output']>;
  /** 子选项 */
  subChoices?: Maybe<Array<TextChoice>>;
  type?: Maybe<Scalars['String']['output']>;
  value: Scalars['ID']['output'];
};

export type TextField = AccessControlableField & AssociatedField & BaseField & CalculableField & ExtraConfigurableSetting & FieldAbility & FormatValidatableField & LengthValidatableField & PlanAvailableField & PredefineableField & WithStatementPredefinedValues & {
  accessControlType: AccessControlType;
  accessControlValues?: Maybe<Array<Scalars['String']['output']>>;
  apiCode: Scalars['ID']['output'];
  apiCodeAlias?: Maybe<Scalars['String']['output']>;
  /** 对应的表单关联字段 */
  associationField?: Maybe<Field>;
  /** 自动填写上次提交内容 */
  cacheData: Scalars['Boolean']['output'];
  /** 开启选项赋值或本身可参与计算 */
  calculable: Scalars['Boolean']['output'];
  /** 客户端ID */
  cid?: Maybe<Scalars['String']['output']>;
  customValidationRegex?: Maybe<Scalars['String']['output']>;
  /** 封装的字段类型 */
  customizedType?: Maybe<Scalars['String']['output']>;
  /** 封装的字段类型文本 */
  customizedTypeName?: Maybe<Scalars['String']['output']>;
  /** 自定义出错文案 */
  customizedValidationMessage?: Maybe<Scalars['String']['output']>;
  /** 已提交的数据是否可被编辑 */
  editable: Scalars['Boolean']['output'];
  /** 场景化可配置字段设置 */
  extraConfigurableSettings?: Maybe<FieldExtraConfigurableSettings>;
  /** 该字段能否使用字段规则: true - 能， false - 不能 */
  fieldRuleAvailable: Scalars['Boolean']['output'];
  /** 是否是关联主键字段 */
  forAssociated?: Maybe<Scalars['Boolean']['output']>;
  /** 是否是关联展示字段 */
  forAssociatedDisplay?: Maybe<Scalars['Boolean']['output']>;
  /** 表单Token */
  formToken: Scalars['String']['output'];
  formatValidationEnabled: Scalars['Boolean']['output'];
  formatValidationJsRegex?: Maybe<JsRegex>;
  formatValidationType?: Maybe<FieldValidation>;
  /** 宽度占用整行的四分之几 */
  gridsToOccupy?: Maybe<Scalars['Int']['output']>;
  hasAbility: Scalars['Boolean']['output'];
  /** 字段标题（去富文本化） */
  label?: Maybe<Scalars['String']['output']>;
  maximumLength?: Maybe<Scalars['BigInteger']['output']>;
  minimumLength?: Maybe<Scalars['BigInteger']['output']>;
  /** 字段描述，富文本 */
  notes?: Maybe<Scalars['String']['output']>;
  paidFeature?: Maybe<PaidFeature>;
  /** 占位符 */
  placeholder?: Maybe<Scalars['String']['output']>;
  planAvailable: Scalars['Boolean']['output'];
  /** 字段排序 */
  position: Scalars['Int']['output'];
  /** 预填写表单 */
  predefined: Scalars['Boolean']['output'];
  /** 默认值 */
  predefinedValue?: Maybe<Scalars['String']['output']>;
  /** 该字段是否是隐私字段 true - 是, false - 不是 */
  privacy: Scalars['Boolean']['output'];
  /** 字段隐藏 */
  private: Scalars['Boolean']['output'];
  /** 字段是否通过预填写表单预设了值 true - 是, false - 否 */
  pseudoFormPredefined?: Maybe<Scalars['Boolean']['output']>;
  /** 字段标题（富文本化） */
  rawLabel?: Maybe<Scalars['String']['output']>;
  /** 字段是否只读，无法编辑 */
  readonly?: Maybe<Scalars['Boolean']['output']>;
  /** 扫码录入时截取部分字符的起始位置 */
  scanBegin?: Maybe<Scalars['BigInteger']['output']>;
  /** 扫码录入时截取部分字符的结束位置 */
  scanEnd?: Maybe<Scalars['BigInteger']['output']>;
  /** 微信扫码录入 */
  scannable: Scalars['Boolean']['output'];
  /** 该字段是否属于评分字段（e.g. 考试、测评中的题目） */
  scorable: Scalars['Boolean']['output'];
  /** 字段提示较长时折叠展示 */
  showPartDescription: Scalars['Boolean']['output'];
  /** 新起一行 */
  startNewRow: Scalars['Boolean']['output'];
  statementPredefinedValues?: Maybe<FieldStatementPredefinedValues>;
  /** 该字段是否可以作为文本插入 true - 能, false - 不能 */
  textPlaceholderable: Scalars['Boolean']['output'];
  /** 扫码录入时截取部分字符 */
  trimmable: Scalars['Boolean']['output'];
  /** 字段类型 */
  type: FieldClass;
  /** 字段类型文本 */
  typeName: Scalars['String']['output'];
  /** 字段验证规则 */
  validations?: Maybe<Array<FieldValidation>>;
};


export type TextFieldHasAbilityArgs = {
  key: FieldAbilityEnum;
};


export type TextFieldNotesArgs = {
  sanitize?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TextMessagePart = {
  /** 文本内容 */
  content?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
};

export type Theme = {
  /** 百变表单-DominantColor */
  dominantColor?: Maybe<Scalars['String']['output']>;
  /** 百变表单-错误提示 */
  error?: Maybe<ThemeTextStyleWithAlignment>;
  /** 百变表单-表单 */
  formApp?: Maybe<ThemeFormApp>;
  /** 表单全局 */
  formContainer: ThemeFormContainer;
  /** 百变表单-字段 */
  formField?: Maybe<ThemeFormField>;
  /** 通用按钮样式 */
  generalButton: ThemeButton;
  /** 页眉设置 */
  header: ThemeHeader;
  /** 百变表单-主题色 */
  primaryColor?: Maybe<Scalars['String']['output']>;
  /** 百变表单-辅色 */
  secondaryColor?: Maybe<Scalars['String']['output']>;
  /** 提交按钮样式 */
  submitButton: ThemeSubmitButton;
  /** 样式模板缩略图 */
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  typography: ThemeTypographyType;
  /** NEXT 表单 UI 版本，如 beautiform */
  uiVersion?: Maybe<ThemeUiVersion>;
  /** 页面背景 */
  wallpaper: ThemeWallpaper;
};

export type ThemeAttributes = {
  /** 百变表单-DominantColor */
  dominantColor?: InputMaybe<Scalars['String']['input']>;
  /** 百变表单-错误提示 */
  error?: InputMaybe<ThemeTextStyleWithAlignmentAttributes>;
  /** 百变表单-表单 */
  formApp?: InputMaybe<ThemeFormAppAttributes>;
  /** 表单全局 */
  formContainer?: InputMaybe<ThemeFormContainerAttributes>;
  /** 百变表单-字段 */
  formField?: InputMaybe<ThemeFormFieldAttributes>;
  /** 通用按钮样式 */
  generalButton?: InputMaybe<ThemeGeneralButtonAttributes>;
  /** 页眉设置 */
  header?: InputMaybe<ThemeHeaderAttributes>;
  /** 表单布局 */
  layout?: InputMaybe<Layout>;
  /** 百变表单-主题色 */
  primaryColor?: InputMaybe<Scalars['String']['input']>;
  /** 百变表单-辅色 */
  secondaryColor?: InputMaybe<Scalars['String']['input']>;
  /** 提交按钮样式 */
  submitButton?: InputMaybe<ThemeSubmitButtonAttributes>;
  typography?: InputMaybe<ThemeTypographyAttributes>;
  /** NEXT 表单 UI 版本，传值才修改 */
  uiVersion?: InputMaybe<ThemeUiVersion>;
  /** 页面背景 */
  wallpaper?: InputMaybe<ThemeWallpaperAttributes>;
};

export type ThemeBackgroundImage = {
  /** 用户上传的背景图片attachment id */
  attachmentId?: Maybe<Scalars['ID']['output']>;
  /** 来自样式模板的背景图片名 */
  fileName?: Maybe<Scalars['String']['output']>;
  /** 背景图片类型 */
  type: BackgroundImageType;
};

export type ThemeBackgroundImageAttributes = {
  attachmentId?: InputMaybe<Scalars['ID']['input']>;
  /** 来自样式模板的背景图片名 */
  fileName?: InputMaybe<Scalars['String']['input']>;
  /** 背景图片类型 */
  type: BackgroundImageType;
};

export type ThemeBaseStyle = {
  color?: Maybe<Scalars['String']['output']>;
  fontFamily?: Maybe<Scalars['String']['output']>;
  fontFamilyRaw?: Maybe<Scalars['String']['output']>;
  fontSize?: Maybe<Scalars['String']['output']>;
  fontWeight?: Maybe<Scalars['String']['output']>;
  letterSpacing?: Maybe<Scalars['String']['output']>;
  lineHeight?: Maybe<Scalars['String']['output']>;
};


export type ThemeBaseStyleFontSizeArgs = {
  convertToPx?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ThemeBaseTextStyleAttributes = {
  color: Scalars['String']['input'];
  fontFamilyRaw?: InputMaybe<Scalars['String']['input']>;
  fontSize: Scalars['String']['input'];
  fontWeight: Scalars['String']['input'];
  letterSpacing?: InputMaybe<Scalars['String']['input']>;
  lineHeight?: InputMaybe<Scalars['String']['input']>;
  paragraphSpacing?: InputMaybe<Scalars['String']['input']>;
};

export type ThemeButton = {
  style: ThemeGeneralButtonStyle;
};

export type ThemeButtonStyleAttributes = {
  /** 底色 */
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  /** 边框颜色 */
  borderColor?: InputMaybe<Scalars['String']['input']>;
  /** 边框宽度 */
  borderWidth?: InputMaybe<Scalars['String']['input']>;
  color: Scalars['String']['input'];
  fontFamilyRaw?: InputMaybe<Scalars['String']['input']>;
  fontSize: Scalars['String']['input'];
  fontWeight: Scalars['String']['input'];
  letterSpacing?: InputMaybe<Scalars['String']['input']>;
  lineHeight?: InputMaybe<Scalars['String']['input']>;
  /** 宽度 */
  padding?: InputMaybe<Scalars['String']['input']>;
  paragraphSpacing?: InputMaybe<Scalars['String']['input']>;
};

export type ThemeControlStyle = ThemeBaseStyle & {
  backgroundColor?: Maybe<Scalars['String']['output']>;
  borderColor?: Maybe<Scalars['String']['output']>;
  borderWidth?: Maybe<Scalars['String']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  fontFamily?: Maybe<Scalars['String']['output']>;
  fontFamilyRaw?: Maybe<Scalars['String']['output']>;
  fontSize?: Maybe<Scalars['String']['output']>;
  fontWeight?: Maybe<Scalars['String']['output']>;
  letterSpacing?: Maybe<Scalars['String']['output']>;
  lineHeight?: Maybe<Scalars['String']['output']>;
  textAlign?: Maybe<Scalars['String']['output']>;
};


export type ThemeControlStyleFontSizeArgs = {
  convertToPx?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ThemeControlStyleAttributes = {
  /** 控件底色 */
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  /** 控件边框颜色 */
  borderColor?: InputMaybe<Scalars['String']['input']>;
  /** 控件边框宽度 */
  borderWidth?: InputMaybe<Scalars['String']['input']>;
  color: Scalars['String']['input'];
  fontFamilyRaw?: InputMaybe<Scalars['String']['input']>;
  fontSize: Scalars['String']['input'];
  fontWeight: Scalars['String']['input'];
  letterSpacing?: InputMaybe<Scalars['String']['input']>;
  lineHeight?: InputMaybe<Scalars['String']['input']>;
  paragraphSpacing?: InputMaybe<Scalars['String']['input']>;
  textAlign: Scalars['String']['input'];
};

export type ThemeFormApp = {
  /** 开启表单底色模糊效果 */
  backgroundBlur?: Maybe<Scalars['Boolean']['output']>;
  /** 表单底色 */
  backgroundColor?: Maybe<Scalars['String']['output']>;
  /** 边框颜色 */
  borderColor?: Maybe<Scalars['String']['output']>;
  /** 边框宽度 */
  borderWidth?: Maybe<Scalars['String']['output']>;
  /** 控件圆角大小 */
  controlRadius?: Maybe<Scalars['String']['output']>;
  /** 字段间距 */
  fieldGap?: Maybe<Scalars['String']['output']>;
  /** 手机屏幕边缘缩进 */
  indentOnLargePhone: Scalars['Boolean']['output'];
  /** 开启表单阴影效果 */
  shadow: Scalars['Boolean']['output'];
};

export type ThemeFormAppAttributes = {
  /** 开启表单底色模糊效果 */
  backgroundBlur?: InputMaybe<Scalars['Boolean']['input']>;
  /** 表单底色 */
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  /** 边框颜色 */
  borderColor?: InputMaybe<Scalars['String']['input']>;
  /** 边框宽度 */
  borderWidth?: InputMaybe<Scalars['String']['input']>;
  /** 控件圆角大小 */
  controlRadius?: InputMaybe<Scalars['String']['input']>;
  /** 字段间距 */
  fieldGap?: InputMaybe<Scalars['String']['input']>;
  /** 手机屏幕边缘缩进 */
  indentOnLargePhone?: InputMaybe<Scalars['Boolean']['input']>;
  /** 开启表单阴影效果 */
  shadow?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ThemeFormContainer = {
  /** 表单全局 - 分隔线（表头和正文之间） */
  divider: ThemeFormDivider;
  /** 手机屏幕边缘缩进 */
  indentOnLargePhone: Scalars['Boolean']['output'];
  /** 开启表单阴影 */
  shadow: Scalars['Boolean']['output'];
  /** 表单全局 */
  style: ThemeFormStyle;
};

export type ThemeFormContainerAttributes = {
  /** 表单全局 - 分隔线（表头和正文之间） */
  divider?: InputMaybe<ThemeFormDeviderAttributes>;
  /** 手机屏幕边缘缩进 */
  indentOnLargePhone?: InputMaybe<Scalars['Boolean']['input']>;
  /** 开启表单阴影 */
  shadow?: InputMaybe<Scalars['Boolean']['input']>;
  /** 表单全局样式 */
  style?: InputMaybe<ThemeFormStyleAttributes>;
};

export type ThemeFormDeviderAttributes = {
  color: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
};

export type ThemeFormDivider = {
  color: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
};

export type ThemeFormField = {
  /** 字段控件 */
  control?: Maybe<ThemeControlStyle>;
  /** 字段描述 */
  desc?: Maybe<ThemeTextStyleWithAlignment>;
  /** 字段标题 */
  label?: Maybe<ThemeTextStyleWithAlignment>;
  /** 字段布局 */
  layout?: Maybe<ThemeFormFieldLayout>;
  /** 字段样式 */
  variant?: Maybe<ThemeFormFieldVariant>;
};

export type ThemeFormFieldAttributes = {
  /** 字段控件 */
  control?: InputMaybe<ThemeControlStyleAttributes>;
  /** 字段描述 */
  desc?: InputMaybe<ThemeTextStyleWithAlignmentAttributes>;
  /** 字段标题 */
  label?: InputMaybe<ThemeTextStyleWithAlignmentAttributes>;
  /** 字段布局 */
  layout?: InputMaybe<ThemeFormFieldLayout>;
  /** 字段样式 */
  variant?: InputMaybe<ThemeFormFieldVariant>;
};

export enum ThemeFormFieldLayout {
  /** Horizontal */
  Horizontal = 'horizontal',
  /** Vertical */
  Vertical = 'vertical'
}

export enum ThemeFormFieldVariant {
  /** Default */
  Default = 'default',
  /** Underline */
  Underline = 'underline'
}

export type ThemeFormStyle = {
  /** 表单底色 */
  backgroundColor?: Maybe<Scalars['String']['output']>;
  /** 边框颜色 */
  borderColor?: Maybe<Scalars['String']['output']>;
  /** 边框宽度 */
  borderWidth?: Maybe<Scalars['String']['output']>;
  /** PC下表单宽度 */
  maxWidth?: Maybe<Scalars['String']['output']>;
};

export type ThemeFormStyleAttributes = {
  /** 表单底色 */
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  /** 边框颜色 */
  borderColor?: InputMaybe<Scalars['String']['input']>;
  /** 边框宽度 */
  borderWidth?: InputMaybe<Scalars['String']['input']>;
  /** PC下表单宽度 */
  maxWidth?: InputMaybe<Scalars['String']['input']>;
};

export type ThemeGeneralButtonAttributes = {
  startBtnText?: InputMaybe<Scalars['String']['input']>;
  style?: InputMaybe<ThemeGeneralButtonStyleAttributes>;
};

export type ThemeGeneralButtonStyle = ThemeBaseStyle & {
  backgroundColor?: Maybe<Scalars['String']['output']>;
  borderColor?: Maybe<Scalars['String']['output']>;
  borderWidth?: Maybe<Scalars['String']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  fontFamily?: Maybe<Scalars['String']['output']>;
  fontFamilyRaw?: Maybe<Scalars['String']['output']>;
  fontSize?: Maybe<Scalars['String']['output']>;
  fontWeight?: Maybe<Scalars['String']['output']>;
  letterSpacing?: Maybe<Scalars['String']['output']>;
  lineHeight?: Maybe<Scalars['String']['output']>;
};


export type ThemeGeneralButtonStyleFontSizeArgs = {
  convertToPx?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ThemeGeneralButtonStyleAttributes = {
  /** 底色 */
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  /** 边框颜色 */
  borderColor?: InputMaybe<Scalars['String']['input']>;
  /** 边框宽度 */
  borderWidth?: InputMaybe<Scalars['String']['input']>;
  color: Scalars['String']['input'];
  fontFamilyRaw?: InputMaybe<Scalars['String']['input']>;
  fontSize: Scalars['String']['input'];
  fontWeight: Scalars['String']['input'];
  letterSpacing?: InputMaybe<Scalars['String']['input']>;
  lineHeight?: InputMaybe<Scalars['String']['input']>;
  paragraphSpacing?: InputMaybe<Scalars['String']['input']>;
};

export type ThemeHeader = {
  backgroundColor?: Maybe<Scalars['String']['output']>;
  /** 轮播图 */
  carouselImages?: Maybe<Array<Attachment>>;
  /** 轮播样式 */
  carouselType?: Maybe<ThemeHeaderCarousel>;
  image?: Maybe<Attachment>;
  imageStyle?: Maybe<ThemeHeaderImageStyle>;
  /** 页眉文字 */
  text?: Maybe<Scalars['String']['output']>;
  textStyle?: Maybe<ThemeTextStyleWithAlignment>;
  /** 页眉展示类型 */
  type: ThemeHeaderType;
};

export type ThemeHeaderAttributes = {
  /** 页面底色 */
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  /** 轮播图 */
  carouselImageAttributes?: InputMaybe<Array<ThemeHeaderCarouselImageAttributes>>;
  /** 轮播样式 */
  carouselType?: InputMaybe<ThemeHeaderCarousel>;
  /** 单张图下图片attachment id */
  imageAttachmentId?: InputMaybe<Scalars['ID']['input']>;
  /** 单张图样式 */
  imageStyle?: InputMaybe<ThemeHeaderImageStyleAttributes>;
  /** 页眉文字 */
  text?: InputMaybe<Scalars['String']['input']>;
  /** 页眉文字样式 */
  textStyle?: InputMaybe<ThemeTextStyleWithAlignmentAttributes>;
  /** 页眉展示类型 */
  type: ThemeHeaderType;
};

export enum ThemeHeaderCarousel {
  /** Normal */
  Normal = 'normal',
  /** Thumbnail */
  Thumbnail = 'thumbnail'
}

export type ThemeHeaderCarouselImageAttributes = {
  attachmentId: Scalars['ID']['input'];
  position: Scalars['Int']['input'];
};

export type ThemeHeaderImageStyle = {
  textAlign?: Maybe<Scalars['String']['output']>;
};

export type ThemeHeaderImageStyleAttributes = {
  textAlign: Scalars['String']['input'];
};

export enum ThemeHeaderType {
  /** Carousel */
  Carousel = 'carousel',
  /** Image */
  Image = 'image',
  /** None */
  None = 'none',
  /** Text */
  Text = 'text'
}

export type ThemeSubmitButton = {
  /** 布局 */
  alignment: SubmitButtonAlignment;
  /** 在手机浏览器中固定在表单底部 */
  fixedToBottomInMobile: Scalars['Boolean']['output'];
  /** 隐藏提交按钮 */
  hidden: Scalars['Boolean']['output'];
  /** 开启阴影 */
  shadow: Scalars['Boolean']['output'];
  style: ThemeSubmitButtonStyle;
};

export type ThemeSubmitButtonAttributes = {
  /** 布局 */
  alignment?: InputMaybe<SubmitButtonAlignment>;
  /** 在手机浏览器中固定在表单底部 */
  fixedToBottomInMobile?: InputMaybe<Scalars['Boolean']['input']>;
  /** 隐藏提交按钮 */
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  /** 阴影 */
  shadow?: InputMaybe<Scalars['Boolean']['input']>;
  style?: InputMaybe<ThemeButtonStyleAttributes>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type ThemeSubmitButtonStyle = ThemeBaseStyle & {
  backgroundColor?: Maybe<Scalars['String']['output']>;
  borderColor?: Maybe<Scalars['String']['output']>;
  borderWidth?: Maybe<Scalars['String']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  fontFamily?: Maybe<Scalars['String']['output']>;
  fontFamilyRaw?: Maybe<Scalars['String']['output']>;
  fontSize?: Maybe<Scalars['String']['output']>;
  fontWeight?: Maybe<Scalars['String']['output']>;
  letterSpacing?: Maybe<Scalars['String']['output']>;
  lineHeight?: Maybe<Scalars['String']['output']>;
  padding?: Maybe<Scalars['String']['output']>;
};


export type ThemeSubmitButtonStyleFontSizeArgs = {
  convertToPx?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ThemeTextStyle = ThemeBaseStyle & {
  color?: Maybe<Scalars['String']['output']>;
  fontFamily?: Maybe<Scalars['String']['output']>;
  fontFamilyRaw?: Maybe<Scalars['String']['output']>;
  fontSize?: Maybe<Scalars['String']['output']>;
  fontWeight?: Maybe<Scalars['String']['output']>;
  letterSpacing?: Maybe<Scalars['String']['output']>;
  lineHeight?: Maybe<Scalars['String']['output']>;
  paragraphSpacing?: Maybe<Scalars['String']['output']>;
};


export type ThemeTextStyleFontSizeArgs = {
  convertToPx?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ThemeTextStyleWithAlignment = ThemeBaseStyle & {
  color?: Maybe<Scalars['String']['output']>;
  fontFamily?: Maybe<Scalars['String']['output']>;
  fontFamilyRaw?: Maybe<Scalars['String']['output']>;
  fontSize?: Maybe<Scalars['String']['output']>;
  fontWeight?: Maybe<Scalars['String']['output']>;
  letterSpacing?: Maybe<Scalars['String']['output']>;
  lineHeight?: Maybe<Scalars['String']['output']>;
  paragraphSpacing?: Maybe<Scalars['String']['output']>;
  textAlign?: Maybe<Scalars['String']['output']>;
};


export type ThemeTextStyleWithAlignmentFontSizeArgs = {
  convertToPx?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ThemeTextStyleWithAlignmentAttributes = {
  color: Scalars['String']['input'];
  fontFamilyRaw?: InputMaybe<Scalars['String']['input']>;
  fontSize: Scalars['String']['input'];
  fontWeight: Scalars['String']['input'];
  letterSpacing?: InputMaybe<Scalars['String']['input']>;
  lineHeight?: InputMaybe<Scalars['String']['input']>;
  paragraphSpacing?: InputMaybe<Scalars['String']['input']>;
  textAlign: Scalars['String']['input'];
};

export type ThemeTypographyAttributes = {
  /** 字段选项样式 */
  choiceStyle?: InputMaybe<ThemeBaseTextStyleAttributes>;
  /** 字段标题样式 */
  fieldLabel?: InputMaybe<ThemeBaseTextStyleAttributes>;
  /** 字段间距 */
  fieldSpace?: InputMaybe<Scalars['String']['input']>;
  /** 表单标题样式 */
  formHeader?: InputMaybe<ThemeTextStyleWithAlignmentAttributes>;
  /** 卡片式表单的辅助色 */
  secondaryColor?: InputMaybe<Scalars['String']['input']>;
  /** 表单描述较长时折叠展示 */
  showPartDescription?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ThemeTypographyType = {
  /** 字段选项 */
  choiceStyle: ThemeTextStyle;
  /** 字段标题 */
  fieldLabel: ThemeTextStyle;
  /** 字段间距 */
  fieldSpace?: Maybe<Scalars['String']['output']>;
  /** 表单标题 */
  formHeader: ThemeTextStyleWithAlignment;
  /** 卡片式表单的辅助色 */
  secondaryColor?: Maybe<Scalars['String']['output']>;
  /** 表单描述较长时折叠展示 */
  showPartDescription: Scalars['Boolean']['output'];
};

export enum ThemeUiVersion {
  Beautiform = 'beautiform',
  Default = 'default'
}

export type ThemeWallpaper = {
  /** 百变表单-背景图片模糊 */
  backgroundBlur: Scalars['Boolean']['output'];
  backgroundColor?: Maybe<Scalars['String']['output']>;
  backgroundImage?: Maybe<ThemeBackgroundImage>;
  backgroundImageUrl?: Maybe<Scalars['String']['output']>;
  backgroundRepeat: Scalars['Boolean']['output'];
};

export type ThemeWallpaperAttributes = {
  /** 百变表单-背景图片模糊 */
  backgroundBlur?: InputMaybe<Scalars['Boolean']['input']>;
  /** 背景底色 */
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  /** 背景图片 */
  backgroundImageAttributes?: InputMaybe<ThemeBackgroundImageAttributes>;
  /** 背景图片重复 */
  backgroundRepeat?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ThinkingMessagePart = {
  /** 思考内容 */
  content?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
};

export type ThirdPartyIntegration = {
  /** 支付宝账户 */
  alipayAccounts: Array<AlipayAccount>;
  /** 创建来源 */
  createdFrom: UserCreatedFrom;
  /** 金数据商户账户 */
  merchantAccounts: Array<MerchantAccount>;
  /** Ping++账户 */
  pingppAccounts: Array<PingppAccount>;
  /** SMTP邮件服务器 */
  smtpAccounts: Array<SmtpAccount>;
  /** 微信服务号账户 */
  weixinAccounts: Array<WeixinAccount>;
  /** 微信支付账户。如果是从FormType过来的，返回该表单可以使用的微信支付账户 */
  wxpayAccounts: Array<WxpayAccount>;
};


export type ThirdPartyIntegrationSmtpAccountsArgs = {
  available?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type TimeAttributes = {
  hour: Scalars['String']['input'];
  minute: Scalars['String']['input'];
};

export type TimeField = AssociatedField & BaseField & FieldAbility & PlanAvailableField & PredefineableField & {
  apiCode: Scalars['ID']['output'];
  apiCodeAlias?: Maybe<Scalars['String']['output']>;
  /** 对应的表单关联字段 */
  associationField?: Maybe<Field>;
  /** 自动填写上次提交内容 */
  cacheData: Scalars['Boolean']['output'];
  /** 客户端ID */
  cid?: Maybe<Scalars['String']['output']>;
  /** 封装的字段类型 */
  customizedType?: Maybe<Scalars['String']['output']>;
  /** 封装的字段类型文本 */
  customizedTypeName?: Maybe<Scalars['String']['output']>;
  /** 自定义出错文案 */
  customizedValidationMessage?: Maybe<Scalars['String']['output']>;
  /** 已提交的数据是否可被编辑 */
  editable: Scalars['Boolean']['output'];
  /** 该字段能否使用字段规则: true - 能， false - 不能 */
  fieldRuleAvailable: Scalars['Boolean']['output'];
  /** 是否是关联主键字段 */
  forAssociated?: Maybe<Scalars['Boolean']['output']>;
  /** 是否是关联展示字段 */
  forAssociatedDisplay?: Maybe<Scalars['Boolean']['output']>;
  /** 表单Token */
  formToken: Scalars['String']['output'];
  /** 宽度占用整行的四分之几 */
  gridsToOccupy?: Maybe<Scalars['Int']['output']>;
  hasAbility: Scalars['Boolean']['output'];
  /** 精确到秒 */
  includeSecond: Scalars['Boolean']['output'];
  /** 字段标题（去富文本化） */
  label?: Maybe<Scalars['String']['output']>;
  /** 字段描述，富文本 */
  notes?: Maybe<Scalars['String']['output']>;
  paidFeature?: Maybe<PaidFeature>;
  planAvailable: Scalars['Boolean']['output'];
  /** 字段排序 */
  position: Scalars['Int']['output'];
  /** 预填写表单 */
  predefined: Scalars['Boolean']['output'];
  /** 默认值 */
  predefinedValue?: Maybe<TimeFieldValue>;
  /** 该字段是否是隐私字段 true - 是, false - 不是 */
  privacy: Scalars['Boolean']['output'];
  /** 字段隐藏 */
  private: Scalars['Boolean']['output'];
  /** 字段是否通过预填写表单预设了值 true - 是, false - 否 */
  pseudoFormPredefined?: Maybe<Scalars['Boolean']['output']>;
  /** 字段标题（富文本化） */
  rawLabel?: Maybe<Scalars['String']['output']>;
  /** 字段是否只读，无法编辑 */
  readonly?: Maybe<Scalars['Boolean']['output']>;
  /** 该字段是否属于评分字段（e.g. 考试、测评中的题目） */
  scorable: Scalars['Boolean']['output'];
  /** 字段提示较长时折叠展示 */
  showPartDescription: Scalars['Boolean']['output'];
  /** 新起一行 */
  startNewRow: Scalars['Boolean']['output'];
  /** 该字段是否可以作为文本插入 true - 能, false - 不能 */
  textPlaceholderable: Scalars['Boolean']['output'];
  /** 字段类型 */
  type: FieldClass;
  /** 字段类型文本 */
  typeName: Scalars['String']['output'];
  /** 字段验证规则 */
  validations?: Maybe<Array<FieldValidation>>;
};


export type TimeFieldHasAbilityArgs = {
  key: FieldAbilityEnum;
};


export type TimeFieldNotesArgs = {
  sanitize?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TimeFieldValue = {
  hour?: Maybe<Scalars['Int']['output']>;
  minute?: Maybe<Scalars['Int']['output']>;
  second?: Maybe<Scalars['Int']['output']>;
};

export type TimeOffsetAttributes = {
  /** 时间项目数量 */
  offsetNumber: Scalars['Int']['input'];
  /** 时间项目单位 */
  unit: TimeOffsetUnit;
};

export enum TimeOffsetUnit {
  Day = 'day',
  Hour = 'hour'
}

export type TimePeriod = {
  /** 结束时间 */
  endTime: TimePeriodTime;
  /** 开始时间 */
  startTime: TimePeriodTime;
};

export type TimePeriodAttributes = {
  /** 结束时间 */
  endTime: TimePeriodTimeAttributes;
  /** 开始时间 */
  startTime: TimePeriodTimeAttributes;
};

export type TimePeriodTime = {
  /** 小时 */
  hour: Scalars['Int']['output'];
  /** 分钟 */
  minute: Scalars['Int']['output'];
};

export type TimePeriodTimeAttributes = {
  /** 小时 */
  hour: Scalars['Int']['input'];
  /** 分钟 */
  minute: Scalars['Int']['input'];
};

export enum TimeRangeMode {
  DifferentByWday = 'different_by_wday',
  SameByWday = 'same_by_wday'
}

export type TimeRangeQuotaAttributes = {
  /** 关联时段表token，前端生成 */
  dailyTimeRangeToken?: InputMaybe<Scalars['ID']['input']>;
  /** 时段结束信息 */
  endTime?: InputMaybe<TimeAttributes>;
  /** 配置的星期 */
  forWday?: InputMaybe<DayNameOfWeek>;
  /** 位置排序 */
  position?: InputMaybe<Scalars['Int']['input']>;
  /** 单价 */
  price?: InputMaybe<Scalars['Float']['input']>;
  /** 时段配额 */
  quota?: InputMaybe<Scalars['BigInteger']['input']>;
  /** 时段开始信息 */
  startTime?: InputMaybe<TimeAttributes>;
};

export type TimeRangeSummary = {
  /** 时段结束时间 */
  endTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** 价格 */
  price: Scalars['Float']['output'];
  /** 剩余配额 */
  remainingQuota?: Maybe<Scalars['BigInteger']['output']>;
  /** 时段开始时间 */
  startTime: Scalars['ISO8601DateTime']['output'];
  /** 已用配额 */
  usedQuota: Scalars['BigInteger']['output'];
};

export type Timer = AssociatedField & BaseField & FieldAbility & PlanAvailableField & {
  apiCode: Scalars['ID']['output'];
  apiCodeAlias?: Maybe<Scalars['String']['output']>;
  /** 对应的表单关联字段 */
  associationField?: Maybe<Field>;
  /** 自动填写上次提交内容 */
  cacheData: Scalars['Boolean']['output'];
  /** 客户端ID */
  cid?: Maybe<Scalars['String']['output']>;
  /** 封装的字段类型 */
  customizedType?: Maybe<Scalars['String']['output']>;
  /** 封装的字段类型文本 */
  customizedTypeName?: Maybe<Scalars['String']['output']>;
  /** 自定义出错文案 */
  customizedValidationMessage?: Maybe<Scalars['String']['output']>;
  /** 已提交的数据是否可被编辑 */
  editable: Scalars['Boolean']['output'];
  /** 倒计时 - 结束时间 */
  endTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** 该字段能否使用字段规则: true - 能， false - 不能 */
  fieldRuleAvailable: Scalars['Boolean']['output'];
  /** 展示字段中，图文介绍、图片展示、轮播图、倒计时的样式 */
  fieldStyle?: Maybe<DisplayFieldsFieldStyleType>;
  /** 是否是关联主键字段 */
  forAssociated?: Maybe<Scalars['Boolean']['output']>;
  /** 是否是关联展示字段 */
  forAssociatedDisplay?: Maybe<Scalars['Boolean']['output']>;
  /** 表单Token */
  formToken: Scalars['String']['output'];
  /** 宽度占用整行的四分之几 */
  gridsToOccupy?: Maybe<Scalars['Int']['output']>;
  hasAbility: Scalars['Boolean']['output'];
  /** 字段标题（去富文本化） */
  label?: Maybe<Scalars['String']['output']>;
  /** 展示字段中，图文介绍、图片展示、轮播图、倒计时的布局 */
  layout?: Maybe<DisplayFieldLayout>;
  /** 字段描述，富文本 */
  notes?: Maybe<Scalars['String']['output']>;
  paidFeature?: Maybe<PaidFeature>;
  planAvailable: Scalars['Boolean']['output'];
  /** 字段排序 */
  position: Scalars['Int']['output'];
  /** 该字段是否是隐私字段 true - 是, false - 不是 */
  privacy: Scalars['Boolean']['output'];
  /** 字段隐藏 */
  private: Scalars['Boolean']['output'];
  /** 字段是否通过预填写表单预设了值 true - 是, false - 否 */
  pseudoFormPredefined?: Maybe<Scalars['Boolean']['output']>;
  /** 字段标题（富文本化） */
  rawLabel?: Maybe<Scalars['String']['output']>;
  /** 字段是否只读，无法编辑 */
  readonly?: Maybe<Scalars['Boolean']['output']>;
  /** 该字段是否属于评分字段（e.g. 考试、测评中的题目） */
  scorable: Scalars['Boolean']['output'];
  /** 字段提示较长时折叠展示 */
  showPartDescription: Scalars['Boolean']['output'];
  /** 新起一行 */
  startNewRow: Scalars['Boolean']['output'];
  /** 倒计时 - 自定义文案 */
  text: DisplayFieldsTextContentType;
  /** 该字段是否可以作为文本插入 true - 能, false - 不能 */
  textPlaceholderable: Scalars['Boolean']['output'];
  /** 字段类型 */
  type: FieldClass;
  /** 字段类型文本 */
  typeName: Scalars['String']['output'];
  /** 字段验证规则 */
  validations?: Maybe<Array<FieldValidation>>;
};


export type TimerHasAbilityArgs = {
  key: FieldAbilityEnum;
};


export type TimerNotesArgs = {
  sanitize?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TradeFreezedActivity = {
  freezeType?: Maybe<Scalars['String']['output']>;
  merchantName?: Maybe<Scalars['String']['output']>;
};

export type TradePaymentForm = {
  /** 商品最低价格 */
  minGoodsPrice?: Maybe<Scalars['Float']['output']>;
  /** 是否有个多个商品 */
  mutilGoodsPrice?: Maybe<Scalars['Boolean']['output']>;
  /** 订单数量 */
  ordersCount?: Maybe<Scalars['Int']['output']>;
  /** 交易数量 */
  transactionCount?: Maybe<Scalars['Int']['output']>;
  /** 交易金额 */
  transactionsAmount?: Maybe<Scalars['Float']['output']>;
};

export type Transaction = ChargeTransaction | PlanTransaction;

export enum TransactionClass {
  ActiveMailTransaction = 'ActiveMailTransaction',
  AiCreditsTransaction = 'AiCreditsTransaction',
  AiPointsTransaction = 'AiPointsTransaction',
  AppPackageTransaction = 'AppPackageTransaction',
  AppTransaction = 'AppTransaction',
  AppUpgradeTransaction = 'AppUpgradeTransaction',
  AudioQuotaTransaction = 'AudioQuotaTransaction',
  ChargeRedEnvelopeTransaction = 'ChargeRedEnvelopeTransaction',
  ChargeTransaction = 'ChargeTransaction',
  ExpandEntryTransaction = 'ExpandEntryTransaction',
  FormApplicationTransaction = 'FormApplicationTransaction',
  FormApplicationUpgradeTransaction = 'FormApplicationUpgradeTransaction',
  GdPortalCustomerTransaction = 'GDPortalCustomerTransaction',
  GdPortalTransaction = 'GDPortalTransaction',
  OtherTransaction = 'OtherTransaction',
  PlanTransaction = 'PlanTransaction',
  SmsTransaction = 'SMSTransaction',
  StorageTransaction = 'StorageTransaction',
  SubAccountTransaction = 'SubAccountTransaction',
  SubmitterTransaction = 'SubmitterTransaction',
  TemplateTransaction = 'TemplateTransaction',
  WeixinAccountTransaction = 'WeixinAccountTransaction'
}

/** Autogenerated input type of TransferForm */
export type TransferFormInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 表单ID或token */
  id: Scalars['ID']['input'];
  /** 转移目标用户 */
  toUserId: Scalars['ID']['input'];
};

/** Autogenerated return type of TransferForm */
export type TransferFormPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
};

/** Autogenerated input type of TransferHandoff */
export type TransferHandoffInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 要转交的 AgentInquiryConversation Id */
  conversationId: Scalars['String']['input'];
  /** 转交目标的 CSMan Id */
  targetId: Scalars['String']['input'];
};

/** Autogenerated return type of TransferHandoff */
export type TransferHandoffPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  conversation?: Maybe<Conversation>;
  errors?: Maybe<Array<Error>>;
};

export type TrashedForm = BaseFile & PublishedFormBaseProperties & Subname & {
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  creatorId: Scalars['ID']['output'];
  deleted: Scalars['Boolean']['output'];
  deletedAt: Scalars['ISO8601DateTime']['output'];
  /** @deprecated deleter可能为空，请使用form_deleter(目前仅cyborg在使用该字段) */
  deleter: User;
  /** 表单、文件夹的图标、颜色等 */
  ensuredSymbol?: Maybe<FormSymbol>;
  /** 表单删除前的数据总量 */
  entryCount: Scalars['Int']['output'];
  formDeleter?: Maybe<User>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /** 站内表单名 */
  subname?: Maybe<Scalars['String']['output']>;
  token: Scalars['String']['output'];
  type: BaseFileEnum;
  userFormSetting?: Maybe<UserFormSetting>;
};

/** The connection type for TrashedForm. */
export type TrashedFormConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<TrashedFormEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<TrashedForm>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type TrashedFormEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<TrashedForm>;
};

export enum TriggerScope {
  /** All */
  All = 'all',
  /** All new */
  AllNew = 'all_new',
  /** All update */
  AllUpdate = 'all_update',
  /** Matched new */
  MatchedNew = 'matched_new',
  /** Matched update */
  MatchedUpdate = 'matched_update',
  /** Schedule time */
  ScheduleTime = 'schedule_time'
}

/** Autogenerated input type of UpdateAdvancedNotificationsRule */
export type UpdateAdvancedNotificationsRuleInput = {
  attributes: RuleAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  formId: Scalars['ID']['input'];
  /** 是否为NEXT创建 */
  fromNext?: InputMaybe<Scalars['Boolean']['input']>;
  ruleId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateAdvancedNotificationsRule */
export type UpdateAdvancedNotificationsRulePayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  rule?: Maybe<Rule>;
};

/** Autogenerated input type of UpdateAvatar */
export type UpdateAvatarInput = {
  attachmentId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  cropH?: InputMaybe<Scalars['Float']['input']>;
  cropW?: InputMaybe<Scalars['Float']['input']>;
  cropX?: InputMaybe<Scalars['Float']['input']>;
  cropY?: InputMaybe<Scalars['Float']['input']>;
};

/** Autogenerated return type of UpdateAvatar */
export type UpdateAvatarPayload = {
  avatarUrl?: Maybe<Scalars['String']['output']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
};

/** Autogenerated input type of UpdateBaseFileTag */
export type UpdateBaseFileTagInput = {
  /** 标签更新属性列表 */
  attributes: Array<BaseFileTagAttributes>;
  /** 文件夹或者表单ID */
  baseFileId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateBaseFileTag */
export type UpdateBaseFileTagPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  tags?: Maybe<Array<FormTag>>;
};

/** Autogenerated input type of UpdateBillingAccount */
export type UpdateBillingAccountInput = {
  attributes: BillingAccountAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of UpdateBillingAccountLandingInfo */
export type UpdateBillingAccountLandingInfoInput = {
  attributes: BillingAccountLandingInfoAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateBillingAccountLandingInfo */
export type UpdateBillingAccountLandingInfoPayload = {
  billingAccount?: Maybe<BillingAccount>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
};

/** Autogenerated return type of UpdateBillingAccount */
export type UpdateBillingAccountPayload = {
  billingAccount?: Maybe<BillingAccount>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
};

/** Autogenerated input type of UpdateBillingAccountUser */
export type UpdateBillingAccountUserInput = {
  attributes: UserAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** UserID */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateBillingAccountUser */
export type UpdateBillingAccountUserPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Autogenerated input type of UpdateCurrentUser */
export type UpdateCurrentUserInput = {
  attributes: CurrentUserAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateCurrentUser */
export type UpdateCurrentUserPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  user?: Maybe<User>;
};

/** Autogenerated input type of UpdateEmail */
export type UpdateEmailInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  isPreValidate?: InputMaybe<Scalars['Boolean']['input']>;
  password: Scalars['String']['input'];
};

/** Autogenerated return type of UpdateEmail */
export type UpdateEmailPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  user?: Maybe<User>;
};

/** Autogenerated input type of UpdateEntryRedEnvelopeSetting */
export type UpdateEntryRedEnvelopeSettingInput = {
  attributes?: InputMaybe<EntryRedEnvelopeSettingAttributes>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 表单ID或token */
  id: Scalars['ID']['input'];
  withRedEnvelope?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of UpdateEntryRedEnvelopeSetting */
export type UpdateEntryRedEnvelopeSettingPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  form?: Maybe<Form>;
};

/** Autogenerated input type of UpdateEntrySmsTask */
export type UpdateEntrySmsTaskInput = {
  attributes: EntrySmsTaskAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 表单的使用场景 */
  formUsage?: InputMaybe<FormUsage>;
  /** 表单ID或token */
  id?: InputMaybe<Scalars['ID']['input']>;
  taskId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateEntrySmsTask */
export type UpdateEntrySmsTaskPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  smsTask?: Maybe<EntrySmsTaskType>;
};

/** Autogenerated input type of UpdateFeatureTrial */
export type UpdateFeatureTrialInput = {
  attributes: FeatureTrialAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of UpdateFieldStateFlow */
export type UpdateFieldStateFlowInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  event: Scalars['String']['input'];
  /** 表单的使用场景 */
  formUsage?: InputMaybe<FormUsage>;
  fsfTarget?: InputMaybe<Scalars['String']['input']>;
  fsfTargetId?: InputMaybe<Scalars['ID']['input']>;
  fsfType: FsfType;
  /** 表单ID或token */
  id: Scalars['ID']['input'];
  serialNumber: Scalars['Int']['input'];
};

/** Autogenerated return type of UpdateFieldStateFlow */
export type UpdateFieldStateFlowPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  entry?: Maybe<Entry>;
  errors?: Maybe<Array<Error>>;
};

/** Autogenerated input type of UpdateFormCooperator */
export type UpdateFormCooperatorInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 外部联系人权限 */
  externalAttachAbilities?: InputMaybe<Array<FormRoleUserExternalAbilitiesType>>;
  /** 表单ID或token */
  id: Scalars['ID']['input'];
  /** 表单角色id */
  roleId: Scalars['ID']['input'];
  /** 被选中协作者的user_id */
  userId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateFormCooperator */
export type UpdateFormCooperatorPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  cooperator?: Maybe<FormCooperators>;
  errors?: Maybe<Array<Error>>;
};

/** Autogenerated input type of UpdateFormEntry */
export type UpdateFormEntryInput = {
  /** 客户端ID */
  cid?: InputMaybe<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  entryAttributes: Scalars['JSON']['input'];
  /** 表单的使用场景 */
  formUsage?: InputMaybe<FormUsage>;
  /** 表单ID或token */
  id: Scalars['ID']['input'];
  /** 本地版本号 */
  localEditedVersion?: InputMaybe<Scalars['Int']['input']>;
  serialNumber: Scalars['Int']['input'];
  /** 默认跳过版本检查 */
  skipEditedVersionCheck?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of UpdateFormEntry */
export type UpdateFormEntryPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  entry?: Maybe<Entry>;
  errors?: Maybe<Array<Error>>;
};

/** Autogenerated input type of UpdateFormEntryRemark */
export type UpdateFormEntryRemarkInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 表单的使用场景 */
  formUsage?: InputMaybe<FormUsage>;
  /** 表单ID或token */
  id: Scalars['ID']['input'];
  /** 备注信息 */
  remark: Scalars['String']['input'];
  /** 数据序号 */
  serialNumber: Scalars['Int']['input'];
};

/** Autogenerated return type of UpdateFormEntryRemark */
export type UpdateFormEntryRemarkPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  status?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of UpdateFormFieldAPICodeAlias */
export type UpdateFormFieldApiCodeAliasInput = {
  apiCode: Scalars['String']['input'];
  apiCodeAlias: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  formId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateFormFieldAPICodeAlias */
export type UpdateFormFieldApiCodeAliasPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  /** Whether the update succeed */
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Autogenerated input type of UpdateFormFolder */
export type UpdateFormFolderInput = {
  attributes?: InputMaybe<FormFolderAttributes>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 文件夹ID或token */
  folderId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateFormFolder */
export type UpdateFormFolderPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  formFolder?: Maybe<FormFolder>;
};

/** Autogenerated input type of UpdateForm */
export type UpdateFormInput = {
  attributes: FormAttributes;
  /** 客户端ID */
  cid?: InputMaybe<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 表单ID或token */
  id: Scalars['ID']['input'];
  /** 本地版本号 */
  localEditedVersion?: InputMaybe<Scalars['Int']['input']>;
  /** 默认跳过版本检查 */
  skipEditedVersionCheck?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated input type of UpdateFormLayout */
export type UpdateFormLayoutInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 表单ID或token */
  id: Scalars['ID']['input'];
  /** 表单布局 */
  layout?: InputMaybe<Layout>;
};

/** Autogenerated return type of UpdateFormLayout */
export type UpdateFormLayoutPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  form?: Maybe<Form>;
};

/** Autogenerated return type of UpdateForm */
export type UpdateFormPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  form?: Maybe<Form>;
};

/** Autogenerated input type of UpdateFormSetting */
export type UpdateFormSettingInput = {
  /** 表单设置 */
  attributes?: InputMaybe<FormSettingAttributes>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 表单ID或token */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateFormSetting */
export type UpdateFormSettingPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  setting?: Maybe<FormSetting>;
};

/** Autogenerated input type of UpdateFormSymbol */
export type UpdateFormSymbolInput = {
  attributes: FormSymbolAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 表单ID或token */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateFormSymbol */
export type UpdateFormSymbolPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  ensuredSymbol: FormSymbol;
  errors?: Maybe<Array<Error>>;
};

/** Autogenerated input type of UpdateFormView */
export type UpdateFormViewInput = {
  attributes: FormViewUpdateAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateFormView */
export type UpdateFormViewPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  formView?: Maybe<FormViewType>;
};

/** Autogenerated input type of UpdateInvoiceTitle */
export type UpdateInvoiceTitleInput = {
  /** 抬头属性 */
  attributes: InvoiceTitleAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateInvoiceTitle */
export type UpdateInvoiceTitlePayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  invoiceTitle?: Maybe<InvoiceTitle>;
};

/** Autogenerated input type of UpdateLocale */
export type UpdateLocaleInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Available values: ["en"] */
  locale: Scalars['String']['input'];
};

/** Autogenerated return type of UpdateLocale */
export type UpdateLocalePayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
};

/** Autogenerated input type of UpdateMobile */
export type UpdateMobileInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  isPreValidate?: InputMaybe<Scalars['Boolean']['input']>;
  isValidateByPassword?: InputMaybe<Scalars['Boolean']['input']>;
  mobileNo: Scalars['String']['input'];
  newMobileVerificationCode?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  verificationCode?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateMobile */
export type UpdateMobilePayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  user?: Maybe<User>;
};

/** Autogenerated input type of UpdateOpenEntry */
export type UpdateOpenEntryInput = {
  attributes: OpenEntryAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 表单ID或token */
  id: Scalars['ID']['input'];
  openEntryId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateOpenEntry */
export type UpdateOpenEntryPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  openEntry?: Maybe<OpenEntry>;
};

/** Autogenerated input type of UpdateOpenResult */
export type UpdateOpenResultInput = {
  /** 结果分享属性 */
  attributes: OpenResultAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 表单ID或token */
  id: Scalars['ID']['input'];
  /** 待更新的结果分享id */
  openResultId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateOpenResult */
export type UpdateOpenResultPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  openResult?: Maybe<OpenResult>;
};

/** Autogenerated input type of UpdateOpenSearch */
export type UpdateOpenSearchInput = {
  /** 对外查询属性 */
  attributes: OpenSearchAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 表单ID或token */
  id: Scalars['ID']['input'];
  /** 待更新的对外查询id */
  openSearchId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateOpenSearch */
export type UpdateOpenSearchPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  openSearch?: Maybe<OpenSearch>;
};

/** Autogenerated input type of UpdatePassword */
export type UpdatePasswordInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  currentPassword?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  passwordConfirmation: Scalars['String']['input'];
};

/** Autogenerated return type of UpdatePassword */
export type UpdatePasswordPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  status?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of UpdatePaymentAccount */
export type UpdatePaymentAccountInput = {
  /** 更新参数 */
  attributes: PaymentAccountAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 支付账号ID */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdatePaymentAccount */
export type UpdatePaymentAccountPayload = {
  account?: Maybe<PaymentAccount>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
};

/** Autogenerated input type of UpdatePaymentRedirectExceptionRules */
export type UpdatePaymentRedirectExceptionRulesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 表单ID或token */
  id: Scalars['ID']['input'];
  /** 跳过支付规则 */
  rulesAttributes?: InputMaybe<Array<PaymentRedirectExceptionRuleAttributes>>;
};

/** Autogenerated return type of UpdatePaymentRedirectExceptionRules */
export type UpdatePaymentRedirectExceptionRulesPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  form?: Maybe<Form>;
};

/** Autogenerated input type of UpdatePhantomForm */
export type UpdatePhantomFormInput = {
  /** 更新幻象表单参数 */
  attributes: PhantomFormAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 幻象表单ID或token */
  formToken?: InputMaybe<Scalars['ID']['input']>;
  /** 模板ID或token */
  templateToken: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdatePhantomForm */
export type UpdatePhantomFormPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  result?: Maybe<Scalars['JSON']['output']>;
};

/** Autogenerated input type of UpdateProfile */
export type UpdateProfileInput = {
  attributes: ProfileAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateProfile */
export type UpdateProfilePayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  user?: Maybe<User>;
};

/** Autogenerated input type of UpdatePseudoForm */
export type UpdatePseudoFormInput = {
  attributes: PseudoFormAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 表单ID或token */
  id: Scalars['ID']['input'];
  pseudoFormId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdatePseudoForm */
export type UpdatePseudoFormPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  pseudoForm?: Maybe<PseudoForm>;
};

/** Autogenerated input type of UpdateReversedAssociationSetting */
export type UpdateReversedAssociationSettingInput = {
  /** 关联字段：是否允许反向关联 */
  allowReverseAssociation: Scalars['Boolean']['input'];
  /** 关联表单-关联字段的apiCode */
  associationFieldApiCode: Scalars['ID']['input'];
  /** 关联表单的id */
  associationFormId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 表单ID或token */
  id: Scalars['ID']['input'];
  /** 关联字段：反向展示字段的apiCodes */
  reverseDisplayFieldApiCodes: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of UpdateReversedAssociationSetting */
export type UpdateReversedAssociationSettingPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  form?: Maybe<Form>;
  updated?: Maybe<Scalars['Boolean']['output']>;
};

/** Autogenerated input type of UpdateSMSSignature */
export type UpdateSmsSignatureInput = {
  attributes: SmsSignatureAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  smsSignatureId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateSMSSignature */
export type UpdateSmsSignaturePayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  smsSignature?: Maybe<Signature>;
};

/** Autogenerated input type of UpdateSession */
export type UpdateSessionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  key?: InputMaybe<SessionKey>;
  value?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of UpdateSession */
export type UpdateSessionPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  value?: Maybe<Scalars['Boolean']['output']>;
};

/** Autogenerated input type of UpdateShareSetting */
export type UpdateShareSettingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 待更新的文件夹ID */
  folderId?: InputMaybe<Scalars['ID']['input']>;
  /** 文件夹协作类型 */
  folderRoleUsersAttributes?: InputMaybe<Array<FormFolderRoleUsersAttributes>>;
  /** 文件夹协作类型 */
  shareType?: InputMaybe<FormFolderShareType>;
};

/** Autogenerated return type of UpdateShareSetting */
export type UpdateShareSettingPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  formFolder?: Maybe<FormFolder>;
};

/** Autogenerated input type of UpdateSingleEntryShareSetting */
export type UpdateSingleEntryShareSettingInput = {
  attributes: SingleEntryShareAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 表单ID或token */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateSingleEntryShareSetting */
export type UpdateSingleEntryShareSettingPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  singleEntryShare?: Maybe<SingleEntryShare>;
};

export type UpdateSubmitterGroupAttributes = {
  /** Portal 的登录方式 */
  authTypes?: InputMaybe<Array<GroupAuthTypesEnum>>;
  /** 用于双字段登录的字段 */
  dualAuthApiCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** 填表人群组名称 */
  name?: InputMaybe<Scalars['String']['input']>;
  /** 客户属性字段 */
  selectedFormFields?: InputMaybe<Array<SubmitterFieldAttributes>>;
  /** Submitter生成规则 */
  submitterRule?: InputMaybe<SubmitterRuleAttributes>;
};

/** Autogenerated input type of UpdateSystemIncidentAction */
export type UpdateSystemIncidentActionInput = {
  attributes: SystemIncidentActionAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateSystemIncidentAction */
export type UpdateSystemIncidentActionPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  incident?: Maybe<SystemIncident>;
};

/** Autogenerated input type of UpdateTable */
export type UpdateTableInput = {
  attributes: FormAttributes;
  /** 客户端ID */
  cid?: InputMaybe<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 表格ID或token */
  id: Scalars['ID']['input'];
  /** 本地版本号 */
  localEditedVersion?: InputMaybe<Scalars['Int']['input']>;
  /** 默认跳过版本检查 */
  skipEditedVersionCheck?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of UpdateTable */
export type UpdateTablePayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  form?: Maybe<Form>;
};

/** Autogenerated input type of UpdateUsageScenarios */
export type UpdateUsageScenariosInput = {
  attributes: UsageScenariosAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateUsageScenarios */
export type UpdateUsageScenariosPayload = {
  billingAccount?: Maybe<BillingAccount>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
};

/** Autogenerated input type of UpdateUserAppSetting */
export type UpdateUserAppSettingInput = {
  attributes: UserAppSettingAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateUserAppSetting */
export type UpdateUserAppSettingPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  userAppSetting?: Maybe<AppSetting>;
};

/** Autogenerated input type of UpdateUserBaseFileTag */
export type UpdateUserBaseFileTagInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 更新标签名称 */
  name: Scalars['String']['input'];
  /** 标签ID */
  tagId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateUserBaseFileTag */
export type UpdateUserBaseFileTagPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
};

/** Autogenerated input type of UpdateUserExtrainfo */
export type UpdateUserExtrainfoInput = {
  attributes: UserExtrainfoAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateUserExtrainfo */
export type UpdateUserExtrainfoPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  extrainfo?: Maybe<Extrainfo>;
};

/** Autogenerated input type of UpdateUserFormAppSetting */
export type UpdateUserFormAppSettingInput = {
  attributes: FormAppSettingAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 表单ID或token */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateUserFormAppSetting */
export type UpdateUserFormAppSettingPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  userFormAppSetting?: Maybe<UserFormAppSetting>;
};

/** Autogenerated input type of UpdateUserFormSetting */
export type UpdateUserFormSettingInput = {
  attributes: Array<UserFormSettingAttributes>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateUserFormSetting */
export type UpdateUserFormSettingPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  userFormSettings?: Maybe<Array<UserFormSetting>>;
};

/** Autogenerated input type of UpdateUserPlan */
export type UpdateUserPlanInput = {
  attributes: UserPlanAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of UpdateUserSetting */
export type UpdateUserSettingInput = {
  attributes: UserSettingAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateUserSetting */
export type UpdateUserSettingPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  userSetting?: Maybe<UserSetting>;
};

/** Autogenerated input type of UpdateUserSubmitterGroupSetting */
export type UpdateUserSubmitterGroupSettingInput = {
  attributes: UpdateUserSubmitterGroupSettingAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  groupToken: Scalars['String']['input'];
};

/** Autogenerated return type of UpdateUserSubmitterGroupSetting */
export type UpdateUserSubmitterGroupSettingPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  userSubmitterGroupSetting?: Maybe<UserSubmitterGroupSetting>;
};

export type Usage = {
  /** 是否可以开启套餐试用 */
  canUseFeatureTrial?: Maybe<Scalars['Boolean']['output']>;
  /** 可试用的套餐 */
  featureTrialPlan?: Maybe<Plan>;
  /** 试用中套餐的剩余天数or可试用套餐的试用天数 */
  featureTrialRemainingDay?: Maybe<Scalars['Int']['output']>;
  /** 模板上是否有付费功能 */
  hasPaidFeature: Scalars['Boolean']['output'];
  /** 选用模板需要的最低套餐 */
  lowestPlanToUse?: Maybe<Plan>;
  /** 模板上可以试用的插件 */
  trialableApps: Array<DoorkeeperApplication>;
  /** 模板上可以试用的高级功能 */
  trialableFormApps: Array<Application>;
  /** 模板上不可用的插件 */
  unavailableApps: Array<DoorkeeperApplication>;
  /** 模板上不可用的高级功能 */
  unavailableFormApps: Array<Application>;
  /** 模板不可用的高级功能 */
  unusableFeatures?: Maybe<Array<PaidFeature>>;
};

export enum UsageScenarioKey {
  CommodityOrder = 'commodity_order',
  Communication = 'communication',
  DailySummary = 'daily_summary',
  EventRegistration = 'event_registration',
  InformationRegistration = 'information_registration',
  Invitation = 'invitation',
  OnlineDraw = 'online_draw',
  OnlineExam = 'online_exam',
  Other = 'other',
  Questionnaire = 'questionnaire',
  Recruitment = 'recruitment',
  Voting = 'voting'
}

export type UsageScenarios = {
  key: UsageScenarioKey;
  name: Scalars['String']['output'];
};

export type UsageScenariosAttributes = {
  /** 用户选择的使用场景[多选] */
  usageScenarios?: InputMaybe<Array<UsageScenarioKey>>;
  /** 用户选择使用场景时，如果选择了[其它]，此字段用于记录[其它]的值 */
  usageScenariosOther?: InputMaybe<Scalars['String']['input']>;
};

export type User = {
  accountDestroyable: Scalars['Boolean']['output'];
  accountDisabled: Scalars['Boolean']['output'];
  /** @deprecated removed */
  accountLimited?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated removed */
  accountLimitedUntil?: Maybe<Scalars['ISO8601DateTime']['output']>;
  apiLicence?: Maybe<ApiLicence>;
  /** User jti token，用于移动端登录/会话 */
  apiToken?: Maybe<Scalars['String']['output']>;
  appSetting: AppSetting;
  authToken?: Maybe<Scalars['String']['output']>;
  authentications?: Maybe<Array<Authentication>>;
  /** 仅支持在currentUser中直接调用 */
  authorizedApplications?: Maybe<DoorkeeperApplicationConnection>;
  availableNavigations: Array<Navigation>;
  avatarUrl?: Maybe<Scalars['String']['output']>;
  billingAccount: BillingAccount;
  /** 用户在所加入的所有企业下的身份 */
  billingAccountUsers: Array<User>;
  canBackToLegacyVersion?: Maybe<Scalars['Boolean']['output']>;
  /** 仅支持在currentUser中直接调用 */
  coupons: Array<Coupon>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  createdFormsCount: Scalars['Int']['output'];
  /** 用户在系统中展示的名字，优先级为：企业身份下的名字 -> 微信昵称 -> 昵称 -> 邮箱 -> 手机号 */
  displayName: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  emailVerified?: Maybe<Scalars['Boolean']['output']>;
  entriesCountOfCreatedForms: Scalars['Int']['output'];
  extrainfo?: Maybe<Extrainfo>;
  fillerIdentity?: Maybe<FillerIdentity>;
  /** 用户创建的文件夹 */
  formFolders?: Maybe<Array<FormFolder>>;
  /** 用户创建的标签 */
  formTags?: Maybe<Array<FormTag>>;
  /** 是否关注金数据公众号；调用微信API结果做60秒缓存 */
  gdWeixinAccountSubscribed?: Maybe<Scalars['Boolean']['output']>;
  /** 浩客用户属性 */
  howxmUserProperties?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  /** 用户的身份信息 */
  idCardInfo?: Maybe<IdCardInfo>;
  /** 是否是模板中心管理员 */
  isTemplateAdmin?: Maybe<Scalars['Boolean']['output']>;
  /** 是否金数据商户平台管理员 */
  isTradeAdmin?: Maybe<Scalars['Boolean']['output']>;
  mixpanelUser: MixpanelUser;
  mobile?: Maybe<Scalars['String']['output']>;
  /** 用户在企业身份下的姓名 */
  name?: Maybe<Scalars['String']['output']>;
  needResetPassword: Scalars['Boolean']['output'];
  neverUsedNext: Scalars['Boolean']['output'];
  nickName?: Maybe<Scalars['String']['output']>;
  /** currentUser的通知消息 */
  notifications: NotificationConnection;
  /** 创建用于续费、升级、购买插件/VAS等订单时的凭证 */
  paymentJwt?: Maybe<Scalars['String']['output']>;
  /** 用户个人 Access Token 列表（仅活跃） */
  personalAccessTokens?: Maybe<Array<PersonalAccessToken>>;
  role: UserRole;
  showCustomerService: Scalars['Boolean']['output'];
  /** 是否展示企业试用横幅广告 */
  showEnterpriseTrialAd: Scalars['Boolean']['output'];
  /** 是否展示user system warning(套餐到期、VAS不足等) */
  showSystemWarning: Scalars['Boolean']['output'];
  stats: UserStats;
  status: UserStatus;
  /** 表单回收站 */
  trashedForms?: Maybe<TrashedFormConnection>;
  /**
   * 是否可以使用 CKEditor 5
   * @deprecated toggle 已移除，始终为 true
   */
  useCk5?: Maybe<Scalars['Boolean']['output']>;
  /** 该用户当前应看新版 Tables 表格（用户显式选择优先，否则跟随账户灰度） */
  useDataTables: Scalars['Boolean']['output'];
  userEntryFilter?: Maybe<EntryFilter>;
  /** User identity id */
  userIdentityId: Scalars['ID']['output'];
  userSetting?: Maybe<UserSetting>;
  weixinBind?: Maybe<Scalars['Boolean']['output']>;
  weixinQiyeUser?: Maybe<WeixinQiyeUser>;
};


export type UserApiTokenArgs = {
  appIdentity: AppIdentity;
};


export type UserAuthorizedApplicationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type UserCanBackToLegacyVersionArgs = {
  page?: InputMaybe<Scalars['String']['input']>;
};


export type UserCreatedFormsCountArgs = {
  layout?: InputMaybe<Layout>;
  scene?: InputMaybe<Scene>;
};


export type UserDisplayNameArgs = {
  privacyProtect?: InputMaybe<Scalars['Boolean']['input']>;
};


export type UserFormFoldersArgs = {
  kind?: InputMaybe<BaseFileKindEnum>;
};


export type UserFormTagsArgs = {
  withUntagged?: InputMaybe<Scalars['Boolean']['input']>;
};


export type UserNotificationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  client?: InputMaybe<TargetClientEnum>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  read?: InputMaybe<Scalars['Boolean']['input']>;
  verb?: InputMaybe<Scalars['String']['input']>;
};


export type UserTrashedFormsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type UserUserEntryFilterArgs = {
  formToken: Scalars['ID']['input'];
  useAs?: InputMaybe<EntryFilterUseAsType>;
};

export type UserAppSettingAttributes = {
  /** 表单数据通知开关[true-打开，false-关闭] */
  formNotificationEnabled: Scalars['Boolean']['input'];
};

export type UserApplication = {
  /** 试用到期时间 */
  expiredAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  ownedStatus: UserApplicationOwnedStatus;
  /** 购买时的套餐类型 */
  planByPurchased?: Maybe<Scalars['String']['output']>;
};

export enum UserApplicationOwnedStatus {
  /** Free limit */
  FreeLimit = 'free_limit',
  /** Gift */
  Gift = 'gift',
  /** Package */
  Package = 'package',
  /** Purchased */
  Purchased = 'purchased',
  /** Trial */
  Trial = 'trial'
}

export type UserAttributes = {
  /** 姓名 */
  name?: InputMaybe<Scalars['String']['input']>;
  /** 子账号的角色 */
  role?: InputMaybe<UserRole>;
  /** 子账号的状态 */
  status?: InputMaybe<UserStatus>;
};

/** The connection type for User. */
export type UserConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<UserEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<User>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export enum UserCreatedFrom {
  /** Activation */
  Activation = 'activation',
  /** Ding talk */
  DingTalk = 'ding_talk',
  /** Invitation */
  Invitation = 'invitation',
  /** Signup */
  Signup = 'signup',
  /** Tencent meeting */
  TencentMeeting = 'tencent_meeting',
  /** Weixin qiye */
  WeixinQiye = 'weixin_qiye'
}

/** An edge in a connection. */
export type UserEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<User>;
};

export type UserExtrainfoAttributes = {
  /** 是否已查看NEXT欢迎页 */
  nextWelcomeViewed?: InputMaybe<Scalars['Boolean']['input']>;
  /** 是否切换到NEXT */
  useNextUi?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserFormAppSetting = {
  /** 表单数据通知开关[true-打开，false-关闭] */
  appNotificationEnabled: Scalars['Boolean']['output'];
};

export type UserFormApplication = NotImplementedApplication | WheelFortune;

export type UserFormApplicationUsage = {
  appCode: FormApplicationAppCode;
  expired?: Maybe<Scalars['Boolean']['output']>;
  expiredAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** 是否是企业版插件 */
  isE30Usage: Scalars['Boolean']['output'];
  purchased?: Maybe<Scalars['Boolean']['output']>;
  /** 当前是否在正在试用 */
  trialNow?: Maybe<Scalars['Boolean']['output']>;
  /** 是否当前为企业版套餐并且插件为个人版 */
  upgradeWithoutApplication: Scalars['Boolean']['output'];
};

export enum UserFormQrcodeStyle {
  /** Qrcode only */
  QrcodeOnly = 'qrcode_only',
  /** With title and footer */
  WithTitleAndFooter = 'with_title_and_footer'
}

export type UserFormSetting = {
  /** 新数据邮件提醒 */
  emailNotification?: Maybe<Scalars['Boolean']['output']>;
  /** 表单是否被收藏，true - 是，false - 否 */
  favored?: Maybe<Scalars['Boolean']['output']>;
  /** 当前用户对于当前表单的父文件夹 */
  folder?: Maybe<FormFolder>;
  /** 表单ID */
  formId: Scalars['ID']['output'];
  /** 默认视图 */
  formView?: Maybe<FormViewType>;
  /** 表单是否置顶，true - 是，false - 否 */
  pinned?: Maybe<Scalars['Boolean']['output']>;
  /** 数据页面显示哪些列 */
  preferColumns: Array<Scalars['String']['output']>;
  /** 表单分享链接类型 */
  publishedUrlDomain?: Maybe<PublishedUrlDomainEnum>;
  /** 码点颜色，多个值表示渐变色 */
  qrcodeBodyColors: Array<Scalars['String']['output']>;
  /** 码眼颜色，多个值表示渐变色 */
  qrcodeEyesColors: Array<Scalars['String']['output']>;
  /** 二维码下方的自定义文案 */
  qrcodeFooterText?: Maybe<Scalars['String']['output']>;
  /** 用户自定义的二维码LOGO */
  qrcodeLogo?: Maybe<Attachment>;
  /** 用户自定义的二维码下载样式 */
  qrcodeStyle?: Maybe<UserFormQrcodeStyle>;
  /** 二维码的标题 */
  qrcodeTitle?: Maybe<Scalars['String']['output']>;
  /** 用户自定义列顺序 */
  sortedColumns?: Maybe<Array<EntryColumn>>;
  /** 标签ID数组 */
  tagIds?: Maybe<Array<Scalars['ID']['output']>>;
  /** 新数据微信提醒 */
  weixinNotification?: Maybe<Scalars['Boolean']['output']>;
  /** 交易成功微信提醒，需用户显式开启 */
  weixinPaymentNotification?: Maybe<Scalars['Boolean']['output']>;
};

export type UserFormSettingAttributes = {
  /** 新数据邮件提醒 */
  emailNotification?: InputMaybe<Scalars['Boolean']['input']>;
  /** 是否被收藏 */
  favored?: InputMaybe<Scalars['Boolean']['input']>;
  /** 表单ID */
  formId: Scalars['ID']['input'];
  /** 默认视图ID */
  formViewId?: InputMaybe<Scalars['ID']['input']>;
  /** 是否置顶 */
  pinned?: InputMaybe<Scalars['Boolean']['input']>;
  /** 数据页面显示哪些列 */
  preferColumns?: InputMaybe<Array<Scalars['String']['input']>>;
  /** 设置表单分享链接类型 */
  publishedUrlDomain?: InputMaybe<PublishedUrlDomainEnum>;
  /** 二维码码点颜色，多个值表示渐变色 */
  qrcodeBodyColors?: InputMaybe<Array<Scalars['String']['input']>>;
  /** 二维码码眼颜色，多个值表示渐变色 */
  qrcodeEyesColors?: InputMaybe<Array<Scalars['String']['input']>>;
  /** 二维码下方的自定义文案 */
  qrcodeFooterText?: InputMaybe<Scalars['String']['input']>;
  /** 用户自定义的二维码LOGO */
  qrcodeLogoId?: InputMaybe<Scalars['ID']['input']>;
  /** 用户自定义的二维码下载样式 */
  qrcodeStyle?: InputMaybe<UserFormQrcodeStyle>;
  /** 二维码的标题 */
  qrcodeTitle?: InputMaybe<Scalars['String']['input']>;
  /** 用户自定义列顺序 */
  sortedColumns?: InputMaybe<Array<EntryColumnAttributes>>;
  /** 新数据微信提醒 */
  weixinNotification?: InputMaybe<Scalars['Boolean']['input']>;
  /** 交易成功微信提醒 */
  weixinPaymentNotification?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserInvitation = {
  email?: Maybe<Scalars['String']['output']>;
  externalUser?: Maybe<User>;
  id: Scalars['ID']['output'];
  mobileNo?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  role: UserInvitationRole;
};

export type UserInvitationAttributes = {
  /** 邮箱或手机号 */
  emailOrMobileNo: Scalars['String']['input'];
  /** 表单已添加的协作者用户 ID，用于接受邀请时转移权限至新用户 */
  externalUserId?: InputMaybe<Scalars['ID']['input']>;
  /** 姓名（用于子账号接受邀请时姓名字段的默认值） */
  name?: InputMaybe<Scalars['String']['input']>;
  /** 子账号角色 */
  role: UserInvitationRole;
};

/** The connection type for UserInvitation. */
export type UserInvitationConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<UserInvitationEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<UserInvitation>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type UserInvitationEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<UserInvitation>;
};

export enum UserInvitationRole {
  /** Admin */
  Admin = 'admin',
  /** Outworker */
  Outworker = 'outworker',
  /** Worker */
  Worker = 'worker'
}

export type UserInviteLink = {
  /** 企业成员角色 */
  role: UserRole;
  /** 企业成员邀请链接Token */
  token: Scalars['String']['output'];
  /** 企业成员邀请链接 */
  url: Scalars['String']['output'];
};

export type UserPlan = {
  /** 套餐到期时间 */
  endDate?: Maybe<Scalars['Date']['output']>;
  /** 对应的套餐信息 */
  plan: Plan;
  /** 套餐开始时间 */
  startDate?: Maybe<Scalars['Date']['output']>;
};

export type UserPlanAttributes = {
  /** true - 已通知，false - 未通知 */
  expiredNoticed?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum UserRole {
  /** Admin */
  Admin = 'admin',
  /** Outworker */
  Outworker = 'outworker',
  /** Owner */
  Owner = 'owner',
  /** Worker */
  Worker = 'worker'
}

export type UserSetting = {
  emailDailySummary: Scalars['Boolean']['output'];
  /** Available values: ["en"] */
  locale: Scalars['String']['output'];
  weixinNotificationEnabled: Scalars['Boolean']['output'];
};

export type UserSettingAttributes = {
  emailDailySummary?: InputMaybe<Scalars['Boolean']['input']>;
  /** Available values: ["en"] */
  locale?: InputMaybe<Scalars['String']['input']>;
  /** Support 'false' value only */
  weixinNotificationEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserStats = {
  /** 用户下的表单今日提交量 */
  formFillCount: Scalars['Int']['output'];
  /** 用户下的表单今日浏览量 */
  formViewCount: Scalars['Int']['output'];
};

export enum UserStatus {
  /** Active */
  Active = 'active',
  /** Disabled */
  Disabled = 'disabled'
}

export type VasStats = {
  date: Scalars['ID']['output'];
  usageCount: Scalars['Float']['output'];
};

export enum VasUsageType {
  AiPoints = 'ai_points',
  AudioQuota = 'audio_quota',
  EntryQuota = 'entry_quota',
  SmsAndEmail = 'sms_and_email',
  StorageQuota = 'storage_quota'
}

/** Autogenerated input type of ValidatePublishedFormFields */
export type ValidatePublishedFormFieldsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  entryAttributes: Scalars['JSON']['input'];
  entryToken?: InputMaybe<Scalars['ID']['input']>;
  formId: Scalars['ID']['input'];
  /** 用与隐身模式的 token */
  incognitoToken?: InputMaybe<Scalars['String']['input']>;
  /** 凭密码填写时用户输入的密码 */
  password?: InputMaybe<Scalars['String']['input']>;
  routeType?: InputMaybe<PublishedFormRoute>;
  xFieldWeixinOpenid?: InputMaybe<Scalars['ID']['input']>;
  xFieldWeixinUnionid?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of ValidatePublishedFormFields */
export type ValidatePublishedFormFieldsPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
};

export type ValidationResult = {
  valueType?: Maybe<ValueTypeEnum>;
};

export enum ValueTypeEnum {
  /** 日期 */
  Datetime = 'datetime',
  /** 数字 */
  Numeric = 'numeric',
  /** 字符串 */
  String = 'string'
}

export enum Vas {
  ActiveMail = 'active_mail',
  AiPoints = 'ai_points',
  AudioQuota = 'audio_quota',
  EntryQuota = 'entry_quota',
  EntryTransactionQuota = 'entry_transaction_quota',
  MerchantEntryTransactionQuota = 'merchant_entry_transaction_quota',
  Other = 'other',
  Sms = 'sms',
  StorageQuota = 'storage_quota'
}

export type VasBalance = {
  /** 账户余额抵扣 */
  balanceUsage: Scalars['Float']['output'];
  /** 单独购买余量 */
  boughtBalance: Scalars['BigInteger']['output'];
  /** 已用量 */
  consumedQuota: Scalars['BigInteger']['output'];
  /** 月套餐余量 */
  currentMonthBalance: Scalars['BigInteger']['output'];
  /** 总余量 */
  totalBalance: Scalars['BigInteger']['output'];
  /** 总量 */
  totalQuota: Scalars['BigInteger']['output'];
};

export type VasPackage = {
  amount: Scalars['Int']['output'];
  price: Scalars['Int']['output'];
};

export type VisitInfo = {
  data: Array<LoginLog>;
  date: Scalars['Date']['output'];
};

/** The connection type for VisitInfo. */
export type VisitInfoConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<VisitInfoEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<VisitInfo>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type VisitInfoEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<VisitInfo>;
};

export type VisualAttributes = {
  name: Scalars['String']['input'];
  namespace?: InputMaybe<Scalars['String']['input']>;
  value: Scalars['String']['input'];
};

export type Webhook = Base & {
  /** 推送类型 */
  approach: Approach;
  cachedFormName: Scalars['String']['output'];
  /** 推送/短信/邮件内容 */
  content?: Maybe<Scalars['String']['output']>;
  entry?: Maybe<Entry>;
  /** 错误信息 */
  errorMessage?: Maybe<Scalars['String']['output']>;
  form?: Maybe<Form>;
  id: Scalars['ID']['output'];
  /** 发送时间（不等于任务触发时间） */
  performedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** 收件人，常用于短信和邮件 */
  recipient?: Maybe<Scalars['String']['output']>;
  /** 返回内容 */
  responseBody?: Maybe<Scalars['String']['output']>;
  /** 状态码 */
  responseCode?: Maybe<Scalars['String']['output']>;
  /** 状态 */
  status: Status;
  /** 推送地址 */
  url?: Maybe<Scalars['String']['output']>;
};

export type WebhookHistoryWebhookFailureActivity = {
  formInfo: FormActivityBaseInfo;
};

export type WebhookRule = BaseRule & {
  /** 推送类型 */
  approach: Approach;
  /** 发送条件字段 api_code */
  conditionKey?: Maybe<Scalars['String']['output']>;
  /** 发送条件的值 */
  conditionValue?: Maybe<Scalars['String']['output']>;
  /** true: 开启ScopeCondition */
  conditionalScope?: Maybe<Scalars['Boolean']['output']>;
  /** 最后一次失败时间 */
  disabledAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** 任务禁用原因，仅 enabled: false 时有效 */
  disabledBy?: Maybe<DisabledBy>;
  /** 任务是否开启 */
  enabled: Scalars['Boolean']['output'];
  /** 是否为支付条件 */
  entryPaid?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  /** 最后一次失败的错误信息 */
  lastErrorMessage?: Maybe<Scalars['String']['output']>;
  /** 发送量 */
  notificationsCount?: Maybe<Scalars['Int']['output']>;
  /** 按周期重复发送 */
  repeatRule?: Maybe<RepeatRule>;
  /** 基于数据定制规则发送 */
  scheduleRule?: Maybe<ScheduleRule>;
  /** 基于日期发送的规则 */
  scheduleTimeRule?: Maybe<ScheduleTimeRule>;
  /** ScopeCondition条件组 */
  scopeConditions?: Maybe<Array<ScopeCondition>>;
  /** 指定发送时间 */
  sendAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** 何时发送 */
  sendTiming?: Maybe<SendTiming>;
  /** 推送范围 */
  triggerScope: TriggerScope;
  /** 更新时间 */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Webhook推送地址 */
  url?: Maybe<Scalars['String']['output']>;
};

export type WeixinAccount = {
  /** Weixin API Account ID */
  apiAccountId?: Maybe<Scalars['ID']['output']>;
  /** 公众号头像 */
  headImg?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** 是否为商户公众号 */
  isMerchant?: Maybe<Scalars['Boolean']['output']>;
  /** 公众号名称 */
  nickName?: Maybe<Scalars['String']['output']>;
  /** 是否通过验证 */
  verified?: Maybe<Scalars['Boolean']['output']>;
};

export type WeixinAccountAuthData = {
  /** 认证成功时API Account ID */
  apiAccountId?: Maybe<Scalars['String']['output']>;
  /** 未认证成功时错误信息 */
  errorMessages?: Maybe<Array<Scalars['String']['output']>>;
  /** 具体的失败类型 */
  failedReason?: Maybe<WeixinAccountAuthFailedReason>;
  /** 认证成功时微信账号头像 */
  headImg?: Maybe<Scalars['String']['output']>;
  /** 认证成功时微信账号ID */
  weixinAccountId?: Maybe<Scalars['String']['output']>;
  /** 认证成功时微信账号名称 */
  weixinAccountName?: Maybe<Scalars['String']['output']>;
  /** 是否认证成功 */
  weixinAuth: Scalars['String']['output'];
};

export enum WeixinAccountAuthFailedReason {
  /** 添加数量超出上限 */
  ExceedLimit = 'exceed_limit'
}

export type WeixinBind = {
  /** 失败原因 */
  errors?: Maybe<Array<Scalars['String']['output']>>;
  /** 是否绑定成功 */
  state: Scalars['Boolean']['output'];
};

/** Autogenerated input type of WeixinBind */
export type WeixinBindInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  force?: InputMaybe<Scalars['Boolean']['input']>;
  wxOpenId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of WeixinBind */
export type WeixinBindPayload = {
  bindMsg?: Maybe<WeixinBind>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
};

export type WeixinCustomizedThumbnailAttachment = {
  fileHeight?: Maybe<Scalars['Int']['output']>;
  fileWidth?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  selected: Scalars['Boolean']['output'];
  url: Scalars['String']['output'];
};

export type WeixinLoginData = {
  appid: Scalars['String']['output'];
  redirectUri: Scalars['String']['output'];
  state: Scalars['String']['output'];
};

export type WeixinOauthData = {
  accessToken?: Maybe<Scalars['ID']['output']>;
  errmsg?: Maybe<Scalars['String']['output']>;
  openid?: Maybe<Scalars['ID']['output']>;
  /** 微信 openid 的签名。legacy react app 使用的是 cookies 校验。next webapp 因为跨域，使用本参数进行校验。 */
  openidSign?: Maybe<Scalars['String']['output']>;
  userInfo?: Maybe<Scalars['JSON']['output']>;
};

export type WeixinOnetime = Base & {
  /** 推送类型 */
  approach: Approach;
  cachedFormName: Scalars['String']['output'];
  /** 推送/短信/邮件内容 */
  content?: Maybe<Scalars['String']['output']>;
  entry?: Maybe<Entry>;
  /** 错误信息 */
  errorMessage?: Maybe<Scalars['String']['output']>;
  form?: Maybe<Form>;
  id: Scalars['ID']['output'];
  /** 发送时间（不等于任务触发时间） */
  performedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** 收件人，常用于短信和邮件 */
  recipient?: Maybe<Scalars['String']['output']>;
  /** 状态 */
  status: Status;
  /** 消息标题 */
  subject: Scalars['String']['output'];
};

export type WeixinOnetimeRule = BaseRule & {
  /** 推送类型 */
  approach: Approach;
  /** 发送条件字段 api_code */
  conditionKey?: Maybe<Scalars['String']['output']>;
  /** 发送条件的值 */
  conditionValue?: Maybe<Scalars['String']['output']>;
  /** true: 开启ScopeCondition */
  conditionalScope?: Maybe<Scalars['Boolean']['output']>;
  /** 消息内容 */
  content?: Maybe<Scalars['String']['output']>;
  /** 任务禁用原因，仅 enabled: false 时有效 */
  disabledBy?: Maybe<DisabledBy>;
  /** 任务是否开启 */
  enabled: Scalars['Boolean']['output'];
  /** 是否为支付条件 */
  entryPaid?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  /** 发送量 */
  notificationsCount?: Maybe<Scalars['Int']['output']>;
  /** 按周期重复发送 */
  repeatRule?: Maybe<RepeatRule>;
  /** 基于数据定制规则发送 */
  scheduleRule?: Maybe<ScheduleRule>;
  /** 基于日期发送的规则 */
  scheduleTimeRule?: Maybe<ScheduleTimeRule>;
  /** ScopeCondition条件组 */
  scopeConditions?: Maybe<Array<ScopeCondition>>;
  /** 指定发送时间 */
  sendAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** 何时发送 */
  sendTiming?: Maybe<SendTiming>;
  /** 消息标题 */
  subject?: Maybe<Scalars['String']['output']>;
  /** 推送范围 */
  triggerScope: TriggerScope;
  /** 更新时间 */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** 微信一次性消息跳转链接 */
  weixinOnetimeUrl?: Maybe<Scalars['String']['output']>;
};

export enum WeixinOpenScanScene {
  AccountDeletion = 'account_deletion',
  NewEntryNotification = 'new_entry_notification'
}

export type WeixinProperties = {
  weixinAccessToken?: Maybe<Scalars['ID']['output']>;
  xFieldWeixinHeadimgurl?: Maybe<Scalars['String']['output']>;
  xFieldWeixinNickname?: Maybe<Scalars['String']['output']>;
  xFieldWeixinOpenid?: Maybe<Scalars['ID']['output']>;
  xFieldWeixinUnionid?: Maybe<Scalars['ID']['output']>;
};

export type WeixinQiyeAccount = {
  accountType?: Maybe<Scalars['String']['output']>;
  corpName?: Maybe<Scalars['String']['output']>;
  corpid?: Maybe<Scalars['String']['output']>;
};

export type WeixinQiyeDepartment = {
  departmentId?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  parentDepartmentId?: Maybe<Scalars['Int']['output']>;
};

export type WeixinQiyeStructure = {
  departments: Array<WeixinQiyeDepartment>;
  users: Array<WeixinQiyeUser>;
};

export type WeixinQiyeUser = {
  departmentIds?: Maybe<Array<Scalars['Int']['output']>>;
  departmentName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  userid: Scalars['String']['output'];
};

export type WeixinShareInfo = {
  /** 微信分享描述 */
  description?: Maybe<Scalars['String']['output']>;
  /** 微信分享标题 */
  name?: Maybe<Scalars['String']['output']>;
};

export type WeixinShareInfoAttributes = {
  /** 微信分享-描述 */
  description?: InputMaybe<Scalars['String']['input']>;
  /** 微信分享-标题 */
  name?: InputMaybe<Scalars['String']['input']>;
};

export type WeixinShareThumbnailAttributes = {
  /** 微信分享-系统内置图标名称 */
  predefinedThumbnailName?: InputMaybe<Scalars['String']['input']>;
  /** 微信分享-自定义图标id */
  weixinCustomizedThumbnailId?: InputMaybe<Scalars['ID']['input']>;
  /** 微信分享-是否选中自定义图标 */
  weixinCustomizedThumbnailSelected?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WeixinThumbnail = {
  /** 用户自定义微信分享图标 */
  customizedThumbnailAttachment?: Maybe<WeixinCustomizedThumbnailAttachment>;
  /** 如果使用了系统预设的图标，此值为图标的文件名 */
  predefinedThumbnailName?: Maybe<Scalars['String']['output']>;
  /** 分享到微信的链接图标的URL */
  url: Scalars['String']['output'];
};

export type WheelFortune = {
  /** 幸运大转盘 - 兑奖设置 */
  cash?: Maybe<Cash>;
  /** 幸运大转盘 - 是否过期：true - 是；false - 否（大转盘试用中为false，非试用中的大转盘且套餐过期则为true） */
  expired: Scalars['Boolean']['output'];
  /** 表单插件关联表单 */
  form: Form;
  /** 是否已有其他表单插件 */
  hasSiblingFormApplication: Scalars['Boolean']['output'];
  /** 插件ID */
  id: Scalars['ID']['output'];
  /** 幸运大转盘 - 中奖设置 */
  lottery?: Maybe<Lottery>;
  /** 当前应该进行的下一步设置：prize_setting - 奖品设置，lotter_setting - 中奖设置，cash_setting - 兑奖设置，finished - 文案设置 */
  nextSettingStep: SettingStep;
  /** 插件开关：true - 已开启，false - 未开启 */
  opened: Scalars['Boolean']['output'];
  /** 幸运大转盘关联奖项 */
  prizes?: Maybe<Array<Prize>>;
  /** 大转盘是否完成所有配置 */
  settingFinished: Scalars['Boolean']['output'];
  /** 当前已经完成至第几步设置：prize_setting - 奖品设置，lotter_setting - 中奖设置，cash_setting - 兑奖设置，finished - 文案设置 */
  settingStep: SettingStep;
  /** 幸运大转盘 - 文案设置 */
  text?: Maybe<Text>;
};

export type Widget = {
  label?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  series?: Maybe<Series>;
};

export type WidgetButton = AssociatedField & BaseField & FieldAbility & PlanAvailableField & {
  apiCode: Scalars['ID']['output'];
  apiCodeAlias?: Maybe<Scalars['String']['output']>;
  /** 对应的表单关联字段 */
  associationField?: Maybe<Field>;
  /** 按钮集 */
  buttons?: Maybe<Array<WidgetsButtonItemType>>;
  /** 按钮数量 */
  buttonsNumber?: Maybe<Scalars['Int']['output']>;
  /** 自动填写上次提交内容 */
  cacheData: Scalars['Boolean']['output'];
  /** 客户端ID */
  cid?: Maybe<Scalars['String']['output']>;
  /** 封装的字段类型 */
  customizedType?: Maybe<Scalars['String']['output']>;
  /** 封装的字段类型文本 */
  customizedTypeName?: Maybe<Scalars['String']['output']>;
  /** 自定义出错文案 */
  customizedValidationMessage?: Maybe<Scalars['String']['output']>;
  /** 已提交的数据是否可被编辑 */
  editable: Scalars['Boolean']['output'];
  /** 该字段能否使用字段规则: true - 能， false - 不能 */
  fieldRuleAvailable: Scalars['Boolean']['output'];
  /** 固定在底部 */
  fixedToBottom?: Maybe<Scalars['Boolean']['output']>;
  /** 是否是关联主键字段 */
  forAssociated?: Maybe<Scalars['Boolean']['output']>;
  /** 是否是关联展示字段 */
  forAssociatedDisplay?: Maybe<Scalars['Boolean']['output']>;
  /** 表单Token */
  formToken: Scalars['String']['output'];
  /** 宽度占用整行的四分之几 */
  gridsToOccupy?: Maybe<Scalars['Int']['output']>;
  hasAbility: Scalars['Boolean']['output'];
  /** 字段标题（去富文本化） */
  label?: Maybe<Scalars['String']['output']>;
  /** 字段描述，富文本 */
  notes?: Maybe<Scalars['String']['output']>;
  paidFeature?: Maybe<PaidFeature>;
  planAvailable: Scalars['Boolean']['output'];
  /** 字段排序 */
  position: Scalars['Int']['output'];
  /** 该字段是否是隐私字段 true - 是, false - 不是 */
  privacy: Scalars['Boolean']['output'];
  /** 字段隐藏 */
  private: Scalars['Boolean']['output'];
  /** 字段是否通过预填写表单预设了值 true - 是, false - 否 */
  pseudoFormPredefined?: Maybe<Scalars['Boolean']['output']>;
  /** 字段标题（富文本化） */
  rawLabel?: Maybe<Scalars['String']['output']>;
  /** 字段是否只读，无法编辑 */
  readonly?: Maybe<Scalars['Boolean']['output']>;
  /** 该字段是否属于评分字段（e.g. 考试、测评中的题目） */
  scorable: Scalars['Boolean']['output'];
  /** 字段提示较长时折叠展示 */
  showPartDescription: Scalars['Boolean']['output'];
  /** 新起一行 */
  startNewRow: Scalars['Boolean']['output'];
  /** 该字段是否可以作为文本插入 true - 能, false - 不能 */
  textPlaceholderable: Scalars['Boolean']['output'];
  /** 字段类型 */
  type: FieldClass;
  /** 字段类型文本 */
  typeName: Scalars['String']['output'];
  /** 字段验证规则 */
  validations?: Maybe<Array<FieldValidation>>;
};


export type WidgetButtonHasAbilityArgs = {
  key: FieldAbilityEnum;
};


export type WidgetButtonNotesArgs = {
  sanitize?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WidgetContact = AssociatedField & BaseField & FieldAbility & PlanAvailableField & {
  apiCode: Scalars['ID']['output'];
  apiCodeAlias?: Maybe<Scalars['String']['output']>;
  /** 对应的表单关联字段 */
  associationField?: Maybe<Field>;
  /** 自动填写上次提交内容 */
  cacheData: Scalars['Boolean']['output'];
  /** 客户端ID */
  cid?: Maybe<Scalars['String']['output']>;
  /** 封装的字段类型 */
  customizedType?: Maybe<Scalars['String']['output']>;
  /** 封装的字段类型文本 */
  customizedTypeName?: Maybe<Scalars['String']['output']>;
  /** 自定义出错文案 */
  customizedValidationMessage?: Maybe<Scalars['String']['output']>;
  /** 已提交的数据是否可被编辑 */
  editable: Scalars['Boolean']['output'];
  /** 该字段能否使用字段规则: true - 能， false - 不能 */
  fieldRuleAvailable: Scalars['Boolean']['output'];
  /** 是否是关联主键字段 */
  forAssociated?: Maybe<Scalars['Boolean']['output']>;
  /** 是否是关联展示字段 */
  forAssociatedDisplay?: Maybe<Scalars['Boolean']['output']>;
  /** 表单Token */
  formToken: Scalars['String']['output'];
  /** 宽度占用整行的四分之几 */
  gridsToOccupy?: Maybe<Scalars['Int']['output']>;
  hasAbility: Scalars['Boolean']['output'];
  /** 字段标题（去富文本化） */
  label?: Maybe<Scalars['String']['output']>;
  /** 字段描述，富文本 */
  notes?: Maybe<Scalars['String']['output']>;
  paidFeature?: Maybe<PaidFeature>;
  /** 电话集 */
  phones?: Maybe<Array<WidgetPhoneItemType>>;
  planAvailable: Scalars['Boolean']['output'];
  /** 字段排序 */
  position: Scalars['Int']['output'];
  /** 该字段是否是隐私字段 true - 是, false - 不是 */
  privacy: Scalars['Boolean']['output'];
  /** 字段隐藏 */
  private: Scalars['Boolean']['output'];
  /** 字段是否通过预填写表单预设了值 true - 是, false - 否 */
  pseudoFormPredefined?: Maybe<Scalars['Boolean']['output']>;
  /** 字段标题（富文本化） */
  rawLabel?: Maybe<Scalars['String']['output']>;
  /** 字段是否只读，无法编辑 */
  readonly?: Maybe<Scalars['Boolean']['output']>;
  /** 该字段是否属于评分字段（e.g. 考试、测评中的题目） */
  scorable: Scalars['Boolean']['output'];
  /** 字段提示较长时折叠展示 */
  showPartDescription: Scalars['Boolean']['output'];
  /** 新起一行 */
  startNewRow: Scalars['Boolean']['output'];
  /** 该字段是否可以作为文本插入 true - 能, false - 不能 */
  textPlaceholderable: Scalars['Boolean']['output'];
  /** 字段类型 */
  type: FieldClass;
  /** 字段类型文本 */
  typeName: Scalars['String']['output'];
  /** 字段验证规则 */
  validations?: Maybe<Array<FieldValidation>>;
  /** 图片集 */
  widgetImages?: Maybe<Array<WidgetsFieldItemImageType>>;
  /** 最大图片数量 */
  widgetMaxImagesNumber?: Maybe<Scalars['Int']['output']>;
};


export type WidgetContactHasAbilityArgs = {
  key: FieldAbilityEnum;
};


export type WidgetContactNotesArgs = {
  sanitize?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WidgetMap = AssociatedField & BaseField & FieldAbility & PlanAvailableField & {
  apiCode: Scalars['ID']['output'];
  apiCodeAlias?: Maybe<Scalars['String']['output']>;
  /** 对应的表单关联字段 */
  associationField?: Maybe<Field>;
  /** 自动填写上次提交内容 */
  cacheData: Scalars['Boolean']['output'];
  /** 客户端ID */
  cid?: Maybe<Scalars['String']['output']>;
  /** 封装的字段类型 */
  customizedType?: Maybe<Scalars['String']['output']>;
  /** 封装的字段类型文本 */
  customizedTypeName?: Maybe<Scalars['String']['output']>;
  /** 自定义出错文案 */
  customizedValidationMessage?: Maybe<Scalars['String']['output']>;
  /** 已提交的数据是否可被编辑 */
  editable: Scalars['Boolean']['output'];
  /** 该字段能否使用字段规则: true - 能， false - 不能 */
  fieldRuleAvailable: Scalars['Boolean']['output'];
  /** 是否是关联主键字段 */
  forAssociated?: Maybe<Scalars['Boolean']['output']>;
  /** 是否是关联展示字段 */
  forAssociatedDisplay?: Maybe<Scalars['Boolean']['output']>;
  /** 表单Token */
  formToken: Scalars['String']['output'];
  /** 宽度占用整行的四分之几 */
  gridsToOccupy?: Maybe<Scalars['Int']['output']>;
  hasAbility: Scalars['Boolean']['output'];
  /** 字段标题（去富文本化） */
  label?: Maybe<Scalars['String']['output']>;
  /** 纬度 */
  latitude?: Maybe<Scalars['String']['output']>;
  /** 允许填写者在手机上自行标注位置 */
  localizableOnMobile: Scalars['Boolean']['output'];
  /** 经度 */
  longitude?: Maybe<Scalars['String']['output']>;
  /** 静态地图图片 */
  mapImage?: Maybe<Attachment>;
  /** 导航地址 */
  navAddress?: Maybe<Scalars['String']['output']>;
  /** 字段描述，富文本 */
  notes?: Maybe<Scalars['String']['output']>;
  paidFeature?: Maybe<PaidFeature>;
  planAvailable: Scalars['Boolean']['output'];
  /** 字段排序 */
  position: Scalars['Int']['output'];
  /** 该字段是否是隐私字段 true - 是, false - 不是 */
  privacy: Scalars['Boolean']['output'];
  /** 字段隐藏 */
  private: Scalars['Boolean']['output'];
  /** 字段是否通过预填写表单预设了值 true - 是, false - 否 */
  pseudoFormPredefined?: Maybe<Scalars['Boolean']['output']>;
  /** 字段标题（富文本化） */
  rawLabel?: Maybe<Scalars['String']['output']>;
  /** 字段是否只读，无法编辑 */
  readonly?: Maybe<Scalars['Boolean']['output']>;
  /** 该字段是否属于评分字段（e.g. 考试、测评中的题目） */
  scorable: Scalars['Boolean']['output'];
  /** 字段提示较长时折叠展示 */
  showPartDescription: Scalars['Boolean']['output'];
  /** 新起一行 */
  startNewRow: Scalars['Boolean']['output'];
  /** 该字段是否可以作为文本插入 true - 能, false - 不能 */
  textPlaceholderable: Scalars['Boolean']['output'];
  /** 字段类型 */
  type: FieldClass;
  /** 字段类型文本 */
  typeName: Scalars['String']['output'];
  /** 字段验证规则 */
  validations?: Maybe<Array<FieldValidation>>;
};


export type WidgetMapHasAbilityArgs = {
  key: FieldAbilityEnum;
};


export type WidgetMapNotesArgs = {
  sanitize?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WidgetMarquee = AssociatedField & BaseField & FieldAbility & PlanAvailableField & {
  apiCode: Scalars['ID']['output'];
  apiCodeAlias?: Maybe<Scalars['String']['output']>;
  /** 对应的表单关联字段 */
  associationField?: Maybe<Field>;
  /** 跑马灯文字样式 */
  backgroundStyle?: Maybe<WidgetsBackgroundType>;
  /** 自动填写上次提交内容 */
  cacheData: Scalars['Boolean']['output'];
  /** 客户端ID */
  cid?: Maybe<Scalars['String']['output']>;
  /** 封装的字段类型 */
  customizedType?: Maybe<Scalars['String']['output']>;
  /** 封装的字段类型文本 */
  customizedTypeName?: Maybe<Scalars['String']['output']>;
  /** 自定义出错文案 */
  customizedValidationMessage?: Maybe<Scalars['String']['output']>;
  /** 已提交的数据是否可被编辑 */
  editable: Scalars['Boolean']['output'];
  /** 填写人数初始值 */
  entriesInitNumber?: Maybe<Scalars['Int']['output']>;
  /** 显示填写人数 */
  entriesNumberVisible?: Maybe<Scalars['Boolean']['output']>;
  /** 该字段能否使用字段规则: true - 能， false - 不能 */
  fieldRuleAvailable: Scalars['Boolean']['output'];
  /** 是否是关联主键字段 */
  forAssociated?: Maybe<Scalars['Boolean']['output']>;
  /** 是否是关联展示字段 */
  forAssociatedDisplay?: Maybe<Scalars['Boolean']['output']>;
  /** 表单Token */
  formToken: Scalars['String']['output'];
  /** 宽度占用整行的四分之几 */
  gridsToOccupy?: Maybe<Scalars['Int']['output']>;
  hasAbility: Scalars['Boolean']['output'];
  /** 字段标题（去富文本化） */
  label?: Maybe<Scalars['String']['output']>;
  /** 显示行数 */
  lines?: Maybe<Scalars['Int']['output']>;
  /** 跑马灯数据类型 */
  marqueeDataType?: Maybe<Scalars['String']['output']>;
  /** 跑马灯文字样式 */
  marqueeStyle?: Maybe<WidgetsBaseTextStyleType>;
  /** 字段描述，富文本 */
  notes?: Maybe<Scalars['String']['output']>;
  paidFeature?: Maybe<PaidFeature>;
  planAvailable: Scalars['Boolean']['output'];
  /** 字段排序 */
  position: Scalars['Int']['output'];
  /** 该字段是否是隐私字段 true - 是, false - 不是 */
  privacy: Scalars['Boolean']['output'];
  /** 字段隐藏 */
  private: Scalars['Boolean']['output'];
  /** 字段是否通过预填写表单预设了值 true - 是, false - 否 */
  pseudoFormPredefined?: Maybe<Scalars['Boolean']['output']>;
  /** 字段标题（富文本化） */
  rawLabel?: Maybe<Scalars['String']['output']>;
  /** 字段是否只读，无法编辑 */
  readonly?: Maybe<Scalars['Boolean']['output']>;
  /** 该字段是否属于评分字段（e.g. 考试、测评中的题目） */
  scorable: Scalars['Boolean']['output'];
  /** 字段提示较长时折叠展示 */
  showPartDescription: Scalars['Boolean']['output'];
  /** 新起一行 */
  startNewRow: Scalars['Boolean']['output'];
  /** 标题文字样式 */
  subjectStyle?: Maybe<WidgetsBaseTextStyleType>;
  /** 该字段是否可以作为文本插入 true - 能, false - 不能 */
  textPlaceholderable: Scalars['Boolean']['output'];
  /** 字段类型 */
  type: FieldClass;
  /** 字段类型文本 */
  typeName: Scalars['String']['output'];
  /** 字段验证规则 */
  validations?: Maybe<Array<FieldValidation>>;
};


export type WidgetMarqueeHasAbilityArgs = {
  key: FieldAbilityEnum;
};


export type WidgetMarqueeNotesArgs = {
  sanitize?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WidgetPhoneItemType = {
  /** 备注 */
  notes?: Maybe<Scalars['String']['output']>;
  /** 电话 */
  phone?: Maybe<Scalars['String']['output']>;
};

export enum WidgetStatusEnum {
  /** 显示 */
  Active = 'active',
  /** 不显示 */
  Inactive = 'inactive'
}

export enum WidgetTargetTypeEnum {
  /** 表单 */
  Form = 'Form',
  /** 字符串 */
  String = 'String'
}

export type WidgetVideo = AssociatedField & BaseField & FieldAbility & PlanAvailableField & {
  apiCode: Scalars['ID']['output'];
  apiCodeAlias?: Maybe<Scalars['String']['output']>;
  /** 对应的表单关联字段 */
  associationField?: Maybe<Field>;
  /** 自动填写上次提交内容 */
  cacheData: Scalars['Boolean']['output'];
  /** 客户端ID */
  cid?: Maybe<Scalars['String']['output']>;
  /** 封装的字段类型 */
  customizedType?: Maybe<Scalars['String']['output']>;
  /** 封装的字段类型文本 */
  customizedTypeName?: Maybe<Scalars['String']['output']>;
  /** 自定义出错文案 */
  customizedValidationMessage?: Maybe<Scalars['String']['output']>;
  /** 已提交的数据是否可被编辑 */
  editable: Scalars['Boolean']['output'];
  /** 该字段能否使用字段规则: true - 能， false - 不能 */
  fieldRuleAvailable: Scalars['Boolean']['output'];
  /** 是否是关联主键字段 */
  forAssociated?: Maybe<Scalars['Boolean']['output']>;
  /** 是否是关联展示字段 */
  forAssociatedDisplay?: Maybe<Scalars['Boolean']['output']>;
  /** 表单Token */
  formToken: Scalars['String']['output'];
  /** 宽度占用整行的四分之几 */
  gridsToOccupy?: Maybe<Scalars['Int']['output']>;
  hasAbility: Scalars['Boolean']['output'];
  /** 字段标题（去富文本化） */
  label?: Maybe<Scalars['String']['output']>;
  /** 字段描述，富文本 */
  notes?: Maybe<Scalars['String']['output']>;
  paidFeature?: Maybe<PaidFeature>;
  planAvailable: Scalars['Boolean']['output'];
  /** 字段排序 */
  position: Scalars['Int']['output'];
  /** 该字段是否是隐私字段 true - 是, false - 不是 */
  privacy: Scalars['Boolean']['output'];
  /** 字段隐藏 */
  private: Scalars['Boolean']['output'];
  /** 字段是否通过预填写表单预设了值 true - 是, false - 否 */
  pseudoFormPredefined?: Maybe<Scalars['Boolean']['output']>;
  /** 字段标题（富文本化） */
  rawLabel?: Maybe<Scalars['String']['output']>;
  /** 字段是否只读，无法编辑 */
  readonly?: Maybe<Scalars['Boolean']['output']>;
  /** 该字段是否属于评分字段（e.g. 考试、测评中的题目） */
  scorable: Scalars['Boolean']['output'];
  /** 字段提示较长时折叠展示 */
  showPartDescription: Scalars['Boolean']['output'];
  /** 新起一行 */
  startNewRow: Scalars['Boolean']['output'];
  /** 该字段是否可以作为文本插入 true - 能, false - 不能 */
  textPlaceholderable: Scalars['Boolean']['output'];
  /** 字段类型 */
  type: FieldClass;
  /** 字段类型文本 */
  typeName: Scalars['String']['output'];
  /** 字段验证规则 */
  validations?: Maybe<Array<FieldValidation>>;
  /** 视频iframe代码 */
  videoEmbedCode?: Maybe<Scalars['String']['output']>;
  /** 边距 */
  videoPadding?: Maybe<Scalars['String']['output']>;
};


export type WidgetVideoHasAbilityArgs = {
  key: FieldAbilityEnum;
};


export type WidgetVideoNotesArgs = {
  sanitize?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WidgetsBackgroundType = {
  /** 背景色 */
  backgroundColor?: Maybe<Scalars['String']['output']>;
  /** 背景图片 */
  backgroundImage?: Maybe<WidgetsFieldItemImageType>;
  /** 背景图片重复 */
  backgroundImageRepeated?: Maybe<Scalars['Boolean']['output']>;
};

export type WidgetsBaseTextStyleType = {
  /** 字体颜色 */
  fontColor?: Maybe<Scalars['String']['output']>;
  /** 字体 */
  fontFamily?: Maybe<Scalars['String']['output']>;
  /** 字体大小 */
  fontSize?: Maybe<Scalars['Int']['output']>;
  /** 字体字重 */
  fontWeight?: Maybe<Scalars['String']['output']>;
};

export type WidgetsButtonItemAttributes = {
  /** 链接属性 */
  linkAttrs?: InputMaybe<WidgetsLinkAttrsItemAttributes>;
  /** 链接类型 */
  linkType?: InputMaybe<Scalars['String']['input']>;
  /** 位置 */
  position?: InputMaybe<Scalars['Int']['input']>;
  /** 按钮样式 */
  style?: InputMaybe<WidgetsdTextStyleAttributes>;
  /** 按钮标题 */
  text?: InputMaybe<Scalars['String']['input']>;
  /** 二维码图片集 */
  widgetImages?: InputMaybe<Array<WidgetsFieldItemImageAttributes>>;
  /** 二维码图片数量 */
  widgetMaxImagesNumber?: InputMaybe<Scalars['Int']['input']>;
};

export type WidgetsButtonItemType = {
  /** 链接属性 */
  linkAttrs?: Maybe<LinkAttrsItemType>;
  /** 链接类型 */
  linkType?: Maybe<Scalars['String']['output']>;
  /** 位置 */
  position?: Maybe<Scalars['Int']['output']>;
  /** 按钮样式 */
  style?: Maybe<WidgetsTextStyleType>;
  /** 按钮标题 */
  text?: Maybe<Scalars['String']['output']>;
  /** 二维码图片集 */
  widgetImages?: Maybe<Array<WidgetsFieldItemImageType>>;
  /** 二维码图片数量 */
  widgetMaxImagesNumber?: Maybe<Scalars['Int']['output']>;
};

export type WidgetsFieldItemImageAttributes = {
  /** 图片的attachment id */
  attachmentId?: InputMaybe<Scalars['ID']['input']>;
};

export type WidgetsFieldItemImageType = {
  /** 图片原件 */
  attachment?: Maybe<Attachment>;
};

export type WidgetsLinkAttrsItemAttributes = {
  /** 小程序appid */
  appid?: InputMaybe<Scalars['String']['input']>;
  /** 拨打电话 */
  phone?: InputMaybe<Scalars['String']['input']>;
  /** 链接URL */
  url?: InputMaybe<Scalars['String']['input']>;
};

export type WidgetsPhoneFieldAttributes = {
  /** 备注 */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** 电话 */
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type WidgetsTextStyleType = {
  /** 字体背景颜色 */
  backgroundColor?: Maybe<Scalars['String']['output']>;
  /** 字体位置 */
  fontAlignment?: Maybe<Scalars['String']['output']>;
  /** 字体颜色 */
  fontColor?: Maybe<Scalars['String']['output']>;
  /** 字体 */
  fontFamily?: Maybe<Scalars['String']['output']>;
  /** 字体大小 */
  fontSize?: Maybe<Scalars['Int']['output']>;
  /** 字体字重 */
  fontWeight?: Maybe<Scalars['String']['output']>;
};

export type WidgetsdBackgroundStyleAttributes = {
  /** 背景色 */
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  /** 背景图片 */
  backgroundImage?: InputMaybe<WidgetsFieldItemImageAttributes>;
  /** 背景图片重复 */
  backgroundImageRepeated?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WidgetsdBaseTextStyleAttributes = {
  /** 字体颜色 */
  fontColor?: InputMaybe<Scalars['String']['input']>;
  /** 字体 */
  fontFamily?: InputMaybe<Scalars['String']['input']>;
  /** 字体大小 */
  fontSize?: InputMaybe<Scalars['Int']['input']>;
  /** 字体字重 */
  fontWeight?: InputMaybe<Scalars['String']['input']>;
};

export type WidgetsdTextStyleAttributes = {
  /** 字体背景颜色 */
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  /** 字体位置 */
  fontAlignment?: InputMaybe<Scalars['String']['input']>;
  /** 字体颜色 */
  fontColor?: InputMaybe<Scalars['String']['input']>;
  /** 字体 */
  fontFamily?: InputMaybe<Scalars['String']['input']>;
  /** 字体大小 */
  fontSize?: InputMaybe<Scalars['Int']['input']>;
  /** 字体字重 */
  fontWeight?: InputMaybe<Scalars['String']['input']>;
};

export type WithConditionalScope = {
  conditionalScope: Scalars['Boolean']['output'];
  scopeConditions?: Maybe<Array<ScopeCondition>>;
};

export type WithCustomers = {
  customers?: Maybe<CustomerConnection>;
  customersCount?: Maybe<Scalars['Int']['output']>;
};


export type WithCustomersCustomersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type WithCustomersCustomersCountArgs = {
  keyword?: InputMaybe<Scalars['String']['input']>;
};

export type WithDynamicAttrs = {
  /** 包含库存信息的商品字段 */
  inventoryFields?: Maybe<Scalars['JSON']['output']>;
  /** 包含余额的选项类字段 */
  quotableFields?: Maybe<Scalars['JSON']['output']>;
};

export type WithPublishedDomainInfo = {
  /** 实际使用的二级域名。当套餐不可用后，返回系统随机二级域名 */
  activeSubdomain?: Maybe<Scalars['String']['output']>;
  /** 所属 BillingAccount 的cname 信息 */
  cnameSetting: Cname;
};

export type WithRatingsDisplayText = {
  /** 最高分文案 */
  maximumRatingsDisplayText?: Maybe<Scalars['String']['output']>;
  /** 最低分文案 */
  minimumRatingsDisplayText?: Maybe<Scalars['String']['output']>;
};

export type WithRedirectUrl = {
  /** 跳转 URL。如果有值，则优先跳转。 */
  redirectUrl?: Maybe<Scalars['String']['output']>;
};


export type WithRedirectUrlRedirectUrlArgs = {
  code?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  weixinCallbackUrlParams?: InputMaybe<Scalars['JSON']['input']>;
};

export type WithSmsVerification = {
  /** 开启短信验证 */
  smsVerification: Scalars['Boolean']['output'];
  /** 获取验证码前需填写图形验证码 */
  smsVerificationCaptcha: Scalars['Boolean']['output'];
};

export type WithStatementPredefinedValues = {
  statementPredefinedValues?: Maybe<FieldStatementPredefinedValues>;
};

export type WithTextContent = {
  /** 文字描述-描述 */
  description: DisplayFieldsTextContentType;
  /** 文字描述-标题 */
  title: DisplayFieldsTextContentType;
};

export type WithdrawAccount = {
  bankAccount: Scalars['String']['output'];
  bankName: Scalars['String']['output'];
  identityAttachmentUrl: Array<Scalars['String']['output']>;
  identityNumber: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type WithdrawAccountAttributes = {
  /** 银行账号 */
  bankAccount: Scalars['String']['input'];
  /** 开户行 */
  bankName: Scalars['String']['input'];
  /** 身份证图片qiniu链接 */
  identityAttachmentUrl: Array<Scalars['String']['input']>;
  /** 身份证号 */
  identityNumber: Scalars['String']['input'];
  /** 姓名 */
  name: Scalars['String']['input'];
};

export type WordingAttributes = {
  alreadyClosed?: InputMaybe<Scalars['String']['input']>;
  alreadyClosedRichText?: InputMaybe<Scalars['String']['input']>;
  fillFrequencyLimited?: InputMaybe<Scalars['String']['input']>;
  fillFrequencyLimitedHideForm?: InputMaybe<Scalars['String']['input']>;
  fillFrequencyLimitedShowForm?: InputMaybe<Scalars['String']['input']>;
  notOpen?: InputMaybe<Scalars['String']['input']>;
  notOpenHideForm?: InputMaybe<Scalars['String']['input']>;
  notOpenShowForm?: InputMaybe<Scalars['String']['input']>;
  regionLimited?: InputMaybe<Scalars['String']['input']>;
  searchResultByPassword?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['String']['input']>;
  submit?: InputMaybe<Scalars['String']['input']>;
  submitByPassword?: InputMaybe<Scalars['String']['input']>;
  viewResultByPassword?: InputMaybe<Scalars['String']['input']>;
};

export type WordingSetting = {
  /** 表单停止提交 */
  alreadyClosed?: Maybe<Scalars['String']['output']>;
  /** 表单停止提交（富文本） */
  alreadyClosedRichText?: Maybe<Scalars['String']['output']>;
  /** 达到限填次数后 */
  fillFrequencyLimited?: Maybe<Scalars['String']['output']>;
  /** 达到限填次数后（不可查看表单内容） */
  fillFrequencyLimitedHideForm?: Maybe<Scalars['String']['output']>;
  /** 达到限填次数后（可查看表单内容） */
  fillFrequencyLimitedShowForm?: Maybe<Scalars['String']['output']>;
  /** 表单未开放 */
  notOpen?: Maybe<Scalars['String']['output']>;
  /** 表单未开放（不可查看表单内容） */
  notOpenHideForm?: Maybe<Scalars['String']['output']>;
  /** 表单未开放（可查看表单内容） */
  notOpenShowForm?: Maybe<Scalars['String']['output']>;
  /** 限制填写地区 */
  regionLimited?: Maybe<Scalars['String']['output']>;
  /** 凭密码访问对外查询页面 */
  searchResultByPassword?: Maybe<Scalars['String']['output']>;
  /** 开始填写 */
  start?: Maybe<Scalars['String']['output']>;
  /** 表单提交按钮 */
  submit?: Maybe<Scalars['String']['output']>;
  /** 凭密码填写表单 */
  submitByPassword?: Maybe<Scalars['String']['output']>;
  /** 凭密码查看表单结果 */
  viewResultByPassword?: Maybe<Scalars['String']['output']>;
};

export type WxMiniappShareInfo = {
  appId: Scalars['String']['output'];
  path: Scalars['String']['output'];
  qrcodeImage?: Maybe<Scalars['String']['output']>;
};

export enum WxOfficialAccountPublicationChannelTypeEnum {
  /** Article */
  Article = 'article',
  /** Auto response */
  AutoResponse = 'auto_response',
  /** Menu */
  Menu = 'menu'
}

export type WxOfficialAccountPublicationSetting = {
  accountType: WxOfficialAccountTypeEnum;
  channel: WxOfficialAccountPublicationChannelTypeEnum;
  way?: Maybe<WxOfficialAccountPublicationWayTypeEnum>;
};

export type WxOfficialAccountPublicationSettingAttributes = {
  accountType?: InputMaybe<WxOfficialAccountTypeEnum>;
  channel?: InputMaybe<WxOfficialAccountPublicationChannelTypeEnum>;
  way?: InputMaybe<WxOfficialAccountPublicationWayTypeEnum>;
};

export enum WxOfficialAccountPublicationWayTypeEnum {
  /** Article link */
  ArticleLink = 'article_link',
  /** Form link */
  FormLink = 'form_link',
  /** Link code */
  LinkCode = 'link_code',
  /** Miniapp */
  Miniapp = 'miniapp',
  /** Qrcode */
  Qrcode = 'qrcode',
  /** Webpage */
  Webpage = 'webpage'
}

export enum WxOfficialAccountTypeEnum {
  /** Authorized */
  Authorized = 'authorized',
  /** Unauthorized */
  Unauthorized = 'unauthorized',
  /** Wxpay binded */
  WxpayBinded = 'wxpay_binded'
}

export type WxpayAccount = {
  /** 如果配置了支付，当且仅当支付微信号与收集信息的微信公众号是同一个时，该字段为true */
  available: Scalars['Boolean']['output'];
  /** 是否开启H5支付 */
  enableH5Pay?: Maybe<Scalars['Boolean']['output']>;
  /** 是否开启JSAPI支付 */
  enableJsapiPay?: Maybe<Scalars['Boolean']['output']>;
  /** 是否开启NATIVE支付 */
  enableNativePay?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  /** 微信支付商户号 */
  mchId: Scalars['String']['output'];
  /** 商户支付密钥 */
  mchKey: Scalars['String']['output'];
  /** 商户名 */
  mchName: Scalars['String']['output'];
  /** 公众号 */
  weixinAccount?: Maybe<WeixinAccount>;
};

export type Wxwork = Base & {
  /** 推送类型 */
  approach: Approach;
  cachedFormName: Scalars['String']['output'];
  /** 推送/短信/邮件内容 */
  content?: Maybe<Scalars['String']['output']>;
  entry?: Maybe<Entry>;
  /** 错误信息 */
  errorMessage?: Maybe<Scalars['String']['output']>;
  form?: Maybe<Form>;
  id: Scalars['ID']['output'];
  /** 提醒对象 */
  mentionedMobileList?: Maybe<Array<Scalars['String']['output']>>;
  /** 发送时间（不等于任务触发时间） */
  performedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** 收件人，常用于短信和邮件 */
  recipient?: Maybe<Scalars['String']['output']>;
  /** 返回内容 */
  responseBody?: Maybe<Scalars['String']['output']>;
  /** 状态码 */
  responseCode?: Maybe<Scalars['String']['output']>;
  /** 状态 */
  status: Status;
  /** 推送地址 */
  url?: Maybe<Scalars['String']['output']>;
};

export type WxworkRule = BaseRule & {
  /** 推送类型 */
  approach: Approach;
  /** 发送条件字段 api_code */
  conditionKey?: Maybe<Scalars['String']['output']>;
  /** 发送条件的值 */
  conditionValue?: Maybe<Scalars['String']['output']>;
  /** true: 开启ScopeCondition */
  conditionalScope?: Maybe<Scalars['Boolean']['output']>;
  /** 消息邮件内容 */
  content?: Maybe<Scalars['String']['output']>;
  /** 任务禁用原因，仅 enabled: false 时有效 */
  disabledBy?: Maybe<DisabledBy>;
  /** 任务是否开启 */
  enabled: Scalars['Boolean']['output'];
  /** 是否为支付条件 */
  entryPaid?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  /** 最后一次失败的错误信息 */
  lastErrorMessage?: Maybe<Scalars['String']['output']>;
  /** 提醒成员，@全体请传: @all */
  mentionedMobileList?: Maybe<Array<Scalars['String']['output']>>;
  /** 发送量 */
  notificationsCount?: Maybe<Scalars['Int']['output']>;
  /** 按周期重复发送 */
  repeatRule?: Maybe<RepeatRule>;
  /** 基于数据定制规则发送 */
  scheduleRule?: Maybe<ScheduleRule>;
  /** 基于日期发送的规则 */
  scheduleTimeRule?: Maybe<ScheduleTimeRule>;
  /** ScopeCondition条件组 */
  scopeConditions?: Maybe<Array<ScopeCondition>>;
  /** 指定发送时间 */
  sendAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** 何时发送 */
  sendTiming?: Maybe<SendTiming>;
  /** 推送范围 */
  triggerScope: TriggerScope;
  /** 更新时间 */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Webhook推送地址 */
  url?: Maybe<Scalars['String']['output']>;
};

export type YamchaAccount = {
  /** 企业ID */
  corpid: Scalars['String']['output'];
  /** 企业名称 */
  name?: Maybe<Scalars['String']['output']>;
  /** 平台 */
  provider: YamchaProvider;
};

export enum YamchaMemberInfoPathTypeEnum {
  /** Account corpid */
  AccountCorpid = 'account_corpid',
  /** Account department ids */
  AccountDepartmentIds = 'account_department_ids',
  /** Account department names */
  AccountDepartmentNames = 'account_department_names',
  /** Account name */
  AccountName = 'account_name',
  /** Avatar */
  Avatar = 'avatar',
  /** Name */
  Name = 'name',
  /** Out member */
  OutMemberId = 'out_member_id'
}

export enum YamchaProvider {
  /** Ding talk */
  DingTalk = 'ding_talk',
  /** Howxm */
  Howxm = 'howxm'
}

/** Autogenerated input type of cancelOpenEntryReservation */
export type CancelOpenEntryReservationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  entryToken: Scalars['ID']['input'];
  formToken?: InputMaybe<Scalars['ID']['input']>;
  openEntryToken?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of cancelOpenEntryReservation */
export type CancelOpenEntryReservationPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of cancelSubmitterReservation */
export type CancelSubmitterReservationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Entry Token */
  entryToken: Scalars['ID']['input'];
};

/** Autogenerated return type of cancelSubmitterReservation */
export type CancelSubmitterReservationPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Autogenerated input type of checkSmsSignatures */
export type CheckSmsSignaturesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  ids: Array<Scalars['String']['input']>;
};

/** Autogenerated return type of checkSmsSignatures */
export type CheckSmsSignaturesPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  smsSignatures?: Maybe<Array<Signature>>;
};

/** Autogenerated input type of checkSmsTemplate */
export type CheckSmsTemplateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
};

/** Autogenerated return type of checkSmsTemplate */
export type CheckSmsTemplatePayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  smsTemplate?: Maybe<SmsTemplate>;
};

/** Autogenerated input type of clearFormData */
export type ClearFormDataInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 表单ID或token */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of clearFormData */
export type ClearFormDataPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  status?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of copyFormRole */
export type CopyFormRoleInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 待拷贝的表单角色 */
  formRoleId: Scalars['ID']['input'];
  /** 表单ID或token */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of copyFormRole */
export type CopyFormRolePayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  formRole?: Maybe<FormRole>;
};

/** Autogenerated input type of createBillingAccountAPILicence */
export type CreateBillingAccountApiLicenceInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of createBillingAccountAPILicence */
export type CreateBillingAccountApiLicencePayload = {
  apiLicence?: Maybe<ApiLicence>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
};

/** Autogenerated input type of createBillingAccountAccessToken */
export type CreateBillingAccountAccessTokenInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

/** Autogenerated return type of createBillingAccountAccessToken */
export type CreateBillingAccountAccessTokenPayload = {
  accountAccessToken?: Maybe<AccountAccessToken>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
};

/** Autogenerated input type of createContactTagRule */
export type CreateContactTagRuleInput = {
  /** 规则属性 */
  attributes: ContactTagRuleAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 表单ID或token */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of createContactTagRule */
export type CreateContactTagRulePayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  contactTagRules?: Maybe<ContactTagRuleConnection>;
  errors?: Maybe<Array<Error>>;
};


/** Autogenerated return type of createContactTagRule */
export type CreateContactTagRulePayloadContactTagRulesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated input type of createFormAmapStats */
export type CreateFormAmapStatsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  formId: Scalars['ID']['input'];
  routeType?: InputMaybe<PublishedFormRoute>;
  type: Amap;
};

/** Autogenerated return type of createFormAmapStats */
export type CreateFormAmapStatsPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
};

/** Autogenerated input type of createFormPoster */
export type CreateFormPosterInput = {
  attributes: PosterAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 表单ID或token */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of createFormPoster */
export type CreateFormPosterPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  poster?: Maybe<Poster>;
  /** 二维码海报自定义图片/AI生成图片 */
  posterBackground?: Maybe<PosterBackground>;
};

/** Autogenerated input type of createFormReportsExportJob */
export type CreateFormReportsExportJobInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 数据筛选条件 */
  filter?: InputMaybe<EntriesFilterAttributes>;
  /** 表单ID或token */
  id: Scalars['ID']['input'];
  /** 搜索关键字 */
  q?: InputMaybe<Scalars['String']['input']>;
  /** 报表相关设置 */
  reportSettings?: InputMaybe<Scalars['JSON']['input']>;
  /** 导出报表类型 */
  reportType?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of createFormReportsExportJob */
export type CreateFormReportsExportJobPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  /** 导出任务id */
  exportJobId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of createFormRole */
export type CreateFormRoleInput = {
  /** 角色属性 */
  attributes: FormRoleAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 表单ID或token */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of createFormRole */
export type CreateFormRolePayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  formRole?: Maybe<FormRole>;
};

/** Autogenerated input type of createOpenEntries */
export type CreateOpenEntriesInput = {
  attributes: OpenEntryAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 表单ID或token */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of createOpenEntries */
export type CreateOpenEntriesPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  openEntry?: Maybe<OpenEntry>;
};

/** Autogenerated input type of createOpenEntryOauthSession */
export type CreateOpenEntryOauthSessionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  openEntryToken?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of createOpenEntryOauthSession */
export type CreateOpenEntryOauthSessionPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  /** session id: 用于标识当前设备，获取最新扫码登录状态。 */
  id: Scalars['String']['output'];
  /** 第三方登录链接 */
  oauthUrl?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of createOpenEntrySmsVerifyCode */
export type CreateOpenEntrySmsVerifyCodeInput = {
  /** 图形验证码 */
  captchaData?: InputMaybe<VisualAttributes>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  fieldApiCode: Scalars['ID']['input'];
  /** geetest4验证码 */
  geetest4Data?: InputMaybe<Geetest4Attributes>;
  /** geetest验证码 */
  geetestData?: InputMaybe<GeetestAttributes>;
  mobile: Scalars['String']['input'];
  openEntryToken?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of createOpenEntrySmsVerifyCode */
export type CreateOpenEntrySmsVerifyCodePayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Autogenerated input type of createSMSSignature */
export type CreateSmsSignatureInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 公司信用编码 */
  companyId: Scalars['String']['input'];
  /** 公司名称 */
  companyName: Scalars['String']['input'];
  /** 身份证反面照片(人像面)  */
  idCardBackAttachmentId?: InputMaybe<Scalars['ID']['input']>;
  /** 身份证正面照片(国徽面)  */
  idCardFrontAttachmentId?: InputMaybe<Scalars['ID']['input']>;
  /** 经办人身份证名 */
  idCardName: Scalars['String']['input'];
  /** 经办人身份证号 */
  idCardNumber: Scalars['String']['input'];
  /** 经办人手机号码 */
  identityMobile: Scalars['String']['input'];
  /** 公司法人姓名（实名认证用） */
  identityName?: InputMaybe<Scalars['String']['input']>;
  /** 资质证明列表 */
  licenseAttachmentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  signature: Scalars['String']['input'];
  /** 签名类型 */
  type?: InputMaybe<SignatureType>;
};

/** Autogenerated return type of createSMSSignature */
export type CreateSmsSignaturePayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  smsSignature?: Maybe<Signature>;
};

/** Autogenerated input type of createSmtpAccount */
export type CreateSmtpAccountInput = {
  /** 更新参数 */
  attributes: SmtpAccountAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of createSmtpAccount */
export type CreateSmtpAccountPayload = {
  account?: Maybe<SmtpAccount>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
};

/** Autogenerated input type of createSubmitterGroup */
export type CreateSubmitterGroupInput = {
  attributes: SubmitterGroupAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of createSubmitterGroup */
export type CreateSubmitterGroupPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  form?: Maybe<Form>;
  group?: Maybe<SubmitterGroup>;
};

/** Autogenerated input type of createSubmitterOauthLoginSession */
export type CreateSubmitterOauthLoginSessionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  portalToken: Scalars['String']['input'];
  /** 微信或企业微信 */
  provider?: InputMaybe<OauthLoginProvider>;
  /** 认证成功后的跳转参数 */
  redirectionAttributes?: InputMaybe<SubmitterRedirectionAttributes>;
};

/** Autogenerated return type of createSubmitterOauthLoginSession */
export type CreateSubmitterOauthLoginSessionPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  /** session id: 用于标识当前设备，获取最新扫码登录状态。 */
  id: Scalars['String']['output'];
  /** 当前 portal 的微信第三方登录链接 */
  oauthUrl: Scalars['String']['output'];
};

/** Autogenerated input type of createSubmitterPortalSession */
export type CreateSubmitterPortalSessionInput = {
  attributes: SubmitterPortalSessionAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  portalToken: Scalars['String']['input'];
  /** 认证成功后的跳转参数 */
  redirectionAttributes?: InputMaybe<SubmitterRedirectionAttributes>;
};

/** Autogenerated return type of createSubmitterPortalSession */
export type CreateSubmitterPortalSessionPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  /** 认证成功后的跳转链接 */
  redirectUrl?: Maybe<Scalars['String']['output']>;
  sessionId?: Maybe<Scalars['String']['output']>;
  submitters?: Maybe<SubmitterConnection>;
};


/** Autogenerated return type of createSubmitterPortalSession */
export type CreateSubmitterPortalSessionPayloadSubmittersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated input type of createSubmitterResponseRateExportJob */
export type CreateSubmitterResponseRateExportJobInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** submitter导出的条件 */
  conditions?: InputMaybe<SubmitterFilterAttributes>;
  /** 表单的使用场景 */
  formUsage?: InputMaybe<FormUsage>;
  /** 表单ID或token */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of createSubmitterResponseRateExportJob */
export type CreateSubmitterResponseRateExportJobPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Autogenerated input type of createSubmitterSendingTask */
export type CreateSubmitterSendingTaskInput = {
  attributes: SubmitterSendingTaskAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of createSubmitterSendingTask */
export type CreateSubmitterSendingTaskPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  task?: Maybe<SubmitterSendingTask>;
};

/** Autogenerated input type of createSubmitterSmsVerifyCode */
export type CreateSubmitterSmsVerifyCodeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** geetest4验证码 */
  geetest4Data?: InputMaybe<Geetest4Attributes>;
  /** geetest验证码 */
  geetestData?: InputMaybe<GeetestAttributes>;
  phoneNo: Scalars['String']['input'];
  portalToken: Scalars['String']['input'];
};

/** Autogenerated return type of createSubmitterSmsVerifyCode */
export type CreateSubmitterSmsVerifyCodePayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Autogenerated input type of createSubmitterWeixinQiyeLoginSession */
export type CreateSubmitterWeixinQiyeLoginSessionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  portalToken: Scalars['String']['input'];
};

/** Autogenerated return type of createSubmitterWeixinQiyeLoginSession */
export type CreateSubmitterWeixinQiyeLoginSessionPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** session id: 用于标识当前设备，获取最新扫码登录状态。 */
  id: Scalars['String']['output'];
  /** 当前企业的portal的企业微信第三方登录链接。 */
  oauthUrl: Scalars['String']['output'];
};

/** Autogenerated input type of deleteExportJob */
export type DeleteExportJobInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 表单ID或token */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of deleteExportJob */
export type DeleteExportJobPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Autogenerated input type of deleteFormEntries */
export type DeleteFormEntriesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 过滤条件 */
  filter?: InputMaybe<EntriesFilterAttributes>;
  /** 表单的使用场景 */
  formUsage?: InputMaybe<FormUsage>;
  /** 表单ID或token */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of deleteFormEntries */
export type DeleteFormEntriesPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  /** 删除后的提示消息，如：该数据占用的选项名额已恢复 */
  message?: Maybe<Scalars['String']['output']>;
  /** 删除成功的数据序号 */
  serialNumbers?: Maybe<Array<Scalars['Int']['output']>>;
};

/** Autogenerated input type of deleteSmtpAccount */
export type DeleteSmtpAccountInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** SMTP账号ID */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of deleteSmtpAccount */
export type DeleteSmtpAccountPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Autogenerated input type of deleteSubmitterPortalSession */
export type DeleteSubmitterPortalSessionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  portalToken: Scalars['String']['input'];
};

/** Autogenerated return type of deleteSubmitterPortalSession */
export type DeleteSubmitterPortalSessionPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Autogenerated input type of destroyContactTagRule */
export type DestroyContactTagRuleInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 表单ID或token */
  id: Scalars['ID']['input'];
  /** 待删除的联系人规则id */
  ruleId: Scalars['ID']['input'];
};

/** Autogenerated return type of destroyContactTagRule */
export type DestroyContactTagRulePayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  status?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of destroyEntriesBatchJob */
export type DestroyEntriesBatchJobInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 表单的使用场景 */
  formUsage?: InputMaybe<FormUsage>;
  /** 表单ID或token */
  id: Scalars['ID']['input'];
  /** ID */
  jobId: Scalars['ID']['input'];
  /** 任务类型 */
  type: EntriesBatchJobTypeType;
};

/** Autogenerated return type of destroyEntriesBatchJob */
export type DestroyEntriesBatchJobPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
};

/** Autogenerated input type of destroyEntriesExportJob */
export type DestroyEntriesExportJobInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 表单的使用场景 */
  formUsage?: InputMaybe<FormUsage>;
  /** 表单ID或token */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of destroyEntriesExportJob */
export type DestroyEntriesExportJobPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
};

/** Autogenerated input type of destroyEntryAttachmentsTask */
export type DestroyEntryAttachmentsTaskInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 表单的使用场景 */
  formUsage?: InputMaybe<FormUsage>;
  /** 表单ID或token */
  id: Scalars['ID']['input'];
  /** ID */
  taskId: Scalars['ID']['input'];
};

/** Autogenerated return type of destroyEntryAttachmentsTask */
export type DestroyEntryAttachmentsTaskPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
};

/** Autogenerated input type of destroyFormRole */
export type DestroyFormRoleInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 表单角色ID */
  formRoleId: Scalars['ID']['input'];
  /** 表单ID或token */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of destroyFormRole */
export type DestroyFormRolePayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  status?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of destroySMSSignature */
export type DestroySmsSignatureInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 短信签名ID */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of destroySMSSignature */
export type DestroySmsSignaturePayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Autogenerated input type of destroySMSTemplate */
export type DestroySmsTemplateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 短信模板ID */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of destroySMSTemplate */
export type DestroySmsTemplatePayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Autogenerated input type of destroySubmitterGroup */
export type DestroySubmitterGroupInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['ID']['input'];
};

/** Autogenerated return type of destroySubmitterGroup */
export type DestroySubmitterGroupPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
};

/** Autogenerated input type of destroySubmitterSocialIdentity */
export type DestroySubmitterSocialIdentityInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  provider: IdentityProvider;
};

/** Autogenerated return type of destroySubmitterSocialIdentity */
export type DestroySubmitterSocialIdentityPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentSubmitter?: Maybe<Submitter>;
  errors?: Maybe<Array<Error>>;
};

/** Autogenerated input type of destroyWheelFortuneWinner */
export type DestroyWheelFortuneWinnerInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 表单的使用场景 */
  formUsage?: InputMaybe<FormUsage>;
  /** 表单ID或token */
  id: Scalars['ID']['input'];
  serialNumber: Scalars['Int']['input'];
  winnerId: Scalars['ID']['input'];
};

/** Autogenerated return type of destroyWheelFortuneWinner */
export type DestroyWheelFortuneWinnerPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  entry?: Maybe<Entry>;
  errors?: Maybe<Array<Error>>;
};

export type GdPortalAppendedFieldMappingAttributes = {
  /** 字段apiCode，新字段不传或传null */
  apiCode?: InputMaybe<Scalars['ID']['input']>;
  /** 字段标题 */
  label?: InputMaybe<Scalars['String']['input']>;
  /** 字段排序标识 */
  position: Scalars['Int']['input'];
};

export type GdPortalAssetsType = {
  /** 类型 */
  assetsType?: Maybe<GdPortalAssetsTypeEnum>;
  /** 附件 */
  attachment?: Maybe<Attachment>;
  /** id */
  id: Scalars['ID']['output'];
};

/** 资源类型。icon:图标，picture:图片 */
export enum GdPortalAssetsTypeEnum {
  Icon = 'icon',
  Picture = 'picture'
}

/** Autogenerated input type of gdPortalAuditPendingCustomer */
export type GdPortalAuditPendingCustomerInput = {
  /** 审核记录ID */
  auditLogId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  portalToken?: InputMaybe<Scalars['ID']['input']>;
  /** 审核结果 */
  status: GdPortalCustomerAuditStatus;
};

/** Autogenerated return type of gdPortalAuditPendingCustomer */
export type GdPortalAuditPendingCustomerPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type GdPortalAuditingSettingAttributes = {
  description?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type GdPortalAuditingSettingType = {
  /** 待审核页面文案 */
  description?: Maybe<Scalars['String']['output']>;
  /** 待审核页面标题 */
  title?: Maybe<Scalars['String']['output']>;
};

export enum GdPortalAuthenticationProviderEnum {
  MiniProgram = 'mini_program',
  Passcode = 'passcode',
  Password = 'password',
  Wechat = 'wechat'
}

export type GdPortalBusinessBoundPortalType = BaseProperties & {
  canView: Scalars['Boolean']['output'];
  customerAlias?: Maybe<Scalars['String']['output']>;
  entryWidgetReadableFields?: Maybe<FieldConnection>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  token: Scalars['String']['output'];
  widget?: Maybe<GdPortalWidgetType>;
};


export type GdPortalBusinessBoundPortalTypeEntryWidgetReadableFieldsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  widgetId: Scalars['ID']['input'];
};


export type GdPortalBusinessBoundPortalTypeWidgetArgs = {
  widgetId: Scalars['ID']['input'];
};

/** Autogenerated input type of gdPortalCancelCustomerReservation */
export type GdPortalCancelCustomerReservationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  formToken: Scalars['String']['input'];
  /** 系统内部功能调用，值为true时，跳过套餐校验 */
  internalUse?: InputMaybe<Scalars['Boolean']['input']>;
  serialNumber: Scalars['Int']['input'];
};

/** Autogenerated return type of gdPortalCancelCustomerReservation */
export type GdPortalCancelCustomerReservationPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
};

export type GdPortalCardWidgetType = BaseWidget & {
  coverAttachment?: Maybe<Attachment>;
  /** 图文组件内容 */
  description?: Maybe<Scalars['String']['output']>;
  displayType?: Maybe<GdPortalWidgetDisplayTypeEnum>;
  icon?: Maybe<GdPortalIconType>;
  id: Scalars['ID']['output'];
  image?: Maybe<Attachment>;
  name?: Maybe<Scalars['String']['output']>;
  /** 标题 */
  title?: Maybe<Scalars['String']['output']>;
  type: GdPortalWidgetTypeEnum;
  /** 图片跳转链接 */
  url?: Maybe<Scalars['String']['output']>;
  visibleGroups?: Maybe<Array<GdPortalCustomerGroupType>>;
  visibleType: GdPortalWidgetVisibleTypeEnum;
};

export type GdPortalCodeMappingType = {
  /** 表单字段编码 */
  sourceCode: Scalars['String']['output'];
  /** 客户字段编码 */
  targetCode: Scalars['String']['output'];
};

/** Autogenerated input type of gdPortalCreateAssets */
export type GdPortalCreateAssetsInput = {
  /** 类型 */
  assetsType: GdPortalAssetsTypeEnum;
  /** 附件ID */
  attachmentId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of gdPortalCreateAssets */
export type GdPortalCreateAssetsPayload = {
  /** 资源 */
  assets: GdPortalAssetsType;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
};

/** Autogenerated input type of gdPortalCreateCustomTheme */
export type GdPortalCreateCustomThemeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 详情 */
  detail: Scalars['JSON']['input'];
  /** 元信息 */
  meta?: InputMaybe<Scalars['JSON']['input']>;
  /** 名称 */
  name: Scalars['String']['input'];
};

/** Autogenerated return type of gdPortalCreateCustomTheme */
export type GdPortalCreateCustomThemePayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** 自定义主题 */
  customTheme: GdPortalTheme;
  errors?: Maybe<Array<Error>>;
};

/** Autogenerated input type of gdPortalCreateCustomerField */
export type GdPortalCreateCustomerFieldInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  customerFieldSetting: GdPortalCustomerFieldSettingAttributes;
  /** 字段 */
  field: FieldAttributes;
  portalToken?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of gdPortalCreateCustomerField */
export type GdPortalCreateCustomerFieldPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  portal: GdPortalPortalType;
};

/** Autogenerated input type of gdPortalCreateCustomerGroup */
export type GdPortalCreateCustomerGroupInput = {
  attributes: GdPortalCustomerGroupAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  portalToken?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of gdPortalCreateCustomerGroup */
export type GdPortalCreateCustomerGroupPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  customerGroup?: Maybe<GdPortalCustomerGroupType>;
  errors?: Maybe<Array<Error>>;
};

/** Autogenerated input type of gdPortalCreateCustomer */
export type GdPortalCreateCustomerInput = {
  /** 客户属性 */
  attributes?: InputMaybe<Scalars['JSON']['input']>;
  /** 认证的主键，可以是：微信code、手机、邮箱等 */
  authKey: Scalars['String']['input'];
  authProvider: GdPortalAuthenticationProviderEnum;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 需要加入的群组的Token */
  customerGroupToken?: InputMaybe<Scalars['ID']['input']>;
  /** 姓名 */
  name?: InputMaybe<Scalars['String']['input']>;
  /** 密码 */
  password?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of gdPortalCreateCustomer */
export type GdPortalCreateCustomerPayload = {
  accessToken?: Maybe<Scalars['String']['output']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  customer?: Maybe<Customer>;
  errors?: Maybe<Array<Error>>;
};

/** Autogenerated input type of gdPortalCreateImportJob */
export type GdPortalCreateImportJobInput = {
  attributes: GdPortalCustomerImportJobAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 客户组Token */
  customerGroupToken?: InputMaybe<Scalars['ID']['input']>;
  /** 是否为预导入 */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  portalToken?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of gdPortalCreateImportJob */
export type GdPortalCreateImportJobPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  job?: Maybe<GdPortalCustomerImportJobType>;
};

/** Autogenerated input type of gdPortalCreatePortalAuthorization */
export type GdPortalCreatePortalAuthorizationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 为对应的表单写Cookie */
  formToken?: InputMaybe<Scalars['ID']['input']>;
  /** 为预填写表单写Cookie */
  pseudoFormToken?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of gdPortalCreatePortalAuthorization */
export type GdPortalCreatePortalAuthorizationPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  customer?: Maybe<Customer>;
  errors?: Maybe<Array<Error>>;
};

/** Autogenerated input type of gdPortalCreatePortalCustomerOrder */
export type GdPortalCreatePortalCustomerOrderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of gdPortalCreatePortalCustomerOrder */
export type GdPortalCreatePortalCustomerOrderPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  /** next收银台支付链接，如果不开启则返回nil */
  paymentUrl?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of gdPortalCreatePortal */
export type GdPortalCreatePortalInput = {
  /** Portal属性 */
  attributes?: InputMaybe<GdPortalPortalAttributes>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 模板ID */
  templateId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of gdPortalCreatePortal */
export type GdPortalCreatePortalPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  portal?: Maybe<GdPortalPortalType>;
};

/** Autogenerated input type of gdPortalCreatePortalPv */
export type GdPortalCreatePortalPvInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** pv路径 */
  path: Scalars['String']['input'];
};

/** Autogenerated return type of gdPortalCreatePortalPv */
export type GdPortalCreatePortalPvPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['Int']['output']>;
  errors?: Maybe<Array<Error>>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Autogenerated input type of gdPortalCreatePortalSession */
export type GdPortalCreatePortalSessionInput = {
  /** 认证的主键，可以是：微信code、手机、邮箱等 */
  authKey: Scalars['String']['input'];
  authProvider: GdPortalAuthenticationProviderEnum;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 分组Token */
  customerGroupToken?: InputMaybe<Scalars['String']['input']>;
  /** geetest4验证码 */
  geetest4Data?: InputMaybe<Geetest4Attributes>;
  /** 验证码 */
  passcode?: InputMaybe<Scalars['String']['input']>;
  /** 密码 */
  password?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of gdPortalCreatePortalSession */
export type GdPortalCreatePortalSessionPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  customer?: Maybe<Customer>;
  errors?: Maybe<Array<Error>>;
};

/** Autogenerated input type of gdPortalCreateSMSVerification */
export type GdPortalCreateSmsVerificationInput = {
  /** 图形验证码 */
  captchaData?: InputMaybe<VisualAttributes>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** geetest4验证码 */
  geetest4Data?: InputMaybe<Geetest4Attributes>;
  mobile: Scalars['String']['input'];
};

/** Autogenerated return type of gdPortalCreateSMSVerification */
export type GdPortalCreateSmsVerificationPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Autogenerated input type of gdPortalCreateWeixinPortalSession */
export type GdPortalCreateWeixinPortalSessionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of gdPortalCreateWeixinPortalSession */
export type GdPortalCreateWeixinPortalSessionPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  session: GdPortalWeixinPortalSessionType;
};

export type GdPortalCustomerAuditLogType = {
  /** 审核时间 */
  auditedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** 审核人 */
  auditor?: Maybe<User>;
  /** 用户 */
  baseCustomer?: Maybe<Customer>;
  /** ID */
  id: Scalars['ID']['output'];
  /** 审核状态 */
  status: GdPortalCustomerAuditStatus;
};

/** The connection type for gdPortalCustomerAuditLogType. */
export type GdPortalCustomerAuditLogTypeConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<GdPortalCustomerAuditLogTypeEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<GdPortalCustomerAuditLogType>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type GdPortalCustomerAuditLogTypeEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<GdPortalCustomerAuditLogType>;
};

export enum GdPortalCustomerAuditStatus {
  /** Passed */
  Passed = 'passed',
  /** Pending */
  Pending = 'pending',
  /** Rejected */
  Rejected = 'rejected'
}

export type GdPortalCustomerCodeMappingAttributes = {
  /** 表单字段编码 */
  sourceCode: Scalars['String']['input'];
  /** 客户字段编码 */
  targetCode: Scalars['String']['input'];
};

export type GdPortalCustomerFieldSettingAttributes = {
  apiCode?: InputMaybe<Scalars['String']['input']>;
  /** 是否在个人中心显示 */
  displayAtProfile?: InputMaybe<Scalars['Boolean']['input']>;
  /** 是否允许客户修改 */
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** true 表示需要补充 */
  needAdd?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GdPortalCustomerFieldSettingType = {
  apiCode: Scalars['String']['output'];
  /** 是否在个人中心显示 */
  displayAtProfile?: Maybe<Scalars['Boolean']['output']>;
  /** 是否允许客户修改 */
  editable?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  /** true: 需要补充 */
  needAdd?: Maybe<Scalars['Boolean']['output']>;
};

export enum GdPortalCustomerFieldsContextEnum {
  /** 客户列表 */
  Customers = 'customers'
}

export type GdPortalCustomerFilledDataType = EntriesBaseProperties & {
  _type?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  fieldValues: Scalars['JSON']['output'];
  id: Scalars['ID']['output'];
  serialNumber: Scalars['Int']['output'];
  token?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};


export type GdPortalCustomerFilledDataTypeFieldValuesArgs = {
  fieldsContext?: InputMaybe<FieldsContext>;
};

/** The connection type for gdPortalCustomerFilledDataType. */
export type GdPortalCustomerFilledDataTypeConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<GdPortalCustomerFilledDataTypeEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<GdPortalCustomerFilledDataType>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type GdPortalCustomerFilledDataTypeEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<GdPortalCustomerFilledDataType>;
};

export type GdPortalCustomerFilledFormType = PublishedFormBaseProperties & SceneProperties & {
  allFields?: Maybe<FieldConnection>;
  deleted: Scalars['Boolean']['output'];
  /**
   * 统一给分离、非分离、
   *           M站各处通用的字段规则对外结构，待稳定后，会废除field_rules_group_by_target字段
   */
  fieldRulesGroupByTargetAndOperator?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /** 表单场景 */
  scene: Scene;
  token: Scalars['String']['output'];
  type: BaseFileEnum;
};


export type GdPortalCustomerFilledFormTypeAllFieldsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type GdPortalCustomerGroupAttributes = {
  /** true: 开启ScopeCondition */
  conditionalScope?: InputMaybe<Scalars['Boolean']['input']>;
  /** 客户创建类型 */
  customerCreationType?: InputMaybe<GdPortalCustomerGroupCustomerCreationTypeEnum>;
  /** 标题 */
  name?: InputMaybe<Scalars['String']['input']>;
  /** ScopeCondition条件组 */
  scopeConditions?: InputMaybe<Array<ScopeConditionAttributes>>;
};

export enum GdPortalCustomerGroupCustomerCreationTypeEnum {
  Dynamic = 'dynamic',
  Normal = 'normal'
}

export type GdPortalCustomerGroupType = WithCustomers & {
  boundForms?: Maybe<FormConnection>;
  conditionalScope: Scalars['Boolean']['output'];
  customerCreationType: GdPortalCustomerGroupCustomerCreationTypeEnum;
  customers?: Maybe<CustomerConnection>;
  customersCount?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  /** 群组名称 */
  name: Scalars['String']['output'];
  scopeConditions?: Maybe<Array<ScopeCondition>>;
  token: Scalars['String']['output'];
};


export type GdPortalCustomerGroupTypeBoundFormsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  formToken?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type GdPortalCustomerGroupTypeCustomersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type GdPortalCustomerGroupTypeCustomersCountArgs = {
  keyword?: InputMaybe<Scalars['String']['input']>;
};

export type GdPortalCustomerImportJobAttributes = {
  /** 字段映射关系 */
  appendedFieldMappings?: InputMaybe<Array<GdPortalAppendedFieldMappingAttributes>>;
  /** 客户字段映射关系 */
  codeMappings: Array<GdPortalCustomerCodeMappingAttributes>;
  /** true: 开启ScopeCondition */
  conditionalScope?: InputMaybe<Scalars['Boolean']['input']>;
  /** 表单Id */
  formId: Scalars['ID']['input'];
  /** ScopeCondition条件组 */
  scopeConditions?: InputMaybe<Array<ScopeConditionAttributes>>;
};

export type GdPortalCustomerImportJobType = {
  /** 是否为预检 */
  dryRun?: Maybe<Scalars['Boolean']['output']>;
  /** 是否为预检快速通道 */
  dryRunFastPass?: Maybe<Scalars['Boolean']['output']>;
  /** 失败的数量 */
  failedCount?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  /** 已导入的数量 */
  importedCount?: Maybe<Scalars['Int']['output']>;
  /** 数据导入进度(0~100) */
  processingPercent?: Maybe<Scalars['Int']['output']>;
  /** 实际可导入的数量 */
  realCanImportCount?: Maybe<Scalars['Int']['output']>;
  /** 重复的数量 */
  repeatedCount?: Maybe<Scalars['Int']['output']>;
  /** Job 状态 */
  status: CustomerImportJobStatusEnum;
};

export enum GdPortalCustomerKindEnum {
  /** 普通用户 */
  Customer = 'Customer',
  /** 待审核用户 */
  PendingCustomer = 'PendingCustomer'
}

export type GdPortalCustomerMobileExistsType = {
  /** 是否存在 */
  exists: Scalars['Boolean']['output'];
};

export type GdPortalCustomerRegistrationStatusType = {
  /** false: 当前账号不可合并 */
  customerMergable?: Maybe<Scalars['Boolean']['output']>;
  customerType: Scalars['String']['output'];
  /** @deprecated 请使用password_free字段 */
  needChangePassword: Scalars['Boolean']['output'];
  /** true: 用户未设置过密码 */
  passwordFree: Scalars['Boolean']['output'];
};

/** Autogenerated input type of gdPortalDeleteCustomer */
export type GdPortalDeleteCustomerInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 客户ID */
  customerId: Scalars['ID']['input'];
  portalToken?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of gdPortalDeleteCustomer */
export type GdPortalDeleteCustomerPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** 被删除的CustomerID */
  deletedCustomerId?: Maybe<Scalars['ID']['output']>;
  errors?: Maybe<Array<Error>>;
  message?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of gdPortalDestroyAssets */
export type GdPortalDestroyAssetsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 资源ID */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of gdPortalDestroyAssets */
export type GdPortalDestroyAssetsPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
};

/** Autogenerated input type of gdPortalDestroyCustomTheme */
export type GdPortalDestroyCustomThemeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['ID']['input'];
};

/** Autogenerated return type of gdPortalDestroyCustomTheme */
export type GdPortalDestroyCustomThemePayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
};

/** Autogenerated input type of gdPortalDestroyCustomerField */
export type GdPortalDestroyCustomerFieldInput = {
  /** 字段apiCode */
  apiCode: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  portalToken?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of gdPortalDestroyCustomerField */
export type GdPortalDestroyCustomerFieldPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  portal: GdPortalPortalType;
};

/** Autogenerated input type of gdPortalDestroyCustomerGroup */
export type GdPortalDestroyCustomerGroupInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  customerGroupToken: Scalars['ID']['input'];
  portalToken?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of gdPortalDestroyCustomerGroup */
export type GdPortalDestroyCustomerGroupPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
};

/** Autogenerated input type of gdPortalDestroyPendingCustomer */
export type GdPortalDestroyPendingCustomerInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of gdPortalDestroyPendingCustomer */
export type GdPortalDestroyPendingCustomerPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  status?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of gdPortalDestroyPortal */
export type GdPortalDestroyPortalInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  portalToken?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of gdPortalDestroyPortal */
export type GdPortalDestroyPortalPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
};

/** Autogenerated input type of gdPortalDestroyPortalSession */
export type GdPortalDestroyPortalSessionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of gdPortalDestroyPortalSession */
export type GdPortalDestroyPortalSessionPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  status?: Maybe<Scalars['String']['output']>;
};

export type GdPortalEntryWidgetType = BaseWidget & {
  displayType?: Maybe<GdPortalWidgetDisplayTypeEnum>;
  fieldSettings?: Maybe<Array<GdPortalFieldSettingType>>;
  form?: Maybe<Form>;
  formToken?: Maybe<Scalars['ID']['output']>;
  icon?: Maybe<GdPortalIconType>;
  id: Scalars['ID']['output'];
  image?: Maybe<Attachment>;
  name?: Maybe<Scalars['String']['output']>;
  type: GdPortalWidgetTypeEnum;
  visibleGroups?: Maybe<Array<GdPortalCustomerGroupType>>;
  visibleType: GdPortalWidgetVisibleTypeEnum;
};

export type GdPortalFieldSettingAttributes = {
  /** 字段API Code */
  apiCode: Scalars['String']['input'];
  /** 字段是否可查看 */
  readable: Scalars['Boolean']['input'];
  /** 字段是否可修改 */
  writable: Scalars['Boolean']['input'];
};

export type GdPortalFieldSettingType = {
  apiCode: Scalars['String']['output'];
  label?: Maybe<Scalars['String']['output']>;
  readable?: Maybe<Scalars['Boolean']['output']>;
  writable?: Maybe<Scalars['Boolean']['output']>;
};

export type GdPortalFooterNavigationSettingAttributes = {
  id?: InputMaybe<Scalars['ID']['input']>;
  myProfileIcon?: InputMaybe<Scalars['String']['input']>;
  myProfileText?: InputMaybe<Scalars['String']['input']>;
  workspaceIcon?: InputMaybe<Scalars['String']['input']>;
  workspaceText?: InputMaybe<Scalars['String']['input']>;
};

export type GdPortalFooterNavigationSettingType = {
  id: Scalars['ID']['output'];
  myProfileIcon?: Maybe<Scalars['String']['output']>;
  myProfileText?: Maybe<Scalars['String']['output']>;
  workspaceIcon?: Maybe<Scalars['String']['output']>;
  workspaceText?: Maybe<Scalars['String']['output']>;
};

export type GdPortalFormPortalInfoType = FillInRate & {
  /**
   * 限填的群组
   * @deprecated 请使用 boundGroupTokens
   */
  boundCustomerGroupToken?: Maybe<Scalars['String']['output']>;
  /** 限填的群组Token列表 */
  boundGroupTokens?: Maybe<Array<Scalars['String']['output']>>;
  /** 表单的填写率。当表单未绑定群组，或群组人数为空时，返回空 */
  customerFillInRate?: Maybe<Scalars['Float']['output']>;
  /** 可填写的客户 */
  customers?: Maybe<CustomerConnection>;
  /** 绑定群组的人数 */
  customersCount?: Maybe<Scalars['Int']['output']>;
  /** 已填写的客户 */
  filledCustomers?: Maybe<CustomerConnection>;
  /** 已填写的客户数 */
  filledCustomersCount?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  token: Scalars['String']['output'];
  /** 未填写的客户 */
  unfilledCustomers?: Maybe<CustomerConnection>;
};


export type GdPortalFormPortalInfoTypeCustomerFillInRateArgs = {
  customerGroupToken?: InputMaybe<Scalars['ID']['input']>;
};


export type GdPortalFormPortalInfoTypeCustomersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  customerGroupToken?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type GdPortalFormPortalInfoTypeCustomersCountArgs = {
  customerGroupToken?: InputMaybe<Scalars['ID']['input']>;
};


export type GdPortalFormPortalInfoTypeFilledCustomersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  customerGroupToken?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type GdPortalFormPortalInfoTypeFilledCustomersCountArgs = {
  customerGroupToken?: InputMaybe<Scalars['ID']['input']>;
};


export type GdPortalFormPortalInfoTypeUnfilledCustomersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  customerGroupToken?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export enum GdPortalFormWidgetOpenTargetEnum {
  Form = 'form',
  OpenResult = 'open_result',
  OpenSearch = 'open_search'
}

export enum GdPortalFormWidgetSubmitTypeEnum {
  Authorized = 'authorized',
  CustomerGroup = 'customer_group'
}

export type GdPortalFormWidgetType = BaseWidget & {
  /** 可以填表的分组 */
  authorizedGroups?: Maybe<Array<GdPortalCustomerGroupType>>;
  displayType?: Maybe<GdPortalWidgetDisplayTypeEnum>;
  form?: Maybe<Form>;
  icon?: Maybe<GdPortalIconType>;
  id: Scalars['ID']['output'];
  image?: Maybe<Attachment>;
  name?: Maybe<Scalars['String']['output']>;
  openTargetToken?: Maybe<Scalars['String']['output']>;
  openTargetType: GdPortalFormWidgetOpenTargetEnum;
  path: Scalars['String']['output'];
  /** 谁可以填写 */
  submitType?: Maybe<GdPortalFormWidgetSubmitTypeEnum>;
  type: GdPortalWidgetTypeEnum;
  visibleGroups?: Maybe<Array<GdPortalCustomerGroupType>>;
  visibleType: GdPortalWidgetVisibleTypeEnum;
};

export type GdPortalIconAttributes = {
  /** 资源ID */
  assetsId?: InputMaybe<Scalars['ID']['input']>;
  /** Icon 背景色 */
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  /** Icon 类型 */
  iconType?: InputMaybe<GdPortalIconTypeEnum>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Icon attachment ID */
  imageId?: InputMaybe<Scalars['ID']['input']>;
  /** 系统自定义图标名称 */
  predefinedName?: InputMaybe<Scalars['String']['input']>;
};

export type GdPortalIconType = {
  /** 资源 */
  assets?: Maybe<GdPortalAssetsType>;
  /** Icon 背景色 */
  backgroundColor?: Maybe<Scalars['String']['output']>;
  /** Icon 类型 */
  iconType?: Maybe<GdPortalIconTypeEnum>;
  id: Scalars['ID']['output'];
  /** 图标 */
  image?: Maybe<Attachment>;
  /** 如果使用了系统预设的图标，此值为图标的文件名 */
  predefinedName?: Maybe<Scalars['String']['output']>;
};

/** 资源类型。system:系统图标，custom:用户上传资源 */
export enum GdPortalIconTypeEnum {
  Custom = 'custom',
  System = 'system'
}

export type GdPortalLinkWidgetType = BaseWidget & {
  displayType?: Maybe<GdPortalWidgetDisplayTypeEnum>;
  icon?: Maybe<GdPortalIconType>;
  id: Scalars['ID']['output'];
  image?: Maybe<Attachment>;
  name?: Maybe<Scalars['String']['output']>;
  type: GdPortalWidgetTypeEnum;
  url?: Maybe<Scalars['String']['output']>;
  visibleGroups?: Maybe<Array<GdPortalCustomerGroupType>>;
  visibleType: GdPortalWidgetVisibleTypeEnum;
};

export type GdPortalLoginShortcutSettingAttributes = {
  id?: InputMaybe<Scalars['ID']['input']>;
  loginBtnText?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type GdPortalLoginShortcutSettingType = {
  id: Scalars['ID']['output'];
  loginBtnText?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type GdPortalPageAttributes = {
  id?: InputMaybe<Scalars['ID']['input']>;
  /** 标题 */
  name: Scalars['String']['input'];
  /** Widget分组 */
  widgetGroups?: InputMaybe<Array<GdPortalWidgetGroupAttributes>>;
};

export type GdPortalPageType = {
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  widgetGroups?: Maybe<Array<GdPortalWidgetGroupType>>;
};

export enum GdPortalPortalAccessPolicyEnum {
  /** Any one */
  AnyOne = 'any_one',
  /** Authorized */
  Authorized = 'authorized'
}

export type GdPortalPortalAttributes = {
  /** 客户身份，自定义的"客户"名称 */
  customerAlias?: InputMaybe<Scalars['String']['input']>;
  /** 名称 */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Page: 工作台页面 */
  pages?: InputMaybe<Array<GdPortalPageAttributes>>;
  /** Portal 设置 */
  portalSetting?: InputMaybe<GdPortalPortalSettingAttributes>;
  signupFormSetting?: InputMaybe<GdPortalSignupFormSettingAttributes>;
  /** 主题token */
  themeToken?: InputMaybe<Scalars['ID']['input']>;
  /** 主题类型 */
  themeType?: InputMaybe<GdPortalThemeTypeEnum>;
};

export enum GdPortalPortalAuditTypeEnum {
  Auto = 'auto',
  Manual = 'manual',
  None = 'none'
}

export enum GdPortalPortalAuthTypeEnum {
  Email = 'email',
  Mobile = 'mobile',
  Weixin = 'weixin'
}

export enum GdPortalPortalLocaleEnum {
  /** En */
  En = 'en',
  /** Zh cn */
  ZhCn = 'zh_cn'
}

/** 发布域名。subdomain:子域名，cname:自定义域名，official:官方域名 */
export enum GdPortalPortalPublishedUrlDomainEnum {
  Cname = 'cname',
  Official = 'official',
  Subdomain = 'subdomain'
}

export type GdPortalPortalQuotaType = {
  /** 客户配额, null 表示无限制 */
  customerQuota?: Maybe<Scalars['Int']['output']>;
  /** 客户配额已使用, -1: 用户量无限制 */
  customerQuotaUsed?: Maybe<Scalars['Int']['output']>;
  /** 门户配额, null 表示无限制 */
  portalQuota?: Maybe<Scalars['Int']['output']>;
  /** 门户配额已使用 */
  portalQuotaUsed?: Maybe<Scalars['Int']['output']>;
};

export enum GdPortalPortalRegistrableTypeEnum {
  Form = 'form',
  Portal = 'portal'
}

export type GdPortalPortalSettingAttributes = {
  /** 进入Portal的许可方式 */
  accessPolicy?: InputMaybe<GdPortalPortalAccessPolicyEnum>;
  /** 审核方式 */
  auditType?: InputMaybe<GdPortalPortalAuditTypeEnum>;
  auditingSetting?: InputMaybe<GdPortalAuditingSettingAttributes>;
  /** 登录方式 */
  authTypes?: InputMaybe<Array<GdPortalPortalAuthTypeEnum>>;
  /** 背景图 */
  backgroundAttachmentId?: InputMaybe<Scalars['ID']['input']>;
  customerFieldSettings?: InputMaybe<Array<GdPortalCustomerFieldSettingAttributes>>;
  /** 是否启用快速登录 */
  enableLoginShortcut?: InputMaybe<Scalars['Boolean']['input']>;
  footerNavigationSetting?: InputMaybe<GdPortalFooterNavigationSettingAttributes>;
  /** Portal 对外语言 */
  locale?: InputMaybe<GdPortalPortalLocaleEnum>;
  loginShortcutSetting?: InputMaybe<GdPortalLoginShortcutSettingAttributes>;
  /** 表单手机字段短信验证的签名 */
  luosimaoSmsSignatureId?: InputMaybe<Scalars['ID']['input']>;
  /** 注册方式 */
  registrableTypes?: InputMaybe<Array<GdPortalPortalRegistrableTypeEnum>>;
  signinSetting?: InputMaybe<GdPortalSigninSettingAttributes>;
  signupSetting?: InputMaybe<GdPortalSignupSettingAttributes>;
  /** 门户短信签名(已弃用) */
  smsSignature?: InputMaybe<Scalars['String']['input']>;
  /** 样式设置 */
  styleSetting?: InputMaybe<GdPortalStyleSettingAttributes>;
  /** 是否使用金数据默认签名 */
  useGdSignature?: InputMaybe<Scalars['Boolean']['input']>;
  /** 使用金数据官方微信公众号 */
  useOfficialWeixinAccount?: InputMaybe<Scalars['Boolean']['input']>;
  /** 绑定的微信公众号 */
  weixinAccountId?: InputMaybe<Scalars['ID']['input']>;
  /** 使用微信手动授权 */
  weixinManualAuthEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  weixinShareSetting?: InputMaybe<GdPortalWeixinShareSettingAttributes>;
};

export type GdPortalPortalSettingType = {
  accessPolicy: GdPortalPortalAccessPolicyEnum;
  auditType: GdPortalPortalAuditTypeEnum;
  auditingSetting?: Maybe<GdPortalAuditingSettingType>;
  authTypes?: Maybe<Array<GdPortalPortalAuthTypeEnum>>;
  /** 背景图 */
  backgroundAttachment?: Maybe<Attachment>;
  customerFieldSettings?: Maybe<Array<GdPortalCustomerFieldSettingType>>;
  enableLoginShortcut?: Maybe<Scalars['Boolean']['output']>;
  footerNavigationSetting?: Maybe<GdPortalFooterNavigationSettingType>;
  id: Scalars['ID']['output'];
  locale: GdPortalPortalLocaleEnum;
  loginShortcutSetting?: Maybe<GdPortalLoginShortcutSettingType>;
  /** 表单手机字段短信验证的签名 */
  luosimaoSmsSignature?: Maybe<GdPortalSmsSignatureType>;
  publishedUrlDomain: GdPortalPortalPublishedUrlDomainEnum;
  registrableTypes: Array<GdPortalPortalRegistrableTypeEnum>;
  signinSetting?: Maybe<GdPortalSigninSettingType>;
  signupSetting?: Maybe<GdPortalSignupSettingType>;
  smsSignature?: Maybe<Scalars['String']['output']>;
  /** 样式设置 */
  styleSetting?: Maybe<GdPortalStyleSettingType>;
  /** 是否使用金数据默认签名 */
  useGdSignature?: Maybe<Scalars['Boolean']['output']>;
  useOfficialWeixinAccount: Scalars['Boolean']['output'];
  weixinAccount?: Maybe<WeixinAccount>;
  weixinManualAuthEnabled: Scalars['Boolean']['output'];
  /** 微信分享设置 */
  weixinShareSetting?: Maybe<GdPortalWeixinShareSettingType>;
};

export type GdPortalPortalType = BaseProperties & WithCustomers & {
  billingAccount?: Maybe<BillingAccount>;
  boundForms?: Maybe<FormConnection>;
  /** 是否可以使用新版登录方式 */
  canUseNewLogin?: Maybe<Scalars['Boolean']['output']>;
  /** 自定义域名 */
  cnameUrl?: Maybe<Scalars['String']['output']>;
  creator?: Maybe<User>;
  customerAlias?: Maybe<Scalars['String']['output']>;
  customerFields: FieldConnection;
  customerGroups?: Maybe<Array<GdPortalCustomerGroupType>>;
  customers?: Maybe<CustomerConnection>;
  customersCount?: Maybe<Scalars['Int']['output']>;
  /** @deprecated 请使用customerFields字段 */
  customersFields: FieldConnection;
  /** 应用域名 */
  domainUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /** 不可被当前Portal绑定的表单ID列表 */
  noneBindableFormIds?: Maybe<Array<Scalars['ID']['output']>>;
  pages: Array<GdPortalPageType>;
  portalSetting?: Maybe<GdPortalPortalSettingType>;
  /** 自定义主题详情，仅当themeType为customization时返回 */
  portalTheme?: Maybe<GdPortalTheme>;
  /** Portal PV */
  pv?: Maybe<Scalars['Int']['output']>;
  signupFormSetting?: Maybe<GdPortalSignupFormSettingType>;
  /** 二级域名 */
  subdomainUrl?: Maybe<Scalars['String']['output']>;
  /** 主题token */
  themeToken?: Maybe<Scalars['String']['output']>;
  /** 主题类型 */
  themeType?: Maybe<GdPortalThemeTypeEnum>;
  token: Scalars['String']['output'];
};


export type GdPortalPortalTypeBoundFormsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type GdPortalPortalTypeCustomerFieldsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  fieldsContext?: InputMaybe<GdPortalCustomerFieldsContextEnum>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type GdPortalPortalTypeCustomersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type GdPortalPortalTypeCustomersCountArgs = {
  keyword?: InputMaybe<Scalars['String']['input']>;
};


export type GdPortalPortalTypeCustomersFieldsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type GdPortalPortalTypePvArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  stop?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
};

/** The connection type for gdPortalPortalType. */
export type GdPortalPortalTypeConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<GdPortalPortalTypeEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<GdPortalPortalType>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type GdPortalPortalTypeEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<GdPortalPortalType>;
};

/** Autogenerated input type of gdPortalPreviewCustomerGroup */
export type GdPortalPreviewCustomerGroupInput = {
  attributes: GdPortalCustomerGroupAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  portalToken?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of gdPortalPreviewCustomerGroup */
export type GdPortalPreviewCustomerGroupPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  customerGroup?: Maybe<GdPortalCustomerGroupType>;
  errors?: Maybe<Array<Error>>;
};

export type GdPortalPublishedPortalType = {
  portal: GdPortalPortalType;
  weixinOauthUrl?: Maybe<Scalars['String']['output']>;
};


export type GdPortalPublishedPortalTypeWeixinOauthUrlArgs = {
  oauthPagePath?: InputMaybe<Scalars['String']['input']>;
  portalWeixinSessionId?: InputMaybe<Scalars['String']['input']>;
  redirectTo?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of gdPortalResetCustomerPassword */
export type GdPortalResetCustomerPasswordInput = {
  accountNumber: Scalars['String']['input'];
  autoLogin?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  newPassword: Scalars['String']['input'];
  passcode: Scalars['String']['input'];
};

/** Autogenerated return type of gdPortalResetCustomerPassword */
export type GdPortalResetCustomerPasswordPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of gdPortalResetPortalCustomerPassword */
export type GdPortalResetPortalCustomerPasswordInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 客户ID */
  customerId: Scalars['ID']['input'];
  portalToken?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of gdPortalResetPortalCustomerPassword */
export type GdPortalResetPortalCustomerPasswordPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
};

export type GdPortalSmsSignatureType = {
  /** 创建时间 */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** 审核失败原因 */
  failedReason?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** 签名 */
  signature: Scalars['String']['output'];
  /** 签名审核状态 */
  signatureStatus?: Maybe<Scalars['String']['output']>;
};

export enum GdPortalSignInTodoEnum {
  AddMoreInfo = 'add_more_info',
  BindMobile = 'bind_mobile',
  ChangePassword = 'change_password'
}

export type GdPortalSigninSettingAttributes = {
  /** 背景图 */
  backgroundAttachmentId?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  focusAttachmentId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  signinBtnText?: InputMaybe<Scalars['String']['input']>;
  signupLinkText?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  weixinBtnText?: InputMaybe<Scalars['String']['input']>;
};

export type GdPortalSigninSettingType = {
  /** 背景图 */
  backgroundAttachment?: Maybe<Attachment>;
  description?: Maybe<Scalars['String']['output']>;
  focusAttachment?: Maybe<Attachment>;
  id: Scalars['ID']['output'];
  signinBtnText?: Maybe<Scalars['String']['output']>;
  signupLinkText?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  weixinBtnText?: Maybe<Scalars['String']['output']>;
};

export type GdPortalSignupBoundPortalType = BaseProperties & {
  customerAlias?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** 身份字段 */
  identityFields?: Maybe<Array<IdentityField>>;
  name: Scalars['String']['output'];
  portalSetting?: Maybe<GdPortalPortalSettingType>;
  token: Scalars['String']['output'];
};

export type GdPortalSignupFormSettingAttributes = {
  /** 字段映射关系 */
  appendedFieldMappings?: InputMaybe<Array<GdPortalAppendedFieldMappingAttributes>>;
  /** 客户字段映射关系 */
  codeMappings: Array<GdPortalCustomerCodeMappingAttributes>;
  /** true: 开启ScopeCondition */
  conditionalScope?: InputMaybe<Scalars['Boolean']['input']>;
  /** 是否删除 */
  destroy?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** ScopeCondition条件组 */
  scopeConditions?: InputMaybe<Array<ScopeConditionAttributes>>;
  signupFormId?: InputMaybe<Scalars['ID']['input']>;
};

export type GdPortalSignupFormSettingType = {
  codeMappings?: Maybe<Array<GdPortalCodeMappingType>>;
  /** true: 开启ScopeCondition */
  conditionalScope?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  /** 身份字段 */
  identityFields?: Maybe<Array<IdentityField>>;
  /** ScopeCondition条件组 */
  scopeConditions?: Maybe<Array<ScopeCondition>>;
  signupForm?: Maybe<Form>;
};

export type GdPortalSignupSettingAttributes = {
  description?: InputMaybe<Scalars['String']['input']>;
  focusAttachmentId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  signinLinkText?: InputMaybe<Scalars['String']['input']>;
  signupBtnText?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  weixinBtnText?: InputMaybe<Scalars['String']['input']>;
};

export type GdPortalSignupSettingType = {
  description?: Maybe<Scalars['String']['output']>;
  focusAttachment?: Maybe<Attachment>;
  id: Scalars['ID']['output'];
  signinLinkText?: Maybe<Scalars['String']['output']>;
  signupBtnText?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  weixinBtnText?: Maybe<Scalars['String']['output']>;
};

export type GdPortalStackWidgetType = BaseWidget & {
  displayType?: Maybe<GdPortalWidgetDisplayTypeEnum>;
  icon?: Maybe<GdPortalIconType>;
  id: Scalars['ID']['output'];
  image?: Maybe<Attachment>;
  name?: Maybe<Scalars['String']['output']>;
  type: GdPortalWidgetTypeEnum;
  visibleGroups?: Maybe<Array<GdPortalCustomerGroupType>>;
  visibleType: GdPortalWidgetVisibleTypeEnum;
  widgets?: Maybe<Array<GdPortalWidgetType>>;
};

export type GdPortalStyleSettingAttributes = {
  /** 背景色 */
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  /** 按钮圆角 */
  buttonRoundedCorners?: InputMaybe<Scalars['Int']['input']>;
  /** 卡片色 */
  cardColor?: InputMaybe<Scalars['String']['input']>;
  /** 卡片圆角 */
  cardRoundedCorners?: InputMaybe<Scalars['Int']['input']>;
  /** 字体色 */
  fontColor?: InputMaybe<Scalars['String']['input']>;
  /** 分组标题对齐方式 */
  groupTitleAlign?: InputMaybe<Scalars['String']['input']>;
  /** 图标库 */
  iconFamily?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** 登录标题对齐方式 */
  loginTitleAlign?: InputMaybe<Scalars['String']['input']>;
  /** 主题色 */
  themeColor?: InputMaybe<Scalars['String']['input']>;
};

export type GdPortalStyleSettingType = {
  /** 背景色 */
  backgroundColor?: Maybe<Scalars['String']['output']>;
  /** 按钮圆角 */
  buttonRoundedCorners?: Maybe<Scalars['Int']['output']>;
  /** 卡片色 */
  cardColor?: Maybe<Scalars['String']['output']>;
  /** 卡片圆角 */
  cardRoundedCorners?: Maybe<Scalars['Int']['output']>;
  /** 字体色 */
  fontColor?: Maybe<Scalars['String']['output']>;
  /** 分组标题对齐方式 */
  groupTitleAlign?: Maybe<Scalars['String']['output']>;
  /** 图标库 */
  iconFamily?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** 登录标题对齐方式 */
  loginTitleAlign?: Maybe<Scalars['String']['output']>;
  /** 主题色 */
  themeColor?: Maybe<Scalars['String']['output']>;
};

export type GdPortalTemplateType = {
  id: Scalars['ID']['output'];
  /** 图片 */
  image: Attachment;
  portal: GdPortalPortalType;
};

export type GdPortalTheme = {
  /** 配置详情 */
  detail: Scalars['JSON']['output'];
  /** 元信息 */
  meta?: Maybe<Scalars['JSON']['output']>;
  /** 名称 */
  name: Scalars['String']['output'];
  /** token */
  token: Scalars['ID']['output'];
};

/** 主题类型。system:系统主题，customization:自定义主题 */
export enum GdPortalThemeTypeEnum {
  Customization = 'customization',
  System = 'system'
}

/** Autogenerated input type of gdPortalUpdateCustomTheme */
export type GdPortalUpdateCustomThemeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 详情 */
  detail: Scalars['JSON']['input'];
  /** 元信息 */
  meta?: InputMaybe<Scalars['JSON']['input']>;
  /** 名称 */
  name: Scalars['String']['input'];
  token: Scalars['ID']['input'];
};

/** Autogenerated return type of gdPortalUpdateCustomTheme */
export type GdPortalUpdateCustomThemePayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** 自定义主题 */
  customTheme: GdPortalTheme;
  errors?: Maybe<Array<Error>>;
};

/** Autogenerated input type of gdPortalUpdateCustomerField */
export type GdPortalUpdateCustomerFieldInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  customerFieldSetting: GdPortalCustomerFieldSettingAttributes;
  /** 字段 */
  field: FieldAttributes;
  portalToken?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of gdPortalUpdateCustomerField */
export type GdPortalUpdateCustomerFieldPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  portal: GdPortalPortalType;
};

/** Autogenerated input type of gdPortalUpdateCustomerFilledEntry */
export type GdPortalUpdateCustomerFilledEntryInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  entryAttributes: Scalars['JSON']['input'];
  formToken: Scalars['String']['input'];
  /** geetest4验证码 */
  geetest4Data?: InputMaybe<Geetest4Attributes>;
  /** 系统内部功能调用，值为true时，跳过套餐校验 */
  internalUse?: InputMaybe<Scalars['Boolean']['input']>;
  serialNumber: Scalars['Int']['input'];
  widgetId: Scalars['String']['input'];
};

/** Autogenerated return type of gdPortalUpdateCustomerFilledEntry */
export type GdPortalUpdateCustomerFilledEntryPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
};

/** Autogenerated input type of gdPortalUpdateCustomerGroup */
export type GdPortalUpdateCustomerGroupInput = {
  attributes: GdPortalCustomerGroupAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  customerGroupToken: Scalars['ID']['input'];
  portalToken?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of gdPortalUpdateCustomerGroup */
export type GdPortalUpdateCustomerGroupPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  customerGroup?: Maybe<GdPortalCustomerGroupType>;
  errors?: Maybe<Array<Error>>;
};

/** Autogenerated input type of gdPortalUpdateCustomer */
export type GdPortalUpdateCustomerInput = {
  /** 需要更新的属性值 */
  attributes: Scalars['JSON']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  reasonType: GdPortalUpdateCustomerReasonTypeEnum;
};

/** Autogenerated return type of gdPortalUpdateCustomer */
export type GdPortalUpdateCustomerPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  customer?: Maybe<Customer>;
  errors?: Maybe<Array<Error>>;
};

/** Autogenerated input type of gdPortalUpdateCustomerProfile */
export type GdPortalUpdateCustomerProfileInput = {
  /** 修改后属性值 */
  attributes: Scalars['JSON']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 客户ID */
  customerId: Scalars['ID']['input'];
  portalToken?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of gdPortalUpdateCustomerProfile */
export type GdPortalUpdateCustomerProfilePayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  customer?: Maybe<Customer>;
  errors?: Maybe<Array<Error>>;
};

export enum GdPortalUpdateCustomerReasonTypeEnum {
  AddMoreInfo = 'add_more_info',
  UpdateProfile = 'update_profile'
}

/** Autogenerated input type of gdPortalUpdateEmail */
export type GdPortalUpdateEmailInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 待绑定的邮箱 */
  email: Scalars['String']['input'];
  /** 被合并的账号密码 */
  password?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of gdPortalUpdateEmail */
export type GdPortalUpdateEmailPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  customer?: Maybe<Customer>;
  errors?: Maybe<Array<Error>>;
};

/** Autogenerated input type of gdPortalUpdateMobile */
export type GdPortalUpdateMobileInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 待绑定的手机号 */
  mobile: Scalars['String']['input'];
  /** 被合并账号的校验码 */
  passcode?: InputMaybe<Scalars['String']['input']>;
  /** 被合并账号的密码 */
  password?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of gdPortalUpdateMobile */
export type GdPortalUpdateMobilePayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  customer?: Maybe<Customer>;
  errors?: Maybe<Array<Error>>;
};

/** Autogenerated input type of gdPortalUpdatePassword */
export type GdPortalUpdatePasswordInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 当前密码 */
  currentPassword?: InputMaybe<Scalars['String']['input']>;
  /** 新密码 */
  password: Scalars['String']['input'];
  /** 确认密码 */
  passwordConfirmation: Scalars['String']['input'];
};

/** Autogenerated return type of gdPortalUpdatePassword */
export type GdPortalUpdatePasswordPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  customer?: Maybe<Customer>;
  errors?: Maybe<Array<Error>>;
};

/** Autogenerated input type of gdPortalUpdatePortal */
export type GdPortalUpdatePortalInput = {
  attributes: GdPortalPortalAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  portalToken?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of gdPortalUpdatePortal */
export type GdPortalUpdatePortalPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  portal?: Maybe<GdPortalPortalType>;
};

/** Autogenerated input type of gdPortalUpdatePortalPublishedUrlDomain */
export type GdPortalUpdatePortalPublishedUrlDomainInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  portalToken?: InputMaybe<Scalars['ID']['input']>;
  /** 发布域名 */
  publishedUrlDomain: GdPortalPortalPublishedUrlDomainEnum;
};

/** Autogenerated return type of gdPortalUpdatePortalPublishedUrlDomain */
export type GdPortalUpdatePortalPublishedUrlDomainPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  portal?: Maybe<GdPortalPortalType>;
};

export enum GdPortalWeixinPortalSessionStatusEnum {
  Expired = 'expired',
  Failed = 'failed',
  Pending = 'pending',
  Succeed = 'succeed'
}

export type GdPortalWeixinPortalSessionType = {
  /** 微信授权码 */
  authCode?: Maybe<Scalars['String']['output']>;
  /** ID */
  id: Scalars['ID']['output'];
  /** 状态 */
  status: GdPortalWeixinPortalSessionStatusEnum;
};

export type GdPortalWeixinShareSettingAttributes = {
  /** 描述 */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Icon */
  icon?: InputMaybe<GdPortalIconAttributes>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** 标题 */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type GdPortalWeixinShareSettingType = {
  /** 描述 */
  description?: Maybe<Scalars['String']['output']>;
  /** Icon */
  icon?: Maybe<GdPortalIconType>;
  id: Scalars['ID']['output'];
  /** 标题 */
  title?: Maybe<Scalars['String']['output']>;
};

export type GdPortalWidgetAttributes = {
  /** 可以填写表单的群组ID */
  authorizedGroupTokens?: InputMaybe<Array<Scalars['ID']['input']>>;
  coverAttachmentId?: InputMaybe<Scalars['ID']['input']>;
  /** 图文组件描述 */
  description?: InputMaybe<Scalars['String']['input']>;
  /** true: 删除Widget */
  destroy?: InputMaybe<Scalars['Boolean']['input']>;
  /** 展示方式 */
  displayType?: InputMaybe<GdPortalWidgetDisplayTypeEnum>;
  /** 字段配置 */
  fieldSettings?: InputMaybe<Array<GdPortalFieldSettingAttributes>>;
  /** 表单token */
  formToken?: InputMaybe<Scalars['String']['input']>;
  /** Icon */
  icon?: InputMaybe<GdPortalIconAttributes>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** 用户自定义图片 */
  imageId?: InputMaybe<Scalars['ID']['input']>;
  /** 标题 */
  name?: InputMaybe<Scalars['String']['input']>;
  /** 对外查询、结果分享、表单等的token */
  openTargetToken?: InputMaybe<Scalars['String']['input']>;
  /** 对外查询、结果分享、表单等 */
  openTargetType?: InputMaybe<GdPortalFormWidgetOpenTargetEnum>;
  /** 顺序 */
  position?: InputMaybe<Scalars['Int']['input']>;
  /** 谁可以填写表单 */
  submitType?: InputMaybe<GdPortalFormWidgetSubmitTypeEnum>;
  /** 图文组件标题 */
  title?: InputMaybe<Scalars['String']['input']>;
  /** Widget 类型 */
  type: GdPortalWidgetTypeEnum;
  url?: InputMaybe<Scalars['String']['input']>;
  /** 可查看组件的群组Token列表 */
  visibleGroupTokens?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** 谁可以查看 */
  visibleType?: InputMaybe<GdPortalWidgetVisibleTypeEnum>;
  widgetGroupId?: InputMaybe<Scalars['ID']['input']>;
  /** Widget */
  widgets?: InputMaybe<Array<GdPortalWidgetAttributes>>;
};

export enum GdPortalWidgetDisplayTypeEnum {
  Icon = 'icon',
  Image = 'image'
}

export type GdPortalWidgetGroupAttributes = {
  /** true: 删除WidgetGroup */
  destroy?: InputMaybe<Scalars['Boolean']['input']>;
  /** 布局列数 */
  gridColumns?: InputMaybe<Scalars['Int']['input']>;
  /** 是否隐藏卡片色，默认false：不隐藏 */
  hiddenCardColor?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** 分组布局 */
  layoutType?: InputMaybe<GdPortalWidgetGroupLayoutTypeEnum>;
  /** 标题 */
  name?: InputMaybe<Scalars['String']['input']>;
  /** 分组位置 Position */
  position?: InputMaybe<Scalars['Int']['input']>;
  /** 是否展示分组标题，默认false： 不展示 */
  showName?: InputMaybe<Scalars['Boolean']['input']>;
  /** 可查看组件的群组Token列表 */
  visibleGroupTokens?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** 谁可以查看 */
  visibleType?: InputMaybe<GdPortalWidgetVisibleTypeEnum>;
  /** Widget */
  widgets?: InputMaybe<Array<GdPortalWidgetAttributes>>;
};

export enum GdPortalWidgetGroupLayoutTypeEnum {
  Grid = 'grid',
  List = 'list'
}

export type GdPortalWidgetGroupType = {
  gridColumns: Scalars['Int']['output'];
  /** 是否隐藏卡片色，默认false：不隐藏 */
  hiddenCardColor?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  layoutType: GdPortalWidgetGroupLayoutTypeEnum;
  name: Scalars['String']['output'];
  showName?: Maybe<Scalars['Boolean']['output']>;
  visibleGroups?: Maybe<Array<GdPortalCustomerGroupType>>;
  visibleType: GdPortalWidgetVisibleTypeEnum;
  widgets?: Maybe<Array<GdPortalWidgetType>>;
};

export type GdPortalWidgetType = GdPortalCardWidgetType | GdPortalEntryWidgetType | GdPortalFormWidgetType | GdPortalLinkWidgetType | GdPortalStackWidgetType;

export enum GdPortalWidgetTypeEnum {
  /** 图文组件 */
  CardWidget = 'CardWidget',
  /** 数据组件 */
  EntryWidget = 'EntryWidget',
  /** 表单组件 */
  FormWidget = 'FormWidget',
  /** 链接组件 */
  LinkWidget = 'LinkWidget',
  /** 堆叠组件 */
  StackWidget = 'StackWidget'
}

export enum GdPortalWidgetVisibleTypeEnum {
  Anyone = 'anyone',
  CustomerGroup = 'customer_group'
}

/** Autogenerated input type of hideAiGeneratedImage */
export type HideAiGeneratedImageInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of hideAiGeneratedImage */
export type HideAiGeneratedImagePayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of hideAiGeneratedPoster */
export type HideAiGeneratedPosterInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of hideAiGeneratedPoster */
export type HideAiGeneratedPosterPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of miniappBindEntryOpenid */
export type MiniappBindEntryOpenidInput = {
  /** nextfe 中的 cid */
  cid?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  entryToken?: InputMaybe<Scalars['ID']['input']>;
  formId: Scalars['ID']['input'];
  routeType?: InputMaybe<PublishedFormRoute>;
};

/** Autogenerated return type of miniappBindEntryOpenid */
export type MiniappBindEntryOpenidPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  /** 是否需要切换用户，true: 需要切换用户，false: 不需要切换用户 */
  switchUser?: Maybe<Scalars['Boolean']['output']>;
  /** 需要切换用户时，返回需要切换的用户id */
  userId?: Maybe<Scalars['ID']['output']>;
};

export type PublishedDynamicAttrs = FormDefaultEntry & WithDynamicAttrs & WithPublishedDomainInfo & WithRedirectUrl & PublishedFormDynamicFields & {
  /** 实际使用的二级域名。当套餐不可用后，返回系统随机二级域名 */
  activeSubdomain?: Maybe<Scalars['String']['output']>;
  /** 表单所属 BillingAccount 的品牌信息 */
  branding: Branding;
  /** 所属 BillingAccount 的cname 信息 */
  cnameSetting: Cname;
  /** 带有默认值的预填写数据 */
  entry?: Maybe<Entry>;
  /** 选择类字段的投票结果统计数据 */
  entryCountsPerChoice?: Maybe<Scalars['JSON']['output']>;
  /** 表单底部品牌信息 */
  footer?: Maybe<Footer>;
  /** 包含库存信息的商品字段 */
  inventoryFields?: Maybe<Scalars['JSON']['output']>;
  /** 跑马灯展示文字数据 */
  marqueeDisplayData?: Maybe<Array<MarqueeDisplayDataType>>;
  /** 跑马灯展示当前数据量 */
  marqueeEntriesCount?: Maybe<Scalars['Int']['output']>;
  /** 包含余额的选项类字段 */
  quotableFields?: Maybe<Scalars['JSON']['output']>;
  /** 跳转 URL。如果有值，则优先跳转。 */
  redirectUrl?: Maybe<Scalars['String']['output']>;
  /** 表单填写状态 */
  status: PublishedFormStatus;
  /** 表单顶部警告 */
  topWarning?: Maybe<Scalars['String']['output']>;
};


export type PublishedDynamicAttrsEntryArgs = {
  code?: InputMaybe<Scalars['ID']['input']>;
};


export type PublishedDynamicAttrsRedirectUrlArgs = {
  code?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  weixinCallbackUrlParams?: InputMaybe<Scalars['JSON']['input']>;
};


export type PublishedDynamicAttrsStatusArgs = {
  code?: InputMaybe<Scalars['ID']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
};

export type PublishedEvaluationReport = EvaluationReportBackground & PublishedScorableFields & {
  /** 报告背景模式为customize时的自定义颜色 */
  backgroundColor?: Maybe<Scalars['String']['output']>;
  /** 报告背景模式: recommendation - 系统推荐背景, follow_form - 跟随表单背景, customize - 自定义背景 */
  backgroundMode: EvaluationBackgroundMode;
  comment?: Maybe<Scalars['String']['output']>;
  /** 考试、测评的试卷总得分 */
  examScore?: Maybe<Scalars['Float']['output']>;
  form?: Maybe<Form>;
  indicatorsScoreMap?: Maybe<Array<IndicatorsScoreMap>>;
  /** 填表人提交的数据分数对应的结果与建议是否允许再填一次 */
  retryable?: Maybe<Scalars['Boolean']['output']>;
};

export type PublishedFormDynamicFields = {
  /** 表单所属 BillingAccount 的品牌信息 */
  branding: Branding;
  /** 选择类字段的投票结果统计数据 */
  entryCountsPerChoice?: Maybe<Scalars['JSON']['output']>;
  /** 表单底部品牌信息 */
  footer?: Maybe<Footer>;
  /** 表单填写状态 */
  status: PublishedFormStatus;
  /** 表单顶部警告 */
  topWarning?: Maybe<Scalars['String']['output']>;
};


export type PublishedFormDynamicFieldsStatusArgs = {
  code?: InputMaybe<Scalars['ID']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
};

export type PublishedFormStatus = {
  key: PublishedFormStatusKey;
  message?: Maybe<Scalars['String']['output']>;
  preventReasons?: Maybe<Array<Scalars['String']['output']>>;
};

export enum PublishedFormStatusKey {
  /** 已停止提交 */
  Closed = 'closed',
  /** 填写设备不允许，例如仅限在微信中填写 */
  DeviseMismatch = 'devise_mismatch',
  /** 已冻结 */
  Disabled = 'disabled',
  /** 被外部校验拒绝 */
  ExternalRejected = 'external_rejected',
  /** 不能在隐身模式下填写 */
  InvalidIncognitoToken = 'invalid_incognito_token',
  /** 需要登录但尚未登录 */
  LoginRequired = 'login_required',
  /** 商户支付冻结 */
  MerchantPayFreezed = 'merchant_pay_freezed',
  /** 暂未开放 */
  NotOpened = 'not_opened',
  /** 开放，能正常填写 */
  Open = 'open',
  /** 密码错误 */
  PasswordInvalid = 'password_invalid',
  /** 需要密码 */
  PasswordRequired = 'password_required',
  /** 名额正在重置中，请稍后再试。 */
  PendingQuotaReset = 'pending_quota_reset',
  /** 限制了表单填写区域 */
  RegionLimited = 'region_limited',
  /** 能展示表单，但不能填写，例如包含套餐不支持的字段、数据余量不足等 */
  SubmissionPrevented = 'submission_prevented',
  /** 无权限，例如仅限企业成员可填、仅限微信粉丝可填等 */
  Unauthorized = 'unauthorized',
  /** 警告中 */
  Warning = 'warning'
}

/** Autogenerated input type of publishedOpenSearchEntryEditVerifications */
export type PublishedOpenSearchEntryEditVerificationsInput = {
  /** 图形验证码 */
  captchaData?: InputMaybe<VisualAttributes>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 数据token */
  entryId: Scalars['ID']['input'];
  formId: Scalars['ID']['input'];
  /** geetest4验证码 */
  geetest4Data?: InputMaybe<Geetest4Attributes>;
  /** geetest验证码 */
  geetestData?: InputMaybe<GeetestAttributes>;
  /** 对外分享ID */
  openResultId?: InputMaybe<Scalars['ID']['input']>;
  /** 对外查询ID */
  openSearchId?: InputMaybe<Scalars['ID']['input']>;
  routeType?: InputMaybe<PublishedFormRoute>;
};

/** Autogenerated return type of publishedOpenSearchEntryEditVerifications */
export type PublishedOpenSearchEntryEditVerificationsPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Autogenerated input type of publishedOpenSearchMobileVerifications */
export type PublishedOpenSearchMobileVerificationsInput = {
  /** 图形验证码 */
  captchaData?: InputMaybe<VisualAttributes>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  formId: Scalars['ID']['input'];
  /** geetest4验证码 */
  geetest4Data?: InputMaybe<Geetest4Attributes>;
  /** geetest验证码 */
  geetestData?: InputMaybe<GeetestAttributes>;
  /** 手机号 */
  mobile: Scalars['String']['input'];
  /** 对外查询ID */
  openSearchId: Scalars['ID']['input'];
  routeType?: InputMaybe<PublishedFormRoute>;
  /** 需要检验的字段code */
  verifyApiCode: Scalars['String']['input'];
};

/** Autogenerated return type of publishedOpenSearchMobileVerifications */
export type PublishedOpenSearchMobileVerificationsPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Autogenerated input type of publishedOpenSearchUpdateEntry */
export type PublishedOpenSearchUpdateEntryInput = {
  /** 图形验证码 */
  captchaData?: InputMaybe<VisualAttributes>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** entry edit token */
  editToken: Scalars['String']['input'];
  entryAttributes: Scalars['JSON']['input'];
  /** entry token */
  entryToken: Scalars['String']['input'];
  formId: Scalars['ID']['input'];
  /** geetest4验证码 */
  geetest4Data?: InputMaybe<Geetest4Attributes>;
  /** geetest验证码 */
  geetestData?: InputMaybe<GeetestAttributes>;
  /** 对外分享ID */
  openResultId?: InputMaybe<Scalars['ID']['input']>;
  /** 对外查询ID */
  openSearchId?: InputMaybe<Scalars['ID']['input']>;
  routeType?: InputMaybe<PublishedFormRoute>;
};

/** Autogenerated return type of publishedOpenSearchUpdateEntry */
export type PublishedOpenSearchUpdateEntryPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  entry?: Maybe<OpenSearchEntry>;
  errors?: Maybe<Array<Error>>;
};

export type PublishedOpensearchQueryType = {
  /** 可查看的字段 */
  displayFields: FieldConnection;
  publishedForm: PublishedForm;
};


export type PublishedOpensearchQueryTypeDisplayFieldsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PublishedScorableFields = {
  /** 考试、测评的试卷总得分 */
  examScore?: Maybe<Scalars['Float']['output']>;
};

export type PublishedWeixinEntry = CustomerProperties & EntriesBaseProperties & MetaProperties & ReservationStatusProperties & ShareAndMarkProperties & WeixinProperties & {
  _type?: Maybe<Scalars['String']['output']>;
  browser?: Maybe<Scalars['String']['output']>;
  colorMark?: Maybe<Scalars['String']['output']>;
  /** 表单联系人 */
  contactId?: Maybe<Scalars['ID']['output']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  creator?: Maybe<PublishedUser>;
  customer?: Maybe<GdCustomer>;
  editToken?: Maybe<Scalars['String']['output']>;
  editUrl?: Maybe<Scalars['String']['output']>;
  editUrlExpireAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** 当前版本号 */
  editedVersion?: Maybe<Scalars['Int']['output']>;
  fieldValues: Scalars['JSON']['output'];
  fillingDuration?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  ip?: Maybe<Scalars['String']['output']>;
  os?: Maybe<Scalars['String']['output']>;
  platform?: Maybe<Scalars['String']['output']>;
  region?: Maybe<RegionInfo>;
  remark?: Maybe<Scalars['String']['output']>;
  /** 预约状态 */
  reservationStatus?: Maybe<ReservationStatusEnum>;
  serialNumber: Scalars['Int']['output'];
  shareLink?: Maybe<Scalars['String']['output']>;
  shareToken?: Maybe<Scalars['String']['output']>;
  startFillingTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  useragent?: Maybe<Scalars['String']['output']>;
  weixinAccessToken?: Maybe<Scalars['ID']['output']>;
  xFieldWeixinHeadimgurl?: Maybe<Scalars['String']['output']>;
  xFieldWeixinNickname?: Maybe<Scalars['String']['output']>;
  xFieldWeixinOpenid?: Maybe<Scalars['ID']['output']>;
  xFieldWeixinUnionid?: Maybe<Scalars['ID']['output']>;
};


export type PublishedWeixinEntryFieldValuesArgs = {
  fieldsContext?: InputMaybe<FieldsContext>;
};

/** Autogenerated input type of restoreFormEntries */
export type RestoreFormEntriesInput = {
  auditTrailId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 表单的使用场景 */
  formUsage?: InputMaybe<FormUsage>;
  /** 表单ID或token */
  id: Scalars['ID']['input'];
  serialNumber?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of restoreFormEntries */
export type RestoreFormEntriesPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentAuditTrail?: Maybe<FormAuditTrails>;
  errors?: Maybe<Array<Error>>;
  restoreAuditTrail?: Maybe<FormAuditTrails>;
};

/** Autogenerated input type of revokeBillingAccountAccessToken */
export type RevokeBillingAccountAccessTokenInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of revokeBillingAccountAccessToken */
export type RevokeBillingAccountAccessTokenPayload = {
  accountAccessToken?: Maybe<AccountAccessToken>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
};

export type Submitter = CustomerProperties & EntriesBaseProperties & MetaProperties & ReservationStatusProperties & ShareAndMarkProperties & WeixinProperties & {
  _type?: Maybe<Scalars['String']['output']>;
  browser?: Maybe<Scalars['String']['output']>;
  colorMark?: Maybe<Scalars['String']['output']>;
  /** 表单联系人 */
  contactId?: Maybe<Scalars['ID']['output']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  creator?: Maybe<PublishedUser>;
  customer?: Maybe<GdCustomer>;
  displayName: Scalars['String']['output'];
  /** 当前版本号 */
  editedVersion?: Maybe<Scalars['Int']['output']>;
  fieldValues: Scalars['JSON']['output'];
  fillingDuration?: Maybe<Scalars['Float']['output']>;
  form?: Maybe<Form>;
  id: Scalars['ID']['output'];
  ip?: Maybe<Scalars['String']['output']>;
  needCharge?: Maybe<Scalars['Boolean']['output']>;
  os?: Maybe<Scalars['String']['output']>;
  platform?: Maybe<Scalars['String']['output']>;
  profile: Scalars['JSON']['output'];
  region?: Maybe<RegionInfo>;
  remark?: Maybe<Scalars['String']['output']>;
  /** 预约状态 */
  reservationStatus?: Maybe<ReservationStatusEnum>;
  serialNumber: Scalars['Int']['output'];
  shareLink?: Maybe<Scalars['String']['output']>;
  shareToken?: Maybe<Scalars['String']['output']>;
  startFillingTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  useragent?: Maybe<Scalars['String']['output']>;
  weixinAccessToken?: Maybe<Scalars['ID']['output']>;
  xFieldWeixinHeadimgurl?: Maybe<Scalars['String']['output']>;
  xFieldWeixinNickname?: Maybe<Scalars['String']['output']>;
  xFieldWeixinOpenid?: Maybe<Scalars['ID']['output']>;
  xFieldWeixinUnionid?: Maybe<Scalars['ID']['output']>;
};


export type SubmitterFieldValuesArgs = {
  fieldsContext?: InputMaybe<FieldsContext>;
};

export type SubmitterBulletinCoverType = {
  /** 用户自定义图片 */
  customizedCover?: Maybe<Attachment>;
  id: Scalars['ID']['output'];
  /** true: 已选中自定义图片，false: 未选中自定义图片 */
  isCustomizedCoverSelected?: Maybe<Scalars['Boolean']['output']>;
  /** 如果使用了系统预设的图片，此值为图片的文件名 */
  predefinedCoverName?: Maybe<Scalars['String']['output']>;
  /** 被选中的图片路径 */
  selectedCoverPath?: Maybe<Scalars['String']['output']>;
};

/** The connection type for submitter. */
export type SubmitterConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SubmitterEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Submitter>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type SubmitterEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Submitter>;
};

export type SubmitterField = {
  actAsIdentity: Scalars['Boolean']['output'];
  actAsSubmitterInfo?: Maybe<SubmitterFieldAsSubmitterInfoEnum>;
  apiCode: Scalars['String']['output'];
  fieldType?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
};

export type SubmitterGroup = {
  actAsOpenEntryAuthIdentity?: Maybe<Scalars['Boolean']['output']>;
  /** Portal 的登录方式 */
  authTypes: Array<GroupAuthTypesEnum>;
  availableIdentityFields?: Maybe<Array<SubmitterField>>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  createdFrom?: Maybe<GroupCreatedFrom>;
  createdSource?: Maybe<Form>;
  creator: User;
  creatorId: Scalars['ID']['output'];
  currentImportJob?: Maybe<SubmitterImportJob>;
  demoCase?: Maybe<GroupDemoCase>;
  /** 用于双字段登录的字段 */
  dualAuthApiCodes?: Maybe<Array<Scalars['String']['output']>>;
  /** 导出任务 */
  exportJob?: Maybe<ExportJobType>;
  groupSetting: SubmitterGroupSetting;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  owner: BillingAccount;
  portal?: Maybe<Portal>;
  selectedFormFields?: Maybe<Array<SubmitterField>>;
  /** 客户生成规则 */
  submitterRule?: Maybe<SubmitterRule>;
  submitters?: Maybe<SubmitterConnection>;
  submittersCount: Scalars['Int']['output'];
  token: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  userSubmitterGroupSetting?: Maybe<UserSubmitterGroupSetting>;
  /** 微信企业账户 */
  weixinQiyeAccount?: Maybe<WeixinQiyeAccount>;
  /** YamchaMemberInfo和客户信息表中字段的映射关系 */
  yamchaMemberInfoMappings?: Maybe<Array<YamchaMemberInfoMappingType>>;
};


export type SubmitterGroupSubmittersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** The connection type for submitterGroup. */
export type SubmitterGroupConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SubmitterGroupEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<SubmitterGroup>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type SubmitterGroupEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<SubmitterGroup>;
};

export type SubmitterGroupSetting = {
  groupId: Scalars['ID']['output'];
  markStyle?: Maybe<SubmitterStyle>;
};

export type SubmitterImportJob = {
  /** 结束时间 */
  finishedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  /** 导入百分比 */
  importedPercent?: Maybe<Scalars['Float']['output']>;
  /** 开始时间 */
  startedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** 状态 */
  status: JobStatus;
  /** 待标记的的数据量 */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type SubmitterNavigationItem = SubmitterProfileNavigationItem | SubmitterWorkspaceNavigationItem;

/** The connection type for submitterNavigationItem. */
export type SubmitterNavigationItemConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SubmitterNavigationItemEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<SubmitterNavigationItem>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type SubmitterNavigationItemEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<SubmitterNavigationItem>;
};

export type SubmitterProfileNavigationItem = {
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  position: Scalars['Int']['output'];
  token: Scalars['ID']['output'];
  type: NavigationItemTypeEnum;
};

export type SubmitterRule = {
  customerTip?: Maybe<Scalars['String']['output']>;
  scopeConditions?: Maybe<Array<ScopeCondition>>;
  showCustomerTip?: Maybe<Scalars['Boolean']['output']>;
};

export type SubmitterSendingTask = {
  /** 任务创建时间 */
  createdAt: Scalars['ISO8601DateTime']['output'];
  group?: Maybe<SubmitterGroup>;
  id: Scalars['ID']['output'];
  /** 发送任务标题 */
  name: Scalars['String']['output'];
  noticeChannel?: Maybe<SendingTaskNoticeChannel>;
  /** 发送内容 */
  noticeContent: Scalars['String']['output'];
  /** 何时发送 */
  shouldSentAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** 发送状态 */
  status: SendingTaskStatus;
  targetCount: Scalars['Int']['output'];
  /** 发送至XXX */
  targetName: Scalars['String']['output'];
  targets?: Maybe<Array<SubmitterSendingTaskNoticeTarget>>;
};

export type SubmitterSendingTaskAttributes = {
  /** 要发送的目标群组ID */
  groupId: Scalars['ID']['input'];
  /** 选中手机属性的api_code */
  mobileFieldCode?: InputMaybe<Scalars['String']['input']>;
  /** 任务名称 */
  name: Scalars['String']['input'];
  noticeChannel?: InputMaybe<SendingTaskNoticeChannel>;
  /** 自定义通知文案 */
  noticeContent?: InputMaybe<Scalars['String']['input']>;
  noticeTargets?: InputMaybe<Array<SubmitterSendingTaskNoticeTargetAttributes>>;
  /** 自定义通知标题 */
  noticeTitle?: InputMaybe<Scalars['String']['input']>;
  /** 仅通知未填写的 Submitter */
  noticeUnfilled?: InputMaybe<Scalars['Boolean']['input']>;
  /** 绑定群组的表单Token */
  payloadToken: Scalars['ID']['input'];
  period?: InputMaybe<Period>;
  /** 预期发送时间，不传或为空则表示立即发送 */
  shouldSentAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  submitterFilter?: InputMaybe<SubmitterFilterAttributes>;
};

/** The connection type for submitterSendingTask. */
export type SubmitterSendingTaskConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SubmitterSendingTaskEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<SubmitterSendingTask>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type SubmitterSendingTaskEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<SubmitterSendingTask>;
};

export type SubmitterSendingTaskNoticeTarget = {
  targetIds: Array<Scalars['ID']['output']>;
  /** 第三方企业的接收者名称 */
  targetNames?: Maybe<Array<Scalars['String']['output']>>;
  targetType?: Maybe<SendingTaskNoticeTargetTypeEnum>;
};

export type SubmitterSendingTaskNoticeTargetAttributes = {
  targetIds: Array<Scalars['ID']['input']>;
  targetType: SendingTaskNoticeTargetTypeEnum;
};

export type SubmitterStyle = {
  color?: Maybe<Scalars['String']['output']>;
};

export type SubmitterWidget = {
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  position: Scalars['Int']['output'];
  scopeConditions?: Maybe<Array<ScopeCondition>>;
  status: WidgetStatusEnum;
  targetName?: Maybe<Scalars['String']['output']>;
  targetPath: Scalars['String']['output'];
  targetType: Scalars['String']['output'];
  thumbnail?: Maybe<SubmitterWidgetThumbnailType>;
};

/** The connection type for submitterWidget. */
export type SubmitterWidgetConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SubmitterWidgetEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<SubmitterWidget>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type SubmitterWidgetEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<SubmitterWidget>;
};

export type SubmitterWidgetGroup = {
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  position: Scalars['Int']['output'];
  widgets?: Maybe<SubmitterWidgetConnection>;
};


export type SubmitterWidgetGroupWidgetsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** The connection type for submitterWidgetGroup. */
export type SubmitterWidgetGroupConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SubmitterWidgetGroupEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<SubmitterWidgetGroup>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type SubmitterWidgetGroupEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<SubmitterWidgetGroup>;
};

export type SubmitterWidgetThumbnailType = {
  /** 用户自定义图标 */
  customizedThumbnail?: Maybe<Attachment>;
  id: Scalars['ID']['output'];
  /** true: 已选中自定义图标，false: 未选中自定义图标 */
  isCustomizedThumbnailSelected?: Maybe<Scalars['Boolean']['output']>;
  /** 如果使用了系统预设的图标，此值为图标的文件名 */
  predefinedThumbnailName?: Maybe<Scalars['String']['output']>;
  /** 被选中的图标路径 */
  selectedThumbnailPath?: Maybe<Scalars['String']['output']>;
};

export type SubmitterWorkspaceNavigationItem = {
  bulletins: BulletinConnection;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  position: Scalars['Int']['output'];
  token: Scalars['ID']['output'];
  type: NavigationItemTypeEnum;
  widgetGroups?: Maybe<SubmitterWidgetGroupConnection>;
};


export type SubmitterWorkspaceNavigationItemBulletinsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type SubmitterWorkspaceNavigationItemWidgetGroupsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated input type of switchUser */
export type SwitchUserInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

/** Autogenerated return type of switchUser */
export type SwitchUserPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Autogenerated input type of updateBillingAccountUrlParamsSignSecret */
export type UpdateBillingAccountUrlParamsSignSecretInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of updateBillingAccountUrlParamsSignSecret */
export type UpdateBillingAccountUrlParamsSignSecretPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  urlParamsSignSecret?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of updateContactTagRule */
export type UpdateContactTagRuleInput = {
  /** 规则属性 */
  attributes: ContactTagRuleAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 表单ID或token */
  id: Scalars['ID']['input'];
  /** 待更新的联系人规则id */
  ruleId: Scalars['ID']['input'];
};

/** Autogenerated return type of updateContactTagRule */
export type UpdateContactTagRulePayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  contactTagRules?: Maybe<ContactTagRuleConnection>;
  errors?: Maybe<Array<Error>>;
};


/** Autogenerated return type of updateContactTagRule */
export type UpdateContactTagRulePayloadContactTagRulesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated input type of updateEntry */
export type UpdateEntryInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  entryAttributes: Scalars['JSON']['input'];
  entryToken: Scalars['ID']['input'];
  formToken?: InputMaybe<Scalars['ID']['input']>;
  openEntryToken?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of updateEntry */
export type UpdateEntryPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  entry?: Maybe<Entry>;
  errors?: Maybe<Array<Error>>;
};

/** Autogenerated input type of updateEntrySingleSharing */
export type UpdateEntrySingleSharingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 表单的使用场景 */
  formUsage?: InputMaybe<FormUsage>;
  /** 表单ID或token */
  id: Scalars['ID']['input'];
  serialNumber: Scalars['Int']['input'];
  shared: Scalars['Boolean']['input'];
};

/** Autogenerated return type of updateEntrySingleSharing */
export type UpdateEntrySingleSharingPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  entry?: Maybe<Entry>;
  errors?: Maybe<Array<Error>>;
};

/** Autogenerated input type of updateFormRole */
export type UpdateFormRoleInput = {
  /** 角色属性 */
  attributes: FormRoleAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 待更新的表单角色 */
  formRoleId: Scalars['ID']['input'];
  /** 表单ID或token */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of updateFormRole */
export type UpdateFormRolePayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  formRole?: Maybe<FormRole>;
};

/** Autogenerated input type of updatePublishedFormEntry */
export type UpdatePublishedFormEntryInput = {
  /** 图形验证码 */
  captchaData?: InputMaybe<VisualAttributes>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** entry edit token */
  editToken: Scalars['String']['input'];
  entryAttributes: Scalars['JSON']['input'];
  /** entry token */
  entryToken: Scalars['String']['input'];
  formId: Scalars['ID']['input'];
  /** geetest4验证码 */
  geetest4Data?: InputMaybe<Geetest4Attributes>;
  /** geetest验证码 */
  geetestData?: InputMaybe<GeetestAttributes>;
  routeType?: InputMaybe<PublishedFormRoute>;
};

/** Autogenerated return type of updatePublishedFormEntry */
export type UpdatePublishedFormEntryPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** 发布页修改数据使用，过期时间为3分钟 */
  editToken?: Maybe<Scalars['String']['output']>;
  /** 提交成功后的entry token */
  entryToken?: Maybe<Scalars['ID']['output']>;
  errors?: Maybe<Array<Error>>;
  /** 提交成功后跳转URL */
  redirectUrl?: Maybe<Scalars['String']['output']>;
  /** true - 修改成功, null - 修改失败, 失败原因查看errors */
  succeed?: Maybe<Scalars['Boolean']['output']>;
  /** 表单总价 */
  totalPrice?: Maybe<Scalars['Float']['output']>;
};

/** Autogenerated input type of updatePublishedWeixinEntry */
export type UpdatePublishedWeixinEntryInput = {
  /** 图形验证码 */
  captchaData?: InputMaybe<VisualAttributes>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** entry edit token */
  editToken: Scalars['String']['input'];
  entryAttributes: Scalars['JSON']['input'];
  /** entry token */
  entryToken: Scalars['String']['input'];
  formId: Scalars['ID']['input'];
  /** geetest4验证码 */
  geetest4Data?: InputMaybe<Geetest4Attributes>;
  /** geetest验证码 */
  geetestData?: InputMaybe<GeetestAttributes>;
  routeType?: InputMaybe<PublishedFormRoute>;
};

/** Autogenerated return type of updatePublishedWeixinEntry */
export type UpdatePublishedWeixinEntryPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  /** 提交成功后跳转URL */
  redirectUrl?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of updateSMSYunpianSignature */
export type UpdateSmsYunpianSignatureInput = {
  attributes: SmsYunpianSignatureAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of updateSMSYunpianSignature */
export type UpdateSmsYunpianSignaturePayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of updateSmtpAccount */
export type UpdateSmtpAccountInput = {
  /** 更新参数 */
  attributes: SmtpAccountAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** SMTP 账号ID */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of updateSmtpAccount */
export type UpdateSmtpAccountPayload = {
  account?: Maybe<SmtpAccount>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
};

/** Autogenerated input type of updateSubmitterGroup */
export type UpdateSubmitterGroupInput = {
  attributes: UpdateSubmitterGroupAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['ID']['input'];
};

/** Autogenerated return type of updateSubmitterGroup */
export type UpdateSubmitterGroupPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  group?: Maybe<SubmitterGroup>;
};

/** Autogenerated input type of updateSubmitterPortal */
export type UpdateSubmitterPortalInput = {
  attributes: SubmitterPortalAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
};

/** Autogenerated return type of updateSubmitterPortal */
export type UpdateSubmitterPortalPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Error>>;
  portal?: Maybe<Portal>;
};

export type UpdateUserSubmitterGroupSettingAttributes = {
  columns: Array<Scalars['String']['input']>;
};

/** Autogenerated input type of updateWheelFortuneWinner */
export type UpdateWheelFortuneWinnerInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 表单的使用场景 */
  formUsage?: InputMaybe<FormUsage>;
  /** 表单ID或token */
  id: Scalars['ID']['input'];
  serialNumber: Scalars['Int']['input'];
  winnerId: Scalars['ID']['input'];
};

/** Autogenerated return type of updateWheelFortuneWinner */
export type UpdateWheelFortuneWinnerPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  entry?: Maybe<Entry>;
  errors?: Maybe<Array<Error>>;
};

export type UserSubmitterGroupSetting = {
  columns?: Maybe<Array<Scalars['String']['output']>>;
};

export type YamchaMemberInfoMappingType = {
  /** member_info_path对应的客户信息表中的field api code */
  fieldCode: Scalars['String']['output'];
  /** 用户信息路径 */
  memberInfoPath?: Maybe<YamchaMemberInfoPathTypeEnum>;
};

export type CopyFormMutationVariables = Exact<{
  input: CopyFormInput;
}>;


export type CopyFormMutation = { copyForm?: { form?: { id: string, name: string, subname?: string | null, originalName: string, type: BaseFileEnum, scene: Scene, layout: Layout, token: string, entriesCount: number, createdAt?: date | null, creatorId: string, hasUnusableFeatures: boolean, hasUnusableFields: boolean, disabled?: boolean | null, owner: { id: string, displayName: string, avatarUrl?: string | null }, billingAccount: { id: string }, stats: { totalFillCount: number, totalViewCount: number }, userFormSetting?: { favored?: boolean | null } | null } | null, errors?: Array<{ code?: number | null, message?: string | null, path?: Array<string> | null, details?: any | null }> | null } | null };

export type CreateFormMutationVariables = Exact<{
  input: CreateFormInput;
}>;


export type CreateFormMutation = { createForm?: { form?: { token: string, scene: Scene, layout: Layout, name: string, createdAt?: date | null, description?: string | null, entriesCount: number, subname?: string | null, originalName: string, editedVersion?: number | null, useCk5?: boolean | null, userFormRole?: { id: string, name: string, abilities: Array<FormRoleAbility>, originalName: string } | null, ensuredSymbol?: { icon: string, backgroundColor: string } | null, stats: { totalFillCount: number, todayFillCount: number, totalViewCount: number, todayViewCount: number }, billingAccount: { id: string, activeSubdomain?: string | null, planPackage?: { plan: { code: string } } | null, branding: { customFooter?: string | null, customFooterEnabled: boolean, customFooterLogoEnabled: boolean, customFooterLink?: string | null, showQrcodeLogo: boolean, navDisplay: NavDisplay, qrcodeLogo?: { id: string, visitUrl: string } | null, navLogo?: { visitUrl: string } | null }, currentFeatureTrialInfo?: { status?: FeatureTrialStatus | null, trialType?: FeatureTrialType | null, endDate?: any | null, onetimeCount?: number | null } | null, cnameSetting: { cname?: string | null, icp?: string | null, protocol: string, cnameEnabled: boolean, customDomainEnabled: boolean }, weixinAccounts: Array<{ id: string, verified?: boolean | null, nickName?: string | null }>, wxpayAccounts: Array<{ id: string, mchName: string, available: boolean, weixinAccount?: { nickName?: string | null, id: string } | null }>, alipayAccounts: Array<{ id: string, email: string }>, pingppAccounts: Array<{ id: string, appid: string }> }, theme: { header: { type: ThemeHeaderType, image?: { visitUrl: string, fileWidth?: number | null } | null, carouselImages?: Array<{ visitUrl: string }> | null }, wallpaper: { backgroundColor?: string | null, backgroundImageUrl?: string | null }, formContainer: { style: { backgroundColor?: string | null } } }, setting: { weixinThumbnail: { url: string } }, userFormSetting?: { preferColumns: Array<string>, pinned?: boolean | null, favored?: boolean | null, publishedUrlDomain?: PublishedUrlDomainEnum | null, folder?: { token: string } | null } | null, allAncestorFolders?: Array<{ token: string, name: string, ensuredSymbol?: { backgroundColor: string } | null, owner?: { id: string } | null }> | null, owner: { id: string, displayName: string, avatarUrl?: string | null, email?: string | null, mobile?: string | null, status: UserStatus }, storageConfig: { provider?: string | null }, userFormAppSetting: { appNotificationEnabled: boolean } } | null, errors?: Array<{ code?: number | null, message?: string | null, path?: Array<string> | null, details?: any | null }> | null } | null };

export type CreateFormHeaderImageAttachmentMutationVariables = Exact<{
  input: CreateFormHeaderImageAttachmentInput;
}>;


export type CreateFormHeaderImageAttachmentMutation = { createFormHeaderImageAttachment?: { errors: Array<string>, attachment?: { id: string, fileName: string, fileWidth?: number | null, fileHeight?: number | null, visitUrl: string } | null } | null };

export type CreateFormInviteLinkMutationVariables = Exact<{
  input: CreateCooperatorLinkInput;
}>;


export type CreateFormInviteLinkMutation = { createFormCooperatorLink?: { cooperatorLink?: { token: string, url: string, userRole?: string | null, formRole?: { name: string, id: string, predefined: boolean } | null } | null, errors?: Array<{ code?: number | null, message?: string | null, path?: Array<string> | null, details?: any | null }> | null } | null };

export type CreateInviteLinkMutationVariables = Exact<{
  input: CreateUserInviteLinkInput;
}>;


export type CreateInviteLinkMutation = { createUserInviteLink?: { role: UserRole, token: string, url: string } | null };

export type CreatePreviewFormMutationVariables = Exact<{
  input: PreviewInput;
}>;


export type CreatePreviewFormMutation = { previewForm?: { cacheToken?: string | null } | null };

export type CreateQiniuCallbackMutationVariables = Exact<{
  input: CreateQiniuCallbackInput;
}>;


export type CreateQiniuCallbackMutation = { createQiniuCallback?: { attachmentId?: string | null, fileName?: string | null, previewUrl?: string | null, errors?: Array<{ code?: number | null, message?: string | null, path?: Array<string> | null, details?: any | null }> | null } | null };

export type CreateQiniuPresignedTokenMutationVariables = Exact<{
  input: CreatePresignedTokenInput;
}>;


export type CreateQiniuPresignedTokenMutation = { createPresignedToken?: { saveKey?: string | null, presignedUrl?: string | null, token?: string | null, storage?: string | null, errors?: Array<{ code?: number | null, message?: string | null, path?: Array<string> | null, details?: any | null }> | null } | null };

export type DestroyAllFormInviteLinksMutationVariables = Exact<{
  input: DestroyFormCooperatorLinksInput;
}>;


export type DestroyAllFormInviteLinksMutation = { destroyFormCooperatorLinks?: { status?: string | null, errors?: Array<{ code?: number | null, message?: string | null, path?: Array<string> | null, details?: any | null }> | null } | null };

export type DestroyCurrentUserMutationVariables = Exact<{
  input: DestroyUserInput;
}>;


export type DestroyCurrentUserMutation = { destroyUser?: { errors?: Array<{ code?: number | null, message?: string | null, path?: Array<string> | null, details?: any | null }> | null } | null };

export type DestroyFormMutationVariables = Exact<{
  input: DestroyFormInput;
}>;


export type DestroyFormMutation = { destroyForm?: { errors?: Array<{ code?: number | null, message?: string | null, path?: Array<string> | null, details?: any | null }> | null } | null };

export type DestroyFormCompletelyMutationVariables = Exact<{
  input: CompletelyDestroyFormInput;
}>;


export type DestroyFormCompletelyMutation = { completelyDestroyForm?: { errors?: Array<{ code?: number | null, message?: string | null, path?: Array<string> | null, details?: any | null }> | null } | null };

export type DestroyFormCooperatorMutationVariables = Exact<{
  formToken: Scalars['ID']['input'];
  targetId: Scalars['ID']['input'];
}>;


export type DestroyFormCooperatorMutation = { destroyFormCooperator?: { errors?: Array<{ code?: number | null, message?: string | null, path?: Array<string> | null, details?: any | null }> | null } | null };

export type DestroyInviteLinksMutationVariables = Exact<{ [key: string]: never; }>;


export type DestroyInviteLinksMutation = { destroyUserInviteLinks?: { succeed: boolean, errors?: Array<{ code?: number | null, message?: string | null, path?: Array<string> | null, details?: any | null }> | null } | null };

export type DestroySubAccountMutationVariables = Exact<{
  input: DestroyBillingAccountUserInput;
}>;


export type DestroySubAccountMutation = { destroyBillingAccountUser?: { success: boolean, errors?: Array<{ code?: number | null, message?: string | null, path?: Array<string> | null, details?: any | null }> | null } | null };

export type GetCoversQueryVariables = Exact<{
  tagId?: InputMaybe<Scalars['ID']['input']>;
  folderId?: InputMaybe<Scalars['ID']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  flatten?: InputMaybe<Scalars['Boolean']['input']>;
  participated?: InputMaybe<Scalars['Boolean']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  ignorePinning?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  managed?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<BaseFileEnum>;
}>;


export type GetCoversQuery = { formCovers?: { totalCount: number, nodes?: Array<{ id: string, name: string, subname?: string | null, originalName: string, type: BaseFileEnum, scene: Scene, layout: Layout, token: string, entriesCount: number, createdAt?: date | null, creatorId: string, hasUnusableFeatures: boolean, hasUnusableFields: boolean, disabled?: boolean | null, owner: { id: string, displayName: string, avatarUrl?: string | null }, billingAccount: { id: string }, stats: { totalFillCount: number, totalViewCount: number }, userFormSetting?: { favored?: boolean | null } | null } | { id: string, name: string, token: string, type: BaseFileEnum, formCount: number, folderCount: number, createdAt?: date | null, lastFormCreatedAt?: date | null, shareType?: FormFolderShareType | null, ensuredSymbol?: { backgroundColor: string } | null, userFormSetting?: { favored?: boolean | null } | null } | {} | null> | null, pageInfo: { hasNextPage: boolean, endCursor?: string | null } } | null };

export type GetCurrentUsageAndBalanceQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentUsageAndBalanceQuery = { currentUser?: { id: string, billingAccount: { id: string, occupiedUsersCount: number, usersQuota: number, realtimeTotalBalance: number, currentMonthlyUsage: { resetDate: any, entryUsage: { totalQuota: number, consumedQuota: number, totalBalance: number, currentMonthBalance: number, balanceUsage: number, boughtBalance: number }, storageUsage: { totalQuota: number, consumedQuota: number, totalBalance: number, currentMonthBalance: number, balanceUsage: number, boughtBalance: number }, smsUsage: { totalQuota: number, consumedQuota: number, totalBalance: number, currentMonthBalance: number, balanceUsage: number, boughtBalance: number }, activeMailUsage: { totalQuota: number, consumedQuota: number, totalBalance: number, currentMonthBalance: number, balanceUsage: number, boughtBalance: number }, entryTransactionUsage: { totalQuota: number, consumedQuota: number, totalBalance: number, currentMonthBalance: number, balanceUsage: number, boughtBalance: number }, aiPointsUsage: { totalQuota: number, consumedQuota: number, totalBalance: number, currentMonthBalance: number, balanceUsage: number, boughtBalance: number }, audioQuotaUsage: { totalQuota: number, consumedQuota: number, totalBalance: number, currentMonthBalance: number, balanceUsage: number, boughtBalance: number } }, debitBalance: { balance: number, smsBalance: number, emailBalance: number, aiPointsBalance: number, audioBalance: number } } } | null };

export type GetCurrentUserQueryVariables = Exact<{
  appIdentity: AppIdentity;
}>;


export type GetCurrentUserQuery = { currentUser?: { id: string, displayName: string, avatarUrl?: string | null, email?: string | null, mobile?: string | null, role: UserRole, status: UserStatus, accountDisabled: boolean, needResetPassword: boolean, accountDestroyable: boolean, notifications: { totalUnreadCount: number }, authentications?: Array<{ name?: string | null, provider: AuthenticationProvider }> | null, billingAccount: { id: string, name?: string | null, subdomain?: string | null, monthlyPayablePlans: Array<PlanCode>, debitBalance: { balance: number }, planPackage?: { endDate?: any | null, currentPlanEndDate?: any | null, plan: { code: string, label: string }, planUpgradeStatus: { enabled: boolean, source?: SubscriptionSource | null, message?: string | null } } | null, currentFeatureTrialInfo?: { expiredNoticed?: boolean | null, status?: FeatureTrialStatus | null, showE30FeatureTrial: boolean, endDate?: any | null, trialType?: FeatureTrialType | null, recommendUpgradePlan?: { code: string, label: string } | null } | null }, billingAccountAbilities: { hasAddSubAccountAbility?: boolean | null }, billingAccountUsers: Array<{ id: string, role: UserRole, status: UserStatus, apiToken?: string | null, billingAccount: { id: string, shortName?: string | null, occupiedUsersCount: number, usersQuota: number, planPackage?: { endDate?: any | null, plan: { code: string, label: string } } | null, currentFeatureTrialInfo?: { status?: FeatureTrialStatus | null, endDate?: any | null, trialType?: FeatureTrialType | null } | null } }> } | null };

export type GetCurrentUserAiPointsUsageQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentUserAiPointsUsageQuery = { currentUser?: { id: string, billingAccount: { currentMonthlyUsage: { aiPointsUsage: { totalQuota: number, consumedQuota: number, totalBalance: number, currentMonthBalance: number, balanceUsage: number, boughtBalance: number } }, debitBalance: { aiPointsBalance: number } } } | null };

export type GetFolderQueryVariables = Exact<{
  folderToken?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetFolderQuery = { formFolder?: { name: string, token: string } | null };

export type GetFormQueryVariables = Exact<{
  formToken?: InputMaybe<Scalars['ID']['input']>;
  scene?: InputMaybe<Scene>;
  layout?: InputMaybe<Layout>;
  platform?: InputMaybe<Platform>;
}>;


export type GetFormQuery = { form?: { token: string, scene: Scene, layout: Layout, name: string, createdAt?: date | null, description?: string | null, entriesCount: number, subname?: string | null, originalName: string, editedVersion?: number | null, useCk5?: boolean | null, billingAccountAbilities: { hasAddSubAccountAbility?: boolean | null }, billingAccountFeatureQuotas: { cooperatorLimitQuota?: number | null }, userFormRole?: { id: string, name: string, abilities: Array<FormRoleAbility>, originalName: string } | null, ensuredSymbol?: { icon: string, backgroundColor: string } | null, stats: { totalFillCount: number, todayFillCount: number, totalViewCount: number, todayViewCount: number }, billingAccount: { id: string, activeSubdomain?: string | null, planPackage?: { plan: { code: string } } | null, branding: { customFooter?: string | null, customFooterEnabled: boolean, customFooterLogoEnabled: boolean, customFooterLink?: string | null, showQrcodeLogo: boolean, navDisplay: NavDisplay, qrcodeLogo?: { id: string, visitUrl: string } | null, navLogo?: { visitUrl: string } | null }, currentFeatureTrialInfo?: { status?: FeatureTrialStatus | null, trialType?: FeatureTrialType | null, endDate?: any | null, onetimeCount?: number | null } | null, cnameSetting: { cname?: string | null, icp?: string | null, protocol: string, cnameEnabled: boolean, customDomainEnabled: boolean }, weixinAccounts: Array<{ id: string, verified?: boolean | null, nickName?: string | null }>, wxpayAccounts: Array<{ id: string, mchName: string, available: boolean, weixinAccount?: { nickName?: string | null, id: string } | null }>, alipayAccounts: Array<{ id: string, email: string }>, pingppAccounts: Array<{ id: string, appid: string }> }, theme: { header: { type: ThemeHeaderType, image?: { visitUrl: string, fileWidth?: number | null } | null, carouselImages?: Array<{ visitUrl: string }> | null }, wallpaper: { backgroundColor?: string | null, backgroundImageUrl?: string | null }, formContainer: { style: { backgroundColor?: string | null } } }, setting: { weixinThumbnail: { url: string } }, userFormSetting?: { preferColumns: Array<string>, pinned?: boolean | null, favored?: boolean | null, publishedUrlDomain?: PublishedUrlDomainEnum | null, folder?: { token: string } | null } | null, allAncestorFolders?: Array<{ token: string, name: string, ensuredSymbol?: { backgroundColor: string } | null, owner?: { id: string } | null }> | null, owner: { id: string, displayName: string, avatarUrl?: string | null, email?: string | null, mobile?: string | null, status: UserStatus }, storageConfig: { provider?: string | null }, userFormAppSetting: { appNotificationEnabled: boolean } } | null };

export type GetFormCooperatorQueryVariables = Exact<{
  formId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}>;


export type GetFormCooperatorQuery = { cooperator?: { id: string, displayName: string, email?: string | null, mobile?: string | null, avatarUrl?: string | null, status: UserStatus, externalAttachAbilities?: Array<FormRoleUserExternalAbilitiesType> | null, formRole: { id: string }, directRole?: { id: string } | null, inheritedRole?: { id: string } | null, billingAccount?: { id: string } | null } | null };

export type GetFormCooperatorsQueryVariables = Exact<{
  formToken: Scalars['ID']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetFormCooperatorsQuery = { form?: { id: string, token: string, cooperators?: { totalCount: number, pageInfo: { hasNextPage: boolean, endCursor?: string | null }, nodes?: Array<{ id: string, displayName: string, email?: string | null, mobile?: string | null, avatarUrl?: string | null, status: UserStatus, externalAttachAbilities?: Array<FormRoleUserExternalAbilitiesType> | null, formRole: { id: string }, directRole?: { id: string } | null, inheritedRole?: { id: string } | null, billingAccount?: { id: string } | null } | null> | null } | null } | null };

export type GetFormInviteLinksQueryVariables = Exact<{
  formToken: Scalars['ID']['input'];
}>;


export type GetFormInviteLinksQuery = { form?: { cooperatorLinks?: Array<{ token: string, url: string, userRole?: string | null, formRole?: { id: string, predefined: boolean } | null }> | null } | null };

export type GetFormRolesQueryVariables = Exact<{
  formToken: Scalars['ID']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetFormRolesQuery = { form?: { token: string, formRoles?: { totalCount: number, pageInfo: { hasNextPage: boolean, endCursor?: string | null }, nodes?: Array<{ id: string, name: string, originalName: string, predefined: boolean, description: string, abilities: Array<FormRoleAbility>, conditionalScope: boolean, scopeConditions?: Array<{ trigger: string, operator: ScopeConditionOperator, value?: any | null, groupIndex?: number | null }> | null, fieldAbilities: Array<{ fieldApiCode: string, abilities?: Array<FormRoleFieldAbilityType> | null }>, formRoleUsers?: { totalCount: number } | null } | null> | null } | null } | null };

export type GetFormSettingQueryVariables = Exact<{
  formToken: Scalars['ID']['input'];
}>;


export type GetFormSettingQuery = { form?: { token: string, setting: { formId: string, manuallyCloseRule: { closed: boolean } } } | null };

export type GetFormStatsQueryVariables = Exact<{
  formToken: Scalars['ID']['input'];
}>;


export type GetFormStatsQuery = { form?: { stats: { totalFillCount: number, todayFillCount: number, totalViewCount: number, todayViewCount: number } } | null };

export type GetGeeTestCaptchaQueryVariables = Exact<{
  type: GeetestKeyEnum;
  options?: InputMaybe<Scalars['JSON']['input']>;
  forceGeetest?: InputMaybe<Scalars['Boolean']['input']>;
  formToken?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetGeeTestCaptchaQuery = { initCaptcha?: { geetestId?: string | null } | null };

export type GetNotificationsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  verb?: InputMaybe<Scalars['String']['input']>;
  read?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetNotificationsQuery = { currentUser?: { id: string, notifications: { totalUnreadCount: number, totalCount: number, pageInfo: { hasNextPage: boolean, endCursor?: string | null }, nodes?: Array<{ id: string, read: boolean, verb: string, startTime: date, endTime: date, count: number, actionUrl?: string | null, actionType: NotificationActionTypeEnum, actionLabel?: string | null, activity?: { formInfo: { formName?: string | null, formToken?: string | null } } | { formInfo: { formName?: string | null, formToken?: string | null } } | { announcement?: { summary?: string | null } | null } | { formInfo: { formName?: string | null, formToken?: string | null } } | { targetId: string, formInfo: { formName?: string | null, formToken?: string | null } } | { targetId: string, formInfo: { formName?: string | null, formToken?: string | null } } | { targetId: string, formInfo: { formName?: string | null, formToken?: string | null } } | { targetId: string, formInfo: { formName?: string | null, formToken?: string | null } } | { formInfo: { formName?: string | null, formToken?: string | null } } | { content?: string | null, formInfo: { formName?: string | null, formToken?: string | null } } | { formInfo: { formName?: string | null, formToken?: string | null } } | { status: string, fieldApiCode: string, downloadUrls?: Array<string> | null, formInfo: { formName?: string | null, formToken?: string | null } } | { formInfo: { formName?: string | null, formToken?: string | null } } | { userName: string, targetType: string, folderInfo: { folderName?: string | null, folderToken?: string | null } } | { formInfo: { formName?: string | null, formToken?: string | null } } | { formInfo: { formName?: string | null, formToken?: string | null } } | { userName: string, targetType: string, formInfo: { formName?: string | null, formToken?: string | null } } | { portalName: string } | { formInfo: { formName?: string | null, formToken?: string | null } } | { formInfo: { formName?: string | null, formToken?: string | null } } | { formInfo: { formName?: string | null, formToken?: string | null } } | { formInfo: { formName?: string | null, formToken?: string | null } } | { content: string } | { warningContent?: string | null, warningType?: string | null, warningLevel?: SystemWarningLevel | null, overdue?: boolean | null } | { merchantName?: string | null, freezeType?: string | null } | { formInfo: { formName?: string | null, formToken?: string | null } } | {} | null } | null> | null } } | null };

export type GetParticipatedFormCoversQueryVariables = Exact<{
  sort?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  participated?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetParticipatedFormCoversQuery = { formCovers?: { totalCount: number, nodes?: Array<{ entriesCount: number, lastEntryCreatedAt?: date | null, form: { id: string, name: string, subname?: string | null, originalName: string, type: BaseFileEnum, scene: Scene, layout: Layout, token: string, entriesCount: number, createdAt?: date | null, creatorId: string, hasUnusableFeatures: boolean, hasUnusableFields: boolean, disabled?: boolean | null, owner: { id: string, displayName: string, avatarUrl?: string | null }, billingAccount: { id: string }, stats: { totalFillCount: number, totalViewCount: number }, userFormSetting?: { favored?: boolean | null } | null } } | {} | null> | null, pageInfo: { hasNextPage: boolean, endCursor?: string | null } } | null };

export type GetSubAccountsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  includeInviteLinks: Scalars['Boolean']['input'];
}>;


export type GetSubAccountsQuery = { currentBillingAccount?: { users: { totalCount: number, pageInfo: { hasNextPage: boolean, endCursor?: string | null }, nodes?: Array<{ id: string, role: UserRole, mobile?: string | null, email?: string | null, status: UserStatus, avatarUrl?: string | null, name?: string | null, createdFormsCount: number, entriesCountOfCreatedForms: number } | null> | null }, userInviteLinks?: Array<{ role: UserRole, token: string, url: string }> } | null };

export type GetTodayStatsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTodayStatsQuery = { currentUser?: { stats: { formFillCount: number, formViewCount: number } } | null };

export type GetTrashedFormsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetTrashedFormsQuery = { currentUser?: { trashedForms?: { totalCount: number, pageInfo: { hasNextPage: boolean, endCursor?: string | null }, nodes?: Array<{ id: string, name: string, subname?: string | null, token: string, deletedAt: date, entryCount: number, creatorId: string, formDeleter?: { displayName: string } | null } | null> | null } | null } | null };

export type MarkAllNotificationsReadMutationVariables = Exact<{
  input: MarkAllNotificationsReadInput;
}>;


export type MarkAllNotificationsReadMutation = { markAllNotificationsRead?: { status?: string | null, errors?: Array<{ code?: number | null, message?: string | null, path?: Array<string> | null, details?: any | null }> | null } | null };

export type MarkNotificationReadMutationVariables = Exact<{
  input: MarkNotificationReadInput;
}>;


export type MarkNotificationReadMutation = { markNotificationRead?: { status?: string | null, errors?: Array<{ code?: number | null, message?: string | null, path?: Array<string> | null, details?: any | null }> | null } | null };

export type RestoreFormMutationVariables = Exact<{
  input: RestoreFormInput;
}>;


export type RestoreFormMutation = { restoreForm?: { errors?: Array<{ code?: number | null, message?: string | null, path?: Array<string> | null, details?: any | null }> | null } | null };

export type ShowFeatureQueryVariables = Exact<{
  key: Scalars['String']['input'];
  forBillingAccountOwner?: InputMaybe<Scalars['Boolean']['input']>;
  formToken?: InputMaybe<Scalars['ID']['input']>;
  forFormBillingAccountOwner?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ShowFeatureQuery = { showFeature: boolean };

export type UpdateFormCooperatorMutationVariables = Exact<{
  formToken: Scalars['ID']['input'];
  roleId: Scalars['ID']['input'];
  targetId: Scalars['ID']['input'];
}>;


export type UpdateFormCooperatorMutation = { updateFormCooperator?: { errors?: Array<{ code?: number | null, message?: string | null, path?: Array<string> | null, details?: any | null }> | null } | null };

export type UpdateFormSettingMutationVariables = Exact<{
  formId: Scalars['ID']['input'];
  attributes: FormSettingAttributes;
}>;


export type UpdateFormSettingMutation = { updateFormSetting?: { setting?: { formId: string, manuallyCloseRule: { closed: boolean } } | null, errors?: Array<{ code?: number | null, message?: string | null, path?: Array<string> | null, details?: any | null }> | null } | null };

export type UpdateFormThemeMutationVariables = Exact<{
  input: SaveThemeInput;
}>;


export type UpdateFormThemeMutation = { saveTheme?: { formId?: string | null, theme?: { header: { type: ThemeHeaderType, image?: { visitUrl: string, fileWidth?: number | null } | null, carouselImages?: Array<{ visitUrl: string }> | null }, wallpaper: { backgroundColor?: string | null, backgroundImageUrl?: string | null }, formContainer: { style: { backgroundColor?: string | null } } } | null, errors?: Array<{ code?: number | null, message?: string | null, path?: Array<string> | null, details?: any | null }> | null } | null };

export type UpdateSubAccountMutationVariables = Exact<{
  input: UpdateBillingAccountUserInput;
}>;


export type UpdateSubAccountMutation = { updateBillingAccountUser?: { success?: boolean | null, errors?: Array<{ code?: number | null, message?: string | null, path?: Array<string> | null, details?: any | null }> | null } | null };

export type UpdateUserFormAppSettingMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  attributes: FormAppSettingAttributes;
}>;


export type UpdateUserFormAppSettingMutation = { updateUserFormAppSetting?: { errors?: Array<{ code?: number | null, message?: string | null, path?: Array<string> | null, details?: any | null }> | null, userFormAppSetting?: { appNotificationEnabled: boolean } | null } | null };

export type UpdateUserFormSettingMutationVariables = Exact<{
  input: UpdateUserFormSettingInput;
}>;


export type UpdateUserFormSettingMutation = { updateUserFormSetting?: { userFormSettings?: Array<{ favored?: boolean | null }> | null, errors?: Array<{ code?: number | null, message?: string | null, path?: Array<string> | null, details?: any | null }> | null } | null };

export type UpdateUserProfileMutationVariables = Exact<{
  input: UpdateProfileInput;
}>;


export type UpdateUserProfileMutation = { updateProfile?: { user?: { nickName?: string | null, displayName: string, avatarUrl?: string | null } | null, errors?: Array<{ code?: number | null, message?: string | null, path?: Array<string> | null, details?: any | null }> | null } | null };

export type BillingAccountBrandingFragment = { customFooter?: string | null, customFooterEnabled: boolean, customFooterLogoEnabled: boolean, customFooterLink?: string | null, showQrcodeLogo: boolean, navDisplay: NavDisplay, qrcodeLogo?: { id: string, visitUrl: string } | null, navLogo?: { visitUrl: string } | null };

export type BillingAccountCnameSettingFragment = { cname?: string | null, icp?: string | null, protocol: string, cnameEnabled: boolean, customDomainEnabled: boolean };

export type ErrorFragment = { code?: number | null, message?: string | null, path?: Array<string> | null, details?: any | null };

export type FolderCoverFragment = { id: string, name: string, token: string, type: BaseFileEnum, formCount: number, folderCount: number, createdAt?: date | null, lastFormCreatedAt?: date | null, shareType?: FormFolderShareType | null, ensuredSymbol?: { backgroundColor: string } | null, userFormSetting?: { favored?: boolean | null } | null };

export type FormBasicFragment = { token: string, scene: Scene, layout: Layout, name: string, createdAt?: date | null, description?: string | null, entriesCount: number, subname?: string | null, originalName: string, editedVersion?: number | null, useCk5?: boolean | null, userFormRole?: { id: string, name: string, abilities: Array<FormRoleAbility>, originalName: string } | null, ensuredSymbol?: { icon: string, backgroundColor: string } | null, stats: { totalFillCount: number, todayFillCount: number, totalViewCount: number, todayViewCount: number }, billingAccount: { id: string, activeSubdomain?: string | null, planPackage?: { plan: { code: string } } | null, branding: { customFooter?: string | null, customFooterEnabled: boolean, customFooterLogoEnabled: boolean, customFooterLink?: string | null, showQrcodeLogo: boolean, navDisplay: NavDisplay, qrcodeLogo?: { id: string, visitUrl: string } | null, navLogo?: { visitUrl: string } | null }, currentFeatureTrialInfo?: { status?: FeatureTrialStatus | null, trialType?: FeatureTrialType | null, endDate?: any | null, onetimeCount?: number | null } | null, cnameSetting: { cname?: string | null, icp?: string | null, protocol: string, cnameEnabled: boolean, customDomainEnabled: boolean }, weixinAccounts: Array<{ id: string, verified?: boolean | null, nickName?: string | null }>, wxpayAccounts: Array<{ id: string, mchName: string, available: boolean, weixinAccount?: { nickName?: string | null, id: string } | null }>, alipayAccounts: Array<{ id: string, email: string }>, pingppAccounts: Array<{ id: string, appid: string }> }, theme: { header: { type: ThemeHeaderType, image?: { visitUrl: string, fileWidth?: number | null } | null, carouselImages?: Array<{ visitUrl: string }> | null }, wallpaper: { backgroundColor?: string | null, backgroundImageUrl?: string | null }, formContainer: { style: { backgroundColor?: string | null } } }, setting: { weixinThumbnail: { url: string } }, userFormSetting?: { preferColumns: Array<string>, pinned?: boolean | null, favored?: boolean | null, publishedUrlDomain?: PublishedUrlDomainEnum | null, folder?: { token: string } | null } | null, allAncestorFolders?: Array<{ token: string, name: string, ensuredSymbol?: { backgroundColor: string } | null, owner?: { id: string } | null }> | null, owner: { id: string, displayName: string, avatarUrl?: string | null, email?: string | null, mobile?: string | null, status: UserStatus }, storageConfig: { provider?: string | null }, userFormAppSetting: { appNotificationEnabled: boolean } };

export type FormCoverFragment = { id: string, name: string, subname?: string | null, originalName: string, type: BaseFileEnum, scene: Scene, layout: Layout, token: string, entriesCount: number, createdAt?: date | null, creatorId: string, hasUnusableFeatures: boolean, hasUnusableFields: boolean, disabled?: boolean | null, owner: { id: string, displayName: string, avatarUrl?: string | null }, billingAccount: { id: string }, stats: { totalFillCount: number, totalViewCount: number }, userFormSetting?: { favored?: boolean | null } | null };

export type FormRoleFragment = { id: string, name: string, originalName: string, predefined: boolean, description: string, abilities: Array<FormRoleAbility>, conditionalScope: boolean, scopeConditions?: Array<{ trigger: string, operator: ScopeConditionOperator, value?: any | null, groupIndex?: number | null }> | null, fieldAbilities: Array<{ fieldApiCode: string, abilities?: Array<FormRoleFieldAbilityType> | null }>, formRoleUsers?: { totalCount: number } | null };

export type FormSettingFragment = { formId: string, manuallyCloseRule: { closed: boolean } };

export type FormStatsFragment = { totalFillCount: number, todayFillCount: number, totalViewCount: number, todayViewCount: number };

export type FormThemeFragment = { header: { type: ThemeHeaderType, image?: { visitUrl: string, fileWidth?: number | null } | null, carouselImages?: Array<{ visitUrl: string }> | null }, wallpaper: { backgroundColor?: string | null, backgroundImageUrl?: string | null }, formContainer: { style: { backgroundColor?: string | null } } };

export type PageInfoFragment = { hasNextPage: boolean, endCursor?: string | null };

export type PaymentAccountsFragment = { wxpayAccounts: Array<{ id: string, mchName: string, available: boolean, weixinAccount?: { nickName?: string | null, id: string } | null }>, alipayAccounts: Array<{ id: string, email: string }>, pingppAccounts: Array<{ id: string, appid: string }> };

export type VasBalanceFragment = { totalQuota: number, consumedQuota: number, totalBalance: number, currentMonthBalance: number, balanceUsage: number, boughtBalance: number };
